import * as i0 from '@angular/core';
import { InjectionToken, Injectable, Inject, Component, EventEmitter, Input, Output, ViewChild, NgModule } from '@angular/core';
import * as i4$1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i2 from '@ft/core';
import { LARGE_DIALOG, BaseListFormDialog, MEDIUM_DIALOG, SMALL_DIALOG, SCALE_ANIMATION, HEIGHT_ANIMATION, AuthGuard, MaterialModule, FtCoreModule } from '@ft/core';
import * as i3$1 from '@ngx-translate/core';
import { TranslateModule } from '@ngx-translate/core';
import * as i1$1 from '@angular/common/http';
import { HttpClientModule } from '@angular/common/http';
import * as i16 from '@angular/forms';
import { FormControl, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import * as i12 from 'ng-busy';
import { NgBusyModule } from 'ng-busy';
import * as i3 from '@angular/router';
import { RouterModule } from '@angular/router';
import * as _ from 'lodash';
import { forEach, assignIn, isString, get, join, map, sumBy, isArray, uniqBy, concat, isEmpty, chain, isNil, assign, size, includes, reject, padStart, find, filter, isMatch, every, subtract, sum, cloneDeep, omit, isUndefined, noop, pick, reduce } from 'lodash';
import * as i1 from '@angular/material/dialog';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import * as i4 from '@angular/material/sidenav';
import * as i8 from '@angular/flex-layout/flex';
import * as i1$2 from '@angular/material/snack-bar';
import * as i6 from '@angular/material/button';
import * as i9 from '@angular/material/icon';
import * as i11 from '@angular/material/toolbar';
import * as i4$2 from '@ft/table';
import { FtTableModule } from '@ft/table';
import * as i10 from '@angular/material/form-field';
import * as i11$1 from '@angular/material/input';
import * as i5 from '@angular/material/core';
import * as i15 from '@angular/material/select';
import * as i13 from '@angular/material/radio';
import * as i8$1 from '@angular/material/slide-toggle';
import * as i15$2 from '@angular/material/tabs';
import * as i15$1 from '@angular/material/tooltip';
import * as i21 from '@ft/file-manager';
import { FileManagerModule, FILE_MANAGER_ROOT_CONFIG, FtFileManagerSharedModule, FtVisualizerModule, MediaModule } from '@ft/file-manager';
import { ENTER, ESCAPE, COMMA } from '@angular/cdk/keycodes';
import * as i4$3 from '@angular/material/chips';
import * as i9$1 from '@angular/flex-layout/extended';
import { BehaviorSubject, of } from 'rxjs';
import moment from 'moment';
import * as i7 from '@angular/material/datepicker';
import * as i12$1 from '@angular/material/divider';
import * as i6$1 from '@angular/material/card';
import * as i7$1 from '@angular/material/list';
import * as i13$1 from '@angular/material/menu';
import WebDataRocks from 'webdatarocks';
import { ngfModule } from 'angular-file';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

const MODULES = [
    {
        label: 'store.store_inventory',
        items: [
            {
                icon: 'mdi-clipboard-check',
                path: './inventory/inventory',
                label: 'store.inventory',
                actions: [
                    {
                        icon: 'mdi-plus',
                        method: () => {
                            return "/inventory/inventory/inventory-form";
                        },
                        tooltip: "shared.add_new",
                        acl: { resource: 'store-inventory', action: 'create', behavior: 'remove' }
                    }
                ]
            },
            {
                icon: 'mdi-format-align-middle',
                path: './inventory/article-historic',
                label: 'inventory.movements_state',
                actions: []
            }
        ]
    },
    {
        label: 'store.store_management',
        items: [
            {
                icon: 'mdi-format-list-bulleted',
                path: './store/article',
                label: 'store.article_list',
                actions: [
                    {
                        icon: 'mdi-plus',
                        method: () => {
                            return "/store/article/article-form";
                        },
                        tooltip: "shared.add_new",
                        acl: { resource: 'store-article', action: 'create', behavior: 'remove' }
                    }
                ]
            },
            {
                icon: 'mdi-account-circle',
                path: './store/provider-list',
                label: 'store.provider_list'
            },
            {
                icon: 'mdi-store',
                path: './store/depot-list',
                label: 'shared.depot_list'
            },
            {
                icon: 'mdi-format-list-bulleted',
                path: './store/family-list',
                label: 'store.family_list'
            },
            {
                icon: 'mdi-elevator',
                path: './store/movement',
                label: 'store.movements',
                actions: [
                    {
                        icon: 'mdi-plus',
                        method: () => {
                            return "/store/movement/movement-form";
                        },
                        tooltip: "shared.add_new",
                        acl: { resource: 'store-movement', action: 'create', behavior: 'remove' }
                    }
                ]
            },
            {
                icon: 'mdi-crop-rotate',
                path: './store/transformation',
                label: 'store.transformation_list',
                actions: [
                    {
                        icon: 'mdi-plus',
                        method: () => {
                            return '/store/transformation/transformation-form';
                        },
                        tooltip: "shared.add_new",
                        acl: { resource: 'store-transformation', action: 'create', behavior: 'remove' }
                    }
                ]
            },
            {
                icon: 'mdi-bank-transfer',
                path: './store/exchange',
                label: 'store.exchange_list',
                actions: [
                    {
                        icon: 'mdi-plus',
                        method: () => {
                            return '/store/exchange/exchange-form';
                        },
                        tooltip: "shared.add_new",
                        acl: { resource: 'store-exchange', action: 'create', behavior: 'remove' }
                    }
                ]
            }
        ]
    },
    {
        label: 'store.purchase_management',
        items: [
            {
                icon: 'mdi-clipboard-text-outline',
                path: './purchase/price-request',
                label: 'purchase.price_request_list',
                actions: [
                    {
                        icon: 'mdi-plus',
                        method: () => {
                            return '/purchase/price-request/price-request-form';
                        },
                        tooltip: "shared.add_new",
                        acl: { resource: 'price-request', action: 'create', behavior: 'remove' }
                    }
                ]
            },
            {
                icon: 'mdi-clipboard-text',
                path: './purchase/purchase-order',
                label: 'shared.purchase_order_list',
                actions: [
                    {
                        icon: 'mdi-plus',
                        method: () => {
                            return '/purchase/purchase-order/purchase-order-form';
                        },
                        tooltip: "shared.add_new",
                        acl: { resource: 'purchase-order', action: 'create', behavior: 'remove' }
                    }
                ]
            },
            {
                icon: 'mdi-file-check',
                path: './purchase/purchase-receipt',
                label: 'purchase.purchase_receipt_list',
                actions: [
                    {
                        icon: 'mdi-plus',
                        method: () => {
                            return '/purchase/purchase-receipt/purchase-receipt-form';
                        },
                        tooltip: "shared.add_new",
                        acl: { resource: 'purchase-receipt', action: 'create', behavior: 'remove' }
                    }
                ]
            },
            {
                icon: 'mdi-clipboard-arrow-down',
                path: './purchase/deposition',
                label: 'purchase.deposition_list',
                actions: [
                    {
                        icon: 'mdi-plus',
                        method: () => {
                            return '/purchase/deposition/deposition-form';
                        },
                        tooltip: "shared.add_new",
                        acl: { resource: 'deposition-form', action: 'create', behavior: 'remove' }
                    }
                ]
            },
            {
                icon: 'mdi-clipboard-arrow-left',
                path: './purchase/return',
                label: 'shared.return_form',
                actions: [
                    {
                        icon: 'mdi-plus',
                        method: () => {
                            return '/purchase/return/return-form';
                        },
                        tooltip: "shared.add_new",
                        acl: { resource: 'return-form', action: 'create', behavior: 'remove' }
                    }
                ]
            },
            {
                icon: 'mdi-receipt',
                path: './purchase/purchase-invoice',
                label: 'purchase.purchase_invoice',
                actions: [
                    {
                        icon: 'mdi-plus',
                        method: () => {
                            return '/purchase/purchase-invoice/purchase-invoice-form';
                        },
                        tooltip: "shared.add_new",
                        acl: { resource: 'purchase-invoice', action: 'create', behavior: 'remove' }
                    }
                ]
            },
            {
                icon: 'mdi-currency-usd',
                path: './purchase/purchase-payment',
                label: 'purchase.purchase_payment',
                actions: [
                    {
                        icon: 'mdi-plus',
                        method: () => {
                            return '/purchase/purchase-payment/purchase-payment-form';
                        },
                        tooltip: "shared.add_new",
                        acl: { resource: 'purchase-payment', action: 'create', behavior: 'remove' }
                    }
                ]
            }
        ]
    },
    {
        label: 'store.store_sale',
        items: [
            {
                icon: 'mdi-file-upload',
                path: './sale/delivery',
                label: 'sale.delivery_list',
                actions: [
                    {
                        icon: 'mdi-plus',
                        method: () => {
                            return '/sale/delivery/delivery-form';
                        },
                        tooltip: "shared.add_new",
                        acl: { resource: 'delivery-form', action: 'create', behavior: 'remove' }
                    }
                ]
            },
            {
                icon: 'mdi-file-export',
                path: './sale/consignment',
                label: 'store.consignment',
                actions: [
                    {
                        icon: 'mdi-plus',
                        method: () => {
                            return '/sale/consignment/consignment-form';
                        },
                        tooltip: "shared.add_new",
                        acl: { resource: 'consignment', action: 'create', behavior: 'remove' }
                    }
                ]
            },
            {
                icon: 'mdi-file-import',
                path: './sale/consignment-return',
                label: 'store.consignment_return',
                actions: [
                    {
                        icon: 'mdi-plus',
                        method: () => {
                            return '/sale/consignment-return/consignment-return-form';
                        },
                        tooltip: "shared.add_new",
                        acl: { resource: 'consignment-return', action: 'create', behavior: 'remove' }
                    }
                ]
            }
        ]
    }
];

function handleViewRoute(view, parentPath) {
    let viewData = _.cloneDeep(view);
    if (_.has(viewData, 'formRoute') && _.has(viewData, 'viewUrl')) {
        viewData.formRoute = `${parentPath}${viewData.formRoute}`;
        viewData.viewUrl = `${parentPath}${viewData.viewUrl}`;
    }
    return viewData;
}
function handleRoute(parentPath, _path) {
    return `${parentPath}${_path}`;
}
function getLinePrice(line, price_mode) {
    if (price_mode == 'TTC' && _.get(line, 'vat.value', 0) != 0) {
        return line.vat ? (line.price * 100) / (100 + _.get(line, 'vat.value', 0)) : 0;
    }
    else {
        return line.price;
    }
}
function getLineVat(line, price_mode) {
    return line.vat ? line.qte * getLinePrice(line, price_mode) * _.get(line, 'vat.value', 0) / 100 : 0;
}
function handleSubTotal(line, price_mode) {
    return line.qte * getLinePrice(line, price_mode) + getLineVat(line, price_mode);
}

const SHARED_MODULE_CONFIG = new InjectionToken('SHARED_MODULE_CONFIG');
class SharedModulesService {
    constructor(config) {
        this.config = config;
        this._pathName = null;
        if (config) {
            this._pathName = config.pathName;
        }
    }
    get pathName() {
        return this._pathName;
    }
}
SharedModulesService.ɵfac = function SharedModulesService_Factory(t) { return new (t || SharedModulesService)(i0.ɵɵinject(SHARED_MODULE_CONFIG)); };
SharedModulesService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: SharedModulesService, factory: SharedModulesService.ɵfac, providedIn: 'root' });
(function () {
    (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SharedModulesService, [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], function () {
        return [{ type: undefined, decorators: [{
                        type: Inject,
                        args: [SHARED_MODULE_CONFIG]
                    }] }];
    }, null);
})();

class SubLayoutComponent {
    constructor(router, sharedModulesService, dialog) {
        this.router = router;
        this.sharedModulesService = sharedModulesService;
        this.dialog = dialog;
        this.links = forEach(_.cloneDeep(MODULES), (e) => {
            forEach(e.items, (i) => {
                forEach(i.actions, (a) => {
                    let m = a.method();
                    assignIn(a, {
                        method: () => {
                            return this.handleRoute(m);
                        }
                    });
                });
            });
        });
    }
    ngOnInit() {
    }
    handleRoute(m) {
        if (isString(m)) {
            this.router.navigate([handleRoute(this.sharedModulesService.pathName, m)], { replaceUrl: true });
        }
    }
}
SubLayoutComponent.ɵfac = function SubLayoutComponent_Factory(t) { return new (t || SubLayoutComponent)(i0.ɵɵdirectiveInject(i3.Router), i0.ɵɵdirectiveInject(SharedModulesService), i0.ɵɵdirectiveInject(i1.MatDialog)); };
SubLayoutComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SubLayoutComponent, selectors: [["fts-sub-layout"]], decls: 6, vars: 1, consts: [[1, "ft-app-container"], ["fxFlex", "", "mode", "side", "opened", ""], [3, "links"], ["fxFlex", ""], ["fxFlex", "", "fxLayout", "column", 1, "ft-parent-layout", "mat-elevation-z1", "ft-content-margin"]], template: function SubLayoutComponent_Template(rf, ctx) {
        if (rf & 1) {
            i0.ɵɵelementStart(0, "mat-drawer-container", 0)(1, "mat-drawer", 1);
            i0.ɵɵelement(2, "ft-drawer-links", 2);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(3, "mat-drawer-content", 3)(4, "div", 4);
            i0.ɵɵelement(5, "router-outlet");
            i0.ɵɵelementEnd()()();
        }
        if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("links", ctx.links);
        }
    }, dependencies: [i4.MatDrawer, i4.MatDrawerContainer, i4.MatDrawerContent, i8.DefaultLayoutDirective, i8.DefaultFlexDirective, i2.DrawerLinksComponent, i3.RouterOutlet], styles: ["[_nghost-%COMP%]{height:100%;display:flex;flex-direction:column}  ft-drawer-links   .mat-list-item   .mat-icon{color:#546e7a}"] });
(function () {
    (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SubLayoutComponent, [{
            type: Component,
            args: [{ selector: 'fts-sub-layout', template: `
    <mat-drawer-container class="ft-app-container">
      <mat-drawer fxFlex mode="side" opened>
        <ft-drawer-links [links]="links"></ft-drawer-links>
      </mat-drawer>

      <mat-drawer-content fxFlex>
        <div class="ft-parent-layout mat-elevation-z1 ft-content-margin" fxFlex fxLayout="column">
          <router-outlet></router-outlet>
        </div>
      </mat-drawer-content>
    </mat-drawer-container>
  `, styles: [":host{height:100%;display:flex;flex-direction:column}::ng-deep ft-drawer-links ::ng-deep .mat-list-item ::ng-deep .mat-icon{color:#546e7a}\n"] }]
        }], function () { return [{ type: i3.Router }, { type: SharedModulesService }, { type: i1.MatDialog }]; }, null);
})();

class MainContainerComponent {
    constructor() { }
    ngOnInit() {
    }
}
MainContainerComponent.ɵfac = function MainContainerComponent_Factory(t) { return new (t || MainContainerComponent)(); };
MainContainerComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MainContainerComponent, selectors: [["fts-main-container"]], decls: 2, vars: 0, consts: [["fxFlex", "", "fxLayout", "column"]], template: function MainContainerComponent_Template(rf, ctx) {
        if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵelement(1, "router-outlet");
            i0.ɵɵelementEnd();
        }
    }, dependencies: [i8.DefaultLayoutDirective, i8.DefaultFlexDirective, i3.RouterOutlet], styles: ["[_nghost-%COMP%]{height:100%;display:flex;flex-direction:column}"] });
(function () {
    (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MainContainerComponent, [{
            type: Component,
            args: [{ selector: 'fts-main-container', template: `
   <div fxFlex fxLayout="column"> 
    <router-outlet></router-outlet>
   </div>
  `, styles: [":host{height:100%;display:flex;flex-direction:column}\n"] }]
        }], function () { return []; }, null);
})();

class SharedService {
    constructor(http, ws) {
        this.http = http;
        this.ws = ws;
    }
    getUrl(cls, id = null) {
        return `/api/${cls}/${id ? id + "/" : ""}`;
    }
    getDocument(cls, id) {
        return this.http.get(this.getUrl(cls, id));
    }
    getDocuments(cls) {
        return this.http.get(this.getUrl(cls));
    }
    saveDocument(cls, item, loadedObject) {
        let pk, data;
        pk = loadedObject ? loadedObject : item.id;
        data = !get(item, 'id') && loadedObject ? assignIn(item, { 'id': loadedObject }) : item;
        return this.http.post(this.getUrl(cls, pk), data);
    }
    deleteDocument(cls, id) {
        return this.http.delete(this.getUrl(cls, id));
    }
    checkDelete(topic, _pk) {
        return this.ws.call(topic, { _pk });
    }
    loadDocument(cls, loadedObject) {
        return this.ws.call(`${cls}.load_document`, { pk: loadedObject });
    }
    validateDocument(_cls, _pk, _type) {
        return this.ws.call(`${_cls}.validate`, { _cls, _pk, _type });
    }
    invalidateDocument(_cls, _pk, _type) {
        return this.ws.call(`${_cls}.invalidate`, { _cls, _pk, _type });
    }
}
SharedService.ɵfac = function SharedService_Factory(t) { return new (t || SharedService)(i0.ɵɵinject(i1$1.HttpClient), i0.ɵɵinject(i2.FtWsService)); };
SharedService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: SharedService, factory: SharedService.ɵfac, providedIn: 'root' });
(function () {
    (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SharedService, [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], function () { return [{ type: i1$1.HttpClient }, { type: i2.FtWsService }]; }, null);
})();

function DocumentsListComponent_div_2_Template(rf, ctx) {
    if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 8)(1, "button", 9);
        i0.ɵɵelement(2, "mat-icon", 10);
        i0.ɵɵelementEnd()();
    }
    if (rf & 2) {
        const ctx_r0 = i0.ɵɵnextContext();
        i0.ɵɵadvance(2);
        i0.ɵɵpropertyInterpolate("fontIcon", ctx_r0.viewSettings.headerIcon);
    }
}
function DocumentsListComponent_h2_3_Template(rf, ctx) {
    if (rf & 1) {
        i0.ɵɵelementStart(0, "h2");
        i0.ɵɵtext(1);
        i0.ɵɵpipe(2, "translate");
        i0.ɵɵelementEnd();
    }
    if (rf & 2) {
        const ctx_r1 = i0.ɵɵnextContext();
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, ctx_r1.viewSettings == null ? null : ctx_r1.viewSettings.headerLabel));
    }
}
function DocumentsListComponent_ng_template_5_Template(rf, ctx) {
    if (rf & 1) {
        const _r4 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "button", 11);
        i0.ɵɵlistener("click", function DocumentsListComponent_ng_template_5_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r4); const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.handleEdit()); });
        i0.ɵɵelement(1, "mat-icon", 12);
        i0.ɵɵelementStart(2, "span");
        i0.ɵɵtext(3);
        i0.ɵɵpipe(4, "translate");
        i0.ɵɵelementEnd()();
    }
    if (rf & 2) {
        const ctx_r2 = i0.ɵɵnextContext();
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 1, ctx_r2.viewSettings == null ? null : ctx_r2.viewSettings.formLabel));
    }
}
const _c0$A = function (a0) { return { resource: a0, action: "create", behavior: "remove" }; };
const _c1$q = function () { return []; };
class DocumentsListComponent {
    constructor(route, router, dialog, purposeService, sharedService, translateService, sharedModulesService, snackBar, printService) {
        this.route = route;
        this.router = router;
        this.dialog = dialog;
        this.purposeService = purposeService;
        this.sharedService = sharedService;
        this.translateService = translateService;
        this.sharedModulesService = sharedModulesService;
        this.snackBar = snackBar;
        this.printService = printService;
        this.viewSettings = null;
        this.reloadEvent = new EventEmitter();
        this.selectedLine = null;
    }
    ngOnInit() {
        this.route.data.subscribe(data => {
            this.viewSettings = _.cloneDeep(data);
            this.viewSettings.viewSettings.viewColumns.push({
                label: '', key: 'actions', type: 'actions', actions: _.concat({
                    class: 'mat-primary',
                    icon: 'mdi-pencil',
                    method: (item, index, ev) => {
                        return this.handleEdit(item);
                    },
                    acl: { resource: _.get(this.viewSettings, 'resource'), action: 'update', behavior: 'disabled' }
                }, _.get(this.viewSettings, 'printGroup') ? {
                    class: 'mat-primary',
                    icon: 'mdi-printer',
                    method: (item, index, ev) => {
                        return this.handlePrint(item);
                    },
                    disabled: (item) => { return !_.get(item, 'state.is_valid'); },
                    acl: { resource: _.get(this.viewSettings, 'resource'), action: 'validate', behavior: 'disabled' }
                } : [], {
                    class: 'mat-warn',
                    icon: 'mdi-delete',
                    method: (item, index, ev) => {
                        return this.handleRemove(item);
                    },
                    disabled: (item) => { return _.get(item, 'state.is_valid'); },
                    acl: { resource: _.get(this.viewSettings, 'resource'), action: 'delete', behavior: 'remove' }
                })
            });
            this.selectedLine = this.viewSettings.model;
        });
    }
    handleEdit(obj) {
        if (this.viewSettings.formRoute) {
            if (obj)
                this.busy = this.router.navigate([handleRoute(this.sharedModulesService.pathName, this.viewSettings.formRoute), obj.id]);
            else {
                this.busy = this.router.navigate([handleRoute(this.sharedModulesService.pathName, this.viewSettings.formRoute)]);
            }
        }
        if (this.viewSettings.editDialogComponent) {
            this.dialog.open(this.viewSettings.editDialogComponent, _.assign(LARGE_DIALOG, {
                data: obj ? obj : {},
                autoFocus: false, disableClose: true
            })).afterClosed().subscribe(res => {
                if (res) {
                    this.reloadEvent.emit('true');
                }
            });
        }
    }
    handleRemove(obj) {
        if (_.get(this.viewSettings, 'deleteTopic')) {
            this.handleRemoveWithCheck(obj);
        }
        else {
            if (!get(obj.state, 'is_valid')) {
                this.sharedService.deleteDocument(_.get(this.viewSettings, 'apiUrl'), obj.id).subscribe(() => {
                    this.reloadEvent.emit('true');
                });
            }
            else {
                this.snackBar.open(this.translateService.instant('shared.impossible_valid_document_delete'), null, {
                    duration: 2500,
                    verticalPosition: "top",
                    horizontalPosition: "right"
                });
            }
        }
    }
    handlePrint(obj) {
        this.printService.performPrint({
            group: _.get(this.viewSettings, 'resource'),
            view: `api/${_.get(this.viewSettings, 'apiUrl')}`,
            model: obj.id
        });
    }
    handleRemoveWithCheck(obj) {
        this.sharedService.checkDelete(_.get(this.viewSettings, 'deleteTopic'), obj.id).subscribe(data => {
            if (data) {
                this.sharedService.deleteDocument(_.get(this.viewSettings, 'apiUrl'), obj.id).subscribe(() => {
                    this.reloadEvent.emit('true');
                });
            }
            else {
                this.snackBar.open(this.translateService.instant('shared.impossible_document_delete_check_dependencies'), null, {
                    duration: 2500,
                    verticalPosition: "top",
                    horizontalPosition: "right"
                });
            }
        });
    }
}
DocumentsListComponent.ɵfac = function DocumentsListComponent_Factory(t) { return new (t || DocumentsListComponent)(i0.ɵɵdirectiveInject(i3.ActivatedRoute), i0.ɵɵdirectiveInject(i3.Router), i0.ɵɵdirectiveInject(i1.MatDialog), i0.ɵɵdirectiveInject(i2.GeneralPurposeService), i0.ɵɵdirectiveInject(SharedService), i0.ɵɵdirectiveInject(i3$1.TranslateService), i0.ɵɵdirectiveInject(SharedModulesService), i0.ɵɵdirectiveInject(i1$2.MatSnackBar), i0.ɵɵdirectiveInject(i2.PrintingService)); };
DocumentsListComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DocumentsListComponent, selectors: [["fts-documents-list"]], decls: 8, vars: 15, consts: [["fxFlex", "", "fxLayout", "column"], ["color", "accent"], ["class", "ft-module-icon", 4, "ngIf"], [4, "ngIf"], ["fxFlex", ""], [3, "ftAcl"], ["fxLayout", "column", "fxFlex", "", 1, "ft-content"], [3, "namespace", "hasPagination", "hasSearch", "selectable", "actions", "viewSettings", "query", "exportExcel", "reloadEvent"], [1, "ft-module-icon"], ["type", "button", "mat-icon-button", ""], ["fontSet", "mdi", 3, "fontIcon"], ["mat-button", "", 1, "with-icon", 3, "click"], ["fontSet", "mdi", "fontIcon", "mdi-plus"]], template: function DocumentsListComponent_Template(rf, ctx) {
        if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "mat-toolbar", 1);
            i0.ɵɵtemplate(2, DocumentsListComponent_div_2_Template, 3, 1, "div", 2);
            i0.ɵɵtemplate(3, DocumentsListComponent_h2_3_Template, 3, 3, "h2", 3);
            i0.ɵɵelement(4, "span", 4);
            i0.ɵɵtemplate(5, DocumentsListComponent_ng_template_5_Template, 5, 3, "ng-template", 5);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(6, "div", 6);
            i0.ɵɵelement(7, "ft-generic-view-table", 7);
            i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", !(ctx.viewSettings == null ? null : ctx.viewSettings.is_subModule));
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", !(ctx.viewSettings == null ? null : ctx.viewSettings.is_subModule));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ftAcl", i0.ɵɵpureFunction1(12, _c0$A, ctx.viewSettings == null ? null : ctx.viewSettings.resource));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("namespace", ctx.viewSettings == null ? null : ctx.viewSettings.viewNamespace)("hasPagination", ctx.viewSettings == null ? null : ctx.viewSettings.hasPagination)("hasSearch", ctx.viewSettings == null ? null : ctx.viewSettings.hasSearch)("selectable", ctx.viewSettings == null ? null : ctx.viewSettings.selectable)("actions", ctx.viewSettings == null ? null : ctx.viewSettings.actions)("viewSettings", ctx.viewSettings == null ? null : ctx.viewSettings.viewSettings)("query", i0.ɵɵpureFunction0(14, _c1$q))("exportExcel", true)("reloadEvent", ctx.reloadEvent);
        }
    }, dependencies: [i4$1.NgIf, i6.MatButton, i9.MatIcon, i11.MatToolbar, i8.DefaultLayoutDirective, i8.DefaultFlexDirective, i4$2.GenericViewTableComponent, i2.AclDirective, i3$1.TranslatePipe], styles: ["[_nghost-%COMP%]{height:100%;display:flex;flex:1 1 100%}"] });
(function () {
    (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DocumentsListComponent, [{
            type: Component,
            args: [{ selector: 'fts-documents-list', template: "<div fxFlex fxLayout=\"column\">\n  <mat-toolbar color=\"accent\">\n    <div *ngIf=\"!viewSettings?.is_subModule\" class=\"ft-module-icon\">\n     <button type=\"button\" mat-icon-button>\n        <mat-icon fontSet=\"mdi\" fontIcon=\"{{viewSettings.headerIcon}}\"></mat-icon>\n    </button>\n    </div>\n    <h2 *ngIf=\"!viewSettings?.is_subModule\">{{ viewSettings?.headerLabel | translate }}</h2>\n    <span fxFlex></span>\n    <ng-template  [ftAcl]=\"{resource: viewSettings?.resource, action: 'create', behavior: 'remove'}\">\n       <button mat-button class=\"with-icon\" (click)=\"handleEdit()\">\n          <mat-icon  fontSet=\"mdi\" fontIcon=\"mdi-plus\"></mat-icon>\n          <span>{{ viewSettings?.formLabel | translate }}</span>\n        </button>\n    </ng-template>\n  </mat-toolbar>\n  <div fxLayout=\"column\" fxFlex class=\"ft-content\">\n      <ft-generic-view-table\n          [namespace]=\"viewSettings?.viewNamespace\"\n          [hasPagination]=\"viewSettings?.hasPagination\"\n          [hasSearch]=\"viewSettings?.hasSearch\"\n          [selectable]=\"viewSettings?.selectable\"\n          [actions]=\"viewSettings?.actions\"\n          [viewSettings]=\"viewSettings?.viewSettings\"\n          [query]=\"[]\"\n          [exportExcel]=\"true\"\n          [reloadEvent]=\"reloadEvent\">\n      </ft-generic-view-table>\n  </div>\n\n</div>\n\n\n", styles: [":host{height:100%;display:flex;flex:1 1 100%}\n"] }]
        }], function () { return [{ type: i3.ActivatedRoute }, { type: i3.Router }, { type: i1.MatDialog }, { type: i2.GeneralPurposeService }, { type: SharedService }, { type: i3$1.TranslateService }, { type: SharedModulesService }, { type: i1$2.MatSnackBar }, { type: i2.PrintingService }]; }, null);
})();

const DEPOSITION_COLUMNS = [
    {
        "label": "purchase.deposition_number",
        "key": "number",
        "type": "text",
        "is_global_searchable": true
    },
    {
        "label": "purchase.date",
        "key": "date",
        "type": "date",
        "is_global_searchable": true
    },
    {
        "label": "store.default_provider",
        "key": "provider.name",
        "type": "text",
        "is_global_searchable": true
    },
    {
        "label": "purchase.deposition_dead_line",
        "key": "dead_line",
        "type": "date",
        "is_global_searchable": true
    },
    {
        "label": "store.depot",
        "key": "store.name",
        "type": "badge",
        "is_global_searchable": true,
        "style": { 'background-color': '#4fc3f7' }
    },
    {
        'label': 'shared.state',
        'key': 'is_valid',
        'type': 'boolean',
        'icon': 'mdi-checkbox-blank-circle',
        'tooltip': (row) => { return get(row, 'state.is_valid') ? "shared.is_valid" : "shared.is_draft"; },
        'style': (row) => {
            return get(row, 'state.is_valid') ? {
                'color': '#76FF03',
                'font-size': '20px'
            } : {
                'color': 'grey',
                'font-size': '20px'
            };
        }
    },
    {
        "label": "shared.vat_amount",
        "key": "vat_amount",
        "type": "number",
        "numberConfig": 'float',
        "is_global_searchable": true
    },
    {
        "label": "shared.ttc_amount",
        "key": "ttc_amount",
        "type": "number",
        "numberConfig": 'float',
        "is_global_searchable": true
    }
];

const PRICE_REQUEST_COLUMNS = [
    {
        "label": "purchase.price_request_number",
        "key": "number",
        "type": "text",
        "is_global_searchable": true
    },
    {
        "label": "purchase.date",
        "key": "date",
        "type": "date",
        "is_global_searchable": true
    },
    {
        "label": "purchase.providers",
        "key": "providers_list",
        "type": "text",
        "is_global_searchable": true,
        callBack: (r) => { return join(map(r.providers, "name"), ', '); }
    },
    {
        'label': 'shared.state',
        'key': 'is_valid',
        'type': 'boolean',
        'icon': 'mdi-checkbox-blank-circle',
        'tooltip': (row) => { return get(row, 'state.is_valid') ? "shared.is_valid" : "shared.is_draft"; },
        'style': (row) => {
            return get(row, 'state.is_valid') ? {
                'color': '#76FF03',
                'font-size': '20px'
            } : {
                'color': 'grey',
                'font-size': '20px'
            };
        }
    }
];

const PURCHASE_ORDER_COLUMNS = [
    {
        "label": "purchase.purchase_order_number",
        "key": "number",
        "type": "text",
        "is_global_searchable": true
    },
    {
        "label": "purchase.date",
        "key": "date",
        "type": "date",
        "is_global_searchable": true
    },
    {
        "label": "store.default_provider",
        "key": "provider.name",
        "type": "text",
        "is_global_searchable": true
    },
    {
        "label": "shared.patient_first_name",
        "key": "patient.first_name",
        "type": "text",
        "is_global_searchable": true
    },
    {
        "label": "shared.patient_last_name",
        "key": "patient.last_name",
        "type": "text",
        "is_global_searchable": true
    },
    {
        "label": "purchase.attention_to",
        "key": "attention_to",
        "type": "text",
        "is_global_searchable": true
    },
    {
        "label": "purchase.payment_mode",
        "key": "payment_mode.type",
        "type": "badge",
        "is_global_searchable": false,
        callBack: (row) => get(row, 'payment_mode.type') ? `shared.${row.payment_mode.type}` : "",
        "style": (row) => { return { 'background-color': "#24ca24" }; }
    },
    {
        'label': 'shared.state',
        'key': 'is_valid',
        'type': 'boolean',
        'icon': 'mdi-checkbox-blank-circle',
        'tooltip': (row) => { return get(row, 'state.is_valid') ? "shared.is_valid" : "shared.is_draft"; },
        'style': (row) => {
            return get(row, 'state.is_valid') ? {
                'color': '#76FF03',
                'font-size': '20px'
            } : {
                'color': 'grey',
                'font-size': '20px'
            };
        }
    },
    {
        "label": "shared.ttc_amount",
        "key": "ttc_amount",
        "type": "number",
        "numberConfig": 'float',
        "is_global_searchable": true
    }
];

const PURCHASE_RECEIPT_COLUMNS = [
    {
        "label": "purchase.receipt_number",
        "key": "number",
        "type": "text",
        "is_global_searchable": true
    },
    {
        "label": "store.date",
        "key": "date",
        "type": "date",
        "is_global_searchable": true
    },
    {
        "label": "store.depot",
        "key": "store.name",
        "type": "badge",
        "is_global_searchable": true,
        "style": { 'background-color': '#4fc3f7' }
    },
    {
        "label": "store.default_provider",
        "key": "provider.name",
        "type": "text",
        "is_global_searchable": true
    },
    {
        'label': 'shared.state',
        'key': 'is_valid',
        'type': 'boolean',
        'icon': 'mdi-checkbox-blank-circle',
        'tooltip': (row) => {
            return get(row, 'state.is_valid') ? "shared.is_valid" : "shared.is_draft";
        },
        'style': (row) => {
            return get(row, 'state.is_valid') ? {
                'color': '#76FF03',
                'font-size': '20px'
            } : {
                'color': 'grey',
                'font-size': '20px'
            };
        }
    },
    {
        "label": "shared.vat_amount",
        "key": "vat_amount",
        "type": "number",
        "numberConfig": 'float',
        "is_global_searchable": true
    },
    {
        "label": "shared.ttc_amount",
        "key": "ttc_amount",
        "type": "number",
        "numberConfig": 'float',
        "is_global_searchable": true
    }
];

const RETURN_COLUMNS = [
    {
        "label": "purchase.return_form_number",
        "key": "number",
        "type": "text",
        "is_global_searchable": true
    },
    {
        "label": "purchase.date",
        "key": "date",
        "type": "date",
        "is_global_searchable": true
    },
    {
        "label": "store.default_provider",
        "key": "provider.name",
        "type": "text",
        "is_global_searchable": true
    },
    {
        "label": "purchase.reason",
        "key": "reason",
        "type": "text",
        "is_global_searchable": true
    },
    {
        "label": "store.depot",
        "key": "store.name",
        "type": "badge",
        "is_global_searchable": true,
        "style": { 'background-color': '#4fc3f7' }
    },
    {
        'label': 'shared.state',
        'key': 'is_valid',
        'type': 'boolean',
        'icon': 'mdi-checkbox-blank-circle',
        'tooltip': (row) => { return get(row, 'state.is_valid') ? "shared.is_valid" : "shared.is_draft"; },
        'style': (row) => {
            return get(row, 'state.is_valid') ? {
                'color': '#76FF03',
                'font-size': '20px'
            } : {
                'color': 'grey',
                'font-size': '20px'
            };
        }
    },
    {
        "label": "shared.ttc_amount",
        "key": "ttc_amount",
        "type": "number",
        "numberConfig": 'float',
        "is_global_searchable": true
    }
];

const SYSTEM_COLUMNS = [
    {
        'key': 'created_at', 'label': 'created_at', 'type': 'date'
    },
    {
        'key': 'updated_at', 'label': 'updated_at', 'type': 'date'
    },
    {
        'key': 'is_deleted', 'label': 'is_deleted', 'type': 'boolean'
    },
    {
        'key': 'deleted_at', 'label': 'deleted_at', 'type': 'date'
    }
];

const CONSIGNMENT_COLUMNS = [
    {
        "label": "sale.consignment_number",
        "type": "text",
        "key": "number",
        "is_global_searchable": true
    },
    {
        "label": "store.date",
        "key": "date",
        "type": "date",
        "is_global_searchable": true
    },
    {
        "label": "store.organization",
        "key": "organization",
        "type": "text",
        "is_global_searchable": true
    },
    {
        "label": "store.depot",
        "key": "store.name",
        "type": "badge",
        "is_global_searchable": true,
        "style": { 'background-color': '#4fc3f7' }
    }, {
        "label": "shared.patient_first_name",
        "key": "patient.first_name",
        "type": "text",
        "is_global_searchable": true
    },
    {
        "label": "shared.patient_last_name",
        "key": "patient.last_name",
        "type": "text",
        "is_global_searchable": true
    },
    {
        "label": "purchase.start_date",
        "type": "date",
        "key": "start_date",
        "is_global_searchable": true
    },
    {
        "label": "purchase.dead_line_date",
        "type": "date",
        "key": "return_date",
        "is_global_searchable": true
    },
    {
        'label': 'shared.state',
        'key': 'is_valid',
        'type': 'boolean',
        'icon': 'mdi-checkbox-blank-circle',
        'tooltip': (row) => { return get(row, 'state.is_valid') ? "shared.is_valid" : "shared.is_draft"; },
        'style': (row) => {
            return get(row, 'state.is_valid') ? {
                'color': '#76FF03',
                'font-size': '20px'
            } : {
                'color': 'grey',
                'font-size': '20px'
            };
        }
    },
    {
        "label": "shared.ttc_amount",
        "key": "ttc_amount",
        "type": "number",
        "numberConfig": 'float',
        "is_global_searchable": true
    }
];

const ARTICLE_COLUMNS = [
    {
        "label": "shared.code",
        "key": "code",
        "type": "text",
        "is_global_searchable": true
    },
    {
        "label": "shared.family",
        "key": "family.name",
        "type": "text",
        "is_global_searchable": true
    },
    {
        "label": "shared.description",
        "key": "description",
        "type": "text",
        "is_global_searchable": true
    },
    {
        "label": "shared.qte",
        "key": "theo_stores.store_qte",
        "type": "number",
        "is_global_searchable": false,
        numberConfig: 'float',
        callBack: (r) => { return sumBy(r.theo_stores, "store_qte"); }
    },
    {
        "label": "shared.consigned_qte",
        "key": "theo_stores.consigned_qte",
        "type": "number",
        "is_global_searchable": false,
        numberConfig: 'float',
        callBack: (r) => { return sumBy(r.theo_stores, "consigned_qte"); }
    },
    {
        "label": "shared.deposition_qte",
        "key": "theo_stores.deposition_qte",
        "type": "number",
        "is_global_searchable": false,
        numberConfig: 'float',
        callBack: (r) => { return sumBy(r.theo_stores, "deposition_qte"); }
    },
    {
        "label": "store.pmp",
        "key": "pmp",
        "type": "number",
        "is_global_searchable": false,
        numberConfig: 'float'
    },
    {
        "label": "shared.purchase_price",
        "key": "purchase_price",
        "type": "number",
        "is_global_searchable": true,
        numberConfig: 'float'
    },
    {
        "label": "shared.sale_price",
        "key": "sale_price",
        "type": "number",
        "is_global_searchable": true,
        numberConfig: 'float'
    },
    {
        "label": "shared.default_provider",
        "key": "default_provider.name",
        "type": "text",
        "is_global_searchable": true
    }
];

const ARTICLE_VIEW = {
    trackByKey: 'id',
    hasSearch: true,
    selectable: true,
    hasPagination: true,
    viewNamespace: 'Liste',
    query: [],
    viewSettings: {
        'model': 'ft_stock.fts_shared.StoreArticle',
        'viewColumns': ARTICLE_COLUMNS,
        'systemColumns': SYSTEM_COLUMNS,
        'defaultName': 'Liste des articles'
    },
    actions: [],
    isSubModule: true,
    'formRoute': '/store/article/article-form/',
    'viewUrl': '/store/article/article-list/',
    'apiUrl': 'store/article',
    'headerLabel': 'shared.article_list',
    'formLabel': 'store.article',
    resource: 'store-article',
    headerIcon: "mdi-format-list-bulleted",
    deleteTopic: 'article.check_delete'
};
const PRICE_REQUEST_VIEW = {
    trackByKey: 'id',
    hasSearch: true,
    selectable: true,
    hasPagination: true,
    viewNamespace: 'Liste',
    query: [],
    viewSettings: {
        'model': 'ft_stock.purchase.PriceRequest',
        'viewColumns': PRICE_REQUEST_COLUMNS,
        'systemColumns': SYSTEM_COLUMNS,
        'defaultName': 'Demandes de prix'
    },
    actions: [],
    isSubModule: true,
    'formRoute': '/purchase/price-request/price-request-form/',
    'viewUrl': 'purchase/price-request/',
    'printGroup': 'price-request',
    'apiUrl': 'purchase/price-request',
    'headerLabel': 'purchase.price_request_list',
    'formLabel': 'store.price_request',
    resource: 'price-request',
    headerIcon: "mdi-clipboard-text-outline"
};
const PURCHASE_ORDER_VIEW = {
    trackByKey: 'id',
    hasSearch: true,
    selectable: true,
    hasPagination: true,
    viewNamespace: 'Liste',
    query: [],
    viewSettings: {
        'model': 'ft_stock.purchase.PurchaseOrder',
        'viewColumns': PURCHASE_ORDER_COLUMNS,
        'systemColumns': SYSTEM_COLUMNS,
        'defaultName': 'Bons de commandes'
    },
    actions: [],
    isSubModule: true,
    'formRoute': '/purchase/purchase-order/purchase-order-form/',
    'viewUrl': 'purchase/purchase-order/purchase-order/',
    'printGroup': 'purchase-order',
    'apiUrl': 'purchase/purchase-order',
    'headerLabel': 'shared.purchase_order_list',
    'formLabel': 'store.purchase_order',
    resource: 'purchase-order',
    headerIcon: "mdi-clipboard-text"
};
const PURCHASE_RECEIPT_VIEW = {
    trackByKey: 'id',
    hasSearch: true,
    selectable: true,
    hasPagination: true,
    viewNamespace: 'Liste',
    query: [],
    viewSettings: {
        'model': 'ft_stock.purchase.PurchaseReceipt',
        'viewColumns': PURCHASE_RECEIPT_COLUMNS,
        'systemColumns': SYSTEM_COLUMNS,
        'defaultName': 'Bons de réceptions'
    },
    actions: [],
    isSubModule: true,
    'formRoute': '/purchase/purchase-receipt/purchase-receipt-form/',
    'viewUrl': 'purchase/purchase-receipt/purchase-receipt/',
    'printGroup': 'purchase-receipt',
    'apiUrl': 'purchase/purchase-receipt',
    'headerLabel': 'purchase.purchase_receipt_list',
    'formLabel': 'purchase.purchase_receipt',
    resource: 'purchase-receipt',
    headerIcon: "mdi-file-check"
};
const DEPOSITION_VIEW = {
    trackByKey: 'id',
    hasSearch: true,
    selectable: true,
    hasPagination: true,
    viewNamespace: 'Liste',
    query: [],
    viewSettings: {
        'model': 'ft_stock.purchase.DepositionForm',
        'viewColumns': DEPOSITION_COLUMNS,
        'systemColumns': SYSTEM_COLUMNS,
        'defaultName': 'Bons de depositions'
    },
    actions: [],
    isSubModule: true,
    'formRoute': '/purchase/deposition/deposition-form/',
    'viewUrl': 'purchase/deposition/deposition-form/',
    'printGroup': 'deposition-form',
    'apiUrl': 'purchase/deposition-form',
    'headerLabel': 'purchase.deposition_list',
    'formLabel': 'store.deposition',
    resource: 'deposition-form',
    headerIcon: "mdi-clipboard-arrow-down"
};
const RETURN_VIEW = {
    trackByKey: 'id',
    hasSearch: true,
    selectable: true,
    hasPagination: true,
    viewNamespace: 'Liste',
    query: [],
    viewSettings: {
        'model': 'ft_stock.purchase.ReturnForm',
        'viewColumns': RETURN_COLUMNS,
        'systemColumns': SYSTEM_COLUMNS,
        'defaultName': 'Bons de retours'
    },
    actions: [],
    isSubModule: true,
    'formRoute': '/purchase/return/return-form/',
    'viewUrl': 'purchase/return/return-form/',
    'printGroup': 'return-form',
    'apiUrl': 'purchase/return-form',
    'headerLabel': 'shared.return_list',
    'formLabel': 'store.return_form',
    resource: 'return-form',
    headerIcon: "mdi-clipboard-arrow-left"
};
const CONSIGNMENT_VIEW = {
    trackByKey: 'id',
    hasSearch: true,
    selectable: true,
    hasPagination: true,
    viewNamespace: 'Liste',
    query: [],
    viewSettings: {
        'model': 'ft_stock.sales.Consignment',
        'viewColumns': CONSIGNMENT_COLUMNS,
        'systemColumns': SYSTEM_COLUMNS,
        'defaultName': 'Bons de consignations'
    },
    actions: [],
    isSubModule: true,
    'formRoute': '/sale/consignment/consignment-form/',
    'viewUrl': 'sale/consignment/',
    'printGroup': 'consignment',
    'apiUrl': 'sale/consignment',
    'headerLabel': 'store.consignment',
    'formLabel': 'store.consignment',
    resource: 'consignment',
    headerIcon: "mdi-file-export"
};

const DEPOT_COLUMNS = [
    {
        "label": "shared.name",
        "key": "name",
        "type": "text",
        "is_global_searchable": true
    },
    {
        "label": "shared.manager",
        "key": "manager",
        "type": "text",
        "is_global_searchable": true
    },
    {
        "label": "shared.address",
        "key": "address",
        "type": "text",
        "is_global_searchable": true
    },
    {
        "label": "shared.description",
        "key": "description",
        "type": "text",
        "is_global_searchable": true
    },
    {
        "label": "shared.is_default",
        "key": "is_default",
        "type": "boolean",
        "is_global_searchable": true,
        'icon': 'mdi-checkbox-blank-circle',
        'style': (row) => {
            return {
                'color': get(row, 'is_default') ? '#76FF03' : 'transparent'
            };
        }
    }
];

function DepotDialogComponent_mat_error_16_Template(rf, ctx) {
    if (rf & 1) {
        i0.ɵɵelementStart(0, "mat-error");
        i0.ɵɵtext(1);
        i0.ɵɵpipe(2, "translate");
        i0.ɵɵelementEnd();
    }
    if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "store.code_already_exist"), "");
    }
}
function DepotDialogComponent_mat_error_17_Template(rf, ctx) {
    if (rf & 1) {
        i0.ɵɵelementStart(0, "mat-error");
        i0.ɵɵtext(1);
        i0.ɵɵpipe(2, "translate");
        i0.ɵɵelementEnd();
    }
    if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "shared.required_field_error"));
    }
}
function DepotDialogComponent_mat_error_22_Template(rf, ctx) {
    if (rf & 1) {
        i0.ɵɵelementStart(0, "mat-error");
        i0.ɵɵtext(1);
        i0.ɵɵpipe(2, "translate");
        i0.ɵɵelementEnd();
    }
    if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "store.name_already_exist"), "");
    }
}
const _c0$z = function (a0) { return { pk: a0, field: "code", "pk_field": "id" }; };
const _c1$p = function (a0) { return { pk: a0, field: "name", pk_field: "id" }; };
class DepotDialogComponent {
    constructor(snackBar, route, translate, dialogRef, sharedService, purposeService, translateService, data) {
        this.snackBar = snackBar;
        this.route = route;
        this.translate = translate;
        this.dialogRef = dialogRef;
        this.sharedService = sharedService;
        this.purposeService = purposeService;
        this.translateService = translateService;
        this.data = data;
        this.model = {};
        this.color = 'accent';
        this.isDialog = false;
    }
    ngOnInit() {
        this.model = this.data;
    }
    addItem() {
        this.sharedService.saveDocument('store/depot', this.model).subscribe(item => {
            this.model = item;
            this.dialogRef.close(item);
            this.snackBar.open(this.translate.instant('store.operation_completed'), null, {
                duration: 2500
            });
        });
    }
}
DepotDialogComponent.ɵfac = function DepotDialogComponent_Factory(t) { return new (t || DepotDialogComponent)(i0.ɵɵdirectiveInject(i1$2.MatSnackBar), i0.ɵɵdirectiveInject(i3.ActivatedRoute), i0.ɵɵdirectiveInject(i3$1.TranslateService), i0.ɵɵdirectiveInject(i1.MatDialogRef), i0.ɵɵdirectiveInject(SharedService), i0.ɵɵdirectiveInject(i2.GeneralPurposeService), i0.ɵɵdirectiveInject(i3$1.TranslateService), i0.ɵɵdirectiveInject(MAT_DIALOG_DATA)); };
DepotDialogComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DepotDialogComponent, selectors: [["fts-depot-dialog"]], decls: 42, vars: 44, consts: [["color", "primary"], ["fontSet", "mdi", 3, "fontIcon"], ["fxFlex", ""], ["mat-icon-button", "", "tabindex", "-1"], ["fontSet", "mdi", "fontIcon", "mdi-close", 3, "mat-dialog-close"], [1, "ft-content"], ["fxLayout", "column", "name", "depot", 1, "form"], ["depotForm", "ngForm"], ["fxLayout", "row", "fxLayoutGap", "6px"], ["fxFlex", "", 1, "with-error-label"], ["matInput", "", "name", "code", "required", "", "ftCustomValidation", "depot.check_uniqueness", 3, "placeholder", "ngModel", "ftAutoFocus", "query", "ftSequenceInput", "ngModelChange"], ["code", "ngModel"], [4, "ngIf"], ["matInput", "", "name", "name", "required", "", "ftCustomValidation", "depot.check_uniqueness", 3, "placeholder", "ngModel", "query", "ngModelChange"], ["name", "ngModel"], ["matInput", "", "name", "manager", 3, "placeholder", "ngModel", "ngModelChange"], ["matInput", "", "name", "description", 3, "placeholder", "ngModel", "ngModelChange"], ["matInput", "", "name", "address", 3, "placeholder", "ngModel", "ngModelChange"], ["mat-dialog-actions", ""], ["mat-raised-button", "", "color", "primary", "type", "submit", 3, "disabled", "click"], ["type", "button", "color", "warn", "mat-raised-button", "", "tabindex", "-1", 3, "mat-dialog-close"]], template: function DepotDialogComponent_Template(rf, ctx) {
        if (rf & 1) {
            i0.ɵɵelementStart(0, "mat-toolbar", 0);
            i0.ɵɵelement(1, "mat-icon", 1);
            i0.ɵɵelementStart(2, "span");
            i0.ɵɵtext(3);
            i0.ɵɵpipe(4, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(5, "span", 2);
            i0.ɵɵelementStart(6, "button", 3);
            i0.ɵɵelement(7, "mat-icon", 4);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(8, "div", 5)(9, "form", 6, 7)(11, "div", 8)(12, "mat-form-field", 9)(13, "input", 10, 11);
            i0.ɵɵlistener("ngModelChange", function DepotDialogComponent_Template_input_ngModelChange_13_listener($event) { return ctx.model.code = $event; });
            i0.ɵɵpipe(15, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(16, DepotDialogComponent_mat_error_16_Template, 3, 3, "mat-error", 12);
            i0.ɵɵtemplate(17, DepotDialogComponent_mat_error_17_Template, 3, 3, "mat-error", 12);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(18, "mat-form-field", 9)(19, "input", 13, 14);
            i0.ɵɵlistener("ngModelChange", function DepotDialogComponent_Template_input_ngModelChange_19_listener($event) { return ctx.model.name = $event; });
            i0.ɵɵpipe(21, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(22, DepotDialogComponent_mat_error_22_Template, 3, 3, "mat-error", 12);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(23, "mat-form-field", 2)(24, "input", 15);
            i0.ɵɵlistener("ngModelChange", function DepotDialogComponent_Template_input_ngModelChange_24_listener($event) { return ctx.model.manager = $event; });
            i0.ɵɵpipe(25, "translate");
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(26, "div", 8)(27, "mat-form-field", 2)(28, "textarea", 16);
            i0.ɵɵlistener("ngModelChange", function DepotDialogComponent_Template_textarea_ngModelChange_28_listener($event) { return ctx.model.description = $event; });
            i0.ɵɵpipe(29, "translate");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(30, "mat-form-field", 2)(31, "textarea", 17);
            i0.ɵɵlistener("ngModelChange", function DepotDialogComponent_Template_textarea_ngModelChange_31_listener($event) { return ctx.model.address = $event; });
            i0.ɵɵpipe(32, "translate");
            i0.ɵɵelementEnd()()()()();
            i0.ɵɵelementStart(33, "div", 18);
            i0.ɵɵelement(34, "span", 2);
            i0.ɵɵelementStart(35, "button", 19);
            i0.ɵɵlistener("click", function DepotDialogComponent_Template_button_click_35_listener() { return ctx.addItem(); });
            i0.ɵɵelementStart(36, "span");
            i0.ɵɵtext(37);
            i0.ɵɵpipe(38, "translate");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(39, "button", 20);
            i0.ɵɵtext(40);
            i0.ɵɵpipe(41, "translate");
            i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
            const _r0 = i0.ɵɵreference(10);
            const _r1 = i0.ɵɵreference(14);
            const _r4 = i0.ɵɵreference(20);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("fontIcon", (ctx.model == null ? null : ctx.model.id) ? "mdi-store" : "mdi-playlist-plus");
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 24, "store.depot"));
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("mat-dialog-close", null);
            i0.ɵɵadvance(6);
            i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(15, 26, "store.code"))("ngModel", ctx.model.code)("ftAutoFocus", true)("query", i0.ɵɵpureFunction1(40, _c0$z, ctx.model.id))("ftSequenceInput", "ft_stock.fts_shared.StoreDepot");
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngIf", _r1 == null ? null : _r1.errors == null ? null : _r1.errors.exists);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", _r1 == null ? null : _r1.errors == null ? null : _r1.errors.required);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(21, 28, "store.depot_name"))("ngModel", ctx.model.name)("query", i0.ɵɵpureFunction1(42, _c1$p, ctx.model.id));
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngIf", _r4 == null ? null : _r4.errors == null ? null : _r4.errors.exists);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(25, 30, "store.manager"))("ngModel", ctx.model.manager);
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(29, 32, "store.description"))("ngModel", ctx.model.description);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(32, 34, "store.address"))("ngModel", ctx.model.address);
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("disabled", _r0.invalid);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(38, 36, "store.save"));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("mat-dialog-close", null);
            i0.ɵɵadvance(1);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(41, 38, "shared.reset"));
        }
    }, dependencies: [i4$1.NgIf, i6.MatButton, i1.MatDialogClose, i1.MatDialogActions, i9.MatIcon, i10.MatError, i10.MatFormField, i11$1.MatInput, i11.MatToolbar, i8.DefaultLayoutDirective, i8.DefaultLayoutGapDirective, i8.DefaultFlexDirective, i16.ɵNgNoValidate, i16.DefaultValueAccessor, i16.NgControlStatus, i16.NgControlStatusGroup, i16.RequiredValidator, i16.NgModel, i16.NgForm, i2.InputDirective, i2.AutoFocusDirective, i2.SequenceInputDirective, i2.CustomValidationDirective, i3$1.TranslatePipe] });
(function () {
    (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DepotDialogComponent, [{
            type: Component,
            args: [{ selector: 'fts-depot-dialog', template: "<mat-toolbar color=\"primary\">\n   <mat-icon fontSet=\"mdi\"  [fontIcon]=\"model?.id ?  'mdi-store' : 'mdi-playlist-plus'\"></mat-icon>\n  <span>{{'store.depot' | translate}}</span>\n  <span fxFlex></span>\n\n  <button mat-icon-button tabindex=\"-1\">\n    <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-close\" [mat-dialog-close]=\"null\"></mat-icon>\n  </button>\n</mat-toolbar>\n<div class=\"ft-content\">\n  <form class=\"form\"  fxLayout=\"column\" #depotForm=\"ngForm\" name=\"depot\">\n\n    <div fxLayout=\"row\" fxLayoutGap=\"6px\">\n      <mat-form-field fxFlex class=\"with-error-label\" >\n        <input  matInput [placeholder]=\"'store.code'|translate\"\n                name=\"code\"\n                [(ngModel)]=\"model.code\"\n                required\n                [ftAutoFocus]=\"true\"\n                ftCustomValidation=\"depot.check_uniqueness\"\n                [query]=\"{pk:model.id, field:'code', 'pk_field':'id'}\"\n                #code=\"ngModel\"[ftSequenceInput]=\"'ft_stock.fts_shared.StoreDepot'\"/>\n        <mat-error *ngIf=\"code?.errors?.exists\"> {{'store.code_already_exist'|translate}}</mat-error>\n         <mat-error *ngIf=\"code?.errors?.required\">{{'shared.required_field_error'|translate}}</mat-error>\n       </mat-form-field>\n      <mat-form-field fxFlex   class=\"with-error-label\">\n        <input matInput [placeholder]=\"'store.depot_name'|translate\" name=\"name\" [(ngModel)]=\"model.name\" required\n               ftCustomValidation=\"depot.check_uniqueness\"\n               [query]=\"{pk:model.id, field:'name', pk_field:'id'}\"\n               #name=\"ngModel\">\n        <mat-error *ngIf=\"name?.errors?.exists\"> {{'store.name_already_exist'|translate}}</mat-error>\n      </mat-form-field>\n      <mat-form-field fxFlex >\n        <input matInput [placeholder]=\"'store.manager'|translate\" name=\"manager\" [(ngModel)]=\"model.manager\">\n      </mat-form-field>\n    </div>\n\n    <div fxLayout=\"row\" fxLayoutGap=\"6px\">\n      <mat-form-field fxFlex>\n        <textarea matInput [placeholder]=\"'store.description'|translate\" name=\"description\"\n                  [(ngModel)]=\"model.description\"></textarea>\n      </mat-form-field>\n      <mat-form-field fxFlex>\n        <textarea matInput [placeholder]=\"'store.address'|translate\" name=\"address\"\n                  [(ngModel)]=\"model.address\"></textarea>\n      </mat-form-field>\n    </div>\n\n  </form>\n</div>\n<div mat-dialog-actions>\n  <span fxFlex></span>\n  <button mat-raised-button color=\"primary\" type=\"submit\" [disabled]=\"depotForm.invalid\" (click)=\"addItem()\">\n    <span>{{'store.save'|translate}}</span>\n  </button>\n    <button type=\"button\" [mat-dialog-close]=\"null\"  color=\"warn\" mat-raised-button tabindex=\"-1\">{{'shared.reset'|translate}}</button>\n</div>\n\n\n\n\n\n\n\n\n\n" }]
        }], function () {
        return [{ type: i1$2.MatSnackBar }, { type: i3.ActivatedRoute }, { type: i3$1.TranslateService }, { type: i1.MatDialogRef }, { type: SharedService }, { type: i2.GeneralPurposeService }, { type: i3$1.TranslateService }, { type: undefined, decorators: [{
                        type: Inject,
                        args: [MAT_DIALOG_DATA]
                    }] }];
    }, null);
})();

const STORE_TRANSFORMATION_COLUMNS = [
    {
        "label": "store.transformation_number",
        "key": "number",
        "type": "text",
        "is_global_searchable": true
    },
    {
        "label": "store.type",
        "key": "type",
        "type": "badge",
        "is_global_searchable": true,
        "style": (row) => { return row.type == 'ASSEMBLY' ? { 'background-color': "#24ca24" } : { 'background-color': "orange" }; },
        callBack: (row) => `shared.${row.type}`
    },
    {
        "label": "store.date",
        "key": "date",
        "type": "date",
        "is_global_searchable": true
    },
    {
        "label": "store.depot",
        "key": "store.name",
        "type": "badge",
        "is_global_searchable": true,
        "style": { 'background-color': '#4fc3f7' }
    },
    {
        'label': 'shared.state',
        'key': 'is_valid',
        'type': 'boolean',
        'icon': 'mdi-checkbox-blank-circle',
        'tooltip': (row) => { return get(row, 'state.is_valid') ? "shared.is_valid" : "shared.is_draft"; },
        'style': (row) => {
            return get(row, 'state.is_valid') ? {
                'color': '#76FF03',
                'font-size': '20px'
            } : {
                'color': 'grey',
                'font-size': '20px'
            };
        }
    },
    {
        "label": "shared.ttc_amount",
        "key": "ttc_amount",
        "type": "number",
        "numberConfig": 'float',
        "is_global_searchable": true
    }
];

const STORE_MOVEMENT_COLUMNS = [
    {
        "label": "store.movement_number",
        "key": "number",
        "type": "text",
        "is_global_searchable": true
    },
    {
        "label": "store.date",
        "key": "date",
        "type": "date",
        "is_global_searchable": true
    },
    {
        "label": "store.organization",
        "key": "organization.name",
        "type": "text",
        "is_global_searchable": true
    },
    {
        "label": "store.depot",
        "key": "store.name",
        "type": "badge",
        "is_global_searchable": true,
        "style": { 'background-color': '#4fc3f7' }
    },
    {
        "label": "shared.patient_first_name",
        "key": "patient.first_name",
        "type": "text",
        "is_global_searchable": true
    },
    {
        "label": "shared.patient_last_name",
        "key": "patient.last_name",
        "type": "text",
        "is_global_searchable": true
    },
    {
        "label": "store.default_provider",
        "key": "provider.name",
        "type": "text",
        "is_global_searchable": true
    },
    {
        "label": "store.type",
        "key": "type",
        "type": "badge",
        "is_global_searchable": true,
        "style": (row) => { return row.type == 'IN' ? { 'background-color': "#24ca24" } : { 'background-color': "orange" }; },
        callBack: (row) => `store.${row.type}`
    },
    {
        'label': 'shared.state',
        'key': 'is_valid',
        'type': 'boolean',
        'icon': 'mdi-checkbox-blank-circle',
        'tooltip': (row) => { return get(row, 'state.is_valid') ? "shared.is_valid" : "shared.is_draft"; },
        'style': (row) => {
            return get(row, 'state.is_valid') ? {
                'color': '#76FF03',
                'font-size': '20px'
            } : {
                'color': 'grey',
                'font-size': '20px'
            };
        }
    },
    {
        "label": "shared.vat_amount",
        "key": "vat_amount",
        "type": "number",
        "numberConfig": 'float',
        "is_global_searchable": true
    },
    {
        "label": "shared.ttc_amount",
        "key": "ttc_amount",
        "type": "number",
        "numberConfig": 'float',
        "is_global_searchable": true
    }
];

const STORE_EXCHANGE_COLUMNS = [
    {
        "label": "store.exchange_number",
        "key": "number",
        "type": "text",
        "is_global_searchable": true
    },
    {
        "label": "store.date",
        "key": "date",
        "type": "date",
        "is_global_searchable": true
    },
    {
        "label": "store.source_depot",
        "key": "store.name",
        "type": "badge",
        "is_global_searchable": true,
        "style": { 'background-color': '#4fc3f7' }
    },
    {
        "label": "store.destination_depot",
        "key": "destination.name",
        "type": "badge",
        "is_global_searchable": true,
        "style": { 'background-color': '#f89243' }
    },
    {
        "label": "store.reason",
        "key": "reason",
        "type": "text",
        "is_global_searchable": true
    },
    {
        "label": "store.responsible",
        "key": "responsible",
        "type": "text",
        "is_global_searchable": true
    },
    {
        'label': 'shared.state',
        'key': 'is_valid',
        'type': 'boolean',
        'icon': 'mdi-checkbox-blank-circle',
        'tooltip': (row) => { return get(row, 'state.is_valid') ? "shared.is_valid" : "shared.is_draft"; },
        'style': (row) => {
            return get(row, 'state.is_valid') ? {
                'color': '#76FF03',
                'font-size': '20px'
            } : {
                'color': 'grey',
                'font-size': '20px'
            };
        }
    }
];

const DEPOT_VIEW = {
    trackByKey: 'id',
    hasSearch: true,
    selectable: true,
    hasPagination: true,
    viewNamespace: 'Liste',
    query: [],
    viewSettings: {
        'model': 'ft_stock.fts_shared.StoreDepot',
        'viewColumns': DEPOT_COLUMNS,
        'systemColumns': SYSTEM_COLUMNS,
        'defaultName': 'Liste des dépôts'
    },
    actions: [],
    isSubModule: true,
    'formRoute': null,
    'viewUrl': 'store/depot',
    'apiUrl': 'store/depot',
    'headerLabel': 'shared.depot_list',
    'formLabel': 'store.depot',
    'editDialogComponent': DepotDialogComponent,
    resource: 'store-depot',
    headerIcon: "mdi-store",
    deleteTopic: 'depot.check_delete'
};
const STORE_EXCHANGE_VIEW = {
    trackByKey: 'id',
    hasSearch: true,
    selectable: true,
    hasPagination: true,
    viewNamespace: 'Liste',
    query: [],
    viewSettings: {
        'model': 'ft_stock.store.StoreExchange',
        'viewColumns': STORE_EXCHANGE_COLUMNS,
        'systemColumns': SYSTEM_COLUMNS,
        'defaultName': 'Échanges Inter-dépôts'
    },
    actions: [],
    isSubModule: true,
    'formRoute': '/store/exchange/exchange-form/',
    'viewUrl': 'store/exchange/',
    'printGroup': 'store-exchange',
    'apiUrl': 'store/store-exchange',
    'headerLabel': 'shared.exchange_list',
    'formLabel': 'store.exchange',
    'editDialogComponent': null,
    resource: 'store-exchange',
    headerIcon: "mdi-bank-transfer"
};
const STORE_MOVEMENT_VIEW = {
    trackByKey: 'id',
    hasSearch: true,
    selectable: true,
    hasPagination: true,
    viewNamespace: 'Liste',
    query: [],
    viewSettings: {
        'model': 'ft_stock.store.StoreMovement',
        'viewColumns': STORE_MOVEMENT_COLUMNS,
        'systemColumns': SYSTEM_COLUMNS,
        'defaultName': 'Mouvements de stock'
    },
    actions: [],
    isSubModule: true,
    'formRoute': '/store/movement/movement-form/',
    'viewUrl': 'store/movement/movement/',
    'printGroup': 'store-movement',
    'apiUrl': 'store/store-movement',
    'headerLabel': 'shared.movement_list',
    'formLabel': 'store.movement',
    'editDialogComponent': null,
    resource: 'store-movement',
    headerIcon: "mdi-elevator"
};
const STORE_TRANSFORMATION_VIEW = {
    trackByKey: 'id',
    hasSearch: true,
    selectable: true,
    hasPagination: true,
    viewNamespace: 'Liste',
    query: [],
    viewSettings: {
        'model': 'ft_stock.store.StoreTransformation',
        'viewColumns': STORE_TRANSFORMATION_COLUMNS,
        'systemColumns': SYSTEM_COLUMNS,
        'defaultName': 'Transformations des articles'
    },
    actions: [],
    isSubModule: true,
    'formRoute': '/store/transformation/transformation-form/',
    'viewUrl': 'store/transformation/transformation/',
    'printGroup': 'store-transformation',
    'apiUrl': 'store/store-transformation',
    'headerLabel': 'shared.transformation_list',
    'formLabel': 'store.transformation_form',
    'editDialogComponent': null,
    resource: 'store-transformation',
    headerIcon: "mdi-crop-rotate"
};

function FamilyDialogComponent_mat_error_16_Template(rf, ctx) {
    if (rf & 1) {
        i0.ɵɵelementStart(0, "mat-error");
        i0.ɵɵtext(1);
        i0.ɵɵpipe(2, "translate");
        i0.ɵɵelementEnd();
    }
    if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "store.code_already_exist"), "");
    }
}
function FamilyDialogComponent_mat_error_21_Template(rf, ctx) {
    if (rf & 1) {
        i0.ɵɵelementStart(0, "mat-error");
        i0.ɵɵtext(1);
        i0.ɵɵpipe(2, "translate");
        i0.ɵɵelementEnd();
    }
    if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "store.name_already_exist"), "");
    }
}
function FamilyDialogComponent_mat_option_26_Template(rf, ctx) {
    if (rf & 1) {
        i0.ɵɵelementStart(0, "mat-option", 24);
        i0.ɵɵtext(1);
        i0.ɵɵelementEnd();
    }
    if (rf & 2) {
        const elem_r6 = ctx.$implicit;
        i0.ɵɵproperty("value", elem_r6);
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", elem_r6.name, "");
    }
}
const _c0$y = function (a0) { return { pk: a0, field: "code", "pk_field": "id" }; };
const _c1$o = function (a0) { return { "$ne": a0 }; };
const _c2$h = function (a0, a1) { return { "_id": a0, parent: a1 }; };
const _c3$3 = function (a1) { return { field: "name", query: a1 }; };
class FamilyDialogComponent {
    constructor(snackBar, route, dialogRef, translate, sharedService, data) {
        this.snackBar = snackBar;
        this.route = route;
        this.dialogRef = dialogRef;
        this.translate = translate;
        this.sharedService = sharedService;
        this.data = data;
        this.familyChanged = new EventEmitter();
    }
    ngOnInit() {
        this.sharedService.getDocuments('store/family').subscribe(data => this.families = _.reject(data, { id: this.model.id }));
        this.model = this.data || {};
    }
    addItem() {
        this.sharedService.saveDocument('store/family', this.model).subscribe(item => {
            this.model = item;
            this.snackBar.open(this.translate.instant('store.operation_completed'), null, {
                duration: 2500,
            });
            if (!_.isEmpty(this.dialogRef)) {
                this.dialogRef.close(item);
            }
        });
    }
    compareValues(o1, o2) {
        return o1 && o2 ? o1.id === o2.id : o1 == o2;
    }
}
FamilyDialogComponent.ɵfac = function FamilyDialogComponent_Factory(t) { return new (t || FamilyDialogComponent)(i0.ɵɵdirectiveInject(i1$2.MatSnackBar), i0.ɵɵdirectiveInject(i3.ActivatedRoute), i0.ɵɵdirectiveInject(i1.MatDialogRef), i0.ɵɵdirectiveInject(i3$1.TranslateService), i0.ɵɵdirectiveInject(SharedService), i0.ɵɵdirectiveInject(MAT_DIALOG_DATA)); };
FamilyDialogComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: FamilyDialogComponent, selectors: [["fts-family-dialog"]], inputs: { family: "family" }, outputs: { familyChanged: "familyChanged" }, decls: 39, vars: 48, consts: [["color", "primary"], ["fontSet", "mdi", 3, "fontIcon"], ["fxFlex", ""], ["mat-icon-button", "", "tabindex", "-1"], ["fontSet", "mdi", "fontIcon", "mdi-close", 3, "mat-dialog-close"], [1, "ft-content"], ["fxLayout", "column", "name", "form", 1, "form", 3, "submit"], ["familyForm", "ngForm"], ["fxLayout", "row", "fxLayoutGap", "6px"], ["fxFlex", "30", 1, "with-error-label"], ["matInput", "", "name", "code", "required", "", "ftCustomValidation", "family.check_uniqueness", 3, "placeholder", "ngModel", "query", "ftSequenceInput", "ngModelChange"], ["code", "ngModel"], [4, "ngIf"], ["fxFlex", "", 1, "with-error-label"], ["matInput", "", "name", "name", "required", "", "ftCustomValidation", "family.check_family_uniqueness", 3, "ftAutoFocus", "placeholder", "ngModel", "watchedValue", "query", "ngModelChange"], ["name", "ngModel"], ["fxLayout", "row"], ["name", "parent", 3, "placeholder", "ngModel", "disabled", "compareWith", "ngModelChange"], [3, "value", 4, "ngFor", "ngForOf"], ["fxFlex", "100"], ["matInput", "", "name", "description", 3, "placeholder", "ngModel", "ngModelChange"], ["mat-dialog-actions", ""], ["mat-raised-button", "", "color", "primary", "type", "submit", 3, "disabled", "click"], ["type", "button", "color", "warn", "mat-raised-button", "", "tabindex", "-1", 3, "mat-dialog-close"], [3, "value"]], template: function FamilyDialogComponent_Template(rf, ctx) {
        if (rf & 1) {
            i0.ɵɵelementStart(0, "mat-toolbar", 0);
            i0.ɵɵelement(1, "mat-icon", 1);
            i0.ɵɵelementStart(2, "span");
            i0.ɵɵtext(3);
            i0.ɵɵpipe(4, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(5, "span", 2);
            i0.ɵɵelementStart(6, "button", 3);
            i0.ɵɵelement(7, "mat-icon", 4);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(8, "div", 5)(9, "form", 6, 7);
            i0.ɵɵlistener("submit", function FamilyDialogComponent_Template_form_submit_9_listener() { return ctx.addItem(); });
            i0.ɵɵelementStart(11, "div", 8)(12, "mat-form-field", 9)(13, "input", 10, 11);
            i0.ɵɵlistener("ngModelChange", function FamilyDialogComponent_Template_input_ngModelChange_13_listener($event) { return ctx.model.code = $event; });
            i0.ɵɵpipe(15, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(16, FamilyDialogComponent_mat_error_16_Template, 3, 3, "mat-error", 12);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(17, "mat-form-field", 13)(18, "input", 14, 15);
            i0.ɵɵlistener("ngModelChange", function FamilyDialogComponent_Template_input_ngModelChange_18_listener($event) { return ctx.model.name = $event; });
            i0.ɵɵpipe(20, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(21, FamilyDialogComponent_mat_error_21_Template, 3, 3, "mat-error", 12);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(22, "div", 16)(23, "mat-form-field", 2)(24, "mat-select", 17);
            i0.ɵɵlistener("ngModelChange", function FamilyDialogComponent_Template_mat_select_ngModelChange_24_listener($event) { return ctx.model.parent = $event; });
            i0.ɵɵpipe(25, "translate");
            i0.ɵɵtemplate(26, FamilyDialogComponent_mat_option_26_Template, 2, 2, "mat-option", 18);
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(27, "div", 16)(28, "mat-form-field", 19)(29, "textarea", 20);
            i0.ɵɵlistener("ngModelChange", function FamilyDialogComponent_Template_textarea_ngModelChange_29_listener($event) { return ctx.model.description = $event; });
            i0.ɵɵpipe(30, "translate");
            i0.ɵɵelementEnd()()()()();
            i0.ɵɵelementStart(31, "div", 21);
            i0.ɵɵelement(32, "span", 2);
            i0.ɵɵelementStart(33, "button", 22);
            i0.ɵɵlistener("click", function FamilyDialogComponent_Template_button_click_33_listener() { return ctx.addItem(); });
            i0.ɵɵtext(34);
            i0.ɵɵpipe(35, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(36, "button", 23);
            i0.ɵɵtext(37);
            i0.ɵɵpipe(38, "translate");
            i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
            const _r0 = i0.ɵɵreference(10);
            const _r1 = i0.ɵɵreference(14);
            const _r3 = i0.ɵɵreference(19);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("fontIcon", (ctx.model == null ? null : ctx.model.id) ? "mdi-format-list-bulleted" : "mdi-playlist-plus");
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 25, "store.family"));
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("mat-dialog-close", null);
            i0.ɵɵadvance(6);
            i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(15, 27, "store.code"))("ngModel", ctx.model.code)("query", i0.ɵɵpureFunction1(39, _c0$y, ctx.model.id))("ftSequenceInput", "ft_stock.fts_shared.StoreFamily");
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngIf", _r1 == null ? null : _r1.errors == null ? null : _r1.errors.exists);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ftAutoFocus", true)("placeholder", i0.ɵɵpipeBind1(20, 29, "store.name_f"))("ngModel", ctx.model.name)("watchedValue", ctx.model.parent)("query", i0.ɵɵpureFunction1(46, _c3$3, i0.ɵɵpureFunction2(43, _c2$h, i0.ɵɵpureFunction1(41, _c1$o, ctx.model.id ? ctx.model.id : null), ctx.model.parent ? ctx.model.parent.id : null)));
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngIf", _r3 == null ? null : _r3.errors == null ? null : _r3.errors.exists);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(25, 31, "store.parent"))("ngModel", ctx.model.parent)("disabled", !ctx.model.name)("compareWith", ctx.compareValues);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngForOf", ctx.families);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(30, 33, "store.description"))("ngModel", ctx.model.description);
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("disabled", _r0.invalid);
            i0.ɵɵadvance(1);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(35, 35, "store.save"), " ");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("mat-dialog-close", null);
            i0.ɵɵadvance(1);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(38, 37, "shared.reset"));
        }
    }, dependencies: [i4$1.NgForOf, i4$1.NgIf, i5.MatOption, i6.MatButton, i1.MatDialogClose, i1.MatDialogActions, i9.MatIcon, i10.MatError, i10.MatFormField, i11$1.MatInput, i15.MatSelect, i11.MatToolbar, i8.DefaultLayoutDirective, i8.DefaultLayoutGapDirective, i8.DefaultFlexDirective, i16.ɵNgNoValidate, i16.DefaultValueAccessor, i16.NgControlStatus, i16.NgControlStatusGroup, i16.RequiredValidator, i16.NgModel, i16.NgForm, i2.InputDirective, i2.AutoFocusDirective, i2.SequenceInputDirective, i2.CustomValidationDirective, i3$1.TranslatePipe] });
(function () {
    (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FamilyDialogComponent, [{
            type: Component,
            args: [{ selector: 'fts-family-dialog', template: "<mat-toolbar color=\"primary\">\n   <mat-icon fontSet=\"mdi\"  [fontIcon]=\"model?.id ?  'mdi-format-list-bulleted' : 'mdi-playlist-plus'\"></mat-icon>\n  <span>{{'store.family'| translate}}</span>\n\n  <span fxFlex></span>\n   <button mat-icon-button tabindex=\"-1\">\n        <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-close\"  [mat-dialog-close]=\"null\"></mat-icon>\n      </button>\n</mat-toolbar>\n<div class=\"ft-content\">\n  <form class=\"form\" (submit)=\"addItem()\"  #familyForm=\"ngForm\" fxLayout=\"column\" name=\"form\">\n    <div fxLayout=\"row\"  fxLayoutGap=\"6px\">\n      <mat-form-field fxFlex=\"30\"  class=\"with-error-label\">\n        <input matInput [placeholder]=\"'store.code'|translate\" name=\"code\" [(ngModel)]=\"model.code\" required\n               ftCustomValidation=\"family.check_uniqueness\"\n               [query]=\"{pk:model.id, field:'code', 'pk_field':'id'}\"  #code=\"ngModel\"  [ftSequenceInput]=\"'ft_stock.fts_shared.StoreFamily'\">\n        <mat-error *ngIf=\"code?.errors?.exists\"> {{'store.code_already_exist'|translate}}</mat-error>\n      </mat-form-field>\n      <mat-form-field fxFlex  class=\"with-error-label\">\n             <input matInput\n                    [ftAutoFocus]=\"true\"\n                    [placeholder]=\"'store.name_f'|translate\" name=\"name\"\n                    [(ngModel)]=\"model.name\" required\n                    ftCustomValidation=\"family.check_family_uniqueness\"\n                    [watchedValue]=\"model.parent\"\n                    [query]=\"{\n                               field:'name',\n                               query:  {'_id': {'$ne': model.id ? model.id :null},\n                               parent: (model.parent ? model.parent.id : null)}\n                               }\"\n                    #name=\"ngModel\">\n             <mat-error *ngIf=\"name?.errors?.exists\"> {{'store.name_already_exist'|translate}}</mat-error>\n           </mat-form-field>\n    </div>\n    <div fxLayout=\"row\">\n      <mat-form-field fxFlex>\n        <mat-select  [placeholder]=\"'store.parent'|translate\" name=\"parent\"\n                    [(ngModel)]=\"model.parent\"\n                    [disabled]=\"!model.name\" [compareWith]=\"compareValues\">\n          <mat-option *ngFor=\"let elem of families\" [value]=\"elem\"> {{elem.name}}</mat-option>\n        </mat-select>\n      </mat-form-field>\n    </div>\n\n\n    <div fxLayout=\"row\">\n      <mat-form-field fxFlex=\"100\">\n        <textarea matInput [placeholder]=\"'store.description'|translate\" name=\"description\"\n                  [(ngModel)]=\"model.description\"></textarea>\n      </mat-form-field>\n    </div>\n\n  </form>\n</div>\n<div mat-dialog-actions>\n  <span fxFlex></span>\n  <button  mat-raised-button color=\"primary\" type=\"submit\" (click)=\"addItem()\"\n          [disabled]=\"familyForm.invalid\">\n    {{'store.save'|translate}}\n  </button>\n  <button type=\"button\" [mat-dialog-close]=\"null\"  color=\"warn\" mat-raised-button tabindex=\"-1\">{{'shared.reset'|translate}}</button>\n</div>\n" }]
        }], function () {
        return [{ type: i1$2.MatSnackBar }, { type: i3.ActivatedRoute }, { type: i1.MatDialogRef }, { type: i3$1.TranslateService }, { type: SharedService }, { type: undefined, decorators: [{
                        type: Inject,
                        args: [MAT_DIALOG_DATA]
                    }] }];
    }, { family: [{
                type: Input
            }], familyChanged: [{
                type: Output
            }] });
})();

function ProviderDialogComponent_mat_error_16_Template(rf, ctx) {
    if (rf & 1) {
        i0.ɵɵelementStart(0, "mat-error");
        i0.ɵɵtext(1);
        i0.ɵɵpipe(2, "translate");
        i0.ɵɵelementEnd();
    }
    if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "store.code_already_exist"), "");
    }
}
function ProviderDialogComponent_mat_error_17_Template(rf, ctx) {
    if (rf & 1) {
        i0.ɵɵelementStart(0, "mat-error");
        i0.ɵɵtext(1);
        i0.ɵɵpipe(2, "translate");
        i0.ɵɵelementEnd();
    }
    if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "shared.required_field_error"));
    }
}
function ProviderDialogComponent_mat_error_22_Template(rf, ctx) {
    if (rf & 1) {
        i0.ɵɵelementStart(0, "mat-error");
        i0.ɵɵtext(1);
        i0.ɵɵpipe(2, "translate");
        i0.ɵɵelementEnd();
    }
    if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "store.name_already_exist"), "");
    }
}
function ProviderDialogComponent_mat_error_23_Template(rf, ctx) {
    if (rf & 1) {
        i0.ɵɵelementStart(0, "mat-error");
        i0.ɵɵtext(1);
        i0.ɵɵpipe(2, "translate");
        i0.ɵɵelementEnd();
    }
    if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "shared.required_field_error"));
    }
}
function ProviderDialogComponent_mat_error_28_Template(rf, ctx) {
    if (rf & 1) {
        i0.ɵɵelementStart(0, "mat-error");
        i0.ɵɵtext(1);
        i0.ɵɵpipe(2, "translate");
        i0.ɵɵelementEnd();
    }
    if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "store.not_a_valid_email"));
    }
}
function ProviderDialogComponent_mat_error_29_Template(rf, ctx) {
    if (rf & 1) {
        i0.ɵɵelementStart(0, "mat-error");
        i0.ɵɵtext(1);
        i0.ɵɵpipe(2, "translate");
        i0.ɵɵelementEnd();
    }
    if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "shared.required_field_error"));
    }
}
function ProviderDialogComponent_mat_error_35_Template(rf, ctx) {
    if (rf & 1) {
        i0.ɵɵelementStart(0, "mat-error");
        i0.ɵɵtext(1);
        i0.ɵɵpipe(2, "translate");
        i0.ɵɵelementEnd();
    }
    if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "store.phone_already_exist"), "");
    }
}
const _c0$x = function (a0) { return { pk: a0, field: "code", "pk_field": "id" }; };
const _c1$n = function (a0) { return { pk: a0, field: "name", "pk_field": "id" }; };
const _c2$g = function (a0) { return { pk: a0, field: "phone", pk_field: "id" }; };
class ProviderDialogComponent {
    constructor(sharedService, snackBar, route, translate, dialogRef, data) {
        this.sharedService = sharedService;
        this.snackBar = snackBar;
        this.route = route;
        this.translate = translate;
        this.dialogRef = dialogRef;
        this.data = data;
        this.email = new FormControl('', [Validators.email]);
        this.isDialog = false;
        this.model = {};
    }
    ngOnInit() {
        this.isDialog = !_.isEmpty(this.dialogRef);
        this.model = _.cloneDeep(this.data);
        let id = _.get(this.model, 'id');
        if (id) {
            this.sharedService.getDocument('store/provider', id).subscribe(data => {
            });
        }
    }
    closeDialog() {
        this.dialogRef.close();
    }
    addItem() {
        this.sharedService.saveDocument('store/provider', this.model).subscribe(item => {
            this.dialogRef.close(item);
            this.snackBar.open(this.translate.instant('store.operation_completed'), null, {
                duration: 2500,
            });
        });
    }
}
ProviderDialogComponent.ɵfac = function ProviderDialogComponent_Factory(t) { return new (t || ProviderDialogComponent)(i0.ɵɵdirectiveInject(SharedService), i0.ɵɵdirectiveInject(i1$2.MatSnackBar), i0.ɵɵdirectiveInject(i3.ActivatedRoute), i0.ɵɵdirectiveInject(i3$1.TranslateService), i0.ɵɵdirectiveInject(i1.MatDialogRef), i0.ɵɵdirectiveInject(MAT_DIALOG_DATA)); };
ProviderDialogComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ProviderDialogComponent, selectors: [["fts-provider-form"]], decls: 74, vars: 75, consts: [["color", "primary"], ["fontSet", "mdi", "fontIcon", "mdi-account-circle"], ["fxFlex", ""], ["mat-icon-button", "", "tabindex", "-1"], ["fontSet", "mdi", "fontIcon", "mdi-close", 3, "mat-dialog-close"], ["fxLayout", "column", 1, "ft-content"], ["fxFill", "", "fxLayout", "column", "name", "provider", 1, "form"], ["providerForm", "ngForm"], ["fxLayout", "row", "fxLayoutGap", "6px"], ["fxFlex", "", 1, "with-error-label"], ["matInput", "", "name", "code", "required", "", "ftCustomValidation", "provider.check_uniqueness", 3, "placeholder", "ngModel", "ftAutoFocus", "query", "ftSequenceInput", "ngModelChange"], ["code", "ngModel"], [4, "ngIf"], ["matInput", "", "name", "name", "ftCustomValidation", "provider.check_uniqueness", "required", "", 3, "ftAutoFocus", "placeholder", "ngModel", "query", "ngModelChange"], ["name", "ngModel"], ["matInput", "", "name", "email", "type", "email", "pattern", "[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\\.[a-zA-Z]{2,4}", 3, "placeholder", "ngModel", "ngModelChange"], ["fontSet", "mdi", "fontIcon", "mdi-email", "matSuffix", ""], ["matInput", "", "maxlength", "10", "minlength", "10", "type", "text", "name", "phone", "pattern", "^[0-9]{5,12}$", "required", "", "ftCustomValidation", "provider.check_uniqueness", 3, "placeholder", "ngModel", "query", "ngModelChange"], ["phone", "ngModel"], ["fontSet", "mdi", "fontIcon", "mdi-phone", "matSuffix", ""], ["matInput", "", "maxlength", "10", "name", "fax", "type", "text", "minlength", "10", 3, "placeholder", "ngModel", "ngModelChange"], ["fontSet", "mdi", "fontIcon", "mdi-fax", "matSuffix", ""], ["matInput", "", "name", "address", 3, "placeholder", "ngModel", "ngModelChange"], ["fontSet", "mdi", "fontIcon", "mdi-map-marker", "matSuffix", ""], ["matInput", "", "name", "comment", 3, "placeholder", "ngModel", "ngModelChange"], [1, "ft-sep"], ["matInput", "", "name", "director", 3, "placeholder", "ngModel", "ngModelChange"], ["matInput", "", "name", "sales_manager", 3, "placeholder", "ngModel", "ngModelChange"], ["matInput", "", "name", "rc", 3, "placeholder", "ngModel", "ngModelChange"], ["matInput", "", "name", "ice", 3, "placeholder", "ngModel", "ngModelChange"], ["mat-dialog-actions", ""], ["mat-raised-button", "", "color", "primary", 3, "disabled", "click"], ["type", "button", "color", "warn", "mat-raised-button", "", "tabindex", "-1", 3, "mat-dialog-close"]], template: function ProviderDialogComponent_Template(rf, ctx) {
        if (rf & 1) {
            i0.ɵɵelementStart(0, "mat-toolbar", 0);
            i0.ɵɵelement(1, "mat-icon", 1);
            i0.ɵɵelementStart(2, "span");
            i0.ɵɵtext(3);
            i0.ɵɵpipe(4, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(5, "span", 2);
            i0.ɵɵelementStart(6, "button", 3);
            i0.ɵɵelement(7, "mat-icon", 4);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(8, "div", 5)(9, "form", 6, 7)(11, "div", 8)(12, "mat-form-field", 9)(13, "input", 10, 11);
            i0.ɵɵlistener("ngModelChange", function ProviderDialogComponent_Template_input_ngModelChange_13_listener($event) { return ctx.model.code = $event; });
            i0.ɵɵpipe(15, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(16, ProviderDialogComponent_mat_error_16_Template, 3, 3, "mat-error", 12);
            i0.ɵɵtemplate(17, ProviderDialogComponent_mat_error_17_Template, 3, 3, "mat-error", 12);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(18, "mat-form-field", 9)(19, "input", 13, 14);
            i0.ɵɵlistener("ngModelChange", function ProviderDialogComponent_Template_input_ngModelChange_19_listener($event) { return ctx.model.name = $event; });
            i0.ɵɵpipe(21, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(22, ProviderDialogComponent_mat_error_22_Template, 3, 3, "mat-error", 12);
            i0.ɵɵtemplate(23, ProviderDialogComponent_mat_error_23_Template, 3, 3, "mat-error", 12);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(24, "div", 8)(25, "mat-form-field", 9)(26, "input", 15);
            i0.ɵɵlistener("ngModelChange", function ProviderDialogComponent_Template_input_ngModelChange_26_listener($event) { return ctx.model.email = $event; });
            i0.ɵɵpipe(27, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(28, ProviderDialogComponent_mat_error_28_Template, 3, 3, "mat-error", 12);
            i0.ɵɵtemplate(29, ProviderDialogComponent_mat_error_29_Template, 3, 3, "mat-error", 12);
            i0.ɵɵelement(30, "mat-icon", 16);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(31, "mat-form-field", 2)(32, "input", 17, 18);
            i0.ɵɵlistener("ngModelChange", function ProviderDialogComponent_Template_input_ngModelChange_32_listener($event) { return ctx.model.phone = $event; });
            i0.ɵɵpipe(34, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(35, ProviderDialogComponent_mat_error_35_Template, 3, 3, "mat-error", 12);
            i0.ɵɵelement(36, "mat-icon", 19);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(37, "mat-form-field", 2)(38, "input", 20);
            i0.ɵɵlistener("ngModelChange", function ProviderDialogComponent_Template_input_ngModelChange_38_listener($event) { return ctx.model.fax = $event; });
            i0.ɵɵpipe(39, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(40, "mat-icon", 21);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(41, "div", 8)(42, "mat-form-field", 2)(43, "textarea", 22);
            i0.ɵɵlistener("ngModelChange", function ProviderDialogComponent_Template_textarea_ngModelChange_43_listener($event) { return ctx.model.address = $event; });
            i0.ɵɵpipe(44, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(45, "mat-icon", 23);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(46, "mat-form-field", 2)(47, "textarea", 24);
            i0.ɵɵlistener("ngModelChange", function ProviderDialogComponent_Template_textarea_ngModelChange_47_listener($event) { return ctx.model.comment = $event; });
            i0.ɵɵpipe(48, "translate");
            i0.ɵɵelementEnd()()();
            i0.ɵɵelement(49, "hr", 25);
            i0.ɵɵelementStart(50, "div", 8)(51, "mat-form-field", 2)(52, "input", 26);
            i0.ɵɵlistener("ngModelChange", function ProviderDialogComponent_Template_input_ngModelChange_52_listener($event) { return ctx.model.director = $event; });
            i0.ɵɵpipe(53, "translate");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(54, "mat-form-field", 2)(55, "input", 27);
            i0.ɵɵlistener("ngModelChange", function ProviderDialogComponent_Template_input_ngModelChange_55_listener($event) { return ctx.model.sales_manager = $event; });
            i0.ɵɵpipe(56, "translate");
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(57, "div", 8)(58, "mat-form-field", 2)(59, "input", 28);
            i0.ɵɵlistener("ngModelChange", function ProviderDialogComponent_Template_input_ngModelChange_59_listener($event) { return ctx.model.rc = $event; });
            i0.ɵɵpipe(60, "translate");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(61, "mat-form-field", 2)(62, "input", 29);
            i0.ɵɵlistener("ngModelChange", function ProviderDialogComponent_Template_input_ngModelChange_62_listener($event) { return ctx.model.ice = $event; });
            i0.ɵɵpipe(63, "translate");
            i0.ɵɵelementEnd()()();
            i0.ɵɵelement(64, "span", 2);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(65, "div", 30);
            i0.ɵɵelement(66, "span", 2);
            i0.ɵɵelementStart(67, "button", 31);
            i0.ɵɵlistener("click", function ProviderDialogComponent_Template_button_click_67_listener() { return ctx.addItem(); });
            i0.ɵɵelementStart(68, "span");
            i0.ɵɵtext(69);
            i0.ɵɵpipe(70, "translate");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(71, "button", 32);
            i0.ɵɵtext(72);
            i0.ɵɵpipe(73, "translate");
            i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
            const _r0 = i0.ɵɵreference(10);
            const _r1 = i0.ɵɵreference(14);
            const _r4 = i0.ɵɵreference(20);
            const _r9 = i0.ɵɵreference(33);
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 41, "store.provider"));
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("mat-dialog-close", null);
            i0.ɵɵadvance(6);
            i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(15, 43, "store.code"))("ngModel", ctx.model.code)("ftAutoFocus", true)("query", i0.ɵɵpureFunction1(69, _c0$x, ctx.model.id))("ftSequenceInput", "ft_stock.fts_shared.StoreProvider");
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngIf", _r1 == null ? null : _r1.errors == null ? null : _r1.errors.exists);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", _r1 == null ? null : _r1.errors == null ? null : _r1.errors.required);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ftAutoFocus", true)("placeholder", i0.ɵɵpipeBind1(21, 45, "store.name"))("ngModel", ctx.model.name)("query", i0.ɵɵpureFunction1(71, _c1$n, ctx.model.id));
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngIf", _r4 == null ? null : _r4.errors == null ? null : _r4.errors.exists);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", _r4 == null ? null : _r4.errors == null ? null : _r4.errors.required);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(27, 47, "store.email"))("ngModel", ctx.model.email);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.email == null ? null : ctx.email.errors == null ? null : ctx.email.errors.email);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.email == null ? null : ctx.email.errors == null ? null : ctx.email.errors.required);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(34, 49, "store.phone"))("ngModel", ctx.model.phone)("query", i0.ɵɵpureFunction1(73, _c2$g, ctx.model.id));
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngIf", _r9 == null ? null : _r9.errors == null ? null : _r9.errors.exists);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(39, 51, "store.fax"))("ngModel", ctx.model.fax);
            i0.ɵɵadvance(5);
            i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(44, 53, "store.address"))("ngModel", ctx.model.address);
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(48, 55, "store.comment"))("ngModel", ctx.model.comment);
            i0.ɵɵadvance(5);
            i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(53, 57, "store.director"))("ngModel", ctx.model.director);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(56, 59, "store.sales_manager"))("ngModel", ctx.model.sales_manager);
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(60, 61, "store.rc"))("ngModel", ctx.model.rc);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(63, 63, "store.ice"))("ngModel", ctx.model.ice);
            i0.ɵɵadvance(5);
            i0.ɵɵproperty("disabled", _r0.invalid);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(70, 65, "store.save"));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("mat-dialog-close", null);
            i0.ɵɵadvance(1);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(73, 67, "shared.reset"));
        }
    }, dependencies: [i4$1.NgIf, i6.MatButton, i1.MatDialogClose, i1.MatDialogActions, i9.MatIcon, i10.MatError, i10.MatFormField, i10.MatSuffix, i11$1.MatInput, i11.MatToolbar, i8.DefaultLayoutDirective, i8.DefaultLayoutGapDirective, i8.FlexFillDirective, i8.DefaultFlexDirective, i16.ɵNgNoValidate, i16.DefaultValueAccessor, i16.NgControlStatus, i16.NgControlStatusGroup, i16.RequiredValidator, i16.MinLengthValidator, i16.MaxLengthValidator, i16.PatternValidator, i16.NgModel, i16.NgForm, i2.InputDirective, i2.AutoFocusDirective, i2.SequenceInputDirective, i2.CustomValidationDirective, i3$1.TranslatePipe] });
(function () {
    (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ProviderDialogComponent, [{
            type: Component,
            args: [{ selector: 'fts-provider-form', template: "<mat-toolbar color=\"primary\">\n   <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-account-circle\"></mat-icon>\n  <span>{{'store.provider'| translate}}</span>\n  <span fxFlex></span>\n\n  <button mat-icon-button tabindex=\"-1\">\n    <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-close\"  [mat-dialog-close]=\"null\"></mat-icon>\n  </button>\n</mat-toolbar>\n<div class=\"ft-content\"   fxLayout=\"column\">\n  <form class=\"form\"  fxFill fxLayout=\"column\" #providerForm=\"ngForm\" name=\"provider\">\n    <div fxLayout=\"row\" fxLayoutGap=\"6px\">\n      <mat-form-field fxFlex class=\"with-error-label\" >\n        <input  matInput [placeholder]=\"'store.code'|translate\"\n                name=\"code\"\n                [(ngModel)]=\"model.code\"\n                required\n               [ftAutoFocus]=\"true\"\n                ftCustomValidation=\"provider.check_uniqueness\"\n                [query]=\"{pk:model.id, field:'code', 'pk_field':'id'}\"\n                #code=\"ngModel\" [ftSequenceInput]=\"'ft_stock.fts_shared.StoreProvider'\">\n        <mat-error *ngIf=\"code?.errors?.exists\"> {{'store.code_already_exist'|translate}}</mat-error>\n         <mat-error *ngIf=\"code?.errors?.required\">{{'shared.required_field_error'|translate}}</mat-error>\n       </mat-form-field>\n      <mat-form-field fxFlex   class=\"with-error-label\" >\n        <input matInput [ftAutoFocus]=\"true\"\n         [placeholder]=\"'store.name'|translate\"\n         name=\"name\" #name=\"ngModel\"\n         [(ngModel)]=\"model.name\"\n         ftCustomValidation=\"provider.check_uniqueness\"\n         [query]=\"{pk:model.id, field:'name', 'pk_field':'id'}\"\n         required>\n         <mat-error *ngIf=\"name?.errors?.exists\"> {{'store.name_already_exist'|translate}}</mat-error>\n         <mat-error *ngIf=\"name?.errors?.required\">{{'shared.required_field_error'|translate}}</mat-error>\n      </mat-form-field>\n    </div>\n    <div fxLayout=\"row\" fxLayoutGap=\"6px\">\n      <mat-form-field fxFlex  class=\"with-error-label\">\n        <input matInput [placeholder]=\"'store.email'|translate\"  name=\"email\" type=\"email\" pattern=\"[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\\.[a-zA-Z]{2,4}\"\n               [(ngModel)]=\"model.email\" >\n        <mat-error *ngIf=\"email?.errors?.email\">{{'store.not_a_valid_email'|translate}}</mat-error>\n        <mat-error *ngIf=\"email?.errors?.required\">{{'shared.required_field_error'|translate}}</mat-error>\n        <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-email\" matSuffix></mat-icon>\n      </mat-form-field>\n      <mat-form-field fxFlex >\n        <input matInput maxlength=\"10\" minlength=\"10\"\n               [placeholder]=\"'store.phone'|translate\" type=\"text\"\n               name=\"phone\"   pattern=\"^[0-9]{5,12}$\"\n               [(ngModel)]=\"model.phone\" required\n               ftCustomValidation=\"provider.check_uniqueness\"\n               [query]=\"{pk:model.id, field:'phone',pk_field:'id'}\"\n               #phone=\"ngModel\">\n        <mat-error *ngIf=\"phone?.errors?.exists\"> {{'store.phone_already_exist'|translate}}</mat-error>\n        <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-phone\" matSuffix></mat-icon>\n      </mat-form-field>\n      <mat-form-field fxFlex >\n        <input matInput maxlength=\"10\" [placeholder]=\"'store.fax'|translate\" name=\"fax\" type=\"text\"\n               [(ngModel)]=\"model.fax\"  minlength=\"10\">\n         <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-fax\" matSuffix></mat-icon>\n      </mat-form-field>\n    </div>\n    <div fxLayout=\"row\" fxLayoutGap=\"6px\">\n      <mat-form-field fxFlex >\n        <textarea matInput [placeholder]=\"'store.address'|translate\" name=\"address\"\n                  [(ngModel)]=\"model.address\"></textarea>\n        <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-map-marker\" matSuffix></mat-icon>\n      </mat-form-field>\n      <mat-form-field fxFlex >\n        <textarea matInput [placeholder]=\"'store.comment'|translate\" name=\"comment\"\n                  [(ngModel)]=\"model.comment\"></textarea>\n      </mat-form-field>\n    </div>\n    <hr class=\"ft-sep\">\n    <div fxLayout=\"row\" fxLayoutGap=\"6px\">\n      <mat-form-field fxFlex >\n        <input matInput [placeholder]=\"'store.director'|translate\" name=\"director\" [(ngModel)]=\"model.director\">\n      </mat-form-field>\n      <mat-form-field fxFlex >\n        <input matInput [placeholder]=\"'store.sales_manager'|translate\" name=\"sales_manager\"\n               [(ngModel)]=\"model.sales_manager\">\n      </mat-form-field>\n    </div>\n    <div fxLayout=\"row\" fxLayoutGap=\"6px\">\n      <mat-form-field fxFlex >\n              <input matInput [placeholder]=\"'store.rc'|translate\" name=\"rc\" [(ngModel)]=\"model.rc\">\n            </mat-form-field>\n      <mat-form-field fxFlex   >\n        <input matInput [placeholder]=\"'store.ice'|translate\" name=\"ice\" [(ngModel)]=\"model.ice\">\n      </mat-form-field>\n    </div>\n    <span fxFlex></span>\n  </form>\n</div>\n<div mat-dialog-actions>\n<span fxFlex></span>\n  <button mat-raised-button color=\"primary\" (click)=\"addItem()\"\n          [disabled]=\"providerForm.invalid\">\n    <span>{{'store.save'|translate}}</span>\n  </button>\n  <button type=\"button\" [mat-dialog-close]=\"null\"  color=\"warn\" mat-raised-button tabindex=\"-1\">{{'shared.reset'|translate}}</button>\n</div>\n" }]
        }], function () {
        return [{ type: SharedService }, { type: i1$2.MatSnackBar }, { type: i3.ActivatedRoute }, { type: i3$1.TranslateService }, { type: i1.MatDialogRef }, { type: undefined, decorators: [{
                        type: Inject,
                        args: [MAT_DIALOG_DATA]
                    }] }];
    }, null);
})();

function ListFormDialogComponent_mat_form_field_11_mat_error_4_Template(rf, ctx) {
    if (rf & 1) {
        i0.ɵɵelementStart(0, "mat-error");
        i0.ɵɵtext(1);
        i0.ɵɵpipe(2, "translate");
        i0.ɵɵelementEnd();
    }
    if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "store.value_already_exist"), "");
    }
}
const _c0$w = function (a1) { return { field: "value", pk: a1, pk_field: "id" }; };
function ListFormDialogComponent_mat_form_field_11_Template(rf, ctx) {
    if (rf & 1) {
        const _r6 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "mat-form-field", 18)(1, "input", 19, 20);
        i0.ɵɵlistener("ngModelChange", function ListFormDialogComponent_mat_form_field_11_Template_input_ngModelChange_1_listener($event) { i0.ɵɵrestoreView(_r6); const ctx_r5 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r5.list.value = $event); });
        i0.ɵɵpipe(3, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(4, ListFormDialogComponent_mat_form_field_11_mat_error_4_Template, 3, 3, "mat-error", 21);
        i0.ɵɵelementEnd();
    }
    if (rf & 2) {
        const _r3 = i0.ɵɵreference(2);
        const ctx_r1 = i0.ɵɵnextContext();
        i0.ɵɵadvance(1);
        i0.ɵɵpropertyInterpolate("ftCustomValidation", ctx_r1.customValidator);
        i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(3, 5, "common.list.value"))("ngModel", ctx_r1.list.value)("query", i0.ɵɵpureFunction1(7, _c0$w, ctx_r1.list.id));
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", _r3 == null ? null : _r3.errors == null ? null : _r3.errors.exists);
    }
}
function ListFormDialogComponent_mat_form_field_12_mat_error_4_Template(rf, ctx) {
    if (rf & 1) {
        i0.ɵɵelementStart(0, "mat-error");
        i0.ɵɵtext(1);
        i0.ɵɵpipe(2, "translate");
        i0.ɵɵelementEnd();
    }
    if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "store.value_already_exist"), "");
    }
}
function ListFormDialogComponent_mat_form_field_12_Template(rf, ctx) {
    if (rf & 1) {
        const _r10 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "mat-form-field", 18)(1, "input", 22, 20);
        i0.ɵɵlistener("ngModelChange", function ListFormDialogComponent_mat_form_field_12_Template_input_ngModelChange_1_listener($event) { i0.ɵɵrestoreView(_r10); const ctx_r9 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r9.list.value = $event); });
        i0.ɵɵpipe(3, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(4, ListFormDialogComponent_mat_form_field_12_mat_error_4_Template, 3, 3, "mat-error", 21);
        i0.ɵɵelementEnd();
    }
    if (rf & 2) {
        const _r7 = i0.ɵɵreference(2);
        const ctx_r2 = i0.ɵɵnextContext();
        i0.ɵɵadvance(1);
        i0.ɵɵpropertyInterpolate("ftCustomValidation", ctx_r2.customValidator);
        i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(3, 6, "common.list.value"))("ngModel", ctx_r2.list.value)("ftNumber", "float")("query", i0.ɵɵpureFunction1(8, _c0$w, ctx_r2.list.id));
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", _r7 == null ? null : _r7.errors == null ? null : _r7.errors.exists);
    }
}
class ListFormDialogComponent extends BaseListFormDialog {
    constructor(service, dialogRef, data) {
        super(service, dialogRef, data);
        this.isNumber = false;
        this.customValidator = null;
        this.isNumber = get(data, 'listDefinition.isNumber', false);
        this.customValidator = get(data, 'listDefinition.customValidator', null);
    }
}
ListFormDialogComponent.ɵfac = function ListFormDialogComponent_Factory(t) { return new (t || ListFormDialogComponent)(i0.ɵɵdirectiveInject(i2.GeneralPurposeService), i0.ɵɵdirectiveInject(i1.MatDialogRef), i0.ɵɵdirectiveInject(MAT_DIALOG_DATA)); };
ListFormDialogComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ListFormDialogComponent, selectors: [["fts-list-form-dialog"]], features: [i0.ɵɵInheritDefinitionFeature], decls: 21, vars: 10, consts: [["color", "primary"], [1, "ft-module-icon"], ["fontSet", "mdi", "fontIcon", "mdi-playlist-plus"], ["mat-dialog-title", "", "translate", "common.list.setup_item"], ["fxFlex", ""], ["mat-icon-button", "", "mat-dialog-close", "", "tabindex", "-1"], ["fontSet", "mdi", "fontIcon", "mdi-close"], ["fxLayout", "column", 3, "subscription", "ftAsyncSubmit"], ["listForm", "ngForm"], ["mat-dialog-content", "", "fxLayout", "column", 1, "ft-busy-container"], [3, "ngBusy"], ["fxFlex", "", "class", "with-error-label", 4, "ngIf"], ["matInput", "", "name", "description", "required", "", "autocomplete", "off", 3, "placeholder", "ngModel", "ngModelChange"], ["mat-dialog-actions", ""], ["mat-raised-button", "", "color", "primary", "type", "submit", 3, "disabled"], ["translate", "common.save"], ["mat-raised-button", "", "color", "warn", "type", "button", "tabindex", "-1", 3, "mat-dialog-close"], ["translate", "common.cancel"], ["fxFlex", "", 1, "with-error-label"], ["matInput", "", "required", "", "name", "value", "autocomplete", "off", "type", "text", 3, "placeholder", "ngModel", "ftCustomValidation", "query", "ngModelChange"], ["value", "ngModel"], [4, "ngIf"], ["matInput", "", "required", "", "name", "value", "autocomplete", "off", 3, "placeholder", "ngModel", "ftNumber", "ftCustomValidation", "query", "ngModelChange"]], template: function ListFormDialogComponent_Template(rf, ctx) {
        if (rf & 1) {
            i0.ɵɵelementStart(0, "mat-toolbar", 0)(1, "div", 1);
            i0.ɵɵelement(2, "mat-icon", 2);
            i0.ɵɵelementEnd();
            i0.ɵɵelement(3, "h2", 3)(4, "span", 4);
            i0.ɵɵelementStart(5, "button", 5);
            i0.ɵɵelement(6, "mat-icon", 6);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(7, "form", 7, 8);
            i0.ɵɵlistener("ftAsyncSubmit", function ListFormDialogComponent_Template_form_ftAsyncSubmit_7_listener() { return ctx.submit(); });
            i0.ɵɵelementStart(9, "div", 9);
            i0.ɵɵelement(10, "div", 10);
            i0.ɵɵtemplate(11, ListFormDialogComponent_mat_form_field_11_Template, 5, 9, "mat-form-field", 11);
            i0.ɵɵtemplate(12, ListFormDialogComponent_mat_form_field_12_Template, 5, 10, "mat-form-field", 11);
            i0.ɵɵelementStart(13, "mat-form-field", 4)(14, "input", 12);
            i0.ɵɵlistener("ngModelChange", function ListFormDialogComponent_Template_input_ngModelChange_14_listener($event) { return ctx.list.description = $event; });
            i0.ɵɵpipe(15, "translate");
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(16, "div", 13)(17, "button", 14);
            i0.ɵɵelement(18, "span", 15);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(19, "button", 16);
            i0.ɵɵelement(20, "span", 17);
            i0.ɵɵelementEnd()()();
        }
        if (rf & 2) {
            const _r0 = i0.ɵɵreference(8);
            i0.ɵɵadvance(7);
            i0.ɵɵproperty("subscription", ctx.loader);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngBusy", ctx.loader);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", !ctx.isNumber);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.isNumber);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(15, 8, "common.list.description"))("ngModel", ctx.list.description);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("disabled", _r0.invalid);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("mat-dialog-close", null);
        }
    }, dependencies: [i4$1.NgIf, i6.MatButton, i1.MatDialogClose, i1.MatDialogTitle, i1.MatDialogContent, i1.MatDialogActions, i9.MatIcon, i10.MatError, i10.MatFormField, i11$1.MatInput, i11.MatToolbar, i8.DefaultLayoutDirective, i8.DefaultFlexDirective, i3$1.TranslateDirective, i16.ɵNgNoValidate, i16.DefaultValueAccessor, i16.NgControlStatus, i16.NgControlStatusGroup, i16.RequiredValidator, i16.NgModel, i16.NgForm, i12.NgBusyDirective, i2.InputDirective, i2.NumberDirective, i2.AsyncSubmitDirective, i2.CustomValidationDirective, i3$1.TranslatePipe] });
(function () {
    (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ListFormDialogComponent, [{
            type: Component,
            args: [{ selector: 'fts-list-form-dialog', template: "<mat-toolbar color=\"primary\">\n    <div class=\"ft-module-icon\">\n        <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-playlist-plus\"></mat-icon>\n    </div>\n    <h2 mat-dialog-title translate=\"common.list.setup_item\"></h2>\n    <span fxFlex></span>\n    <button mat-icon-button mat-dialog-close tabindex=\"-1\">\n        <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-close\"></mat-icon>\n    </button>\n</mat-toolbar>\n\n<form #listForm=\"ngForm\" fxLayout=\"column\" (ftAsyncSubmit)=\"submit()\" [subscription]=\"loader\">\n    <div mat-dialog-content fxLayout=\"column\" class=\"ft-busy-container\">\n        <div [ngBusy]=\"loader\"></div>\n        <mat-form-field  *ngIf=\"!isNumber\" fxFlex  class=\"with-error-label\">\n            <input matInput required [placeholder]=\"'common.list.value' | translate\" name=\"value\"\n                   [(ngModel)]=\"list.value\" autocomplete=\"off\" type=\"text\"\n                   #value=\"ngModel\"\n                   ftCustomValidation=\"{{customValidator}}\"\n                   [query]=\"{field:'value', pk:list.id, pk_field:'id'}\"\n                   >\n            <mat-error *ngIf=\"value?.errors?.exists\"> {{'store.value_already_exist'|translate}}</mat-error>\n        </mat-form-field>\n        <mat-form-field *ngIf=\"isNumber\" fxFlex  class=\"with-error-label\">\n            <input matInput required [placeholder]=\"'common.list.value' | translate\" name=\"value\"\n                   [(ngModel)]=\"list.value\" autocomplete=\"off\" [ftNumber]=\"'float'\"\n                   #value=\"ngModel\"\n                   ftCustomValidation=\"{{customValidator}}\"\n                   [query]=\"{field:'value', pk:list.id, pk_field:'id'}\"\n                   >\n            <mat-error *ngIf=\"value?.errors?.exists\"> {{'store.value_already_exist'|translate}}</mat-error>\n        </mat-form-field>\n\n        <mat-form-field fxFlex>\n            <input matInput [placeholder]=\"'common.list.description' | translate\" name=\"description\" required\n                   [(ngModel)]=\"list.description\" autocomplete=\"off\">\n        </mat-form-field>\n    </div>\n    <div mat-dialog-actions>\n        <button mat-raised-button color=\"primary\" type=\"submit\"\n                [disabled]=\"listForm.invalid\">\n            <span translate=\"common.save\"></span>\n        </button>\n        <button mat-raised-button color=\"warn\" type=\"button\"\n                [mat-dialog-close]=\"null\" tabindex=\"-1\">\n            <span translate=\"common.cancel\"></span>\n        </button>\n    </div>\n</form>\n" }]
        }], function () {
        return [{ type: i2.GeneralPurposeService }, { type: i1.MatDialogRef }, { type: undefined, decorators: [{
                        type: Inject,
                        args: [MAT_DIALOG_DATA]
                    }] }];
    }, null);
})();

const PATIENT_COLUMNS = [
    {
        'label': 'shared.first_name',
        'key': 'first_name',
        'sortBy': 'first_name',
        'type': 'text',
        'is_global_searchable': true
    }, {
        'label': 'shared.last_name',
        'key': 'last_name',
        'sortBy': 'last_name',
        'type': 'text',
        'is_global_searchable': true
    },
    {
        'label': 'shared.birth_date',
        'key': 'birth_date',
        'sortBy': 'birth_date',
        'type': 'date',
        'is_global_searchable': true
    },
    {
        'label': 'shared.cin',
        'key': 'national_id',
        'sortBy': 'national_id',
        'type': 'text',
        'is_global_searchable': true
    }
];

const ORGANIZATION_COLUMNS = [
    {
        "label": "shared.name",
        "key": "name",
        "sortBy": "name",
        "type": "text",
        "is_global_searchable": true
    },
    {
        "label": "shared.full_name",
        "key": "full_name",
        "sortBy": "full_name",
        "type": "text",
        "is_global_searchable": true
    },
    {
        "label": "shared.address",
        "key": "address",
        "sortBy": "address",
        "type": "text",
        "is_global_searchable": true
    },
    {
        "label": "shared.email",
        "key": "email",
        "sortBy": "email",
        "type": "text",
        "is_global_searchable": true
    },
    {
        "label": "shared.phone_number",
        "key": "phone_numbers",
        "type": "text",
        "is_global_searchable": true
    }
];

const PROVIDER_COLUMNS = [
    {
        "label": "store.name",
        "key": "name",
        "type": "text",
        "is_global_searchable": true
    },
    {
        "label": "store.director",
        "key": "director",
        "type": "text",
        "is_global_searchable": true
    },
    {
        "label": "store.sales_manager",
        "key": "sales_manager",
        "type": "text",
        "is_global_searchable": true
    },
    {
        "label": "store.phone",
        "key": "phone",
        "type": "text",
        "is_global_searchable": true
    },
    {
        "label": "store.email",
        "key": "email",
        "type": "text",
        "is_global_searchable": true
    }
];

const FAMILY_COLUMNS = [
    {
        "label": "shared.name",
        "key": "name",
        "type": "text",
        "is_global_searchable": true
    },
    {
        "label": "store.parent",
        "key": "parent.name",
        "type": "text",
        "is_global_searchable": true
    },
    {
        "label": "shared.address",
        "key": "address",
        "type": "text",
        "is_global_searchable": true
    },
    {
        "label": "shared.description",
        "key": "description",
        "type": "text",
        "is_global_searchable": true
    }
];

const PATIENT_VIEW = {
    trackByKey: 'id',
    hasSearch: true,
    selectable: true,
    hasPagination: true,
    viewNamespace: 'Liste',
    query: [],
    viewSettings: {
        'model': 'ft_stock.fts_shared.FtPatient',
        'viewColumns': PATIENT_COLUMNS,
        'systemColumns': SYSTEM_COLUMNS,
        'defaultName': 'Liste des patient'
    },
    actions: [],
    isSubModule: true,
    'formRoute': '',
    'viewUrl': '',
    'apiUrl': 'store/patient',
    'headerLabel': 'shared.patient_list',
    'formLabel': '',
    resource: 'ft-patient',
    headerIcon: "mdi-format-list-bulleted",
    deleteTopic: ''
};
const ORGANIZATION_VIEW = {
    trackByKey: 'id',
    hasSearch: true,
    selectable: true,
    hasPagination: true,
    viewNamespace: 'Liste',
    query: [],
    viewSettings: {
        'model': 'ft_stock.fts_shared.Organization',
        'viewColumns': ORGANIZATION_COLUMNS,
        'systemColumns': SYSTEM_COLUMNS,
        'defaultName': 'Liste des organismes'
    },
    actions: [],
    isSubModule: true,
    'formRoute': '',
    'viewUrl': '',
    'apiUrl': 'store/organization',
    'headerLabel': 'shared.organization_list',
    'formLabel': '',
    resource: 'organization',
    headerIcon: "mdi-format-list-bulleted",
    deleteTopic: ''
};
const PROVIDER_VIEW = {
    trackByKey: 'id',
    hasSearch: true,
    selectable: true,
    hasPagination: true,
    viewNamespace: 'Liste',
    query: [],
    viewSettings: {
        'model': 'ft_stock.fts_shared.StoreProvider',
        'viewColumns': PROVIDER_COLUMNS,
        'systemColumns': SYSTEM_COLUMNS,
        'defaultName': 'Liste des fournisseurs'
    },
    actions: [],
    isSubModule: true,
    'formRoute': null,
    'viewUrl': 'store/provider',
    'apiUrl': 'store/provider',
    'headerLabel': 'store.provider_list',
    'formLabel': 'store.provider',
    'editDialogComponent': ProviderDialogComponent,
    resource: 'store-provider',
    headerIcon: "mdi-account-circle",
    deleteTopic: 'provider.check_delete'
};
const FAMILY_VIEW = {
    trackByKey: 'id',
    hasSearch: true,
    selectable: true,
    hasPagination: true,
    viewNamespace: 'Liste',
    query: [],
    viewSettings: {
        'model': 'ft_stock.fts_shared.StoreFamily',
        'viewColumns': FAMILY_COLUMNS,
        'systemColumns': SYSTEM_COLUMNS,
        'defaultName': 'Liste des familles'
    },
    actions: [],
    isSubModule: true,
    'formRoute': null,
    'viewUrl': 'store/family',
    'apiUrl': 'store/family',
    'headerLabel': 'shared.family_list',
    'formLabel': 'store.family',
    'editDialogComponent': FamilyDialogComponent,
    resource: 'store-family',
    headerIcon: 'mdi-format-list-bulleted',
    deleteTopic: 'family.check_delete'
};

function AddArticleDialogComponent_span_6_Template(rf, ctx) {
    if (rf & 1) {
        i0.ɵɵelementStart(0, "span");
        i0.ɵɵtext(1);
        i0.ɵɵelementEnd();
    }
    if (rf & 2) {
        const ctx_r0 = i0.ɵɵnextContext();
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(": ", ctx_r0.model == null ? null : ctx_r0.model.code, "");
    }
}
function AddArticleDialogComponent_mat_error_19_Template(rf, ctx) {
    if (rf & 1) {
        i0.ɵɵelementStart(0, "mat-error");
        i0.ɵɵtext(1);
        i0.ɵɵpipe(2, "translate");
        i0.ɵɵelementEnd();
    }
    if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "store.code_already_exist"), "");
    }
}
function AddArticleDialogComponent_mat_radio_button_65_Template(rf, ctx) {
    if (rf & 1) {
        i0.ɵɵelementStart(0, "mat-radio-button", 43);
        i0.ɵɵtext(1);
        i0.ɵɵpipe(2, "translate");
        i0.ɵɵelementEnd();
    }
    if (rf & 2) {
        const element_r5 = ctx.$implicit;
        i0.ɵɵproperty("value", element_r5);
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 2, "store." + element_r5), " ");
    }
}
const _c0$v = function (a0) { return { pk: a0, field: "code", pk_field: "id" }; };
const _c1$m = function () { return { key: "value", url: "api/list/unity/", cls: "list/unity", customValidator: "store-unity.check_uniqueness" }; };
const _c2$f = function () { return { key: "description", url: "api/list/vat/", cls: "list/vat", isNumber: true, customValidator: "store-vat.check_uniqueness" }; };
class AddArticleDialogComponent {
    constructor(snackBar, dialog, route, router, sharedService, sharedModulesService, purposeSerive, translateService, dialogRef) {
        this.snackBar = snackBar;
        this.dialog = dialog;
        this.route = route;
        this.router = router;
        this.sharedService = sharedService;
        this.sharedModulesService = sharedModulesService;
        this.purposeSerive = purposeSerive;
        this.translateService = translateService;
        this.dialogRef = dialogRef;
        this.model = {
            purchase_price: 0.0,
            purchase_price_max: 0.0,
            sale_price: 0.0,
            sale_price_min: 0.0,
            min_qte: 0.0,
            max_qte: 0.0,
            min_dep_qte: 0.0,
            max_dep_qte: 0.0,
            evaluation: 'FIFO'
        };
        this.familyInputSettings = _.assignIn(_.cloneDeep(FAMILY_VIEW), { selectable: false });
        this.familyDialog = FamilyDialogComponent;
        this.providerInputSettings = _.assignIn(_.cloneDeep(PROVIDER_VIEW), { selectable: false });
        this.providerDialog = ProviderDialogComponent;
        this.unityDialog = ListFormDialogComponent;
        this.vatDialog = ListFormDialogComponent;
        this.reloadUnitiesEvent = new EventEmitter();
        this.reloadVatsEvent = new EventEmitter();
        this.evaluations = ['FIFO', 'LIFO', 'FEFO', 'PMP'];
        this.busy = null;
        this.apiUrl = 'store/article';
        this.urls = { list: '/store/article/article-list', form: '/store/article/article-form' };
        this.isDialog = false;
        this.readOnly = false;
    }
    ngOnInit() {
    }
    saveArticle(with_exit) {
        this.busy = this.sharedService.saveDocument('store/article', this.model).subscribe(item => {
            this.model = item;
            this.snackBar.open(this.translateService.instant('store.operation_completed'), null, {
                duration: 2500,
            });
            this.dialogRef.close(true);
        });
    }
    handleReloadUnities(data) {
        if (data) {
            this.reloadUnitiesEvent.emit(true);
        }
    }
    handleReloadVats(data) {
        if (data) {
            this.reloadVatsEvent.emit(true);
        }
    }
}
AddArticleDialogComponent.ɵfac = function AddArticleDialogComponent_Factory(t) { return new (t || AddArticleDialogComponent)(i0.ɵɵdirectiveInject(i1$2.MatSnackBar), i0.ɵɵdirectiveInject(i1.MatDialog), i0.ɵɵdirectiveInject(i3.ActivatedRoute), i0.ɵɵdirectiveInject(i3.Router), i0.ɵɵdirectiveInject(SharedService), i0.ɵɵdirectiveInject(SharedModulesService), i0.ɵɵdirectiveInject(i2.GeneralPurposeService), i0.ɵɵdirectiveInject(i3$1.TranslateService), i0.ɵɵdirectiveInject(i1.MatDialogRef)); };
AddArticleDialogComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AddArticleDialogComponent, selectors: [["fts-article-dialog"]], decls: 100, vars: 138, consts: [["color", "primary"], ["fontSet", "mdi", "fontIcon", "mdi-format-list-bulleted"], [4, "ngIf"], ["fxFlex", ""], ["mat-icon-button", "", "tabindex", "-1"], ["fontSet", "mdi", "fontIcon", "mdi-close", 3, "mat-dialog-close"], ["mat-dialog-content", "", "fxLayout", "column", 1, "ft-content"], [3, "ngBusy"], ["fxFill", "", "fxLayout", "column", "name", "article", 1, "ft-content", "ft-padding"], ["articleForm", "ngForm"], ["fxLayout", "row", "fxLayoutGap", "8px"], ["fxFlex", "25", 1, "with-error-label"], ["matInput", "", "name", "code", "required", "", "ftCustomValidation", "article.check_uniqueness", 3, "ftAutoFocus", "placeholder", "ngModel", "query", "readonly", "ngModelChange"], ["code", "ngModel"], ["matInput", "", "name", "description", "required", "", 3, "placeholder", "ngModel", "ngModelChange"], ["fxFlex", "", 3, "label", "model", "value", "settings", "dialog", "modelChange"], ["fxFlex", "", 3, "model", "listDialog", "reloadEvent", "config", "label", "modelChange"], ["fxFlex", "", 3, "model", "listDialog", "reloadEvent", "config", "label", "defaultValues", "modelChange"], ["matInput", "", "name", "purchase_price", 3, "placeholder", "ngModel", "ftNumber", "ngModelChange"], ["matInput", "", "name", "purchase_price_max", 3, "placeholder", "ftNumber", "ngModel", "ngModelChange"], ["matInput", "", "name", "sale_price", 3, "placeholder", "ftNumber", "ngModel", "ngModelChange"], ["matInput", "", "name", "sale_price_min", 3, "placeholder", "ftNumber", "ngModel", "ngModelChange"], ["matInput", "", "name", "min_qte", 3, "placeholder", "ftNumber", "ngModel", "ngModelChange"], ["matInput", "", "name", "max_qte", 3, "placeholder", "ftNumber", "ngModel", "ngModelChange"], ["matInput", "", "name", "min_dep_qte", 3, "placeholder", "ftNumber", "ngModel", "ngModelChange"], ["matInput", "", "name", "max_dep_qte", 3, "placeholder", "ftNumber", "ngModel", "ngModelChange"], [1, "ft-sep"], ["fxLayoutGap", "6px", "fxLayout", "column"], ["floatLabel", "always", 1, "ft-radio-field"], ["matInput", "", "placeholder", "", 2, "display", "none"], ["name", "evaluation", "color", "primary", "fxFlex", "", 3, "ngModel", "ngModelChange"], [3, "value", 4, "ngFor", "ngForOf"], ["fxLayoutGap", "6px", "fxFlex", "row"], ["name", "prohibited_for_sale", "color", "primary", 3, "ngModel", "ngModelChange"], [3, "innerHTML"], ["name", "prohibited_to_purchase", "color", "primary", 3, "ngModel", "ngModelChange"], ["name", "allows_negative_stock", "color", "primary", 3, "ngModel", "ngModelChange"], ["name", "has_serial", "color", "primary", 3, "ngModel", "disabled", "ngModelChange"], ["name", "has_lot_number", "color", "primary", 3, "ngModel", "disabled", "ngModelChange"], ["name", "lapsing", "color", "primary", 3, "ngModel", "ngModelChange"], ["mat-dialog-actions", ""], ["mat-raised-button", "", "color", "warn", 3, "mat-dialog-close"], ["mat-raised-button", "", "color", "primary", 3, "disabled", "click"], [3, "value"]], template: function AddArticleDialogComponent_Template(rf, ctx) {
        if (rf & 1) {
            i0.ɵɵelementStart(0, "mat-toolbar", 0);
            i0.ɵɵelement(1, "mat-icon", 1);
            i0.ɵɵelementStart(2, "h2")(3, "span");
            i0.ɵɵtext(4);
            i0.ɵɵpipe(5, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(6, AddArticleDialogComponent_span_6_Template, 2, 1, "span", 2);
            i0.ɵɵelementEnd();
            i0.ɵɵelement(7, "span", 3);
            i0.ɵɵelementStart(8, "button", 4);
            i0.ɵɵelement(9, "mat-icon", 5);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(10, "div", 6);
            i0.ɵɵelement(11, "div", 7);
            i0.ɵɵelementStart(12, "form", 8, 9)(14, "div", 10)(15, "mat-form-field", 11)(16, "input", 12, 13);
            i0.ɵɵlistener("ngModelChange", function AddArticleDialogComponent_Template_input_ngModelChange_16_listener($event) { return ctx.model.code = $event; });
            i0.ɵɵpipe(18, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(19, AddArticleDialogComponent_mat_error_19_Template, 3, 3, "mat-error", 2);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(20, "mat-form-field", 3)(21, "input", 14);
            i0.ɵɵlistener("ngModelChange", function AddArticleDialogComponent_Template_input_ngModelChange_21_listener($event) { return ctx.model.description = $event; });
            i0.ɵɵpipe(22, "translate");
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(23, "div", 10)(24, "fts-document-select", 15);
            i0.ɵɵlistener("modelChange", function AddArticleDialogComponent_Template_fts_document_select_modelChange_24_listener($event) { return ctx.model.family = $event; });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(25, "fts-document-select", 15);
            i0.ɵɵlistener("modelChange", function AddArticleDialogComponent_Template_fts_document_select_modelChange_25_listener($event) { return ctx.model.default_provider = $event; });
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(26, "div", 10)(27, "fts-list-select", 16);
            i0.ɵɵlistener("modelChange", function AddArticleDialogComponent_Template_fts_list_select_modelChange_27_listener($event) { return ctx.model.purchase_unity = $event; })("modelChange", function AddArticleDialogComponent_Template_fts_list_select_modelChange_27_listener($event) { return ctx.handleReloadUnities($event); });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(28, "fts-list-select", 17);
            i0.ɵɵlistener("modelChange", function AddArticleDialogComponent_Template_fts_list_select_modelChange_28_listener($event) { return ctx.model.purchase_vat = $event; })("modelChange", function AddArticleDialogComponent_Template_fts_list_select_modelChange_28_listener($event) { return ctx.handleReloadVats($event); });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(29, "mat-form-field", 3)(30, "input", 18);
            i0.ɵɵlistener("ngModelChange", function AddArticleDialogComponent_Template_input_ngModelChange_30_listener($event) { return ctx.model.purchase_price = $event; });
            i0.ɵɵpipe(31, "translate");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(32, "mat-form-field", 3)(33, "input", 19);
            i0.ɵɵlistener("ngModelChange", function AddArticleDialogComponent_Template_input_ngModelChange_33_listener($event) { return ctx.model.purchase_price_max = $event; });
            i0.ɵɵpipe(34, "translate");
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(35, "div", 10)(36, "fts-list-select", 16);
            i0.ɵɵlistener("modelChange", function AddArticleDialogComponent_Template_fts_list_select_modelChange_36_listener($event) { return ctx.model.sale_unity = $event; })("modelChange", function AddArticleDialogComponent_Template_fts_list_select_modelChange_36_listener($event) { return ctx.handleReloadUnities($event); });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(37, "fts-list-select", 17);
            i0.ɵɵlistener("modelChange", function AddArticleDialogComponent_Template_fts_list_select_modelChange_37_listener($event) { return ctx.model.sale_vat = $event; })("modelChange", function AddArticleDialogComponent_Template_fts_list_select_modelChange_37_listener($event) { return ctx.handleReloadVats($event); });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(38, "mat-form-field", 3)(39, "input", 20);
            i0.ɵɵlistener("ngModelChange", function AddArticleDialogComponent_Template_input_ngModelChange_39_listener($event) { return ctx.model.sale_price = $event; });
            i0.ɵɵpipe(40, "translate");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(41, "mat-form-field", 3)(42, "input", 21);
            i0.ɵɵlistener("ngModelChange", function AddArticleDialogComponent_Template_input_ngModelChange_42_listener($event) { return ctx.model.sale_price_min = $event; });
            i0.ɵɵpipe(43, "translate");
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(44, "div", 10)(45, "mat-form-field", 3)(46, "input", 22);
            i0.ɵɵlistener("ngModelChange", function AddArticleDialogComponent_Template_input_ngModelChange_46_listener($event) { return ctx.model.min_qte = $event; });
            i0.ɵɵpipe(47, "translate");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(48, "mat-form-field", 3)(49, "input", 23);
            i0.ɵɵlistener("ngModelChange", function AddArticleDialogComponent_Template_input_ngModelChange_49_listener($event) { return ctx.model.max_qte = $event; });
            i0.ɵɵpipe(50, "translate");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(51, "mat-form-field", 3)(52, "input", 24);
            i0.ɵɵlistener("ngModelChange", function AddArticleDialogComponent_Template_input_ngModelChange_52_listener($event) { return ctx.model.min_dep_qte = $event; });
            i0.ɵɵpipe(53, "translate");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(54, "mat-form-field", 3)(55, "input", 25);
            i0.ɵɵlistener("ngModelChange", function AddArticleDialogComponent_Template_input_ngModelChange_55_listener($event) { return ctx.model.max_dep_qte = $event; });
            i0.ɵɵpipe(56, "translate");
            i0.ɵɵelementEnd()()();
            i0.ɵɵelement(57, "hr", 26);
            i0.ɵɵelementStart(58, "div", 27)(59, "h4");
            i0.ɵɵtext(60);
            i0.ɵɵpipe(61, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(62, "mat-form-field", 28);
            i0.ɵɵelement(63, "input", 29);
            i0.ɵɵelementStart(64, "mat-radio-group", 30);
            i0.ɵɵlistener("ngModelChange", function AddArticleDialogComponent_Template_mat_radio_group_ngModelChange_64_listener($event) { return ctx.model.evaluation = $event; });
            i0.ɵɵtemplate(65, AddArticleDialogComponent_mat_radio_button_65_Template, 3, 4, "mat-radio-button", 31);
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(66, "div", 27)(67, "h4");
            i0.ɵɵtext(68);
            i0.ɵɵpipe(69, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(70, "div", 32)(71, "mat-slide-toggle", 33);
            i0.ɵɵlistener("ngModelChange", function AddArticleDialogComponent_Template_mat_slide_toggle_ngModelChange_71_listener($event) { return ctx.model.prohibited_for_sale = $event; });
            i0.ɵɵelement(72, "span", 34);
            i0.ɵɵpipe(73, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(74, "mat-slide-toggle", 35);
            i0.ɵɵlistener("ngModelChange", function AddArticleDialogComponent_Template_mat_slide_toggle_ngModelChange_74_listener($event) { return ctx.model.prohibited_to_purchase = $event; });
            i0.ɵɵelement(75, "span", 34);
            i0.ɵɵpipe(76, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(77, "mat-slide-toggle", 36);
            i0.ɵɵlistener("ngModelChange", function AddArticleDialogComponent_Template_mat_slide_toggle_ngModelChange_77_listener($event) { return ctx.model.allows_negative_stock = $event; });
            i0.ɵɵelement(78, "span", 34);
            i0.ɵɵpipe(79, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(80, "mat-slide-toggle", 37);
            i0.ɵɵlistener("ngModelChange", function AddArticleDialogComponent_Template_mat_slide_toggle_ngModelChange_80_listener($event) { return ctx.model.has_serial = $event; });
            i0.ɵɵelement(81, "span", 34);
            i0.ɵɵpipe(82, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(83, "mat-slide-toggle", 38);
            i0.ɵɵlistener("ngModelChange", function AddArticleDialogComponent_Template_mat_slide_toggle_ngModelChange_83_listener($event) { return ctx.model.has_lot_number = $event; });
            i0.ɵɵelement(84, "span", 34);
            i0.ɵɵpipe(85, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(86, "mat-slide-toggle", 39);
            i0.ɵɵlistener("ngModelChange", function AddArticleDialogComponent_Template_mat_slide_toggle_ngModelChange_86_listener($event) { return ctx.model.lapsing = $event; });
            i0.ɵɵelement(87, "span", 34);
            i0.ɵɵpipe(88, "translate");
            i0.ɵɵelementEnd()()()()();
            i0.ɵɵelementStart(89, "div", 40);
            i0.ɵɵelement(90, "span", 3)(91, "span", 3);
            i0.ɵɵelementStart(92, "button", 41)(93, "span");
            i0.ɵɵtext(94);
            i0.ɵɵpipe(95, "translate");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(96, "button", 42);
            i0.ɵɵlistener("click", function AddArticleDialogComponent_Template_button_click_96_listener() { return ctx.saveArticle(false); });
            i0.ɵɵelementStart(97, "span");
            i0.ɵɵtext(98);
            i0.ɵɵpipe(99, "translate");
            i0.ɵɵelementEnd()()();
        }
        if (rf & 2) {
            const _r1 = i0.ɵɵreference(13);
            const _r2 = i0.ɵɵreference(17);
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(5, 90, "store.article_form_sheet"), " ");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.model == null ? null : ctx.model.id);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("mat-dialog-close", null);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngBusy", ctx.busy);
            i0.ɵɵadvance(5);
            i0.ɵɵproperty("ftAutoFocus", true)("placeholder", i0.ɵɵpipeBind1(18, 92, "store.code"))("ngModel", ctx.model.code)("query", i0.ɵɵpureFunction1(132, _c0$v, ctx.model.id))("readonly", ctx.readOnly);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngIf", _r2 == null ? null : _r2.errors == null ? null : _r2.errors.exists);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(22, 94, "store.description"))("ngModel", ctx.model.description);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("label", "store.family")("model", ctx.model.family)("value", "name")("settings", ctx.familyInputSettings)("dialog", ctx.familyDialog);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("label", "store.default_provider")("model", ctx.model.default_provider)("value", "name")("settings", ctx.providerInputSettings)("dialog", ctx.providerDialog);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("model", ctx.model.purchase_unity)("listDialog", ctx.unityDialog)("reloadEvent", ctx.reloadUnitiesEvent)("config", i0.ɵɵpureFunction0(134, _c1$m))("label", "store.purchase_unity");
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("model", ctx.model.purchase_vat)("listDialog", ctx.vatDialog)("reloadEvent", ctx.reloadVatsEvent)("config", i0.ɵɵpureFunction0(135, _c2$f))("label", "store.purchase_vat")("defaultValues", "default_purchase_vat");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(31, 96, "store.purchase_price"))("ngModel", ctx.model.purchase_price)("ftNumber", "float");
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(34, 98, "store.purchase_price_max"))("ftNumber", "float")("ngModel", ctx.model.purchase_price_max);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("model", ctx.model.sale_unity)("listDialog", ctx.unityDialog)("reloadEvent", ctx.reloadUnitiesEvent)("config", i0.ɵɵpureFunction0(136, _c1$m))("label", "store.sale_unity");
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("model", ctx.model.sale_vat)("listDialog", ctx.vatDialog)("reloadEvent", ctx.reloadVatsEvent)("config", i0.ɵɵpureFunction0(137, _c2$f))("label", "store.sale_vat")("defaultValues", "default_sale_vat");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(40, 100, "store.sale_price"))("ftNumber", "float")("ngModel", ctx.model.sale_price);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(43, 102, "store.sale_price_min"))("ftNumber", "float")("ngModel", ctx.model.sale_price_min);
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(47, 104, "store.min_qte"))("ftNumber", "float")("ngModel", ctx.model.min_qte);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(50, 106, "store.max_qte"))("ftNumber", "float")("ngModel", ctx.model.max_qte);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(53, 108, "store.min_dep_qte"))("ftNumber", "float")("ngModel", ctx.model.min_dep_qte);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(56, 110, "store.max_dep_qte"))("ftNumber", "float")("ngModel", ctx.model.max_dep_qte);
            i0.ɵɵadvance(5);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(61, 112, "store.store_out_rules"));
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngModel", ctx.model.evaluation);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngForOf", ctx.evaluations);
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(69, 114, "store.management_rules"));
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngModel", ctx.model.prohibited_for_sale);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(73, 116, "store.prohibited_for_sale"), i0.ɵɵsanitizeHtml);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngModel", ctx.model.prohibited_to_purchase);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(76, 118, "store.prohibited_to_purchase"), i0.ɵɵsanitizeHtml);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngModel", ctx.model.allows_negative_stock);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(79, 120, "store.allows_negative_stock"), i0.ɵɵsanitizeHtml);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngModel", ctx.model.has_serial)("disabled", ctx.model.has_lot_number);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(82, 122, "store.has_serial"), i0.ɵɵsanitizeHtml);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngModel", ctx.model.has_lot_number)("disabled", ctx.model.has_serial);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(85, 124, "store.has_lot_number"), i0.ɵɵsanitizeHtml);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngModel", ctx.model.lapsing);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(88, 126, "store.lapsing"), i0.ɵɵsanitizeHtml);
            i0.ɵɵadvance(5);
            i0.ɵɵproperty("mat-dialog-close", null);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(95, 128, "store.cancel"));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("disabled", _r1.invalid);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(99, 130, "store.save"));
        }
    }, encapsulation: 2 });
(function () {
    (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AddArticleDialogComponent, [{
            type: Component,
            args: [{ selector: 'fts-article-dialog', template: "<mat-toolbar color=\"primary\">\n      <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-format-list-bulleted\"></mat-icon>\n\n  <h2>\n    <span> {{'store.article_form_sheet'|translate}} </span>\n        <span *ngIf=\"model?.id\">: {{model?.code}}</span>\n\n  </h2>\n  <span fxFlex></span>\n  <button mat-icon-button tabindex=\"-1\">\n    <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-close\"  [mat-dialog-close]=\"null\"></mat-icon>\n  </button>\n\n\n</mat-toolbar>\n<div mat-dialog-content  class=\"ft-content\"   fxLayout=\"column\">\n <div [ngBusy]=\"busy\"></div>\n      <form class=\"form\" fxFill fxLayout=\"column\" name=\"article\" #articleForm=\"ngForm\" class=\"ft-content ft-padding\">\n\n        <div fxLayout=\"row\" fxLayoutGap=\"8px\">\n          <mat-form-field  fxFlex=\"25\"  class=\"with-error-label\">\n            <input [ftAutoFocus]=\"true\"\n                   matInput\n                   [placeholder]=\"'store.code'|translate\" name=\"code\"\n                   [(ngModel)]=\"model.code\" required\n                   [query]=\"{pk:model.id, field:'code', pk_field:'id'}\"\n                   ftCustomValidation=\"article.check_uniqueness\"\n                   #code=\"ngModel\"\n                   [readonly]=\"readOnly\">\n            <mat-error *ngIf=\"code?.errors?.exists\"> {{'store.code_already_exist'|translate}}</mat-error>\n          </mat-form-field>\n          <mat-form-field fxFlex >\n            <input matInput [placeholder]=\"'store.description'|translate\"\n                   name=\"description\"  [(ngModel)]=\"model.description\" required>\n          </mat-form-field>\n        </div>\n        <div fxLayout=\"row\" fxLayoutGap=\"8px\">\n          <fts-document-select fxFlex\n                               [label]=\"'store.family'\"\n                               [(model)]=\"model.family\"\n                               [value]=\"'name'\"\n                               [settings]=\"familyInputSettings\"\n                               [dialog]=\"familyDialog\">\n          </fts-document-select>\n          <fts-document-select fxFlex\n                               [label]=\"'store.default_provider'\"\n                               [(model)]=\"model.default_provider\"\n                               [value]=\"'name'\"\n                               [settings]=\"providerInputSettings\"\n                               [dialog]=\"providerDialog\">\n          </fts-document-select>\n        </div>\n        <div fxLayout=\"row\" fxLayoutGap=\"8px\">\n            <fts-list-select fxFlex\n                             [(model)]=\"model.purchase_unity\"\n                             [listDialog]=\"unityDialog\"\n                             (modelChange)=\"handleReloadUnities($event)\"\n                             [reloadEvent]=\"reloadUnitiesEvent\"\n                             [config]=\"{key: 'value', url: 'api/list/unity/', cls:'list/unity', customValidator:'store-unity.check_uniqueness'}\"\n                             [label]=\"'store.purchase_unity'\"\n                              >\n            </fts-list-select>\n            <fts-list-select fxFlex\n                             [(model)]=\"model.purchase_vat\"\n                             [listDialog]=\"vatDialog\"\n                            [reloadEvent]=\"reloadVatsEvent\"\n                            (modelChange)=\"handleReloadVats($event)\"\n                             [config]=\"{key: 'description', url: 'api/list/vat/', cls:'list/vat', isNumber:true,customValidator:'store-vat.check_uniqueness' }\"\n                             [label]=\"'store.purchase_vat'\"  [defaultValues]=\"'default_purchase_vat'\"\n                             >\n            </fts-list-select>\n            <mat-form-field fxFlex>\n              <input matInput [placeholder]=\"'store.purchase_price'|translate\" name=\"purchase_price\"\n                   [(ngModel)]=\"model.purchase_price\" [ftNumber]=\"'float'\">\n            </mat-form-field>\n            <mat-form-field fxFlex>\n              <input matInput [placeholder]=\"'store.purchase_price_max'|translate\" [ftNumber]=\"'float'\"\n                     name=\"purchase_price_max\"\n                     [(ngModel)]=\"model.purchase_price_max\">\n            </mat-form-field>\n        </div>\n        <div fxLayout=\"row\" fxLayoutGap=\"8px\">\n          <fts-list-select fxFlex\n                           [(model)]=\"model.sale_unity\"\n                           [listDialog]=\"unityDialog\"\n                           (modelChange)=\"handleReloadUnities($event)\"\n                           [reloadEvent]=\"reloadUnitiesEvent\"\n                           [config]=\"{key: 'value', url: 'api/list/unity/', cls:'list/unity',customValidator:'store-unity.check_uniqueness'}\"\n                           [label]=\"'store.sale_unity'\"\n                           >\n          </fts-list-select>\n          <fts-list-select fxFlex\n                            [(model)]=\"model.sale_vat\"\n                            [listDialog]=\"vatDialog\"\n                            [reloadEvent]=\"reloadVatsEvent\"\n                            (modelChange)=\"handleReloadVats($event)\"\n                            [config]=\"{key: 'description', url: 'api/list/vat/', cls:'list/vat', isNumber:true,customValidator:'store-vat.check_uniqueness'}\"\n                            [label]=\"'store.sale_vat'\"  [defaultValues]=\"'default_sale_vat'\"\n                             >\n          </fts-list-select>\n          <mat-form-field fxFlex>\n            <input matInput\n                   [placeholder]=\"'store.sale_price'|translate\"\n                   [ftNumber]=\"'float'\" name=\"sale_price\"\n                   [(ngModel)]=\"model.sale_price\">\n          </mat-form-field>\n\n          <mat-form-field fxFlex>\n            <input matInput [placeholder]=\"'store.sale_price_min'|translate\" [ftNumber]=\"'float'\"\n                   name=\"sale_price_min\"\n                   [(ngModel)]=\"model.sale_price_min\">\n          </mat-form-field>\n        </div>\n        <div fxLayout=\"row\" fxLayoutGap=\"8px\">\n          <mat-form-field fxFlex>\n            <input matInput [placeholder]=\"'store.min_qte'|translate\" name=\"min_qte\" [ftNumber]=\"'float'\"\n                   [(ngModel)]=\"model.min_qte\">\n          </mat-form-field>\n\n          <mat-form-field fxFlex>\n            <input matInput [placeholder]=\"'store.max_qte'|translate\" name=\"max_qte\" [ftNumber]=\"'float'\"\n                   [(ngModel)]=\"model.max_qte\">\n          </mat-form-field>\n\n          <mat-form-field fxFlex>\n            <input matInput [placeholder]=\"'store.min_dep_qte'|translate\" [ftNumber]=\"'float'\" name=\"min_dep_qte\"\n                   [(ngModel)]=\"model.min_dep_qte\">\n          </mat-form-field>\n\n          <mat-form-field fxFlex>\n            <input matInput [placeholder]=\"'store.max_dep_qte'|translate\" [ftNumber]=\"'float'\" name=\"max_dep_qte\"\n                   [(ngModel)]=\"model.max_dep_qte\">\n          </mat-form-field>\n        </div>\n\n        <hr class=\"ft-sep\">\n        <div  fxLayoutGap=\"6px\" fxLayout=\"column\">\n          <h4>{{'store.store_out_rules'|translate}}</h4>\n          <mat-form-field floatLabel=\"always\" class=\"ft-radio-field\">\n            <input matInput placeholder=\"\" style=\"display: none\">\n            <mat-radio-group [(ngModel)]=\"model.evaluation\" name=\"evaluation\" color=\"primary\" fxFlex>\n              <mat-radio-button *ngFor=\"let element of evaluations\" [value]=\"element\">\n                {{'store.'+element|translate}}\n              </mat-radio-button>\n            </mat-radio-group>\n\n          </mat-form-field>\n        </div>\n        <div  fxLayoutGap=\"6px\" fxLayout=\"column\">\n            <h4>{{'store.management_rules'|translate}}</h4>\n           <div fxLayoutGap=\"6px\" fxFlex=\"row\">\n              <mat-slide-toggle name=\"prohibited_for_sale\" [(ngModel)]=\"model.prohibited_for_sale\" color=\"primary\">\n                <span [innerHTML]=\"'store.prohibited_for_sale' | translate\"></span>\n              </mat-slide-toggle>\n\n              <mat-slide-toggle name=\"prohibited_to_purchase\" [(ngModel)]=\"model.prohibited_to_purchase\" color=\"primary\">\n                <span [innerHTML]=\"'store.prohibited_to_purchase' | translate\"></span>\n              </mat-slide-toggle>\n\n              <mat-slide-toggle name=\"allows_negative_stock\" [(ngModel)]=\"model.allows_negative_stock\" color=\"primary\">\n                <span [innerHTML]=\"'store.allows_negative_stock' | translate\"></span>\n              </mat-slide-toggle>\n\n              <mat-slide-toggle name=\"has_serial\" [(ngModel)]=\"model.has_serial\" [disabled]=\"model.has_lot_number\" color=\"primary\">\n                <span [innerHTML]=\"'store.has_serial' | translate\"></span>\n              </mat-slide-toggle>\n\n              <mat-slide-toggle name=\"has_lot_number\" [(ngModel)]=\"model.has_lot_number\" [disabled]=\"model.has_serial\" color=\"primary\">\n                <span [innerHTML]=\"'store.has_lot_number' | translate\"></span>\n              </mat-slide-toggle>\n\n              <mat-slide-toggle name=\"lapsing\" [(ngModel)]=\"model.lapsing\" color=\"primary\">\n                <span [innerHTML]=\"'store.lapsing' | translate\"></span>\n              </mat-slide-toggle>\n\n          </div>\n\n        </div>\n      </form>\n</div>\n<div mat-dialog-actions>\n  <span fxFlex></span>\n    <span fxFlex></span>\n    <button mat-raised-button color=\"warn\" [mat-dialog-close]=\"null\">\n      <span>{{'store.cancel'|translate}}</span>\n    </button>\n\n    <button mat-raised-button color=\"primary\" (click)=\"saveArticle(false)\"\n            [disabled]=\"articleForm.invalid\">\n      <span>{{'store.save'|translate}}</span>\n    </button>\n</div>\n\n" }]
        }], function () { return [{ type: i1$2.MatSnackBar }, { type: i1.MatDialog }, { type: i3.ActivatedRoute }, { type: i3.Router }, { type: SharedService }, { type: SharedModulesService }, { type: i2.GeneralPurposeService }, { type: i3$1.TranslateService }, { type: i1.MatDialogRef }]; }, null);
})();

function SelectDocumentsDialogComponent_div_11_Template(rf, ctx) {
    if (rf & 1) {
        const _r2 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "div", 10);
        i0.ɵɵelement(1, "span", 4);
        i0.ɵɵelementStart(2, "button", 11);
        i0.ɵɵlistener("click", function SelectDocumentsDialogComponent_div_11_Template_button_click_2_listener() { i0.ɵɵrestoreView(_r2); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.add()); });
        i0.ɵɵtext(3);
        i0.ɵɵpipe(4, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "button", 12);
        i0.ɵɵtext(6);
        i0.ɵɵpipe(7, "translate");
        i0.ɵɵelementEnd()();
    }
    if (rf & 2) {
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 3, "shared.submit_add"), " ");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("mat-dialog-close", null);
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(7, 5, "shared.reset"));
    }
}
class SelectDocumentsDialogComponent {
    constructor(dialogRef, dialog, data) {
        this.dialogRef = dialogRef;
        this.dialog = dialog;
        this.data = data;
        this.settings = null;
        this.selectedItems = [];
        this.tableSettings = null;
        this.reloadEvent = new EventEmitter();
        this.actions = [];
    }
    ngOnInit() {
        this.settings = this.data ? this.data : {};
        this.tableSettings = _.assign(this.settings, !this.settings.selectable ? {
            rowClick: (row) => {
                return this.select(row);
            }
        } : {});
        if (_.get(this.tableSettings, 'name') == 'store-article') {
            this.actions = [{
                    class: 'mat-primary',
                    icon: 'mdi-plus',
                    method: (e, ev) => { return this.handleNew(); },
                    acl: { resource: _.get('store-article', 'resource'), action: 'update', behavior: 'remove' }
                }];
        }
    }
    handleSelectionChange(data) {
        this.selectedItems = data;
    }
    add() {
        this.dialogRef.close(this.selectedItems);
    }
    select(row) {
        this.dialogRef.close(row);
    }
    handleNew() {
        this.dialog.open(AddArticleDialogComponent, _.assign(LARGE_DIALOG, {
            data: {},
            autoFocus: false, disableClose: true
        })).afterClosed().subscribe(res => {
            if (res) {
                this.reloadEvent.emit('true');
            }
        });
    }
}
SelectDocumentsDialogComponent.ɵfac = function SelectDocumentsDialogComponent_Factory(t) { return new (t || SelectDocumentsDialogComponent)(i0.ɵɵdirectiveInject(i1.MatDialogRef), i0.ɵɵdirectiveInject(i1.MatDialog), i0.ɵɵdirectiveInject(MAT_DIALOG_DATA)); };
SelectDocumentsDialogComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SelectDocumentsDialogComponent, selectors: [["fts-select-documents-dialog"]], decls: 12, vars: 13, consts: [["color", "primary"], [1, "ft-module-icon"], ["fontSet", "mdi", 3, "fontIcon"], ["mat-dialog-title", ""], ["fxFlex", ""], ["type", "button", "mat-icon-button", "", "mat-dialog-close", "", "tabindex", "-1"], ["fontSet", "mdi", "fontIcon", "mdi-close"], ["mat-dialog-content", "", 1, "ft-content"], ["fxFlex", "", 3, "namespace", "viewSettings", "hasPagination", "selectable", "query", "selected", "reloadEvent", "actions", "selectionChange", "lineClick", "selectedChange"], ["mat-dialog-actions", "", 4, "ngIf"], ["mat-dialog-actions", ""], ["type", "button", "color", "primary", "mat-raised-button", "", "tabindex", "2", 3, "click"], ["type", "button", "color", "warn", "mat-raised-button", "", "tabindex", "-1", 3, "mat-dialog-close"]], template: function SelectDocumentsDialogComponent_Template(rf, ctx) {
        if (rf & 1) {
            i0.ɵɵelementStart(0, "mat-toolbar", 0)(1, "div", 1);
            i0.ɵɵelement(2, "mat-icon", 2);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(3, "h2", 3);
            i0.ɵɵtext(4);
            i0.ɵɵpipe(5, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(6, "span", 4);
            i0.ɵɵelementStart(7, "button", 5);
            i0.ɵɵelement(8, "mat-icon", 6);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(9, "div", 7)(10, "ft-generic-view-table", 8);
            i0.ɵɵlistener("selectionChange", function SelectDocumentsDialogComponent_Template_ft_generic_view_table_selectionChange_10_listener($event) { return ctx.handleSelectionChange($event); })("lineClick", function SelectDocumentsDialogComponent_Template_ft_generic_view_table_lineClick_10_listener($event) { return ctx.tableSettings == null ? null : ctx.tableSettings.rowClick($event); })("selectedChange", function SelectDocumentsDialogComponent_Template_ft_generic_view_table_selectedChange_10_listener($event) { return ctx.selectedItems = $event; });
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(11, SelectDocumentsDialogComponent_div_11_Template, 8, 7, "div", 9);
        }
        if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵpropertyInterpolate("fontIcon", ctx.settings["headerIcon"]);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(5, 11, ctx.settings["headerLabel"]));
            i0.ɵɵadvance(6);
            i0.ɵɵproperty("namespace", ctx.tableSettings == null ? null : ctx.tableSettings.viewNamespace)("viewSettings", ctx.tableSettings == null ? null : ctx.tableSettings.viewSettings)("hasPagination", ctx.tableSettings == null ? null : ctx.tableSettings.hasPagination)("selectable", ctx.tableSettings == null ? null : ctx.tableSettings.selectable)("query", ctx.tableSettings == null ? null : ctx.tableSettings.query)("selected", ctx.selectedItems)("reloadEvent", ctx.reloadEvent)("actions", ctx.actions);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.settings == null ? null : ctx.settings.selectable);
        }
    }, dependencies: [i4$1.NgIf, i6.MatButton, i1.MatDialogClose, i1.MatDialogTitle, i1.MatDialogContent, i1.MatDialogActions, i9.MatIcon, i11.MatToolbar, i8.DefaultFlexDirective, i4$2.GenericViewTableComponent, i3$1.TranslatePipe] });
(function () {
    (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SelectDocumentsDialogComponent, [{
            type: Component,
            args: [{ selector: 'fts-select-documents-dialog', template: "<mat-toolbar color=\"primary\">\n  <div class=\"ft-module-icon\">\n    <mat-icon fontSet=\"mdi\" fontIcon=\"{{settings['headerIcon']}}\"></mat-icon>\n  </div>\n\n  <h2 mat-dialog-title>{{ settings['headerLabel'] | translate }}</h2>\n  <span fxFlex></span>\n\n  <button type=\"button\" mat-icon-button mat-dialog-close tabindex=\"-1\">\n    <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-close\"></mat-icon>\n  </button>\n</mat-toolbar>\n<div mat-dialog-content class=\"ft-content\"  >\n\n  <ft-generic-view-table  fxFlex [namespace]=\"tableSettings?.viewNamespace\"\n                         [viewSettings]=\"tableSettings?.viewSettings\"\n                         [hasPagination]=\"tableSettings?.hasPagination\"\n                         [selectable]=\"tableSettings?.selectable\"\n                         [query]=\"tableSettings?.query\"\n                         (selectionChange)=\"handleSelectionChange($event)\"\n                         (lineClick)=\"tableSettings?.rowClick($event)\"\n                          [(selected)]=\"selectedItems\"\n                         [reloadEvent]=\"reloadEvent\"\n                           [actions]=\"actions\" \n\n>\n</ft-generic-view-table>\n</div>\n<div *ngIf=\"settings?.selectable\" mat-dialog-actions>\n  <span fxFlex></span>\n  <button type=\"button\" color=\"primary\" mat-raised-button tabindex=\"2\" (click)=\"add()\" >\n    {{'shared.submit_add'|translate}}\n  </button>\n  <button type=\"button\" [mat-dialog-close]=\"null\"  color=\"warn\" mat-raised-button tabindex=\"-1\">{{'shared.reset'|translate}}</button>\n</div>\n" }]
        }], function () {
        return [{ type: i1.MatDialogRef }, { type: i1.MatDialog }, { type: undefined, decorators: [{
                        type: Inject,
                        args: [MAT_DIALOG_DATA]
                    }] }];
    }, null);
})();

function DocumentSelectComponent_input_1_Template(rf, ctx) {
    if (rf & 1) {
        const _r5 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "input", 7);
        i0.ɵɵlistener("ngModelChange", function DocumentSelectComponent_input_1_Template_input_ngModelChange_0_listener($event) { i0.ɵɵrestoreView(_r5); const ctx_r4 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r4.currentModel = $event); })("click", function DocumentSelectComponent_input_1_Template_input_click_0_listener() { i0.ɵɵrestoreView(_r5); const ctx_r6 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r6.showDialog()); })("change", function DocumentSelectComponent_input_1_Template_input_change_0_listener() { i0.ɵɵrestoreView(_r5); const ctx_r7 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r7.handleChange()); });
        i0.ɵɵpipe(1, "translate");
        i0.ɵɵelementEnd();
    }
    if (rf & 2) {
        const ctx_r0 = i0.ɵɵnextContext();
        i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(1, 5, ctx_r0.label))("ngModel", ctx_r0.currentModel)("readonly", true)("required", ctx_r0.is_required)("disabled", ctx_r0.is_disabled);
    }
}
function DocumentSelectComponent_mat_chip_list_2_mat_chip_2_Template(rf, ctx) {
    if (rf & 1) {
        const _r12 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "mat-chip", 12);
        i0.ɵɵlistener("removed", function DocumentSelectComponent_mat_chip_list_2_mat_chip_2_Template_mat_chip_removed_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r12); const m_r10 = restoredCtx.$implicit; const ctx_r11 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r11.removeModelsItem(m_r10)); });
        i0.ɵɵtext(1);
        i0.ɵɵelement(2, "mat-icon", 13);
        i0.ɵɵelementEnd();
    }
    if (rf & 2) {
        const m_r10 = ctx.$implicit;
        const ctx_r9 = i0.ɵɵnextContext(2);
        i0.ɵɵproperty("selectable", false)("removable", !ctx_r9.is_disabled);
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", m_r10[ctx_r9.value], " ");
    }
}
function DocumentSelectComponent_mat_chip_list_2_Template(rf, ctx) {
    if (rf & 1) {
        i0.ɵɵelementStart(0, "mat-chip-list", 8, 9);
        i0.ɵɵtemplate(2, DocumentSelectComponent_mat_chip_list_2_mat_chip_2_Template, 3, 3, "mat-chip", 10);
        i0.ɵɵelement(3, "input", 11);
        i0.ɵɵpipe(4, "translate");
        i0.ɵɵelementEnd();
    }
    if (rf & 2) {
        const _r8 = i0.ɵɵreference(1);
        const ctx_r1 = i0.ɵɵnextContext();
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngForOf", ctx_r1.currentModels);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(4, 6, ctx_r1.label))("matChipInputFor", _r8)("readonly", true)("matChipInputSeparatorKeyCodes", ctx_r1.separatorKeysCodes)("matChipInputAddOnBlur", true);
    }
}
const _c0$u = function (a0) { return { "hidden": a0 }; };
function DocumentSelectComponent_button_3_Template(rf, ctx) {
    if (rf & 1) {
        const _r14 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "button", 14);
        i0.ɵɵlistener("click", function DocumentSelectComponent_button_3_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r14); const ctx_r13 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r13.showDialog(true)); });
        i0.ɵɵelement(1, "mat-icon", 15);
        i0.ɵɵelementEnd();
    }
    if (rf & 2) {
        const ctx_r2 = i0.ɵɵnextContext();
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(1, _c0$u, ctx_r2.is_disabled));
    }
}
function DocumentSelectComponent_button_6_Template(rf, ctx) {
    if (rf & 1) {
        const _r16 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "button", 16);
        i0.ɵɵlistener("click", function DocumentSelectComponent_button_6_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r16); const ctx_r15 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r15.reset()); });
        i0.ɵɵelement(1, "mat-icon", 17);
        i0.ɵɵelementEnd();
    }
    if (rf & 2) {
        const ctx_r3 = i0.ɵɵnextContext();
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(1, _c0$u, ctx_r3.is_disabled));
    }
}
class DocumentSelectComponent {
    constructor(dialog) {
        this.dialog = dialog;
        this.currentModel = null;
        this.currentModels = [];
        this._model = null;
        this.is_disabled = false;
        this.separatorKeysCodes = [ENTER, ESCAPE];
        this.is_required = false;
        this.multiple = false;
        this.modelChange = new EventEmitter();
    }
    set model(value) {
        this._model = value;
        if (this.multiple) {
            this.currentModels = value || [];
        }
        else {
            this.currentModel = _.get(this._model, this.value);
        }
    }
    set handleDisabled(value) {
        this.is_disabled = value;
    }
    ngOnInit() {
    }
    handleChange() {
        this.modelChange.emit(this._model);
    }
    showDialog(is_new = false) {
        if (is_new) {
            this.dialog.open(this.addDialog, _.assign(MEDIUM_DIALOG, {
                data: {},
                disableClose: true
            })).afterClosed().subscribe(res => {
                if (res) {
                    if (this.multiple) {
                        this._model.push(res);
                        this.currentModels.push(res);
                    }
                    else {
                        this._model = res;
                        this.currentModel = _.get(this._model, this.value);
                    }
                    this.modelChange.emit(_.cloneDeep(this._model));
                }
            });
        }
        else {
            this.dialog.open(SelectDocumentsDialogComponent, _.assign(LARGE_DIALOG, {
                data: _.assignIn(this.settings, { selectable: this.multiple }),
                disableClose: true
            })).afterClosed().subscribe(res => {
                if (res) {
                    if (isArray(res)) {
                        this.currentModels = uniqBy(concat(this.currentModels, res), this.value);
                        this._model = this.currentModels;
                    }
                    else {
                        this._model = res;
                        this.currentModel = _.get(this._model, this.value);
                    }
                    this.modelChange.emit(_.cloneDeep(this._model));
                }
            });
        }
    }
    reset() {
        this._model = null;
        if (this.multiple) {
            this.currentModels = [];
            this.modelChange.emit([]);
        }
        else {
            this.currentModel = null;
            this.modelChange.emit(null);
        }
    }
    removeModelsItem(m) {
        const index = this.currentModels.indexOf(m);
        if (index >= 0) {
            this.currentModels.splice(index, 1);
            this._model = this.currentModels;
            this.modelChange.emit(_.cloneDeep(this._model));
        }
    }
}
DocumentSelectComponent.ɵfac = function DocumentSelectComponent_Factory(t) { return new (t || DocumentSelectComponent)(i0.ɵɵdirectiveInject(i1.MatDialog)); };
DocumentSelectComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DocumentSelectComponent, selectors: [["fts-document-select"]], inputs: { label: "label", settings: "settings", is_required: ["required", "is_required"], addDialog: ["dialog", "addDialog"], multiple: "multiple", value: "value", model: "model", handleDisabled: ["disabled", "handleDisabled"] }, outputs: { modelChange: "modelChange" }, decls: 7, vars: 7, consts: [["fxFlex", ""], ["readonly", "", "matInput", "", 3, "placeholder", "ngModel", "readonly", "required", "disabled", "ngModelChange", "click", "change", 4, "ngIf"], ["aria-label", " selection", 4, "ngIf"], ["matSuffix", "", "mat-icon-button", "", "type", "button", "color", "accent", 3, "ngClass", "click", 4, "ngIf"], ["matSuffix", "", "mat-icon-button", "", "type", "button", "color", "primary", 3, "ngClass", "click"], ["fontSet", "mdi", "fontIcon", "mdi-magnify"], ["matSuffix", "", "mat-icon-button", "", "type", "button", "color", "warn", 3, "ngClass", "click", 4, "ngIf"], ["readonly", "", "matInput", "", 3, "placeholder", "ngModel", "readonly", "required", "disabled", "ngModelChange", "click", "change"], ["aria-label", " selection"], ["chipList", ""], [3, "selectable", "removable", "removed", 4, "ngFor", "ngForOf"], [3, "placeholder", "matChipInputFor", "readonly", "matChipInputSeparatorKeyCodes", "matChipInputAddOnBlur"], [3, "selectable", "removable", "removed"], ["matChipRemove", "", "fontSet", "mdi", "fontIcon", "mdi-close"], ["matSuffix", "", "mat-icon-button", "", "type", "button", "color", "accent", 3, "ngClass", "click"], ["fontSet", "mdi", "fontIcon", "mdi-plus"], ["matSuffix", "", "mat-icon-button", "", "type", "button", "color", "warn", 3, "ngClass", "click"], ["fontSet", "mdi", "fontIcon", "mdi-close"]], template: function DocumentSelectComponent_Template(rf, ctx) {
        if (rf & 1) {
            i0.ɵɵelementStart(0, "mat-form-field", 0);
            i0.ɵɵtemplate(1, DocumentSelectComponent_input_1_Template, 2, 7, "input", 1);
            i0.ɵɵtemplate(2, DocumentSelectComponent_mat_chip_list_2_Template, 5, 8, "mat-chip-list", 2);
            i0.ɵɵtemplate(3, DocumentSelectComponent_button_3_Template, 2, 3, "button", 3);
            i0.ɵɵelementStart(4, "button", 4);
            i0.ɵɵlistener("click", function DocumentSelectComponent_Template_button_click_4_listener() { return ctx.showDialog(); });
            i0.ɵɵelement(5, "mat-icon", 5);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(6, DocumentSelectComponent_button_6_Template, 2, 3, "button", 6);
            i0.ɵɵelementEnd();
        }
        if (rf & 2) {
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", !ctx.multiple);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.multiple);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.addDialog);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(5, _c0$u, ctx.is_disabled));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.currentModel || (ctx.currentModels == null ? null : ctx.currentModels.length) > 0);
        }
    }, dependencies: [i4$1.NgClass, i4$1.NgForOf, i4$1.NgIf, i6.MatButton, i4$3.MatChipList, i4$3.MatChip, i4$3.MatChipInput, i4$3.MatChipRemove, i9.MatIcon, i10.MatFormField, i10.MatSuffix, i11$1.MatInput, i8.DefaultFlexDirective, i9$1.DefaultClassDirective, i16.DefaultValueAccessor, i16.NgControlStatus, i16.RequiredValidator, i16.NgModel, i2.InputDirective, i3$1.TranslatePipe], styles: [".hidden[_ngcontent-%COMP%]{display:none}"] });
(function () {
    (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DocumentSelectComponent, [{
            type: Component,
            args: [{ selector: 'fts-document-select', template: "<mat-form-field fxFlex>\n  <input *ngIf=\"!multiple\" readonly matInput [placeholder]=\"label|translate\" [(ngModel)]=\"currentModel\"\n        (click)=\"showDialog()\" [readonly]=\"true\" (change)=\"handleChange()\"\n        [required]=\"is_required\" [disabled]=\"is_disabled\"/>\n\n  <mat-chip-list *ngIf=\"multiple\"  #chipList aria-label=\" selection\">\n    <mat-chip *ngFor=\"let m of currentModels\" [selectable]=\"false\"\n             [removable]=\"!is_disabled\" (removed)=\"removeModelsItem(m)\">\n      {{m[value]}}\n      <mat-icon matChipRemove  fontSet=\"mdi\" fontIcon=\"mdi-close\"  > </mat-icon>\n    </mat-chip>\n    <input [placeholder]=\"label|translate\"\n           [matChipInputFor]=\"chipList\" [readonly]=\"true\"\n           [matChipInputSeparatorKeyCodes]=\"separatorKeysCodes\"\n           [matChipInputAddOnBlur]=\"true\">\n  </mat-chip-list>\n\n\n\n  <button *ngIf=\"addDialog\" matSuffix mat-icon-button (click)=\"showDialog(true)\" [ngClass]=\"{'hidden':is_disabled}\" type=\"button\" color=\"accent\">\n    <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-plus\"></mat-icon>\n  </button>\n  <button matSuffix mat-icon-button (click)=\"showDialog()\"  [ngClass]=\"{'hidden':is_disabled}\" type=\"button\" color=\"primary\">\n    <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-magnify\"></mat-icon>\n  </button>\n\n  <button *ngIf=\"currentModel || currentModels?.length>0\" matSuffix mat-icon-button (click)=\"reset()\" [ngClass]=\"{'hidden':is_disabled}\"  type=\"button\"  color=\"warn\">\n    <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-close\"></mat-icon>\n  </button>\n</mat-form-field>\n\n", styles: [".hidden{display:none}\n"] }]
        }], function () { return [{ type: i1.MatDialog }]; }, { label: [{
                type: Input
            }], settings: [{
                type: Input
            }], is_required: [{
                type: Input,
                args: ['required']
            }], addDialog: [{
                type: Input,
                args: ['dialog']
            }], multiple: [{
                type: Input
            }], value: [{
                type: Input
            }], model: [{
                type: Input
            }], modelChange: [{
                type: Output
            }], handleDisabled: [{
                type: Input,
                args: ['disabled']
            }] });
})();

function ListSelectComponent_mat_option_3_Template(rf, ctx) {
    if (rf & 1) {
        i0.ɵɵelementStart(0, "mat-option", 6);
        i0.ɵɵtext(1);
        i0.ɵɵelementEnd();
    }
    if (rf & 2) {
        const e_r2 = ctx.$implicit;
        const ctx_r0 = i0.ɵɵnextContext();
        i0.ɵɵproperty("value", e_r2);
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate(e_r2[ctx_r0.config["key"]]);
    }
}
const _c0$t = function (a0) { return { "hidden": a0 }; };
function ListSelectComponent_button_4_Template(rf, ctx) {
    if (rf & 1) {
        const _r4 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "button", 7);
        i0.ɵɵlistener("click", function ListSelectComponent_button_4_Template_button_click_0_listener($event) { i0.ɵɵrestoreView(_r4); const ctx_r3 = i0.ɵɵnextContext(); $event.stopImmediatePropagation(); return i0.ɵɵresetView(ctx_r3.addObj()); });
        i0.ɵɵelement(1, "mat-icon", 8);
        i0.ɵɵelementEnd();
    }
    if (rf & 2) {
        const ctx_r1 = i0.ɵɵnextContext();
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(1, _c0$t, ctx_r1.is_disabled));
    }
}
const _c1$l = function () { return { standalone: true }; };
class ListSelectComponent {
    constructor(sharedService, dialog, defaultValuesService) {
        this.sharedService = sharedService;
        this.dialog = dialog;
        this.defaultValuesService = defaultValuesService;
        this.currentModel = null;
        this.label = '';
        this.config = '';
        this.is_required = false;
        this.defaultValues = '';
        this.updateOnChange = false;
        this.is_disabled = false;
        this.modelChange = new EventEmitter();
        this.data = [];
    }
    set handleReload(value) {
        if (value) {
            if (this.config['cls']) {
                this.sharedService.getDocuments(`${this.config['cls']}`).subscribe(res => this.data = res);
            }
        }
    }
    set handleReloadEvent(value) {
        if (value) {
            value.subscribe(data => {
                if (value) {
                    if (this.config['cls']) {
                        this.sharedService.getDocuments(`${this.config['cls']}`).subscribe(res => this.data = res);
                    }
                }
            });
        }
    }
    set handleDisabled(value) {
        this.is_disabled = value;
    }
    set handleModel(value) {
        this.currentModel = value;
    }
    ngOnInit() {
        if (this.config['cls']) {
            this.sharedService.getDocuments(`${this.config['cls']}`).subscribe(res => {
                this.data = res;
                if (!this.currentModel) {
                    this.currentModel = this.defaultValuesService.getValue(this.defaultValues);
                    this.modelChange.emit(this.currentModel);
                }
            });
        }
    }
    compareObj(o1, o2) {
        return o1 && o2 ? o1.id === o2.id : o1 == o2;
    }
    changeModel() {
        this.modelChange.emit(this.currentModel);
    }
    addObj() {
        this.dialog.open(this.listDialog, _.assign(MEDIUM_DIALOG, {
            data: {
                listDefinition: {
                    url: this.config['url'],
                    isNumber: this.config['isNumber'],
                    customValidator: this.config['customValidator']
                }
            },
            disableClose: true
        })).afterClosed().subscribe(res => {
            if (res) {
                this.data.push(res);
                this.currentModel = res;
                this.modelChange.emit(this.currentModel);
            }
        });
    }
}
ListSelectComponent.ɵfac = function ListSelectComponent_Factory(t) { return new (t || ListSelectComponent)(i0.ɵɵdirectiveInject(SharedService), i0.ɵɵdirectiveInject(i1.MatDialog), i0.ɵɵdirectiveInject(i2.DefaultValuesService)); };
ListSelectComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ListSelectComponent, selectors: [["fts-list-select"]], inputs: { label: "label", config: "config", is_required: ["required", "is_required"], defaultValues: "defaultValues", updateOnChange: "updateOnChange", listDialog: "listDialog", handleReload: ["reload", "handleReload"], handleReloadEvent: ["reloadEvent", "handleReloadEvent"], handleDisabled: ["disabled", "handleDisabled"], handleModel: ["model", "handleModel"] }, outputs: { modelChange: "modelChange" }, decls: 7, vars: 16, consts: [["fxFlex", ""], [3, "placeholder", "ngModel", "required", "disabled", "ngModelOptions", "compareWith", "ftDefaultValues", "updateOnChange", "ngModelChange", "selectionChange"], [3, "value", 4, "ngFor", "ngForOf"], ["matSuffix", "", "mat-icon-button", "", "type", "button", "matTooltip", "ajouter", "type", "button", "color", "primary", 3, "ngClass", "click", 4, "ngIf"], ["matSuffix", "", "mat-icon-button", "", "type", "button", "color", "warn", "matTooltip", "clean", "type", "button", "color", "warn", 3, "ngClass", "click"], ["fontSet", "mdi", "fontIcon", "mdi-close"], [3, "value"], ["matSuffix", "", "mat-icon-button", "", "type", "button", "matTooltip", "ajouter", "type", "button", "color", "primary", 3, "ngClass", "click"], ["fontSet", "mdi", "fontIcon", "mdi-plus"]], template: function ListSelectComponent_Template(rf, ctx) {
        if (rf & 1) {
            i0.ɵɵelementStart(0, "mat-form-field", 0)(1, "mat-select", 1);
            i0.ɵɵlistener("ngModelChange", function ListSelectComponent_Template_mat_select_ngModelChange_1_listener($event) { return ctx.currentModel = $event; })("selectionChange", function ListSelectComponent_Template_mat_select_selectionChange_1_listener() { return ctx.changeModel(); });
            i0.ɵɵpipe(2, "translate");
            i0.ɵɵtemplate(3, ListSelectComponent_mat_option_3_Template, 2, 2, "mat-option", 2);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(4, ListSelectComponent_button_4_Template, 2, 3, "button", 3);
            i0.ɵɵelementStart(5, "button", 4);
            i0.ɵɵlistener("click", function ListSelectComponent_Template_button_click_5_listener($event) { $event.stopImmediatePropagation(); return ctx.currentModel = null; });
            i0.ɵɵelement(6, "mat-icon", 5);
            i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(2, 11, ctx.label))("ngModel", ctx.currentModel)("required", ctx.is_required)("disabled", ctx.is_disabled)("ngModelOptions", i0.ɵɵpureFunction0(13, _c1$l))("compareWith", ctx.compareObj)("ftDefaultValues", ctx.defaultValues)("updateOnChange", ctx.updateOnChange);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngForOf", ctx.data);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.listDialog);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(14, _c0$t, ctx.is_disabled));
        }
    }, dependencies: [i4$1.NgClass, i4$1.NgForOf, i4$1.NgIf, i5.MatOption, i6.MatButton, i9.MatIcon, i10.MatFormField, i10.MatSuffix, i15.MatSelect, i15$1.MatTooltip, i8.DefaultFlexDirective, i9$1.DefaultClassDirective, i16.NgControlStatus, i16.RequiredValidator, i16.NgModel, i2.DefaultValuesDirective, i3$1.TranslatePipe], styles: [".hidden[_ngcontent-%COMP%]{display:none}"] });
(function () {
    (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ListSelectComponent, [{
            type: Component,
            args: [{ selector: 'fts-list-select', template: "<mat-form-field fxFlex>\n  <mat-select [placeholder]=\"label|translate\"   [(ngModel)]=\"currentModel\" [required]=\"is_required\" [disabled]=\"is_disabled\"\n              [ngModelOptions]=\"{standalone:true}\"  (selectionChange)=\"changeModel()\" [compareWith]=\"compareObj\"\n                    [ftDefaultValues]=\"defaultValues\"  [updateOnChange]=\"updateOnChange\">\n    <mat-option *ngFor=\"let e of data\" [value]=\"e\">{{e[config['key']]}}</mat-option>\n  </mat-select>\n  <button *ngIf=\"listDialog\" matSuffix mat-icon-button  type=\"button\" matTooltip=\"ajouter\"   [ngClass]=\"{'hidden':is_disabled}\" type=\"button\"  color=\"primary\"\n          (click)=\"$event.stopImmediatePropagation();addObj();\">\n    <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-plus\"></mat-icon>\n  </button>\n  <button matSuffix mat-icon-button type=\"button\" color=\"warn\" matTooltip=\"clean\"   [ngClass]=\"{'hidden':is_disabled}\" type=\"button\"  color=\"warn\"\n          (click)=\"$event.stopImmediatePropagation(); currentModel=null;\">\n    <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-close\"></mat-icon>\n  </button>\n</mat-form-field>\n", styles: [".hidden{display:none}\n"] }]
        }], function () { return [{ type: SharedService }, { type: i1.MatDialog }, { type: i2.DefaultValuesService }]; }, { label: [{
                type: Input
            }], config: [{
                type: Input
            }], is_required: [{
                type: Input,
                args: ['required']
            }], defaultValues: [{
                type: Input
            }], updateOnChange: [{
                type: Input
            }], listDialog: [{
                type: Input
            }], handleReload: [{
                type: Input,
                args: ['reload']
            }], handleReloadEvent: [{
                type: Input,
                args: ['reloadEvent']
            }], handleDisabled: [{
                type: Input,
                args: ['disabled']
            }], handleModel: [{
                type: Input,
                args: ['model']
            }], modelChange: [{
                type: Output
            }] });
})();

class ArticleComponentsComponent {
    constructor(translateService, dialog) {
        this.translateService = translateService;
        this.dialog = dialog;
        this.componentsMultiActions = [
            {
                class: 'mat-primary',
                icon: 'mdi-plus',
                isMultipleSelection: false,
                method: (item, ev) => {
                    return this.addComponent();
                },
                tooltip: this.translateService.instant('shared.add')
            }
        ];
        this.componentsLinesColumns = new BehaviorSubject([
            {
                'label': 'store.code',
                'key': 'code',
                'type': 'text',
                'is_global_searchable': true
            },
            {
                'label': 'store.description',
                'key': 'description',
                'type': 'text',
                'is_global_searchable': true,
                'editable': true
            },
            {
                'label': 'store.qte',
                'key': 'qte',
                'type': 'number',
                'is_global_searchable': true,
                'editable': true,
                numberConfig: 'float'
            },
            {
                'label': 'store.price',
                'key': 'price',
                'type': 'number',
                'is_global_searchable': true,
                'editable': true,
                numberConfig: 'float'
            },
            {
                label: '', key: 'actions', type: 'actions', actions: [
                    {
                        class: 'mat-warn',
                        icon: 'mdi-close-circle',
                        method: (item, index, ev) => {
                            return this.removeComponent(item, index);
                        },
                        tooltip: this.translateService.instant('shared.delete')
                    }
                ]
            }
        ]);
        this.componentsLinesSource$ = of([]);
        this.components = [];
        this.pk = null;
        this.modelChange = new EventEmitter();
    }
    set modeId(value) {
        this.pk = value;
    }
    set currentModel(value) {
        if (value) {
            this.components = value;
            this.componentsLinesSource$ = of(value);
        }
    }
    ngOnInit() {
    }
    addComponent() {
        this.dialog.open(SelectDocumentsDialogComponent, _.assign(LARGE_DIALOG, {
            data: _.assignIn(_.cloneDeep(ARTICLE_VIEW), {
                name: "store-article",
                query: this.pk ? [{
                        key: '_id',
                        logical_operator: 'and',
                        operator: '$ne',
                        value: this.pk
                    }] : []
            }),
            disableClose: true,
        })).afterClosed().subscribe(res => {
            if (!isEmpty(res)) {
                this.components = chain(res)
                    .map(item => {
                    return {
                        qte: 1,
                        price: get(item, 'pmp', 0),
                        article: { id: get(item, 'id') },
                        code: get(item, 'code'),
                        description: get(item, 'description')
                    };
                })
                    .concat(this.components)
                    .uniqBy('article.id')
                    .value();
            }
            this.componentsLinesSource$ = of(this.components);
            this.modelChange.emit(this.components);
        });
    }
    removeComponent(item, index) {
        this.components.splice(index, 1);
        this.componentsLinesSource$ = of(this.components);
        this.modelChange.emit(this.components);
    }
}
ArticleComponentsComponent.ɵfac = function ArticleComponentsComponent_Factory(t) { return new (t || ArticleComponentsComponent)(i0.ɵɵdirectiveInject(i3$1.TranslateService), i0.ɵɵdirectiveInject(i1.MatDialog)); };
ArticleComponentsComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ArticleComponentsComponent, selectors: [["fts-article-components"]], inputs: { modeId: ["pk", "modeId"], currentModel: ["model", "currentModel"] }, outputs: { modelChange: "modelChange" }, decls: 2, vars: 7, consts: [["fxFlex", "", 3, "remote", "source", "selectable", "columns", "multiActions"]], template: function ArticleComponentsComponent_Template(rf, ctx) {
        if (rf & 1) {
            i0.ɵɵelement(0, "ft-generic-body-table", 0);
            i0.ɵɵpipe(1, "async");
        }
        if (rf & 2) {
            i0.ɵɵproperty("remote", false)("source", ctx.componentsLinesSource$)("selectable", false)("columns", i0.ɵɵpipeBind1(1, 5, ctx.componentsLinesColumns))("multiActions", ctx.componentsMultiActions);
        }
    }, dependencies: [i8.DefaultFlexDirective, i4$2.GenericBodyTableComponent, i4$1.AsyncPipe] });
(function () {
    (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ArticleComponentsComponent, [{
            type: Component,
            args: [{ selector: 'fts-article-components', template: "<ft-generic-body-table fxFlex\n                       [remote]=\"false\"\n                       [source]=\"componentsLinesSource$\"\n                       [selectable]=\"false\"\n                       [columns]=\"componentsLinesColumns | async\"\n                       [multiActions]=\"componentsMultiActions\"\n>\n</ft-generic-body-table>\n" }]
        }], function () { return [{ type: i3$1.TranslateService }, { type: i1.MatDialog }]; }, { modeId: [{
                type: Input,
                args: ['pk']
            }], currentModel: [{
                type: Input,
                args: ['model']
            }], modelChange: [{
                type: Output
            }] });
})();

class ArticleSubstitutionsComponent {
    constructor(translateService, dialog) {
        this.translateService = translateService;
        this.dialog = dialog;
        this.substitutionsLinesActions = [
            {
                class: 'mat-primary',
                icon: 'mdi-plus',
                isMultipleSelection: false,
                method: (item, ev) => {
                    return this.addSubstitution();
                },
                tooltip: this.translateService.instant('shared.add')
            }
        ];
        this.substitutionsLinesColumns = new BehaviorSubject([
            {
                'label': 'store.code',
                'key': 'code',
                'type': 'text',
                'is_global_searchable': true
            },
            {
                'label': 'store.description',
                'key': 'description',
                'type': 'text',
                'is_global_searchable': true
            },
            {
                label: '', key: 'actions', type: 'actions', actions: [
                    {
                        class: 'mat-warn',
                        icon: 'mdi-close-circle',
                        method: (item, index, ev) => {
                            return this.removeSubstitution(item, index);
                        },
                        tooltip: this.translateService.instant('shared.delete')
                    }
                ]
            }
        ]);
        this.substitutionsLinesSource$ = of([]);
        this.pk = null;
        this.substitutions = [];
        this.modelChange = new EventEmitter();
    }
    set modeId(value) {
        this.pk = value;
    }
    set currentModel(value) {
        if (value) {
            this.substitutions = value;
            this.substitutionsLinesSource$ = of(value);
        }
    }
    ngOnInit() {
    }
    addSubstitution() {
        this.dialog.open(SelectDocumentsDialogComponent, _.assign(LARGE_DIALOG, {
            data: _.assignIn(_.cloneDeep(ARTICLE_VIEW), {
                name: "store-article",
                query: this.pk ? [{
                        key: '_id',
                        logical_operator: 'and',
                        operator: '$ne',
                        value: this.pk
                    }] : []
            }),
            disableClose: true,
        })).afterClosed().subscribe(res => {
            if (!isEmpty(res)) {
                this.substitutions = chain(res)
                    .concat(this.substitutions)
                    .uniqBy('id')
                    .value();
            }
            this.substitutionsLinesSource$ = of(this.substitutions);
            this.modelChange.emit(this.substitutions);
        });
    }
    removeSubstitution(item, index) {
        this.substitutions.splice(index, 1);
        this.substitutionsLinesSource$ = of(this.substitutions);
        this.modelChange.emit(this.substitutions);
    }
}
ArticleSubstitutionsComponent.ɵfac = function ArticleSubstitutionsComponent_Factory(t) { return new (t || ArticleSubstitutionsComponent)(i0.ɵɵdirectiveInject(i3$1.TranslateService), i0.ɵɵdirectiveInject(i1.MatDialog)); };
ArticleSubstitutionsComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ArticleSubstitutionsComponent, selectors: [["fts-article-substitutions"]], inputs: { modeId: ["pk", "modeId"], currentModel: ["model", "currentModel"] }, outputs: { modelChange: "modelChange" }, decls: 2, vars: 7, consts: [["fxFlex", "", 3, "remote", "multiActions", "columns", "source", "selectable"]], template: function ArticleSubstitutionsComponent_Template(rf, ctx) {
        if (rf & 1) {
            i0.ɵɵelement(0, "ft-generic-body-table", 0);
            i0.ɵɵpipe(1, "async");
        }
        if (rf & 2) {
            i0.ɵɵproperty("remote", false)("multiActions", ctx.substitutionsLinesActions)("columns", i0.ɵɵpipeBind1(1, 5, ctx.substitutionsLinesColumns))("source", ctx.substitutionsLinesSource$)("selectable", false);
        }
    }, dependencies: [i8.DefaultFlexDirective, i4$2.GenericBodyTableComponent, i4$1.AsyncPipe] });
(function () {
    (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ArticleSubstitutionsComponent, [{
            type: Component,
            args: [{ selector: 'fts-article-substitutions', template: "<ft-generic-body-table fxFlex\n                       [remote]=\"false\"\n                       [multiActions]=\"substitutionsLinesActions\"\n                       [columns]=\"substitutionsLinesColumns | async\"\n                       [source]=\"substitutionsLinesSource$\"\n                       [selectable]=\"false\"\n>\n</ft-generic-body-table>\n" }]
        }], function () { return [{ type: i3$1.TranslateService }, { type: i1.MatDialog }]; }, { modeId: [{
                type: Input,
                args: ['pk']
            }], currentModel: [{
                type: Input,
                args: ['model']
            }], modelChange: [{
                type: Output
            }] });
})();

function ArticleFormComponent_span_8_Template(rf, ctx) {
    if (rf & 1) {
        i0.ɵɵelementStart(0, "span");
        i0.ɵɵtext(1);
        i0.ɵɵelementEnd();
    }
    if (rf & 2) {
        const ctx_r0 = i0.ɵɵnextContext();
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(": ", ctx_r0.model == null ? null : ctx_r0.model.code, "");
    }
}
function ArticleFormComponent_mat_error_24_Template(rf, ctx) {
    if (rf & 1) {
        i0.ɵɵelementStart(0, "mat-error");
        i0.ɵɵtext(1);
        i0.ɵɵpipe(2, "translate");
        i0.ɵɵelementEnd();
    }
    if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "store.code_already_exist"), "");
    }
}
function ArticleFormComponent_mat_radio_button_70_Template(rf, ctx) {
    if (rf & 1) {
        i0.ɵɵelementStart(0, "mat-radio-button", 51);
        i0.ɵɵtext(1);
        i0.ɵɵpipe(2, "translate");
        i0.ɵɵelementEnd();
    }
    if (rf & 2) {
        const element_r7 = ctx.$implicit;
        i0.ɵɵproperty("value", element_r7);
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 2, "store." + element_r7), " ");
    }
}
function ArticleFormComponent_ft_file_manager_104_Template(rf, ctx) {
    if (rf & 1) {
        i0.ɵɵelement(0, "ft-file-manager", 52);
    }
    if (rf & 2) {
        const ctx_r5 = i0.ɵɵnextContext();
        i0.ɵɵproperty("root", "store-article")("rootId", ctx_r5.model.id);
    }
}
function ArticleFormComponent_button_106_Template(rf, ctx) {
    if (rf & 1) {
        const _r9 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "button", 48);
        i0.ɵɵlistener("click", function ArticleFormComponent_button_106_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r9); const ctx_r8 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r8.checkRemoveArticle()); });
        i0.ɵɵelement(1, "mat-icon", 53);
        i0.ɵɵelementEnd();
    }
}
const _c0$s = function (a0) { return { pk: a0, field: "code", pk_field: "id" }; };
const _c1$k = function () { return { key: "value", url: "api/list/unity/", cls: "list/unity", customValidator: "store-unity.check_uniqueness" }; };
const _c2$e = function () { return { key: "description", url: "api/list/vat/", cls: "list/vat", isNumber: true, customValidator: "store-vat.check_uniqueness" }; };
class ArticleFormComponent {
    constructor(snackBar, dialog, route, router, sharedService, sharedModulesService, purposeSerive, translateService) {
        this.snackBar = snackBar;
        this.dialog = dialog;
        this.route = route;
        this.router = router;
        this.sharedService = sharedService;
        this.sharedModulesService = sharedModulesService;
        this.purposeSerive = purposeSerive;
        this.translateService = translateService;
        this.model = {
            purchase_price: 0.0,
            purchase_price_max: 0.0,
            sale_price: 0.0,
            sale_price_min: 0.0,
            min_qte: 0.0,
            max_qte: 0.0,
            min_dep_qte: 0.0,
            max_dep_qte: 0.0,
            evaluation: 'FIFO'
        };
        this.blockSave = false;
        this.familyInputSettings = _.assignIn(_.cloneDeep(FAMILY_VIEW), { selectable: false });
        this.familyDialog = FamilyDialogComponent;
        this.providerInputSettings = _.assignIn(_.cloneDeep(PROVIDER_VIEW), { selectable: false });
        this.providerDialog = ProviderDialogComponent;
        this.unityDialog = ListFormDialogComponent;
        this.vatDialog = ListFormDialogComponent;
        this.reloadUnitiesEvent = new EventEmitter();
        this.reloadVatsEvent = new EventEmitter();
        this.evaluations = ['FIFO', 'LIFO', 'FEFO'];
        this.busy = null;
        this.apiUrl = 'store/article';
        this.urls = { list: '/store/article/article-list', form: '/store/article/article-form' };
        this.isDialog = false;
        this.readOnly = false;
    }
    ngOnInit() {
        this.route.params.subscribe(data => {
            let id = _.get(data, 'id');
            if (id) {
                this.sharedService.getDocument(this.apiUrl, id).subscribe(data => {
                    this.model = data;
                });
                this.sharedService.checkDelete("article.check_delete", id).subscribe(res => {
                    this.readOnly = !res;
                });
            }
        });
    }
    goBack() {
        this.router.navigate([handleRoute(this.sharedModulesService.pathName, this.urls["list"])]);
    }
    saveArticle(with_exit) {
        if (!this.blockSave) {
            this.blockSave = true;
            this.busy = this.sharedService.saveDocument('store/article', this.model).subscribe(item => {
                this.blockSave = false;
                this.model = item;
                if (with_exit) {
                    this.router.navigate([handleRoute(this.sharedModulesService.pathName, this.urls["list"])]);
                }
                else {
                    this.router.navigate([handleRoute(this.sharedModulesService.pathName, this.urls["form"]), this.model.id], { replaceUrl: true });
                }
                this.snackBar.open(this.translateService.instant('store.operation_completed'), null, {
                    duration: 2500,
                });
            });
        }
    }
    checkRemoveArticle() {
        this.sharedService.checkDelete('article.check_delete', this.model.id).subscribe(data => {
            if (data) {
                if (!this.blockSave) {
                    this.blockSave = true;
                    this.sharedService.deleteDocument(this.apiUrl, this.model.id).subscribe(() => {
                        this.blockSave = false;
                        this.router.navigate([handleRoute(this.sharedModulesService.pathName, this.urls["list"])]);
                    });
                }
            }
            else {
                this.snackBar.open(this.translateService.instant('shared.impossible_document_delete_check_dependencies'), null, {
                    duration: 2500,
                    verticalPosition: "top",
                    horizontalPosition: "right"
                });
            }
        });
    }
    handleReloadUnities(data) {
        if (data) {
            this.reloadUnitiesEvent.emit(true);
        }
    }
    handleReloadVats(data) {
        if (data) {
            this.reloadVatsEvent.emit(true);
        }
    }
}
ArticleFormComponent.ɵfac = function ArticleFormComponent_Factory(t) { return new (t || ArticleFormComponent)(i0.ɵɵdirectiveInject(i1$2.MatSnackBar), i0.ɵɵdirectiveInject(i1.MatDialog), i0.ɵɵdirectiveInject(i3.ActivatedRoute), i0.ɵɵdirectiveInject(i3.Router), i0.ɵɵdirectiveInject(SharedService), i0.ɵɵdirectiveInject(SharedModulesService), i0.ɵɵdirectiveInject(i2.GeneralPurposeService), i0.ɵɵdirectiveInject(i3$1.TranslateService)); };
ArticleFormComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ArticleFormComponent, selectors: [["fts-article-form"]], decls: 120, vars: 164, consts: [["color", "accent"], [1, "ft-module-icon"], ["type", "button", "mat-icon-button", ""], ["fontSet", "mdi", "fontIcon", "mdi-format-list-bulleted"], [4, "ngIf"], ["fxFlex", ""], ["type", "button", "mat-button", "", 1, "with-icon", 3, "matTooltip", "click"], ["fxLayout", "column", 3, "label"], [3, "ngBusy"], ["fxFill", "", "fxLayout", "column", "name", "article", 1, "ft-content", "ft-padding"], ["articleForm", "ngForm"], ["fxLayout", "row", "fxLayoutGap", "8px"], ["fxFlex", "25", 1, "with-error-label"], ["matInput", "", "name", "code", "required", "", "ftCustomValidation", "article.check_uniqueness", 3, "ftAutoFocus", "placeholder", "ngModel", "query", "readonly", "ngModelChange"], ["code", "ngModel"], ["matInput", "", "name", "description", "required", "", 3, "placeholder", "ngModel", "ngModelChange"], ["fxFlex", "", 3, "label", "model", "value", "settings", "dialog", "modelChange"], ["fxFlex", "", 3, "model", "listDialog", "reloadEvent", "config", "label", "modelChange"], ["fxFlex", "", 3, "model", "listDialog", "reloadEvent", "config", "label", "defaultValues", "modelChange"], ["matInput", "", "name", "purchase_price", 3, "placeholder", "ngModel", "ftNumber", "ngModelChange"], ["matInput", "", "name", "purchase_price_max", 3, "placeholder", "ftNumber", "ngModel", "ngModelChange"], ["matInput", "", "name", "sale_price", 3, "placeholder", "ftNumber", "ngModel", "ngModelChange"], ["matInput", "", "name", "sale_price_min", 3, "placeholder", "ftNumber", "ngModel", "ngModelChange"], ["matInput", "", "name", "min_qte", 3, "placeholder", "ftNumber", "ngModel", "ngModelChange"], ["matInput", "", "name", "max_qte", 3, "placeholder", "ftNumber", "ngModel", "ngModelChange"], ["matInput", "", "name", "min_dep_qte", 3, "placeholder", "ftNumber", "ngModel", "ngModelChange"], ["matInput", "", "name", "max_dep_qte", 3, "placeholder", "ftNumber", "ngModel", "ngModelChange"], [1, "ft-sep"], ["fxLayoutGap", "6px", "fxLayout", "column"], ["floatLabel", "always", 1, "ft-radio-field"], ["matInput", "", "placeholder", "", 2, "display", "none"], ["name", "evaluation", "color", "primary", "fxFlex", "", 3, "ngModel", "ngModelChange"], [3, "value", 4, "ngFor", "ngForOf"], ["fxLayoutGap", "6px", "fxFlex", "row"], ["name", "prohibited_for_sale", "color", "primary", 3, "ngModel", "ngModelChange"], [3, "innerHTML"], ["name", "prohibited_to_purchase", "color", "primary", 3, "ngModel", "ngModelChange"], ["name", "allows_negative_stock", "color", "primary", 3, "ngModel", "ngModelChange"], ["name", "has_serial", "color", "primary", 3, "ngModel", "disabled", "ngModelChange"], ["name", "has_lot_number", "color", "primary", 3, "ngModel", "disabled", "ngModelChange"], ["name", "lapsing", "color", "primary", 3, "ngModel", "ngModelChange"], [3, "label", "disabled"], ["fxFlex", "", "fxFill", "", "fxLayout", "column", 1, "ft-content"], [3, "model", "pk", "modelChange"], ["disabled", "", 3, "label", "disabled"], [3, "root", "rootId", 4, "ngIf"], [1, "ft-actions"], ["mat-raised-button", "", "color", "warn", 3, "click", 4, "ngIf"], ["mat-raised-button", "", "color", "warn", 3, "click"], ["mat-raised-button", "", "color", "primary", "routerLink", "/store/article/article-list", 3, "disabled", "click"], ["mat-raised-button", "", "color", "primary", 3, "disabled", "click"], [3, "value"], [3, "root", "rootId"], ["fontSet", "mdi", "fontIcon", "mdi-delete"]], template: function ArticleFormComponent_Template(rf, ctx) {
        if (rf & 1) {
            i0.ɵɵelementStart(0, "mat-toolbar", 0)(1, "div", 1)(2, "button", 2);
            i0.ɵɵelement(3, "mat-icon", 3);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(4, "h2")(5, "span");
            i0.ɵɵtext(6);
            i0.ɵɵpipe(7, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(8, ArticleFormComponent_span_8_Template, 2, 1, "span", 4);
            i0.ɵɵelementEnd();
            i0.ɵɵelement(9, "span", 5);
            i0.ɵɵelementStart(10, "button", 6);
            i0.ɵɵlistener("click", function ArticleFormComponent_Template_button_click_10_listener() { return ctx.goBack(); });
            i0.ɵɵpipe(11, "translate");
            i0.ɵɵelement(12, "mat-icon", 3);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(13, "mat-tab-group", 5)(14, "mat-tab", 7);
            i0.ɵɵpipe(15, "translate");
            i0.ɵɵelement(16, "div", 8);
            i0.ɵɵelementStart(17, "form", 9, 10)(19, "div", 11)(20, "mat-form-field", 12)(21, "input", 13, 14);
            i0.ɵɵlistener("ngModelChange", function ArticleFormComponent_Template_input_ngModelChange_21_listener($event) { return ctx.model.code = $event; });
            i0.ɵɵpipe(23, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(24, ArticleFormComponent_mat_error_24_Template, 3, 3, "mat-error", 4);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(25, "mat-form-field", 5)(26, "input", 15);
            i0.ɵɵlistener("ngModelChange", function ArticleFormComponent_Template_input_ngModelChange_26_listener($event) { return ctx.model.description = $event; });
            i0.ɵɵpipe(27, "translate");
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(28, "div", 11)(29, "fts-document-select", 16);
            i0.ɵɵlistener("modelChange", function ArticleFormComponent_Template_fts_document_select_modelChange_29_listener($event) { return ctx.model.family = $event; });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(30, "fts-document-select", 16);
            i0.ɵɵlistener("modelChange", function ArticleFormComponent_Template_fts_document_select_modelChange_30_listener($event) { return ctx.model.default_provider = $event; });
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(31, "div", 11)(32, "fts-list-select", 17);
            i0.ɵɵlistener("modelChange", function ArticleFormComponent_Template_fts_list_select_modelChange_32_listener($event) { return ctx.model.purchase_unity = $event; })("modelChange", function ArticleFormComponent_Template_fts_list_select_modelChange_32_listener($event) { return ctx.handleReloadUnities($event); });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(33, "fts-list-select", 18);
            i0.ɵɵlistener("modelChange", function ArticleFormComponent_Template_fts_list_select_modelChange_33_listener($event) { return ctx.model.purchase_vat = $event; })("modelChange", function ArticleFormComponent_Template_fts_list_select_modelChange_33_listener($event) { return ctx.handleReloadVats($event); });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(34, "mat-form-field", 5)(35, "input", 19);
            i0.ɵɵlistener("ngModelChange", function ArticleFormComponent_Template_input_ngModelChange_35_listener($event) { return ctx.model.purchase_price = $event; });
            i0.ɵɵpipe(36, "translate");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(37, "mat-form-field", 5)(38, "input", 20);
            i0.ɵɵlistener("ngModelChange", function ArticleFormComponent_Template_input_ngModelChange_38_listener($event) { return ctx.model.purchase_price_max = $event; });
            i0.ɵɵpipe(39, "translate");
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(40, "div", 11)(41, "fts-list-select", 17);
            i0.ɵɵlistener("modelChange", function ArticleFormComponent_Template_fts_list_select_modelChange_41_listener($event) { return ctx.model.sale_unity = $event; })("modelChange", function ArticleFormComponent_Template_fts_list_select_modelChange_41_listener($event) { return ctx.handleReloadUnities($event); });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(42, "fts-list-select", 18);
            i0.ɵɵlistener("modelChange", function ArticleFormComponent_Template_fts_list_select_modelChange_42_listener($event) { return ctx.model.sale_vat = $event; })("modelChange", function ArticleFormComponent_Template_fts_list_select_modelChange_42_listener($event) { return ctx.handleReloadVats($event); });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(43, "mat-form-field", 5)(44, "input", 21);
            i0.ɵɵlistener("ngModelChange", function ArticleFormComponent_Template_input_ngModelChange_44_listener($event) { return ctx.model.sale_price = $event; });
            i0.ɵɵpipe(45, "translate");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(46, "mat-form-field", 5)(47, "input", 22);
            i0.ɵɵlistener("ngModelChange", function ArticleFormComponent_Template_input_ngModelChange_47_listener($event) { return ctx.model.sale_price_min = $event; });
            i0.ɵɵpipe(48, "translate");
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(49, "div", 11)(50, "mat-form-field", 5)(51, "input", 23);
            i0.ɵɵlistener("ngModelChange", function ArticleFormComponent_Template_input_ngModelChange_51_listener($event) { return ctx.model.min_qte = $event; });
            i0.ɵɵpipe(52, "translate");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(53, "mat-form-field", 5)(54, "input", 24);
            i0.ɵɵlistener("ngModelChange", function ArticleFormComponent_Template_input_ngModelChange_54_listener($event) { return ctx.model.max_qte = $event; });
            i0.ɵɵpipe(55, "translate");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(56, "mat-form-field", 5)(57, "input", 25);
            i0.ɵɵlistener("ngModelChange", function ArticleFormComponent_Template_input_ngModelChange_57_listener($event) { return ctx.model.min_dep_qte = $event; });
            i0.ɵɵpipe(58, "translate");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(59, "mat-form-field", 5)(60, "input", 26);
            i0.ɵɵlistener("ngModelChange", function ArticleFormComponent_Template_input_ngModelChange_60_listener($event) { return ctx.model.max_dep_qte = $event; });
            i0.ɵɵpipe(61, "translate");
            i0.ɵɵelementEnd()()();
            i0.ɵɵelement(62, "hr", 27);
            i0.ɵɵelementStart(63, "div", 28)(64, "h4");
            i0.ɵɵtext(65);
            i0.ɵɵpipe(66, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(67, "mat-form-field", 29);
            i0.ɵɵelement(68, "input", 30);
            i0.ɵɵelementStart(69, "mat-radio-group", 31);
            i0.ɵɵlistener("ngModelChange", function ArticleFormComponent_Template_mat_radio_group_ngModelChange_69_listener($event) { return ctx.model.evaluation = $event; });
            i0.ɵɵtemplate(70, ArticleFormComponent_mat_radio_button_70_Template, 3, 4, "mat-radio-button", 32);
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(71, "div", 28)(72, "h4");
            i0.ɵɵtext(73);
            i0.ɵɵpipe(74, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(75, "div", 33)(76, "mat-slide-toggle", 34);
            i0.ɵɵlistener("ngModelChange", function ArticleFormComponent_Template_mat_slide_toggle_ngModelChange_76_listener($event) { return ctx.model.prohibited_for_sale = $event; });
            i0.ɵɵelement(77, "span", 35);
            i0.ɵɵpipe(78, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(79, "mat-slide-toggle", 36);
            i0.ɵɵlistener("ngModelChange", function ArticleFormComponent_Template_mat_slide_toggle_ngModelChange_79_listener($event) { return ctx.model.prohibited_to_purchase = $event; });
            i0.ɵɵelement(80, "span", 35);
            i0.ɵɵpipe(81, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(82, "mat-slide-toggle", 37);
            i0.ɵɵlistener("ngModelChange", function ArticleFormComponent_Template_mat_slide_toggle_ngModelChange_82_listener($event) { return ctx.model.allows_negative_stock = $event; });
            i0.ɵɵelement(83, "span", 35);
            i0.ɵɵpipe(84, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(85, "mat-slide-toggle", 38);
            i0.ɵɵlistener("ngModelChange", function ArticleFormComponent_Template_mat_slide_toggle_ngModelChange_85_listener($event) { return ctx.model.has_serial = $event; });
            i0.ɵɵelement(86, "span", 35);
            i0.ɵɵpipe(87, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(88, "mat-slide-toggle", 39);
            i0.ɵɵlistener("ngModelChange", function ArticleFormComponent_Template_mat_slide_toggle_ngModelChange_88_listener($event) { return ctx.model.has_lot_number = $event; });
            i0.ɵɵelement(89, "span", 35);
            i0.ɵɵpipe(90, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(91, "mat-slide-toggle", 40);
            i0.ɵɵlistener("ngModelChange", function ArticleFormComponent_Template_mat_slide_toggle_ngModelChange_91_listener($event) { return ctx.model.lapsing = $event; });
            i0.ɵɵelement(92, "span", 35);
            i0.ɵɵpipe(93, "translate");
            i0.ɵɵelementEnd()()()()();
            i0.ɵɵelementStart(94, "mat-tab", 41);
            i0.ɵɵpipe(95, "translate");
            i0.ɵɵelementStart(96, "div", 42)(97, "fts-article-components", 43);
            i0.ɵɵlistener("modelChange", function ArticleFormComponent_Template_fts_article_components_modelChange_97_listener($event) { return ctx.model.components = $event; });
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(98, "mat-tab", 41);
            i0.ɵɵpipe(99, "translate");
            i0.ɵɵelementStart(100, "div", 42)(101, "fts-article-substitutions", 43);
            i0.ɵɵlistener("modelChange", function ArticleFormComponent_Template_fts_article_substitutions_modelChange_101_listener($event) { return ctx.model.substitutions = $event; });
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(102, "mat-tab", 44);
            i0.ɵɵpipe(103, "translate");
            i0.ɵɵtemplate(104, ArticleFormComponent_ft_file_manager_104_Template, 1, 2, "ft-file-manager", 45);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(105, "div", 46);
            i0.ɵɵtemplate(106, ArticleFormComponent_button_106_Template, 2, 0, "button", 47);
            i0.ɵɵelement(107, "span", 5);
            i0.ɵɵelementStart(108, "button", 48);
            i0.ɵɵlistener("click", function ArticleFormComponent_Template_button_click_108_listener() { return ctx.goBack(); });
            i0.ɵɵelementStart(109, "span");
            i0.ɵɵtext(110);
            i0.ɵɵpipe(111, "translate");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(112, "button", 49);
            i0.ɵɵlistener("click", function ArticleFormComponent_Template_button_click_112_listener() { return ctx.saveArticle(true); });
            i0.ɵɵelementStart(113, "span");
            i0.ɵɵtext(114);
            i0.ɵɵpipe(115, "translate");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(116, "button", 50);
            i0.ɵɵlistener("click", function ArticleFormComponent_Template_button_click_116_listener() { return ctx.saveArticle(false); });
            i0.ɵɵelementStart(117, "span");
            i0.ɵɵtext(118);
            i0.ɵɵpipe(119, "translate");
            i0.ɵɵelementEnd()()();
        }
        if (rf & 2) {
            const _r1 = i0.ɵɵreference(18);
            const _r2 = i0.ɵɵreference(22);
            i0.ɵɵadvance(6);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(7, 104, "store.article_form_sheet"), " ");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.model == null ? null : ctx.model.id);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("matTooltip", i0.ɵɵpipeBind1(11, 106, "store.article_list"));
            i0.ɵɵadvance(4);
            i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(15, 108, "store.article_general"));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngBusy", ctx.busy);
            i0.ɵɵadvance(5);
            i0.ɵɵproperty("ftAutoFocus", true)("placeholder", i0.ɵɵpipeBind1(23, 110, "store.code"))("ngModel", ctx.model.code)("query", i0.ɵɵpureFunction1(158, _c0$s, ctx.model.id))("readonly", ctx.readOnly);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngIf", _r2 == null ? null : _r2.errors == null ? null : _r2.errors.exists);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(27, 112, "store.description"))("ngModel", ctx.model.description);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("label", "store.family")("model", ctx.model.family)("value", "name")("settings", ctx.familyInputSettings)("dialog", ctx.familyDialog);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("label", "store.default_provider")("model", ctx.model.default_provider)("value", "name")("settings", ctx.providerInputSettings)("dialog", ctx.providerDialog);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("model", ctx.model.purchase_unity)("listDialog", ctx.unityDialog)("reloadEvent", ctx.reloadUnitiesEvent)("config", i0.ɵɵpureFunction0(160, _c1$k))("label", "store.purchase_unity");
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("model", ctx.model.purchase_vat)("listDialog", ctx.vatDialog)("reloadEvent", ctx.reloadVatsEvent)("config", i0.ɵɵpureFunction0(161, _c2$e))("label", "store.purchase_vat")("defaultValues", "default_purchase_vat");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(36, 114, "store.purchase_price"))("ngModel", ctx.model.purchase_price)("ftNumber", "float");
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(39, 116, "store.purchase_price_max"))("ftNumber", "float")("ngModel", ctx.model.purchase_price_max);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("model", ctx.model.sale_unity)("listDialog", ctx.unityDialog)("reloadEvent", ctx.reloadUnitiesEvent)("config", i0.ɵɵpureFunction0(162, _c1$k))("label", "store.sale_unity");
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("model", ctx.model.sale_vat)("listDialog", ctx.vatDialog)("reloadEvent", ctx.reloadVatsEvent)("config", i0.ɵɵpureFunction0(163, _c2$e))("label", "store.sale_vat")("defaultValues", "default_sale_vat");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(45, 118, "store.sale_price"))("ftNumber", "float")("ngModel", ctx.model.sale_price);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(48, 120, "store.sale_price_min"))("ftNumber", "float")("ngModel", ctx.model.sale_price_min);
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(52, 122, "store.min_qte"))("ftNumber", "float")("ngModel", ctx.model.min_qte);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(55, 124, "store.max_qte"))("ftNumber", "float")("ngModel", ctx.model.max_qte);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(58, 126, "store.min_dep_qte"))("ftNumber", "float")("ngModel", ctx.model.min_dep_qte);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(61, 128, "store.max_dep_qte"))("ftNumber", "float")("ngModel", ctx.model.max_dep_qte);
            i0.ɵɵadvance(5);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(66, 130, "store.store_out_rules"));
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngModel", ctx.model.evaluation);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngForOf", ctx.evaluations);
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(74, 132, "store.management_rules"));
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngModel", ctx.model.prohibited_for_sale);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(78, 134, "store.prohibited_for_sale"), i0.ɵɵsanitizeHtml);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngModel", ctx.model.prohibited_to_purchase);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(81, 136, "store.prohibited_to_purchase"), i0.ɵɵsanitizeHtml);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngModel", ctx.model.allows_negative_stock);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(84, 138, "store.allows_negative_stock"), i0.ɵɵsanitizeHtml);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngModel", ctx.model.has_serial)("disabled", ctx.model.has_lot_number);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(87, 140, "store.has_serial"), i0.ɵɵsanitizeHtml);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngModel", ctx.model.has_lot_number)("disabled", ctx.model.has_serial);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(90, 142, "store.has_lot_number"), i0.ɵɵsanitizeHtml);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngModel", ctx.model.lapsing);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(93, 144, "store.lapsing"), i0.ɵɵsanitizeHtml);
            i0.ɵɵadvance(2);
            i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(95, 146, "store.component"));
            i0.ɵɵproperty("disabled", !ctx.model.id);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("model", ctx.model.components)("pk", ctx.model.id);
            i0.ɵɵadvance(1);
            i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(99, 148, "store.substitutions"));
            i0.ɵɵproperty("disabled", !ctx.model.id);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("model", ctx.model.substitutions)("pk", ctx.model.id);
            i0.ɵɵadvance(1);
            i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(103, 150, "shared.attached_documents"));
            i0.ɵɵproperty("disabled", !ctx.model.id);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.model == null ? null : ctx.model.id);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.model.id && !ctx.readOnly);
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(111, 152, "store.cancel"));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("disabled", _r1.invalid);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(115, 154, "store.save_close"));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("disabled", _r1.invalid);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(119, 156, "store.save"));
        }
    }, dependencies: [i4$1.NgForOf, i4$1.NgIf, i6.MatButton, i9.MatIcon, i10.MatError, i10.MatFormField, i11$1.MatInput, i13.MatRadioGroup, i13.MatRadioButton, i8$1.MatSlideToggle, i15$2.MatTabGroup, i15$2.MatTab, i11.MatToolbar, i15$1.MatTooltip, i8.DefaultLayoutDirective, i8.DefaultLayoutGapDirective, i8.FlexFillDirective, i8.DefaultFlexDirective, i16.ɵNgNoValidate, i16.DefaultValueAccessor, i16.NgControlStatus, i16.NgControlStatusGroup, i16.RequiredValidator, i16.NgModel, i16.NgForm, i12.NgBusyDirective, i2.InputDirective, i2.NumberDirective, i2.AutoFocusDirective, i2.CustomValidationDirective, i3.RouterLink, i21.FileManagerComponent, DocumentSelectComponent, ListSelectComponent, ArticleComponentsComponent, ArticleSubstitutionsComponent, i3$1.TranslatePipe], styles: ["[_nghost-%COMP%]{height:100%;display:flex;flex-direction:column}"] });
(function () {
    (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ArticleFormComponent, [{
            type: Component,
            args: [{ selector: 'fts-article-form', template: "<mat-toolbar color=\"accent\">\n  <div class=\"ft-module-icon\">\n    <button type=\"button\" mat-icon-button>\n      <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-format-list-bulleted\"></mat-icon>\n    </button>\n  </div>\n  <h2>\n    <span> {{'store.article_form_sheet'|translate}} </span>\n    <span *ngIf=\"model?.id\">: {{model?.code}}</span>\n  </h2>\n  <span fxFlex></span>\n  <button type=\"button\" mat-button class=\"with-icon\"  (click)=\"goBack()\"  [matTooltip]=\"'store.article_list'|translate\">\n    <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-format-list-bulleted\"></mat-icon>\n  </button>\n</mat-toolbar>\n<mat-tab-group fxFlex>\n  <mat-tab label=\"{{'store.article_general'|translate}}\" fxLayout=\"column\" >\n      <div [ngBusy]=\"busy\"></div>\n      <form class=\"form\" fxFill fxLayout=\"column\" name=\"article\" #articleForm=\"ngForm\" class=\"ft-content ft-padding\">\n\n        <div fxLayout=\"row\" fxLayoutGap=\"8px\">\n             <!--<div fxLayout=\"column\">\n            <div fxLayout=\"nogrow\" class=\"picture\"   ngfSelect ngfDrop >\n\n            </div>\n\n          </div>-->\n          <mat-form-field  fxFlex=\"25\"  class=\"with-error-label\">\n            <input [ftAutoFocus]=\"true\"\n                   matInput\n                   [placeholder]=\"'store.code'|translate\" name=\"code\"\n                   [(ngModel)]=\"model.code\" required\n                   [query]=\"{pk:model.id, field:'code', pk_field:'id'}\"\n                   ftCustomValidation=\"article.check_uniqueness\"\n                   #code=\"ngModel\"\n                   [readonly]=\"readOnly\">\n            <mat-error *ngIf=\"code?.errors?.exists\"> {{'store.code_already_exist'|translate}}</mat-error>\n          </mat-form-field>\n          <mat-form-field fxFlex >\n            <input matInput [placeholder]=\"'store.description'|translate\"\n                   name=\"description\"  [(ngModel)]=\"model.description\" required>\n          </mat-form-field>\n        </div>\n        <div fxLayout=\"row\" fxLayoutGap=\"8px\">\n          <fts-document-select fxFlex\n                               [label]=\"'store.family'\"\n                               [(model)]=\"model.family\"\n                               [value]=\"'name'\"\n                               [settings]=\"familyInputSettings\"\n                               [dialog]=\"familyDialog\">\n          </fts-document-select>\n          <fts-document-select fxFlex\n                               [label]=\"'store.default_provider'\"\n                               [(model)]=\"model.default_provider\"\n                               [value]=\"'name'\"\n                               [settings]=\"providerInputSettings\"\n                               [dialog]=\"providerDialog\">\n          </fts-document-select>\n        </div>\n        <div fxLayout=\"row\" fxLayoutGap=\"8px\">\n            <fts-list-select fxFlex\n                             [(model)]=\"model.purchase_unity\"\n                             [listDialog]=\"unityDialog\"\n                             (modelChange)=\"handleReloadUnities($event)\"\n                             [reloadEvent]=\"reloadUnitiesEvent\"\n                             [config]=\"{key: 'value', url: 'api/list/unity/', cls:'list/unity', customValidator:'store-unity.check_uniqueness'}\"\n                             [label]=\"'store.purchase_unity'\"\n                              >\n            </fts-list-select>\n            <fts-list-select fxFlex\n                             [(model)]=\"model.purchase_vat\"\n                             [listDialog]=\"vatDialog\"\n                             [reloadEvent]=\"reloadVatsEvent\"\n                             (modelChange)=\"handleReloadVats($event)\"\n                             [config]=\"{key: 'description', url: 'api/list/vat/', cls:'list/vat', isNumber:true,customValidator:'store-vat.check_uniqueness' }\"\n                             [label]=\"'store.purchase_vat'\"  [defaultValues]=\"'default_purchase_vat'\"\n                             >\n            </fts-list-select>\n\n            <mat-form-field fxFlex>\n              <input matInput [placeholder]=\"'store.purchase_price'|translate\" name=\"purchase_price\"\n                   [(ngModel)]=\"model.purchase_price\" [ftNumber]=\"'float'\">\n            </mat-form-field>\n            <mat-form-field fxFlex>\n              <input matInput [placeholder]=\"'store.purchase_price_max'|translate\" [ftNumber]=\"'float'\"\n                     name=\"purchase_price_max\"\n                     [(ngModel)]=\"model.purchase_price_max\">\n            </mat-form-field>\n        </div>\n        <div fxLayout=\"row\" fxLayoutGap=\"8px\">\n          <fts-list-select fxFlex\n                           [(model)]=\"model.sale_unity\"\n                           [listDialog]=\"unityDialog\"\n                           (modelChange)=\"handleReloadUnities($event)\"\n                           [reloadEvent]=\"reloadUnitiesEvent\"\n                           [config]=\"{key: 'value', url: 'api/list/unity/', cls:'list/unity',customValidator:'store-unity.check_uniqueness'}\"\n                           [label]=\"'store.sale_unity'\"\n                           >\n          </fts-list-select>\n          <fts-list-select fxFlex\n                            [(model)]=\"model.sale_vat\"\n                            [listDialog]=\"vatDialog\"\n                            [reloadEvent]=\"reloadVatsEvent\"\n                            (modelChange)=\"handleReloadVats($event)\"\n                            [config]=\"{key: 'description', url: 'api/list/vat/', cls:'list/vat', isNumber:true,customValidator:'store-vat.check_uniqueness'}\"\n                            [label]=\"'store.sale_vat'\"  [defaultValues]=\"'default_sale_vat'\"\n                             >\n          </fts-list-select>\n          <mat-form-field fxFlex>\n            <input matInput\n                   [placeholder]=\"'store.sale_price'|translate\"\n                   [ftNumber]=\"'float'\" name=\"sale_price\"\n                   [(ngModel)]=\"model.sale_price\">\n          </mat-form-field>\n\n          <mat-form-field fxFlex>\n            <input matInput [placeholder]=\"'store.sale_price_min'|translate\" [ftNumber]=\"'float'\"\n                   name=\"sale_price_min\"\n                   [(ngModel)]=\"model.sale_price_min\">\n          </mat-form-field>\n        </div>\n        <div fxLayout=\"row\" fxLayoutGap=\"8px\">\n          <mat-form-field fxFlex>\n            <input matInput [placeholder]=\"'store.min_qte'|translate\" name=\"min_qte\" [ftNumber]=\"'float'\"\n                   [(ngModel)]=\"model.min_qte\">\n          </mat-form-field>\n\n          <mat-form-field fxFlex>\n            <input matInput [placeholder]=\"'store.max_qte'|translate\" name=\"max_qte\" [ftNumber]=\"'float'\"\n                   [(ngModel)]=\"model.max_qte\">\n          </mat-form-field>\n\n          <mat-form-field fxFlex>\n            <input matInput [placeholder]=\"'store.min_dep_qte'|translate\" [ftNumber]=\"'float'\" name=\"min_dep_qte\"\n                   [(ngModel)]=\"model.min_dep_qte\">\n          </mat-form-field>\n\n          <mat-form-field fxFlex>\n            <input matInput [placeholder]=\"'store.max_dep_qte'|translate\" [ftNumber]=\"'float'\" name=\"max_dep_qte\"\n                   [(ngModel)]=\"model.max_dep_qte\">\n          </mat-form-field>\n        </div>\n\n        <hr class=\"ft-sep\">\n        <div  fxLayoutGap=\"6px\" fxLayout=\"column\">\n          <h4>{{'store.store_out_rules'|translate}}</h4>\n          <mat-form-field floatLabel=\"always\" class=\"ft-radio-field\">\n            <input matInput placeholder=\"\" style=\"display: none\">\n            <mat-radio-group [(ngModel)]=\"model.evaluation\" name=\"evaluation\" color=\"primary\" fxFlex>\n              <mat-radio-button *ngFor=\"let element of evaluations\" [value]=\"element\">\n                {{'store.'+element|translate}}\n              </mat-radio-button>\n            </mat-radio-group>\n\n          </mat-form-field>\n        </div>\n        <div  fxLayoutGap=\"6px\" fxLayout=\"column\">\n            <h4>{{'store.management_rules'|translate}}</h4>\n           <div fxLayoutGap=\"6px\" fxFlex=\"row\">\n              <mat-slide-toggle name=\"prohibited_for_sale\" [(ngModel)]=\"model.prohibited_for_sale\" color=\"primary\">\n                <span [innerHTML]=\"'store.prohibited_for_sale' | translate\"></span>\n              </mat-slide-toggle>\n\n              <mat-slide-toggle name=\"prohibited_to_purchase\" [(ngModel)]=\"model.prohibited_to_purchase\" color=\"primary\">\n                <span [innerHTML]=\"'store.prohibited_to_purchase' | translate\"></span>\n              </mat-slide-toggle>\n\n              <mat-slide-toggle name=\"allows_negative_stock\" [(ngModel)]=\"model.allows_negative_stock\" color=\"primary\">\n                <span [innerHTML]=\"'store.allows_negative_stock' | translate\"></span>\n              </mat-slide-toggle>\n\n              <mat-slide-toggle name=\"has_serial\" [(ngModel)]=\"model.has_serial\" [disabled]=\"model.has_lot_number\" color=\"primary\">\n                <span [innerHTML]=\"'store.has_serial' | translate\"></span>\n              </mat-slide-toggle>\n\n              <mat-slide-toggle name=\"has_lot_number\" [(ngModel)]=\"model.has_lot_number\" [disabled]=\"model.has_serial\" color=\"primary\">\n                <span [innerHTML]=\"'store.has_lot_number' | translate\"></span>\n              </mat-slide-toggle>\n\n              <mat-slide-toggle name=\"lapsing\" [(ngModel)]=\"model.lapsing\" color=\"primary\">\n                <span [innerHTML]=\"'store.lapsing' | translate\"></span>\n              </mat-slide-toggle>\n\n          </div>\n\n        </div>\n      </form>\n  </mat-tab>\n  <mat-tab label=\"{{'store.component'|translate}}\" [disabled]=\"!model.id\">\n    <div fxFlex class=\"ft-content\" fxFill=\"\" fxLayout=\"column\">\n      <fts-article-components [(model)]=\"model.components\" [pk]=\"model.id\"></fts-article-components>\n    </div>\n  </mat-tab>\n  <mat-tab label=\"{{'store.substitutions'|translate}}\" [disabled]=\"!model.id\">\n    <div  class=\"ft-content\" fxFlex=\"\" fxFill=\"\" fxLayout=\"column\">\n      <fts-article-substitutions [(model)]=\"model.substitutions\" [pk]=\"model.id\"></fts-article-substitutions>\n    </div>\n  </mat-tab>\n   <!--<mat-tab label=\"{{'store.historical_purchase_sales'|translate}}\" disabled  [disabled]=\"!model.id\">\n   <fts-historical fxFill=\"\"></fts-historical>\n  </mat-tab>-->\n  <mat-tab label=\"{{'shared.attached_documents'|translate}}\" disabled  [disabled]=\"!model.id\">\n      <ft-file-manager *ngIf=\"model?.id\" [root]=\"'store-article'\" [rootId]=\"model.id\"></ft-file-manager>\n  </mat-tab>\n</mat-tab-group>\n<div class=\"ft-actions\">\n  <button *ngIf=\"model.id && !readOnly\" mat-raised-button color=\"warn\" (click)=\"checkRemoveArticle()\">\n     <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-delete\"></mat-icon>\n  </button>\n  <span fxFlex></span>\n  <button mat-raised-button color=\"warn\" (click)=\"goBack()\">\n    <span>{{'store.cancel'|translate}}</span>\n  </button>\n  <button mat-raised-button color=\"primary\" (click)=\"saveArticle(true)\" routerLink=\"/store/article/article-list\"\n          [disabled]=\"articleForm.invalid\">\n    <span>{{'store.save_close'|translate}}</span>\n  </button>\n\n  <button mat-raised-button color=\"primary\" (click)=\"saveArticle(false)\"\n          [disabled]=\"articleForm.invalid\">\n    <span>{{'store.save'|translate}}</span>\n  </button>\n</div>\n", styles: [":host{height:100%;display:flex;flex-direction:column}\n"] }]
        }], function () { return [{ type: i1$2.MatSnackBar }, { type: i1.MatDialog }, { type: i3.ActivatedRoute }, { type: i3.Router }, { type: SharedService }, { type: SharedModulesService }, { type: i2.GeneralPurposeService }, { type: i3$1.TranslateService }]; }, null);
})();

const PURCHASE_INVOICE_COLUMNS = [
    {
        'label': 'purchase.invoice_number',
        'key': 'number',
        'type': 'text',
        'is_global_searchable': true,
        'sortBy': 'number'
    },
    {
        'label': 'purchase.date',
        'key': 'date',
        'sortBy': 'date',
        'type': 'date',
        'is_global_searchable': true
    },
    {
        'label': 'purchase.deadline',
        'key': 'deadline',
        'sortBy': 'deadline',
        'type': 'date',
        'is_global_searchable': true
    },
    {
        "label": "store.default_provider",
        "key": "provider.name",
        "type": "text",
        "is_global_searchable": true
    },
    {
        "label": "purchase.payment_mode",
        "key": "payment_mode.type",
        "type": "badge",
        "is_global_searchable": false,
        callBack: (row) => get(row, 'payment_mode.type') ? `shared.${row.payment_mode.type}` : "",
        "style": (row) => { return { 'background-color': "#24ca24" }; }
    },
    {
        'label': 'shared.state',
        'key': 'state.is_valid',
        'type': 'boolean',
        'icon': 'mdi-checkbox-blank-circle',
        'tooltip': (row) => { return get(row, 'state.is_valid') ? "shared.is_valid" : "shared.is_draft"; },
        'style': (row) => {
            return get(row, 'state.is_valid') ? {
                'color': '#76FF03',
                'font-size': '20px'
            } : {
                'color': 'grey',
                'font-size': '20px'
            };
        }
    },
    {
        "label": "shared.ttc_amount",
        "key": "ttc_amount",
        "type": "number",
        "numberConfig": 'float',
        "is_global_searchable": true
    }
];

const PURCHASE_PAYMENT_COLUMNS = [
    {
        'label': 'purchase.payment_number',
        'type': 'text',
        'key': 'number',
        'sortBy': 'number',
        'is_global_searchable': true
    },
    {
        'label': 'shared.date',
        'type': 'date',
        'key': 'date',
        'sortBy': 'date',
        'is_global_searchable': true
    },
    {
        "label": "store.default_provider",
        "key": "provider.name",
        "type": "text",
        "is_global_searchable": true
    },
    {
        "label": "purchase.received_amount",
        "key": "received_amount",
        "type": "number",
        "numberConfig": 'float',
        "is_global_searchable": true
    },
    {
        "label": "purchase.consumed_amount",
        "key": "consumed_amount",
        "type": "number",
        "numberConfig": 'float',
        "is_global_searchable": true
    },
    {
        "label": "purchase.remaining_amount",
        "key": "remaining_amount",
        "type": "number",
        "numberConfig": 'float',
        "is_global_searchable": true
    }
];

const PURCHASE_INVOICE_VIEW = {
    trackByKey: 'id',
    hasSearch: true,
    selectable: true,
    hasPagination: true,
    viewNamespace: 'Liste',
    query: [],
    viewSettings: {
        'model': 'ft_stock.purchase.PurchaseInvoice',
        'viewColumns': PURCHASE_INVOICE_COLUMNS,
        'systemColumns': SYSTEM_COLUMNS,
        'defaultName': 'Liste des Factures'
    },
    actions: [],
    isSubModule: true,
    'formRoute': '/purchase/purchase-invoice/purchase-invoice-form/',
    'viewUrl': 'purchase/purchase-invoice/purchase-invoice-form/',
    'printGroup': 'purchase-invoice',
    'apiUrl': 'purchase/purchase-invoice',
    'headerLabel': 'purchase.purchase_invoice_list',
    'formLabel': 'purchase.purchase_invoice_form',
    resource: 'purchase-invoice',
    headerIcon: "mdi-receipt"
};
const PURCHASE_PAYMENT_VIEW = {
    trackByKey: 'id',
    hasSearch: true,
    selectable: true,
    hasPagination: true,
    viewNamespace: 'Liste',
    query: [],
    viewSettings: {
        'model': 'ft_stock.purchase.PurchasePayment',
        'viewColumns': PURCHASE_PAYMENT_COLUMNS,
        'systemColumns': SYSTEM_COLUMNS,
        'defaultName': 'Liste des réglements'
    },
    actions: [],
    isSubModule: true,
    'formRoute': '/purchase/purchase-payment/purchase-payment-form/',
    'viewUrl': 'purchase/purchase-payment/purchase-payment-form/',
    'printGroup': 'purchase-payment',
    'apiUrl': 'purchase/purchase-payment',
    'headerLabel': 'purchase.purchase_payment_list',
    'formLabel': 'purchase.purchase_payment_form',
    resource: 'purchase-payment',
    headerIcon: "mdi-currency-usd"
};

const DELIVERY_COLUMNS = [
    {
        "label": "sale.delivery_number",
        "key": "number",
        "type": "text",
        "is_global_searchable": true
    },
    {
        "label": "sale.date",
        "key": "date",
        "type": "date",
        "is_global_searchable": true
    },
    {
        "label": "store.organization",
        "key": "organization.name",
        "type": "text",
        "is_global_searchable": true
    },
    {
        "label": "shared.patient_first_name",
        "key": "patient.first_name",
        "type": "text",
        "is_global_searchable": true
    },
    {
        "label": "shared.patient_last_name",
        "key": "patient.last_name",
        "type": "text",
        "is_global_searchable": true
    },
    {
        'label': 'shared.state',
        'key': 'is_valid',
        'type': 'boolean',
        'icon': 'mdi-checkbox-blank-circle',
        'tooltip': (row) => { return get(row, 'state.is_valid') ? "shared.is_valid" : "shared.is_draft"; },
        'style': (row) => {
            return get(row, 'state.is_valid') ? {
                'color': '#76FF03',
                'font-size': '20px'
            } : {
                'color': 'grey',
                'font-size': '20px'
            };
        }
    },
    {
        "label": "shared.vat_amount",
        "key": "vat_amount",
        "type": "number",
        "numberConfig": 'float',
        "is_global_searchable": true
    },
    {
        "label": "shared.ttc_amount",
        "key": "ttc_amount",
        "type": "number",
        "numberConfig": 'float',
        "is_global_searchable": true
    }
];

const CONSIGNMENT_RETURN_COLUMNS = [
    {
        "label": "purchase.return_form_number",
        "type": "text",
        "key": "number",
        "is_global_searchable": true
    },
    {
        "label": "store.date",
        "key": "date",
        "type": "date",
        "is_global_searchable": true
    },
    {
        "label": "store.organization",
        "key": "organization",
        "type": "text",
        "is_global_searchable": true
    },
    {
        "label": "store.depot",
        "key": "store.name",
        "type": "badge",
        "is_global_searchable": true,
        "style": { 'background-color': '#4fc3f7' }
    },
    {
        "label": "shared.patient_first_name",
        "key": "patient.first_name",
        "type": "text",
        "is_global_searchable": true
    },
    {
        "label": "shared.patient_last_name",
        "key": "patient.last_name",
        "type": "text",
        "is_global_searchable": true
    },
    {
        'label': 'shared.state',
        'key': 'is_valid',
        'type': 'boolean',
        'icon': 'mdi-checkbox-blank-circle',
        'tooltip': (row) => { return get(row, 'state.is_valid') ? "shared.is_valid" : "shared.is_draft"; },
        'style': (row) => {
            return get(row, 'state.is_valid') ? {
                'color': '#76FF03',
                'font-size': '20px'
            } : {
                'color': 'grey',
                'font-size': '20px'
            };
        }
    },
    {
        "label": "shared.ttc_amount",
        "key": "ttc_amount",
        "type": "number",
        "numberConfig": 'float',
        "is_global_searchable": true
    }
];

const DELIVERY_VIEW = {
    trackByKey: 'id',
    hasSearch: true,
    selectable: true,
    hasPagination: true,
    viewNamespace: 'Liste',
    query: [],
    viewSettings: {
        'model': 'ft_stock.sales.DeliveryForm',
        'viewColumns': DELIVERY_COLUMNS,
        'systemColumns': SYSTEM_COLUMNS,
        'defaultName': 'Bons de livraison'
    },
    actions: [],
    isSubModule: true,
    'formRoute': '/sale/delivery/delivery-form/',
    'viewUrl': 'sale/delivery/',
    'printGroup': 'delivery-form',
    'apiUrl': 'sale/delivery-form',
    'headerLabel': 'sale.delivery_list',
    'formLabel': 'store.delivery',
    resource: 'delivery-form',
    headerIcon: "mdi-file-upload"
};
const CONSIGNMENT_RETURN_VIEW = {
    trackByKey: 'id',
    hasSearch: true,
    selectable: true,
    hasPagination: true,
    viewNamespace: 'Liste',
    query: [],
    viewSettings: {
        'model': 'ft_stock.sales.ConsignmentReturn',
        'viewColumns': CONSIGNMENT_RETURN_COLUMNS,
        'systemColumns': SYSTEM_COLUMNS,
        'defaultName': 'Retours de consignations'
    },
    actions: [],
    isSubModule: true,
    'formRoute': '/sale/consignment-return/consignment-return-form/',
    'viewUrl': 'sale/consignment-return/',
    'printGroup': 'consignment-return',
    'apiUrl': 'sale/consignment-return',
    'headerLabel': 'store.consignment_return',
    'formLabel': 'sale.consignment_return',
    resource: 'consignment-return',
    headerIcon: "mdi-file-import"
};

const STORE_INVENTORY_COLUMNS = [
    {
        "label": "inventory.inventory_number",
        "key": "number",
        "type": "text",
        "is_global_searchable": true
    },
    {
        "label": "store.date",
        "key": "date",
        "type": "date",
        "is_global_searchable": true
    },
    {
        "label": "store.depot",
        "key": "store.name",
        "type": "badge",
        "is_global_searchable": true,
        "style": { 'background-color': '#4fc3f7' }
    },
    {
        "label": "store.manager",
        "key": "manager",
        "type": "text",
        "is_global_searchable": true
    },
    {
        "label": "store.comment",
        "key": "comment",
        "type": "text",
        "is_global_searchable": true
    }
];

const STORE_INVENTORY_VIEW = {
    trackByKey: 'id',
    hasSearch: true,
    selectable: true,
    hasPagination: true,
    viewNamespace: 'Liste',
    query: [],
    viewSettings: {
        'model': 'ft_stock.store.StoreInventory',
        'viewColumns': STORE_INVENTORY_COLUMNS,
        'systemColumns': SYSTEM_COLUMNS,
        'defaultName': 'Liste des inventaires'
    },
    actions: [],
    isSubModule: true,
    'viewUrl': '/inventory/inventory/inventory-list/',
    'formRoute': '/inventory/inventory/inventory-form/',
    'printGroup': 'store-inventory',
    'apiUrl': '/store/inventory',
    'headerLabel': 'shared.inventory_list',
    'formLabel': 'store.inventory_form',
    resource: 'store-inventory',
    headerIcon: "mdi-clipboard-check"
};

function PatientDialogComponent_mat_radio_button_37_Template(rf, ctx) {
    if (rf & 1) {
        i0.ɵɵelementStart(0, "mat-radio-button", 36);
        i0.ɵɵtext(1);
        i0.ɵɵelementEnd();
    }
    if (rf & 2) {
        const b_type_r6 = ctx.$implicit;
        i0.ɵɵproperty("value", b_type_r6);
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", b_type_r6, " ");
    }
}
const _c0$r = function () { return { key: "value", url: "api/list/title", cls: "list/title" }; };
const _c1$j = function (a1, a2, a3, a4) { return { field: "last_name", pk: a1, first_name: a2, last_name: a3, national_id: a4 }; };
const _c2$d = function (a1, a2, a3, a4) { return { field: "first_name", pk: a1, first_name: a2, last_name: a3, national_id: a4 }; };
const _c3$2 = function () { return ["M", "F"]; };
const _c4$2 = function () { return { key: "value", url: "api/list/marital-status", cls: "list/marital-status" }; };
const _c5 = function (a1, a2, a3, a4) { return { field: "national_id", pk: a1, first_name: a2, last_name: a3, national_id: a4 }; };
class PatientDialogComponent {
    constructor(dialogRef, sharedService, data, dialog) {
        this.dialogRef = dialogRef;
        this.sharedService = sharedService;
        this.data = data;
        this.dialog = dialog;
        this.patient = {};
        this.organizationInputSettings = _.assignIn(_.cloneDeep(ORGANIZATION_VIEW), { selectable: false });
    }
    ngOnInit() {
        this.patient = this.data ? this.data : {
            contact_info: { phone_numbers: [] },
            // external_id: "None",
            national_id: null,
            source: 'FtBilling',
            medical_insurances: [],
            address: { content: null },
            gender: 'M'
        };
        if (!_.has(this.patient, 'contact_info')) {
            this.patient.contact_info = { phone_numbers: [] };
        }
        if (!_.has(this.patient, 'address')) {
            this.patient.address = { content: null };
        }
    }
    save() {
        if (_.isEmpty(this.patient.national_id)) {
            this.patient.national_id = null;
        }
        this.loader = this.sharedService.saveDocument('store/patient', this.patient).subscribe(data => {
            this.dialogRef.close(data);
        });
    }
    listChange(value) {
        get(value, 'gender') == 'FEMALE' ? this.patient.gender = 'F' : this.patient.gender = 'M';
    }
}
PatientDialogComponent.ɵfac = function PatientDialogComponent_Factory(t) { return new (t || PatientDialogComponent)(i0.ɵɵdirectiveInject(i1.MatDialogRef), i0.ɵɵdirectiveInject(SharedService), i0.ɵɵdirectiveInject(MAT_DIALOG_DATA), i0.ɵɵdirectiveInject(i1.MatDialog)); };
PatientDialogComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PatientDialogComponent, selectors: [["fts-patient-dialog"]], decls: 61, vars: 74, consts: [["color", "primary"], [1, "ft-module-icon"], ["type", "button", "mat-icon-button", "", "tabindex", "-2"], ["fontSet", "mdi", "fontIcon", "mdi-account-settings"], ["fxFlex", ""], ["type", "button", "mat-icon-button", "", "mat-dialog-close", "", "tabindex", "-1"], ["fontSet", "mdi", "fontIcon", "mdi-close"], ["novalidate", ""], ["form", "ngForm"], [3, "ngBusy"], ["mat-dialog-content", "", "fxLayout", "column", 1, "ft-busy-container", 2, "min-height", "230px"], ["fxLayout", "row", "fxLayoutGap", "6px"], ["fxFlex", "", 3, "model", "config", "label", "modelChange"], ["matInput", "", "type", "text", "required", "", "name", "last_name", "ftCustomValidation", "patient.check_uniqueness", 3, "placeholder", "ftAutoFocus", "ngModel", "query", "ngModelChange"], ["last_name", "ngModel"], ["matInput", "", "type", "text", "required", "", "name", "first_name", "ftCustomValidation", "patient.check_uniqueness", 3, "placeholder", "ngModel", "query", "ngModelChange"], ["first_name", "ngModel"], ["fxFlex", "nogrow"], ["matInput", "", "ftDate", "", "name", "b_date", 3, "matDatepicker", "placeholder", "ngModel", "ngModelChange"], ["matSuffix", "", 3, "for"], ["matDatepickerToggleIcon", "", "fontSet", "mdi", "fontIcon", "mdi-calendar-today"], ["b_date", ""], ["floatLabel", "always", 1, "ft-radio-field"], ["matInput", "", 2, "display", "none", 3, "placeholder"], ["name", "b_type", "fxLayout", "row", 3, "ngModel", "ngModelChange"], [3, "value", 4, "ngFor", "ngForOf"], [1, "ft-sep"], ["fxLayout", "row", "fxFlex", "", "fxLayoutGap", "6px"], ["fxFlex", "", 1, "with-error-label"], ["matInput", "", "type", "text", "name", "national_id", "ftCustomValidation", "patient.check_uniqueness", "name", "national_id", 3, "placeholder", "ngModel", "query", "ngModelChange"], ["national_id", "ngModel"], ["matInput", "", "type", "text", "name", "phone_numbers", 3, "placeholder", "ngModel", "ngModelChange"], ["matInput", "", "name", "address", 3, "ngModel", "placeholder", "ngModelChange"], ["mat-dialog-actions", ""], ["type", "button", "color", "primary", "mat-raised-button", "", "tabindex", "2", 3, "disabled", "click"], ["type", "button", "color", "warn", "mat-raised-button", "", "tabindex", "-1", 3, "mat-dialog-close"], [3, "value"]], template: function PatientDialogComponent_Template(rf, ctx) {
        if (rf & 1) {
            i0.ɵɵelementStart(0, "mat-toolbar", 0)(1, "div", 1)(2, "button", 2);
            i0.ɵɵelement(3, "mat-icon", 3);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(4, "h2");
            i0.ɵɵtext(5);
            i0.ɵɵpipe(6, "translate");
            i0.ɵɵpipe(7, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(8, "span", 4);
            i0.ɵɵelementStart(9, "button", 5);
            i0.ɵɵelement(10, "mat-icon", 6);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(11, "form", 7, 8);
            i0.ɵɵelement(13, "div", 9);
            i0.ɵɵelementStart(14, "div", 10)(15, "div", 11)(16, "fts-list-select", 12);
            i0.ɵɵlistener("modelChange", function PatientDialogComponent_Template_fts_list_select_modelChange_16_listener($event) { return ctx.patient.title = $event; });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(17, "mat-form-field", 4)(18, "input", 13, 14);
            i0.ɵɵlistener("ngModelChange", function PatientDialogComponent_Template_input_ngModelChange_18_listener($event) { return ctx.patient.last_name = $event; });
            i0.ɵɵpipe(20, "translate");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(21, "mat-form-field", 4)(22, "input", 15, 16);
            i0.ɵɵlistener("ngModelChange", function PatientDialogComponent_Template_input_ngModelChange_22_listener($event) { return ctx.patient.first_name = $event; });
            i0.ɵɵpipe(24, "translate");
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(25, "div", 11)(26, "mat-form-field", 17)(27, "input", 18);
            i0.ɵɵlistener("ngModelChange", function PatientDialogComponent_Template_input_ngModelChange_27_listener($event) { return ctx.patient.birth_date = $event; });
            i0.ɵɵpipe(28, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(29, "mat-datepicker-toggle", 19);
            i0.ɵɵelement(30, "mat-icon", 20);
            i0.ɵɵelementEnd();
            i0.ɵɵelement(31, "mat-datepicker", null, 21);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(33, "mat-form-field", 22);
            i0.ɵɵelement(34, "input", 23);
            i0.ɵɵpipe(35, "translate");
            i0.ɵɵelementStart(36, "mat-radio-group", 24);
            i0.ɵɵlistener("ngModelChange", function PatientDialogComponent_Template_mat_radio_group_ngModelChange_36_listener($event) { return ctx.patient.gender = $event; });
            i0.ɵɵtemplate(37, PatientDialogComponent_mat_radio_button_37_Template, 2, 2, "mat-radio-button", 25);
            i0.ɵɵelementEnd()()();
            i0.ɵɵelement(38, "hr", 26);
            i0.ɵɵelementStart(39, "div", 27)(40, "fts-list-select", 12);
            i0.ɵɵlistener("modelChange", function PatientDialogComponent_Template_fts_list_select_modelChange_40_listener($event) { return ctx.patient.marital_status = $event; });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(41, "mat-form-field", 28)(42, "input", 29, 30);
            i0.ɵɵlistener("ngModelChange", function PatientDialogComponent_Template_input_ngModelChange_42_listener($event) { return ctx.patient.national_id = $event; });
            i0.ɵɵpipe(44, "translate");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(45, "mat-form-field", 4)(46, "input", 31);
            i0.ɵɵlistener("ngModelChange", function PatientDialogComponent_Template_input_ngModelChange_46_listener($event) { return (ctx.patient.contact_info.phone_numbers[0] = $event); });
            i0.ɵɵpipe(47, "translate");
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(48, "div", 27)(49, "mat-form-field", 4)(50, "textarea", 32);
            i0.ɵɵlistener("ngModelChange", function PatientDialogComponent_Template_textarea_ngModelChange_50_listener($event) { return ctx.patient.address.content = $event; });
            i0.ɵɵpipe(51, "translate");
            i0.ɵɵtext(52, "              ");
            i0.ɵɵelementEnd()()()();
            i0.ɵɵelementStart(53, "div", 33);
            i0.ɵɵelement(54, "span", 4);
            i0.ɵɵelementStart(55, "button", 34);
            i0.ɵɵlistener("click", function PatientDialogComponent_Template_button_click_55_listener() { return ctx.save(); });
            i0.ɵɵtext(56);
            i0.ɵɵpipe(57, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(58, "button", 35);
            i0.ɵɵtext(59);
            i0.ɵɵpipe(60, "translate");
            i0.ɵɵelementEnd()()();
        }
        if (rf & 2) {
            const _r0 = i0.ɵɵreference(12);
            const _r1 = i0.ɵɵreference(19);
            const _r2 = i0.ɵɵreference(23);
            const _r3 = i0.ɵɵreference(32);
            const _r5 = i0.ɵɵreference(43);
            i0.ɵɵadvance(5);
            i0.ɵɵtextInterpolate2("", i0.ɵɵpipeBind1(6, 34, "shared.patient_file"), " ", (_r5 == null ? null : _r5.errors == null ? null : _r5.errors.exists) || (_r1 == null ? null : _r1.errors == null ? null : _r1.errors.exists) || (_r2 == null ? null : _r2.errors == null ? null : _r2.errors.exists) ? " - " + i0.ɵɵpipeBind1(7, 36, "shared.patient_already_exist") : "", "");
            i0.ɵɵadvance(8);
            i0.ɵɵproperty("ngBusy", ctx.loader);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("model", ctx.patient.title)("config", i0.ɵɵpureFunction0(56, _c0$r))("label", "shared.title");
            i0.ɵɵadvance(2);
            i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(20, 38, "shared.last_name"));
            i0.ɵɵproperty("ftAutoFocus", true)("ngModel", ctx.patient.last_name)("query", i0.ɵɵpureFunction4(57, _c1$j, ctx.patient == null ? null : ctx.patient.id, ctx.patient == null ? null : ctx.patient.first_name, ctx.patient == null ? null : ctx.patient.last_name, ctx.patient == null ? null : ctx.patient.national_id));
            i0.ɵɵadvance(4);
            i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(24, 40, "shared.first_name"));
            i0.ɵɵproperty("ngModel", ctx.patient.first_name)("query", i0.ɵɵpureFunction4(62, _c2$d, ctx.patient == null ? null : ctx.patient.id, ctx.patient == null ? null : ctx.patient.first_name, ctx.patient == null ? null : ctx.patient.last_name, ctx.patient == null ? null : ctx.patient.national_id));
            i0.ɵɵadvance(5);
            i0.ɵɵproperty("matDatepicker", _r3)("placeholder", i0.ɵɵpipeBind1(28, 42, "shared.birth_date"))("ngModel", ctx.patient.birth_date);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("for", _r3);
            i0.ɵɵadvance(5);
            i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(35, 44, "shared.gender"));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngModel", ctx.patient.gender);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngForOf", i0.ɵɵpureFunction0(67, _c3$2));
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("model", ctx.patient.marital_status)("config", i0.ɵɵpureFunction0(68, _c4$2))("label", "common.list.marital_status");
            i0.ɵɵadvance(2);
            i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(44, 46, "patient.national_id"));
            i0.ɵɵproperty("ngModel", ctx.patient.national_id)("query", i0.ɵɵpureFunction4(69, _c5, ctx.patient == null ? null : ctx.patient.id, ctx.patient == null ? null : ctx.patient.first_name, ctx.patient == null ? null : ctx.patient.last_name, ctx.patient == null ? null : ctx.patient.national_id));
            i0.ɵɵadvance(4);
            i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(47, 48, "shared.phone_number"));
            i0.ɵɵproperty("ngModel", ctx.patient.contact_info.phone_numbers[0]);
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngModel", ctx.patient.address.content)("placeholder", i0.ɵɵpipeBind1(51, 50, "shared.address"));
            i0.ɵɵadvance(5);
            i0.ɵɵproperty("disabled", _r0.invalid);
            i0.ɵɵadvance(1);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(57, 52, "shared.save"), " ");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("mat-dialog-close", null);
            i0.ɵɵadvance(1);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(60, 54, "shared.reset"), " ");
        }
    }, dependencies: [i4$1.NgForOf, i6.MatButton, i7.MatDatepicker, i7.MatDatepickerInput, i7.MatDatepickerToggle, i7.MatDatepickerToggleIcon, i1.MatDialogClose, i1.MatDialogContent, i1.MatDialogActions, i9.MatIcon, i10.MatFormField, i10.MatSuffix, i11$1.MatInput, i13.MatRadioGroup, i13.MatRadioButton, i11.MatToolbar, i8.DefaultLayoutDirective, i8.DefaultLayoutGapDirective, i8.DefaultFlexDirective, i16.ɵNgNoValidate, i16.DefaultValueAccessor, i16.NgControlStatus, i16.NgControlStatusGroup, i16.RequiredValidator, i16.NgModel, i16.NgForm, i12.NgBusyDirective, i2.DateDirective, i2.InputDirective, i2.AutoFocusDirective, i2.CustomValidationDirective, ListSelectComponent, i3$1.TranslatePipe] });
(function () {
    (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PatientDialogComponent, [{
            type: Component,
            args: [{ selector: 'fts-patient-dialog', template: "<mat-toolbar color=\"primary\">\n  <div class=\"ft-module-icon\">\n    <button type=\"button\" mat-icon-button tabindex=\"-2\">\n      <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-account-settings\"></mat-icon>\n    </button>\n  </div>\n    <h2>{{ 'shared.patient_file' | translate }} {{national_id?.errors?.exists ||last_name?.errors?.exists ||first_name?.errors?.exists ? ' - ' +('shared.patient_already_exist' |translate)  : ''}}</h2>\n\n  <span fxFlex></span>\n  <button type=\"button\" mat-icon-button mat-dialog-close tabindex=\"-1\">\n    <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-close\"></mat-icon>\n  </button>\n</mat-toolbar>\n<form novalidate #form=\"ngForm\" >\n  <div [ngBusy]=\"loader\"></div>\n\n  <div mat-dialog-content fxLayout=\"column\" class=\"ft-busy-container\" style=\"min-height: 230px;\">\n    <div fxLayout=\"row\" fxLayoutGap=\"6px\" >\n      <fts-list-select fxFlex\n                       [(model)]=\"patient.title\"\n                       [config]=\"{key: 'value',\n                                   url: 'api/list/title',\n                                   cls:'list/title' }\"\n                       [label]=\"'shared.title'\"\n                        >\n      </fts-list-select>\n      <mat-form-field fxFlex>\n        <input matInput type=\"text\" required name=\"last_name\"\n              placeholder=\"{{'shared.last_name'|translate}}\"\n              [ftAutoFocus]=\"true\"\n              [(ngModel)]=\"patient.last_name\"\n              #last_name=\"ngModel\"\n              ftCustomValidation=\"patient.check_uniqueness\"\n              [query]=\"{field:'last_name',\n                         pk:patient?.id,\n                         first_name:patient?.first_name,\n                         last_name:patient?.last_name,\n                         national_id:patient?.national_id\n                       }\"\n               />\n        </mat-form-field>\n        <mat-form-field fxFlex>\n                    <input matInput  type=\"text\" required\n                           name=\"first_name\"\n                           placeholder=\"{{'shared.first_name'|translate}}\"\n                           [(ngModel)]=\"patient.first_name\"\n                           #first_name=\"ngModel\"\n                           ftCustomValidation=\"patient.check_uniqueness\"\n                           [query]=\"{field:'first_name',\n                                      pk:patient?.id,\n                                      first_name:patient?.first_name,\n                                      last_name:patient?.last_name,\n                                      national_id:patient?.national_id }\"\n                           />\n        </mat-form-field>\n    </div>\n    <div fxLayout=\"row\" fxLayoutGap=\"6px\" >\n        <mat-form-field fxFlex=\"nogrow\" >\n            <input matInput ftDate\n                   [matDatepicker]=\"b_date\"\n                   [placeholder]=\"'shared.birth_date'|translate\"\n                   [(ngModel)]=\"patient.birth_date\" name=\"b_date\">\n            <mat-datepicker-toggle matSuffix [for]=\"b_date\">\n              <mat-icon matDatepickerToggleIcon fontSet=\"mdi\" fontIcon=\"mdi-calendar-today\"></mat-icon>\n            </mat-datepicker-toggle>\n            <mat-datepicker #b_date></mat-datepicker>\n        </mat-form-field>\n        <mat-form-field floatLabel=\"always\" class=\"ft-radio-field\">\n          <input matInput placeholder=\"{{'shared.gender'|translate}}\" style=\"display: none\">\n          <mat-radio-group [(ngModel)]=\"patient.gender\" name=\"b_type\" fxLayout=\"row\" >\n            <mat-radio-button *ngFor=\"let b_type of ['M','F']\" [value]=\"b_type\">\n              {{b_type}}\n            </mat-radio-button>\n          </mat-radio-group>\n        </mat-form-field>\n    </div>\n    <hr class=\"ft-sep\">\n    <div fxLayout=\"row\" fxFlex fxLayoutGap=\"6px\">\n      <fts-list-select fxFlex\n                       [(model)]=\"patient.marital_status\"\n                       [config]=\"{key: 'value',\n                                   url: 'api/list/marital-status',\n                                   cls:'list/marital-status' }\"\n                       [label]=\"'common.list.marital_status'\"\n                        >\n      </fts-list-select>\n      <mat-form-field fxFlex  class=\"with-error-label\">\n          <input matInput type=\"text\"\n                name=\"national_id\"\n                placeholder=\"{{'patient.national_id'|translate}}\"\n                [(ngModel)]=\"patient.national_id\"\n                ftCustomValidation=\"patient.check_uniqueness\"\n                [query]=\"{field:'national_id',\n                    pk:patient?.id,\n                     first_name:patient?.first_name,\n                     last_name:patient?.last_name,\n                     national_id:patient?.national_id }\"\n                name=\"national_id\"\n                 #national_id=\"ngModel\"\n            />\n        </mat-form-field>\n        <mat-form-field fxFlex>\n          <input matInput type=\"text\"\n                 name=\"phone_numbers\"\n                 placeholder=\"{{'shared.phone_number'|translate}}\"\n                 [(ngModel)]=\"patient.contact_info.phone_numbers[0]\" />\n        </mat-form-field>\n\n    </div>\n     <div fxLayout=\"row\" fxFlex fxLayoutGap=\"6px\">\n       <mat-form-field fxFlex>\n              <textarea matInput\n                        [(ngModel)]=\"patient.address.content\"\n                        name=\"address\"\n                        [placeholder]=\"'shared.address'|translate\">\n              </textarea>\n        </mat-form-field>\n     </div>\n  </div>\n  <div mat-dialog-actions>\n    <span fxFlex></span>\n    <button type=\"button\" color=\"primary\" mat-raised-button tabindex=\"2\"\n            (click)=\"save()\" [disabled]=\"form.invalid\">\n      {{'shared.save'|translate}}\n    </button>\n    <button type=\"button\" [mat-dialog-close]=\"null\" color=\"warn\" mat-raised-button tabindex=\"-1\">\n      {{'shared.reset'|translate}}\n    </button>\n  </div>\n</form>\n\n" }]
        }], function () {
        return [{ type: i1.MatDialogRef }, { type: SharedService }, { type: undefined, decorators: [{
                        type: Inject,
                        args: [MAT_DIALOG_DATA]
                    }] }, { type: i1.MatDialog }];
    }, null);
})();

const PAYMENT_CONDITIONS = [
    { key: 'net_10_days', value: 10 },
    { key: 'net_30_days', value: 30 },
    { key: 'net_120_days', value: 120 },
    { key: 'net_60_days', value: 60 },
    { key: 'net_90_days', value: 90 },
    { key: 'end_of_month_the_10', value: 25 },
    { key: 'end_of_month_the_25', value: 40 },
    { key: '30_end_of_month', value: 45 },
    { key: '45_end_of_month', value: 60 },
    { key: '60_end_of_month', value: 75 },
    { key: '90_end_of_month', value: 105 },
    { key: '30_end_of_month_the_10', value: 55 },
    { key: '30_end_of_month_the_15', value: 60 },
    { key: '30_end_of_month_the_25', value: 70 },
    { key: '60_end_of_month_the_10', value: 85 },
    { key: '60_end_of_month_the_25', value: 100 },
    { key: '90_end_of_month_the_10', value: 115 }
];
const PAYMENT_MODE_TYPES = ['None', 'CASH', 'CHCK', 'CCCA', 'CCHK', 'CDAC', 'DDPO', 'DEBC'];

function OrganizationDialogComponent_mat_error_18_Template(rf, ctx) {
    if (rf & 1) {
        i0.ɵɵelement(0, "mat-error", 27);
    }
}
function OrganizationDialogComponent_mat_option_26_Template(rf, ctx) {
    if (rf & 1) {
        i0.ɵɵelementStart(0, "mat-option", 28);
        i0.ɵɵtext(1);
        i0.ɵɵpipe(2, "translate");
        i0.ɵɵelementEnd();
    }
    if (rf & 2) {
        const condition_r6 = ctx.$implicit;
        i0.ɵɵproperty("value", condition_r6);
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 2, "shared." + condition_r6.key), " ");
    }
}
function OrganizationDialogComponent_mat_error_34_Template(rf, ctx) {
    if (rf & 1) {
        i0.ɵɵelementStart(0, "mat-error");
        i0.ɵɵtext(1);
        i0.ɵɵpipe(2, "translate");
        i0.ɵɵelementEnd();
    }
    if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "shared.invalid_value"), " ");
    }
}
function OrganizationDialogComponent_mat_error_35_Template(rf, ctx) {
    if (rf & 1) {
        i0.ɵɵelementStart(0, "mat-error");
        i0.ɵɵtext(1);
        i0.ɵɵpipe(2, "translate");
        i0.ɵɵelementEnd();
    }
    if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "shared.is_required"), " ");
    }
}
const _c0$q = function (a1) { return { field: "name", pk: a1 }; };
class OrganizationDialogComponent {
    constructor(dialogRef, sharedService, dialog, data, translateService) {
        this.dialogRef = dialogRef;
        this.sharedService = sharedService;
        this.dialog = dialog;
        this.data = data;
        this.translateService = translateService;
        this.paymentConditions = PAYMENT_CONDITIONS;
        this.organization = {};
        this.separatorKeysCodes = [ENTER, COMMA];
        this.emailFormControl = new FormControl('', [
            Validators.required,
            Validators.email,
        ]);
        this.cls = 'organization';
        this.initData(data);
    }
    ngOnInit() {
        this.organization['phone_numbers'] = [];
    }
    initData(params) {
        /*if (_.get(params, 'id')) {
          this.loading =this.sharedService.getDocument( 'store/organization' ,  _.get(params, 'id')).subscribe(data => {
              this.organization = data;
            });
        }*/
    }
    save() {
        this.loading = this.sharedService.saveDocument('store/organization', this.organization).subscribe(data => {
            this.dialogRef.close(data);
        });
    }
    removePhoneItem(item) {
        const index = this.organization['phone_numbers'].indexOf(item);
        if (index >= 0) {
            this.organization['phone_numbers'].splice(index, 1);
        }
    }
    addPhoneItem(event) {
        const input = event.input;
        const value = event.value;
        if ((value || '').trim()) {
            this.organization['phone_numbers'].push(value.trim());
        }
        if (input) {
            input.value = '';
        }
    }
    compareCondition(o1, o2) {
        return o1 && o2 ? o1.key == o2.key : false;
    }
}
OrganizationDialogComponent.ɵfac = function OrganizationDialogComponent_Factory(t) { return new (t || OrganizationDialogComponent)(i0.ɵɵdirectiveInject(i1.MatDialogRef), i0.ɵɵdirectiveInject(SharedService), i0.ɵɵdirectiveInject(i1.MatDialog), i0.ɵɵdirectiveInject(MAT_DIALOG_DATA), i0.ɵɵdirectiveInject(i3$1.TranslateService)); };
OrganizationDialogComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: OrganizationDialogComponent, selectors: [["fts-organization-dialog"]], decls: 51, vars: 51, consts: [["color", "primary"], [1, "ft-module-icon"], ["fontSet", "mdi", "fontIcon", "mdi-brightness-7"], ["mat-dialog-title", ""], ["fxFlex", ""], ["type", "button", "mat-icon-button", "", "mat-dialog-close", "", "tabindex", "-1"], ["fontSet", "mdi", "fontIcon", "mdi-close"], ["fxLayout", "column", "fxFlex", ""], ["organizationForm", "ngForm"], ["mat-dialog-content", "", "fxLayout", "column", 1, "ft-busy-container", 2, "min-height", "230px"], [3, "ngBusy"], ["fxLayout", "row", "fxLayoutGap", "6px"], ["fxFlex", "", 1, "with-error-label"], ["required", "", "matInput", "", "name", "name", "ftCustomValidation", "organization.check_uniqueness", 3, "ngModel", "ftAutoFocus", "query", "placeholder", "ngModelChange"], ["name", "ngModel"], ["translate", "shared.already_exist", 4, "ngIf"], ["matInput", "", "name", "full_name", 3, "ngModel", "placeholder", "ngModelChange"], ["ftDefaultValues", "default_payment_condition", "name", "payment_condition", 3, "placeholder", "compareWith", "ngModel", "ngModelChange"], [3, "value", 4, "ngFor", "ngForOf"], ["matInput", "", "name", "accounting_code", 3, "ngModel", "placeholder", "ngModelChange"], ["matInput", "", "name", "email", "type", "email", "required", "", 3, "ngModel", "placeholder", "formControl", "ngModelChange"], [4, "ngIf"], ["matInput", "", "type", "text", "name", "phone_numbers", 3, "placeholder", "ngModel", "ngModelChange"], ["matInput", "", "name", "address", 3, "ngModel", "rows", "placeholder", "ngModelChange"], ["mat-dialog-actions", ""], ["type", "button", "color", "primary", "mat-raised-button", "", "tabindex", "2", 3, "disabled", "click"], ["type", "button", "color", "warn", "mat-raised-button", "", "tabindex", "-1", 3, "mat-dialog-close"], ["translate", "shared.already_exist"], [3, "value"]], template: function OrganizationDialogComponent_Template(rf, ctx) {
        if (rf & 1) {
            i0.ɵɵelementStart(0, "mat-toolbar", 0)(1, "div", 1);
            i0.ɵɵelement(2, "mat-icon", 2);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(3, "h2", 3);
            i0.ɵɵtext(4);
            i0.ɵɵpipe(5, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(6, "span", 4);
            i0.ɵɵelementStart(7, "button", 5);
            i0.ɵɵelement(8, "mat-icon", 6);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(9, "form", 7, 8)(11, "div", 9);
            i0.ɵɵelement(12, "div", 10);
            i0.ɵɵelementStart(13, "div", 11)(14, "mat-form-field", 12)(15, "input", 13, 14);
            i0.ɵɵlistener("ngModelChange", function OrganizationDialogComponent_Template_input_ngModelChange_15_listener($event) { return (ctx.organization["name"] = $event); });
            i0.ɵɵpipe(17, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(18, OrganizationDialogComponent_mat_error_18_Template, 1, 0, "mat-error", 15);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(19, "mat-form-field", 4)(20, "input", 16);
            i0.ɵɵlistener("ngModelChange", function OrganizationDialogComponent_Template_input_ngModelChange_20_listener($event) { return (ctx.organization["full_name"] = $event); });
            i0.ɵɵpipe(21, "translate");
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(22, "div", 11)(23, "mat-form-field", 4)(24, "mat-select", 17);
            i0.ɵɵlistener("ngModelChange", function OrganizationDialogComponent_Template_mat_select_ngModelChange_24_listener($event) { return ctx.organization.payment_condition = $event; });
            i0.ɵɵpipe(25, "translate");
            i0.ɵɵtemplate(26, OrganizationDialogComponent_mat_option_26_Template, 3, 4, "mat-option", 18);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(27, "mat-form-field", 4)(28, "input", 19);
            i0.ɵɵlistener("ngModelChange", function OrganizationDialogComponent_Template_input_ngModelChange_28_listener($event) { return (ctx.organization["accounting_code"] = $event); });
            i0.ɵɵpipe(29, "translate");
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(30, "div", 11)(31, "mat-form-field", 12)(32, "input", 20);
            i0.ɵɵlistener("ngModelChange", function OrganizationDialogComponent_Template_input_ngModelChange_32_listener($event) { return (ctx.organization["email"] = $event); });
            i0.ɵɵpipe(33, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(34, OrganizationDialogComponent_mat_error_34_Template, 3, 3, "mat-error", 21);
            i0.ɵɵtemplate(35, OrganizationDialogComponent_mat_error_35_Template, 3, 3, "mat-error", 21);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(36, "mat-form-field", 4)(37, "input", 22);
            i0.ɵɵlistener("ngModelChange", function OrganizationDialogComponent_Template_input_ngModelChange_37_listener($event) { return (ctx.organization.phone_numbers[0] = $event); });
            i0.ɵɵpipe(38, "translate");
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(39, "div", 11)(40, "mat-form-field", 4)(41, "textarea", 23);
            i0.ɵɵlistener("ngModelChange", function OrganizationDialogComponent_Template_textarea_ngModelChange_41_listener($event) { return (ctx.organization["address"] = $event); });
            i0.ɵɵpipe(42, "translate");
            i0.ɵɵelementEnd()()()();
            i0.ɵɵelementStart(43, "div", 24);
            i0.ɵɵelement(44, "span", 4);
            i0.ɵɵelementStart(45, "button", 25);
            i0.ɵɵlistener("click", function OrganizationDialogComponent_Template_button_click_45_listener() { return ctx.save(); });
            i0.ɵɵtext(46);
            i0.ɵɵpipe(47, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(48, "button", 26);
            i0.ɵɵtext(49);
            i0.ɵɵpipe(50, "translate");
            i0.ɵɵelementEnd()()();
        }
        if (rf & 2) {
            const _r0 = i0.ɵɵreference(10);
            const _r1 = i0.ɵɵreference(16);
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(5, 29, "shared.organization_file"));
            i0.ɵɵadvance(8);
            i0.ɵɵproperty("ngBusy", ctx.loading);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngModel", ctx.organization["name"])("ftAutoFocus", true)("query", i0.ɵɵpureFunction1(49, _c0$q, ctx.organization == null ? null : ctx.organization.id))("placeholder", i0.ɵɵpipeBind1(17, 31, "shared.name"));
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngIf", _r1 == null ? null : _r1.errors == null ? null : _r1.errors.exists);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngModel", ctx.organization["full_name"])("placeholder", i0.ɵɵpipeBind1(21, 33, "shared.full_name"));
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(25, 35, "shared.payment_condition"))("compareWith", ctx.compareCondition)("ngModel", ctx.organization.payment_condition);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngForOf", ctx.paymentConditions);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngModel", ctx.organization["accounting_code"])("placeholder", i0.ɵɵpipeBind1(29, 37, "shared.accounting_code"));
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngModel", ctx.organization["email"])("placeholder", i0.ɵɵpipeBind1(33, 39, "shared.email"))("formControl", ctx.emailFormControl);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.emailFormControl.hasError("email") && !ctx.emailFormControl.hasError("required"));
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.emailFormControl.hasError("required"));
            i0.ɵɵadvance(2);
            i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(38, 41, "shared.phone_number"));
            i0.ɵɵproperty("ngModel", ctx.organization.phone_numbers[0]);
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngModel", ctx.organization["address"])("rows", 1)("placeholder", i0.ɵɵpipeBind1(42, 43, "shared.address"));
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("disabled", _r0.invalid);
            i0.ɵɵadvance(1);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(47, 45, "shared.save"), " ");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("mat-dialog-close", null);
            i0.ɵɵadvance(1);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(50, 47, "shared.reset"), " ");
        }
    }, dependencies: [i4$1.NgForOf, i4$1.NgIf, i5.MatOption, i6.MatButton, i1.MatDialogClose, i1.MatDialogTitle, i1.MatDialogContent, i1.MatDialogActions, i9.MatIcon, i10.MatError, i10.MatFormField, i11$1.MatInput, i15.MatSelect, i11.MatToolbar, i8.DefaultLayoutDirective, i8.DefaultLayoutGapDirective, i8.DefaultFlexDirective, i3$1.TranslateDirective, i16.ɵNgNoValidate, i16.DefaultValueAccessor, i16.NgControlStatus, i16.NgControlStatusGroup, i16.RequiredValidator, i16.NgModel, i16.NgForm, i12.NgBusyDirective, i2.InputDirective, i2.AutoFocusDirective, i2.DefaultValuesDirective, i2.CustomValidationDirective, i16.FormControlDirective, i3$1.TranslatePipe], styles: [".ft-chip-list[_ngcontent-%COMP%]     .mat-chip{height:24px}.ft-chip-list[_ngcontent-%COMP%]     .mat-icon{display:inline-table}ft-body-table[_ngcontent-%COMP%]     .ft-action-cell-2.cdk-cell .mat-icon-button.default{color:#20b2aa}  .hide-icon .mat-icon{display:none}"] });
(function () {
    (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OrganizationDialogComponent, [{
            type: Component,
            args: [{ selector: 'fts-organization-dialog', template: "  <mat-toolbar color=\"primary\">\n    <div class=\"ft-module-icon\">\n      <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-brightness-7\"></mat-icon>\n    </div>\n    <h2 mat-dialog-title>{{ 'shared.organization_file' | translate }}</h2>\n    <span fxFlex></span>\n    <button type=\"button\" mat-icon-button mat-dialog-close tabindex=\"-1\">\n      <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-close\"></mat-icon>\n    </button>\n  </mat-toolbar>\n\n    <form #organizationForm=\"ngForm\" fxLayout=\"column\" fxFlex>\n\n  <div mat-dialog-content fxLayout=\"column\" class=\"ft-busy-container\" style=\"min-height: 230px;\">\n       <div [ngBusy]=\"loading\"></div>\n      <div fxLayout=\"row\" fxLayoutGap=\"6px\">\n        <mat-form-field fxFlex class=\"with-error-label\">\n          <input required matInput\n                 [(ngModel)]=\"organization['name']\"\n                 name=\"name\"\n                 [ftAutoFocus]=\"true\"\n                 #name=\"ngModel\"\n                 ftCustomValidation=\"organization.check_uniqueness\"\n                 [query]=\"{field:'name', pk:organization?.id}\"\n                 [placeholder]=\"'shared.name'|translate\">\n          <mat-error *ngIf=\"name?.errors?.exists\" translate=\"shared.already_exist\"></mat-error>\n        </mat-form-field>\n        <mat-form-field fxFlex>\n          <input matInput [(ngModel)]=\"organization['full_name']\" name=\"full_name\"\n                 [placeholder]=\"'shared.full_name'|translate\">\n        </mat-form-field>\n      </div>\n      <div fxLayout=\"row\" fxLayoutGap=\"6px\">\n          <mat-form-field fxFlex>\n            <mat-select [placeholder]=\"'shared.payment_condition' | translate\"\n                        [compareWith]=\"compareCondition\"\n                        ftDefaultValues=\"default_payment_condition\"\n                        [(ngModel)]=\"organization.payment_condition\"\n                        name=\"payment_condition\">\n              <mat-option *ngFor=\"let condition of paymentConditions\" [value]=\"condition\">\n                {{'shared.'+condition.key|translate}}\n              </mat-option>\n            </mat-select>\n          </mat-form-field>\n          <mat-form-field fxFlex>\n            <input matInput [(ngModel)]=\"organization['accounting_code']\"\n                   name=\"accounting_code\"\n                   [placeholder]=\"'shared.accounting_code'|translate\">\n          </mat-form-field>\n      </div>\n      <div fxLayout=\"row\" fxLayoutGap=\"6px\">\n          <mat-form-field fxFlex class=\"with-error-label\">\n                  <input matInput [(ngModel)]=\"organization['email']\"\n                         name=\"email\"\n                         type=\"email\" required\n                         [placeholder]=\"'shared.email'|translate\"\n                         [formControl]=\"emailFormControl\">\n                  <mat-error *ngIf=\"emailFormControl.hasError('email') && !emailFormControl.hasError('required')\">\n                    {{'shared.invalid_value'|translate}}\n                  </mat-error>\n                  <mat-error *ngIf=\"emailFormControl.hasError('required')\">\n                    {{'shared.is_required'|translate}}\n                  </mat-error>\n                </mat-form-field>\n\n            <mat-form-field fxFlex>\n              <input matInput type=\"text\"\n                     name=\"phone_numbers\"\n                     placeholder=\"{{'shared.phone_number'|translate}}\"\n                     [(ngModel)]=\"organization.phone_numbers[0]\" />\n            </mat-form-field>\n      </div>\n       <div fxLayout=\"row\" fxLayoutGap=\"6px\">\n          <mat-form-field fxFlex >\n            <textarea matInput [(ngModel)]=\"organization['address']\" name=\"address\" [rows]=\"1\"\n                    [placeholder]=\"'shared.address'|translate\"></textarea>\n          </mat-form-field>\n      </div>\n\n  </div>\n  <div mat-dialog-actions>\n    <span fxFlex></span>\n    <button type=\"button\" color=\"primary\" mat-raised-button tabindex=\"2\" (click)=\"save()\" [disabled]=\"organizationForm.invalid\">\n      {{'shared.save'|translate}}\n    </button>\n    <button type=\"button\" [mat-dialog-close]=\"null\" color=\"warn\" mat-raised-button tabindex=\"-1\">\n      {{'shared.reset'|translate}}\n    </button>\n  </div>\n   </form>\n\n", styles: [".ft-chip-list ::ng-deep .mat-chip{height:24px}.ft-chip-list ::ng-deep .mat-icon{display:inline-table}ft-body-table ::ng-deep .ft-action-cell-2.cdk-cell .mat-icon-button.default{color:#20b2aa}::ng-deep .hide-icon .mat-icon{display:none}\n"] }]
        }], function () {
        return [{ type: i1.MatDialogRef }, { type: SharedService }, { type: i1.MatDialog }, { type: undefined, decorators: [{
                        type: Inject,
                        args: [MAT_DIALOG_DATA]
                    }] }, { type: i3$1.TranslateService }];
    }, null);
})();

class AlertDialogComponent {
    constructor(dialogRef, data) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.message_text = 'message text is missing';
        this.message_text = _.get(data, 'message_text', this.message_text);
    }
    ngOnInit() {
    }
}
AlertDialogComponent.ɵfac = function AlertDialogComponent_Factory(t) { return new (t || AlertDialogComponent)(i0.ɵɵdirectiveInject(i1.MatDialogRef), i0.ɵɵdirectiveInject(MAT_DIALOG_DATA)); };
AlertDialogComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AlertDialogComponent, selectors: [["ftb-alert-dialog"]], decls: 11, vars: 7, consts: [["mat-dialog-content", "", 1, "ft-content"], ["fxLayout", "row", "fxLayoutGap", "6px"], [1, "confirm-modal-text"], ["fxLayout", "row", "fxLayoutAlign", "center center"], ["fxFlex", ""], ["type", "button", "mat-button", "", "color", "primary", 3, "mat-dialog-close"]], template: function AlertDialogComponent_Template(rf, ctx) {
        if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "p", 2);
            i0.ɵɵtext(3);
            i0.ɵɵpipe(4, "translate");
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(5, "mat-dialog-actions", 3);
            i0.ɵɵelement(6, "span", 4);
            i0.ɵɵelementStart(7, "button", 5)(8, "span");
            i0.ɵɵtext(9);
            i0.ɵɵpipe(10, "translate");
            i0.ɵɵelementEnd()()();
        }
        if (rf & 2) {
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 3, ctx.message_text));
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("mat-dialog-close", true);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(10, 5, "shared.yes"));
        }
    }, dependencies: [i6.MatButton, i1.MatDialogClose, i1.MatDialogContent, i1.MatDialogActions, i8.DefaultLayoutDirective, i8.DefaultLayoutGapDirective, i8.DefaultLayoutAlignDirective, i8.DefaultFlexDirective, i3$1.TranslatePipe], styles: [".confirm-modal-text[_ngcontent-%COMP%]{font-size:14px;text-align:center}"] });
(function () {
    (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AlertDialogComponent, [{
            type: Component,
            args: [{ selector: 'ftb-alert-dialog', template: "<div mat-dialog-content class=\"ft-content\">\n  <div fxLayout=\"row\" fxLayoutGap=\"6px\"  >\n    <p class=\"confirm-modal-text\">{{message_text | translate}}</p>\n  </div>\n</div>\n\n<mat-dialog-actions fxLayout=\"row\" fxLayoutAlign=\"center center\">\n  <span fxFlex></span>\n  <button type=\"button\" mat-button color=\"primary\"   [mat-dialog-close]=\"true\">\n    <span>{{'shared.yes' | translate}}</span>\n  </button>\n</mat-dialog-actions>\n", styles: [".confirm-modal-text{font-size:14px;text-align:center}\n"] }]
        }], function () {
        return [{ type: i1.MatDialogRef }, { type: undefined, decorators: [{
                        type: Inject,
                        args: [MAT_DIALOG_DATA]
                    }] }];
    }, null);
})();

function DocumentActionsComponent_ng_template_1_button_0_Template(rf, ctx) {
    if (rf & 1) {
        const _r9 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "button", 7);
        i0.ɵɵlistener("click", function DocumentActionsComponent_ng_template_1_button_0_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r9); const ctx_r8 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r8.remove()); });
        i0.ɵɵelement(1, "mat-icon", 8);
        i0.ɵɵelementEnd();
    }
    if (rf & 2) {
        i0.ɵɵproperty("@heightAnimation", undefined);
    }
}
function DocumentActionsComponent_ng_template_1_Template(rf, ctx) {
    if (rf & 1) {
        i0.ɵɵtemplate(0, DocumentActionsComponent_ng_template_1_button_0_Template, 2, 1, "button", 6);
    }
    if (rf & 2) {
        const ctx_r0 = i0.ɵɵnextContext();
        i0.ɵɵproperty("ngIf", (ctx_r0.model == null ? null : ctx_r0.model.id) && !(ctx_r0.model == null ? null : ctx_r0.model.state == null ? null : ctx_r0.model.state.is_valid));
    }
}
const _c0$p = function (a0, a1, a2) { return { group: a0, view: a1, model: a2 }; };
function DocumentActionsComponent_button_2_Template(rf, ctx) {
    if (rf & 1) {
        const _r11 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "button", 9);
        i0.ɵɵlistener("click", function DocumentActionsComponent_button_2_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r11); const ctx_r10 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r10.print()); })("prePrint", function DocumentActionsComponent_button_2_Template_button_prePrint_0_listener() { i0.ɵɵrestoreView(_r11); const ctx_r12 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r12.prePrint()); });
        i0.ɵɵelement(1, "mat-icon", 10);
        i0.ɵɵelementEnd();
    }
    if (rf & 2) {
        const ctx_r1 = i0.ɵɵnextContext();
        i0.ɵɵproperty("disabled", !(ctx_r1.model == null ? null : ctx_r1.model.state == null ? null : ctx_r1.model.state.is_valid))("ftPrint", i0.ɵɵpureFunction3(2, _c0$p, ctx_r1.resource, ctx_r1.getPrintUrl(), ctx_r1.model == null ? null : ctx_r1.model.id));
    }
}
const _c1$i = function (a0, a1, a3) { return { group: a0, view: a1, type: "pdf", model: a3 }; };
function DocumentActionsComponent_button_3_Template(rf, ctx) {
    if (rf & 1) {
        const _r14 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "button", 9);
        i0.ɵɵlistener("click", function DocumentActionsComponent_button_3_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r14); const ctx_r13 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r13.print()); })("prePrint", function DocumentActionsComponent_button_3_Template_button_prePrint_0_listener() { i0.ɵɵrestoreView(_r14); const ctx_r15 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r15.prePrint()); });
        i0.ɵɵelement(1, "mat-icon", 11);
        i0.ɵɵelementEnd();
    }
    if (rf & 2) {
        const ctx_r2 = i0.ɵɵnextContext();
        i0.ɵɵproperty("disabled", !(ctx_r2.model == null ? null : ctx_r2.model.state == null ? null : ctx_r2.model.state.is_valid))("ftPrint", i0.ɵɵpureFunction3(2, _c1$i, ctx_r2.resource, ctx_r2.getPrintUrl(), ctx_r2.model == null ? null : ctx_r2.model.id));
    }
}
function DocumentActionsComponent_ng_template_9_button_0_Template(rf, ctx) {
    if (rf & 1) {
        const _r18 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "button", 13);
        i0.ɵɵlistener("click", function DocumentActionsComponent_ng_template_9_button_0_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r18); const ctx_r17 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r17.invalidate()); });
        i0.ɵɵelement(1, "mat-icon", 14);
        i0.ɵɵelementStart(2, "span");
        i0.ɵɵtext(3);
        i0.ɵɵpipe(4, "translate");
        i0.ɵɵelementEnd()();
    }
    if (rf & 2) {
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 1, "shared.invalidate"));
    }
}
function DocumentActionsComponent_ng_template_9_Template(rf, ctx) {
    if (rf & 1) {
        i0.ɵɵtemplate(0, DocumentActionsComponent_ng_template_9_button_0_Template, 5, 3, "button", 12);
    }
    if (rf & 2) {
        const ctx_r3 = i0.ɵɵnextContext();
        i0.ɵɵproperty("ngIf", (ctx_r3.model == null ? null : ctx_r3.model.id) && (ctx_r3.model == null ? null : ctx_r3.model.state == null ? null : ctx_r3.model.state.is_valid));
    }
}
function DocumentActionsComponent_ng_template_10_button_0_Template(rf, ctx) {
    if (rf & 1) {
        const _r21 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "button", 16);
        i0.ɵɵlistener("click", function DocumentActionsComponent_ng_template_10_button_0_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r21); const ctx_r20 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r20.validate()); });
        i0.ɵɵelement(1, "mat-icon", 17);
        i0.ɵɵelementStart(2, "span");
        i0.ɵɵtext(3);
        i0.ɵɵpipe(4, "translate");
        i0.ɵɵelementEnd()();
    }
    if (rf & 2) {
        const ctx_r19 = i0.ɵɵnextContext(2);
        i0.ɵɵproperty("disabled", ctx_r19.formInvalid || ctx_r19.lockValidate() || ctx_r19.disableValidate);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 2, "shared.validate"));
    }
}
function DocumentActionsComponent_ng_template_10_Template(rf, ctx) {
    if (rf & 1) {
        i0.ɵɵtemplate(0, DocumentActionsComponent_ng_template_10_button_0_Template, 5, 4, "button", 15);
    }
    if (rf & 2) {
        const ctx_r4 = i0.ɵɵnextContext();
        i0.ɵɵproperty("ngIf", !(ctx_r4.model == null ? null : ctx_r4.model.state == null ? null : ctx_r4.model.state.is_valid));
    }
}
function DocumentActionsComponent_button_11_Template(rf, ctx) {
    if (rf & 1) {
        const _r23 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "button", 18);
        i0.ɵɵlistener("click", function DocumentActionsComponent_button_11_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r23); const ctx_r22 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r22.save(true)); });
        i0.ɵɵelementStart(1, "span");
        i0.ɵɵtext(2);
        i0.ɵɵpipe(3, "translate");
        i0.ɵɵelementEnd()();
    }
    if (rf & 2) {
        const ctx_r5 = i0.ɵɵnextContext();
        i0.ɵɵproperty("disabled", ctx_r5.formInvalid);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 2, "shared.save_exit"));
    }
}
function DocumentActionsComponent_button_12_Template(rf, ctx) {
    if (rf & 1) {
        const _r25 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "button", 18);
        i0.ɵɵlistener("click", function DocumentActionsComponent_button_12_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r25); const ctx_r24 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r24.save()); });
        i0.ɵɵelementStart(1, "span");
        i0.ɵɵtext(2);
        i0.ɵɵpipe(3, "translate");
        i0.ɵɵelementEnd()();
    }
    if (rf & 2) {
        const ctx_r6 = i0.ɵɵnextContext();
        i0.ɵɵproperty("disabled", ctx_r6.formInvalid);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 2, "shared.save"));
    }
}
const _c2$c = function (a0) { return { resource: a0, action: "delete", behavior: "remove" }; };
const _c3$1 = function (a0) { return { resource: a0, action: "invalidate", behavior: "remove" }; };
const _c4$1 = function (a0) { return { resource: a0, action: "validate", behavior: "remove" }; };
class DocumentActionsComponent {
    constructor(sharedService, router, route, dialog, sharedModulesService, translateService, snackBar) {
        this.sharedService = sharedService;
        this.router = router;
        this.route = route;
        this.dialog = dialog;
        this.sharedModulesService = sharedModulesService;
        this.translateService = translateService;
        this.snackBar = snackBar;
        this.autoValidate = false;
        this.autoInvalidate = false;
        this._formInvalid = new BehaviorSubject(false);
        this.preventSave = false;
        this.busy = null;
        this.model = null;
        this.movementType = null;
        this.disableValidate = false;
        this.modelChange = new EventEmitter();
        this.busyChange = new EventEmitter();
    }
    set currentModel(value) {
        this.model = value;
    }
    set handleMovementType(value) {
        this.movementType = value;
    }
    set handleDisableValidate(value) {
        this.disableValidate = value;
    }
    set formInvalid(value) {
        this._formInvalid.next(value);
    }
    get formInvalid() {
        return this._formInvalid.getValue();
    }
    set handleSubscription(value) {
        this.busy = value;
    }
    ngOnInit() {
    }
    save(with_exit) {
        if (!this.preventSave) {
            this.preventSave = true;
            if (!isNil(this.loadedObject)) {
                this.sharedService.loadDocument(this.resource, this.loadedObject).subscribe(data => {
                    this.handleSave(with_exit, data);
                });
            }
            else {
                this.handleSave(with_exit);
            }
        }
    }
    handleSave(with_exit, load_data) {
        this.busy = this.sharedService.saveDocument(this.cls, this.model, load_data ? this.loadedObject : null).subscribe(data => {
            if (data) {
                this.saveSuccess(data, with_exit);
                this.preventSave = false;
            }
        }, error => {
            this.preventSave = false;
        });
        this.busyChange.emit(this.busy);
    }
    saveSuccess(data, with_exit) {
        this.model = data;
        if (with_exit) {
            this.router.navigate([handleRoute(this.sharedModulesService.pathName, this.routes['list'])]);
        }
        else {
            this.modelChange.emit(data);
            this.router.navigate([handleRoute(this.sharedModulesService.pathName, this.routes['form']), get(this.model, 'id')], { replaceUrl: true });
        }
    }
    remove() {
        if (!get(this.model.state, 'is_valid')) {
            this.sharedService.deleteDocument(this.cls, this.model.id).subscribe((data) => {
                this.router.navigate([handleRoute(this.sharedModulesService.pathName, this.routes['list'])]);
            });
        }
        else {
            this.snackBar.open(this.translateService.instant('shared.impossible_valid_document_delete'), null, {
                duration: 2500,
                verticalPosition: "top",
                horizontalPosition: "right"
            });
        }
    }
    exit() {
        this.router.navigate([handleRoute(this.sharedModulesService.pathName, this.routes['list'])]);
    }
    validate() {
        if (!get(this.model, 'state.is_valid', false)) {
            if (!this.preventSave) {
                this.preventSave = true;
                if (!isNil(this.loadedObject)) {
                    this.sharedService.loadDocument(this.resource, this.loadedObject).subscribe(data => {
                        this.performValidate(data);
                    });
                }
                else {
                    this.performValidate();
                }
            }
        }
    }
    performValidate(load_data) {
        this.sharedService.saveDocument(this.cls, this.model, load_data ? this.loadedObject : null).subscribe(data => {
            if (data) {
                this.model = data;
                this.handleValidate();
            }
        });
    }
    handleValidate() {
        this.busy = this.handleValidateFunction().subscribe(data => {
            this.preventSave = false;
            if (data) {
                this.saveSuccess(data, false);
            }
            else {
                this.dialog.open(AlertDialogComponent, assign(SMALL_DIALOG, { data: { message_text: 'shared.validate_object_failed' } }));
            }
        });
        this.busyChange.emit(this.busy);
    }
    handleValidateFunction() {
        if (this.autoValidate) {
            this.model.state.is_valid = true;
            return this.sharedService.saveDocument(this.cls, this.model, null);
        }
        else {
            return this.sharedService.validateDocument(this.resource, get(this.model, 'id'), this.movementType);
        }
    }
    invalidate() {
        if (get(this.model.state, 'is_valid')) {
            this.preventSave = true;
            this.busy = this.handleInvalidateFunction().subscribe(data => {
                this.preventSave = false;
                if (data) {
                    this.model = data;
                    this.modelChange.emit(data);
                }
                else {
                    this.dialog.open(AlertDialogComponent, assign(SMALL_DIALOG, { data: { message_text: 'shared.invalidate_object_failed' } }));
                }
            });
            this.busyChange.emit(this.busy);
        }
    }
    handleInvalidateFunction() {
        if (this.autoInvalidate) {
            this.model.state.is_valid = false;
            return this.sharedService.saveDocument(this.cls, this.model, null);
        }
        else {
            return this.sharedService.invalidateDocument(this.resource, get(this.model, 'id'), this.movementType);
        }
    }
    print() {
    }
    prePrint() {
    }
    getPrintUrl() {
        return `api/${this.cls}`;
    }
    share() {
    }
    lockValidate() {
        if (!this.autoValidate) {
            return get(this.model, 'lines', []).length == 0
                || (chain(this.model).get('lines', []).find((e) => {
                    return get(e, 'article.has_serial') && size(e.serials_list) != get(e, 'qte');
                }).value())
                || (chain(this.model).get('lines', []).find((e) => {
                    return get(e, 'article.has_lot_number') && chain(e).get('lots_list').sumBy('store_qte').value() != get(e, 'qte');
                }).value())
                || (includes(['ASSEMBLY', 'DISASSEMBLING'], this.movementType) &&
                    ((get(this.model.article, 'has_serial') && size(this.model.serials_list) != get(this.model, 'qte', 0))
                        ||
                            (get(this.model.article, 'has_lot_number') && sumBy(this.model.lots_list, 'store_qte') != get(this.model, 'qte', 0))));
        }
        else {
            return get(this.model, 'lines', []).length == 0;
        }
    }
}
DocumentActionsComponent.ɵfac = function DocumentActionsComponent_Factory(t) { return new (t || DocumentActionsComponent)(i0.ɵɵdirectiveInject(SharedService), i0.ɵɵdirectiveInject(i3.Router), i0.ɵɵdirectiveInject(i3.ActivatedRoute), i0.ɵɵdirectiveInject(i1.MatDialog), i0.ɵɵdirectiveInject(SharedModulesService), i0.ɵɵdirectiveInject(i3$1.TranslateService), i0.ɵɵdirectiveInject(i1$2.MatSnackBar)); };
DocumentActionsComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DocumentActionsComponent, selectors: [["fts-document-actions"]], inputs: { loadedObject: "loadedObject", cls: "cls", resource: "resource", routes: "routes", printGroup: "printGroup", autoValidate: "autoValidate", autoInvalidate: "autoInvalidate", currentModel: ["model", "currentModel"], handleMovementType: ["movementType", "handleMovementType"], handleDisableValidate: ["disableValidate", "handleDisableValidate"], formInvalid: "formInvalid", handleSubscription: ["busy", "handleSubscription"] }, outputs: { modelChange: "modelChange", busyChange: "busyChange" }, decls: 13, vars: 16, consts: [["fxFlex", "noshrink", 1, "ft-actions"], [3, "ftAcl"], ["type", "button", "mat-mini-fab", "", "color", "primary", 3, "disabled", "ftPrint", "click", "prePrint", 4, "ngIf"], ["fxFlex", ""], ["type", "button", "mat-raised-button", "", "color", "warn", 3, "click"], ["type", "button", "mat-raised-button", "", "color", "primary", 3, "disabled", "click", 4, "ngIf"], ["type", "button", "mat-mini-fab", "", "color", "warn", 3, "click", 4, "ngIf"], ["type", "button", "mat-mini-fab", "", "color", "warn", 3, "click"], ["fontSet", "mdi", "fontIcon", "mdi-delete"], ["type", "button", "mat-mini-fab", "", "color", "primary", 3, "disabled", "ftPrint", "click", "prePrint"], ["fontSet", "mdi", "fontIcon", "mdi-printer"], ["fontSet", "mdi", "fontIcon", "mdi-file-pdf"], ["type", "button", "mat-raised-button", "", "color", "warn", "class", "has-icon", 3, "click", 4, "ngIf"], ["type", "button", "mat-raised-button", "", "color", "warn", 1, "has-icon", 3, "click"], ["fontSet", "mdi", "fontIcon", "mdi-lock-open-outline"], ["type", "button", "mat-raised-button", "", "class", "has-icon success-button", 3, "disabled", "click", 4, "ngIf"], ["type", "button", "mat-raised-button", "", 1, "has-icon", "success-button", 3, "disabled", "click"], ["fontSet", "mdi", "fontIcon", "mdi-lock-outline"], ["type", "button", "mat-raised-button", "", "color", "primary", 3, "disabled", "click"]], template: function DocumentActionsComponent_Template(rf, ctx) {
        if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtemplate(1, DocumentActionsComponent_ng_template_1_Template, 1, 1, "ng-template", 1);
            i0.ɵɵtemplate(2, DocumentActionsComponent_button_2_Template, 2, 6, "button", 2);
            i0.ɵɵtemplate(3, DocumentActionsComponent_button_3_Template, 2, 6, "button", 2);
            i0.ɵɵelement(4, "span", 3);
            i0.ɵɵelementStart(5, "button", 4);
            i0.ɵɵlistener("click", function DocumentActionsComponent_Template_button_click_5_listener() { return ctx.exit(); });
            i0.ɵɵelementStart(6, "span");
            i0.ɵɵtext(7);
            i0.ɵɵpipe(8, "translate");
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(9, DocumentActionsComponent_ng_template_9_Template, 1, 1, "ng-template", 1);
            i0.ɵɵtemplate(10, DocumentActionsComponent_ng_template_10_Template, 1, 1, "ng-template", 1);
            i0.ɵɵtemplate(11, DocumentActionsComponent_button_11_Template, 4, 4, "button", 5);
            i0.ɵɵtemplate(12, DocumentActionsComponent_button_12_Template, 4, 4, "button", 5);
            i0.ɵɵelementEnd();
        }
        if (rf & 2) {
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ftAcl", i0.ɵɵpureFunction1(10, _c2$c, ctx.resource));
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.model == null ? null : ctx.model.id);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.model == null ? null : ctx.model.id);
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(8, 8, "shared.exit"));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ftAcl", i0.ɵɵpureFunction1(12, _c3$1, ctx.resource));
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ftAcl", i0.ɵɵpureFunction1(14, _c4$1, ctx.resource));
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", !(ctx.model == null ? null : ctx.model.state == null ? null : ctx.model.state.is_valid));
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", !(ctx.model == null ? null : ctx.model.state == null ? null : ctx.model.state.is_valid));
        }
    }, dependencies: [i4$1.NgIf, i6.MatButton, i9.MatIcon, i8.DefaultFlexDirective, i2.AclDirective, i2.PrintDirective, i3$1.TranslatePipe], data: { animation: [
            SCALE_ANIMATION,
            HEIGHT_ANIMATION
        ] } });
(function () {
    (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DocumentActionsComponent, [{
            type: Component,
            args: [{ selector: 'fts-document-actions', animations: [
                        SCALE_ANIMATION,
                        HEIGHT_ANIMATION
                    ], template: "<div class=\"ft-actions\" fxFlex=\"noshrink\">\n  <ng-template  [ftAcl]=\"{resource: resource, action: 'delete', behavior: 'remove'}\">\n    <button type=\"button\" *ngIf=\"model?.id && !model?.state?.is_valid\" (click)=\"remove()\" mat-mini-fab color=\"warn\"\n            [@heightAnimation]   >\n      <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-delete\"></mat-icon>\n    </button>\n  </ng-template>\n  <button type=\"button\" *ngIf=\"model?.id\" mat-mini-fab color=\"primary\" (click)=\"print()\"\n          (prePrint)=\"prePrint()\" [disabled]=\"!model?.state?.is_valid\"\n          [ftPrint]=\"{group:resource, view:getPrintUrl(),  model:model?.id}\">\n    <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-printer\"></mat-icon>\n  </button>\n  <button type=\"button\" *ngIf=\"model?.id\" mat-mini-fab color=\"primary\" (click)=\"print()\"\n          (prePrint)=\"prePrint()\" [disabled]=\"!model?.state?.is_valid\"\n          [ftPrint]=\"{group:resource, view:getPrintUrl(),type:'pdf',  model:model?.id}\">\n    <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-file-pdf\"></mat-icon>\n  </button>\n  <span fxFlex></span>\n  <!--*ngIf=\"!model?.state?.is_valid\" removed by demande -->\n  <button type=\"button\" mat-raised-button color=\"warn\" (click)=\"exit()\">\n    <span>{{'shared.exit'|translate}}</span>\n  </button>\n  <ng-template [ftAcl]=\"{resource: resource, action: 'invalidate', behavior: 'remove'}\">\n    <button type=\"button\" mat-raised-button color=\"warn\" class=\"has-icon\" *ngIf=\"model?.id && model?.state?.is_valid\"\n            (click)=\"invalidate()\">\n      <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-lock-open-outline\"></mat-icon>\n      <span>{{'shared.invalidate'|translate}}</span>\n    </button>\n  </ng-template>\n  <ng-template [ftAcl]=\"{resource: resource, action: 'validate', behavior: 'remove'}\">\n    <button type=\"button\" mat-raised-button  class=\"has-icon success-button\" *ngIf=\"!model?.state?.is_valid\"\n            [disabled]=\"formInvalid ||lockValidate() || disableValidate\"\n            (click)=\"validate()\">\n      <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-lock-outline\"></mat-icon>\n      <span>{{'shared.validate'|translate}}</span>\n    </button>\n  </ng-template>\n\n  <button type=\"button\" *ngIf=\"!model?.state?.is_valid\" mat-raised-button color=\"primary\" (click)=\"save(true)\"\n          [disabled]=\"formInvalid\">\n    <span>{{'shared.save_exit'|translate}}</span>\n  </button>\n  <button type=\"button\" *ngIf=\"!model?.state?.is_valid\" mat-raised-button color=\"primary\" (click)=\"save()\"\n          [disabled]=\"formInvalid\">\n    <span>{{'shared.save'|translate}}</span>\n  </button>\n</div>\n" }]
        }], function () { return [{ type: SharedService }, { type: i3.Router }, { type: i3.ActivatedRoute }, { type: i1.MatDialog }, { type: SharedModulesService }, { type: i3$1.TranslateService }, { type: i1$2.MatSnackBar }]; }, { loadedObject: [{
                type: Input
            }], cls: [{
                type: Input
            }], resource: [{
                type: Input
            }], routes: [{
                type: Input
            }], printGroup: [{
                type: Input
            }], autoValidate: [{
                type: Input
            }], autoInvalidate: [{
                type: Input
            }], currentModel: [{
                type: Input,
                args: ['model']
            }], handleMovementType: [{
                type: Input,
                args: ['movementType']
            }], handleDisableValidate: [{
                type: Input,
                args: ['disableValidate']
            }], modelChange: [{
                type: Output
            }], formInvalid: [{
                type: Input
            }], handleSubscription: [{
                type: Input,
                args: ['busy']
            }], busyChange: [{
                type: Output
            }] });
})();

function LinesDialogComponent_mat_tab_group_9_mat_tab_1_Template(rf, ctx) {
    if (rf & 1) {
        const _r5 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "mat-tab", 14);
        i0.ɵɵpipe(1, "translate");
        i0.ɵɵelementStart(2, "div", 15)(3, "ft-generic-view-table", 16);
        i0.ɵɵlistener("selectedChange", function LinesDialogComponent_mat_tab_group_9_mat_tab_1_Template_ft_generic_view_table_selectedChange_3_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r5); const tab_r3 = restoredCtx.$implicit; const ctx_r4 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r4.handleSelection($event, tab_r3.name)); });
        i0.ɵɵelementEnd()()();
    }
    if (rf & 2) {
        const tab_r3 = ctx.$implicit;
        const ctx_r2 = i0.ɵɵnextContext(2);
        i0.ɵɵproperty("label", i0.ɵɵpipeBind1(1, 10, tab_r3.label))("disabled", !ctx_r2.cls.includes(tab_r3.name));
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("namespace", tab_r3.viewSetting == null ? null : tab_r3.viewSetting.viewNamespace)("hasPagination", tab_r3.viewSetting == null ? null : tab_r3.viewSetting.hasPagination)("hasSearch", true)("selectable", true)("actions", tab_r3.viewSetting == null ? null : tab_r3.viewSetting.actions)("viewSettings", tab_r3.viewSetting == null ? null : tab_r3.viewSetting.viewSettings)("query", tab_r3.viewSetting == null ? null : tab_r3.viewSetting.query)("reloadEvent", tab_r3 == null ? null : tab_r3.viewSetting == null ? null : tab_r3.viewSetting.reloadEvent);
    }
}
function LinesDialogComponent_mat_tab_group_9_Template(rf, ctx) {
    if (rf & 1) {
        const _r7 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "mat-tab-group", 12);
        i0.ɵɵlistener("selectedTabChange", function LinesDialogComponent_mat_tab_group_9_Template_mat_tab_group_selectedTabChange_0_listener($event) { i0.ɵɵrestoreView(_r7); const ctx_r6 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r6.handleChanges($event.index)); });
        i0.ɵɵtemplate(1, LinesDialogComponent_mat_tab_group_9_mat_tab_1_Template, 4, 12, "mat-tab", 13);
        i0.ɵɵelementEnd();
    }
    if (rf & 2) {
        const ctx_r0 = i0.ɵɵnextContext();
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngForOf", ctx_r0.displayedTabs);
    }
}
function LinesDialogComponent_div_10_Template(rf, ctx) {
    if (rf & 1) {
        const _r9 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "div", 17)(1, "ft-generic-view-table", 16);
        i0.ɵɵlistener("selectedChange", function LinesDialogComponent_div_10_Template_ft_generic_view_table_selectedChange_1_listener($event) { i0.ɵɵrestoreView(_r9); const ctx_r8 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r8.handleSelection($event, ctx_r8.tab.name)); });
        i0.ɵɵelementEnd()();
    }
    if (rf & 2) {
        const ctx_r1 = i0.ɵɵnextContext();
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("namespace", ctx_r1.tab.viewSetting == null ? null : ctx_r1.tab.viewSetting.viewNamespace)("hasPagination", ctx_r1.tab.viewSetting == null ? null : ctx_r1.tab.viewSetting.hasPagination)("hasSearch", true)("selectable", true)("actions", ctx_r1.tab.viewSetting == null ? null : ctx_r1.tab.viewSetting.actions)("viewSettings", ctx_r1.tab.viewSetting == null ? null : ctx_r1.tab.viewSetting.viewSettings)("query", ctx_r1.tab.viewSetting == null ? null : ctx_r1.tab.viewSetting.query)("reloadEvent", ctx_r1.tab == null ? null : ctx_r1.tab.viewSetting == null ? null : ctx_r1.tab.viewSetting.reloadEvent);
    }
}
class LinesDialogComponent {
    constructor(dialogRef, dialog, ref, data) {
        this.dialogRef = dialogRef;
        this.dialog = dialog;
        this.ref = ref;
        this.data = data;
        this.linesChange = new EventEmitter();
        this.tableLines = new BehaviorSubject([]);
        this.tableDataChange = this.tableLines.asObservable();
        this.reloadEvent = new EventEmitter();
        this.selectedItems = {};
        this.selectedLine = null;
        this.cls = [];
        this.tab = null;
        this.displayedTabs = [];
        this.asyncTabs = [
            {
                label: 'shared.articles',
                viewSetting: _.assign({}, ARTICLE_VIEW, {
                    query: _.get(data, "query.article", []),
                    actions: [{
                            class: 'mat-primary',
                            icon: 'mdi-plus',
                            method: (item, ev) => {
                                return this.handleNewArticle();
                            },
                            acl: { resource: _.get('store-article', 'resource'), action: 'update', behavior: 'remove' }
                        }],
                    reloadEvent: new EventEmitter()
                }),
                name: 'article'
            },
            {
                label: 'purchase.price_request_list',
                viewSetting: _.assign({}, PRICE_REQUEST_VIEW, {
                    query: _.get(data, "query.PriceRequest", [])
                }),
                name: 'PriceRequest'
            },
            {
                label: 'shared.purchase_order',
                viewSetting: _.assign({}, PURCHASE_ORDER_VIEW, {
                    query: _.get(data, "query.PurchaseOrder", [])
                }),
                name: 'PurchaseOrder'
            },
            {
                label: 'purchase.purchase_receipt_list',
                viewSetting: _.assign({}, PURCHASE_RECEIPT_VIEW, {
                    query: _.get(data, "query.PurchaseReceipt", [])
                }),
                name: 'PurchaseReceipt'
            },
            {
                label: 'shared.return_form',
                viewSetting: _.assign({}, RETURN_VIEW, {
                    query: _.get(data, "query.ReturnForm", [])
                }),
                name: 'ReturnForm'
            },
            {
                label: 'purchase.deposition_list',
                viewSetting: _.assign({}, DEPOSITION_VIEW, {
                    query: _.get(data, "query.DepositionForm", [])
                }),
                name: 'DepositionForm'
            },
            {
                label: 'store.consignment',
                viewSetting: _.assign({}, CONSIGNMENT_VIEW, {
                    query: _.get(data, "query.Consignment", [])
                }),
                name: 'Consignment'
            }
        ];
        this.selectedTab = this.asyncTabs[1];
        this.viewSetting = this.selectedTab.viewSetting;
    }
    ngOnInit() {
        switch (_.get(this.data, 'cls')) {
            case 'PurchaseReceipt':
                this.cls = ['article', 'PurchaseOrder', 'PriceRequest', 'DepositionForm'];
                break;
            case 'ReturnForm':
                this.cls = ['DepositionForm', 'PurchaseReceipt'];
                break;
            case 'PurchaseOrder':
                this.cls = ['article', 'PriceRequest'];
                break;
            case 'ConsignmentReturn':
                this.cls = ['Consignment'];
                break;
            case 'PurchaseInvoice':
                this.cls = ['article', 'PurchaseReceipt'];
                break;
            default:
                this.cls = ['article'];
                break;
        }
        this.displayedTabs = _.filter(this.asyncTabs, (t) => { return _.includes(this.cls, t.name); });
        if (_.size(this.cls) == 1) {
            this.tab = this.displayedTabs[0];
            this.viewSetting = this.tab.viewSetting;
        }
    }
    handleChanges(index) {
        this.selectedTab = this.displayedTabs[index];
        this.viewSetting = this.selectedTab.viewSetting;
        this.ref.markForCheck();
    }
    handleSelection(data, name) {
        this.selectedItems[name] = data;
    }
    selectItem() {
        this.dialogRef.close(this.selectedItems);
    }
    handleNewArticle() {
        this.dialog.open(AddArticleDialogComponent, _.assign(LARGE_DIALOG, {
            data: {},
            autoFocus: false, disableClose: true
        })).afterClosed().subscribe(res => {
            if (res) {
                this.displayedTabs[_.findIndex(this.displayedTabs, (e) => { return e.name == 'article'; })].viewSetting.reloadEvent.emit('true');
            }
        });
    }
}
LinesDialogComponent.ɵfac = function LinesDialogComponent_Factory(t) { return new (t || LinesDialogComponent)(i0.ɵɵdirectiveInject(i1.MatDialogRef), i0.ɵɵdirectiveInject(i1.MatDialog), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(MAT_DIALOG_DATA)); };
LinesDialogComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: LinesDialogComponent, selectors: [["fts-lines-dialog"]], inputs: { linesChange: "linesChange" }, decls: 19, vars: 11, consts: [["color", "primary"], [1, "ft-module-icon"], ["fontSet", "mdi", "fontIcon", "mdi-format-list-bulleted"], ["mat-dialog-title", ""], ["fxFlex", ""], ["mat-icon-button", "", "mat-dialog-close", "", "tabindex", "-1"], ["fontSet", "mdi", "fontIcon", "mdi-close"], [3, "selectedTabChange", 4, "ngIf"], ["mat-dialog-content", "", "class", "ft-content", 4, "ngIf"], ["mat-dialog-actions", ""], ["color", "primary", "mat-raised-button", "", 3, "click"], ["mat-raised-button", "", "mat-dialog-close", "", "tabindex", "-1", "color", "warn"], [3, "selectedTabChange"], [3, "label", "disabled", 4, "ngFor", "ngForOf"], [3, "label", "disabled"], ["mat-dialog-content", "", "fxFlex", "", 1, "ft-content"], ["fxFlex", "", 3, "namespace", "hasPagination", "hasSearch", "selectable", "actions", "viewSettings", "query", "reloadEvent", "selectedChange"], ["mat-dialog-content", "", 1, "ft-content"]], template: function LinesDialogComponent_Template(rf, ctx) {
        if (rf & 1) {
            i0.ɵɵelementStart(0, "mat-toolbar", 0)(1, "div", 1);
            i0.ɵɵelement(2, "mat-icon", 2);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(3, "h2", 3);
            i0.ɵɵtext(4);
            i0.ɵɵpipe(5, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(6, "span", 4);
            i0.ɵɵelementStart(7, "button", 5);
            i0.ɵɵelement(8, "mat-icon", 6);
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(9, LinesDialogComponent_mat_tab_group_9_Template, 2, 1, "mat-tab-group", 7);
            i0.ɵɵtemplate(10, LinesDialogComponent_div_10_Template, 2, 8, "div", 8);
            i0.ɵɵelementStart(11, "div", 9);
            i0.ɵɵelement(12, "span", 4);
            i0.ɵɵelementStart(13, "button", 10);
            i0.ɵɵlistener("click", function LinesDialogComponent_Template_button_click_13_listener() { return ctx.selectItem(); });
            i0.ɵɵtext(14);
            i0.ɵɵpipe(15, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(16, "button", 11);
            i0.ɵɵtext(17);
            i0.ɵɵpipe(18, "translate");
            i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(5, 5, ctx.cls.length == 1 ? ctx.tab == null ? null : ctx.tab.viewSetting == null ? null : ctx.tab.viewSetting.headerLabel : "shared.selected_details"), " ");
            i0.ɵɵadvance(5);
            i0.ɵɵproperty("ngIf", ctx.cls.length > 1);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.cls.length == 1);
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(15, 7, "shared.save"), " ");
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(18, 9, "shared.reset"));
        }
    }, dependencies: [i4$1.NgForOf, i4$1.NgIf, i6.MatButton, i1.MatDialogClose, i1.MatDialogTitle, i1.MatDialogContent, i1.MatDialogActions, i9.MatIcon, i15$2.MatTabGroup, i15$2.MatTab, i11.MatToolbar, i8.DefaultFlexDirective, i4$2.GenericViewTableComponent, i3$1.TranslatePipe] });
(function () {
    (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LinesDialogComponent, [{
            type: Component,
            args: [{ selector: 'fts-lines-dialog', template: "<mat-toolbar color=\"primary\">\n  <div class=\"ft-module-icon\">\n    <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-format-list-bulleted\"></mat-icon>\n  </div>\n  <h2 mat-dialog-title>\n    {{ (cls.length==1 ?  tab?.viewSetting?.headerLabel : 'shared.selected_details')|translate}}\n  </h2>\n  <span fxFlex></span>\n  <button mat-icon-button mat-dialog-close tabindex=\"-1\">\n    <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-close\"></mat-icon>\n  </button>\n</mat-toolbar>\n<mat-tab-group (selectedTabChange)=\"handleChanges($event.index)\" *ngIf=\"cls.length>1\">\n  <mat-tab *ngFor=\"let tab of displayedTabs\" [label]=\"tab.label|translate\" [disabled]=\"!this.cls.includes(tab.name)\">\n    <div mat-dialog-content fxFlex class=\"ft-content\">\n      <ft-generic-view-table fxFlex\n                             [namespace]=\"tab.viewSetting?.viewNamespace\"\n                             [hasPagination]=\"tab.viewSetting?.hasPagination\"\n                             [hasSearch]=\"true\"\n                             [selectable]=\"true\"\n                             [actions]=\"tab.viewSetting?.actions\"\n                             [viewSettings]=\"tab.viewSetting?.viewSettings\"\n                             [query]=\"tab.viewSetting?.query\"\n                             (selectedChange)=\"handleSelection($event, tab.name)\"\n                             [reloadEvent]=\"tab?.viewSetting?.reloadEvent\"\n      ></ft-generic-view-table>\n    </div>\n  </mat-tab>\n</mat-tab-group>\n<div mat-dialog-content class=\"ft-content\" *ngIf=\"cls.length==1\" >\n  <ft-generic-view-table  fxFlex\n                          [namespace]=\"tab.viewSetting?.viewNamespace\"\n                          [hasPagination]=\"tab.viewSetting?.hasPagination\"\n                          [hasSearch]=\"true\"\n                          [selectable]=\"true\"\n                          [actions]=\"tab.viewSetting?.actions\"\n                          [viewSettings]=\"tab.viewSetting?.viewSettings\"\n                          [query]=\"tab.viewSetting?.query\"\n                          (selectedChange)=\"handleSelection($event, tab.name)\"\n                          [reloadEvent]=\"tab?.viewSetting?.reloadEvent\">\n  </ft-generic-view-table>\n</div>\n<div mat-dialog-actions>\n  <span fxFlex></span>\n  <button color=\"primary\" mat-raised-button (click)=\"selectItem()\">\n    {{'shared.save'|translate}}\n  </button>\n  <button mat-raised-button mat-dialog-close  tabindex=\"-1\" color=\"warn\" >{{'shared.reset'|translate}}</button>\n</div>\n" }]
        }], function () {
        return [{ type: i1.MatDialogRef }, { type: i1.MatDialog }, { type: i0.ChangeDetectorRef }, { type: undefined, decorators: [{
                        type: Inject,
                        args: [MAT_DIALOG_DATA]
                    }] }];
    }, { linesChange: [{
                type: Input
            }] });
})();

function InSerialDialogComponent_div_9_Template(rf, ctx) {
    if (rf & 1) {
        const _r7 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "div", 8)(1, "div", 21)(2, "mat-form-field", 22)(3, "input", 23);
        i0.ɵɵlistener("ngModelChange", function InSerialDialogComponent_div_9_Template_input_ngModelChange_3_listener($event) { i0.ɵɵrestoreView(_r7); const ctx_r6 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r6.defaultGenerator.prefix = $event); });
        i0.ɵɵpipe(4, "translate");
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(5, "mat-form-field", 22)(6, "input", 24);
        i0.ɵɵlistener("ngModelChange", function InSerialDialogComponent_div_9_Template_input_ngModelChange_6_listener($event) { i0.ɵɵrestoreView(_r7); const ctx_r8 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r8.defaultGenerator.filling = $event); });
        i0.ɵɵpipe(7, "translate");
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(8, "mat-form-field", 22)(9, "input", 25);
        i0.ɵɵlistener("ngModelChange", function InSerialDialogComponent_div_9_Template_input_ngModelChange_9_listener($event) { i0.ɵɵrestoreView(_r7); const ctx_r9 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r9.defaultGenerator.start = $event); });
        i0.ɵɵpipe(10, "translate");
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(11, "mat-form-field", 22)(12, "input", 26);
        i0.ɵɵlistener("ngModelChange", function InSerialDialogComponent_div_9_Template_input_ngModelChange_12_listener($event) { i0.ɵɵrestoreView(_r7); const ctx_r10 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r10.defaultGenerator.increment = $event); });
        i0.ɵɵpipe(13, "translate");
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(14, "button", 27);
        i0.ɵɵlistener("click", function InSerialDialogComponent_div_9_Template_button_click_14_listener($event) { i0.ɵɵrestoreView(_r7); const ctx_r11 = i0.ɵɵnextContext(); $event.stopImmediatePropagation(); return i0.ɵɵresetView(ctx_r11.generateSerials()); });
        i0.ɵɵelement(15, "mat-icon", 28);
        i0.ɵɵelementEnd()();
        i0.ɵɵelement(16, "hr", 29);
        i0.ɵɵelementEnd();
    }
    if (rf & 2) {
        const ctx_r0 = i0.ɵɵnextContext();
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(4, 8, "shared.prefix"))("ngModel", ctx_r0.defaultGenerator.prefix);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(7, 10, "shared.filling"))("ngModel", ctx_r0.defaultGenerator.filling);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(10, 12, "shared.start"))("ngModel", ctx_r0.defaultGenerator.start);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(13, 14, "shared.increment"))("ngModel", ctx_r0.defaultGenerator.increment);
    }
}
function InSerialDialogComponent_button_17_Template(rf, ctx) {
    if (rf & 1) {
        const _r13 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "button", 30);
        i0.ɵɵlistener("click", function InSerialDialogComponent_button_17_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r13); const ctx_r12 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r12.cancelSearch()); });
        i0.ɵɵelement(1, "mat-icon", 5);
        i0.ɵɵelementEnd();
    }
    if (rf & 2) {
        i0.ɵɵproperty("@scaleAnimation", undefined);
    }
}
function InSerialDialogComponent_mat_form_field_19_mat_error_4_Template(rf, ctx) {
    if (rf & 1) {
        i0.ɵɵelementStart(0, "mat-error");
        i0.ɵɵtext(1);
        i0.ɵɵpipe(2, "translate");
        i0.ɵɵelementEnd();
    }
    if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "store.code_already_exist"), " ");
    }
}
function InSerialDialogComponent_mat_form_field_19_ng_container_5_button_1_Template(rf, ctx) {
    if (rf & 1) {
        const _r22 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "button", 38);
        i0.ɵɵlistener("click", function InSerialDialogComponent_mat_form_field_19_ng_container_5_button_1_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r22); const s_r14 = i0.ɵɵnextContext(2).$implicit; return i0.ɵɵresetView(s_r14.code = null); });
        i0.ɵɵelement(1, "mat-icon", 39);
        i0.ɵɵelementEnd();
    }
}
function InSerialDialogComponent_mat_form_field_19_ng_container_5_Template(rf, ctx) {
    if (rf & 1) {
        i0.ɵɵelementContainerStart(0, 36);
        i0.ɵɵtemplate(1, InSerialDialogComponent_mat_form_field_19_ng_container_5_button_1_Template, 2, 0, "button", 37);
        i0.ɵɵelementContainerEnd();
    }
    if (rf & 2) {
        const s_r14 = i0.ɵɵnextContext().$implicit;
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", s_r14.code);
    }
}
const _c0$o = function (a0, a2) { return { serial_uid: a0, field: "code", article: a2 }; };
function InSerialDialogComponent_mat_form_field_19_Template(rf, ctx) {
    if (rf & 1) {
        const _r25 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "mat-form-field", 31)(1, "input", 32, 33);
        i0.ɵɵlistener("ngModelChange", function InSerialDialogComponent_mat_form_field_19_Template_input_ngModelChange_1_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r25); const s_r14 = restoredCtx.$implicit; return i0.ɵɵresetView(s_r14.code = $event); });
        i0.ɵɵpipe(3, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(4, InSerialDialogComponent_mat_form_field_19_mat_error_4_Template, 3, 3, "mat-error", 34);
        i0.ɵɵtemplate(5, InSerialDialogComponent_mat_form_field_19_ng_container_5_Template, 2, 1, "ng-container", 35);
        i0.ɵɵelementEnd();
    }
    if (rf & 2) {
        const s_r14 = ctx.$implicit;
        const i_r15 = ctx.index;
        const _r16 = i0.ɵɵreference(2);
        const ctx_r3 = i0.ɵɵnextContext();
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(3, 7, "shared.serial"))("name", "serials[" + i_r15 + "].code")("ngModel", s_r14.code)("disabled", ctx_r3.readOnly)("query", i0.ɵɵpureFunction2(9, _c0$o, s_r14["serial_uid"], ctx_r3.article));
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", (_r16 == null ? null : _r16.errors == null ? null : _r16.errors.exists) || ctx_r3.checkExist(s_r14.code));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx_r3.readOnly);
    }
}
function InSerialDialogComponent_div_20_Template(rf, ctx) {
    if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 40);
        i0.ɵɵelement(1, "mat-icon", 41)(2, "span", 42);
        i0.ɵɵelementEnd();
    }
    if (rf & 2) {
        i0.ɵɵproperty("@scaleAnimation", undefined);
    }
}
function InSerialDialogComponent_button_23_Template(rf, ctx) {
    if (rf & 1) {
        const _r27 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "button", 43);
        i0.ɵɵlistener("click", function InSerialDialogComponent_button_23_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r27); const ctx_r26 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r26.saveSerial()); });
        i0.ɵɵtext(1);
        i0.ɵɵpipe(2, "translate");
        i0.ɵɵelementEnd();
    }
    if (rf & 2) {
        const ctx_r5 = i0.ɵɵnextContext();
        const _r1 = i0.ɵɵreference(11);
        i0.ɵɵproperty("disabled", _r1.invalid || ctx_r5.checkDuplicates());
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 2, "shared.save"), " ");
    }
}
class InSerialDialogComponent {
    constructor(dialogRef, data) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.serials = [];
        this.qte = 0;
        this.defaultGenerator = {
            prefix: '',
            filling: 1,
            start: 1,
            increment: 1
        };
        this.isFocused = false;
        this.key = '';
        this.filteredSerials = [];
        this.readOnly = false;
        this.qte = get(data, 'qte');
        this.serials = get(data, 'serials');
        this.article = get(data, 'article');
        this.readOnly = get(data, 'readOnly', false);
    }
    ngOnInit() {
        let supSize = this.qte - size(this.serials);
        for (let i = 0; i < supSize; i++) {
            this.serials.push({ code: null });
        }
    }
    saveSerial() {
        this.dialogRef.close(reject(this.serials, { code: null }));
    }
    removeSerial(idx) {
        this.serials.splice(idx, 1);
    }
    generateSerials() {
        for (let i = 0; i < this.qte; i++) {
            let incrementSerial = `${padStart(this.defaultGenerator.prefix, this.defaultGenerator.filling, '0')}${this.defaultGenerator.start + this.defaultGenerator.increment * i}`;
            if (!find(this.serials, (s) => {
                return s.code == incrementSerial;
            })) {
                this.serials[i] = { 'code': incrementSerial };
            }
        }
    }
    applyFilter(filterValue) {
        this.key = filterValue;
        this.filteredSerials = filter(this.serials, item => {
            return isMatch(item['code'], filterValue);
        });
    }
    cancelSearch() {
        this.key = '';
    }
    checkExist(code) {
        return size(filter(this.serials, item => {
            return item['code'] == code;
        })) > 1;
    }
    checkDuplicates() {
        return size(this.serials) > chain(this.serials).map('code').uniq().size().value();
    }
}
InSerialDialogComponent.ɵfac = function InSerialDialogComponent_Factory(t) { return new (t || InSerialDialogComponent)(i0.ɵɵdirectiveInject(i1.MatDialogRef), i0.ɵɵdirectiveInject(MAT_DIALOG_DATA)); };
InSerialDialogComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: InSerialDialogComponent, selectors: [["fts-in-serial-dialog"]], decls: 27, vars: 19, consts: [["color", "primary"], ["mat-dialog-title", ""], ["fontSet", "mdi", "fontIcon", "mdi-format-list-bulleted"], ["fxFlex", ""], ["mat-icon-button", "", "mat-dialog-close", "", "tabindex", "-1"], ["fontSet", "mdi", "fontIcon", "mdi-close"], ["mat-dialog-content", "", "fxLayout", "column", 1, "ft-content"], ["fxLayout", "column", 4, "ngIf"], ["fxLayout", "column"], ["listForm", "ngForm"], ["fxLayout", "column", 1, "serials"], ["fxLayout", "row", 1, "search-bar"], ["fontSet", "mdi", "fontIcon", "mdi-magnify"], ["type", "text", "fxFlex", "", 3, "value", "ftAutoFocus", "placeholder", "focus", "blur", "input"], ["type", "button", "mat-icon-button", "", "color", "warn", 3, "click", 4, "ngIf"], ["fxLayout", "column", 1, "serials_list"], ["fxFlex", "", "floatLabel", "never", "class", "with-error-label", 4, "ngFor", "ngForOf"], ["class", "ft-empty-content", 4, "ngIf"], ["mat-dialog-actions", ""], ["color", "primary", "mat-raised-button", "", 3, "disabled", "click", 4, "ngIf"], ["color", "warn", "mat-raised-button", "", "tabindex", "-1", 3, "mat-dialog-close"], ["fxLayoutGap", "6px", "fxLayoutAlign", "center"], ["fxFlex", "21", 1, "form-field"], ["matInput", "", "name", "prefix", 3, "placeholder", "ngModel", "ngModelChange"], ["matInput", "", "name", "filling", "type", "number", 3, "placeholder", "ngModel", "ngModelChange"], ["matInput", "", "name", "start", "type", "number", 3, "placeholder", "ngModel", "ngModelChange"], ["matInput", "", "name", "increment", "type", "number", 3, "placeholder", "ngModel", "ngModelChange"], ["mat-mini-fab", "", "matSuffix", "", "type", "button", 1, "fab-icon", 3, "click"], ["fontSet", "mdi", "fontIcon", "mdi-refresh"], [1, "ft-sep"], ["type", "button", "mat-icon-button", "", "color", "warn", 3, "click"], ["fxFlex", "", "floatLabel", "never", 1, "with-error-label"], ["matInput", "", "required", "", "ftCustomValidation", "serial-number.check_uniqueness", 3, "placeholder", "name", "ngModel", "disabled", "query", "ngModelChange"], ["code", "ngModel"], [4, "ngIf"], ["matSuffix", "", 4, "ngIf"], ["matSuffix", ""], ["mat-icon-button", "", "type", "button", "color", "warn", 3, "click", 4, "ngIf"], ["mat-icon-button", "", "type", "button", "color", "warn", 3, "click"], ["fontSet", "mdi", "fontIcon", "mdi-close-circle"], [1, "ft-empty-content"], ["fontSet", "mdi", "fontIcon", "mdi-alert-circle-outline"], ["translate", "common.no_element_to_show"], ["color", "primary", "mat-raised-button", "", 3, "disabled", "click"]], template: function InSerialDialogComponent_Template(rf, ctx) {
        if (rf & 1) {
            i0.ɵɵelementStart(0, "mat-toolbar", 0)(1, "h2", 1);
            i0.ɵɵelement(2, "mat-icon", 2);
            i0.ɵɵtext(3);
            i0.ɵɵpipe(4, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(5, "span", 3);
            i0.ɵɵelementStart(6, "button", 4);
            i0.ɵɵelement(7, "mat-icon", 5);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(8, "div", 6);
            i0.ɵɵtemplate(9, InSerialDialogComponent_div_9_Template, 17, 16, "div", 7);
            i0.ɵɵelementStart(10, "form", 8, 9)(12, "div", 10)(13, "div", 11);
            i0.ɵɵelement(14, "mat-icon", 12);
            i0.ɵɵelementStart(15, "input", 13);
            i0.ɵɵlistener("focus", function InSerialDialogComponent_Template_input_focus_15_listener() { return ctx.isFocused = true; })("blur", function InSerialDialogComponent_Template_input_blur_15_listener() { return ctx.isFocused = false; })("input", function InSerialDialogComponent_Template_input_input_15_listener($event) { return ctx.applyFilter($event.target.value); });
            i0.ɵɵpipe(16, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(17, InSerialDialogComponent_button_17_Template, 2, 1, "button", 14);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(18, "div", 15);
            i0.ɵɵtemplate(19, InSerialDialogComponent_mat_form_field_19_Template, 6, 12, "mat-form-field", 16);
            i0.ɵɵtemplate(20, InSerialDialogComponent_div_20_Template, 3, 1, "div", 17);
            i0.ɵɵelementEnd()()()();
            i0.ɵɵelementStart(21, "div", 18);
            i0.ɵɵelement(22, "span", 3);
            i0.ɵɵtemplate(23, InSerialDialogComponent_button_23_Template, 3, 4, "button", 19);
            i0.ɵɵelementStart(24, "button", 20);
            i0.ɵɵtext(25);
            i0.ɵɵpipe(26, "translate");
            i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 13, "shared.serial_number"), " ");
            i0.ɵɵadvance(6);
            i0.ɵɵproperty("ngIf", !ctx.readOnly);
            i0.ɵɵadvance(5);
            i0.ɵɵclassProp("mat-primary", ctx.isFocused);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("value", ctx.key)("ftAutoFocus", true)("placeholder", i0.ɵɵpipeBind1(16, 15, "store.search"));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.key && ctx.key != "");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngForOf", ctx.key && ctx.key != "" ? ctx.filteredSerials : ctx.serials);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.key && ctx.key != "" && ctx.filteredSerials.length == 0);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngIf", !ctx.readOnly);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("mat-dialog-close", null);
            i0.ɵɵadvance(1);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(26, 17, ctx.readOnly ? "shared.exit" : "shared.cancel"));
        }
    }, dependencies: [i4$1.NgForOf, i4$1.NgIf, i6.MatButton, i1.MatDialogClose, i1.MatDialogTitle, i1.MatDialogContent, i1.MatDialogActions, i9.MatIcon, i10.MatError, i10.MatFormField, i10.MatSuffix, i11$1.MatInput, i11.MatToolbar, i8.DefaultLayoutDirective, i8.DefaultLayoutGapDirective, i8.DefaultLayoutAlignDirective, i8.DefaultFlexDirective, i3$1.TranslateDirective, i16.ɵNgNoValidate, i16.DefaultValueAccessor, i16.NumberValueAccessor, i16.NgControlStatus, i16.NgControlStatusGroup, i16.RequiredValidator, i16.NgModel, i16.NgForm, i2.InputDirective, i2.AutoFocusDirective, i2.CustomValidationDirective, i3$1.TranslatePipe], styles: [".search-bar[_ngcontent-%COMP%]{background-color:#ff8935;transition:margin-right .25s cubic-bezier(.4,0,.2,1);flex:none;margin-bottom:6px;transition:all .25s cubic-bezier(.4,0,.2,1);border-radius:4px;border:1px solid #eceff1;background-color:#eceff11a}.search-bar.focused[_ngcontent-%COMP%]{background:rgba(236,239,241,.3)}.search-bar[_ngcontent-%COMP%] > .mat-icon[_ngcontent-%COMP%], .search-bar[_ngcontent-%COMP%] > .mat-icon-button[_ngcontent-%COMP%]{width:29px;height:29px;margin:3px}.search-bar[_ngcontent-%COMP%] > .mat-icon[_ngcontent-%COMP%]:last-of-type, .search-bar[_ngcontent-%COMP%] > .mat-icon-button[_ngcontent-%COMP%]:last-of-type{margin-right:9px}.search-bar[_ngcontent-%COMP%] > .mat-icon[_ngcontent-%COMP%]{text-align:center;line-height:29px}.search-bar[_ngcontent-%COMP%]   .mat-icon[_ngcontent-%COMP%]{transition:color .28s cubic-bezier(.4,0,.2,1)}.search-bar[_ngcontent-%COMP%] > input[_ngcontent-%COMP%]{border:none;outline:none;font-size:14px;background:inherit}.serials[_ngcontent-%COMP%]{border:1px solid #cfd8dc;border-radius:4px}.serials_list[_ngcontent-%COMP%]{padding:0 4px;overflow:auto;max-height:260px;min-height:70px}.fab-icon[_ngcontent-%COMP%]{margin-top:14px;width:28px;height:28px;box-shadow:none;background-color:#4caf50}"], data: { animation: [
            SCALE_ANIMATION
        ] } });
(function () {
    (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(InSerialDialogComponent, [{
            type: Component,
            args: [{ selector: 'fts-in-serial-dialog', animations: [
                        SCALE_ANIMATION
                    ], template: "<mat-toolbar color=\"primary\">\n  <h2 mat-dialog-title>\n    <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-format-list-bulleted\"></mat-icon>\n    {{ 'shared.serial_number' | translate }}\n  </h2>\n  <span fxFlex></span>\n  <button mat-icon-button mat-dialog-close tabindex=\"-1\">\n    <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-close\"></mat-icon>\n  </button>\n</mat-toolbar>\n\n<div mat-dialog-content class=\"ft-content\"  fxLayout=\"column\">\n    <div fxLayout=\"column\" *ngIf=\"!readOnly\">\n      <div fxLayoutGap=\"6px\" fxLayoutAlign=\"center\">\n        <mat-form-field class=\"form-field\" fxFlex=\"21\">\n          <input matInput [placeholder]=\"'shared.prefix'|translate\" name=\"prefix\"\n                 [(ngModel)]=\"defaultGenerator.prefix\">\n        </mat-form-field>\n        <mat-form-field class=\"form-field\" fxFlex=\"21\">\n          <input matInput [placeholder]=\"'shared.filling'|translate\" name=\"filling\" type=\"number\"\n                 [(ngModel)]=\"defaultGenerator.filling\">\n        </mat-form-field>\n        <mat-form-field class=\"form-field\" fxFlex=\"21\">\n          <input matInput [placeholder]=\"'shared.start'|translate\" name=\"start\" type=\"number\"\n                 [(ngModel)]=\"defaultGenerator.start\">\n        </mat-form-field>\n        <mat-form-field class=\"form-field\" fxFlex=\"21\">\n          <input matInput [placeholder]=\"'shared.increment'|translate\"\n                 name=\"increment\" type=\"number\" [(ngModel)]=\"defaultGenerator.increment\">\n        </mat-form-field>\n        <button mat-mini-fab matSuffix type=\"button\" class=\"fab-icon\"\n                (click)=\"$event.stopImmediatePropagation();generateSerials()\">\n          <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-refresh\"></mat-icon>\n        </button>\n      </div>\n      <hr class=\"ft-sep\">\n    </div>\n    <form #listForm=\"ngForm\" fxLayout=\"column\">\n      <div  fxLayout=\"column\" class=\"serials\">\n        <div class=\"search-bar\" fxLayout=\"row\"  >\n            <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-magnify\" [class.mat-primary]=\"isFocused\"></mat-icon>\n            <input type=\"text\" fxFlex [value]='key' [ftAutoFocus]=\"true\" [placeholder]=\"'store.search' | translate\"\n                   (focus)=\"isFocused = true\" (blur)=\"isFocused = false\" (input)=\"applyFilter($event.target.value)\"/>\n            <button type=\"button\" mat-icon-button (click)=\"cancelSearch()\" color=\"warn\" *ngIf=\"key && key!=''\"\n                    [@scaleAnimation]>\n                <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-close\"></mat-icon>\n            </button>\n        </div>\n        <div fxLayout=\"column\"  class=\"serials_list\">\n          <mat-form-field fxFlex  floatLabel=\"never\" *ngFor=\"let s  of (key && key!=''? filteredSerials :serials); let i = index \"  class=\"with-error-label\">\n            <input matInput\n                  required\n                  [placeholder]=\"'shared.serial' | translate\"\n                  [name]=\"'serials[' + i + '].code'\"\n                  [(ngModel)]=\"s.code\"\n                  [disabled]=\"readOnly\"\n                  #code=\"ngModel\"\n                  [query]=\"{serial_uid:s['serial_uid'], field:'code',  article:article}\"\n                  ftCustomValidation=\"serial-number.check_uniqueness\">\n            <mat-error *ngIf=\"code?.errors?.exists || checkExist(s.code)\">\n                    {{'store.code_already_exist'|translate}}\n            </mat-error>\n            <ng-container matSuffix *ngIf=\"!readOnly\">\n              <button mat-icon-button type=\"button\" color=\"warn\"\n                                  (click)=\"s.code=null\" *ngIf=\"s.code\">\n                            <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-close-circle\"></mat-icon>\n                          </button>\n            </ng-container>\n\n          </mat-form-field>\n           <div *ngIf=\"key && key!='' && filteredSerials.length==0\" class=\"ft-empty-content\" [@scaleAnimation]  >\n              <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-alert-circle-outline\"></mat-icon>\n              <span translate=\"common.no_element_to_show\"></span>\n           </div>\n        </div>\n      </div>\n    </form>\n</div>\n<div mat-dialog-actions>\n  <span fxFlex></span>\n  <button color=\"primary\"  *ngIf=\"!readOnly\" mat-raised-button (click)=\"saveSerial()\" [disabled]=\"listForm.invalid || checkDuplicates()\">\n    {{'shared.save'|translate}}\n  </button>\n  <button [mat-dialog-close]=\"null\" color=\"warn\" mat-raised-button tabindex=\"-1\">{{ (readOnly ?'shared.exit':'shared.cancel')|translate}}</button>\n</div>\n", styles: [".search-bar{background-color:#ff8935;transition:margin-right .25s cubic-bezier(.4,0,.2,1);flex:none;margin-bottom:6px;transition:all .25s cubic-bezier(.4,0,.2,1);border-radius:4px;border:1px solid #eceff1;background-color:#eceff11a}.search-bar.focused{background:rgba(236,239,241,.3)}.search-bar>.mat-icon,.search-bar>.mat-icon-button{width:29px;height:29px;margin:3px}.search-bar>.mat-icon:last-of-type,.search-bar>.mat-icon-button:last-of-type{margin-right:9px}.search-bar>.mat-icon{text-align:center;line-height:29px}.search-bar .mat-icon{transition:color .28s cubic-bezier(.4,0,.2,1)}.search-bar>input{border:none;outline:none;font-size:14px;background:inherit}.serials{border:1px solid #cfd8dc;border-radius:4px}.serials_list{padding:0 4px;overflow:auto;max-height:260px;min-height:70px}.fab-icon{margin-top:14px;width:28px;height:28px;box-shadow:none;background-color:#4caf50}\n"] }]
        }], function () {
        return [{ type: i1.MatDialogRef }, { type: undefined, decorators: [{
                        type: Inject,
                        args: [MAT_DIALOG_DATA]
                    }] }];
    }, null);
})();

function InLotDialogComponent_button_14_Template(rf, ctx) {
    if (rf & 1) {
        const _r2 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "button", 12);
        i0.ɵɵlistener("click", function InLotDialogComponent_button_14_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r2); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.saveLot()); });
        i0.ɵɵtext(1);
        i0.ɵɵpipe(2, "translate");
        i0.ɵɵelementEnd();
    }
    if (rf & 2) {
        const ctx_r0 = i0.ɵɵnextContext();
        i0.ɵɵproperty("disabled", !ctx_r0.isValidQte() || !ctx_r0.isCodesValid());
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 2, "shared.save"), " ");
    }
}
const _c0$n = function () { return []; };
class InLotDialogComponent {
    constructor(data, dialogRef, sharedService, translate) {
        this.data = data;
        this.dialogRef = dialogRef;
        this.sharedService = sharedService;
        this.translate = translate;
        this.lots = [];
        this.qte = 0;
        this.linesSource = of([]);
        this.multiActions = [
            {
                icon: 'mdi-plus-box',
                class: 'mat-primary',
                isMultipleSelection: false,
                method: (item, index, ev) => {
                    this.addLot();
                },
                disabled: () => {
                    return this.qte <= sumBy(this.lots, 'store_qte');
                }
            },
        ];
        this.readOnly = false;
        this.qte = get(data, 'qte');
        this.article = get(data, 'article');
        this.lots = get(data, 'lots');
        this.linesSource = of(this.lots);
        this.readOnly = get(data, 'readOnly', false);
        this.columns = new BehaviorSubject([
            {
                'label': 'store.code',
                'key': 'code',
                'type': 'text',
                "editable": !this.readOnly,
                'is_global_searchable': true
            },
            {
                'label': 'store.date',
                'key': 'expiry_date',
                'type': 'date',
                "editable": !this.readOnly,
                'is_global_searchable': true
            },
            {
                'label': 'store.qte',
                'key': 'store_qte',
                'type': 'number',
                "editable": !this.readOnly,
                'numberConfig': "float",
                min: 0
            },
            {
                label: '', key: 'actions', type: 'actions', actions: [
                    {
                        class: 'mat-warn',
                        icon: 'mdi-close-circle',
                        disabled: (r) => {
                            return this.readOnly;
                        },
                        method: (item, index, ev) => {
                            return this.removeLine(item, index);
                        },
                    }
                ]
            }
        ]);
    }
    ngOnInit() {
    }
    removeLine(row, idx) {
        this.lots.splice(idx, 1);
        this.linesSource = of(this.lots);
    }
    saveLot() {
        this.dialogRef.close(this.lots);
    }
    addLot() {
        this.lots.push({
            code: null,
            expiry_date: moment(),
            store_qte: this.requiredQte(),
        });
        this.linesSource = of(this.lots);
    }
    isValidQte() {
        return this.qte == sumBy(this.lots, 'store_qte');
    }
    isCodesValid() {
        return every(this.lots, (l) => {
            return !isEmpty(l['code']);
        });
    }
    requiredQte() {
        return this.qte - sumBy(this.lots, 'store_qte');
    }
}
InLotDialogComponent.ɵfac = function InLotDialogComponent_Factory(t) { return new (t || InLotDialogComponent)(i0.ɵɵdirectiveInject(MAT_DIALOG_DATA), i0.ɵɵdirectiveInject(i1.MatDialogRef), i0.ɵɵdirectiveInject(SharedService), i0.ɵɵdirectiveInject(i3$1.TranslateService)); };
InLotDialogComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: InLotDialogComponent, selectors: [["fts-in-lot-dialog"]], decls: 18, vars: 19, consts: [["color", "primary"], ["mat-dialog-title", ""], ["fontSet", "mdi", "fontIcon", "mdi-format-list-bulleted"], ["fxFlex", ""], ["mat-icon-button", "", "tabindex", "-1", 3, "mat-dialog-close"], ["fontSet", "mdi", "fontIcon", "mdi-close"], ["mat-dialog-content", "", "fxFill", "", 1, "ft-content"], ["fxLayout", "column", "fxFlex", "", "fxFill", "", 1, "ft-content"], [3, "remote", "source", "selectable", "hasPagination", "columns", "multiActions", "hasFooter"], ["mat-dialog-actions", ""], ["color", "primary", "mat-raised-button", "", 3, "disabled", "click", 4, "ngIf"], ["color", "warn", "mat-raised-button", "", "tabindex", "-1", 3, "mat-dialog-close"], ["color", "primary", "mat-raised-button", "", 3, "disabled", "click"]], template: function InLotDialogComponent_Template(rf, ctx) {
        if (rf & 1) {
            i0.ɵɵelementStart(0, "mat-toolbar", 0)(1, "h2", 1);
            i0.ɵɵelement(2, "mat-icon", 2);
            i0.ɵɵtext(3);
            i0.ɵɵpipe(4, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(5, "span", 3);
            i0.ɵɵelementStart(6, "button", 4);
            i0.ɵɵelement(7, "mat-icon", 5);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(8, "div", 6)(9, "div", 7);
            i0.ɵɵelement(10, "ft-generic-body-table", 8);
            i0.ɵɵpipe(11, "async");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(12, "div", 9);
            i0.ɵɵelement(13, "span", 3);
            i0.ɵɵtemplate(14, InLotDialogComponent_button_14_Template, 3, 4, "button", 10);
            i0.ɵɵelementStart(15, "button", 11);
            i0.ɵɵtext(16);
            i0.ɵɵpipe(17, "translate");
            i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 12, "shared.lot_number"), "");
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("mat-dialog-close", null);
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("remote", false)("source", ctx.linesSource)("selectable", false)("hasPagination", true)("columns", i0.ɵɵpipeBind1(11, 14, ctx.columns))("multiActions", ctx.readOnly ? i0.ɵɵpureFunction0(18, _c0$n) : ctx.multiActions)("hasFooter", false);
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngIf", !ctx.readOnly);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("mat-dialog-close", null);
            i0.ɵɵadvance(1);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(17, 16, ctx.readOnly ? "shared.exit" : "shared.cancel"));
        }
    }, dependencies: [i4$1.NgIf, i6.MatButton, i1.MatDialogClose, i1.MatDialogTitle, i1.MatDialogContent, i1.MatDialogActions, i9.MatIcon, i11.MatToolbar, i8.DefaultLayoutDirective, i8.FlexFillDirective, i8.DefaultFlexDirective, i4$2.GenericBodyTableComponent, i4$1.AsyncPipe, i3$1.TranslatePipe] });
(function () {
    (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(InLotDialogComponent, [{
            type: Component,
            args: [{ selector: 'fts-in-lot-dialog', template: "<mat-toolbar color=\"primary\">\n  <h2 mat-dialog-title>\n    <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-format-list-bulleted\"></mat-icon>\n    {{ 'shared.lot_number' | translate }}</h2>\n  <span fxFlex></span>\n  <button mat-icon-button [mat-dialog-close]=\"null\" tabindex=\"-1\">\n    <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-close\"></mat-icon>\n  </button>\n</mat-toolbar>\n\n\n<div mat-dialog-content class=\"ft-content\" fxFill>\n\n   <div fxLayout=\"column\" fxFlex  fxFill class=\"ft-content\">\n          <ft-generic-body-table\n            [remote]=\"false\"\n            [source]=\"linesSource\"\n            [selectable]=\"false\"\n            [hasPagination]=\"true\"\n            [columns]=\"columns| async\"\n            [multiActions]=\"readOnly ? []: multiActions\"\n            [hasFooter]=\"false\"\n          ></ft-generic-body-table>\n        </div>\n</div>\n<div mat-dialog-actions>\n  <span fxFlex></span>\n  <button color=\"primary\"  *ngIf=\"!readOnly\" mat-raised-button (click)=\"saveLot()\" [disabled]=\"!isValidQte() || !isCodesValid()\">\n    {{'shared.save'|translate}}\n  </button>\n\n<!-- [disabled]=\"!sumQteLot()\"-->\n  <button [mat-dialog-close]=\"null\" color=\"warn\" mat-raised-button tabindex=\"-1\">{{ (readOnly ?'shared.exit':'shared.cancel')|translate}}</button>\n</div>\n" }]
        }], function () {
        return [{ type: undefined, decorators: [{
                        type: Inject,
                        args: [MAT_DIALOG_DATA]
                    }] }, { type: i1.MatDialogRef }, { type: SharedService }, { type: i3$1.TranslateService }];
    }, null);
})();

class SerialService {
    constructor(http, ws) {
        this.http = http;
        this.ws = ws;
    }
    getAvailableSerials(depot, article, mvtType, sourceDoc) {
        return this.ws.call("serial-number.get_available_serials", { depot, article, mvtType, sourceDoc });
    }
}
SerialService.ɵfac = function SerialService_Factory(t) { return new (t || SerialService)(i0.ɵɵinject(i1$1.HttpClient), i0.ɵɵinject(i2.FtWsService)); };
SerialService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: SerialService, factory: SerialService.ɵfac, providedIn: 'root' });
(function () {
    (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SerialService, [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], function () { return [{ type: i1$1.HttpClient }, { type: i2.FtWsService }]; }, null);
})();

function OutSerialDialogComponent_div_12_Template(rf, ctx) {
    if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 21);
        i0.ɵɵelement(1, "mat-icon", 22)(2, "span", 23);
        i0.ɵɵelementEnd();
    }
    if (rf & 2) {
        i0.ɵɵproperty("@scaleAnimation", undefined);
    }
}
function OutSerialDialogComponent_ng_container_13_mat_list_option_1_Template(rf, ctx) {
    if (rf & 1) {
        i0.ɵɵelementStart(0, "mat-list-option", 25);
        i0.ɵɵtext(1);
        i0.ɵɵelementEnd();
    }
    if (rf & 2) {
        const s_r5 = i0.ɵɵnextContext().$implicit;
        i0.ɵɵproperty("value", s_r5);
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", s_r5.code, " ");
    }
}
function OutSerialDialogComponent_ng_container_13_Template(rf, ctx) {
    if (rf & 1) {
        i0.ɵɵelementContainerStart(0);
        i0.ɵɵtemplate(1, OutSerialDialogComponent_ng_container_13_mat_list_option_1_Template, 2, 2, "mat-list-option", 24);
        i0.ɵɵelementContainerEnd();
    }
    if (rf & 2) {
        const s_r5 = ctx.$implicit;
        const ctx_r1 = i0.ɵɵnextContext();
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx_r1.checkIsSelected(s_r5 == null ? null : s_r5.code));
    }
}
function OutSerialDialogComponent_div_19_Template(rf, ctx) {
    if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 21);
        i0.ɵɵelement(1, "mat-icon", 22)(2, "span", 23);
        i0.ɵɵelementEnd();
    }
    if (rf & 2) {
        i0.ɵɵproperty("@scaleAnimation", undefined);
    }
}
function OutSerialDialogComponent_mat_list_item_20_ng_container_2_Template(rf, ctx) {
    if (rf & 1) {
        const _r12 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementContainerStart(0);
        i0.ɵɵelementStart(1, "button", 29);
        i0.ɵɵlistener("click", function OutSerialDialogComponent_mat_list_item_20_ng_container_2_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r12); const item_r8 = i0.ɵɵnextContext().$implicit; const ctx_r10 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r10.removeSerial(item_r8)); });
        i0.ɵɵelement(2, "mat-icon", 30);
        i0.ɵɵelementEnd();
        i0.ɵɵelementContainerEnd();
    }
    if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("@scaleAnimation", undefined);
    }
}
function OutSerialDialogComponent_mat_list_item_20_Template(rf, ctx) {
    if (rf & 1) {
        i0.ɵɵelementStart(0, "mat-list-item", 26);
        i0.ɵɵelement(1, "span", 27);
        i0.ɵɵtemplate(2, OutSerialDialogComponent_mat_list_item_20_ng_container_2_Template, 3, 1, "ng-container", 28);
        i0.ɵɵelementEnd();
    }
    if (rf & 2) {
        const item_r8 = ctx.$implicit;
        const ctx_r3 = i0.ɵɵnextContext();
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("translate", item_r8.code);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx_r3.readOnly);
    }
}
function OutSerialDialogComponent_button_23_Template(rf, ctx) {
    if (rf & 1) {
        const _r14 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "button", 31);
        i0.ɵɵlistener("click", function OutSerialDialogComponent_button_23_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r14); const ctx_r13 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r13.saveSerial()); });
        i0.ɵɵtext(1);
        i0.ɵɵpipe(2, "translate");
        i0.ɵɵelementEnd();
    }
    if (rf & 2) {
        const ctx_r4 = i0.ɵɵnextContext();
        i0.ɵɵproperty("disabled", ctx_r4.qte != ctx_r4.serials.length);
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 2, "shared.saveSerial"), " ");
    }
}
class OutSerialDialogComponent {
    constructor(data, dialogRef, serialService) {
        this.data = data;
        this.dialogRef = dialogRef;
        this.serialService = serialService;
        this.serials = [];
        this.qte = 0;
        this.depot = null;
        this.selectedSerials = [];
        this.readOnly = false;
        this.movementType = null;
        this.sourceDoc = null;
        this.serials = get(data, 'serials', []);
        this.qte = get(data, 'qte');
        this.article = get(data, 'article');
        this.depot = get(data, 'depot');
        this.readOnly = get(data, 'readOnly', false);
        this.movementType = get(data, 'movementType', null);
        this.sourceDoc = get(data, 'sourceDoc', null);
    }
    ngOnInit() {
        if (!this.readOnly) {
            this.busy = this.serialService.getAvailableSerials(this.depot, this.article, this.movementType, this.sourceDoc).subscribe(data => {
                this.availableSerials = data;
            });
        }
    }
    saveSerial() {
        this.dialogRef.close(this.serials);
    }
    removeSerial(idx) {
        this.serials.splice(idx, 1);
    }
    selectSerials() {
        this.serials = concat(this.serials, this.selectedSerials);
    }
    checkIsSelected(code) {
        return code ? find(this.serials, (e) => {
            return e.code == code;
        }) : false;
    }
}
OutSerialDialogComponent.ɵfac = function OutSerialDialogComponent_Factory(t) { return new (t || OutSerialDialogComponent)(i0.ɵɵdirectiveInject(MAT_DIALOG_DATA), i0.ɵɵdirectiveInject(i1.MatDialogRef), i0.ɵɵdirectiveInject(SerialService)); };
OutSerialDialogComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: OutSerialDialogComponent, selectors: [["fts-out-serial-dialog"]], decls: 27, vars: 19, consts: [["color", "primary"], ["mat-dialog-title", ""], ["fontSet", "mdi", "fontIcon", "mdi-format-list-bulleted"], ["fxFlex", ""], ["mat-icon-button", "", "mat-dialog-close", "", "tabindex", "-1"], ["fontSet", "mdi", "fontIcon", "mdi-close"], ["mat-dialog-content", "", "fxLayout", "row", 1, "ft-content"], ["fxLayout", "row", "fxFlex", "", 3, "ngBusy"], ["fxLayout", "column", "fxFlex", "", 1, "selection-list", 3, "tabindex", "fxLayoutAlign"], ["tabindex", "-2", "role", "list", "fxFlex", "", "multiple", "", "color", "accent", 3, "ngModel", "disabled", "ngModelChange"], ["class", "ft-empty-content", 4, "ngIf"], [4, "ngFor", "ngForOf"], ["fxLayout", "column", "fxLayoutAlign", "center center"], ["mat-icon-button", "", "tabindex", "-1", 1, "mat-primary", 3, "disabled", "click"], ["fontSet", "mdi", "fontIcon", "mdi-arrow-right-drop-circle-outline"], ["fxLayout", "column", "fxFlex", "", 1, "selection-list", 3, "fxLayoutAlign"], ["role", "list"], ["role", "listitem", 4, "ngFor", "ngForOf"], ["mat-dialog-actions", ""], ["color", "primary", "mat-raised-button", "", 3, "disabled", "click", 4, "ngIf"], ["color", "warn", "mat-raised-button", "", "tabindex", "-1", 3, "mat-dialog-close"], [1, "ft-empty-content"], ["fontSet", "mdi", "fontIcon", "mdi-alert-circle-outline"], ["translate", "common.no_element_to_show"], [3, "value", 4, "ngIf"], [3, "value"], ["role", "listitem"], ["fxFlex", "", 3, "translate"], [4, "ngIf"], ["mat-icon-button", "", "color", "warn", 3, "click"], ["fxFlex", "noshrink", "fontSet", "mdi", "fontIcon", "mdi-close-circle"], ["color", "primary", "mat-raised-button", "", 3, "disabled", "click"]], template: function OutSerialDialogComponent_Template(rf, ctx) {
        if (rf & 1) {
            i0.ɵɵelementStart(0, "mat-toolbar", 0)(1, "h2", 1);
            i0.ɵɵelement(2, "mat-icon", 2);
            i0.ɵɵtext(3);
            i0.ɵɵpipe(4, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(5, "span", 3);
            i0.ɵɵelementStart(6, "button", 4);
            i0.ɵɵelement(7, "mat-icon", 5);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(8, "div", 6)(9, "div", 7)(10, "div", 8)(11, "mat-selection-list", 9);
            i0.ɵɵlistener("ngModelChange", function OutSerialDialogComponent_Template_mat_selection_list_ngModelChange_11_listener($event) { return ctx.selectedSerials = $event; });
            i0.ɵɵtemplate(12, OutSerialDialogComponent_div_12_Template, 3, 1, "div", 10);
            i0.ɵɵtemplate(13, OutSerialDialogComponent_ng_container_13_Template, 2, 1, "ng-container", 11);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(14, "div", 12)(15, "button", 13);
            i0.ɵɵlistener("click", function OutSerialDialogComponent_Template_button_click_15_listener() { return ctx.selectSerials(); });
            i0.ɵɵelement(16, "mat-icon", 14);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(17, "div", 15)(18, "mat-action-list", 16);
            i0.ɵɵtemplate(19, OutSerialDialogComponent_div_19_Template, 3, 1, "div", 10);
            i0.ɵɵtemplate(20, OutSerialDialogComponent_mat_list_item_20_Template, 3, 2, "mat-list-item", 17);
            i0.ɵɵelementEnd()()()();
            i0.ɵɵelementStart(21, "div", 18);
            i0.ɵɵelement(22, "span", 3);
            i0.ɵɵtemplate(23, OutSerialDialogComponent_button_23_Template, 3, 4, "button", 19);
            i0.ɵɵelementStart(24, "button", 20);
            i0.ɵɵtext(25);
            i0.ɵɵpipe(26, "translate");
            i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 15, "shared.serial_number"), " ");
            i0.ɵɵadvance(6);
            i0.ɵɵproperty("ngBusy", ctx.busy);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("tabindex", 1)("fxLayoutAlign", (ctx.availableSerials == null ? null : ctx.availableSerials.length) > 0 ? "start" : "center center");
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngModel", ctx.selectedSerials)("disabled", ctx.readOnly);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", (ctx.availableSerials == null ? null : ctx.availableSerials.length) == 0);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngForOf", ctx.availableSerials);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("disabled", ctx.readOnly || (ctx.selectedSerials == null ? null : ctx.selectedSerials.length) == 0 || (ctx.selectedSerials == null ? null : ctx.selectedSerials.length) > ctx.qte || ctx.qte == ctx.serials.length);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("fxLayoutAlign", ctx.serials.length > 0 ? "start" : "center center");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", !ctx.serials || ctx.serials.length == 0);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngForOf", ctx.serials);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngIf", !ctx.readOnly);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("mat-dialog-close", null);
            i0.ɵɵadvance(1);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(26, 17, ctx.readOnly ? "shared.exit" : "shared.cancel"));
        }
    }, dependencies: [i4$1.NgForOf, i4$1.NgIf, i6.MatButton, i1.MatDialogClose, i1.MatDialogTitle, i1.MatDialogContent, i1.MatDialogActions, i9.MatIcon, i7$1.MatList, i7$1.MatListItem, i7$1.MatSelectionList, i7$1.MatListOption, i11.MatToolbar, i8.DefaultLayoutDirective, i8.DefaultLayoutAlignDirective, i8.DefaultFlexDirective, i3$1.TranslateDirective, i16.NgControlStatus, i16.NgModel, i12.NgBusyDirective, i3$1.TranslatePipe], data: { animation: [
            SCALE_ANIMATION
        ] } });
(function () {
    (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OutSerialDialogComponent, [{
            type: Component,
            args: [{ selector: 'fts-out-serial-dialog', animations: [
                        SCALE_ANIMATION
                    ], template: "<mat-toolbar color=\"primary\">\n  <h2 mat-dialog-title>\n    <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-format-list-bulleted\"></mat-icon>\n    {{ 'shared.serial_number' | translate }}\n  </h2>\n  <span fxFlex></span>\n  <button mat-icon-button mat-dialog-close tabindex=\"-1\">\n    <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-close\"></mat-icon>\n  </button>\n</mat-toolbar>\n\n<div mat-dialog-content class=\"ft-content\" fxLayout=\"row\">\n    <div  [ngBusy]=\"busy\" fxLayout=\"row\" fxFlex>\n      <div fxLayout=\"column\" fxFlex class=\"selection-list\"  [tabindex]=\"1\" [fxLayoutAlign]=\"availableSerials?.length>0? 'start':'center center'\">\n        <mat-selection-list tabindex=\"-2\" role=\"list\" fxFlex [(ngModel)]=\"selectedSerials\" multiple color=\"accent\" [disabled]=\"readOnly\">\n          <div *ngIf=\"availableSerials?.length == 0\" class=\"ft-empty-content\" [@scaleAnimation]  >\n              <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-alert-circle-outline\"></mat-icon>\n              <span translate=\"common.no_element_to_show\"></span>\n          </div>\n          <ng-container *ngFor=\"let s of availableSerials;\">\n            <mat-list-option *ngIf=\"!checkIsSelected(s?.code)\"  [value]=\"s\" >\n                {{ s.code }}\n            </mat-list-option>\n          </ng-container>\n        </mat-selection-list>\n      </div>\n      <div fxLayout=\"column\" fxLayoutAlign=\"center center\">\n         <button mat-icon-button tabindex=\"-1\"  class=\"mat-primary\" (click)=\"selectSerials()\" [disabled]=\"readOnly||selectedSerials?.length==0 ||selectedSerials?.length>qte || qte ==serials.length\">\n            <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-arrow-right-drop-circle-outline\"></mat-icon>\n          </button>\n      </div>\n      <div fxLayout=\"column\" fxFlex  class=\"selection-list\" [fxLayoutAlign]=\"serials.length>0? 'start':'center center'\">\n         <mat-action-list role=\"list\">\n            <div *ngIf=\"!serials || serials.length == 0\" class=\"ft-empty-content\" [@scaleAnimation]  >\n                <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-alert-circle-outline\"></mat-icon>\n                <span translate=\"common.no_element_to_show\"></span>\n            </div>\n            <mat-list-item role=\"listitem\" *ngFor=\"let item of serials\">\n                    <span fxFlex [translate]=\"item.code\"></span>\n                    <ng-container  *ngIf=\"!readOnly\">\n                      <button (click)=\"removeSerial(item)\"  mat-icon-button color=\"warn\" >\n                        <mat-icon fxFlex=\"noshrink\" fontSet=\"mdi\" fontIcon=\"mdi-close-circle\" [@scaleAnimation]></mat-icon>\n                      </button>\n                    </ng-container>\n\n            </mat-list-item>\n         </mat-action-list>\n      </div>\n    </div>\n</div>\n<div mat-dialog-actions>\n  <span fxFlex></span>\n  <button color=\"primary\"  *ngIf=\"!readOnly\" mat-raised-button (click)=\"saveSerial()\" [disabled]=\"qte !=serials.length\">\n    {{'shared.saveSerial'|translate}}\n  </button>\n  <button [mat-dialog-close]=\"null\" color=\"warn\" mat-raised-button tabindex=\"-1\">{{ (readOnly ?'shared.exit':'shared.cancel')|translate}}</button>\n</div>\n" }]
        }], function () {
        return [{ type: undefined, decorators: [{
                        type: Inject,
                        args: [MAT_DIALOG_DATA]
                    }] }, { type: i1.MatDialogRef }, { type: SerialService }];
    }, null);
})();

class LotService {
    constructor(http, ws) {
        this.http = http;
        this.ws = ws;
    }
    getAvailableLots(depot, article, mvtType, sourceDoc) {
        return this.ws.call("lot-number.get_available_lots", { depot, article, mvtType, sourceDoc });
    }
}
LotService.ɵfac = function LotService_Factory(t) { return new (t || LotService)(i0.ɵɵinject(i1$1.HttpClient), i0.ɵɵinject(i2.FtWsService)); };
LotService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: LotService, factory: LotService.ɵfac, providedIn: 'root' });
(function () {
    (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LotService, [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], function () { return [{ type: i1$1.HttpClient }, { type: i2.FtWsService }]; }, null);
})();

function OutLotDialogComponent_div_12_Template(rf, ctx) {
    if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 20);
        i0.ɵɵelement(1, "mat-icon", 21)(2, "span", 22);
        i0.ɵɵelementEnd();
    }
    if (rf & 2) {
        i0.ɵɵproperty("@scaleAnimation", undefined);
    }
}
function OutLotDialogComponent_ng_container_13_mat_list_option_1_Template(rf, ctx) {
    if (rf & 1) {
        i0.ɵɵelementStart(0, "mat-list-option", 24);
        i0.ɵɵtext(1);
        i0.ɵɵelementEnd();
    }
    if (rf & 2) {
        const s_r3 = i0.ɵɵnextContext().$implicit;
        i0.ɵɵproperty("value", s_r3);
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", s_r3.code, " ");
    }
}
function OutLotDialogComponent_ng_container_13_Template(rf, ctx) {
    if (rf & 1) {
        i0.ɵɵelementContainerStart(0);
        i0.ɵɵtemplate(1, OutLotDialogComponent_ng_container_13_mat_list_option_1_Template, 2, 2, "mat-list-option", 23);
        i0.ɵɵelementContainerEnd();
    }
    if (rf & 2) {
        const s_r3 = ctx.$implicit;
        const ctx_r1 = i0.ɵɵnextContext();
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx_r1.checkIsSelected(s_r3 == null ? null : s_r3.code));
    }
}
function OutLotDialogComponent_button_22_Template(rf, ctx) {
    if (rf & 1) {
        const _r7 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "button", 25);
        i0.ɵɵlistener("click", function OutLotDialogComponent_button_22_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r7); const ctx_r6 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r6.saveLot()); });
        i0.ɵɵtext(1);
        i0.ɵɵpipe(2, "translate");
        i0.ɵɵelementEnd();
    }
    if (rf & 2) {
        const ctx_r2 = i0.ɵɵnextContext();
        i0.ɵɵproperty("disabled", !ctx_r2.isValidQte());
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 2, "shared.save"), " ");
    }
}
class OutLotDialogComponent {
    constructor(data, dialogRef, sharedService, translate, lotService) {
        this.data = data;
        this.dialogRef = dialogRef;
        this.sharedService = sharedService;
        this.translate = translate;
        this.lotService = lotService;
        this.lots = [];
        this.qte = 0;
        this.depot = null;
        this.linesSource = of([]);
        this.selectedLots = [];
        this.readOnly = false;
        this.movementType = null;
        this.sourceDoc = null;
        this.columns = new BehaviorSubject([
            {
                'label': 'store.code',
                'key': 'code',
                'type': 'text',
                'is_global_searchable': true
            },
            {
                'label': 'store.date',
                'key': 'expiry_date',
                'type': 'date',
                'is_global_searchable': true
            },
            {
                'label': 'store.qte',
                'key': 'store_qte',
                'type': 'number',
                "editable": (r) => {
                    return !this.readOnly;
                },
                "max": this.allowedQte(),
                min: 0,
                'numberConfig': "float"
            },
            {
                label: '', key: 'actions', type: 'actions', actions: [
                    {
                        class: 'mat-warn',
                        icon: 'mdi-close-circle',
                        disabled: (r) => {
                            return this.readOnly;
                        },
                        method: (item, index, ev) => {
                            return this.removeLine(item, index);
                        },
                    }
                ]
            }
        ]);
        this.qte = get(data, 'qte');
        this.article = get(data, 'article');
        this.depot = get(data, 'depot');
        this.lots = get(data, 'lots');
        this.linesSource = of(this.lots);
        this.readOnly = get(data, 'readOnly', false);
        this.movementType = get(data, 'movementType', null);
        this.sourceDoc = get(data, 'sourceDoc', null);
    }
    ngOnInit() {
        this.busy = this.lotService.getAvailableLots(this.depot, this.article, this.movementType, this.sourceDoc).subscribe(data => {
            this.availableLots = data;
        });
    }
    removeLine(row, idx) {
        this.lots.splice(idx, 1);
        this.linesSource = of(this.lots);
    }
    saveLot() {
        this.dialogRef.close(this.lots);
    }
    checkIsSelected(code) {
        return code ? find(this.lots, (e) => {
            return e.code == code;
        }) : false;
    }
    getRequiredLotQte(l) {
        let allowedQts = this.allowedQte();
        if (allowedQts > 0) {
            let available_qte = subtract(sum([
                get(l, 'store_qte', 0),
                get(l, 'deposition_qte', 0)
            ]), sum([get(l, 'consigned_qte', 0),
                get(l, 'sold_qte', 0),
                get(l, 'return_qte', 0)
            ]));
            return available_qte > allowedQts ? allowedQts : available_qte;
        }
        else
            return 0;
    }
    selectLots() {
        let lot = [];
        forEach(cloneDeep(this.selectedLots), (l) => {
            this.lots.push(assignIn(omit(l, 'deposition_qte', 'consigned_qte', 'sold_qte', 'return_qte'), { 'store_qte': this.getRequiredLotQte(l) }));
        });
        this.linesSource = of(this.lots);
    }
    allowedQte() {
        return this.qte - sumBy(this.lots, 'store_qte');
    }
    isValidQte() {
        return this.qte == sumBy(this.lots, 'store_qte') && !find(this.lots, { store_qte: 0 });
    }
}
OutLotDialogComponent.ɵfac = function OutLotDialogComponent_Factory(t) { return new (t || OutLotDialogComponent)(i0.ɵɵdirectiveInject(MAT_DIALOG_DATA), i0.ɵɵdirectiveInject(i1.MatDialogRef), i0.ɵɵdirectiveInject(SharedService), i0.ɵɵdirectiveInject(i3$1.TranslateService), i0.ɵɵdirectiveInject(LotService)); };
OutLotDialogComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: OutLotDialogComponent, selectors: [["fts-out-lot-dialog"]], decls: 26, vars: 23, consts: [["color", "primary"], ["mat-dialog-title", ""], ["fontSet", "mdi", "fontIcon", "mdi-format-list-bulleted"], ["fxFlex", ""], ["mat-icon-button", "", "mat-dialog-close", "", "tabindex", "-1"], ["fontSet", "mdi", "fontIcon", "mdi-close"], ["mat-dialog-content", "", "fxLayout", "row", 1, "ft-content"], ["fxLayout", "row", "fxFlex", "", 3, "ngBusy"], ["fxLayout", "column", "fxFlex", "30", 1, "selection-list", 3, "fxLayoutAlign"], ["tabindex", "-2", "role", "list", "multiple", "", "color", "accent", 3, "ngModel", "disabled", "ngModelChange"], ["class", "ft-empty-content", 4, "ngIf"], [4, "ngFor", "ngForOf"], ["fxLayout", "column", "fxLayoutAlign", "center center"], ["mat-icon-button", "", "tabindex", "-1", 1, "mat-primary", 3, "disabled", "click"], ["fontSet", "mdi", "fontIcon", "mdi-arrow-right-drop-circle-outline"], ["fxLayout", "column", "fxFlex", "", 1, "ft-content"], [3, "remote", "source", "selectable", "hasPagination", "columns", "hasFooter"], ["mat-dialog-actions", ""], ["color", "primary", "mat-raised-button", "", 3, "disabled", "click", 4, "ngIf"], ["color", "warn", "mat-raised-button", "", "tabindex", "-1", 3, "mat-dialog-close"], [1, "ft-empty-content"], ["fontSet", "mdi", "fontIcon", "mdi-alert-circle-outline"], ["translate", "common.no_element_to_show"], [3, "value", 4, "ngIf"], [3, "value"], ["color", "primary", "mat-raised-button", "", 3, "disabled", "click"]], template: function OutLotDialogComponent_Template(rf, ctx) {
        if (rf & 1) {
            i0.ɵɵelementStart(0, "mat-toolbar", 0)(1, "h2", 1);
            i0.ɵɵelement(2, "mat-icon", 2);
            i0.ɵɵtext(3);
            i0.ɵɵpipe(4, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(5, "span", 3);
            i0.ɵɵelementStart(6, "button", 4);
            i0.ɵɵelement(7, "mat-icon", 5);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(8, "div", 6)(9, "div", 7)(10, "div", 8)(11, "mat-selection-list", 9);
            i0.ɵɵlistener("ngModelChange", function OutLotDialogComponent_Template_mat_selection_list_ngModelChange_11_listener($event) { return ctx.selectedLots = $event; });
            i0.ɵɵtemplate(12, OutLotDialogComponent_div_12_Template, 3, 1, "div", 10);
            i0.ɵɵtemplate(13, OutLotDialogComponent_ng_container_13_Template, 2, 1, "ng-container", 11);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(14, "div", 12)(15, "button", 13);
            i0.ɵɵlistener("click", function OutLotDialogComponent_Template_button_click_15_listener() { return ctx.selectLots(); });
            i0.ɵɵelement(16, "mat-icon", 14);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(17, "div", 15);
            i0.ɵɵelement(18, "ft-generic-body-table", 16);
            i0.ɵɵpipe(19, "async");
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(20, "div", 17);
            i0.ɵɵelement(21, "span", 3);
            i0.ɵɵtemplate(22, OutLotDialogComponent_button_22_Template, 3, 4, "button", 18);
            i0.ɵɵelementStart(23, "button", 19);
            i0.ɵɵtext(24);
            i0.ɵɵpipe(25, "translate");
            i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 17, "shared.lot_number"), "");
            i0.ɵɵadvance(6);
            i0.ɵɵproperty("ngBusy", ctx.busy);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("fxLayoutAlign", (ctx.availableLots == null ? null : ctx.availableLots.length) > 0 ? "start" : "center center");
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngModel", ctx.selectedLots)("disabled", ctx.readOnly);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", (ctx.availableLots == null ? null : ctx.availableLots.length) == 0);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngForOf", ctx.availableLots);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("disabled", ctx.readOnly || (ctx.selectedLots == null ? null : ctx.selectedLots.length) == 0);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("remote", false)("source", ctx.linesSource)("selectable", false)("hasPagination", true)("columns", i0.ɵɵpipeBind1(19, 19, ctx.columns))("hasFooter", false);
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngIf", !ctx.readOnly);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("mat-dialog-close", null);
            i0.ɵɵadvance(1);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(25, 21, ctx.readOnly ? "shared.exit" : "shared.cancel"));
        }
    }, dependencies: [i4$1.NgForOf, i4$1.NgIf, i6.MatButton, i1.MatDialogClose, i1.MatDialogTitle, i1.MatDialogContent, i1.MatDialogActions, i9.MatIcon, i7$1.MatSelectionList, i7$1.MatListOption, i11.MatToolbar, i8.DefaultLayoutDirective, i8.DefaultLayoutAlignDirective, i8.DefaultFlexDirective, i3$1.TranslateDirective, i16.NgControlStatus, i16.NgModel, i12.NgBusyDirective, i4$2.GenericBodyTableComponent, i4$1.AsyncPipe, i3$1.TranslatePipe], data: { animation: [
            SCALE_ANIMATION
        ] } });
(function () {
    (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OutLotDialogComponent, [{
            type: Component,
            args: [{ selector: 'fts-out-lot-dialog', animations: [
                        SCALE_ANIMATION
                    ], template: "<mat-toolbar color=\"primary\">\n  <h2 mat-dialog-title>\n    <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-format-list-bulleted\"></mat-icon>\n    {{ 'shared.lot_number' | translate }}</h2>\n  <span fxFlex></span>\n  <button mat-icon-button mat-dialog-close tabindex=\"-1\">\n    <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-close\"></mat-icon>\n  </button>\n</mat-toolbar>\n\n<div mat-dialog-content  class=\"ft-content\" fxLayout=\"row\">\n    <div  [ngBusy]=\"busy\" fxLayout=\"row\" fxFlex>\n      <div fxLayout=\"column\" fxFlex=\"30\" class=\"selection-list\"  [fxLayoutAlign]=\"availableLots?.length>0? 'start':'center center'\">\n        <mat-selection-list tabindex=\"-2\" role=\"list\" [(ngModel)]=\"selectedLots\" multiple color=\"accent\" [disabled]=\"readOnly\">\n          <div *ngIf=\"availableLots?.length == 0\" class=\"ft-empty-content\" [@scaleAnimation]  >\n              <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-alert-circle-outline\"></mat-icon>\n              <span translate=\"common.no_element_to_show\"></span>\n          </div>\n          <ng-container *ngFor=\"let s of availableLots\">\n            <mat-list-option *ngIf=\"!checkIsSelected(s?.code)\"  [value]=\"s\" >\n                {{ s.code }}\n            </mat-list-option>\n          </ng-container>\n        </mat-selection-list>\n      </div>\n      <div fxLayout=\"column\" fxLayoutAlign=\"center center\">\n         <button mat-icon-button tabindex=\"-1\"  class=\"mat-primary\" (click)=\"selectLots()\" [disabled]=\"readOnly || selectedLots?.length==0\"  >\n            <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-arrow-right-drop-circle-outline\"></mat-icon>\n          </button>\n      </div>\n\n      <div fxLayout=\"column\" fxFlex    class=\"ft-content\">\n        <ft-generic-body-table\n          [remote]=\"false\"\n          [source]=\"linesSource\"\n          [selectable]=\"false\"\n          [hasPagination]=\"true\"\n          [columns]=\"columns| async\"\n          [hasFooter]=\"false\"\n        ></ft-generic-body-table>\n      </div>\n    </div>\n</div>\n<div mat-dialog-actions>\n  <span fxFlex></span>\n  <button color=\"primary\"  *ngIf=\"!readOnly\" mat-raised-button (click)=\"saveLot()\"  [disabled]=\"!isValidQte()\" >\n    {{'shared.save'|translate}}\n  </button>\n\n<!-- [disabled]=\"!sumQteLot()\"-->\n  <button [mat-dialog-close]=\"null\" color=\"warn\" mat-raised-button tabindex=\"-1\">{{ (readOnly ?'shared.exit':'shared.cancel')|translate}}</button>\n</div>\n" }]
        }], function () {
        return [{ type: undefined, decorators: [{
                        type: Inject,
                        args: [MAT_DIALOG_DATA]
                    }] }, { type: i1.MatDialogRef }, { type: SharedService }, { type: i3$1.TranslateService }, { type: LotService }];
    }, null);
})();

function ArticleSummaryDialogComponent_mat_radio_button_74_Template(rf, ctx) {
    if (rf & 1) {
        i0.ɵɵelementStart(0, "mat-radio-button", 36);
        i0.ɵɵtext(1);
        i0.ɵɵpipe(2, "translate");
        i0.ɵɵelementEnd();
    }
    if (rf & 2) {
        const element_r3 = ctx.$implicit;
        const ctx_r1 = i0.ɵɵnextContext();
        i0.ɵɵproperty("value", element_r3)("disabled", ctx_r1.readOnly);
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 3, "store." + element_r3), " ");
    }
}
function ArticleSummaryDialogComponent_div_75_Template(rf, ctx) {
    if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 28)(1, "h4");
        i0.ɵɵtext(2);
        i0.ɵɵpipe(3, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "div", 37)(5, "mat-slide-toggle", 38);
        i0.ɵɵelement(6, "span", 39);
        i0.ɵɵpipe(7, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(8, "mat-slide-toggle", 40);
        i0.ɵɵelement(9, "span", 39);
        i0.ɵɵpipe(10, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(11, "mat-slide-toggle", 41);
        i0.ɵɵelement(12, "span", 39);
        i0.ɵɵpipe(13, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(14, "mat-slide-toggle", 42);
        i0.ɵɵelement(15, "span", 39);
        i0.ɵɵpipe(16, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(17, "mat-slide-toggle", 43);
        i0.ɵɵelement(18, "span", 39);
        i0.ɵɵpipe(19, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(20, "mat-slide-toggle", 44);
        i0.ɵɵelement(21, "span", 39);
        i0.ɵɵpipe(22, "translate");
        i0.ɵɵelementEnd()()();
    }
    if (rf & 2) {
        const ctx_r2 = i0.ɵɵnextContext();
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 19, "store.management_rules"));
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("checked", ctx_r2.model.prohibited_for_sale)("disabled", ctx_r2.readOnly);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(7, 21, "store.prohibited_for_sale"), i0.ɵɵsanitizeHtml);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("checked", ctx_r2.model.prohibited_to_purchase)("disabled", ctx_r2.readOnly);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(10, 23, "store.prohibited_to_purchase"), i0.ɵɵsanitizeHtml);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("checked", ctx_r2.model.allows_negative_stock)("disabled", ctx_r2.readOnly);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(13, 25, "store.allows_negative_stock"), i0.ɵɵsanitizeHtml);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("checked", ctx_r2.model.has_serial)("disabled", ctx_r2.readOnly || (ctx_r2.model == null ? null : ctx_r2.model.has_lot_number));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(16, 27, "store.has_serial"), i0.ɵɵsanitizeHtml);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("checked", ctx_r2.model.has_lot_number)("disabled", ctx_r2.readOnly || (ctx_r2.model == null ? null : ctx_r2.model.has_serial));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(19, 29, "store.has_lot_number"), i0.ɵɵsanitizeHtml);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("checked", ctx_r2.model.lapsing)("disabled", ctx_r2.readOnly);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(22, 31, "store.lapsing"), i0.ɵɵsanitizeHtml);
    }
}
class ArticleSummaryDialogComponent {
    constructor(sharedService, dialogRef, data) {
        this.sharedService = sharedService;
        this.dialogRef = dialogRef;
        this.data = data;
        this.pk = null;
        this.busy = null;
        this.readOnly = true;
        this.evaluations = ['FIFO', 'LIFO', 'FEFO', 'PMP'];
        this.pk = _.get(data, 'id');
    }
    ngOnInit() {
        this.busy = this.sharedService.getDocument('store/article', this.pk).subscribe(data => {
            this.model = data;
        });
    }
    closeDialog() {
        this.dialogRef.close();
    }
}
ArticleSummaryDialogComponent.ɵfac = function ArticleSummaryDialogComponent_Factory(t) { return new (t || ArticleSummaryDialogComponent)(i0.ɵɵdirectiveInject(SharedService), i0.ɵɵdirectiveInject(i1.MatDialogRef), i0.ɵɵdirectiveInject(MAT_DIALOG_DATA)); };
ArticleSummaryDialogComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ArticleSummaryDialogComponent, selectors: [["fts-article-summary"]], decls: 81, vars: 106, consts: [["color", "primary"], ["fontSet", "mdi", "fontIcon", "mdi-format-list-bulleted"], ["fxFlex", ""], ["mat-icon-button", "", "tabindex", "-1"], ["fontSet", "mdi", "fontIcon", "mdi-close", 3, "mat-dialog-close"], ["mat-dialog-content", "", "fxLayout", "column", 1, "ft-content"], [3, "ngBusy"], ["fxLayout", "column", "name", "article", 1, "ft-padding"], ["articleForm", "ngForm"], ["fxLayout", "row", "fxLayoutGap", "8px"], ["fxFlex", "25", 1, "with-error-label"], ["matInput", "", "name", "code", 3, "ftAutoFocus", "readonly", "placeholder", "value"], ["matInput", "", "name", "description", "required", "", 3, "placeholder", "readonly", "value"], ["matInput", "", "name", "family", "required", "", 3, "placeholder", "readonly", "value"], ["matInput", "", "name", "default_provider", "required", "", 3, "placeholder", "readonly", "value"], ["matInput", "", "name", "purchase_unity", "required", "", 3, "placeholder", "readonly", "value"], ["matInput", "", "name", "purchase_vat", "required", "", 3, "placeholder", "readonly", "value"], ["matInput", "", "name", "purchase_price", 3, "placeholder", "value", "ftNumber", "readonly"], ["matInput", "", "name", "purchase_price_max", 3, "placeholder", "ftNumber", "readonly", "value"], ["matInput", "", "name", "sale_unity", 3, "placeholder", "ftNumber", "readonly", "value"], ["matInput", "", "name", "sale_vat", 3, "placeholder", "ftNumber", "readonly", "value"], ["matInput", "", "name", "sale_price", 3, "placeholder", "ftNumber", "readonly", "value"], ["matInput", "", "name", "sale_price_min", 3, "placeholder", "ftNumber", "readonly", "value"], ["matInput", "", "name", "min_qte", 3, "placeholder", "ftNumber", "value", "readonly"], ["matInput", "", "name", "max_qte", 3, "placeholder", "ftNumber", "value", "readonly"], ["matInput", "", "name", "min_dep_qte", 3, "placeholder", "ftNumber", "value", "readonly"], ["matInput", "", "name", "max_dep_qte", 3, "placeholder", "ftNumber", "value", "readonly"], [1, "ft-sep"], ["fxLayoutGap", "6px", "fxLayout", "column"], ["floatLabel", "always", 1, "ft-radio-field"], ["matInput", "", "placeholder", "", 2, "display", "none"], ["name", "evaluation", "color", "primary", "fxFlex", "", 3, "value"], [3, "value", "disabled", 4, "ngFor", "ngForOf"], ["fxLayoutGap", "6px", "fxLayout", "column", 4, "ngIf"], ["mat-dialog-actions", ""], ["type", "button", "color", "warn", "mat-raised-button", "", "tabindex", "-1", 3, "mat-dialog-close"], [3, "value", "disabled"], ["fxLayoutGap", "6px", "fxFlex", "row"], ["name", "prohibited_for_sale", "color", "primary", 3, "checked", "disabled"], [3, "innerHTML"], ["name", "prohibited_to_purchase", "color", "primary", 3, "checked", "disabled"], ["name", "allows_negative_stock", "color", "primary", 3, "checked", "disabled"], ["name", "has_serial", "color", "primary", 3, "checked", "disabled"], ["name", "has_lot_number", "color", "primary", 3, "checked", "disabled"], ["name", "lapsing", "color", "primary", 3, "checked", "disabled"]], template: function ArticleSummaryDialogComponent_Template(rf, ctx) {
        if (rf & 1) {
            i0.ɵɵelementStart(0, "mat-toolbar", 0);
            i0.ɵɵelement(1, "mat-icon", 1);
            i0.ɵɵelementStart(2, "h2")(3, "span");
            i0.ɵɵtext(4);
            i0.ɵɵpipe(5, "translate");
            i0.ɵɵelementEnd()();
            i0.ɵɵelement(6, "span", 2);
            i0.ɵɵelementStart(7, "button", 3);
            i0.ɵɵelement(8, "mat-icon", 4);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(9, "div", 5);
            i0.ɵɵelement(10, "div", 6);
            i0.ɵɵelementStart(11, "form", 7, 8)(13, "div", 9)(14, "mat-form-field", 10);
            i0.ɵɵelement(15, "input", 11);
            i0.ɵɵpipe(16, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(17, "mat-form-field", 2);
            i0.ɵɵelement(18, "input", 12);
            i0.ɵɵpipe(19, "translate");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(20, "div", 9)(21, "mat-form-field", 2);
            i0.ɵɵelement(22, "input", 13);
            i0.ɵɵpipe(23, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(24, "mat-form-field", 2);
            i0.ɵɵelement(25, "input", 14);
            i0.ɵɵpipe(26, "translate");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(27, "div", 9)(28, "mat-form-field", 2);
            i0.ɵɵelement(29, "input", 15);
            i0.ɵɵpipe(30, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(31, "mat-form-field", 2);
            i0.ɵɵelement(32, "input", 16);
            i0.ɵɵpipe(33, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(34, "mat-form-field", 2);
            i0.ɵɵelement(35, "input", 17);
            i0.ɵɵpipe(36, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(37, "mat-form-field", 2);
            i0.ɵɵelement(38, "input", 18);
            i0.ɵɵpipe(39, "translate");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(40, "div", 9)(41, "mat-form-field", 2);
            i0.ɵɵelement(42, "input", 19);
            i0.ɵɵpipe(43, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(44, "mat-form-field", 2);
            i0.ɵɵelement(45, "input", 20);
            i0.ɵɵpipe(46, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(47, "mat-form-field", 2);
            i0.ɵɵelement(48, "input", 21);
            i0.ɵɵpipe(49, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(50, "mat-form-field", 2);
            i0.ɵɵelement(51, "input", 22);
            i0.ɵɵpipe(52, "translate");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(53, "div", 9)(54, "mat-form-field", 2);
            i0.ɵɵelement(55, "input", 23);
            i0.ɵɵpipe(56, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(57, "mat-form-field", 2);
            i0.ɵɵelement(58, "input", 24);
            i0.ɵɵpipe(59, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(60, "mat-form-field", 2);
            i0.ɵɵelement(61, "input", 25);
            i0.ɵɵpipe(62, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(63, "mat-form-field", 2);
            i0.ɵɵelement(64, "input", 26);
            i0.ɵɵpipe(65, "translate");
            i0.ɵɵelementEnd()();
            i0.ɵɵelement(66, "hr", 27);
            i0.ɵɵelementStart(67, "div", 28)(68, "h4");
            i0.ɵɵtext(69);
            i0.ɵɵpipe(70, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(71, "mat-form-field", 29);
            i0.ɵɵelement(72, "input", 30);
            i0.ɵɵelementStart(73, "mat-radio-group", 31);
            i0.ɵɵtemplate(74, ArticleSummaryDialogComponent_mat_radio_button_74_Template, 3, 5, "mat-radio-button", 32);
            i0.ɵɵelementEnd()()();
            i0.ɵɵtemplate(75, ArticleSummaryDialogComponent_div_75_Template, 23, 33, "div", 33);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(76, "div", 34);
            i0.ɵɵelement(77, "span", 2);
            i0.ɵɵelementStart(78, "button", 35);
            i0.ɵɵtext(79);
            i0.ɵɵpipe(80, "translate");
            i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(5, 68, "store.article_form_sheet"), " ");
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("mat-dialog-close", null);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngBusy", ctx.busy);
            i0.ɵɵadvance(5);
            i0.ɵɵproperty("ftAutoFocus", true)("readonly", ctx.readOnly)("placeholder", i0.ɵɵpipeBind1(16, 70, "store.code"))("value", ctx.model == null ? null : ctx.model.code);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(19, 72, "store.description"))("readonly", ctx.readOnly)("value", ctx.model == null ? null : ctx.model.description);
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(23, 74, "store.family"))("readonly", ctx.readOnly)("value", ctx.model == null ? null : ctx.model.family == null ? null : ctx.model.family.name);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(26, 76, "store.default_provider"))("readonly", ctx.readOnly)("value", ctx.model == null ? null : ctx.model.default_provider == null ? null : ctx.model.default_provider.name);
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(30, 78, "store.purchase_unity"))("readonly", ctx.readOnly)("value", ctx.model == null ? null : ctx.model.purchase_unity == null ? null : ctx.model.purchase_unity.value);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(33, 80, "store.purchase_vat"))("readonly", ctx.readOnly)("value", ctx.model == null ? null : ctx.model.purchase_vat == null ? null : ctx.model.purchase_vat.description);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(36, 82, "store.purchase_price"))("value", ctx.model == null ? null : ctx.model.purchase_price)("ftNumber", "float")("readonly", ctx.readOnly);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(39, 84, "store.purchase_price_max"))("ftNumber", "float")("readonly", ctx.readOnly)("value", ctx.model == null ? null : ctx.model.purchase_price_max);
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(43, 86, "store.sale_unity"))("ftNumber", "float")("readonly", ctx.readOnly)("value", ctx.model == null ? null : ctx.model.sale_unity == null ? null : ctx.model.sale_unity.value);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(46, 88, "store.sale_vat"))("ftNumber", "float")("readonly", ctx.readOnly)("value", ctx.model == null ? null : ctx.model.sale_vat == null ? null : ctx.model.sale_vat.description);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(49, 90, "store.sale_price"))("ftNumber", "float")("readonly", ctx.readOnly)("value", ctx.model == null ? null : ctx.model.sale_price);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(52, 92, "store.sale_price_min"))("ftNumber", "float")("readonly", ctx.readOnly)("value", ctx.model == null ? null : ctx.model.sale_price_min);
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(56, 94, "store.min_qte"))("ftNumber", "float")("value", ctx.model == null ? null : ctx.model.min_qte)("readonly", ctx.readOnly);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(59, 96, "store.max_qte"))("ftNumber", "float")("value", ctx.model == null ? null : ctx.model.max_qte)("readonly", ctx.readOnly);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(62, 98, "store.min_dep_qte"))("ftNumber", "float")("value", ctx.model == null ? null : ctx.model.min_dep_qte)("readonly", ctx.readOnly);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(65, 100, "store.max_dep_qte"))("ftNumber", "float")("value", ctx.model == null ? null : ctx.model.max_dep_qte)("readonly", ctx.readOnly);
            i0.ɵɵadvance(5);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(70, 102, "store.store_out_rules"));
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("value", ctx.model == null ? null : ctx.model.evaluation);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngForOf", ctx.evaluations);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.model == null ? null : ctx.model.id);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("mat-dialog-close", null);
            i0.ɵɵadvance(1);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(80, 104, "shared.exit"));
        }
    }, dependencies: [i4$1.NgForOf, i4$1.NgIf, i6.MatButton, i1.MatDialogClose, i1.MatDialogContent, i1.MatDialogActions, i9.MatIcon, i10.MatFormField, i11$1.MatInput, i13.MatRadioGroup, i13.MatRadioButton, i8$1.MatSlideToggle, i11.MatToolbar, i8.DefaultLayoutDirective, i8.DefaultLayoutGapDirective, i8.DefaultFlexDirective, i16.ɵNgNoValidate, i16.NgControlStatusGroup, i16.NgForm, i12.NgBusyDirective, i2.InputDirective, i2.NumberDirective, i2.AutoFocusDirective, i3$1.TranslatePipe], encapsulation: 2 });
(function () {
    (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ArticleSummaryDialogComponent, [{
            type: Component,
            args: [{ selector: 'fts-article-summary', template: "<mat-toolbar color=\"primary\">\n      <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-format-list-bulleted\"></mat-icon>\n\n  <h2>\n    <span> {{'store.article_form_sheet'|translate}} </span>\n  </h2>\n  <span fxFlex></span>\n  <button mat-icon-button tabindex=\"-1\">\n    <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-close\"  [mat-dialog-close]=\"null\"></mat-icon>\n  </button>\n</mat-toolbar>\n<div mat-dialog-content  class=\"ft-content\"   fxLayout=\"column\">\n  <div [ngBusy]=\"busy\"></div>\n  <form   fxLayout=\"column\" name=\"article\" #articleForm=\"ngForm\" class=\"ft-padding\">\n\n        <div fxLayout=\"row\" fxLayoutGap=\"8px\">\n          <mat-form-field  fxFlex=\"25\"  class=\"with-error-label\">\n            <input [ftAutoFocus]=\"true\" [readonly]=\"readOnly\"\n                   matInput\n                   [placeholder]=\"'store.code'|translate\" name=\"code\"\n                   [value]=\"model?.code\"   >\n          </mat-form-field>\n          <mat-form-field fxFlex >\n            <input matInput [placeholder]=\"'store.description'|translate\"  [readonly]=\"readOnly\"\n                   name=\"description\"  [value]=\"model?.description\" required>\n          </mat-form-field>\n        </div>\n          <div fxLayout=\"row\" fxLayoutGap=\"8px\">\n              <mat-form-field fxFlex >\n                <input matInput [placeholder]=\"'store.family'|translate\"  [readonly]=\"readOnly\"\n                   name=\"family\"  [value]=\"model?.family?.name\" required>\n              </mat-form-field>\n              <mat-form-field fxFlex >\n                <input matInput [placeholder]=\"'store.default_provider'|translate\"  [readonly]=\"readOnly\"\n                   name=\"default_provider\"  [value]=\"model?.default_provider?.name\" required>\n              </mat-form-field>\n        </div>\n      <div fxLayout=\"row\" fxLayoutGap=\"8px\">\n              <mat-form-field fxFlex >\n                <input matInput [placeholder]=\"'store.purchase_unity'|translate\"  [readonly]=\"readOnly\"\n                   name=\"purchase_unity\"  [value]=\"model?.purchase_unity?.value\" required>\n              </mat-form-field>\n              <mat-form-field fxFlex >\n                <input matInput [placeholder]=\"'store.purchase_vat'|translate\"  [readonly]=\"readOnly\"\n                   name=\"purchase_vat\"  [value]=\"model?.purchase_vat?.description\" required>\n              </mat-form-field>\n            <mat-form-field fxFlex>\n              <input matInput [placeholder]=\"'store.purchase_price'|translate\" name=\"purchase_price\"\n                   [value]=\"model?.purchase_price\" [ftNumber]=\"'float'\"  [readonly]=\"readOnly\" >\n            </mat-form-field>\n            <mat-form-field fxFlex>\n              <input matInput [placeholder]=\"'store.purchase_price_max'|translate\" [ftNumber]=\"'float'\"\n                     name=\"purchase_price_max\"  [readonly]=\"readOnly\"\n                     [value]=\"model?.purchase_price_max\">\n            </mat-form-field>\n        </div>\n        <div fxLayout=\"row\" fxLayoutGap=\"8px\">\n\n            <mat-form-field fxFlex>\n              <input matInput [placeholder]=\"'store.sale_unity'|translate\" [ftNumber]=\"'float'\"\n                     name=\"sale_unity\"  [readonly]=\"readOnly\"\n                     [value]=\"model?.sale_unity?.value\">\n            </mat-form-field>\n\n            <mat-form-field fxFlex>\n              <input matInput [placeholder]=\"'store.sale_vat'|translate\" [ftNumber]=\"'float'\"\n                     name=\"sale_vat\"  [readonly]=\"readOnly\"\n                     [value]=\"model?.sale_vat?.description\">\n            </mat-form-field>\n          <mat-form-field fxFlex>\n            <input matInput\n                   [placeholder]=\"'store.sale_price'|translate\"\n                   [ftNumber]=\"'float'\" name=\"sale_price\" [readonly]=\"readOnly\"\n                   [value]=\"model?.sale_price\">\n          </mat-form-field>\n\n          <mat-form-field fxFlex>\n            <input matInput [placeholder]=\"'store.sale_price_min'|translate\" [ftNumber]=\"'float'\"\n                   name=\"sale_price_min\" [readonly]=\"readOnly\"\n                   [value]=\"model?.sale_price_min\">\n          </mat-form-field>\n        </div>\n         <div fxLayout=\"row\" fxLayoutGap=\"8px\">\n          <mat-form-field fxFlex>\n            <input matInput [placeholder]=\"'store.min_qte'|translate\" name=\"min_qte\" [ftNumber]=\"'float'\"\n                   [value]=\"model?.min_qte\"  [readonly]=\"readOnly\" >\n          </mat-form-field>\n\n          <mat-form-field fxFlex>\n            <input matInput [placeholder]=\"'store.max_qte'|translate\" name=\"max_qte\" [ftNumber]=\"'float'\"\n                   [value]=\"model?.max_qte\"  [readonly]=\"readOnly\" >\n          </mat-form-field>\n\n          <mat-form-field fxFlex>\n            <input matInput [placeholder]=\"'store.min_dep_qte'|translate\" [ftNumber]=\"'float'\" name=\"min_dep_qte\"\n                   [value]=\"model?.min_dep_qte\"  [readonly]=\"readOnly\" >\n          </mat-form-field>\n\n          <mat-form-field fxFlex>\n            <input matInput [placeholder]=\"'store.max_dep_qte'|translate\" [ftNumber]=\"'float'\" name=\"max_dep_qte\"\n                   [value]=\"model?.max_dep_qte\"  [readonly]=\"readOnly\" >\n          </mat-form-field>\n        </div>\n\n        <hr class=\"ft-sep\">\n        <div  fxLayoutGap=\"6px\" fxLayout=\"column\">\n          <h4>{{'store.store_out_rules'|translate}}</h4>\n          <mat-form-field floatLabel=\"always\" class=\"ft-radio-field\">\n            <input matInput placeholder=\"\" style=\"display: none\">\n            <mat-radio-group [value]=\"model?.evaluation\" name=\"evaluation\" color=\"primary\"    fxFlex>\n              <mat-radio-button *ngFor=\"let element of evaluations\" [value]=\"element\" [disabled]=\"readOnly\">\n                {{'store.'+element|translate}}\n              </mat-radio-button>\n            </mat-radio-group>\n\n          </mat-form-field>\n        </div>\n        <div  fxLayoutGap=\"6px\" fxLayout=\"column\" *ngIf=\"model?.id\" >\n            <h4>{{'store.management_rules'|translate}}</h4>\n           <div fxLayoutGap=\"6px\" fxFlex=\"row\">\n              <mat-slide-toggle name=\"prohibited_for_sale\" [checked]=\"model.prohibited_for_sale\"  [disabled]=\"readOnly\" color=\"primary\">\n                <span [innerHTML]=\"'store.prohibited_for_sale' | translate\"></span>\n              </mat-slide-toggle>\n\n              <mat-slide-toggle name=\"prohibited_to_purchase\" [checked]=\"model.prohibited_to_purchase\"  [disabled]=\"readOnly\" color=\"primary\">\n                <span [innerHTML]=\"'store.prohibited_to_purchase' | translate\"></span>\n              </mat-slide-toggle>\n\n              <mat-slide-toggle name=\"allows_negative_stock\" [checked]=\"model.allows_negative_stock\"  [disabled]=\"readOnly\" color=\"primary\">\n                <span [innerHTML]=\"'store.allows_negative_stock' | translate\"></span>\n              </mat-slide-toggle>\n\n              <mat-slide-toggle name=\"has_serial\" [checked]=\"model.has_serial\" [disabled]=\"readOnly || model?.has_lot_number\" color=\"primary\">\n                <span [innerHTML]=\"'store.has_serial' | translate\"></span>\n              </mat-slide-toggle>\n\n              <mat-slide-toggle name=\"has_lot_number\" [checked]=\"model.has_lot_number\"   [disabled]=\"readOnly || model?.has_serial\" color=\"primary\">\n                <span [innerHTML]=\"'store.has_lot_number' | translate\"></span>\n              </mat-slide-toggle>\n\n              <mat-slide-toggle name=\"lapsing\" [checked]=\"model.lapsing\"  [disabled]=\"readOnly\" color=\"primary\">\n                <span [innerHTML]=\"'store.lapsing' | translate\"></span>\n              </mat-slide-toggle>\n\n          </div>\n\n        </div>\n\n  </form>\n</div>\n<div mat-dialog-actions>\n<span fxFlex></span>\n  <button type=\"button\" [mat-dialog-close]=\"null\"  color=\"warn\" mat-raised-button tabindex=\"-1\">{{'shared.exit'|translate}}</button>\n</div>\n" }]
        }], function () {
        return [{ type: SharedService }, { type: i1.MatDialogRef }, { type: undefined, decorators: [{
                        type: Inject,
                        args: [MAT_DIALOG_DATA]
                    }] }];
    }, null);
})();

function AddLoadsDialogComponent_button_14_Template(rf, ctx) {
    if (rf & 1) {
        const _r2 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "button", 12);
        i0.ɵɵlistener("click", function AddLoadsDialogComponent_button_14_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r2); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.saveLoad()); });
        i0.ɵɵtext(1);
        i0.ɵɵpipe(2, "translate");
        i0.ɵɵelementEnd();
    }
    if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "shared.save"), " ");
    }
}
const _c0$m = function () { return []; };
class AddLoadsDialogComponent {
    constructor(data, dialogRef, sharedService, translate) {
        this.data = data;
        this.dialogRef = dialogRef;
        this.sharedService = sharedService;
        this.translate = translate;
        this.loads = [];
        this.linesSource = of([]);
        this.readOnly = false;
        this.columns = new BehaviorSubject([
            {
                'label': 'shared.name',
                'key': 'name',
                'type': 'text',
                "editable": !this.readOnly,
                'is_global_searchable': true
            },
            {
                'label': 'shared.price',
                'key': 'price',
                'type': 'number',
                "editable": !this.readOnly,
                'numberConfig': "float",
                min: 0
            },
            {
                label: '', key: 'actions', type: 'actions', actions: [
                    {
                        class: 'mat-warn',
                        icon: 'mdi-close-circle',
                        disabled: (r) => {
                            return this.readOnly;
                        },
                        method: (item, index, ev) => {
                            return this.removeLine(item, index);
                        },
                    }
                ]
            }
        ]);
        this.multiActions = [
            {
                icon: 'mdi-plus-box',
                class: 'mat-primary',
                isMultipleSelection: false,
                method: (item, index, ev) => {
                    this.addLoad();
                },
                disabled: () => {
                    return this.readOnly;
                }
            },
        ];
        this.loads = get(data, 'loads');
        this.linesSource = of(this.loads);
        this.readOnly = get(data, 'readOnly', false);
    }
    ngOnInit() {
    }
    removeLine(row, idx) {
        this.loads.splice(idx, 1);
        this.linesSource = of(this.loads);
    }
    saveLoad() {
        this.dialogRef.close(this.loads);
    }
    addLoad() {
        this.loads.push({
            name: null,
            price: 0,
        });
        this.linesSource = of(this.loads);
    }
}
AddLoadsDialogComponent.ɵfac = function AddLoadsDialogComponent_Factory(t) { return new (t || AddLoadsDialogComponent)(i0.ɵɵdirectiveInject(MAT_DIALOG_DATA), i0.ɵɵdirectiveInject(i1.MatDialogRef), i0.ɵɵdirectiveInject(SharedService), i0.ɵɵdirectiveInject(i3$1.TranslateService)); };
AddLoadsDialogComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AddLoadsDialogComponent, selectors: [["fts-add-loads-dialog"]], decls: 18, vars: 19, consts: [["color", "primary"], ["mat-dialog-title", ""], ["fontSet", "mdi", "fontIcon", "mdi-note-plus"], ["fxFlex", ""], ["mat-icon-button", "", "tabindex", "-1", 3, "mat-dialog-close"], ["fontSet", "mdi", "fontIcon", "mdi-close"], ["mat-dialog-content", "", "fxFill", "", 1, "ft-content"], ["fxLayout", "column", "fxFlex", "", "fxFill", "", 1, "ft-content"], [3, "remote", "source", "selectable", "hasPagination", "columns", "multiActions", "hasFooter"], ["mat-dialog-actions", ""], ["color", "primary", "mat-raised-button", "", 3, "click", 4, "ngIf"], ["color", "warn", "mat-raised-button", "", "tabindex", "-1", 3, "mat-dialog-close"], ["color", "primary", "mat-raised-button", "", 3, "click"]], template: function AddLoadsDialogComponent_Template(rf, ctx) {
        if (rf & 1) {
            i0.ɵɵelementStart(0, "mat-toolbar", 0)(1, "h2", 1);
            i0.ɵɵelement(2, "mat-icon", 2);
            i0.ɵɵtext(3);
            i0.ɵɵpipe(4, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(5, "span", 3);
            i0.ɵɵelementStart(6, "button", 4);
            i0.ɵɵelement(7, "mat-icon", 5);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(8, "div", 6)(9, "div", 7);
            i0.ɵɵelement(10, "ft-generic-body-table", 8);
            i0.ɵɵpipe(11, "async");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(12, "div", 9);
            i0.ɵɵelement(13, "span", 3);
            i0.ɵɵtemplate(14, AddLoadsDialogComponent_button_14_Template, 3, 3, "button", 10);
            i0.ɵɵelementStart(15, "button", 11);
            i0.ɵɵtext(16);
            i0.ɵɵpipe(17, "translate");
            i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 12, "shared.add_load"), "");
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("mat-dialog-close", null);
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("remote", false)("source", ctx.linesSource)("selectable", false)("hasPagination", true)("columns", i0.ɵɵpipeBind1(11, 14, ctx.columns))("multiActions", ctx.readOnly ? i0.ɵɵpureFunction0(18, _c0$m) : ctx.multiActions)("hasFooter", false);
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngIf", !ctx.readOnly);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("mat-dialog-close", null);
            i0.ɵɵadvance(1);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(17, 16, ctx.readOnly ? "shared.exit" : "shared.cancel"));
        }
    }, dependencies: [i4$1.NgIf, i6.MatButton, i1.MatDialogClose, i1.MatDialogTitle, i1.MatDialogContent, i1.MatDialogActions, i9.MatIcon, i11.MatToolbar, i8.DefaultLayoutDirective, i8.FlexFillDirective, i8.DefaultFlexDirective, i4$2.GenericBodyTableComponent, i4$1.AsyncPipe, i3$1.TranslatePipe], encapsulation: 2 });
(function () {
    (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AddLoadsDialogComponent, [{
            type: Component,
            args: [{ selector: 'fts-add-loads-dialog', template: "<mat-toolbar color=\"primary\">\n  <h2 mat-dialog-title>\n    <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-note-plus\"></mat-icon>\n    {{ 'shared.add_load' | translate }}</h2>\n  <span fxFlex></span>\n  <button mat-icon-button [mat-dialog-close]=\"null\" tabindex=\"-1\">\n    <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-close\"></mat-icon>\n  </button>\n</mat-toolbar>\n\n\n<div mat-dialog-content class=\"ft-content\" fxFill>\n\n   <div fxLayout=\"column\" fxFlex  fxFill class=\"ft-content\">\n          <ft-generic-body-table\n            [remote]=\"false\"\n            [source]=\"linesSource\"\n            [selectable]=\"false\"\n            [hasPagination]=\"true\"\n            [columns]=\"columns| async\"\n            [multiActions]=\"readOnly ? []: multiActions\"\n            [hasFooter]=\"false\"\n          ></ft-generic-body-table>\n        </div>\n</div>\n<div mat-dialog-actions>\n  <span fxFlex></span>\n  <button color=\"primary\"  *ngIf=\"!readOnly\" mat-raised-button (click)=\"saveLoad()\" >\n    {{'shared.save'|translate}}\n  </button>\n\n\n  <button [mat-dialog-close]=\"null\" color=\"warn\" mat-raised-button tabindex=\"-1\">{{ (readOnly ?'shared.exit':'shared.cancel')|translate}}</button>\n</div>\n" }]
        }], function () {
        return [{ type: undefined, decorators: [{
                        type: Inject,
                        args: [MAT_DIALOG_DATA]
                    }] }, { type: i1.MatDialogRef }, { type: SharedService }, { type: i3$1.TranslateService }];
    }, null);
})();

const _c0$l = function () { return []; };
class DocumentLinesComponent {
    constructor(route, dialog, translateService, sharedService, defaultValuesService) {
        this.route = route;
        this.dialog = dialog;
        this.translateService = translateService;
        this.sharedService = sharedService;
        this.defaultValuesService = defaultValuesService;
        this.readOnly = false;
        this.linesSource = of([]);
        this.columns = [
            {
                "label": "shared.deposition_abbreviate",
                "key": "deposition_number",
                "type": "text",
                callBack: (r) => {
                    return get(r, 'source_document._model') == 'DepositionForm' ? get(r, 'source_document.number') : "";
                },
                class: 'minimal-text'
            },
            {
                "label": "shared.receipt_abbreviate",
                "key": "receipt_number",
                "type": "text",
                callBack: (r) => {
                    return get(r, 'source_document._model') == 'PurchaseReceipt' ? get(r, 'source_document.number') : "";
                },
                class: 'minimal-text'
            },
            {
                "label": "shared.consignment_abbreviate",
                "key": "consignment_number",
                "type": "text",
                callBack: (r) => {
                    return get(r, 'source_document._model') == 'Consignment' ? get(r, 'source_document.number') : "";
                },
                class: 'minimal-text'
            },
            {
                "label": "shared.purchase_order_abbreviate",
                "key": "order_number",
                "type": "text",
                callBack: (r) => {
                    return get(r, 'source_document._model') == 'PurchaseOrder' ? get(r, 'source_document.number') : "";
                },
                class: 'minimal-text'
            }, {
                "label": "shared.price_request_abbreviate",
                "key": "price_request_number",
                "type": "text",
                callBack: (r) => {
                    return get(r, 'source_document._model') == 'PriceRequest' ? get(r, 'source_document.number') : "";
                },
                class: 'minimal-text'
            },
            {
                "label": "store.code",
                "key": "code",
                "type": "text"
            },
            {
                "label": "store.description",
                "key": "description",
                "type": "text",
                "editable": true,
                'extended': true
            },
            {
                "label": "store.quantity",
                "key": "qte",
                "type": "number",
                "editable": true,
                numberConfig: 'float'
            },
            {
                "label": "store.price",
                "key": "price",
                "type": "number",
                "editable": true,
                numberConfig: 'float'
            },
            {
                "label": "store.vat",
                "key": "vat",
                "type": "select",
                "editable": true,
                "selector": "description",
                "source": this.sharedService.getDocuments('list/vat'),
            },
            {
                "label": "store.depot",
                "key": "store",
                "type": "select",
                "selector": "name",
                "editable": true,
                "source": this.sharedService.getDocuments('store/depot')
            },
            {
                "label": "store.destination_depot",
                "key": "destination",
                "type": "select",
                "selector": "name",
                "editable": true,
                "source": this.sharedService.getDocuments('store/depot'),
                "class": "hidden"
            },
            {
                "label": "store.total_sous",
                "key": "sub_total",
                "type": "number",
                "numberConfig": "float",
                "callBack": (row) => {
                    return row.sub_total = handleSubTotal(row, this.priceMode);
                }
            }
        ];
        this.multiActions = [
            {
                class: 'mat-primary',
                icon: 'mdi-playlist-plus',
                isMultipleSelection: false,
                method: (item, ev) => {
                    return this.showSelectionDialog();
                },
                disabled: (item) => {
                    return !this.defaultDepot && includes(['OUT', 'Consignment'], this.movementType);
                },
                tooltip: this.translateService.instant('shared.add')
            },
            {
                class: 'mat-primary',
                icon: 'mdi-note-plus',
                isMultipleSelection: false,
                method: (item, ev) => {
                    return this.showLoadDialog();
                },
                hidden: (item) => {
                    return this.movementType != 'PurchaseInvoice';
                },
                tooltip: this.translateService.instant('shared.add_load')
            },
            {
                class: 'mat-accent',
                icon: 'mdi-comment-plus-outline',
                isMultipleSelection: false,
                method: (item, ev) => {
                    return this.addComment();
                },
                tooltip: this.translateService.instant('shared.add_comment')
            }
        ];
        this.actionColumn = {
            label: '', key: 'actions', type: 'actions', actions: [
                {
                    class: 'mat-primary',
                    icon: 'mdi-text-box',
                    method: (item, index, ev) => {
                        this.showArticleDetails(item);
                    },
                    tooltip: "shared.article_details",
                    disabled: (item) => {
                        return get(item, 'is_comment');
                    },
                },
                {
                    icon: 'mdi-alpha-s-circle',
                    method: (item, index, ev) => {
                        this.handleSerials(item);
                    },
                    disabled: (item) => {
                        return !get(item, 'article.has_serial') || !get(item, 'store.id', null);
                    },
                    hidden: (item) => {
                        return get(item, 'article.has_lot_number');
                    },
                    class: (line) => {
                        if (line.qte != get(line, 'serials_list', []).length) {
                            return 'mat-warn';
                        }
                        else {
                            return 'success-color';
                        }
                    },
                    tooltip: "shared.serial_numbers"
                },
                {
                    icon: 'mdi-alpha-l-circle',
                    method: (item, index, ev) => {
                        this.handleLots(item);
                    },
                    hidden: (item) => {
                        return !get(item, 'article.has_lot_number', false);
                    },
                    disabled: (item) => {
                        return !get(item, 'store.id', null);
                    },
                    class: (line) => {
                        return line.qte != chain(line).get('lots_list').sumBy('store_qte').value() ? 'mat-warn' : 'success-color';
                    },
                    tooltip: "shared.lot_numbers"
                },
                {
                    class: 'mat-warn',
                    icon: 'mdi-close-circle',
                    method: (item, index, ev) => {
                        return this.removeLine(item, index);
                    },
                    disabled: () => {
                        return this.readOnly;
                    },
                    tooltip: "shared.delete"
                }
            ]
        };
        this.extendedColHandler = (index, item) => get(item, 'is_comment') === true;
        this.modelLines = [];
        this.modelLoads = null;
        this.priceMode = null;
        this.defaultDepot = null;
        this.movementType = null;
        this.optionalDepot = null;
        this.displayedCols = [];
        this.provider = null;
        this.linesChange = new EventEmitter();
        this.loadsChange = new EventEmitter();
    }
    set handleOptionalDepot(value) {
        this.optionalDepot = value;
    }
    set handlePriceMode(value) {
        this.priceMode = value;
        forEach(this.modelLines, (row) => {
            row.sub_total = handleSubTotal(row, this.priceMode);
        });
        this.linesSource = of(this.modelLines);
    }
    set handleDepot(value) {
        this.defaultDepot = value;
    }
    set handleMovementType(value) {
        this.movementType = value;
    }
    set handleReadOnly(value) {
        this.readOnly = value;
    }
    set handleDisplayedCols(value) {
        this.displayedCols = value;
    }
    set lines(value) {
        if (!isUndefined(value)) {
            this.modelLines = value;
            this.linesSource = of(value);
        }
    }
    set loads(value) {
        if (!isUndefined(value)) {
            this.modelLoads = value;
        }
    }
    set handlePovider(value) {
        if (!isNil(value)) {
            this.provider = value;
        }
    }
    ngOnInit() {
        this.linesColumns = new BehaviorSubject(reject(this.columns, (c) => {
            return !includes(this.displayedCols, c.key);
        }).concat(this.actionColumn));
    }
    addComment() {
        this.modelLines.push({
            code: '',
            description: '',
            is_comment: true
        });
        this.linesSource = of(this.modelLines);
    }
    showArticleDetails(row) {
        this.dialog.open(ArticleSummaryDialogComponent, assignIn(LARGE_DIALOG, {
            data: {
                id: get(row, 'article.id')
            },
            disableClose: true
        })).afterClosed().subscribe(noop);
    }
    handleSerials(row) {
        this.handleSerialDialog(row).afterClosed().subscribe(data => {
            if (data) {
                row.serials_list = data;
                this.linesSource = of(this.modelLines);
            }
        });
    }
    handleLots(row) {
        this.handleLotDialog(row).afterClosed().subscribe(data => {
            if (data) {
                row.lots_list = data;
                this.linesSource = of(this.modelLines);
            }
        });
    }
    handleSerialDialog(row) {
        let data = {
            data: {
                serials: cloneDeep(get(row, 'serials_list', [])),
                qte: get(row, 'qte', 0),
                article: get(row, 'article.id', null),
                depot: get(row, 'store.id', null),
                readOnly: this.readOnly,
                movementType: this.movementType,
                sourceDoc: pick(get(row, 'source_document'), 'id', '_model')
            }
        };
        switch (this.movementType) {
            case 'IN':
            case 'DISASSEMBLING':
            case 'DepositionForm':
                return this.dialog.open(InSerialDialogComponent, assignIn(SMALL_DIALOG, data));
                break;
            case 'OUT':
            case 'ASSEMBLY':
            case 'StoreExchange':
            case 'ReturnForm':
            case 'Consignment':
            case 'ConsignmentReturn':
            case 'PurchaseInvoice':
                return this.dialog.open(OutSerialDialogComponent, assignIn(MEDIUM_DIALOG, data));
                break;
            case 'PurchaseReceipt':
                if (get(row, 'source_document._model') == 'DepositionForm') {
                    return this.dialog.open(OutSerialDialogComponent, assignIn(MEDIUM_DIALOG, data));
                }
                else {
                    return this.dialog.open(InSerialDialogComponent, assignIn(SMALL_DIALOG, data));
                }
                break;
        }
    }
    handleLotDialog(row) {
        let data = {
            data: {
                lots: cloneDeep(get(row, 'lots_list', [])),
                qte: get(row, 'qte', 0),
                article: get(row, 'article.id', null),
                depot: get(row, 'store.id', null),
                readOnly: this.readOnly,
                movementType: this.movementType,
                sourceDoc: pick(get(row, 'source_document'), 'id', '_model')
            }
        };
        switch (this.movementType) {
            case 'IN':
            case 'DISASSEMBLING':
            case 'DepositionForm':
                return this.dialog.open(InLotDialogComponent, assignIn(MEDIUM_DIALOG, data));
                break;
            case 'OUT':
            case 'ASSEMBLY':
            case 'StoreExchange':
            case 'ReturnForm':
            case 'Consignment':
            case 'ConsignmentReturn':
            case 'PurchaseInvoice':
                return this.dialog.open(OutLotDialogComponent, assignIn(MEDIUM_DIALOG, data));
                break;
            case 'PurchaseReceipt':
                if (get(row, 'source_document._model') == 'DepositionForm') {
                    return this.dialog.open(OutLotDialogComponent, assignIn(MEDIUM_DIALOG, data));
                }
                else {
                    return this.dialog.open(InLotDialogComponent, assignIn(MEDIUM_DIALOG, data));
                }
                break;
        }
    }
    removeLine(row, index) {
        this.modelLines.splice(index, 1);
        this.linesSource = of(this.modelLines);
    }
    showSelectionDialog() {
        this.dialog.open(LinesDialogComponent, assignIn(LARGE_DIALOG, {
            data: {
                cls: this.movementType,
                query: {
                    article: this.handleArticleQuery(),
                    PriceRequest: this.handlePriceRequestQuery(),
                    PurchaseOrder: this.handlePurchaseOrderQuery(),
                    PurchaseReceipt: this.handlePurchaseReceiptQuery(),
                    ReturnForm: this.handleReturnFormQuery(),
                    DepositionForm: this.handleDepositionFormQuery(),
                    Consignment: this.handleConsignmentQuery()
                },
                selectable: true
            },
            disableClose: true
        })).afterClosed().subscribe(this.handleLines.bind(this));
    }
    handleLines(data) {
        let articleLines = this.handleArticleLines(get(data, 'article', []));
        let documentLines = this.handleDocuments(omit(data, "article"));
        //
        // if (data && !this.checkExistence(data)) {
        //   this.linesChange.emit(this.model.lines);
        // }
        this.modelLines = chain(this.modelLines).concat(articleLines, documentLines).value();
        this.handleLinesChange();
    }
    handleLinesChange() {
        this.linesChange.emit(this.modelLines);
        this.linesSource = of(this.modelLines);
    }
    handleArticleLines(articles) {
        return map(articles, item => chain(item)
            .pick("code", "description")
            .assign({
            article: item,
            qte: 1,
            store: this.defaultDepot,
            lots_list: [],
            serials_list: [],
        }, this.switchVatPrice(item), this.movementType == 'StoreExchange' ? { destination: this.optionalDepot } : {})
            .value());
    }
    prepareDocumentsLines(document, documentType) {
        if (documentType) {
            let lines = this.chooseLines(document, documentType);
            return map(lines, line => assignIn(line, {
                source_document: { id: document.id, _cls: documentType, _model: documentType, number: document.number },
                lots_list: [],
                serials_list: [],
                store: this.defaultDepot
            }));
        }
    }
    chooseLines(document, documentType) {
        let newLines = reject(document.lines, line => {
            return find(this.modelLines, l => l.code == line.code && l.uid == line.uid && l.source_document._model == documentType);
        });
        switch (documentType) {
            case "PriceRequest":
                return chain(newLines).filter(line => {
                    return get(line, 'qte') > get(line, 'commanded_qte');
                }).map(line => assignIn(line, { qte: get(line, 'qte') - get(line, 'commanded_qte') })).value();
            case "PurchaseOrder":
                return chain(newLines).filter(line => {
                    return get(line, 'qte') > get(line, 'receipted_qte');
                }).map(line => assignIn(line, { qte: get(line, 'qte') - get(line, 'receipted_qte') })).value();
            case "DepositionForm":
                return chain(newLines).filter(line => {
                    return get(line, 'qte', 0) > (get(line, 'receipted_qte', 1) + get(line, 'returned_qte', 1));
                }).map(line => assignIn(line, { qte: get(line, 'qte') - (get(line, 'receipted_qte', 1) + get(line, 'returned_qte', 1)) })).value();
            default:
                return document.lines;
        }
    }
    handleDocuments(data) {
        return reduce(data, (newLines, documents, type) => {
            return reduce(documents, (documentLines, document) => {
                return concat(documentLines, this.prepareDocumentsLines(document, type));
            }, newLines);
        }, []);
    }
    switchVatPrice(item) {
        switch (this.movementType) {
            case 'IN':
            case 'DISASSEMBLING':
            case 'DepositionForm':
            case 'PurchaseReceipt':
            case 'ReturnForm':
                return {
                    price: get(item, 'purchase_price', 0),
                    vat: get(item, 'purchase_vat', this.defaultValuesService.getValue('default_sale_vat'))
                };
            case 'OUT':
            case 'ASSEMBLY':
            case 'StoreExchange':
            case 'Consignment':
            case 'ConsignmentReturn':
                return {
                    price: get(item, 'pmp') || get(item, 'sale_price', 0),
                    vat: get(item, 'sale_vat', this.defaultValuesService.getValue('default_sale_vat'))
                };
            case 'PriceRequest':
            case 'PurchaseOrder':
                return { price: get(item, 'purchase_price', 0), vat: null };
            default:
                return {
                    price: get(item, 'purchase_price', 0),
                    vat: get(item, 'purchase_vat', this.defaultValuesService.getValue('default_sale_vat'))
                };
        }
    }
    handleArticleQuery() {
        switch (this.movementType) {
            case 'IN':
            case 'DepositionForm':
            case 'PurchaseReceipt':
            case 'PurchaseOrder':
                return [{ key: "prohibited_to_purchase", value: false, logical_operator: 'and', operator: '$eq' }];
            case 'OUT':
            case 'ASSEMBLY':
            case 'StoreExchange':
            case 'Consignment':
                return [{ key: "allows_negative_stock", value: true, logical_operator: 'or', operator: '$eq' },
                    { key: "prohibited_for_sale", value: false, logical_operator: 'and', operator: '$eq' },
                    { key: "theo_stores.depot", value: this.defaultDepot.id, logical_operator: 'and', operator: '$eq' },
                    { key: "theo_stores.store_qte", value: 0, logical_operator: 'or', operator: '$gt' },
                    { key: "theo_stores.deposition_qte", value: 0, logical_operator: 'or', operator: '$gt' },
                ];
            default:
                return [];
        }
    }
    handlePriceRequestQuery() {
        switch (this.movementType) {
            case 'PurchaseReceipt':
            case 'PurchaseOrder':
                return [...[{ key: "state.is_valid", value: true, logical_operator: 'and', operator: '$eq' },
                        { key: "fully_commanded", value: false, logical_operator: 'and', operator: '$eq' },
                        { key: "fully_receipted", value: false, logical_operator: 'and', operator: '$eq' },
                    ], ...this.provider ? [{
                            key: "providers",
                            logical_operator: 'and',
                            operator: '$elemMatch',
                            value: { '$eq': this.provider.id }
                        }] : []];
            default:
                return [];
        }
    }
    handlePurchaseOrderQuery() {
        if (this.movementType == 'PurchaseReceipt') {
            return [...[{ key: "state.is_valid", value: true, logical_operator: 'and', operator: '$eq' },
                    { key: "fully_receipted", value: false, logical_operator: 'and', operator: '$eq' },
                ], ...this.provider ? [{
                        key: "provider",
                        logical_operator: 'and',
                        operator: '$eq',
                        value: this.provider.id
                    }] : []];
        }
        else
            return [];
    }
    handlePurchaseReceiptQuery() {
        switch (this.movementType) {
            case 'ReturnForm':
            case 'PurchaseInvoice':
                return [...[{ key: "state.is_valid", value: true, logical_operator: 'and', operator: '$eq' },
                        { key: "fully_returned", value: false, logical_operator: 'and', operator: '$eq' },
                    ], ...this.provider ? [{
                            key: "provider",
                            logical_operator: 'and',
                            operator: '$eq',
                            value: this.provider.id
                        }] : []];
            default:
                return [];
        }
    }
    handleReturnFormQuery() {
        switch (this.movementType) {
            case 'ReturnForm':
            case 'PurchaseInvoice':
                return [...[{ key: "state.is_valid", value: true, logical_operator: 'and', operator: '$eq' },
                    ], ...this.provider ? [{
                            key: "provider",
                            logical_operator: 'and',
                            operator: '$eq',
                            value: this.provider.id
                        }] : []];
            default:
                return [];
        }
    }
    handleDepositionFormQuery() {
        switch (this.movementType) {
            case 'ReturnForm':
            case 'PurchaseReceipt':
                return [...[{ key: "state.is_valid", value: true, logical_operator: 'and', operator: '$eq' },
                        { key: "fully_used", value: false, logical_operator: 'and', operator: '$eq' },
                    ], ...this.provider ? [{
                            key: "provider",
                            logical_operator: 'and',
                            operator: '$eq',
                            value: this.provider.id
                        }] : []];
            default:
                return [];
        }
    }
    handleConsignmentQuery() {
        switch (this.movementType) {
            case 'ConsignmentReturn':
                return [{ key: "state.is_valid", value: true, logical_operator: 'and', operator: '$eq' },
                    { key: "fully_returned", value: false, logical_operator: 'and', operator: '$eq' }];
            default:
                return [];
        }
    }
    showLoadDialog() {
        this.dialog.open(AddLoadsDialogComponent, assignIn(LARGE_DIALOG, {
            data: { loads: cloneDeep(this.modelLoads) }, disableClose: true
        })).afterClosed().subscribe(data => {
            if (data) {
                this.modelLoads = data;
                this.loadsChange.emit(this.modelLoads);
            }
        });
    }
}
DocumentLinesComponent.ɵfac = function DocumentLinesComponent_Factory(t) { return new (t || DocumentLinesComponent)(i0.ɵɵdirectiveInject(i3.ActivatedRoute), i0.ɵɵdirectiveInject(i1.MatDialog), i0.ɵɵdirectiveInject(i3$1.TranslateService), i0.ɵɵdirectiveInject(SharedService), i0.ɵɵdirectiveInject(i2.DefaultValuesService)); };
DocumentLinesComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DocumentLinesComponent, selectors: [["fts-document-lines"]], inputs: { handleOptionalDepot: ["optionalDepot", "handleOptionalDepot"], handlePriceMode: ["priceMode", "handlePriceMode"], handleDepot: ["defaultDepot", "handleDepot"], handleMovementType: ["movementType", "handleMovementType"], handleReadOnly: ["readOnly", "handleReadOnly"], handleDisplayedCols: ["displayedCols", "handleDisplayedCols"], lines: "lines", loads: "loads", handlePovider: ["provider", "handlePovider"] }, outputs: { linesChange: "linesChange", loadsChange: "loadsChange" }, decls: 3, vars: 11, consts: [["fxLayout", "column", "fxFlex", "", "fxFill", "", 1, "ft-content"], [3, "remote", "source", "selectable", "hasPagination", "columns", "multiActions", "hasFooter", "extendedHandler"]], template: function DocumentLinesComponent_Template(rf, ctx) {
        if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵelement(1, "ft-generic-body-table", 1);
            i0.ɵɵpipe(2, "async");
            i0.ɵɵelementEnd();
        }
        if (rf & 2) {
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("remote", false)("source", ctx.linesSource)("selectable", false)("hasPagination", true)("columns", i0.ɵɵpipeBind1(2, 8, ctx.linesColumns))("multiActions", ctx.readOnly ? i0.ɵɵpureFunction0(10, _c0$l) : ctx.multiActions)("hasFooter", false)("extendedHandler", ctx.extendedColHandler);
        }
    }, dependencies: [i8.DefaultLayoutDirective, i8.FlexFillDirective, i8.DefaultFlexDirective, i4$2.GenericBodyTableComponent, i4$1.AsyncPipe], styles: [".table-container .mat-table .minimal-text{max-width:45px}"] });
(function () {
    (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DocumentLinesComponent, [{
            type: Component,
            args: [{ selector: 'fts-document-lines', template: "<div fxLayout=\"column\" fxFlex  fxFill class=\"ft-content\">\n  <ft-generic-body-table\n    [remote]=\"false\"\n    [source]=\"linesSource\"\n    [selectable]=\"false\"\n    [hasPagination]=\"true\"\n    [columns]=\"linesColumns| async\"\n    [multiActions]=\"readOnly ? [] : multiActions\"\n    [hasFooter]=\"false\"\n    [extendedHandler]=\"extendedColHandler\"\n  ></ft-generic-body-table>\n</div>\n", styles: ["::ng-deep .table-container .mat-table .minimal-text{max-width:45px}\n"] }]
        }], function () { return [{ type: i3.ActivatedRoute }, { type: i1.MatDialog }, { type: i3$1.TranslateService }, { type: SharedService }, { type: i2.DefaultValuesService }]; }, { handleOptionalDepot: [{
                type: Input,
                args: ['optionalDepot']
            }], handlePriceMode: [{
                type: Input,
                args: ['priceMode']
            }], handleDepot: [{
                type: Input,
                args: ['defaultDepot']
            }], handleMovementType: [{
                type: Input,
                args: ['movementType']
            }], handleReadOnly: [{
                type: Input,
                args: ['readOnly']
            }], handleDisplayedCols: [{
                type: Input,
                args: ['displayedCols']
            }], lines: [{
                type: Input
            }], linesChange: [{
                type: Output
            }], loads: [{
                type: Input
            }], handlePovider: [{
                type: Input,
                args: ['provider']
            }], loadsChange: [{
                type: Output
            }] });
})();

function DocumentFooterComponent_ng_container_11_span_2_Template(rf, ctx) {
    if (rf & 1) {
        i0.ɵɵelementStart(0, "span");
        i0.ɵɵtext(1);
        i0.ɵɵpipe(2, "translate");
        i0.ɵɵelementEnd();
    }
    if (rf & 2) {
        const i_r7 = ctx.$implicit;
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate2("", i0.ɵɵpipeBind1(2, 2, "shared.amount_vat_line"), " ", i_r7.label, "%");
    }
}
function DocumentFooterComponent_ng_container_11_Template(rf, ctx) {
    if (rf & 1) {
        i0.ɵɵelementContainerStart(0);
        i0.ɵɵelement(1, "hr", 5);
        i0.ɵɵtemplate(2, DocumentFooterComponent_ng_container_11_span_2_Template, 3, 4, "span", 6);
        i0.ɵɵelement(3, "hr", 5);
        i0.ɵɵelementContainerEnd();
    }
    if (rf & 2) {
        const ctx_r0 = i0.ɵɵnextContext();
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngForOf", ctx_r0.groupedVat());
    }
}
function DocumentFooterComponent_ng_container_15_Template(rf, ctx) {
    if (rf & 1) {
        i0.ɵɵelementContainerStart(0);
        i0.ɵɵelementStart(1, "span");
        i0.ɵɵtext(2);
        i0.ɵɵpipe(3, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementContainerEnd();
    }
    if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 1, "shared.add_load"));
    }
}
function DocumentFooterComponent_ng_container_22_span_2_Template(rf, ctx) {
    if (rf & 1) {
        i0.ɵɵelementStart(0, "span");
        i0.ɵɵtext(1, ":");
        i0.ɵɵelementEnd();
    }
}
function DocumentFooterComponent_ng_container_22_Template(rf, ctx) {
    if (rf & 1) {
        i0.ɵɵelementContainerStart(0);
        i0.ɵɵelement(1, "hr", 5);
        i0.ɵɵtemplate(2, DocumentFooterComponent_ng_container_22_span_2_Template, 2, 0, "span", 6);
        i0.ɵɵelement(3, "hr", 5);
        i0.ɵɵelementContainerEnd();
    }
    if (rf & 2) {
        const ctx_r2 = i0.ɵɵnextContext();
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngForOf", ctx_r2.groupedVat());
    }
}
function DocumentFooterComponent_ng_container_25_Template(rf, ctx) {
    if (rf & 1) {
        i0.ɵɵelementContainerStart(0);
        i0.ɵɵelementStart(1, "span");
        i0.ɵɵtext(2, ":");
        i0.ɵɵelementEnd();
        i0.ɵɵelementContainerEnd();
    }
}
function DocumentFooterComponent_ng_container_32_span_2_Template(rf, ctx) {
    if (rf & 1) {
        i0.ɵɵelementStart(0, "span");
        i0.ɵɵtext(1);
        i0.ɵɵpipe(2, "ftNumber");
        i0.ɵɵelementEnd();
    }
    if (rf & 2) {
        const i_r11 = ctx.$implicit;
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(2, 1, i_r11.value, "float"));
    }
}
function DocumentFooterComponent_ng_container_32_Template(rf, ctx) {
    if (rf & 1) {
        i0.ɵɵelementContainerStart(0);
        i0.ɵɵelement(1, "hr", 5);
        i0.ɵɵtemplate(2, DocumentFooterComponent_ng_container_32_span_2_Template, 3, 4, "span", 6);
        i0.ɵɵelement(3, "hr", 5);
        i0.ɵɵelementContainerEnd();
    }
    if (rf & 2) {
        const ctx_r4 = i0.ɵɵnextContext();
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngForOf", ctx_r4.groupedVat());
    }
}
function DocumentFooterComponent_ng_container_36_Template(rf, ctx) {
    if (rf & 1) {
        i0.ɵɵelementContainerStart(0);
        i0.ɵɵelementStart(1, "span");
        i0.ɵɵtext(2);
        i0.ɵɵpipe(3, "ftNumber");
        i0.ɵɵelementEnd();
        i0.ɵɵelementContainerEnd();
    }
    if (rf & 2) {
        const ctx_r5 = i0.ɵɵnextContext();
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(3, 1, ctx_r5.loads_amount(), "float"));
    }
}
class DocumentFooterComponent {
    constructor() {
        this.modelLines = [];
        this.modelLoads = [];
        this.priceMode = null;
        this.textAmount = '';
        this.linesChange = new EventEmitter();
        this.loadsChange = new EventEmitter();
    }
    set handlePriceMode(value) {
        this.priceMode = value;
    }
    set lines(value) {
        if (!isUndefined(value)) {
            this.modelLines = value;
        }
    }
    set loads(value) {
        if (!isUndefined(value)) {
            this.modelLoads = value;
        }
    }
    set handleTextAmount(value) {
        this.textAmount = value;
    }
    ngOnInit() {
    }
    ht_amount() {
        return sumBy(this.modelLines, (l) => {
            return getLinePrice(l, this.priceMode);
        });
    }
    ttc_amount() {
        return chain(this.modelLines).reject((l) => {
            return l['is_comment'];
        }).sumBy('sub_total').value() + this.loads_amount();
    }
    tva_amount() {
        return sumBy(this.modelLines, (l) => {
            return getLineVat(l, this.priceMode);
        });
    }
    loads_amount() {
        return sumBy(this.modelLoads, 'price');
    }
    groupedVat() {
        return chain(this.modelLines).reject((l) => {
            return l['is_comment'] || isNil(l['vat']);
        }).groupBy('vat.value').mapValues((v) => {
            return sumBy(v, (l) => {
                return getLineVat(l, this.priceMode);
            });
        }).map((v, k) => {
            return { label: k, value: v };
        }).value();
    }
}
DocumentFooterComponent.ɵfac = function DocumentFooterComponent_Factory(t) { return new (t || DocumentFooterComponent)(); };
DocumentFooterComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DocumentFooterComponent, selectors: [["fts-document-footer"]], inputs: { handlePriceMode: ["priceMode", "handlePriceMode"], lines: "lines", loads: "loads", handleTextAmount: ["textAmount", "handleTextAmount"] }, outputs: { linesChange: "linesChange", loadsChange: "loadsChange" }, decls: 40, vars: 30, consts: [[1, "ft-amounts"], [1, "flex-nogrow"], ["fxFlex", ""], ["fxLayout", "row", 1, "amounts"], [4, "ngIf"], [1, "ft-sep"], [4, "ngFor", "ngForOf"]], template: function DocumentFooterComponent_Template(rf, ctx) {
        if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "h4")(2, "span", 1);
            i0.ɵɵtext(3);
            i0.ɵɵpipe(4, "titlecase");
            i0.ɵɵelementEnd()();
            i0.ɵɵelement(5, "span", 2);
            i0.ɵɵelementStart(6, "div", 3)(7, "div")(8, "span");
            i0.ɵɵtext(9);
            i0.ɵɵpipe(10, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(11, DocumentFooterComponent_ng_container_11_Template, 4, 1, "ng-container", 4);
            i0.ɵɵelementStart(12, "span");
            i0.ɵɵtext(13);
            i0.ɵɵpipe(14, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(15, DocumentFooterComponent_ng_container_15_Template, 4, 3, "ng-container", 4);
            i0.ɵɵelementStart(16, "span");
            i0.ɵɵtext(17);
            i0.ɵɵpipe(18, "translate");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(19, "div")(20, "span");
            i0.ɵɵtext(21, ":");
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(22, DocumentFooterComponent_ng_container_22_Template, 4, 1, "ng-container", 4);
            i0.ɵɵelementStart(23, "span");
            i0.ɵɵtext(24, ":");
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(25, DocumentFooterComponent_ng_container_25_Template, 3, 0, "ng-container", 4);
            i0.ɵɵelementStart(26, "span");
            i0.ɵɵtext(27, ":");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(28, "div")(29, "span");
            i0.ɵɵtext(30);
            i0.ɵɵpipe(31, "ftNumber");
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(32, DocumentFooterComponent_ng_container_32_Template, 4, 1, "ng-container", 4);
            i0.ɵɵelementStart(33, "span");
            i0.ɵɵtext(34);
            i0.ɵɵpipe(35, "ftNumber");
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(36, DocumentFooterComponent_ng_container_36_Template, 4, 4, "ng-container", 4);
            i0.ɵɵelementStart(37, "span");
            i0.ɵɵtext(38);
            i0.ɵɵpipe(39, "ftNumber");
            i0.ɵɵelementEnd()()()();
        }
        if (rf & 2) {
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 13, ctx.textAmount));
            i0.ɵɵadvance(6);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(10, 15, "shared.ht_amount"));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.groupedVat().length > 1);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(14, 17, "shared.vat_amount"));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.modelLoads.length > 0);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(18, 19, "shared.ttc_amount"));
            i0.ɵɵadvance(5);
            i0.ɵɵproperty("ngIf", ctx.groupedVat().length > 1);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngIf", ctx.modelLoads.length > 0);
            i0.ɵɵadvance(5);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(31, 21, ctx.ht_amount(), "float"));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.groupedVat().length > 1);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(35, 24, ctx.tva_amount(), "float"));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.modelLoads.length > 0);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(39, 27, ctx.ttc_amount(), "float"));
        }
    }, dependencies: [i4$1.NgForOf, i4$1.NgIf, i8.DefaultLayoutDirective, i8.DefaultFlexDirective, i4$1.TitleCasePipe, i3$1.TranslatePipe, i2.NumberPipe], styles: [".ft-amounts[_ngcontent-%COMP%]{margin-top:1%;padding:12px}.ft-amounts[_ngcontent-%COMP%]   .amounts[_ngcontent-%COMP%]{font-size:16px}.ft-amounts[_ngcontent-%COMP%]   .amounts[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]:first-child{float:left}.ft-amounts[_ngcontent-%COMP%]   .amounts[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]:nth-child(2){display:inline-block;margin:0 8px}.ft-amounts[_ngcontent-%COMP%]   .amounts[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]:last-child{font-weight:500;float:right;text-align:-webkit-right}.ft-amounts[_ngcontent-%COMP%]   .amounts[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]:last-child > span[_ngcontent-%COMP%]{min-width:60px;text-align:right}.ft-amounts[_ngcontent-%COMP%]   .amounts[_ngcontent-%COMP%]   div[_ngcontent-%COMP%] > span[_ngcontent-%COMP%]{display:table;text-transform:uppercase;font-weight:500;margin-top:8px}"] });
(function () {
    (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DocumentFooterComponent, [{
            type: Component,
            args: [{ selector: 'fts-document-footer', template: "<div class=\"ft-amounts\">\n  <h4>\n      <span class=\"flex-nogrow\" >{{textAmount | titlecase}}</span>\n  </h4>\n<span fxFlex=\"\" ></span>\n<div class=\"amounts\" fxLayout=\"row\">\n  <div>\n  <span>{{'shared.ht_amount'|translate }}</span>\n  <ng-container *ngIf=\"groupedVat().length>1\">\n      <hr class=\"ft-sep\">\n      <span *ngFor=\"let i of groupedVat()\">{{'shared.amount_vat_line'| translate}} {{i.label}}%</span>\n      <hr class=\"ft-sep\">\n  </ng-container>\n  <span>{{'shared.vat_amount'|translate }}</span>\n  <ng-container *ngIf=\"modelLoads.length>0\">\n      <span>{{'shared.add_load'|translate }}</span>\n   </ng-container>\n  <span>{{'shared.ttc_amount'|translate }}</span>\n  </div>\n  <div>\n    <span>:</span>\n    <ng-container *ngIf=\"groupedVat().length>1\">\n        <hr class=\"ft-sep\">\n        <span *ngFor=\"let i of groupedVat()\">:</span>\n        <hr class=\"ft-sep\">\n    </ng-container>\n    <span>:</span>\n    <ng-container *ngIf=\"modelLoads.length>0\">\n        <span>:</span>\n    </ng-container>\n    <span>:</span>\n  </div>\n  <div>\n    <span>{{ht_amount() | ftNumber:'float'}}</span>\n    <ng-container *ngIf=\"groupedVat().length>1\">\n        <hr class=\"ft-sep\">\n        <span *ngFor=\"let i of groupedVat()\">{{i.value| ftNumber:'float'}}</span>\n        <hr class=\"ft-sep\">\n    </ng-container>\n    <span>{{tva_amount() | ftNumber:'float'}}</span>\n    <ng-container *ngIf=\"modelLoads.length>0\">\n         <span>{{loads_amount() | ftNumber:'float'}}</span>\n    </ng-container>\n    <span>{{ttc_amount() | ftNumber:'float'}}</span>\n  </div>\n</div>\n</div>\n", styles: [".ft-amounts{margin-top:1%;padding:12px}.ft-amounts .amounts{font-size:16px}.ft-amounts .amounts div:first-child{float:left}.ft-amounts .amounts div:nth-child(2){display:inline-block;margin:0 8px}.ft-amounts .amounts div:last-child{font-weight:500;float:right;text-align:-webkit-right}.ft-amounts .amounts div:last-child>span{min-width:60px;text-align:right}.ft-amounts .amounts div>span{display:table;text-transform:uppercase;font-weight:500;margin-top:8px}\n"] }]
        }], function () { return []; }, { handlePriceMode: [{
                type: Input,
                args: ['priceMode']
            }], lines: [{
                type: Input
            }], linesChange: [{
                type: Output
            }], loads: [{
                type: Input
            }], loadsChange: [{
                type: Output
            }], handleTextAmount: [{
                type: Input,
                args: ['textAmount']
            }] });
})();

function DocumentDetailsComponent_div_3_Template(rf, ctx) {
    if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 8);
        i0.ɵɵelement(1, "img", 9);
        i0.ɵɵelementEnd();
    }
}
function DocumentDetailsComponent_ft_file_manager_9_Template(rf, ctx) {
    if (rf & 1) {
        i0.ɵɵelement(0, "ft-file-manager", 10);
    }
    if (rf & 2) {
        const ctx_r1 = i0.ɵɵnextContext();
        i0.ɵɵproperty("root", ctx_r1.resource)("rootId", ctx_r1.model.id);
    }
}
class DocumentDetailsComponent {
    constructor() {
        this.movementType = null;
        this.resource = null;
        this.displayedCols = [];
        this.modelChange = new EventEmitter();
    }
    set handleDisplayedCols(value) {
        this.displayedCols = value;
    }
    set handleMovementType(value) {
        this.movementType = value;
    }
    set handleModel(value) {
        this.model = value;
    }
    set handleResource(value) {
        this.resource = value;
    }
    ngOnInit() {
    }
}
DocumentDetailsComponent.ɵfac = function DocumentDetailsComponent_Factory(t) { return new (t || DocumentDetailsComponent)(); };
DocumentDetailsComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DocumentDetailsComponent, selectors: [["fts-document-details"]], inputs: { handleDisplayedCols: ["displayedCols", "handleDisplayedCols"], handleMovementType: ["movementType", "handleMovementType"], handleModel: ["model", "handleModel"], handleResource: ["resource", "handleResource"] }, outputs: { modelChange: "modelChange" }, decls: 12, vars: 26, consts: [["fxFlex", ""], ["fxFlex", "", 3, "label"], ["fxLayoutAlign", "center center", "class", "validate-icon", 4, "ngIf"], ["fxLayout", "column", "fxFlex", ""], ["fxFlex", "", 3, "lines", "loads", "defaultDepot", "optionalDepot", "priceMode", "movementType", "readOnly", "displayedCols", "provider", "linesChange", "loadsChange"], [3, "lines", "loads", "priceMode", "textAmount", "linesChange", "loadsChange"], ["fxFlex", "", 3, "disabled", "label"], [3, "root", "rootId", 4, "ngIf"], ["fxLayoutAlign", "center center", 1, "validate-icon"], ["mat-card-image", "", "src", "/assets/lock-outline.svg", "alt", "validation img"], [3, "root", "rootId"]], template: function DocumentDetailsComponent_Template(rf, ctx) {
        if (rf & 1) {
            i0.ɵɵelementStart(0, "mat-tab-group", 0)(1, "mat-tab", 1);
            i0.ɵɵpipe(2, "translate");
            i0.ɵɵtemplate(3, DocumentDetailsComponent_div_3_Template, 2, 0, "div", 2);
            i0.ɵɵelementStart(4, "div", 3)(5, "fts-document-lines", 4);
            i0.ɵɵlistener("linesChange", function DocumentDetailsComponent_Template_fts_document_lines_linesChange_5_listener($event) { return ctx.model.lines = $event; })("loadsChange", function DocumentDetailsComponent_Template_fts_document_lines_loadsChange_5_listener($event) { return ctx.model.loads = $event; });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(6, "fts-document-footer", 5);
            i0.ɵɵlistener("linesChange", function DocumentDetailsComponent_Template_fts_document_footer_linesChange_6_listener($event) { return ctx.model.lines = $event; })("loadsChange", function DocumentDetailsComponent_Template_fts_document_footer_loadsChange_6_listener($event) { return ctx.model.loads = $event; });
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(7, "mat-tab", 6);
            i0.ɵɵpipe(8, "translate");
            i0.ɵɵtemplate(9, DocumentDetailsComponent_ft_file_manager_9_Template, 1, 2, "ft-file-manager", 7);
            i0.ɵɵelementEnd();
            i0.ɵɵelement(10, "mat-tab", 6);
            i0.ɵɵpipe(11, "translate");
            i0.ɵɵelementEnd();
        }
        if (rf & 2) {
            i0.ɵɵadvance(1);
            i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(2, 20, "shared.document_lines"));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.model.state == null ? null : ctx.model.state.is_valid);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("lines", ctx.model.lines)("loads", ctx.model.loads)("defaultDepot", ctx.model.store)("optionalDepot", ctx.model.destination)("priceMode", ctx.model.price_mode)("movementType", ctx.movementType)("readOnly", ctx.model == null ? null : ctx.model.state == null ? null : ctx.model.state.is_valid)("displayedCols", ctx.displayedCols)("provider", ctx.model == null ? null : ctx.model.provider);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("lines", ctx.model.lines)("loads", ctx.model.loads)("priceMode", ctx.model.price_mode)("textAmount", ctx.model == null ? null : ctx.model.text_amount);
            i0.ɵɵadvance(1);
            i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(8, 22, "shared.file_manager"));
            i0.ɵɵproperty("disabled", !(ctx.model == null ? null : ctx.model.id) || !ctx.resource);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", (ctx.model == null ? null : ctx.model.id) && ctx.resource);
            i0.ɵɵadvance(1);
            i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(11, 24, "shared.comments"));
            i0.ɵɵproperty("disabled", true);
        }
    }, dependencies: [i4$1.NgIf, i6$1.MatCardImage, i15$2.MatTabGroup, i15$2.MatTab, i8.DefaultLayoutDirective, i8.DefaultLayoutAlignDirective, i8.DefaultFlexDirective, i21.FileManagerComponent, DocumentLinesComponent, DocumentFooterComponent, i3$1.TranslatePipe], styles: [".mat-tab-group[_ngcontent-%COMP%]{border:1px solid #eceff1}"] });
(function () {
    (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DocumentDetailsComponent, [{
            type: Component,
            args: [{ selector: 'fts-document-details', template: " <mat-tab-group fxFlex>\n    <mat-tab fxFlex label=\"{{'shared.document_lines'|translate}}\">\n      <div *ngIf=\"model.state?.is_valid\" fxLayoutAlign=\"center center\" class=\"validate-icon\">\n            <img mat-card-image src=\"/assets/lock-outline.svg\" alt=\"validation img\">\n          </div>\n    <div fxLayout=\"column\" fxFlex>\n        <fts-document-lines fxFlex\n                            [(lines)]=\"model.lines\"\n                            [(loads)]=\"model.loads\"\n                            [defaultDepot]=\"model.store\"\n                            [optionalDepot]=\"model.destination\"\n                            [priceMode]=\"model.price_mode\"\n                            [movementType]=\"movementType \"\n                            [readOnly]=\"model?.state?.is_valid\"\n                            [displayedCols]=\"displayedCols\"\n                            [provider]=\"model?.provider\"\n                            >\n        </fts-document-lines>\n        <fts-document-footer  [(lines)]=\"model.lines\"   [(loads)]=\"model.loads\" [priceMode]=\"model.price_mode\" [textAmount]=\"model?.text_amount\"></fts-document-footer>\n    </div>\n    </mat-tab>\n     <mat-tab  [disabled]=\"!model?.id || !resource\" fxFlex label=\"{{'shared.file_manager'|translate}}\">\n        <ft-file-manager  *ngIf=\"model?.id && resource\" [root]=\"resource\" [rootId]=\"model.id\"></ft-file-manager>\n    </mat-tab>\n     <mat-tab  [disabled]=\"true\" fxFlex label=\"{{'shared.comments'|translate}}\">\n    </mat-tab>\n </mat-tab-group>\n", styles: [".mat-tab-group{border:1px solid #eceff1}\n"] }]
        }], function () { return []; }, { handleDisplayedCols: [{
                type: Input,
                args: ['displayedCols']
            }], handleMovementType: [{
                type: Input,
                args: ['movementType']
            }], handleModel: [{
                type: Input,
                args: ['model']
            }], handleResource: [{
                type: Input,
                args: ['resource']
            }], modelChange: [{
                type: Output
            }] });
})();

function MovementComponent_mat_radio_button_42_Template(rf, ctx) {
    if (rf & 1) {
        i0.ɵɵelementStart(0, "mat-radio-button", 33);
        i0.ɵɵtext(1);
        i0.ɵɵpipe(2, "translate");
        i0.ɵɵelementEnd();
    }
    if (rf & 2) {
        const type_r5 = ctx.$implicit;
        i0.ɵɵproperty("value", type_r5);
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 2, "store." + type_r5), " ");
    }
}
function MovementComponent_mat_radio_button_47_Template(rf, ctx) {
    if (rf & 1) {
        i0.ɵɵelementStart(0, "mat-radio-button", 33);
        i0.ɵɵtext(1);
        i0.ɵɵpipe(2, "translate");
        i0.ɵɵelementEnd();
    }
    if (rf & 2) {
        const type_price_r6 = ctx.$implicit;
        i0.ɵɵproperty("value", type_price_r6);
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 2, "shared." + type_price_r6), " ");
    }
}
const _c0$k = function () { return { cls: "ft_stock.store.StoreMovement", field: "number" }; };
const _c1$h = function () { return { key: "name", url: "api/store/depot", cls: "store/depot", customValidator: "depot.check_uniqueness" }; };
const _c2$b = function () { return ["code", "description", "qte", "price", "vat", "store", "sub_total"]; };
class MovementComponent {
    constructor(sharedService, router, route, location, purposeService, translateService, sharedModulesService, defaultValuesService) {
        this.sharedService = sharedService;
        this.router = router;
        this.route = route;
        this.location = location;
        this.purposeService = purposeService;
        this.translateService = translateService;
        this.sharedModulesService = sharedModulesService;
        this.defaultValuesService = defaultValuesService;
        this.providerInputSettings = assignIn(cloneDeep(PROVIDER_VIEW), { selectable: false });
        this.providerDialog = ProviderDialogComponent;
        this.patientInputSettings = assignIn(cloneDeep(PATIENT_VIEW), { selectable: false });
        this.patientDialog = PatientDialogComponent;
        this.organizationInputSettings = assignIn(cloneDeep(ORGANIZATION_VIEW), { selectable: false });
        this.organizationDialog = OrganizationDialogComponent;
        this.depotDialog = DepotDialogComponent;
        this.loadedObject = null;
        this.types = ['IN', 'OUT'];
        this.price_mode = ['HT', 'TTC'];
        this.model = { date: moment(), type: this.defaultValuesService.getValue('default_movement_type') || 'IN', price_mode: this.defaultValuesService.getValue('default_price_mode') || 'HT' };
        this.apiUrl = 'store/store-movement';
        this.resource = 'store-movement';
        this.routes = { list: '/store/movement', form: '/store/movement/movement-form' };
    }
    ngOnInit() {
        this.route.params.subscribe((data) => {
            let id = get(data, 'id');
            if (id)
                this.sharedService.getDocument(this.apiUrl, id).subscribe(data => {
                    this.model = data;
                });
        });
    }
    goBack() {
        this.router.navigate([handleRoute(this.sharedModulesService.pathName, this.routes["list"])]);
    }
    typeChanged(ev) {
        if (!isEmpty(this.model.lines) && !every(this.model.lines, (l) => { return isEmpty(l.serials_list) && isEmpty(l.lots_list); })) {
            this.purposeService.openConfirmDialog(this.translateService.instant('store.movement_change_type_message', ev.value))
                .subscribe(res => {
                if (res)
                    this.model = assignIn(this.model, { lines: [] });
            });
        }
    }
}
MovementComponent.ɵfac = function MovementComponent_Factory(t) { return new (t || MovementComponent)(i0.ɵɵdirectiveInject(SharedService), i0.ɵɵdirectiveInject(i3.Router), i0.ɵɵdirectiveInject(i3.ActivatedRoute), i0.ɵɵdirectiveInject(i4$1.Location), i0.ɵɵdirectiveInject(i2.GeneralPurposeService), i0.ɵɵdirectiveInject(i3$1.TranslateService), i0.ɵɵdirectiveInject(SharedModulesService), i0.ɵɵdirectiveInject(i2.DefaultValuesService)); };
MovementComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MovementComponent, selectors: [["fts-movement"]], decls: 51, vars: 78, consts: [["color", "accent"], [1, "ft-module-icon"], ["type", "button", "mat-icon-button", ""], ["fontSet", "mdi", "fontIcon", "mdi-elevator"], ["fxFlex", ""], ["type", "button", "mat-button", "", 1, "with-icon", 3, "matTooltip", "click"], ["fontSet", "mdi", "fontIcon", "mdi-format-list-bulleted"], ["fxFlex", "", "fxLayout", "column", 1, "ft-content"], [3, "ngBusy"], ["novalidate", "", "fxLayout", "column", "fxFlex", ""], ["movementForm", "ngForm"], ["fxLayout", "row", 1, "ft-padding"], ["fxFlex", "60", "fxLayout", "column"], ["fxLayout", "row", "fxLayoutGap", "6px"], ["fxFlex", "nogrow"], ["matInput", "", "type", "text", "required", "", "name", "sequence", 3, "ftSequenceInput", "ftSequenceToggle", "placeholder", "ngModel", "disabled", "ngModelChange"], ["matSuffix", "", 3, "objectId", "config", "objectIdChange"], ["toggle", ""], ["matInput", "", "ftDate", "", "name", "date", 3, "ftAutoFocus", "placeholder", "disabled", "ngModel", "matDatepicker", "ngModelChange"], ["matSuffix", "", 3, "for"], ["picker", ""], ["fxFlex", "", 3, "disabled", "label", "model", "value", "settings", "dialog", "modelChange"], [3, "vertical"], ["fxFlex", "nogrow", "fxLayout", "column"], [3, "required", "disabled", "model", "listDialog", "config", "label", "defaultValues", "modelChange"], ["floatLabel", "always", 1, "ft-radio-field"], ["matInput", "", 2, "display", "none", 3, "placeholder"], ["name", "type", "ftDefaultValues", "default_movement_type", 3, "ngModel", "disabled", "ngModelChange", "change"], [3, "value", 4, "ngFor", "ngForOf"], ["name", "price_mode", "ftDefaultValues", "default_price_mode", 3, "ngModel", "disabled", "ngModelChange"], ["fxLayout", "column", "fxFlex", ""], ["fxFlex", "", 3, "model", "resource", "movementType", "displayedCols", "modelChange"], ["fxFlex", "nogrow", 3, "model", "cls", "resource", "formInvalid", "busy", "routes", "loadedObject", "movementType", "modelChange", "busyChange"], [3, "value"]], template: function MovementComponent_Template(rf, ctx) {
        if (rf & 1) {
            i0.ɵɵelementStart(0, "mat-toolbar", 0)(1, "div", 1)(2, "button", 2);
            i0.ɵɵelement(3, "mat-icon", 3);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(4, "h2")(5, "span");
            i0.ɵɵtext(6);
            i0.ɵɵpipe(7, "translate");
            i0.ɵɵelementEnd()();
            i0.ɵɵelement(8, "span", 4);
            i0.ɵɵelementStart(9, "button", 5);
            i0.ɵɵlistener("click", function MovementComponent_Template_button_click_9_listener() { return ctx.goBack(); });
            i0.ɵɵpipe(10, "translate");
            i0.ɵɵelement(11, "mat-icon", 6);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(12, "div", 7);
            i0.ɵɵelement(13, "div", 8);
            i0.ɵɵelementStart(14, "form", 9, 10)(16, "div", 11)(17, "div", 12)(18, "div", 13)(19, "mat-form-field", 14)(20, "input", 15);
            i0.ɵɵlistener("ngModelChange", function MovementComponent_Template_input_ngModelChange_20_listener($event) { return ctx.model.number = $event; });
            i0.ɵɵpipe(21, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(22, "ft-sequence-toggle", 16, 17);
            i0.ɵɵlistener("objectIdChange", function MovementComponent_Template_ft_sequence_toggle_objectIdChange_22_listener($event) { return ctx.loadedObject = $event; });
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(24, "mat-form-field", 14)(25, "input", 18);
            i0.ɵɵlistener("ngModelChange", function MovementComponent_Template_input_ngModelChange_25_listener($event) { return ctx.model.date = $event; });
            i0.ɵɵpipe(26, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(27, "mat-datepicker-toggle", 19)(28, "mat-datepicker", null, 20);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(30, "div", 13)(31, "fts-document-select", 21);
            i0.ɵɵlistener("modelChange", function MovementComponent_Template_fts_document_select_modelChange_31_listener($event) { return ctx.model.provider = $event; });
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(32, "div", 13)(33, "fts-document-select", 21);
            i0.ɵɵlistener("modelChange", function MovementComponent_Template_fts_document_select_modelChange_33_listener($event) { return ctx.model.patient = $event; });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(34, "fts-document-select", 21);
            i0.ɵɵlistener("modelChange", function MovementComponent_Template_fts_document_select_modelChange_34_listener($event) { return ctx.model.organization = $event; });
            i0.ɵɵelementEnd()()();
            i0.ɵɵelement(35, "mat-divider", 22);
            i0.ɵɵelementStart(36, "div", 23)(37, "fts-list-select", 24);
            i0.ɵɵlistener("modelChange", function MovementComponent_Template_fts_list_select_modelChange_37_listener($event) { return ctx.model.store = $event; });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(38, "mat-form-field", 25);
            i0.ɵɵelement(39, "input", 26);
            i0.ɵɵpipe(40, "translate");
            i0.ɵɵelementStart(41, "mat-radio-group", 27);
            i0.ɵɵlistener("ngModelChange", function MovementComponent_Template_mat_radio_group_ngModelChange_41_listener($event) { return ctx.model.type = $event; })("change", function MovementComponent_Template_mat_radio_group_change_41_listener($event) { return ctx.typeChanged($event); });
            i0.ɵɵtemplate(42, MovementComponent_mat_radio_button_42_Template, 3, 4, "mat-radio-button", 28);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(43, "mat-form-field", 25);
            i0.ɵɵelement(44, "input", 26);
            i0.ɵɵpipe(45, "translate");
            i0.ɵɵelementStart(46, "mat-radio-group", 29);
            i0.ɵɵlistener("ngModelChange", function MovementComponent_Template_mat_radio_group_ngModelChange_46_listener($event) { return ctx.model.price_mode = $event; });
            i0.ɵɵtemplate(47, MovementComponent_mat_radio_button_47_Template, 3, 4, "mat-radio-button", 28);
            i0.ɵɵelementEnd()()()();
            i0.ɵɵelementStart(48, "div", 30)(49, "fts-document-details", 31);
            i0.ɵɵlistener("modelChange", function MovementComponent_Template_fts_document_details_modelChange_49_listener($event) { return ctx.model = $event; });
            i0.ɵɵelementEnd()()()();
            i0.ɵɵelementStart(50, "fts-document-actions", 32);
            i0.ɵɵlistener("modelChange", function MovementComponent_Template_fts_document_actions_modelChange_50_listener($event) { return ctx.model = $event; })("busyChange", function MovementComponent_Template_fts_document_actions_busyChange_50_listener($event) { return ctx.loading = $event; });
            i0.ɵɵelementEnd();
        }
        if (rf & 2) {
            const _r0 = i0.ɵɵreference(15);
            const _r1 = i0.ɵɵreference(23);
            const _r2 = i0.ɵɵreference(29);
            i0.ɵɵadvance(6);
            i0.ɵɵtextInterpolate2("", i0.ɵɵpipeBind1(7, 63, "store.movement"), " N\u00B0:", ctx.model.number, "");
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("matTooltip", i0.ɵɵpipeBind1(10, 65, "store.movements"));
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngBusy", ctx.loading);
            i0.ɵɵadvance(7);
            i0.ɵɵproperty("ftSequenceInput", "ft_stock.store.StoreMovement")("ftSequenceToggle", _r1)("placeholder", i0.ɵɵpipeBind1(21, 67, "store.movement_number"))("ngModel", ctx.model.number)("disabled", ctx.model == null ? null : ctx.model.state == null ? null : ctx.model.state.is_valid);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("objectId", ctx.loadedObject)("config", i0.ɵɵpureFunction0(75, _c0$k));
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ftAutoFocus", true)("placeholder", i0.ɵɵpipeBind1(26, 69, "store.date"))("disabled", ctx.model == null ? null : ctx.model.state == null ? null : ctx.model.state.is_valid)("ngModel", ctx.model.date)("matDatepicker", _r2);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("for", _r2);
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("disabled", ctx.model == null ? null : ctx.model.state == null ? null : ctx.model.state.is_valid)("label", "store.default_provider")("model", ctx.model.provider)("value", "name")("settings", ctx.providerInputSettings)("dialog", ctx.providerDialog);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("disabled", ctx.model == null ? null : ctx.model.state == null ? null : ctx.model.state.is_valid)("label", "store.patient")("model", ctx.model.patient)("value", "full_name")("settings", ctx.patientInputSettings)("dialog", ctx.patientDialog);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("disabled", ctx.model == null ? null : ctx.model.state == null ? null : ctx.model.state.is_valid)("label", "store.organization")("model", ctx.model.organization)("value", "name")("settings", ctx.organizationInputSettings)("dialog", ctx.organizationDialog);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("vertical", true);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("required", true)("disabled", ctx.model == null ? null : ctx.model.state == null ? null : ctx.model.state.is_valid)("model", ctx.model.store)("listDialog", ctx.depotDialog)("config", i0.ɵɵpureFunction0(76, _c1$h))("label", "store.depot")("defaultValues", "default_store");
            i0.ɵɵadvance(2);
            i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(40, 71, "store.type"));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngModel", ctx.model.type)("disabled", ctx.model == null ? null : ctx.model.state == null ? null : ctx.model.state.is_valid);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngForOf", ctx.types);
            i0.ɵɵadvance(2);
            i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(45, 73, "shared.price_mode"));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngModel", ctx.model.price_mode)("disabled", ctx.model == null ? null : ctx.model.state == null ? null : ctx.model.state.is_valid);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngForOf", ctx.price_mode);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("model", ctx.model)("resource", ctx.resource)("movementType", ctx.model == null ? null : ctx.model.type)("displayedCols", i0.ɵɵpureFunction0(77, _c2$b));
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("model", ctx.model)("cls", ctx.apiUrl)("resource", ctx.resource)("formInvalid", _r0.invalid || !(ctx.model == null ? null : ctx.model.store))("busy", ctx.loading)("routes", ctx.routes)("loadedObject", ctx.loadedObject)("movementType", ctx.model == null ? null : ctx.model.type);
        }
    }, dependencies: [i4$1.NgForOf, i6.MatButton, i7.MatDatepicker, i7.MatDatepickerInput, i7.MatDatepickerToggle, i9.MatIcon, i10.MatFormField, i10.MatSuffix, i11$1.MatInput, i12$1.MatDivider, i13.MatRadioGroup, i13.MatRadioButton, i11.MatToolbar, i15$1.MatTooltip, i8.DefaultLayoutDirective, i8.DefaultLayoutGapDirective, i8.DefaultFlexDirective, i16.ɵNgNoValidate, i16.DefaultValueAccessor, i16.NgControlStatus, i16.NgControlStatusGroup, i16.RequiredValidator, i16.NgModel, i16.NgForm, i12.NgBusyDirective, i2.SequenceToggleComponent, i2.DateDirective, i2.InputDirective, i2.AutoFocusDirective, i2.SequenceInputDirective, i2.DefaultValuesDirective, DocumentSelectComponent, ListSelectComponent, DocumentActionsComponent, DocumentDetailsComponent, i3$1.TranslatePipe], styles: ["[_nghost-%COMP%]{height:100%;display:flex;flex-direction:column}"] });
(function () {
    (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MovementComponent, [{
            type: Component,
            args: [{ selector: 'fts-movement', template: "<mat-toolbar color=\"accent\">\n  <div class=\"ft-module-icon\">\n    <button type=\"button\" mat-icon-button>\n      <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-elevator\"></mat-icon>\n    </button>\n  </div>\n  <h2>\n    <span>{{'store.movement'| translate}} N\u00B0:{{model.number}}</span>\n  </h2>\n  <span fxFlex></span>\n  <button type=\"button\" mat-button class=\"with-icon\"  (click)=\"goBack()\" [matTooltip]=\"'store.movements'|translate\">\n    <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-format-list-bulleted\"></mat-icon>\n  </button>\n</mat-toolbar>\n\n<div fxFlex fxLayout=\"column\" class=\"ft-content\">\n   <div [ngBusy]=\"loading\"></div>\n  <!--<div *ngIf=\"model.state?.is_valid\" fxLayoutAlign=\"center center\" class=\"validate-icon\">\n    <img mat-card-image src=\"/assets/lock-outline.svg\" alt=\"validation img\">\n  </div>-->\n  <form novalidate #movementForm=\"ngForm\" fxLayout=\"column\" fxFlex  >\n      <div class=\"ft-padding\" fxLayout=\"row\"  >\n        <div fxFlex=\"60\" fxLayout=\"column\">\n            <div fxLayout=\"row\" fxLayoutGap=\"6px\">\n\n              <mat-form-field fxFlex=\"nogrow\">\n                <input matInput type=\"text\" required\n                       [ftSequenceInput]=\"'ft_stock.store.StoreMovement'\"\n                       [ftSequenceToggle]=\"toggle\"\n                       name=\"sequence\"\n                       [placeholder]=\"'store.movement_number'|translate\"\n                       [(ngModel)]=\"model.number\"\n\n                       [disabled]=\"model?.state?.is_valid\"/>\n                <ft-sequence-toggle matSuffix #toggle  [(objectId)]=\"loadedObject\"\n                                    [config]=\"{cls: 'ft_stock.store.StoreMovement', field: 'number'}\">\n                </ft-sequence-toggle>\n              </mat-form-field>\n              <mat-form-field fxFlex=\"nogrow\">\n                <input matInput ftDate [ftAutoFocus]=\"true\" [placeholder]=\"'store.date'|translate\" name=\"date\" [disabled]=\"model?.state?.is_valid\"\n                       [(ngModel)]=\"model.date\" [matDatepicker]=\"picker\">\n                <mat-datepicker-toggle matSuffix [for]=\"picker\"></mat-datepicker-toggle>\n                <mat-datepicker #picker></mat-datepicker>\n              </mat-form-field>\n\n           </div>\n           <div fxLayout=\"row\"  fxLayoutGap=\"6px\">\n              <fts-document-select fxFlex\n                                   [disabled]=\"model?.state?.is_valid\"\n                                   [label]=\"'store.default_provider'\"\n                                   [(model)]=\"model.provider\"\n                                   [value]=\"'name'\"\n                                   [settings]=\"providerInputSettings\"\n                                   [dialog]=\"providerDialog\">\n              </fts-document-select>\n           </div>\n\n            <div fxLayout=\"row\"  fxLayoutGap=\"6px\">\n              <fts-document-select fxFlex\n                     [disabled]=\"model?.state?.is_valid\"\n                     [label]=\"'store.patient'\"\n                     [(model)]=\"model.patient\"\n                     [value]=\"'full_name'\"\n                     [settings]=\"patientInputSettings\"\n                     [dialog]=\"patientDialog\">\n              </fts-document-select>\n              <fts-document-select fxFlex\n                     [disabled]=\"model?.state?.is_valid\"\n                     [label]=\"'store.organization'\"\n                     [(model)]=\"model.organization\"\n                     [value]=\"'name'\"\n                     [settings]=\"organizationInputSettings\"\n                     [dialog]=\"organizationDialog\">\n              </fts-document-select>\n            </div>\n        </div>\n        <mat-divider [vertical]=\"true\"></mat-divider>\n        <div fxFlex=\"nogrow\" fxLayout=\"column\">\n\n                <fts-list-select\n                   [required]=\"true\"\n                   [disabled]=\"model?.state?.is_valid\"\n                   [(model)]=\"model.store\"\n                   [listDialog]=\"depotDialog\"\n                   [config]=\"{key: 'name', url: 'api/store/depot', cls:'store/depot', customValidator:'depot.check_uniqueness'}\"\n                   [label]=\"'store.depot'\"\n                    [defaultValues]=\"'default_store'\"\n                    >\n                </fts-list-select>\n                <mat-form-field floatLabel=\"always\" class=\"ft-radio-field\">\n                  <input matInput placeholder=\"{{'store.type'|translate}}\" style=\"display: none\">\n                  <mat-radio-group [(ngModel)]=\"model.type\" name=\"type\" [disabled]=\"model?.state?.is_valid\"  ftDefaultValues=\"default_movement_type\"\n                                   (change)=\"typeChanged($event)\" >\n                    <mat-radio-button *ngFor=\"let type of types\" [value]=\"type\">\n                      {{'store.'+type|translate}}\n                    </mat-radio-button>\n                  </mat-radio-group>\n                </mat-form-field>\n\n                <mat-form-field floatLabel=\"always\" class=\"ft-radio-field\" >\n                  <input matInput placeholder=\"{{'shared.price_mode'|translate}}\" style=\"display: none\">\n                  <mat-radio-group [(ngModel)]=\"model.price_mode\" name=\"price_mode\" [disabled]=\"model?.state?.is_valid\"  ftDefaultValues=\"default_price_mode\">\n                    <mat-radio-button *ngFor=\"let type_price of price_mode\" [value]=\"type_price\">\n                      {{'shared.'+type_price|translate}}\n                    </mat-radio-button>\n                  </mat-radio-group>\n                </mat-form-field>\n\n\n        </div>\n      </div>\n      <div fxLayout=\"column\" fxFlex>\n        <fts-document-details  fxFlex\n                               [(model)]=\"model\"\n                               [resource]=\"resource\"\n                               [movementType]=\"model?.type\"\n                               [displayedCols]=\"['code','description','qte','price','vat','store','sub_total']\">\n        </fts-document-details>\n      </div>\n  </form>\n\n</div>\n<fts-document-actions fxFlex=\"nogrow\" [(model)]=\"model\" [cls]=\"apiUrl\" [resource]=\"resource\"\n                      [formInvalid]=\"movementForm.invalid || !model?.store\"  [(busy)]=\"loading\"\n                      [routes]=\"routes\" [loadedObject]=\"loadedObject\" [movementType]=\"model?.type\"></fts-document-actions>\n", styles: [":host{height:100%;display:flex;flex-direction:column}\n"] }]
        }], function () { return [{ type: SharedService }, { type: i3.Router }, { type: i3.ActivatedRoute }, { type: i4$1.Location }, { type: i2.GeneralPurposeService }, { type: i3$1.TranslateService }, { type: SharedModulesService }, { type: i2.DefaultValuesService }]; }, null);
})();

const _c0$j = function () { return { "success-color": true }; };
const _c1$g = function () { return { "mat-warn": true }; };
function ArticleTransformSelectComponent_button_3_Template(rf, ctx) {
    if (rf & 1) {
        const _r4 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "button", 6);
        i0.ɵɵlistener("click", function ArticleTransformSelectComponent_button_3_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r4); const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.handleSerials()); });
        i0.ɵɵelement(1, "mat-icon", 7);
        i0.ɵɵelementEnd();
    }
    if (rf & 2) {
        const ctx_r0 = i0.ɵɵnextContext();
        i0.ɵɵproperty("ngClass", ctx_r0.qte == (ctx_r0.serials_list == null ? null : ctx_r0.serials_list.length) ? i0.ɵɵpureFunction0(1, _c0$j) : i0.ɵɵpureFunction0(2, _c1$g));
    }
}
function ArticleTransformSelectComponent_button_4_Template(rf, ctx) {
    if (rf & 1) {
        const _r6 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "button", 6);
        i0.ɵɵlistener("click", function ArticleTransformSelectComponent_button_4_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r6); const ctx_r5 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r5.handleLots()); });
        i0.ɵɵelement(1, "mat-icon", 8);
        i0.ɵɵelementEnd();
    }
    if (rf & 2) {
        const ctx_r1 = i0.ɵɵnextContext();
        i0.ɵɵproperty("ngClass", ctx_r1.qte == ctx_r1.getLotsQte() ? i0.ɵɵpureFunction0(1, _c0$j) : i0.ɵɵpureFunction0(2, _c1$g));
    }
}
const _c2$a = function (a0) { return { "hidden": a0 }; };
function ArticleTransformSelectComponent_button_7_Template(rf, ctx) {
    if (rf & 1) {
        const _r8 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "button", 9);
        i0.ɵɵlistener("click", function ArticleTransformSelectComponent_button_7_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r8); const ctx_r7 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r7.reset()); });
        i0.ɵɵelement(1, "mat-icon", 10);
        i0.ɵɵelementEnd();
    }
    if (rf & 2) {
        const ctx_r2 = i0.ɵɵnextContext();
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(1, _c2$a, ctx_r2.is_disabled));
    }
}
class ArticleTransformSelectComponent extends DocumentSelectComponent {
    constructor() {
        super(...arguments);
        this.serials_list = [];
        this.lots_list = [];
        this.store = null;
        this.qte = 0;
        this.readOnly = false;
        this.mvtType = 'IN';
        this.serialsChange = new EventEmitter();
        this.lotsChange = new EventEmitter();
    }
    set handleStore(value) {
        this.store = value;
    }
    set handleQte(value) {
        this.qte = value;
    }
    set handleReadOnly(value) {
        this.readOnly = value;
    }
    set handleMvtType(value) {
        this.mvtType = value;
    }
    set serials(value) {
        this.serials_list = value;
    }
    set lots(value) {
        this.lots_list = value;
    }
    getLotsQte() {
        return sumBy(this.lots_list, 'store_qte');
    }
    handleSerials() {
        this.handleSerialDialog().afterClosed().subscribe(data => {
            if (data) {
                this.serials_list = data;
                this.lots_list = [];
                this.serialsChange.emit(this.serials_list);
                this.lotsChange.emit(this.lots_list);
            }
        });
    }
    handleLots() {
        this.handleLotDialog().afterClosed().subscribe(data => {
            if (data) {
                this.lots_list = data;
                this.serials_list = [];
                this.lotsChange.emit(this.lots_list);
                this.serialsChange.emit(this.serials_list);
            }
        });
    }
    handleSerialDialog() {
        let data = {
            data: {
                serials: cloneDeep(this.serials_list),
                qte: this.qte,
                article: get(this._model, 'id'),
                depot: get(this.store, 'id'),
                readOnly: this.readOnly
            },
            disableClose: true
        };
        switch (this.mvtType) {
            case 'IN':
            case 'ASSEMBLY':
                return this.dialog.open(InSerialDialogComponent, assignIn(SMALL_DIALOG, data));
                break;
            case 'OUT':
            case 'DISASSEMBLING':
                return this.dialog.open(OutSerialDialogComponent, assignIn(MEDIUM_DIALOG, data));
                break;
        }
    }
    handleLotDialog() {
        let data = {
            data: {
                lots: cloneDeep(this.lots_list),
                qte: this.qte,
                article: get(this._model, 'id'),
                depot: get(this.store, 'id'),
                readOnly: this.readOnly
            },
            disableClose: true
        };
        switch (this.mvtType) {
            case 'IN':
            case 'ASSEMBLY':
                return this.dialog.open(InLotDialogComponent, assignIn(MEDIUM_DIALOG, data));
                break;
            case 'OUT':
            case 'DISASSEMBLING':
                return this.dialog.open(OutLotDialogComponent, assignIn(MEDIUM_DIALOG, data));
                break;
        }
    }
}
ArticleTransformSelectComponent.ɵfac = /*@__PURE__*/ function () { let ɵArticleTransformSelectComponent_BaseFactory; return function ArticleTransformSelectComponent_Factory(t) { return (ɵArticleTransformSelectComponent_BaseFactory || (ɵArticleTransformSelectComponent_BaseFactory = i0.ɵɵgetInheritedFactory(ArticleTransformSelectComponent)))(t || ArticleTransformSelectComponent); }; }();
ArticleTransformSelectComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ArticleTransformSelectComponent, selectors: [["fts-article-transform-select"]], inputs: { handleStore: ["store", "handleStore"], handleQte: ["qte", "handleQte"], handleReadOnly: ["readOnly", "handleReadOnly"], handleMvtType: ["mvtType", "handleMvtType"], serials: "serials", lots: "lots" }, outputs: { serialsChange: "serialsChange", lotsChange: "lotsChange" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 8, vars: 13, consts: [["fxFlex", ""], ["readonly", "", "matInput", "", 3, "placeholder", "ngModel", "readonly", "required", "disabled", "ngModelChange", "click", "change"], ["matSuffix", "", "mat-icon-button", "", "type", "button", 3, "ngClass", "click", 4, "ngIf"], ["matSuffix", "", "mat-icon-button", "", "type", "button", "color", "primary", 3, "ngClass", "click"], ["fontSet", "mdi", "fontIcon", "mdi-magnify"], ["matSuffix", "", "mat-icon-button", "", "type", "button", "color", "warn", 3, "ngClass", "click", 4, "ngIf"], ["matSuffix", "", "mat-icon-button", "", "type", "button", 3, "ngClass", "click"], ["fontSet", "mdi", "fontIcon", "mdi-alpha-s-box"], ["fontSet", "mdi", "fontIcon", "mdi-alpha-l-box"], ["matSuffix", "", "mat-icon-button", "", "type", "button", "color", "warn", 3, "ngClass", "click"], ["fontSet", "mdi", "fontIcon", "mdi-close"]], template: function ArticleTransformSelectComponent_Template(rf, ctx) {
        if (rf & 1) {
            i0.ɵɵelementStart(0, "mat-form-field", 0)(1, "input", 1);
            i0.ɵɵlistener("ngModelChange", function ArticleTransformSelectComponent_Template_input_ngModelChange_1_listener($event) { return ctx.currentModel = $event; })("click", function ArticleTransformSelectComponent_Template_input_click_1_listener() { return ctx.showDialog(); })("change", function ArticleTransformSelectComponent_Template_input_change_1_listener() { return ctx.handleChange(); });
            i0.ɵɵpipe(2, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(3, ArticleTransformSelectComponent_button_3_Template, 2, 3, "button", 2);
            i0.ɵɵtemplate(4, ArticleTransformSelectComponent_button_4_Template, 2, 3, "button", 2);
            i0.ɵɵelementStart(5, "button", 3);
            i0.ɵɵlistener("click", function ArticleTransformSelectComponent_Template_button_click_5_listener() { return ctx.showDialog(); });
            i0.ɵɵelement(6, "mat-icon", 4);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(7, ArticleTransformSelectComponent_button_7_Template, 2, 3, "button", 5);
            i0.ɵɵelementEnd();
        }
        if (rf & 2) {
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(2, 9, ctx.label))("ngModel", ctx.currentModel)("readonly", true)("required", ctx.is_required)("disabled", ctx.is_disabled);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx._model == null ? null : ctx._model.has_serial);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx._model == null ? null : ctx._model.has_lot_number);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(11, _c2$a, ctx.is_disabled));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.currentModel);
        }
    }, dependencies: [i4$1.NgClass, i4$1.NgIf, i6.MatButton, i9.MatIcon, i10.MatFormField, i10.MatSuffix, i11$1.MatInput, i8.DefaultFlexDirective, i9$1.DefaultClassDirective, i16.DefaultValueAccessor, i16.NgControlStatus, i16.RequiredValidator, i16.NgModel, i2.InputDirective, i3$1.TranslatePipe], styles: [".hidden[_ngcontent-%COMP%]{display:none}"] });
(function () {
    (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ArticleTransformSelectComponent, [{
            type: Component,
            args: [{ selector: 'fts-article-transform-select', template: "<mat-form-field fxFlex>\n  <input readonly matInput [placeholder]=\"label|translate\" [(ngModel)]=\"currentModel\"\n        (click)=\"showDialog()\" [readonly]=\"true\" (change)=\"handleChange()\"\n        [required]=\"is_required\" [disabled]=\"is_disabled\"/>\n  <button matSuffix mat-icon-button *ngIf=\"_model?.has_serial\" (click)=\"handleSerials()\"   [ngClass]=\"(qte==serials_list?.length? {'success-color':true}:{'mat-warn':true})\" type=\"button\">\n    <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-alpha-s-box\"></mat-icon>\n  </button>\n  <button matSuffix mat-icon-button *ngIf=\"_model?.has_lot_number\" (click)=\"handleLots()\"   [ngClass]=\"qte==getLotsQte() ? {'success-color':true}:{'mat-warn':true}\"  type=\"button\">\n    <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-alpha-l-box\"></mat-icon>\n  </button>\n  <button matSuffix mat-icon-button (click)=\"showDialog()\"  [ngClass]=\"{'hidden':is_disabled}\" type=\"button\" color=\"primary\">\n    <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-magnify\"></mat-icon>\n  </button>\n  <button *ngIf=\"currentModel\" matSuffix mat-icon-button (click)=\"reset()\" [ngClass]=\"{'hidden':is_disabled}\"  type=\"button\"  color=\"warn\">\n    <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-close\"></mat-icon>\n  </button>\n</mat-form-field>\n\n\n\n", styles: [".hidden{display:none}\n"] }]
        }], null, { handleStore: [{
                type: Input,
                args: ['store']
            }], handleQte: [{
                type: Input,
                args: ['qte']
            }], handleReadOnly: [{
                type: Input,
                args: ['readOnly']
            }], handleMvtType: [{
                type: Input,
                args: ['mvtType']
            }], serials: [{
                type: Input
            }], serialsChange: [{
                type: Output
            }], lots: [{
                type: Input
            }], lotsChange: [{
                type: Output
            }] });
})();

function TransformationComponent_mat_radio_button_47_Template(rf, ctx) {
    if (rf & 1) {
        i0.ɵɵelementStart(0, "mat-radio-button", 36);
        i0.ɵɵtext(1);
        i0.ɵɵpipe(2, "translate");
        i0.ɵɵelementEnd();
    }
    if (rf & 2) {
        const type_r4 = ctx.$implicit;
        i0.ɵɵproperty("value", type_r4);
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 2, "shared." + type_r4), " ");
    }
}
const _c0$i = function () { return { cls: "ft_stock.store.StoreTransformation", field: "number" }; };
const _c1$f = function () { return { key: "name", url: "api/store/depot", cls: "store/depot", customValidator: "depot.check_uniqueness" }; };
const _c2$9 = function () { return ["code", "description", "qte", "price", "vat", "store", "sub_total"]; };
class TransformationComponent {
    constructor(sharedModulesService, defaultValuesService, router, route, sharedService) {
        this.sharedModulesService = sharedModulesService;
        this.defaultValuesService = defaultValuesService;
        this.router = router;
        this.route = route;
        this.sharedService = sharedService;
        this.depotDialog = DepotDialogComponent;
        this.articleInputSettings = assignIn(cloneDeep(ARTICLE_VIEW), { selectable: false });
        this.loadedObject = null;
        this.types = ['ASSEMBLY', 'DISASSEMBLING'];
        this.price_mode = ['HT', 'TTC'];
        this.model = { date: moment(), type: 'ASSEMBLY', price_mode: this.defaultValuesService.getValue('default_price_mode') || 'HT', serials_list: [], lots_list: [], qte: 1, price: 0, article: null };
        this.apiUrl = 'store/store-transformation';
        this.resource = 'store-transformation';
        this.routes = { list: '/store/transformation', form: '/store/transformation/transformation-form' };
    }
    ngOnInit() {
        this.route.params.subscribe((data) => {
            let id = get(data, 'id');
            if (id)
                this.sharedService.getDocument(this.apiUrl, id).subscribe(data => {
                    this.model = data;
                });
        });
    }
    goBack() {
        this.router.navigate([handleRoute(this.sharedModulesService.pathName, this.routes["list"])]);
    }
}
TransformationComponent.ɵfac = function TransformationComponent_Factory(t) { return new (t || TransformationComponent)(i0.ɵɵdirectiveInject(SharedModulesService), i0.ɵɵdirectiveInject(i2.DefaultValuesService), i0.ɵɵdirectiveInject(i3.Router), i0.ɵɵdirectiveInject(i3.ActivatedRoute), i0.ɵɵdirectiveInject(SharedService)); };
TransformationComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: TransformationComponent, selectors: [["fts-transformation"]], decls: 51, vars: 77, consts: [["color", "accent"], [1, "ft-module-icon"], ["type", "button", "mat-icon-button", ""], ["fontSet", "mdi", "fontIcon", "mdi-crop-rotate"], ["fxFlex", ""], ["type", "button", "mat-button", "", 1, "with-icon", 3, "matTooltip", "click"], ["fontSet", "mdi", "fontIcon", "mdi-format-list-bulleted"], ["fxFlex", "", "fxLayout", "column", 1, "ft-content"], [3, "ngBusy"], ["novalidate", "", "fxLayout", "column", "fxFlex", ""], ["transformationForm", "ngForm"], ["fxLayout", "row", 1, "ft-padding"], ["fxFlex", "60", "fxLayout", "column"], ["fxLayout", "row", "fxLayoutGap", "6px"], ["fxFlex", "nogrow"], ["matInput", "", "type", "text", "required", "", "name", "sequence", 3, "ftSequenceInput", "ftSequenceToggle", "placeholder", "ngModel", "disabled", "ngModelChange"], ["matSuffix", "", 3, "objectId", "config", "objectIdChange"], ["toggle", ""], ["matInput", "", "ftDate", "", "name", "date", 3, "ftAutoFocus", "placeholder", "disabled", "ngModel", "matDatepicker", "ngModelChange"], ["matSuffix", "", 3, "for"], ["picker", ""], ["fxFlex", "50", 3, "disabled", "label", "model", "serials", "lots", "store", "qte", "value", "mvtType", "readOnly", "required", "settings", "modelChange", "serialsChange", "lotsChange"], ["fxFlex", "25"], ["matInput", "", "name", "qte", "min", "1", "type", "number", "required", "", 3, "placeholder", "ngModel", "readonly", "ngModelChange"], ["matInput", "", "name", "price", "required", "", 3, "placeholder", "ftNumber", "ngModel", "readonly", "ngModelChange"], [3, "vertical"], ["fxLayout", "column", "fxFlex", ""], ["fxLayout", "row", "fxFlex", "nogrow"], [3, "required", "disabled", "model", "listDialog", "config", "label", "defaultValues", "modelChange"], ["fxLayout", "row", "fxLayoutGap", "8px"], ["fxFlex", "", "floatLabel", "always", 1, "ft-radio-field"], ["matInput", "", 2, "display", "none", 3, "placeholder"], ["name", "type", 3, "ngModel", "disabled", "ngModelChange"], [3, "value", 4, "ngFor", "ngForOf"], ["fxFlex", "", 3, "model", "resource", "movementType", "displayedCols", "modelChange"], ["fxFlex", "nogrow", 3, "model", "cls", "resource", "formInvalid", "busy", "routes", "loadedObject", "movementType", "modelChange", "busyChange"], [3, "value"]], template: function TransformationComponent_Template(rf, ctx) {
        if (rf & 1) {
            i0.ɵɵelementStart(0, "mat-toolbar", 0)(1, "div", 1)(2, "button", 2);
            i0.ɵɵelement(3, "mat-icon", 3);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(4, "h2")(5, "span");
            i0.ɵɵtext(6);
            i0.ɵɵpipe(7, "translate");
            i0.ɵɵelementEnd()();
            i0.ɵɵelement(8, "span", 4);
            i0.ɵɵelementStart(9, "button", 5);
            i0.ɵɵlistener("click", function TransformationComponent_Template_button_click_9_listener() { return ctx.goBack(); });
            i0.ɵɵpipe(10, "translate");
            i0.ɵɵelement(11, "mat-icon", 6);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(12, "div", 7);
            i0.ɵɵelement(13, "div", 8);
            i0.ɵɵelementStart(14, "form", 9, 10)(16, "div", 11)(17, "div", 12)(18, "div", 13)(19, "mat-form-field", 14)(20, "input", 15);
            i0.ɵɵlistener("ngModelChange", function TransformationComponent_Template_input_ngModelChange_20_listener($event) { return ctx.model.number = $event; });
            i0.ɵɵpipe(21, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(22, "ft-sequence-toggle", 16, 17);
            i0.ɵɵlistener("objectIdChange", function TransformationComponent_Template_ft_sequence_toggle_objectIdChange_22_listener($event) { return ctx.loadedObject = $event; });
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(24, "mat-form-field", 14)(25, "input", 18);
            i0.ɵɵlistener("ngModelChange", function TransformationComponent_Template_input_ngModelChange_25_listener($event) { return ctx.model.date = $event; });
            i0.ɵɵpipe(26, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(27, "mat-datepicker-toggle", 19)(28, "mat-datepicker", null, 20);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(30, "div", 13)(31, "fts-article-transform-select", 21);
            i0.ɵɵlistener("modelChange", function TransformationComponent_Template_fts_article_transform_select_modelChange_31_listener($event) { return ctx.model.article = $event; })("serialsChange", function TransformationComponent_Template_fts_article_transform_select_serialsChange_31_listener($event) { return ctx.model.serials_list = $event; })("lotsChange", function TransformationComponent_Template_fts_article_transform_select_lotsChange_31_listener($event) { return ctx.model.lots_list = $event; });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(32, "mat-form-field", 22)(33, "input", 23);
            i0.ɵɵlistener("ngModelChange", function TransformationComponent_Template_input_ngModelChange_33_listener($event) { return ctx.model.qte = $event; });
            i0.ɵɵpipe(34, "translate");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(35, "mat-form-field", 22)(36, "input", 24);
            i0.ɵɵlistener("ngModelChange", function TransformationComponent_Template_input_ngModelChange_36_listener($event) { return ctx.model.price = $event; });
            i0.ɵɵpipe(37, "translate");
            i0.ɵɵelementEnd()()()();
            i0.ɵɵelement(38, "mat-divider", 25);
            i0.ɵɵelementStart(39, "div", 26)(40, "div", 27)(41, "fts-list-select", 28);
            i0.ɵɵlistener("modelChange", function TransformationComponent_Template_fts_list_select_modelChange_41_listener($event) { return ctx.model.store = $event; });
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(42, "div", 29)(43, "mat-form-field", 30);
            i0.ɵɵelement(44, "input", 31);
            i0.ɵɵpipe(45, "translate");
            i0.ɵɵelementStart(46, "mat-radio-group", 32);
            i0.ɵɵlistener("ngModelChange", function TransformationComponent_Template_mat_radio_group_ngModelChange_46_listener($event) { return ctx.model.type = $event; });
            i0.ɵɵtemplate(47, TransformationComponent_mat_radio_button_47_Template, 3, 4, "mat-radio-button", 33);
            i0.ɵɵelementEnd()()()()();
            i0.ɵɵelementStart(48, "div", 26)(49, "fts-document-details", 34);
            i0.ɵɵlistener("modelChange", function TransformationComponent_Template_fts_document_details_modelChange_49_listener($event) { return ctx.model = $event; });
            i0.ɵɵelementEnd()()()();
            i0.ɵɵelementStart(50, "fts-document-actions", 35);
            i0.ɵɵlistener("modelChange", function TransformationComponent_Template_fts_document_actions_modelChange_50_listener($event) { return ctx.model = $event; })("busyChange", function TransformationComponent_Template_fts_document_actions_busyChange_50_listener($event) { return ctx.loading = $event; });
            i0.ɵɵelementEnd();
        }
        if (rf & 2) {
            const _r0 = i0.ɵɵreference(15);
            const _r1 = i0.ɵɵreference(23);
            const _r2 = i0.ɵɵreference(29);
            i0.ɵɵadvance(6);
            i0.ɵɵtextInterpolate2("", i0.ɵɵpipeBind1(7, 60, "store.transformation_form"), "\u00A0 N\u00B0:", ctx.model.number, "");
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("matTooltip", i0.ɵɵpipeBind1(10, 62, "store.transformation_list"));
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngBusy", ctx.loading);
            i0.ɵɵadvance(7);
            i0.ɵɵproperty("ftSequenceInput", "ft_stock.store.StoreTransformation")("ftSequenceToggle", _r1)("placeholder", i0.ɵɵpipeBind1(21, 64, "store.transformation_number"))("ngModel", ctx.model.number)("disabled", ctx.model == null ? null : ctx.model.state == null ? null : ctx.model.state.is_valid);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("objectId", ctx.loadedObject)("config", i0.ɵɵpureFunction0(74, _c0$i));
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ftAutoFocus", true)("placeholder", i0.ɵɵpipeBind1(26, 66, "store.date"))("disabled", ctx.model == null ? null : ctx.model.state == null ? null : ctx.model.state.is_valid)("ngModel", ctx.model.date)("matDatepicker", _r2);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("for", _r2);
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("disabled", ctx.model == null ? null : ctx.model.state == null ? null : ctx.model.state.is_valid)("label", "store.article")("model", ctx.model.article)("serials", ctx.model.serials_list)("lots", ctx.model.lots_list)("store", ctx.model.store)("qte", ctx.model.qte)("value", "code")("mvtType", ctx.model.type)("readOnly", ctx.model == null ? null : ctx.model.state == null ? null : ctx.model.state.is_valid)("required", true)("settings", ctx.articleInputSettings);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(34, 68, "store.qte"))("ngModel", ctx.model.qte)("readonly", ctx.model == null ? null : ctx.model.state == null ? null : ctx.model.state.is_valid);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(37, 70, "shared.price"))("ftNumber", "float")("ngModel", ctx.model.price)("readonly", ctx.model == null ? null : ctx.model.state == null ? null : ctx.model.state.is_valid);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("vertical", true);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("required", true)("disabled", ctx.model == null ? null : ctx.model.state == null ? null : ctx.model.state.is_valid)("model", ctx.model.store)("listDialog", ctx.depotDialog)("config", i0.ɵɵpureFunction0(75, _c1$f))("label", "store.depot")("defaultValues", "default_store");
            i0.ɵɵadvance(3);
            i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(45, 72, "store.type"));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngModel", ctx.model.type)("disabled", ctx.model == null ? null : ctx.model.is_valid);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngForOf", ctx.types);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("model", ctx.model)("resource", ctx.resource)("movementType", ctx.model == null ? null : ctx.model.type)("displayedCols", i0.ɵɵpureFunction0(76, _c2$9));
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("model", ctx.model)("cls", ctx.apiUrl)("resource", ctx.resource)("formInvalid", _r0.invalid || !(ctx.model == null ? null : ctx.model.store) || !(ctx.model == null ? null : ctx.model.article))("busy", ctx.loading)("routes", ctx.routes)("loadedObject", ctx.loadedObject)("movementType", ctx.model == null ? null : ctx.model.type);
        }
    }, dependencies: [i4$1.NgForOf, i6.MatButton, i7.MatDatepicker, i7.MatDatepickerInput, i7.MatDatepickerToggle, i9.MatIcon, i10.MatFormField, i10.MatSuffix, i11$1.MatInput, i12$1.MatDivider, i13.MatRadioGroup, i13.MatRadioButton, i11.MatToolbar, i15$1.MatTooltip, i8.DefaultLayoutDirective, i8.DefaultLayoutGapDirective, i8.DefaultFlexDirective, i16.ɵNgNoValidate, i16.DefaultValueAccessor, i16.NumberValueAccessor, i16.NgControlStatus, i16.NgControlStatusGroup, i16.RequiredValidator, i16.MinValidator, i16.NgModel, i16.NgForm, i12.NgBusyDirective, i2.SequenceToggleComponent, i2.DateDirective, i2.InputDirective, i2.NumberDirective, i2.AutoFocusDirective, i2.SequenceInputDirective, ListSelectComponent, DocumentActionsComponent, DocumentDetailsComponent, ArticleTransformSelectComponent, i3$1.TranslatePipe], styles: ["[_nghost-%COMP%]{height:100%;display:flex;flex-direction:column}"] });
(function () {
    (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TransformationComponent, [{
            type: Component,
            args: [{ selector: 'fts-transformation', template: "\n<mat-toolbar color=\"accent\">\n  <div class=\"ft-module-icon\">\n    <button type=\"button\" mat-icon-button>\n      <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-crop-rotate\"></mat-icon>\n    </button>\n  </div>\n  <h2>\n    <span>{{'store.transformation_form'| translate}}&nbsp; N\u00B0:{{model.number}}</span>\n  </h2>\n  <span fxFlex></span>\n  <button type=\"button\" mat-button class=\"with-icon\"  (click)=\"goBack()\" [matTooltip]=\"'store.transformation_list'|translate\">\n    <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-format-list-bulleted\"></mat-icon>\n  </button>\n</mat-toolbar>\n\n<div fxFlex fxLayout=\"column\" class=\"ft-content\">\n   <div [ngBusy]=\"loading\"></div>\n\n  <form novalidate #transformationForm=\"ngForm\" fxLayout=\"column\" fxFlex  >\n      <div class=\"ft-padding\" fxLayout=\"row\">\n        <div fxFlex=\"60\" fxLayout=\"column\">\n          <div fxLayout=\"row\" fxLayoutGap=\"6px\">\n\n               <mat-form-field fxFlex=\"nogrow\">\n                  <input matInput type=\"text\" required\n                         [ftSequenceInput]=\"'ft_stock.store.StoreTransformation'\"\n                         [ftSequenceToggle]=\"toggle\"\n                         name=\"sequence\"\n                         [placeholder]=\"'store.transformation_number'|translate\"\n                         [(ngModel)]=\"model.number\"\n\n                         [disabled]=\"model?.state?.is_valid\"/>\n                  <ft-sequence-toggle matSuffix #toggle  [(objectId)]=\"loadedObject\"\n                                      [config]=\"{cls: 'ft_stock.store.StoreTransformation', field: 'number'}\">\n                  </ft-sequence-toggle>\n                </mat-form-field>\n                <mat-form-field fxFlex=\"nogrow\">\n                  <input matInput ftDate [ftAutoFocus]=\"true\" [placeholder]=\"'store.date'|translate\" name=\"date\" [disabled]=\"model?.state?.is_valid\"\n                         [(ngModel)]=\"model.date\" [matDatepicker]=\"picker\">\n                  <mat-datepicker-toggle matSuffix [for]=\"picker\"></mat-datepicker-toggle>\n                  <mat-datepicker #picker></mat-datepicker>\n                </mat-form-field>\n            </div>\n\n         <div fxLayout=\"row\" fxLayoutGap=\"6px\" >\n            <fts-article-transform-select fxFlex=\"50\"\n                                 [disabled]=\"model?.state?.is_valid\"\n                                 [label]=\"'store.article'\"\n                                 [(model)]=\"model.article\"\n                                 [(serials)]=\"model.serials_list\"\n                                 [(lots)]=\"model.lots_list\"\n                                 [store]=\"model.store\"\n                                 [qte]=\"model.qte\"\n                                 [value]=\"'code'\"\n                                 [mvtType]=\"model.type\"\n                                 [readOnly]=\"model?.state?.is_valid\"\n                                 [required]=\"true\"\n                                 [settings]=\"articleInputSettings\" >\n            </fts-article-transform-select>\n            <mat-form-field fxFlex=\"25\">\n              <input matInput [placeholder]=\"'store.qte'|translate\" name=\"qte\"   min=\"1\" type=\"number\"\n                     [(ngModel)]=\"model.qte\" required [readonly]=\"model?.state?.is_valid\">\n            </mat-form-field>\n            <mat-form-field fxFlex=\"25\">\n              <input matInput [placeholder]=\"'shared.price'|translate\" name=\"price\" [ftNumber]=\"'float'\"\n                     [(ngModel)]=\"model.price\" required [readonly]=\"model?.state?.is_valid\">\n            </mat-form-field>\n\n          </div>\n        </div>\n        <mat-divider [vertical]=\"true\"></mat-divider>\n        <div fxLayout=\"column\" fxFlex >\n          <div  fxLayout=\"row\" fxFlex=\"nogrow\" >\n            <fts-list-select [required]=\"true\"\n                             [disabled]=\"model?.state?.is_valid\"\n                             [(model)]=\"model.store\"\n                             [listDialog]=\"depotDialog\"\n                             [config]=\"{key: 'name', url: 'api/store/depot', cls:'store/depot', customValidator:'depot.check_uniqueness'}\"\n                             [label]=\"'store.depot'\"\n                              [defaultValues]=\"'default_store'\"\n                              >\n            </fts-list-select>\n          </div>\n\n          <div  fxLayout=\"row\" fxLayoutGap=\"8px\" >\n            <mat-form-field  fxFlex floatLabel=\"always\" class=\"ft-radio-field\">\n              <input matInput placeholder=\"{{'store.type'|translate}}\" style=\"display: none\">\n              <mat-radio-group [(ngModel)]=\"model.type\" name=\"type\" [disabled]=\"model?.is_valid\">\n                <mat-radio-button *ngFor=\"let type of types\" [value]=\"type\">\n                  {{'shared.'+type|translate}}\n                </mat-radio-button>\n              </mat-radio-group>\n\n            </mat-form-field>\n          </div>\n        </div>\n\n      </div>\n\n      <div fxLayout=\"column\" fxFlex>\n        <fts-document-details  fxFlex\n                               [(model)]=\"model\"\n                               [resource]=\"resource\"\n                               [movementType]=\"model?.type\"\n                               [displayedCols]=\"['code','description','qte','price','vat','store','sub_total']\"\n                               >\n        </fts-document-details>\n      </div>\n  </form>\n</div>\n\n<fts-document-actions fxFlex=\"nogrow\" [(model)]=\"model\" [cls]=\"apiUrl\" [resource]=\"resource\"\n                      [formInvalid]=\"transformationForm.invalid || !model?.store || !model?.article\"  [(busy)]=\"loading\"\n                      [routes]=\"routes\" [loadedObject]=\"loadedObject\" [movementType]=\"model?.type\"></fts-document-actions>\n", styles: [":host{height:100%;display:flex;flex-direction:column}\n"] }]
        }], function () { return [{ type: SharedModulesService }, { type: i2.DefaultValuesService }, { type: i3.Router }, { type: i3.ActivatedRoute }, { type: SharedService }]; }, null);
})();

const _c0$h = function () { return { cls: "ft_stock.store.StoreExchange", field: "number" }; };
const _c1$e = function () { return { key: "name", url: "api/store/depot", cls: "store/depot", customValidator: "depot.check_uniqueness" }; };
const _c2$8 = function () { return ["code", "description", "qte", "price", "vat", "store", "destination", "sub_total"]; };
class ExchangeComponent {
    constructor(sharedModulesService, defaultValuesService, router, route, sharedService) {
        this.sharedModulesService = sharedModulesService;
        this.defaultValuesService = defaultValuesService;
        this.router = router;
        this.route = route;
        this.sharedService = sharedService;
        this.depotDialog = DepotDialogComponent;
        this.loadedObject = null;
        this.model = { date: moment(), price_mode: this.defaultValuesService.getValue('default_price_mode') || 'HT' };
        this.apiUrl = 'store/store-exchange';
        this.resource = 'store-exchange';
        this.routes = { list: '/store/exchange', form: '/store/exchange/exchange-form' };
    }
    ngOnInit() {
        this.route.params.subscribe((data) => {
            let id = get(data, 'id');
            if (id)
                this.sharedService.getDocument(this.apiUrl, id).subscribe(data => {
                    this.model = data;
                });
        });
    }
    goBack() {
        this.router.navigate([handleRoute(this.sharedModulesService.pathName, this.routes["list"])]);
    }
}
ExchangeComponent.ɵfac = function ExchangeComponent_Factory(t) { return new (t || ExchangeComponent)(i0.ɵɵdirectiveInject(SharedModulesService), i0.ɵɵdirectiveInject(i2.DefaultValuesService), i0.ɵɵdirectiveInject(i3.Router), i0.ɵɵdirectiveInject(i3.ActivatedRoute), i0.ɵɵdirectiveInject(SharedService)); };
ExchangeComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExchangeComponent, selectors: [["fts-exchange"]], decls: 44, vars: 65, consts: [["color", "accent"], [1, "ft-module-icon"], ["type", "button", "mat-icon-button", ""], ["fontSet", "mdi", "fontIcon", "mdi-bank-transfer"], ["fxFlex", ""], ["type", "button", "mat-button", "", 1, "with-icon", 3, "matTooltip", "click"], ["fontSet", "mdi", "fontIcon", "mdi-format-list-bulleted"], ["fxFlex", "", "fxLayout", "column", 1, "ft-content"], [3, "ngBusy"], ["novalidate", "", "fxLayout", "column", "fxFlex", ""], ["Form", "ngForm"], ["fxLayout", "row", 1, "ft-padding"], ["fxFlex", "55", "fxLayout", "column"], ["fxLayout", "row", "fxLayoutGap", "6px"], ["fxFlex", "nogrow"], ["matInput", "", "type", "text", "required", "", "name", "sequence", 3, "ftSequenceInput", "ftSequenceToggle", "placeholder", "ngModel", "readonly", "ngModelChange"], ["matSuffix", "", 3, "objectId", "config", "objectIdChange"], ["toggle", ""], ["matInput", "", "ftDate", "", "name", "date", 3, "ftAutoFocus", "placeholder", "readonly", "ngModel", "matDatepicker", "ngModelChange"], ["matSuffix", "", 3, "for"], ["picker", ""], ["fxFlex", "50", 3, "required", "disabled", "model", "listDialog", "config", "label", "defaultValues", "modelChange"], ["fxFlex", "50", 3, "required", "disabled", "model", "listDialog", "config", "label", "modelChange"], [3, "vertical"], ["fxFlex", "43", "fxLayout", "column"], ["matInput", "", "name", "reason", 3, "placeholder", "ngModel", "readonly", "ngModelChange"], ["matInput", "", "name", "responsible", 3, "placeholder", "ngModel", "readonly", "ngModelChange"], ["fxLayout", "column", "fxFlex", ""], ["fxFlex", "", 3, "model", "resource", "movementType", "displayedCols", "modelChange"], ["fxFlex", "nogrow", 3, "model", "cls", "resource", "formInvalid", "busy", "routes", "loadedObject", "movementType", "modelChange", "busyChange"]], template: function ExchangeComponent_Template(rf, ctx) {
        if (rf & 1) {
            i0.ɵɵelementStart(0, "mat-toolbar", 0)(1, "div", 1)(2, "button", 2);
            i0.ɵɵelement(3, "mat-icon", 3);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(4, "h2")(5, "span");
            i0.ɵɵtext(6);
            i0.ɵɵpipe(7, "translate");
            i0.ɵɵelementEnd()();
            i0.ɵɵelement(8, "span", 4);
            i0.ɵɵelementStart(9, "button", 5);
            i0.ɵɵlistener("click", function ExchangeComponent_Template_button_click_9_listener() { return ctx.goBack(); });
            i0.ɵɵpipe(10, "translate");
            i0.ɵɵelement(11, "mat-icon", 6);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(12, "div", 7);
            i0.ɵɵelement(13, "div", 8);
            i0.ɵɵelementStart(14, "form", 9, 10)(16, "div", 11)(17, "div", 12)(18, "div", 13)(19, "mat-form-field", 14)(20, "input", 15);
            i0.ɵɵlistener("ngModelChange", function ExchangeComponent_Template_input_ngModelChange_20_listener($event) { return ctx.model.number = $event; });
            i0.ɵɵpipe(21, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(22, "ft-sequence-toggle", 16, 17);
            i0.ɵɵlistener("objectIdChange", function ExchangeComponent_Template_ft_sequence_toggle_objectIdChange_22_listener($event) { return ctx.loadedObject = $event; });
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(24, "mat-form-field", 14)(25, "input", 18);
            i0.ɵɵlistener("ngModelChange", function ExchangeComponent_Template_input_ngModelChange_25_listener($event) { return ctx.model.date = $event; });
            i0.ɵɵpipe(26, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(27, "mat-datepicker-toggle", 19)(28, "mat-datepicker", null, 20);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(30, "div", 13)(31, "fts-list-select", 21);
            i0.ɵɵlistener("modelChange", function ExchangeComponent_Template_fts_list_select_modelChange_31_listener($event) { return ctx.model.store = $event; });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(32, "fts-list-select", 22);
            i0.ɵɵlistener("modelChange", function ExchangeComponent_Template_fts_list_select_modelChange_32_listener($event) { return ctx.model.destination = $event; });
            i0.ɵɵelementEnd()()();
            i0.ɵɵelement(33, "mat-divider", 23);
            i0.ɵɵelementStart(34, "div", 24)(35, "mat-form-field", 4)(36, "input", 25);
            i0.ɵɵlistener("ngModelChange", function ExchangeComponent_Template_input_ngModelChange_36_listener($event) { return ctx.model.reason = $event; });
            i0.ɵɵpipe(37, "translate");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(38, "mat-form-field", 4)(39, "input", 26);
            i0.ɵɵlistener("ngModelChange", function ExchangeComponent_Template_input_ngModelChange_39_listener($event) { return ctx.model.responsible = $event; });
            i0.ɵɵpipe(40, "translate");
            i0.ɵɵelementEnd()()()();
            i0.ɵɵelementStart(41, "div", 27)(42, "fts-document-details", 28);
            i0.ɵɵlistener("modelChange", function ExchangeComponent_Template_fts_document_details_modelChange_42_listener($event) { return ctx.model = $event; });
            i0.ɵɵelementEnd()()()();
            i0.ɵɵelementStart(43, "fts-document-actions", 29);
            i0.ɵɵlistener("modelChange", function ExchangeComponent_Template_fts_document_actions_modelChange_43_listener($event) { return ctx.model = $event; })("busyChange", function ExchangeComponent_Template_fts_document_actions_busyChange_43_listener($event) { return ctx.loading = $event; });
            i0.ɵɵelementEnd();
        }
        if (rf & 2) {
            const _r0 = i0.ɵɵreference(15);
            const _r1 = i0.ɵɵreference(23);
            const _r2 = i0.ɵɵreference(29);
            i0.ɵɵadvance(6);
            i0.ɵɵtextInterpolate2("", i0.ɵɵpipeBind1(7, 49, "store.store_exchange"), "\u00A0 N\u00B0:", ctx.model.number, "");
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("matTooltip", i0.ɵɵpipeBind1(10, 51, "store.exchange_list"));
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngBusy", ctx.loading);
            i0.ɵɵadvance(7);
            i0.ɵɵproperty("ftSequenceInput", "ft_stock.store.StoreExchange")("ftSequenceToggle", _r1)("placeholder", i0.ɵɵpipeBind1(21, 53, "store.exchange_number"))("ngModel", ctx.model.number)("readonly", ctx.model == null ? null : ctx.model.state == null ? null : ctx.model.state.is_valid);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("objectId", ctx.loadedObject)("config", i0.ɵɵpureFunction0(61, _c0$h));
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ftAutoFocus", true)("placeholder", i0.ɵɵpipeBind1(26, 55, "store.date"))("readonly", ctx.model == null ? null : ctx.model.state == null ? null : ctx.model.state.is_valid)("ngModel", ctx.model.date)("matDatepicker", _r2);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("for", _r2);
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("required", true)("disabled", ctx.model == null ? null : ctx.model.state == null ? null : ctx.model.state.is_valid)("model", ctx.model.store)("listDialog", ctx.depotDialog)("config", i0.ɵɵpureFunction0(62, _c1$e))("label", "store.source_depot")("defaultValues", "default_store");
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("required", true)("disabled", ctx.model == null ? null : ctx.model.state == null ? null : ctx.model.state.is_valid)("model", ctx.model.destination)("listDialog", ctx.depotDialog)("config", i0.ɵɵpureFunction0(63, _c1$e))("label", "store.destination_depot");
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("vertical", true);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(37, 57, "store.reason"))("ngModel", ctx.model.reason)("readonly", ctx.model == null ? null : ctx.model.state == null ? null : ctx.model.state.is_valid);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(40, 59, "store.responsible"))("ngModel", ctx.model.responsible)("readonly", ctx.model == null ? null : ctx.model.state == null ? null : ctx.model.state.is_valid);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("model", ctx.model)("resource", ctx.resource)("movementType", "StoreExchange")("displayedCols", i0.ɵɵpureFunction0(64, _c2$8));
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("model", ctx.model)("cls", ctx.apiUrl)("resource", ctx.resource)("formInvalid", _r0.invalid || !(ctx.model == null ? null : ctx.model.store) || !(ctx.model == null ? null : ctx.model.destination) || (ctx.model == null ? null : ctx.model.store) == (ctx.model == null ? null : ctx.model.destination))("busy", ctx.loading)("routes", ctx.routes)("loadedObject", ctx.loadedObject)("movementType", "StoreExchange");
        }
    }, dependencies: [i6.MatButton, i7.MatDatepicker, i7.MatDatepickerInput, i7.MatDatepickerToggle, i9.MatIcon, i10.MatFormField, i10.MatSuffix, i11$1.MatInput, i12$1.MatDivider, i11.MatToolbar, i15$1.MatTooltip, i8.DefaultLayoutDirective, i8.DefaultLayoutGapDirective, i8.DefaultFlexDirective, i16.ɵNgNoValidate, i16.DefaultValueAccessor, i16.NgControlStatus, i16.NgControlStatusGroup, i16.RequiredValidator, i16.NgModel, i16.NgForm, i12.NgBusyDirective, i2.SequenceToggleComponent, i2.DateDirective, i2.InputDirective, i2.AutoFocusDirective, i2.SequenceInputDirective, ListSelectComponent, DocumentActionsComponent, DocumentDetailsComponent, i3$1.TranslatePipe], styles: ["[_nghost-%COMP%]{height:100%;display:flex;flex-direction:column}"] });
(function () {
    (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExchangeComponent, [{
            type: Component,
            args: [{ selector: 'fts-exchange', template: "\n<mat-toolbar color=\"accent\">\n  <div class=\"ft-module-icon\">\n    <button type=\"button\" mat-icon-button>\n      <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-bank-transfer\"></mat-icon>\n    </button>\n  </div>\n  <h2>\n    <span>{{'store.store_exchange'| translate}}&nbsp; N\u00B0:{{model.number}}</span>\n  </h2>\n  <span fxFlex></span>\n  <button type=\"button\" mat-button class=\"with-icon\"  (click)=\"goBack()\"[matTooltip]=\"'store.exchange_list'|translate\">\n    <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-format-list-bulleted\" ></mat-icon>\n  </button>\n</mat-toolbar>\n\n<div fxFlex fxLayout=\"column\" class=\"ft-content\">\n   <div [ngBusy]=\"loading\"></div>\n\n  <form novalidate #Form=\"ngForm\" fxLayout=\"column\" fxFlex  >\n      <div class=\"ft-padding\" fxLayout=\"row\">\n        <div fxFlex=\"55\" fxLayout=\"column\">\n          <div fxLayout=\"row\" fxLayoutGap=\"6px\">\n               <mat-form-field fxFlex=\"nogrow\">\n                  <input matInput type=\"text\" required\n                         [ftSequenceInput]=\"'ft_stock.store.StoreExchange'\"\n                         [ftSequenceToggle]=\"toggle\"\n                         name=\"sequence\"\n                         [placeholder]=\"'store.exchange_number'|translate\"\n                         [(ngModel)]=\"model.number\"\n\n                         [readonly]=\"model?.state?.is_valid\"/>\n                  <ft-sequence-toggle matSuffix #toggle  [(objectId)]=\"loadedObject\"\n                                      [config]=\"{cls: 'ft_stock.store.StoreExchange', field: 'number'}\">\n                  </ft-sequence-toggle>\n                </mat-form-field>\n                <mat-form-field fxFlex=\"nogrow\">\n                  <input matInput [ftAutoFocus]=\"true\"  ftDate [placeholder]=\"'store.date'|translate\" name=\"date\" [readonly]=\"model?.state?.is_valid\"\n                         [(ngModel)]=\"model.date\" [matDatepicker]=\"picker\">\n                  <mat-datepicker-toggle matSuffix [for]=\"picker\"></mat-datepicker-toggle>\n                  <mat-datepicker #picker></mat-datepicker>\n                </mat-form-field>\n            </div>\n\n          <div fxLayout=\"row\" fxLayoutGap=\"6px\" >\n              <fts-list-select fxFlex=\"50\"\n                               [required]=\"true\"\n                               [disabled]=\"model?.state?.is_valid\"\n                               [(model)]=\"model.store\"\n                               [listDialog]=\"depotDialog\"\n                               [config]=\"{key: 'name', url: 'api/store/depot', cls:'store/depot', customValidator:'depot.check_uniqueness'}\"\n                               [label]=\"'store.source_depot'\"  [defaultValues]=\"'default_store'\"\n                                >\n              </fts-list-select>\n\n              <fts-list-select fxFlex=\"50\"\n                 [required]=\"true\"\n                 [disabled]=\"model?.state?.is_valid\"\n                 [(model)]=\"model.destination\"\n                 [listDialog]=\"depotDialog\"\n                 [config]=\"{key: 'name', url: 'api/store/depot', cls:'store/depot', customValidator:'depot.check_uniqueness'}\"\n                 [label]=\"'store.destination_depot'\"\n                  >\n              </fts-list-select>\n          </div>\n\n        </div>\n        <mat-divider [vertical]=\"true\"></mat-divider>\n        <div fxFlex=\"43\"  fxLayout=\"column\">\n            <mat-form-field fxFlex >\n              <input matInput [placeholder]=\"'store.reason'|translate\" name=\"reason\"\n                     [(ngModel)]=\"model.reason\" [readonly]=\"model?.state?.is_valid\">\n            </mat-form-field>\n            <mat-form-field fxFlex >\n              <input matInput [placeholder]=\"'store.responsible'|translate\" name=\"responsible\"\n                     [(ngModel)]=\"model.responsible\"  [readonly]=\"model?.state?.is_valid\">\n            </mat-form-field>\n        </div>\n      </div>\n\n      <div fxLayout=\"column\" fxFlex>\n        <fts-document-details  fxFlex [(model)]=\"model\"\n                               [resource]=\"resource\" [movementType]=\"'StoreExchange'\"\n                               [displayedCols]=\"['code','description','qte','price','vat','store','destination','sub_total']\"  >\n        </fts-document-details>\n      </div>\n  </form>\n</div>\n\n<fts-document-actions fxFlex=\"nogrow\" [(model)]=\"model\" [cls]=\"apiUrl\" [resource]=\"resource\"\n                      [formInvalid]=\"Form.invalid || !model?.store ||  !model?.destination  ||model?.store==model?.destination \"  [(busy)]=\"loading\"\n                      [routes]=\"routes\" [loadedObject]=\"loadedObject\" [movementType]=\"'StoreExchange'\"></fts-document-actions>\n\n", styles: [":host{height:100%;display:flex;flex-direction:column}\n"] }]
        }], function () { return [{ type: SharedModulesService }, { type: i2.DefaultValuesService }, { type: i3.Router }, { type: i3.ActivatedRoute }, { type: SharedService }]; }, null);
})();

function PriceRequestFormComponent_div_14_Template(rf, ctx) {
    if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 26);
        i0.ɵɵelement(1, "img", 27);
        i0.ɵɵelementEnd();
    }
}
const _c0$g = function () { return { cls: "ft_stock.purchase.PriceRequest", field: "number" }; };
const _c1$d = function () { return ["code", "description", "qte"]; };
class PriceRequestFormComponent {
    constructor(sharedModulesService, router, route, sharedService) {
        this.sharedModulesService = sharedModulesService;
        this.router = router;
        this.route = route;
        this.sharedService = sharedService;
        this.providerInputSettings = assignIn(cloneDeep(PROVIDER_VIEW), { selectable: false });
        this.providerDialog = ProviderDialogComponent;
        this.loadedObject = null;
        this.model = { date: moment(), providers: [] };
        this.apiUrl = 'purchase/price-request';
        this.resource = 'price-request';
        this.routes = { list: '/purchase/price-request', form: '/purchase/price-request/price-request-form' };
    }
    ngOnInit() {
        this.route.params.subscribe((data) => {
            let id = get(data, 'id');
            if (id)
                this.sharedService.getDocument(this.apiUrl, id).subscribe(data => {
                    this.model = data;
                });
        });
    }
    goBack() {
        this.router.navigate([handleRoute(this.sharedModulesService.pathName, this.routes["list"])]);
    }
}
PriceRequestFormComponent.ɵfac = function PriceRequestFormComponent_Factory(t) { return new (t || PriceRequestFormComponent)(i0.ɵɵdirectiveInject(SharedModulesService), i0.ɵɵdirectiveInject(i3.Router), i0.ɵɵdirectiveInject(i3.ActivatedRoute), i0.ɵɵdirectiveInject(SharedService)); };
PriceRequestFormComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PriceRequestFormComponent, selectors: [["fts-price-request-form"]], decls: 36, vars: 50, consts: [["color", "accent"], [1, "ft-module-icon"], ["type", "button", "mat-icon-button", ""], ["fontSet", "mdi", "fontIcon", "mdi-clipboard-text-outline"], ["fxFlex", ""], ["type", "button", "mat-button", "", 1, "with-icon", 3, "matTooltip", "click"], ["fontSet", "mdi", "fontIcon", "mdi-format-list-bulleted"], ["fxFlex", "", "fxLayout", "column", 1, "ft-content"], [3, "ngBusy"], ["fxLayoutAlign", "center center", "class", "validate-icon", 4, "ngIf"], ["fxFlex", "", "fxLayout", "column", "fxLayoutGap", "8px"], ["Form", "ngForm"], ["fxLayout", "row", 1, "ft-padding"], ["fxFlex", "50", "fxLayout", "column"], ["fxLayout", "row", "fxLayoutGap", "6px"], ["fxFlex", "nogrow"], ["matInput", "", "type", "text", "required", "", "name", "sequence", 3, "ftSequenceInput", "ftSequenceToggle", "placeholder", "ngModel", "readonly", "ngModelChange"], ["matSuffix", "", 3, "objectId", "config", "objectIdChange"], ["toggle", ""], ["matInput", "", "ftDate", "", "name", "date", 3, "ftAutoFocus", "placeholder", "readonly", "ngModel", "matDatepicker", "ngModelChange"], ["matSuffix", "", 3, "for"], ["picker", ""], ["fxFlex", "", 3, "disabled", "label", "model", "value", "multiple", "settings", "dialog", "modelChange"], ["fxLayout", "column", "fxFlex", ""], ["fxFlex", "", 3, "lines", "defaultDepot", "priceMode", "movementType", "readOnly", "displayedCols", "linesChange"], ["fxFlex", "nogrow", 3, "model", "cls", "resource", "formInvalid", "busy", "autoValidate", "routes", "loadedObject", "movementType", "modelChange", "busyChange"], ["fxLayoutAlign", "center center", 1, "validate-icon"], ["mat-card-image", "", "src", "/assets/lock-outline.svg", "alt", "validation img"]], template: function PriceRequestFormComponent_Template(rf, ctx) {
        if (rf & 1) {
            i0.ɵɵelementStart(0, "mat-toolbar", 0)(1, "div", 1)(2, "button", 2);
            i0.ɵɵelement(3, "mat-icon", 3);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(4, "h2")(5, "span");
            i0.ɵɵtext(6);
            i0.ɵɵpipe(7, "translate");
            i0.ɵɵelementEnd()();
            i0.ɵɵelement(8, "span", 4);
            i0.ɵɵelementStart(9, "button", 5);
            i0.ɵɵlistener("click", function PriceRequestFormComponent_Template_button_click_9_listener() { return ctx.goBack(); });
            i0.ɵɵpipe(10, "translate");
            i0.ɵɵelement(11, "mat-icon", 6);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(12, "div", 7);
            i0.ɵɵelement(13, "div", 8);
            i0.ɵɵtemplate(14, PriceRequestFormComponent_div_14_Template, 2, 0, "div", 9);
            i0.ɵɵelementStart(15, "form", 10, 11)(17, "div", 12)(18, "div", 13)(19, "div", 14)(20, "mat-form-field", 15)(21, "input", 16);
            i0.ɵɵlistener("ngModelChange", function PriceRequestFormComponent_Template_input_ngModelChange_21_listener($event) { return ctx.model.number = $event; });
            i0.ɵɵpipe(22, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(23, "ft-sequence-toggle", 17, 18);
            i0.ɵɵlistener("objectIdChange", function PriceRequestFormComponent_Template_ft_sequence_toggle_objectIdChange_23_listener($event) { return ctx.loadedObject = $event; });
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(25, "mat-form-field", 15)(26, "input", 19);
            i0.ɵɵlistener("ngModelChange", function PriceRequestFormComponent_Template_input_ngModelChange_26_listener($event) { return ctx.model.date = $event; });
            i0.ɵɵpipe(27, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(28, "mat-datepicker-toggle", 20)(29, "mat-datepicker", null, 21);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(31, "div", 14)(32, "fts-document-select", 22);
            i0.ɵɵlistener("modelChange", function PriceRequestFormComponent_Template_fts_document_select_modelChange_32_listener($event) { return ctx.model.providers = $event; });
            i0.ɵɵelementEnd()()()();
            i0.ɵɵelementStart(33, "div", 23)(34, "fts-document-lines", 24);
            i0.ɵɵlistener("linesChange", function PriceRequestFormComponent_Template_fts_document_lines_linesChange_34_listener($event) { return ctx.model.lines = $event; });
            i0.ɵɵelementEnd()()()();
            i0.ɵɵelementStart(35, "fts-document-actions", 25);
            i0.ɵɵlistener("modelChange", function PriceRequestFormComponent_Template_fts_document_actions_modelChange_35_listener($event) { return ctx.model = $event; })("busyChange", function PriceRequestFormComponent_Template_fts_document_actions_busyChange_35_listener($event) { return ctx.loading = $event; });
            i0.ɵɵelementEnd();
        }
        if (rf & 2) {
            const _r1 = i0.ɵɵreference(16);
            const _r2 = i0.ɵɵreference(24);
            const _r3 = i0.ɵɵreference(30);
            i0.ɵɵadvance(6);
            i0.ɵɵtextInterpolate2("", i0.ɵɵpipeBind1(7, 40, "store.price_request"), "\u00A0 N\u00B0:", ctx.model.number, "");
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("matTooltip", i0.ɵɵpipeBind1(10, 42, "purchase.price_request_list"));
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngBusy", ctx.loading);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.model.state == null ? null : ctx.model.state.is_valid);
            i0.ɵɵadvance(7);
            i0.ɵɵproperty("ftSequenceInput", "ft_stock.purchase.PriceRequest")("ftSequenceToggle", _r2)("placeholder", i0.ɵɵpipeBind1(22, 44, "purchase.price_request_number"))("ngModel", ctx.model.number)("readonly", ctx.model == null ? null : ctx.model.state == null ? null : ctx.model.state.is_valid);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("objectId", ctx.loadedObject)("config", i0.ɵɵpureFunction0(48, _c0$g));
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ftAutoFocus", true)("placeholder", i0.ɵɵpipeBind1(27, 46, "store.date"))("readonly", ctx.model == null ? null : ctx.model.state == null ? null : ctx.model.state.is_valid)("ngModel", ctx.model.date)("matDatepicker", _r3);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("for", _r3);
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("disabled", ctx.model == null ? null : ctx.model.state == null ? null : ctx.model.state.is_valid)("label", "purchase.providers")("model", ctx.model.providers)("value", "name")("multiple", true)("settings", ctx.providerInputSettings)("dialog", ctx.providerDialog);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("lines", ctx.model.lines)("defaultDepot", null)("priceMode", "HT")("movementType", "PriceRequest")("readOnly", ctx.model == null ? null : ctx.model.state == null ? null : ctx.model.state.is_valid)("displayedCols", i0.ɵɵpureFunction0(49, _c1$d));
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("model", ctx.model)("cls", ctx.apiUrl)("resource", ctx.resource)("formInvalid", _r1.invalid || !(ctx.model == null ? null : ctx.model.providers) || (ctx.model == null ? null : ctx.model.providers == null ? null : ctx.model.providers.length) == 0)("busy", ctx.loading)("autoValidate", true)("routes", ctx.routes)("loadedObject", ctx.loadedObject)("movementType", "PriceRequest");
        }
    }, dependencies: [i4$1.NgIf, i6.MatButton, i6$1.MatCardImage, i7.MatDatepicker, i7.MatDatepickerInput, i7.MatDatepickerToggle, i9.MatIcon, i10.MatFormField, i10.MatSuffix, i11$1.MatInput, i11.MatToolbar, i15$1.MatTooltip, i8.DefaultLayoutDirective, i8.DefaultLayoutGapDirective, i8.DefaultLayoutAlignDirective, i8.DefaultFlexDirective, i16.ɵNgNoValidate, i16.DefaultValueAccessor, i16.NgControlStatus, i16.NgControlStatusGroup, i16.RequiredValidator, i16.NgModel, i16.NgForm, i12.NgBusyDirective, i2.SequenceToggleComponent, i2.DateDirective, i2.InputDirective, i2.AutoFocusDirective, i2.SequenceInputDirective, DocumentSelectComponent, DocumentActionsComponent, DocumentLinesComponent, i3$1.TranslatePipe], styles: ["[_nghost-%COMP%]{height:100%;display:flex;flex-direction:column}"] });
(function () {
    (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PriceRequestFormComponent, [{
            type: Component,
            args: [{ selector: 'fts-price-request-form', template: "<mat-toolbar color=\"accent\">\n  <div class=\"ft-module-icon\">\n    <button type=\"button\" mat-icon-button>\n      <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-clipboard-text-outline\"></mat-icon>\n    </button>\n  </div>\n  <h2>\n    <span>{{'store.price_request'| translate}}&nbsp; N\u00B0:{{model.number}}</span>\n  </h2>\n  <span fxFlex></span>\n  <button type=\"button\" mat-button class=\"with-icon\"  (click)=\"goBack()\" [matTooltip]=\"'purchase.price_request_list'|translate\">\n    <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-format-list-bulleted\"></mat-icon>\n  </button>\n</mat-toolbar>\n\n<div fxFlex fxLayout=\"column\" class=\"ft-content\">\n    <div [ngBusy]=\"loading\"></div>\n    <div *ngIf=\"model.state?.is_valid\" fxLayoutAlign=\"center center\" class=\"validate-icon\">\n      <img mat-card-image src=\"/assets/lock-outline.svg\" alt=\"validation img\">\n    </div>\n    <form #Form=\"ngForm\" fxFlex fxLayout=\"column\" fxLayoutGap=\"8px\">\n    <div class=\"ft-padding\" fxLayout=\"row\">\n          <div fxFlex=\"50\" fxLayout=\"column\">\n            <div fxLayout=\"row\" fxLayoutGap=\"6px\">\n                 <mat-form-field fxFlex=\"nogrow\">\n                    <input matInput type=\"text\" required\n                           [ftSequenceInput]=\"'ft_stock.purchase.PriceRequest'\"\n                           [ftSequenceToggle]=\"toggle\"\n                           name=\"sequence\"\n                           [placeholder]=\"'purchase.price_request_number'|translate\"\n                           [(ngModel)]=\"model.number\"\n\n                           [readonly]=\"model?.state?.is_valid\"/>\n                    <ft-sequence-toggle matSuffix #toggle  [(objectId)]=\"loadedObject\"\n                                        [config]=\"{cls: 'ft_stock.purchase.PriceRequest', field: 'number'}\">\n                    </ft-sequence-toggle>\n                  </mat-form-field>\n                  <mat-form-field fxFlex=\"nogrow\">\n                    <input matInput [ftAutoFocus]=\"true\"  ftDate [placeholder]=\"'store.date'|translate\" name=\"date\" [readonly]=\"model?.state?.is_valid\"\n                           [(ngModel)]=\"model.date\" [matDatepicker]=\"picker\">\n                    <mat-datepicker-toggle matSuffix [for]=\"picker\"></mat-datepicker-toggle>\n                    <mat-datepicker #picker></mat-datepicker>\n                  </mat-form-field>\n            </div>\n            <div fxLayout=\"row\" fxLayoutGap=\"6px\">\n\n              <fts-document-select fxFlex\n                                   [disabled]=\"model?.state?.is_valid\"\n                                   [label]=\"'purchase.providers'\"\n                                   [(model)]=\"model.providers\"\n                                   [value]=\"'name'\"\n                                   [multiple]=\"true\"\n                                   [settings]=\"providerInputSettings\"\n                                   [dialog]=\"providerDialog\">\n              </fts-document-select>\n            </div>\n\n          </div>\n    </div>\n\n    <div fxLayout=\"column\" fxFlex>\n      <fts-document-lines fxFlex [(lines)]=\"model.lines\"\n                          [defaultDepot]=\"null\"\n                          [priceMode]=\"'HT'\"\n                          [movementType]=\"'PriceRequest'\"\n                          [readOnly]=\"model?.state?.is_valid\"\n                          [displayedCols]=\"['code','description','qte']\"\n                          >\n      </fts-document-lines>\n\n    </div>\n\n  </form>\n</div>\n\n<fts-document-actions fxFlex=\"nogrow\" [(model)]=\"model\" [cls]=\"apiUrl\" [resource]=\"resource\"\n                      [formInvalid]=\"Form.invalid || !model?.providers ||  model?.providers?.length==0 \"\n                      [(busy)]=\"loading\" [autoValidate]=\"true\"\n                      [routes]=\"routes\" [loadedObject]=\"loadedObject\" [movementType]=\"'PriceRequest'\"></fts-document-actions>\n\n", styles: [":host{height:100%;display:flex;flex-direction:column}\n"] }]
        }], function () { return [{ type: SharedModulesService }, { type: i3.Router }, { type: i3.ActivatedRoute }, { type: SharedService }]; }, null);
})();

function PurchaseOrderComponent_button_12_Template(rf, ctx) {
    if (rf & 1) {
        i0.ɵɵelementStart(0, "button", 42);
        i0.ɵɵelement(1, "mat-icon", 43);
        i0.ɵɵelementEnd();
    }
    if (rf & 2) {
        i0.ɵɵnextContext();
        const _r1 = i0.ɵɵreference(14);
        i0.ɵɵproperty("matMenuTriggerFor", _r1);
    }
}
function PurchaseOrderComponent_mat_option_56_Template(rf, ctx) {
    if (rf & 1) {
        i0.ɵɵelementStart(0, "mat-option", 44);
        i0.ɵɵtext(1);
        i0.ɵɵpipe(2, "translate");
        i0.ɵɵelementEnd();
    }
    if (rf & 2) {
        const type_r9 = ctx.$implicit;
        i0.ɵɵproperty("value", type_r9);
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 2, "shared." + type_r9), " ");
    }
}
function PurchaseOrderComponent_mat_option_60_Template(rf, ctx) {
    if (rf & 1) {
        i0.ɵɵelementStart(0, "mat-option", 44);
        i0.ɵɵtext(1);
        i0.ɵɵpipe(2, "translate");
        i0.ɵɵelementEnd();
    }
    if (rf & 2) {
        const condition_r10 = ctx.$implicit;
        i0.ɵɵproperty("value", condition_r10);
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 2, "shared." + condition_r10.key), " ");
    }
}
function PurchaseOrderComponent_mat_radio_button_72_Template(rf, ctx) {
    if (rf & 1) {
        i0.ɵɵelementStart(0, "mat-radio-button", 44);
        i0.ɵɵtext(1);
        i0.ɵɵpipe(2, "translate");
        i0.ɵɵelementEnd();
    }
    if (rf & 2) {
        const type_price_r11 = ctx.$implicit;
        i0.ɵɵproperty("value", type_price_r11);
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 2, "shared." + type_price_r11), " ");
    }
}
const _c0$f = function () { return { cls: "ft_stock.purchase.PurchaseOrder", field: "number" }; };
const _c1$c = function () { return ["price_request_number", "code", "description", "qte", "price", "sub_total"]; };
class PurchaseOrderComponent {
    constructor(sharedModulesService, defaultValuesService, router, route, sharedService) {
        this.sharedModulesService = sharedModulesService;
        this.defaultValuesService = defaultValuesService;
        this.router = router;
        this.route = route;
        this.sharedService = sharedService;
        this.providerInputSettings = assignIn(cloneDeep(PROVIDER_VIEW), { selectable: false });
        this.providerDialog = ProviderDialogComponent;
        this.patientInputSettings = assignIn(cloneDeep(PATIENT_VIEW), { selectable: false });
        this.patientDialog = PatientDialogComponent;
        this.loadedObject = null;
        this.paymentModeTypes = PAYMENT_MODE_TYPES;
        this.paymentConditions = PAYMENT_CONDITIONS;
        this.price_mode = ['HT', 'TTC'];
        this.model = { date: moment(), price_mode: this.defaultValuesService.getValue('default_price_mode') || 'HT', payment_mode: { type: this.defaultValuesService.getValue('payment_mode') } };
        this.apiUrl = 'purchase/purchase-order';
        this.resource = 'purchase-order';
        this.routes = { list: '/purchase/purchase-order', form: '/purchase/purchase-order/purchase-order-form' };
    }
    ngOnInit() {
        this.route.params.subscribe((data) => {
            let id = get(data, 'id');
            if (id)
                this.sharedService.getDocument(this.apiUrl, id).subscribe(data => {
                    this.model = data;
                });
        });
    }
    goBack() {
        this.router.navigate([handleRoute(this.sharedModulesService.pathName, this.routes["list"])]);
    }
    handleState(state) {
        this.loading = this.sharedService.saveDocument(this.apiUrl, this.model, null).subscribe(data => {
            this.model = data;
        });
    }
    compareMode(o1, o2) {
        return o1 == o2;
    }
    compareCondition(o1, o2) {
        return o1 && o2 ? o1.key == o2.key || o1.id == o2.id : false;
    }
}
PurchaseOrderComponent.ɵfac = function PurchaseOrderComponent_Factory(t) { return new (t || PurchaseOrderComponent)(i0.ɵɵdirectiveInject(SharedModulesService), i0.ɵɵdirectiveInject(i2.DefaultValuesService), i0.ɵɵdirectiveInject(i3.Router), i0.ɵɵdirectiveInject(i3.ActivatedRoute), i0.ɵɵdirectiveInject(SharedService)); };
PurchaseOrderComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PurchaseOrderComponent, selectors: [["fts-purchase-order"]], decls: 76, vars: 92, consts: [["color", "accent"], [1, "ft-module-icon"], ["type", "button", "mat-icon-button", ""], ["fontSet", "mdi", "fontIcon", "mdi-clipboard-text"], ["fxFlex", ""], ["mat-icon-button", "", 3, "matTooltip", "click"], ["fontSet", "mdi", "fontIcon", "mdi-format-list-bulleted"], ["mat-icon-button", "", "aria-label", "action menu", 3, "matMenuTriggerFor", 4, "ngIf"], ["menu", "matMenu"], ["mat-menu-item", "", 3, "click"], ["fontSet", "mdi", "fontIcon", "mdi-check-circle", "color", "accent"], ["fontSet", "mdi", "fontIcon", "mdi-close-circle", "color", "accent"], ["fxFlex", "", "fxLayout", "column", 1, "ft-content"], [3, "ngBusy"], ["fxFlex", "", "fxLayout", "column", "fxLayoutGap", "8px"], ["Form", "ngForm"], ["fxLayout", "row", 1, "ft-padding"], ["fxFlex", "60", "fxLayout", "column"], ["fxLayout", "row", "fxLayoutGap", "6px"], ["fxFlex", "nogrow"], ["matInput", "", "type", "text", "required", "", "name", "sequence", 3, "ftSequenceInput", "ftSequenceToggle", "placeholder", "ngModel", "ftAutoFocus", "readonly", "ngModelChange"], ["matSuffix", "", 3, "objectId", "config", "objectIdChange"], ["toggle", ""], ["matInput", "", "ftDate", "", "name", "date", 3, "ftAutoFocus", "placeholder", "readonly", "ngModel", "matDatepicker", "ngModelChange"], ["matSuffix", "", 3, "for"], ["picker", ""], ["fxFlex", "", 3, "disabled", "label", "model", "required", "value", "settings", "dialog", "modelChange"], ["fxFlex", "", 3, "disabled", "label", "model", "value", "settings", "dialog", "modelChange"], ["matInput", "", "name", "attention_to", 3, "placeholder", "ngModel", "readonly", "ngModelChange"], [3, "vertical"], ["fxFlex", "", "fxLayout", "column"], ["ftDefaultValues", "payment_mode", "name", "mode", 3, "placeholder", "compareWith", "ngModel", "ngModelChange"], [3, "value", 4, "ngFor", "ngForOf"], ["ftDefaultValues", "default_payment_condition", "name", "payment_condition", 3, "placeholder", "compareWith", "ngModel", "ngModelChange"], ["matInput", "", "ftDate", "", "name", "delivery_date", "required", "", 3, "placeholder", "readonly", "ngModel", "matDatepicker", "ngModelChange"], ["picker2", ""], ["fxLayout", "column", "floatLabel", "always", 1, "ft-radio-field"], ["matInput", "", 2, "display", "none", 3, "placeholder"], ["name", "price_mode", "ftDefaultValues", "default_price_mode", 3, "ngModel", "disabled", "ngModelChange"], ["fxLayout", "column", "fxFlex", ""], ["fxFlex", "", 3, "model", "resource", "movementType", "displayedCols", "modelChange"], ["fxFlex", "nogrow", 3, "model", "cls", "resource", "formInvalid", "busy", "autoValidate", "routes", "loadedObject", "movementType", "modelChange", "busyChange"], ["mat-icon-button", "", "aria-label", "action menu", 3, "matMenuTriggerFor"], ["fontSet", "mdi", "fontIcon", "mdi-dots-vertical"], [3, "value"]], template: function PurchaseOrderComponent_Template(rf, ctx) {
        if (rf & 1) {
            i0.ɵɵelementStart(0, "mat-toolbar", 0)(1, "div", 1)(2, "button", 2);
            i0.ɵɵelement(3, "mat-icon", 3);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(4, "h2")(5, "span");
            i0.ɵɵtext(6);
            i0.ɵɵpipe(7, "translate");
            i0.ɵɵelementEnd()();
            i0.ɵɵelement(8, "span", 4);
            i0.ɵɵelementStart(9, "button", 5);
            i0.ɵɵlistener("click", function PurchaseOrderComponent_Template_button_click_9_listener() { return ctx.goBack(); });
            i0.ɵɵpipe(10, "translate");
            i0.ɵɵelement(11, "mat-icon", 6);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(12, PurchaseOrderComponent_button_12_Template, 2, 1, "button", 7);
            i0.ɵɵelementStart(13, "mat-menu", null, 8)(15, "button", 9);
            i0.ɵɵlistener("click", function PurchaseOrderComponent_Template_button_click_15_listener() { return ctx.handleState({ "fenced": true }); });
            i0.ɵɵelement(16, "mat-icon", 10);
            i0.ɵɵelementStart(17, "span");
            i0.ɵɵtext(18);
            i0.ɵɵpipe(19, "translate");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(20, "button", 9);
            i0.ɵɵlistener("click", function PurchaseOrderComponent_Template_button_click_20_listener() { return ctx.handleState({ "canceled": true }); });
            i0.ɵɵelement(21, "mat-icon", 11);
            i0.ɵɵelementStart(22, "span");
            i0.ɵɵtext(23);
            i0.ɵɵpipe(24, "translate");
            i0.ɵɵelementEnd()()()();
            i0.ɵɵelementStart(25, "div", 12);
            i0.ɵɵelement(26, "div", 13);
            i0.ɵɵelementStart(27, "form", 14, 15)(29, "div", 16)(30, "div", 17)(31, "div", 18)(32, "mat-form-field", 19)(33, "input", 20);
            i0.ɵɵlistener("ngModelChange", function PurchaseOrderComponent_Template_input_ngModelChange_33_listener($event) { return ctx.model.number = $event; });
            i0.ɵɵpipe(34, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(35, "ft-sequence-toggle", 21, 22);
            i0.ɵɵlistener("objectIdChange", function PurchaseOrderComponent_Template_ft_sequence_toggle_objectIdChange_35_listener($event) { return ctx.loadedObject = $event; });
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(37, "mat-form-field", 19)(38, "input", 23);
            i0.ɵɵlistener("ngModelChange", function PurchaseOrderComponent_Template_input_ngModelChange_38_listener($event) { return ctx.model.date = $event; });
            i0.ɵɵpipe(39, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(40, "mat-datepicker-toggle", 24)(41, "mat-datepicker", null, 25);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(43, "div", 18)(44, "fts-document-select", 26);
            i0.ɵɵlistener("modelChange", function PurchaseOrderComponent_Template_fts_document_select_modelChange_44_listener($event) { return ctx.model.provider = $event; });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(45, "fts-document-select", 27);
            i0.ɵɵlistener("modelChange", function PurchaseOrderComponent_Template_fts_document_select_modelChange_45_listener($event) { return ctx.model.patient = $event; });
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(46, "div", 18)(47, "mat-form-field", 4)(48, "input", 28);
            i0.ɵɵlistener("ngModelChange", function PurchaseOrderComponent_Template_input_ngModelChange_48_listener($event) { return ctx.model.attention_to = $event; });
            i0.ɵɵpipe(49, "translate");
            i0.ɵɵelementEnd()()()();
            i0.ɵɵelement(50, "mat-divider", 29);
            i0.ɵɵelementStart(51, "div", 30)(52, "div", 18)(53, "mat-form-field", 4)(54, "mat-select", 31);
            i0.ɵɵlistener("ngModelChange", function PurchaseOrderComponent_Template_mat_select_ngModelChange_54_listener($event) { return ctx.model.payment_mode.type = $event; });
            i0.ɵɵpipe(55, "translate");
            i0.ɵɵtemplate(56, PurchaseOrderComponent_mat_option_56_Template, 3, 4, "mat-option", 32);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(57, "mat-form-field", 4)(58, "mat-select", 33);
            i0.ɵɵlistener("ngModelChange", function PurchaseOrderComponent_Template_mat_select_ngModelChange_58_listener($event) { return ctx.model.payment_condition = $event; });
            i0.ɵɵpipe(59, "translate");
            i0.ɵɵtemplate(60, PurchaseOrderComponent_mat_option_60_Template, 3, 4, "mat-option", 32);
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(61, "div", 18)(62, "mat-form-field", 19)(63, "input", 34);
            i0.ɵɵlistener("ngModelChange", function PurchaseOrderComponent_Template_input_ngModelChange_63_listener($event) { return ctx.model.delivery_date = $event; });
            i0.ɵɵpipe(64, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(65, "mat-datepicker-toggle", 24)(66, "mat-datepicker", null, 35);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(68, "mat-form-field", 36);
            i0.ɵɵelement(69, "input", 37);
            i0.ɵɵpipe(70, "translate");
            i0.ɵɵelementStart(71, "mat-radio-group", 38);
            i0.ɵɵlistener("ngModelChange", function PurchaseOrderComponent_Template_mat_radio_group_ngModelChange_71_listener($event) { return ctx.model.price_mode = $event; });
            i0.ɵɵtemplate(72, PurchaseOrderComponent_mat_radio_button_72_Template, 3, 4, "mat-radio-button", 32);
            i0.ɵɵelementEnd()()()()();
            i0.ɵɵelementStart(73, "div", 39)(74, "fts-document-details", 40);
            i0.ɵɵlistener("modelChange", function PurchaseOrderComponent_Template_fts_document_details_modelChange_74_listener($event) { return ctx.model = $event; });
            i0.ɵɵelementEnd()()()();
            i0.ɵɵelementStart(75, "fts-document-actions", 41);
            i0.ɵɵlistener("modelChange", function PurchaseOrderComponent_Template_fts_document_actions_modelChange_75_listener($event) { return ctx.model = $event; })("busyChange", function PurchaseOrderComponent_Template_fts_document_actions_busyChange_75_listener($event) { return ctx.loading = $event; });
            i0.ɵɵelementEnd();
        }
        if (rf & 2) {
            const _r2 = i0.ɵɵreference(28);
            const _r3 = i0.ɵɵreference(36);
            const _r4 = i0.ɵɵreference(42);
            const _r7 = i0.ɵɵreference(67);
            i0.ɵɵadvance(6);
            i0.ɵɵtextInterpolate2("", i0.ɵɵpipeBind1(7, 68, "purchase.purchase_order"), "\u00A0 N\u00B0:", ctx.model.number, "");
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("matTooltip", i0.ɵɵpipeBind1(10, 70, "purchase.purchase_order_list"));
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngIf", ctx.model == null ? null : ctx.model.id);
            i0.ɵɵadvance(6);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(19, 72, "purchase.fence_doc"));
            i0.ɵɵadvance(5);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(24, 74, "purchase.cancel_doc"));
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngBusy", ctx.loading);
            i0.ɵɵadvance(7);
            i0.ɵɵproperty("ftSequenceInput", "ft_stock.purchase.PurchaseOrder")("ftSequenceToggle", _r3)("placeholder", i0.ɵɵpipeBind1(34, 76, "purchase.purchase_order_number"))("ngModel", ctx.model.number)("ftAutoFocus", true)("readonly", ctx.model == null ? null : ctx.model.state == null ? null : ctx.model.state.is_valid);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("objectId", ctx.loadedObject)("config", i0.ɵɵpureFunction0(90, _c0$f));
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ftAutoFocus", true)("placeholder", i0.ɵɵpipeBind1(39, 78, "store.date"))("readonly", ctx.model == null ? null : ctx.model.state == null ? null : ctx.model.state.is_valid)("ngModel", ctx.model.date)("matDatepicker", _r4);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("for", _r4);
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("disabled", ctx.model == null ? null : ctx.model.state == null ? null : ctx.model.state.is_valid)("label", "shared.provider")("model", ctx.model.provider)("required", true)("value", "name")("settings", ctx.providerInputSettings)("dialog", ctx.providerDialog);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("disabled", ctx.model == null ? null : ctx.model.state == null ? null : ctx.model.state.is_valid)("label", "store.patient")("model", ctx.model.patient)("value", "full_name")("settings", ctx.patientInputSettings)("dialog", ctx.patientDialog);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(49, 80, "purchase.attention_to"))("ngModel", ctx.model.attention_to)("readonly", ctx.model == null ? null : ctx.model.state == null ? null : ctx.model.state.is_valid);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("vertical", true);
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(55, 82, "purchase.payment_mode"))("compareWith", ctx.compareMode)("ngModel", ctx.model.payment_mode.type);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngForOf", ctx.paymentModeTypes);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(59, 84, "purchase.payment_condition"))("compareWith", ctx.compareCondition)("ngModel", ctx.model.payment_condition);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngForOf", ctx.paymentConditions);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(64, 86, "store.delivery_date"))("readonly", ctx.model == null ? null : ctx.model.state == null ? null : ctx.model.state.is_valid)("ngModel", ctx.model.delivery_date)("matDatepicker", _r7);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("for", _r7);
            i0.ɵɵadvance(4);
            i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(70, 88, "shared.price_mode"));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngModel", ctx.model.price_mode)("disabled", true);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngForOf", ctx.price_mode);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("model", ctx.model)("resource", ctx.resource)("movementType", "PurchaseOrder")("displayedCols", i0.ɵɵpureFunction0(91, _c1$c));
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("model", ctx.model)("cls", ctx.apiUrl)("resource", ctx.resource)("formInvalid", _r2.invalid || !ctx.model.provider)("busy", ctx.loading)("autoValidate", true)("routes", ctx.routes)("loadedObject", ctx.loadedObject)("movementType", "PurchaseOrder");
        }
    }, dependencies: [i4$1.NgForOf, i4$1.NgIf, i5.MatOption, i6.MatButton, i7.MatDatepicker, i7.MatDatepickerInput, i7.MatDatepickerToggle, i9.MatIcon, i10.MatFormField, i10.MatSuffix, i11$1.MatInput, i12$1.MatDivider, i13$1.MatMenu, i13$1.MatMenuItem, i13$1.MatMenuTrigger, i13.MatRadioGroup, i13.MatRadioButton, i15.MatSelect, i11.MatToolbar, i15$1.MatTooltip, i8.DefaultLayoutDirective, i8.DefaultLayoutGapDirective, i8.DefaultFlexDirective, i16.ɵNgNoValidate, i16.DefaultValueAccessor, i16.NgControlStatus, i16.NgControlStatusGroup, i16.RequiredValidator, i16.NgModel, i16.NgForm, i12.NgBusyDirective, i2.SequenceToggleComponent, i2.DateDirective, i2.InputDirective, i2.AutoFocusDirective, i2.SequenceInputDirective, i2.DefaultValuesDirective, DocumentSelectComponent, DocumentActionsComponent, DocumentDetailsComponent, i3$1.TranslatePipe], styles: ["[_nghost-%COMP%]{height:100%;display:flex;flex-direction:column}"] });
(function () {
    (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PurchaseOrderComponent, [{
            type: Component,
            args: [{ selector: 'fts-purchase-order', template: "<mat-toolbar color=\"accent\">\n  <div class=\"ft-module-icon\">\n    <button type=\"button\" mat-icon-button>\n      <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-clipboard-text\"></mat-icon>\n    </button>\n  </div>\n  <h2>\n    <span>{{'purchase.purchase_order'| translate}}&nbsp; N\u00B0:{{model.number}}</span>\n  </h2>\n  <span fxFlex></span>\n\n  <button mat-icon-button (click)=\"goBack()\"\n          [matTooltip]=\"'purchase.purchase_order_list'| translate\">\n    <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-format-list-bulleted\"></mat-icon>\n  </button>\n\n  <button mat-icon-button [matMenuTriggerFor]=\"menu\" aria-label=\"action menu\" *ngIf=\"model?.id\">\n    <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-dots-vertical\"></mat-icon>\n  </button>\n  <mat-menu #menu=\"matMenu\">\n    <button mat-menu-item (click)=\"handleState({'fenced':true})\">\n      <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-check-circle\" color=\"accent\"></mat-icon>\n      <span>{{'purchase.fence_doc'| translate}}</span>\n    </button>\n    <button mat-menu-item (click)=\"handleState({'canceled':true})\">\n      <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-close-circle\" color=\"accent\"></mat-icon>\n      <span>{{'purchase.cancel_doc'| translate}}</span>\n    </button>\n  </mat-menu>\n</mat-toolbar>\n\n<div fxFlex fxLayout=\"column\" class=\"ft-content\">\n    <div [ngBusy]=\"loading\"></div>\n\n    <form #Form=\"ngForm\" fxFlex fxLayout=\"column\" fxLayoutGap=\"8px\">\n    <div class=\"ft-padding\" fxLayout=\"row\">\n          <div fxFlex=\"60\" fxLayout=\"column\">\n            <div fxLayout=\"row\" fxLayoutGap=\"6px\">\n                 <mat-form-field fxFlex=\"nogrow\">\n                    <input matInput type=\"text\" required\n                           [ftSequenceInput]=\"'ft_stock.purchase.PurchaseOrder'\"\n                           [ftSequenceToggle]=\"toggle\"\n                           name=\"sequence\"\n                           [placeholder]=\"'purchase.purchase_order_number'|translate\"\n                           [(ngModel)]=\"model.number\"\n                            [ftAutoFocus]=\"true\"\n                           [readonly]=\"model?.state?.is_valid\"/>\n                    <ft-sequence-toggle matSuffix #toggle  [(objectId)]=\"loadedObject\"\n                                        [config]=\"{cls: 'ft_stock.purchase.PurchaseOrder', field: 'number'}\">\n                    </ft-sequence-toggle>\n                  </mat-form-field>\n                  <mat-form-field fxFlex=\"nogrow\">\n                    <input matInput [ftAutoFocus]=\"true\" ftDate [placeholder]=\"'store.date'|translate\" name=\"date\" [readonly]=\"model?.state?.is_valid\"\n                           [(ngModel)]=\"model.date\" [matDatepicker]=\"picker\">\n                    <mat-datepicker-toggle matSuffix [for]=\"picker\"></mat-datepicker-toggle>\n                    <mat-datepicker #picker></mat-datepicker>\n                  </mat-form-field>\n\n            </div>\n            <div fxLayout=\"row\" fxLayoutGap=\"6px\">\n              <fts-document-select fxFlex\n                                   [disabled]=\"model?.state?.is_valid\"\n                                   [label]=\"'shared.provider'\"\n                                   [(model)]=\"model.provider\"\n                                   [required]=\"true\"\n                                   [value]=\"'name'\"\n                                   [settings]=\"providerInputSettings\"\n                                   [dialog]=\"providerDialog\">\n              </fts-document-select>\n              <fts-document-select fxFlex\n                     [disabled]=\"model?.state?.is_valid\"\n                     [label]=\"'store.patient'\"\n                     [(model)]=\"model.patient\"\n                     [value]=\"'full_name'\"\n                     [settings]=\"patientInputSettings\"\n                     [dialog]=\"patientDialog\">\n              </fts-document-select>\n            </div>\n            <div fxLayout=\"row\" fxLayoutGap=\"6px\">\n               <mat-form-field  fxFlex=\"\">\n                <input matInput [placeholder]=\"'purchase.attention_to'|translate\" name=\"attention_to\"\n                         [(ngModel)]=\"model.attention_to\" [readonly]=\"model?.state?.is_valid\">\n                </mat-form-field>\n            </div>\n          </div>\n          <mat-divider [vertical]=\"true\"></mat-divider>\n          <div fxFlex fxLayout=\"column\">\n            <div fxLayout=\"row\" fxLayoutGap=\"6px\">\n               <mat-form-field fxFlex>\n                  <mat-select [placeholder]=\"'purchase.payment_mode' | translate\" [compareWith]=\"compareMode\"\n                              ftDefaultValues=\"payment_mode\"\n                              [(ngModel)]=\"model.payment_mode.type\" name=\"mode\">\n                    <mat-option *ngFor=\"let type of paymentModeTypes\" [value]=\"type\">\n                      {{'shared.'+type |translate}}\n                    </mat-option>\n                  </mat-select>\n                </mat-form-field>\n                <mat-form-field fxFlex>\n                  <mat-select [placeholder]=\"'purchase.payment_condition' | translate\" [compareWith]=\"compareCondition\" ftDefaultValues=\"default_payment_condition\"\n                              [(ngModel)]=\"model.payment_condition\" name=\"payment_condition\">\n                    <mat-option *ngFor=\"let condition of paymentConditions\" [value]=\"condition\">\n                      {{'shared.'+condition.key|translate}}\n                    </mat-option>\n                  </mat-select>\n                </mat-form-field>\n            </div>\n            <div  fxLayout=\"row\" fxLayoutGap=\"6px\">\n                <mat-form-field fxFlex=\"nogrow\">\n                  <input matInput ftDate [placeholder]=\"'store.delivery_date'|translate\" name=\"delivery_date\" [readonly]=\"model?.state?.is_valid\" required\n                         [(ngModel)]=\"model.delivery_date\" [matDatepicker]=\"picker2\">\n                  <mat-datepicker-toggle matSuffix [for]=\"picker2\"></mat-datepicker-toggle>\n                  <mat-datepicker #picker2></mat-datepicker>\n                </mat-form-field>\n                <mat-form-field fxLayout=\"column\" floatLabel=\"always\" class=\"ft-radio-field\" >\n                  <input matInput placeholder=\"{{'shared.price_mode'|translate}}\"  style=\"display: none\">\n                  <mat-radio-group [(ngModel)]=\"model.price_mode\" name=\"price_mode\" [disabled]=\"true\"  ftDefaultValues=\"default_price_mode\">\n                    <mat-radio-button *ngFor=\"let type_price of price_mode\" [value]=\"type_price\">\n                      {{'shared.'+type_price|translate}}\n                    </mat-radio-button>\n                  </mat-radio-group>\n                </mat-form-field>\n            </div>\n          </div>\n    </div>\n\n\n    <div fxLayout=\"column\" fxFlex>\n      <fts-document-details  fxFlex [(model)]=\"model\"\n                               [resource]=\"resource\"\n                                    [movementType]=\"'PurchaseOrder'\"\n                                    [displayedCols]=\"['price_request_number','code','description','qte','price','sub_total']\"\n                                    >\n      </fts-document-details>\n    </div>\n\n  </form>\n</div>\n\n<fts-document-actions fxFlex=\"nogrow\" [(model)]=\"model\" [cls]=\"apiUrl\" [resource]=\"resource\"\n                      [formInvalid]=\"Form.invalid|| !model.provider\"  [(busy)]=\"loading\" [autoValidate]=\"true\"\n                      [routes]=\"routes\" [loadedObject]=\"loadedObject\" [movementType]=\"'PurchaseOrder'\"></fts-document-actions>\n\n", styles: [":host{height:100%;display:flex;flex-direction:column}\n"] }]
        }], function () { return [{ type: SharedModulesService }, { type: i2.DefaultValuesService }, { type: i3.Router }, { type: i3.ActivatedRoute }, { type: SharedService }]; }, null);
})();

function DepositionComponent_mat_radio_button_52_Template(rf, ctx) {
    if (rf & 1) {
        i0.ɵɵelementStart(0, "mat-radio-button", 36);
        i0.ɵɵtext(1);
        i0.ɵɵpipe(2, "translate");
        i0.ɵɵelementEnd();
    }
    if (rf & 2) {
        const type_price_r6 = ctx.$implicit;
        i0.ɵɵproperty("value", type_price_r6);
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 2, "shared." + type_price_r6), " ");
    }
}
const _c0$e = function () { return { cls: "ft_stock.purchase.DepositionForm", field: "number" }; };
const _c1$b = function () { return { key: "name", url: "api/store/depot", cls: "store/depot", customValidator: "depot.check_uniqueness" }; };
const _c2$7 = function () { return ["code", "description", "qte", "price", "vat", "store", "sub_total"]; };
class DepositionComponent {
    constructor(sharedModulesService, defaultValuesService, router, route, sharedService) {
        this.sharedModulesService = sharedModulesService;
        this.defaultValuesService = defaultValuesService;
        this.router = router;
        this.route = route;
        this.sharedService = sharedService;
        this.providerInputSettings = assignIn(cloneDeep(PROVIDER_VIEW), { selectable: false });
        this.providerDialog = ProviderDialogComponent;
        this.loadedObject = null;
        this.depotDialog = DepotDialogComponent;
        this.price_mode = ['HT', 'TTC'];
        this.model = { date: moment(), start_date: moment(), dead_line: moment(), price_mode: this.defaultValuesService.getValue('default_price_mode') || 'HT' };
        this.apiUrl = 'purchase/deposition-form';
        this.resource = 'deposition-form';
        this.routes = { list: '/purchase/deposition', form: '/purchase/deposition/deposition-form' };
    }
    ngOnInit() {
        this.route.params.subscribe((data) => {
            let id = get(data, 'id');
            if (id)
                this.sharedService.getDocument(this.apiUrl, id).subscribe(data => {
                    this.model = data;
                });
        });
    }
    goBack() {
        this.router.navigate([handleRoute(this.sharedModulesService.pathName, this.routes["list"])]);
    }
}
DepositionComponent.ɵfac = function DepositionComponent_Factory(t) { return new (t || DepositionComponent)(i0.ɵɵdirectiveInject(SharedModulesService), i0.ɵɵdirectiveInject(i2.DefaultValuesService), i0.ɵɵdirectiveInject(i3.Router), i0.ɵɵdirectiveInject(i3.ActivatedRoute), i0.ɵɵdirectiveInject(SharedService)); };
DepositionComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DepositionComponent, selectors: [["fts-deposition"]], decls: 56, vars: 76, consts: [["color", "accent"], [1, "ft-module-icon"], ["type", "button", "mat-icon-button", ""], ["fontSet", "mdi", "fontIcon", "mdi-clipboard-arrow-down"], ["fxFlex", ""], ["type", "button", "mat-button", "", 1, "with-icon", 3, "matTooltip", "click"], ["fontSet", "mdi", "fontIcon", "mdi-format-list-bulleted"], ["fxFlex", "", "fxLayout", "column", 1, "ft-content"], [3, "ngBusy"], ["novalidate", "", "fxLayout", "column", "fxFlex", ""], ["Form", "ngForm"], ["fxLayout", "row", 1, "ft-padding"], ["fxFlex", "60", "fxLayout", "column"], ["fxLayout", "row", "fxLayoutGap", "6px"], ["fxFlex", "24"], ["matInput", "", "type", "text", "required", "", "name", "sequence", 3, "ftSequenceInput", "ftSequenceToggle", "placeholder", "ngModel", "disabled", "ngModelChange"], ["matSuffix", "", 3, "objectId", "config", "objectIdChange"], ["toggle", ""], ["matInput", "", "ftDate", "", "name", "date", 3, "ftAutoFocus", "placeholder", "disabled", "ngModel", "matDatepicker", "ngModelChange"], ["matSuffix", "", 3, "for"], ["picker", ""], ["matInput", "", "ftDate", "", "name", "start_date", "required", "", 3, "placeholder", "max", "disabled", "ngModel", "matDatepicker", "ngModelChange"], ["picker3", ""], ["matInput", "", "ftDate", "", "name", "dead_line", "required", "", 3, "placeholder", "min", "disabled", "ngModel", "matDatepicker", "ngModelChange"], ["picker2", ""], ["fxFlex", "", 3, "disabled", "label", "model", "value", "settings", "dialog", "modelChange"], [3, "vertical"], ["fxFlex", "nogrow", "fxLayout", "column"], ["fxFlex", "", 3, "required", "disabled", "model", "listDialog", "config", "label", "defaultValues", "modelChange"], ["floatLabel", "always", 1, "ft-radio-field"], ["matInput", "", 2, "display", "none", 3, "placeholder"], ["name", "price_mode", "ftDefaultValues", "default_price_mode", 3, "ngModel", "disabled", "ngModelChange"], [3, "value", 4, "ngFor", "ngForOf"], ["fxLayout", "column", "fxFlex", ""], ["fxFlex", "", 3, "model", "movementType", "resource", "displayedCols", "modelChange"], ["fxFlex", "nogrow", 3, "model", "cls", "resource", "formInvalid", "busy", "routes", "loadedObject", "movementType", "modelChange", "busyChange"], [3, "value"]], template: function DepositionComponent_Template(rf, ctx) {
        if (rf & 1) {
            i0.ɵɵelementStart(0, "mat-toolbar", 0)(1, "div", 1)(2, "button", 2);
            i0.ɵɵelement(3, "mat-icon", 3);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(4, "h2")(5, "span");
            i0.ɵɵtext(6);
            i0.ɵɵpipe(7, "translate");
            i0.ɵɵelementEnd()();
            i0.ɵɵelement(8, "span", 4);
            i0.ɵɵelementStart(9, "button", 5);
            i0.ɵɵlistener("click", function DepositionComponent_Template_button_click_9_listener() { return ctx.goBack(); });
            i0.ɵɵpipe(10, "translate");
            i0.ɵɵelement(11, "mat-icon", 6);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(12, "div", 7);
            i0.ɵɵelement(13, "div", 8);
            i0.ɵɵelementStart(14, "form", 9, 10)(16, "div", 11)(17, "div", 12)(18, "div", 13)(19, "mat-form-field", 14)(20, "input", 15);
            i0.ɵɵlistener("ngModelChange", function DepositionComponent_Template_input_ngModelChange_20_listener($event) { return ctx.model.number = $event; });
            i0.ɵɵpipe(21, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(22, "ft-sequence-toggle", 16, 17);
            i0.ɵɵlistener("objectIdChange", function DepositionComponent_Template_ft_sequence_toggle_objectIdChange_22_listener($event) { return ctx.loadedObject = $event; });
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(24, "mat-form-field", 14)(25, "input", 18);
            i0.ɵɵlistener("ngModelChange", function DepositionComponent_Template_input_ngModelChange_25_listener($event) { return ctx.model.date = $event; });
            i0.ɵɵpipe(26, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(27, "mat-datepicker-toggle", 19)(28, "mat-datepicker", null, 20);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(30, "mat-form-field", 14)(31, "input", 21);
            i0.ɵɵlistener("ngModelChange", function DepositionComponent_Template_input_ngModelChange_31_listener($event) { return ctx.model.start_date = $event; });
            i0.ɵɵpipe(32, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(33, "mat-datepicker-toggle", 19)(34, "mat-datepicker", null, 22);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(36, "mat-form-field", 14)(37, "input", 23);
            i0.ɵɵlistener("ngModelChange", function DepositionComponent_Template_input_ngModelChange_37_listener($event) { return ctx.model.dead_line = $event; });
            i0.ɵɵpipe(38, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(39, "mat-datepicker-toggle", 19)(40, "mat-datepicker", null, 24);
            i0.ɵɵelementEnd();
            i0.ɵɵelement(42, "span", 4);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(43, "div", 13)(44, "fts-document-select", 25);
            i0.ɵɵlistener("modelChange", function DepositionComponent_Template_fts_document_select_modelChange_44_listener($event) { return ctx.model.provider = $event; });
            i0.ɵɵelementEnd()()();
            i0.ɵɵelement(45, "mat-divider", 26);
            i0.ɵɵelementStart(46, "div", 27)(47, "fts-list-select", 28);
            i0.ɵɵlistener("modelChange", function DepositionComponent_Template_fts_list_select_modelChange_47_listener($event) { return ctx.model.store = $event; });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(48, "mat-form-field", 29);
            i0.ɵɵelement(49, "input", 30);
            i0.ɵɵpipe(50, "translate");
            i0.ɵɵelementStart(51, "mat-radio-group", 31);
            i0.ɵɵlistener("ngModelChange", function DepositionComponent_Template_mat_radio_group_ngModelChange_51_listener($event) { return ctx.model.price_mode = $event; });
            i0.ɵɵtemplate(52, DepositionComponent_mat_radio_button_52_Template, 3, 4, "mat-radio-button", 32);
            i0.ɵɵelementEnd()()()();
            i0.ɵɵelementStart(53, "div", 33)(54, "fts-document-details", 34);
            i0.ɵɵlistener("modelChange", function DepositionComponent_Template_fts_document_details_modelChange_54_listener($event) { return ctx.model = $event; });
            i0.ɵɵelementEnd()()()();
            i0.ɵɵelementStart(55, "fts-document-actions", 35);
            i0.ɵɵlistener("modelChange", function DepositionComponent_Template_fts_document_actions_modelChange_55_listener($event) { return ctx.model = $event; })("busyChange", function DepositionComponent_Template_fts_document_actions_busyChange_55_listener($event) { return ctx.loading = $event; });
            i0.ɵɵelementEnd();
        }
        if (rf & 2) {
            const _r0 = i0.ɵɵreference(15);
            const _r1 = i0.ɵɵreference(23);
            const _r2 = i0.ɵɵreference(29);
            const _r3 = i0.ɵɵreference(35);
            const _r4 = i0.ɵɵreference(41);
            i0.ɵɵadvance(6);
            i0.ɵɵtextInterpolate2("", i0.ɵɵpipeBind1(7, 59, "store.deposition_form"), " N\u00B0:", ctx.model.number, "");
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("matTooltip", i0.ɵɵpipeBind1(10, 61, "store.deposition_list"));
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngBusy", ctx.loading);
            i0.ɵɵadvance(7);
            i0.ɵɵproperty("ftSequenceInput", "ft_stock.purchase.DepositionForm")("ftSequenceToggle", _r1)("placeholder", i0.ɵɵpipeBind1(21, 63, "purchase.deposition_number"))("ngModel", ctx.model.number)("disabled", ctx.model == null ? null : ctx.model.state == null ? null : ctx.model.state.is_valid);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("objectId", ctx.loadedObject)("config", i0.ɵɵpureFunction0(73, _c0$e));
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ftAutoFocus", true)("placeholder", i0.ɵɵpipeBind1(26, 65, "store.date"))("disabled", ctx.model == null ? null : ctx.model.state == null ? null : ctx.model.state.is_valid)("ngModel", ctx.model.date)("matDatepicker", _r2);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("for", _r2);
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(32, 67, "purchase.start_date"))("max", ctx.model.dead_line)("disabled", ctx.model == null ? null : ctx.model.state == null ? null : ctx.model.state.is_valid)("ngModel", ctx.model.start_date)("matDatepicker", _r3);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("for", _r3);
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(38, 69, "purchase.dead_line_date"))("min", ctx.model.start_date)("disabled", ctx.model == null ? null : ctx.model.state == null ? null : ctx.model.state.is_valid)("ngModel", ctx.model.dead_line)("matDatepicker", _r4);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("for", _r4);
            i0.ɵɵadvance(5);
            i0.ɵɵproperty("disabled", ctx.model == null ? null : ctx.model.state == null ? null : ctx.model.state.is_valid)("label", "store.default_provider")("model", ctx.model.provider)("value", "name")("settings", ctx.providerInputSettings)("dialog", ctx.providerDialog);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("vertical", true);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("required", true)("disabled", ctx.model == null ? null : ctx.model.state == null ? null : ctx.model.state.is_valid)("model", ctx.model.store)("listDialog", ctx.depotDialog)("config", i0.ɵɵpureFunction0(74, _c1$b))("label", "store.depot")("defaultValues", "default_store");
            i0.ɵɵadvance(2);
            i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(50, 71, "shared.price_mode"));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngModel", ctx.model.price_mode)("disabled", ctx.model == null ? null : ctx.model.state == null ? null : ctx.model.state.is_valid);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngForOf", ctx.price_mode);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("model", ctx.model)("movementType", "DepositionForm")("resource", ctx.resource)("displayedCols", i0.ɵɵpureFunction0(75, _c2$7));
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("model", ctx.model)("cls", ctx.apiUrl)("resource", ctx.resource)("formInvalid", _r0.invalid || !(ctx.model == null ? null : ctx.model.store))("busy", ctx.loading)("routes", ctx.routes)("loadedObject", ctx.loadedObject)("movementType", "DepositionForm");
        }
    }, dependencies: [i4$1.NgForOf, i6.MatButton, i7.MatDatepicker, i7.MatDatepickerInput, i7.MatDatepickerToggle, i9.MatIcon, i10.MatFormField, i10.MatSuffix, i11$1.MatInput, i12$1.MatDivider, i13.MatRadioGroup, i13.MatRadioButton, i11.MatToolbar, i15$1.MatTooltip, i8.DefaultLayoutDirective, i8.DefaultLayoutGapDirective, i8.DefaultFlexDirective, i16.ɵNgNoValidate, i16.DefaultValueAccessor, i16.NgControlStatus, i16.NgControlStatusGroup, i16.RequiredValidator, i16.NgModel, i16.NgForm, i12.NgBusyDirective, i2.SequenceToggleComponent, i2.DateDirective, i2.InputDirective, i2.AutoFocusDirective, i2.SequenceInputDirective, i2.DefaultValuesDirective, DocumentSelectComponent, ListSelectComponent, DocumentActionsComponent, DocumentDetailsComponent, i3$1.TranslatePipe], styles: ["[_nghost-%COMP%]{height:100%;display:flex;flex-direction:column}"] });
(function () {
    (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DepositionComponent, [{
            type: Component,
            args: [{ selector: 'fts-deposition', template: "<mat-toolbar color=\"accent\">\n  <div class=\"ft-module-icon\">\n    <button type=\"button\" mat-icon-button>\n      <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-clipboard-arrow-down\"></mat-icon>\n    </button>\n  </div>\n  <h2>\n    <span>{{'store.deposition_form'| translate}} N\u00B0:{{model.number}}</span>\n  </h2>\n  <span fxFlex></span>\n  <button type=\"button\" mat-button class=\"with-icon\"  (click)=\"goBack()\" [matTooltip]=\"'store.deposition_list'|translate\">\n    <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-format-list-bulleted\"></mat-icon>\n  </button>\n</mat-toolbar>\n\n<div fxFlex fxLayout=\"column\" class=\"ft-content\">\n   <div [ngBusy]=\"loading\"></div>\n\n  <form novalidate #Form=\"ngForm\" fxLayout=\"column\" fxFlex  >\n      <div class=\"ft-padding\" fxLayout=\"row\"  >\n        <div fxFlex=\"60\" fxLayout=\"column\">\n            <div fxLayout=\"row\" fxLayoutGap=\"6px\">\n              <mat-form-field fxFlex=\"24\">\n                <input matInput type=\"text\" required\n                       [ftSequenceInput]=\"'ft_stock.purchase.DepositionForm'\"\n                       [ftSequenceToggle]=\"toggle\"\n                       name=\"sequence\"\n                       [placeholder]=\"'purchase.deposition_number'|translate\"\n                       [(ngModel)]=\"model.number\"\n\n                       [disabled]=\"model?.state?.is_valid\"/>\n                <ft-sequence-toggle matSuffix #toggle  [(objectId)]=\"loadedObject\"\n                                    [config]=\"{cls: 'ft_stock.purchase.DepositionForm', field: 'number'}\">\n                </ft-sequence-toggle>\n              </mat-form-field>\n              <mat-form-field fxFlex=\"24\">\n                <input matInput ftDate [ftAutoFocus]=\"true\" [placeholder]=\"'store.date'|translate\" name=\"date\" [disabled]=\"model?.state?.is_valid\"\n                       [(ngModel)]=\"model.date\" [matDatepicker]=\"picker\">\n                <mat-datepicker-toggle matSuffix [for]=\"picker\"></mat-datepicker-toggle>\n                <mat-datepicker #picker></mat-datepicker>\n              </mat-form-field>\n              <mat-form-field fxFlex=\"24\">\n                <input matInput ftDate [placeholder]=\"'purchase.start_date'|translate\" name=\"start_date\"  [max]=\"model.dead_line\"\n                       required\n                       [disabled]=\"model?.state?.is_valid\"\n                       [(ngModel)]=\"model.start_date\" [matDatepicker]=\"picker3\">\n                <mat-datepicker-toggle matSuffix [for]=\"picker3\"></mat-datepicker-toggle>\n                <mat-datepicker #picker3></mat-datepicker>\n              </mat-form-field>\n              <mat-form-field fxFlex=\"24\">\n                <input matInput ftDate [placeholder]=\"'purchase.dead_line_date'|translate\" name=\"dead_line\" [min]=\"model.start_date\"\n                       required\n                       [disabled]=\"model?.state?.is_valid\"\n                       [(ngModel)]=\"model.dead_line\" [matDatepicker]=\"picker2\">\n                <mat-datepicker-toggle matSuffix [for]=\"picker2\"></mat-datepicker-toggle>\n                <mat-datepicker #picker2></mat-datepicker>\n              </mat-form-field>\n               <span fxFlex > </span>\n\n           </div>\n            <div fxLayout=\"row\"  fxLayoutGap=\"6px\">\n\n              <fts-document-select fxFlex\n                       [disabled]=\"model?.state?.is_valid\"\n                       [label]=\"'store.default_provider'\"\n                       [(model)]=\"model.provider\"\n                       [value]=\"'name'\"\n                       [settings]=\"providerInputSettings\"\n                       [dialog]=\"providerDialog\">\n              </fts-document-select>\n            </div>\n        </div>\n        <mat-divider [vertical]=\"true\"></mat-divider>\n        <div fxFlex=\"nogrow\" fxLayout=\"column\">\n\n              <fts-list-select fxFlex\n                               [required]=\"true\"\n                               [disabled]=\"model?.state?.is_valid\"\n                               [(model)]=\"model.store\"\n                               [listDialog]=\"depotDialog\"\n                               [config]=\"{key: 'name', url: 'api/store/depot', cls:'store/depot', customValidator:'depot.check_uniqueness'}\"\n                               [label]=\"'store.depot'\"  [defaultValues]=\"'default_store'\"\n                                >\n              </fts-list-select>\n              <mat-form-field floatLabel=\"always\" class=\"ft-radio-field\" >\n                <input matInput placeholder=\"{{'shared.price_mode'|translate}}\" style=\"display: none\">\n                <mat-radio-group [(ngModel)]=\"model.price_mode\" name=\"price_mode\" [disabled]=\"model?.state?.is_valid\"  ftDefaultValues=\"default_price_mode\">\n                  <mat-radio-button *ngFor=\"let type_price of price_mode\" [value]=\"type_price\">\n                    {{'shared.'+type_price|translate}}\n                  </mat-radio-button>\n                </mat-radio-group>\n              </mat-form-field>\n        </div>\n      </div>\n      <div fxLayout=\"column\" fxFlex>\n        <fts-document-details  fxFlex [(model)]=\"model\"\n                                [movementType]=\"'DepositionForm'\"\n                               [resource]=\"resource\"\n                                [displayedCols]=\"[ 'code','description','qte','price','vat','store','sub_total']\">\n        </fts-document-details>\n      </div>\n  </form>\n\n</div>\n<fts-document-actions fxFlex=\"nogrow\" [(model)]=\"model\" [cls]=\"apiUrl\" [resource]=\"resource\"\n                      [formInvalid]=\"Form.invalid || !model?.store\"  [(busy)]=\"loading\"\n                      [routes]=\"routes\" [loadedObject]=\"loadedObject\" [movementType]=\"'DepositionForm'\"></fts-document-actions>\n", styles: [":host{height:100%;display:flex;flex-direction:column}\n"] }]
        }], function () { return [{ type: SharedModulesService }, { type: i2.DefaultValuesService }, { type: i3.Router }, { type: i3.ActivatedRoute }, { type: SharedService }]; }, null);
})();

function ReturnFormComponent_mat_radio_button_42_Template(rf, ctx) {
    if (rf & 1) {
        i0.ɵɵelementStart(0, "mat-radio-button", 33);
        i0.ɵɵtext(1);
        i0.ɵɵpipe(2, "translate");
        i0.ɵɵelementEnd();
    }
    if (rf & 2) {
        const type_price_r4 = ctx.$implicit;
        i0.ɵɵproperty("value", type_price_r4);
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 2, "shared." + type_price_r4), " ");
    }
}
const _c0$d = function () { return { cls: "ft_stock.purchase.ReturnForm", field: "number" }; };
const _c1$a = function () { return { key: "name", url: "api/store/depot", cls: "store/depot", customValidator: "depot.check_uniqueness" }; };
const _c2$6 = function () { return ["deposition_number", "receipt_number", "code", "description", "qte", "price", "vat", "store", "sub_total"]; };
class ReturnFormComponent {
    constructor(sharedModulesService, defaultValuesService, router, route, sharedService) {
        this.sharedModulesService = sharedModulesService;
        this.defaultValuesService = defaultValuesService;
        this.router = router;
        this.route = route;
        this.sharedService = sharedService;
        this.providerInputSettings = assignIn(cloneDeep(PROVIDER_VIEW), { selectable: false });
        this.providerDialog = ProviderDialogComponent;
        this.loadedObject = null;
        this.depotDialog = DepotDialogComponent;
        this.price_mode = ['HT', 'TTC'];
        this.model = { date: moment(), start_date: moment(), dead_line: moment(), price_mode: this.defaultValuesService.getValue('default_price_mode') || 'HT' };
        this.apiUrl = 'purchase/return-form';
        this.resource = 'return-form';
        this.routes = { list: '/purchase/return', form: '/purchase/return/return-form' };
    }
    ngOnInit() {
        this.route.params.subscribe((data) => {
            let id = get(data, 'id');
            if (id)
                this.sharedService.getDocument(this.apiUrl, id).subscribe(data => {
                    this.model = data;
                });
        });
    }
    goBack() {
        this.router.navigate([handleRoute(this.sharedModulesService.pathName, this.routes["list"])]);
    }
}
ReturnFormComponent.ɵfac = function ReturnFormComponent_Factory(t) { return new (t || ReturnFormComponent)(i0.ɵɵdirectiveInject(SharedModulesService), i0.ɵɵdirectiveInject(i2.DefaultValuesService), i0.ɵɵdirectiveInject(i3.Router), i0.ɵɵdirectiveInject(i3.ActivatedRoute), i0.ɵɵdirectiveInject(SharedService)); };
ReturnFormComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ReturnFormComponent, selectors: [["fts-return-form"]], decls: 46, vars: 64, consts: [["color", "accent"], [1, "ft-module-icon"], ["type", "button", "mat-icon-button", ""], ["fontSet", "mdi", "fontIcon", "mdi-clipboard-arrow-left"], ["fxFlex", ""], ["type", "button", "mat-button", "", 1, "with-icon", 3, "matTooltip", "click"], ["fontSet", "mdi", "fontIcon", "mdi-format-list-bulleted"], ["fxFlex", "", "fxLayout", "column", 1, "ft-content"], [3, "ngBusy"], ["novalidate", "", "fxLayout", "column", "fxFlex", ""], ["Form", "ngForm"], ["fxLayout", "row", 1, "ft-padding"], ["fxFlex", "60", "fxLayout", "column"], ["fxLayout", "row", "fxLayoutGap", "6px"], ["fxFlex", "24"], ["matInput", "", "type", "text", "required", "", "name", "sequence", 3, "ftSequenceInput", "ftSequenceToggle", "placeholder", "ngModel", "disabled", "ngModelChange"], ["matSuffix", "", 3, "objectId", "config", "objectIdChange"], ["toggle", ""], ["matInput", "", "ftDate", "", "name", "date", 3, "ftAutoFocus", "placeholder", "disabled", "ngModel", "matDatepicker", "ngModelChange"], ["matSuffix", "", 3, "for"], ["picker", ""], ["fxFlex", "", 3, "disabled", "label", "model", "value", "settings", "dialog", "modelChange"], ["matInput", "", "name", "reason", 3, "placeholder", "ngModel", "ngModelChange"], [3, "vertical"], ["fxFlex", "nogrow", "fxLayout", "column"], ["fxFlex", "", 3, "required", "disabled", "model", "listDialog", "config", "label", "defaultValues", "modelChange"], ["floatLabel", "always", 1, "ft-radio-field"], ["matInput", "", 2, "display", "none", 3, "placeholder"], ["name", "price_mode", "ftDefaultValues", "default_price_mode", 3, "ngModel", "disabled", "ngModelChange"], [3, "value", 4, "ngFor", "ngForOf"], ["fxLayout", "column", "fxFlex", ""], ["fxFlex", "", 3, "model", "resource", "movementType", "displayedCols", "modelChange"], ["fxFlex", "nogrow", 3, "model", "cls", "resource", "formInvalid", "busy", "routes", "loadedObject", "movementType", "modelChange", "busyChange"], [3, "value"]], template: function ReturnFormComponent_Template(rf, ctx) {
        if (rf & 1) {
            i0.ɵɵelementStart(0, "mat-toolbar", 0)(1, "div", 1)(2, "button", 2);
            i0.ɵɵelement(3, "mat-icon", 3);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(4, "h2")(5, "span");
            i0.ɵɵtext(6);
            i0.ɵɵpipe(7, "translate");
            i0.ɵɵelementEnd()();
            i0.ɵɵelement(8, "span", 4);
            i0.ɵɵelementStart(9, "button", 5);
            i0.ɵɵlistener("click", function ReturnFormComponent_Template_button_click_9_listener() { return ctx.goBack(); });
            i0.ɵɵpipe(10, "translate");
            i0.ɵɵelement(11, "mat-icon", 6);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(12, "div", 7);
            i0.ɵɵelement(13, "div", 8);
            i0.ɵɵelementStart(14, "form", 9, 10)(16, "div", 11)(17, "div", 12)(18, "div", 13)(19, "mat-form-field", 14)(20, "input", 15);
            i0.ɵɵlistener("ngModelChange", function ReturnFormComponent_Template_input_ngModelChange_20_listener($event) { return ctx.model.number = $event; });
            i0.ɵɵpipe(21, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(22, "ft-sequence-toggle", 16, 17);
            i0.ɵɵlistener("objectIdChange", function ReturnFormComponent_Template_ft_sequence_toggle_objectIdChange_22_listener($event) { return ctx.loadedObject = $event; });
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(24, "mat-form-field", 14)(25, "input", 18);
            i0.ɵɵlistener("ngModelChange", function ReturnFormComponent_Template_input_ngModelChange_25_listener($event) { return ctx.model.date = $event; });
            i0.ɵɵpipe(26, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(27, "mat-datepicker-toggle", 19)(28, "mat-datepicker", null, 20);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(30, "fts-document-select", 21);
            i0.ɵɵlistener("modelChange", function ReturnFormComponent_Template_fts_document_select_modelChange_30_listener($event) { return ctx.model.provider = $event; });
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(31, "div", 13)(32, "mat-form-field", 4)(33, "input", 22);
            i0.ɵɵlistener("ngModelChange", function ReturnFormComponent_Template_input_ngModelChange_33_listener($event) { return ctx.model.reason = $event; });
            i0.ɵɵpipe(34, "translate");
            i0.ɵɵelementEnd()()()();
            i0.ɵɵelement(35, "mat-divider", 23);
            i0.ɵɵelementStart(36, "div", 24)(37, "fts-list-select", 25);
            i0.ɵɵlistener("modelChange", function ReturnFormComponent_Template_fts_list_select_modelChange_37_listener($event) { return ctx.model.store = $event; });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(38, "mat-form-field", 26);
            i0.ɵɵelement(39, "input", 27);
            i0.ɵɵpipe(40, "translate");
            i0.ɵɵelementStart(41, "mat-radio-group", 28);
            i0.ɵɵlistener("ngModelChange", function ReturnFormComponent_Template_mat_radio_group_ngModelChange_41_listener($event) { return ctx.model.price_mode = $event; });
            i0.ɵɵtemplate(42, ReturnFormComponent_mat_radio_button_42_Template, 3, 4, "mat-radio-button", 29);
            i0.ɵɵelementEnd()()()();
            i0.ɵɵelementStart(43, "div", 30)(44, "fts-document-details", 31);
            i0.ɵɵlistener("modelChange", function ReturnFormComponent_Template_fts_document_details_modelChange_44_listener($event) { return ctx.model = $event; });
            i0.ɵɵelementEnd()()()();
            i0.ɵɵelementStart(45, "fts-document-actions", 32);
            i0.ɵɵlistener("modelChange", function ReturnFormComponent_Template_fts_document_actions_modelChange_45_listener($event) { return ctx.model = $event; })("busyChange", function ReturnFormComponent_Template_fts_document_actions_busyChange_45_listener($event) { return ctx.loading = $event; });
            i0.ɵɵelementEnd();
        }
        if (rf & 2) {
            const _r0 = i0.ɵɵreference(15);
            const _r1 = i0.ɵɵreference(23);
            const _r2 = i0.ɵɵreference(29);
            i0.ɵɵadvance(6);
            i0.ɵɵtextInterpolate2("", i0.ɵɵpipeBind1(7, 49, "store.return_form"), " N\u00B0:", ctx.model.number, "");
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("matTooltip", i0.ɵɵpipeBind1(10, 51, "purchase.return_list"));
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngBusy", ctx.loading);
            i0.ɵɵadvance(7);
            i0.ɵɵproperty("ftSequenceInput", "ft_stock.purchase.ReturnForm")("ftSequenceToggle", _r1)("placeholder", i0.ɵɵpipeBind1(21, 53, "purchase.return_form_number"))("ngModel", ctx.model.number)("disabled", ctx.model == null ? null : ctx.model.state == null ? null : ctx.model.state.is_valid);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("objectId", ctx.loadedObject)("config", i0.ɵɵpureFunction0(61, _c0$d));
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ftAutoFocus", true)("placeholder", i0.ɵɵpipeBind1(26, 55, "store.date"))("disabled", ctx.model == null ? null : ctx.model.state == null ? null : ctx.model.state.is_valid)("ngModel", ctx.model.date)("matDatepicker", _r2);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("for", _r2);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("disabled", ctx.model == null ? null : ctx.model.state == null ? null : ctx.model.state.is_valid)("label", "store.default_provider")("model", ctx.model.provider)("value", "name")("settings", ctx.providerInputSettings)("dialog", ctx.providerDialog);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(34, 57, "purchase.reason"))("ngModel", ctx.model.reason);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("vertical", true);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("required", true)("disabled", ctx.model == null ? null : ctx.model.state == null ? null : ctx.model.state.is_valid)("model", ctx.model.store)("listDialog", ctx.depotDialog)("config", i0.ɵɵpureFunction0(62, _c1$a))("label", "store.depot")("defaultValues", "default_store");
            i0.ɵɵadvance(2);
            i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(40, 59, "shared.price_mode"));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngModel", ctx.model.price_mode)("disabled", ctx.model == null ? null : ctx.model.state == null ? null : ctx.model.state.is_valid);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngForOf", ctx.price_mode);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("model", ctx.model)("resource", ctx.resource)("movementType", "ReturnForm")("displayedCols", i0.ɵɵpureFunction0(63, _c2$6));
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("model", ctx.model)("cls", ctx.apiUrl)("resource", ctx.resource)("formInvalid", _r0.invalid || !(ctx.model == null ? null : ctx.model.store))("busy", ctx.loading)("routes", ctx.routes)("loadedObject", ctx.loadedObject)("movementType", "ReturnForm");
        }
    }, dependencies: [i4$1.NgForOf, i6.MatButton, i7.MatDatepicker, i7.MatDatepickerInput, i7.MatDatepickerToggle, i9.MatIcon, i10.MatFormField, i10.MatSuffix, i11$1.MatInput, i12$1.MatDivider, i13.MatRadioGroup, i13.MatRadioButton, i11.MatToolbar, i15$1.MatTooltip, i8.DefaultLayoutDirective, i8.DefaultLayoutGapDirective, i8.DefaultFlexDirective, i16.ɵNgNoValidate, i16.DefaultValueAccessor, i16.NgControlStatus, i16.NgControlStatusGroup, i16.RequiredValidator, i16.NgModel, i16.NgForm, i12.NgBusyDirective, i2.SequenceToggleComponent, i2.DateDirective, i2.InputDirective, i2.AutoFocusDirective, i2.SequenceInputDirective, i2.DefaultValuesDirective, DocumentSelectComponent, ListSelectComponent, DocumentActionsComponent, DocumentDetailsComponent, i3$1.TranslatePipe], styles: ["[_nghost-%COMP%]{height:100%;display:flex;flex-direction:column}"] });
(function () {
    (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ReturnFormComponent, [{
            type: Component,
            args: [{ selector: 'fts-return-form', template: "<mat-toolbar color=\"accent\">\n  <div class=\"ft-module-icon\">\n    <button type=\"button\" mat-icon-button>\n      <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-clipboard-arrow-left\"></mat-icon>\n    </button>\n  </div>\n  <h2>\n    <span>{{'store.return_form'| translate}} N\u00B0:{{model.number}}</span>\n  </h2>\n  <span fxFlex></span>\n  <button type=\"button\" mat-button class=\"with-icon\"  (click)=\"goBack()\" [matTooltip]=\"'purchase.return_list'|translate\">\n    <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-format-list-bulleted\"></mat-icon>\n  </button>\n</mat-toolbar>\n\n<div fxFlex fxLayout=\"column\" class=\"ft-content\">\n   <div [ngBusy]=\"loading\"></div>\n\n  <form novalidate #Form=\"ngForm\" fxLayout=\"column\" fxFlex  >\n      <div class=\"ft-padding\" fxLayout=\"row\"  >\n        <div fxFlex=\"60\" fxLayout=\"column\">\n            <div fxLayout=\"row\" fxLayoutGap=\"6px\">\n              <mat-form-field fxFlex=\"24\">\n                <input matInput type=\"text\" required\n                       [ftSequenceInput]=\"'ft_stock.purchase.ReturnForm'\"\n                       [ftSequenceToggle]=\"toggle\"\n                       name=\"sequence\"\n                       [placeholder]=\"'purchase.return_form_number'|translate\"\n                       [(ngModel)]=\"model.number\"\n\n                       [disabled]=\"model?.state?.is_valid\"/>\n                <ft-sequence-toggle matSuffix #toggle  [(objectId)]=\"loadedObject\"\n                                    [config]=\"{cls: 'ft_stock.purchase.ReturnForm', field: 'number'}\">\n                </ft-sequence-toggle>\n              </mat-form-field>\n              <mat-form-field fxFlex=\"24\">\n                <input matInput ftDate [ftAutoFocus]=\"true\"  [placeholder]=\"'store.date'|translate\" name=\"date\" [disabled]=\"model?.state?.is_valid\"\n                       [(ngModel)]=\"model.date\" [matDatepicker]=\"picker\">\n                <mat-datepicker-toggle matSuffix [for]=\"picker\"></mat-datepicker-toggle>\n                <mat-datepicker #picker></mat-datepicker>\n              </mat-form-field>\n\n              <fts-document-select fxFlex\n                                   [disabled]=\"model?.state?.is_valid\"\n                                   [label]=\"'store.default_provider'\"\n                                   [(model)]=\"model.provider\"\n                                   [value]=\"'name'\"\n                                   [settings]=\"providerInputSettings\"\n                                   [dialog]=\"providerDialog\">\n              </fts-document-select>\n\n           </div>\n            <div fxLayout=\"row\"  fxLayoutGap=\"6px\">\n              <mat-form-field fxFlex >\n                <input matInput [placeholder]=\"'purchase.reason'|translate\"\n                       name=\"reason\"  [(ngModel)]=\"model.reason\" >\n              </mat-form-field>\n            </div>\n        </div>\n        <mat-divider [vertical]=\"true\"></mat-divider>\n        <div fxFlex=\"nogrow\" fxLayout=\"column\">\n\n\n              <fts-list-select fxFlex\n                               [required]=\"true\"\n                               [disabled]=\"model?.state?.is_valid\"\n                               [(model)]=\"model.store\"\n                               [listDialog]=\"depotDialog\"\n                               [config]=\"{key: 'name', url: 'api/store/depot', cls:'store/depot', customValidator:'depot.check_uniqueness'}\"\n                               [label]=\"'store.depot'\"  [defaultValues]=\"'default_store'\"\n                                >\n              </fts-list-select>\n              <mat-form-field floatLabel=\"always\" class=\"ft-radio-field\" >\n                <input matInput placeholder=\"{{'shared.price_mode'|translate}}\" style=\"display: none\">\n                <mat-radio-group [(ngModel)]=\"model.price_mode\" name=\"price_mode\" [disabled]=\"model?.state?.is_valid\"  ftDefaultValues=\"default_price_mode\">\n                  <mat-radio-button *ngFor=\"let type_price of price_mode\" [value]=\"type_price\">\n                    {{'shared.'+type_price|translate}}\n                  </mat-radio-button>\n                </mat-radio-group>\n              </mat-form-field>\n        </div>\n      </div>\n      <div fxLayout=\"column\" fxFlex>\n        <fts-document-details  fxFlex [(model)]=\"model\"\n                               [resource]=\"resource\"   [movementType]=\"'ReturnForm'\"\n                              [displayedCols]=\"['deposition_number','receipt_number', 'code','description','qte','price','vat','store','sub_total']\">\n\n        </fts-document-details>\n      </div>\n  </form>\n\n</div>\n<fts-document-actions fxFlex=\"nogrow\" [(model)]=\"model\" [cls]=\"apiUrl\" [resource]=\"resource\"\n                      [formInvalid]=\"Form.invalid || !model?.store\"  [(busy)]=\"loading\"\n                      [routes]=\"routes\" [loadedObject]=\"loadedObject\" [movementType]=\"'ReturnForm'\"></fts-document-actions>\n", styles: [":host{height:100%;display:flex;flex-direction:column}\n"] }]
        }], function () { return [{ type: SharedModulesService }, { type: i2.DefaultValuesService }, { type: i3.Router }, { type: i3.ActivatedRoute }, { type: SharedService }]; }, null);
})();

function DeliveryComponent_mat_radio_button_43_Template(rf, ctx) {
    if (rf & 1) {
        i0.ɵɵelementStart(0, "mat-radio-button", 34);
        i0.ɵɵtext(1);
        i0.ɵɵpipe(2, "translate");
        i0.ɵɵelementEnd();
    }
    if (rf & 2) {
        const type_price_r4 = ctx.$implicit;
        i0.ɵɵproperty("value", type_price_r4);
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 2, "shared." + type_price_r4), " ");
    }
}
const _c0$c = function () { return { cls: "ft_stock.sales.DeliveryForm", field: "number" }; };
const _c1$9 = function () { return { key: "name", url: "api/store/depot", cls: "store/depot", customValidator: "depot.check_uniqueness" }; };
const _c2$5 = function () { return ["code", "description", "qte", "price", "vat", "store", "sub_total"]; };
class DeliveryComponent {
    constructor(sharedService, router, route, location, purposeService, translateService, sharedModulesService, defaultValuesService) {
        this.sharedService = sharedService;
        this.router = router;
        this.route = route;
        this.location = location;
        this.purposeService = purposeService;
        this.translateService = translateService;
        this.sharedModulesService = sharedModulesService;
        this.defaultValuesService = defaultValuesService;
        this.patientInputSettings = assignIn(cloneDeep(PATIENT_VIEW), { selectable: false });
        this.patientDialog = PatientDialogComponent;
        this.organizationInputSettings = assignIn(cloneDeep(ORGANIZATION_VIEW), { selectable: false });
        this.organizationDialog = OrganizationDialogComponent;
        this.depotDialog = DepotDialogComponent;
        this.loadedObject = null;
        this.price_mode = ['HT', 'TTC'];
        this.model = { date: moment(), price_mode: this.defaultValuesService.getValue('default_price_mode') || 'HT' };
        this.apiUrl = 'sale/delivery-form';
        this.resource = 'delivery-form';
        this.routes = { list: '/sale/delivery', form: '/sale/delivery/delivery-form' };
    }
    ngOnInit() {
        this.route.params.subscribe((data) => {
            let id = get(data, 'id');
            if (id)
                this.sharedService.getDocument(this.apiUrl, id).subscribe(data => {
                    this.model = data;
                });
        });
    }
    goBack() {
        this.router.navigate([handleRoute(this.sharedModulesService.pathName, this.routes["list"])]);
    }
}
DeliveryComponent.ɵfac = function DeliveryComponent_Factory(t) { return new (t || DeliveryComponent)(i0.ɵɵdirectiveInject(SharedService), i0.ɵɵdirectiveInject(i3.Router), i0.ɵɵdirectiveInject(i3.ActivatedRoute), i0.ɵɵdirectiveInject(i4$1.Location), i0.ɵɵdirectiveInject(i2.GeneralPurposeService), i0.ɵɵdirectiveInject(i3$1.TranslateService), i0.ɵɵdirectiveInject(SharedModulesService), i0.ɵɵdirectiveInject(i2.DefaultValuesService)); };
DeliveryComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DeliveryComponent, selectors: [["fts-delivery"]], decls: 47, vars: 71, consts: [["color", "accent"], [1, "ft-module-icon"], ["type", "button", "mat-icon-button", ""], ["fontSet", "mdi", "fontIcon", "mdi-file-upload"], ["fxFlex", ""], ["type", "button", "mat-button", "", 1, "with-icon", 3, "matTooltip", "click"], ["fontSet", "mdi", "fontIcon", "mdi-format-list-bulleted"], ["fxFlex", "", "fxLayout", "column", 1, "ft-content"], [3, "ngBusy"], ["novalidate", "", "fxLayout", "column", "fxFlex", ""], ["Form", "ngForm"], ["fxLayout", "row", 1, "ft-padding"], ["fxFlex", "60", "fxLayout", "column"], ["fxLayout", "row", "fxLayoutGap", "6px"], ["fxFlex", "25"], ["matInput", "", "type", "text", "required", "", "name", "sequence", 3, "ftSequenceInput", "ftSequenceToggle", "placeholder", "ngModel", "disabled", "ngModelChange"], ["matSuffix", "", 3, "objectId", "config", "objectIdChange"], ["toggle", ""], ["fxFlex", "24"], ["matInput", "", "ftDate", "", "name", "date", 3, "ftAutoFocus", "placeholder", "disabled", "ngModel", "matDatepicker", "ngModelChange"], ["matSuffix", "", 3, "for"], ["picker", ""], ["matInput", "", "name", "delivery_man", 3, "placeholder", "ngModel", "readonly", "ngModelChange"], ["fxFlex", "", 3, "disabled", "label", "model", "value", "settings", "dialog", "modelChange"], [3, "vertical"], ["fxFlex", "nogrow", "fxLayout", "column"], ["fxFlex", "", 3, "required", "disabled", "model", "listDialog", "config", "label", "defaultValues", "modelChange"], ["floatLabel", "always", 1, "ft-radio-field"], ["matInput", "", 2, "display", "none", 3, "placeholder"], ["name", "price_mode", "ftDefaultValues", "default_price_mode", 3, "ngModel", "disabled", "ngModelChange"], [3, "value", 4, "ngFor", "ngForOf"], ["fxLayout", "column", "fxFlex", ""], ["fxFlex", "", 3, "model", "resource", "movementType", "displayedCols", "modelChange"], ["fxFlex", "nogrow", 3, "model", "cls", "resource", "formInvalid", "busy", "routes", "loadedObject", "movementType", "modelChange", "busyChange"], [3, "value"]], template: function DeliveryComponent_Template(rf, ctx) {
        if (rf & 1) {
            i0.ɵɵelementStart(0, "mat-toolbar", 0)(1, "div", 1)(2, "button", 2);
            i0.ɵɵelement(3, "mat-icon", 3);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(4, "h2")(5, "span");
            i0.ɵɵtext(6);
            i0.ɵɵpipe(7, "translate");
            i0.ɵɵelementEnd()();
            i0.ɵɵelement(8, "span", 4);
            i0.ɵɵelementStart(9, "button", 5);
            i0.ɵɵlistener("click", function DeliveryComponent_Template_button_click_9_listener() { return ctx.goBack(); });
            i0.ɵɵpipe(10, "translate");
            i0.ɵɵelement(11, "mat-icon", 6);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(12, "div", 7);
            i0.ɵɵelement(13, "div", 8);
            i0.ɵɵelementStart(14, "form", 9, 10)(16, "div", 11)(17, "div", 12)(18, "div", 13)(19, "mat-form-field", 14)(20, "input", 15);
            i0.ɵɵlistener("ngModelChange", function DeliveryComponent_Template_input_ngModelChange_20_listener($event) { return ctx.model.number = $event; });
            i0.ɵɵpipe(21, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(22, "ft-sequence-toggle", 16, 17);
            i0.ɵɵlistener("objectIdChange", function DeliveryComponent_Template_ft_sequence_toggle_objectIdChange_22_listener($event) { return ctx.loadedObject = $event; });
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(24, "mat-form-field", 18)(25, "input", 19);
            i0.ɵɵlistener("ngModelChange", function DeliveryComponent_Template_input_ngModelChange_25_listener($event) { return ctx.model.date = $event; });
            i0.ɵɵpipe(26, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(27, "mat-datepicker-toggle", 20)(28, "mat-datepicker", null, 21);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(30, "mat-form-field", 4)(31, "input", 22);
            i0.ɵɵlistener("ngModelChange", function DeliveryComponent_Template_input_ngModelChange_31_listener($event) { return ctx.model.delivery_man = $event; });
            i0.ɵɵpipe(32, "translate");
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(33, "div", 13)(34, "fts-document-select", 23);
            i0.ɵɵlistener("modelChange", function DeliveryComponent_Template_fts_document_select_modelChange_34_listener($event) { return ctx.model.patient = $event; });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(35, "fts-document-select", 23);
            i0.ɵɵlistener("modelChange", function DeliveryComponent_Template_fts_document_select_modelChange_35_listener($event) { return ctx.model.organization = $event; });
            i0.ɵɵelementEnd()()();
            i0.ɵɵelement(36, "mat-divider", 24);
            i0.ɵɵelementStart(37, "div", 25)(38, "fts-list-select", 26);
            i0.ɵɵlistener("modelChange", function DeliveryComponent_Template_fts_list_select_modelChange_38_listener($event) { return ctx.model.store = $event; });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(39, "mat-form-field", 27);
            i0.ɵɵelement(40, "input", 28);
            i0.ɵɵpipe(41, "translate");
            i0.ɵɵelementStart(42, "mat-radio-group", 29);
            i0.ɵɵlistener("ngModelChange", function DeliveryComponent_Template_mat_radio_group_ngModelChange_42_listener($event) { return ctx.model.price_mode = $event; });
            i0.ɵɵtemplate(43, DeliveryComponent_mat_radio_button_43_Template, 3, 4, "mat-radio-button", 30);
            i0.ɵɵelementEnd()()()();
            i0.ɵɵelementStart(44, "div", 31)(45, "fts-document-details", 32);
            i0.ɵɵlistener("modelChange", function DeliveryComponent_Template_fts_document_details_modelChange_45_listener($event) { return ctx.model = $event; });
            i0.ɵɵelementEnd()()()();
            i0.ɵɵelementStart(46, "fts-document-actions", 33);
            i0.ɵɵlistener("modelChange", function DeliveryComponent_Template_fts_document_actions_modelChange_46_listener($event) { return ctx.model = $event; })("busyChange", function DeliveryComponent_Template_fts_document_actions_busyChange_46_listener($event) { return ctx.loading = $event; });
            i0.ɵɵelementEnd();
        }
        if (rf & 2) {
            const _r0 = i0.ɵɵreference(15);
            const _r1 = i0.ɵɵreference(23);
            const _r2 = i0.ɵɵreference(29);
            i0.ɵɵadvance(6);
            i0.ɵɵtextInterpolate2("", i0.ɵɵpipeBind1(7, 56, "sale.delivery"), " N\u00B0:", ctx.model.number, "");
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("matTooltip", i0.ɵɵpipeBind1(10, 58, "sale.delivery_list"));
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngBusy", ctx.loading);
            i0.ɵɵadvance(7);
            i0.ɵɵproperty("ftSequenceInput", "ft_stock.sales.DeliveryForm")("ftSequenceToggle", _r1)("placeholder", i0.ɵɵpipeBind1(21, 60, "sale.delivery_number"))("ngModel", ctx.model.number)("disabled", ctx.model == null ? null : ctx.model.state == null ? null : ctx.model.state.is_valid);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("objectId", ctx.loadedObject)("config", i0.ɵɵpureFunction0(68, _c0$c));
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ftAutoFocus", true)("placeholder", i0.ɵɵpipeBind1(26, 62, "store.date"))("disabled", ctx.model == null ? null : ctx.model.state == null ? null : ctx.model.state.is_valid)("ngModel", ctx.model.date)("matDatepicker", _r2);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("for", _r2);
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(32, 64, "sale.delivery_man"))("ngModel", ctx.model.delivery_man)("readonly", ctx.model == null ? null : ctx.model.state == null ? null : ctx.model.state.is_valid);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("disabled", ctx.model == null ? null : ctx.model.state == null ? null : ctx.model.state.is_valid)("label", "store.patient")("model", ctx.model.patient)("value", "full_name")("settings", ctx.patientInputSettings)("dialog", ctx.patientDialog);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("disabled", ctx.model == null ? null : ctx.model.state == null ? null : ctx.model.state.is_valid)("label", "store.organization")("model", ctx.model.organization)("value", "name")("settings", ctx.organizationInputSettings)("dialog", ctx.organizationDialog);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("vertical", true);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("required", true)("disabled", ctx.model == null ? null : ctx.model.state == null ? null : ctx.model.state.is_valid)("model", ctx.model.store)("listDialog", ctx.depotDialog)("config", i0.ɵɵpureFunction0(69, _c1$9))("label", "store.depot")("defaultValues", "default_store");
            i0.ɵɵadvance(2);
            i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(41, 66, "shared.price_mode"));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngModel", ctx.model.price_mode)("disabled", ctx.model == null ? null : ctx.model.state == null ? null : ctx.model.state.is_valid);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngForOf", ctx.price_mode);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("model", ctx.model)("resource", ctx.resource)("movementType", "OUT")("displayedCols", i0.ɵɵpureFunction0(70, _c2$5));
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("model", ctx.model)("cls", ctx.apiUrl)("resource", ctx.resource)("formInvalid", _r0.invalid || !(ctx.model == null ? null : ctx.model.store))("busy", ctx.loading)("routes", ctx.routes)("loadedObject", ctx.loadedObject)("movementType", "OUT");
        }
    }, dependencies: [i4$1.NgForOf, i6.MatButton, i7.MatDatepicker, i7.MatDatepickerInput, i7.MatDatepickerToggle, i9.MatIcon, i10.MatFormField, i10.MatSuffix, i11$1.MatInput, i12$1.MatDivider, i13.MatRadioGroup, i13.MatRadioButton, i11.MatToolbar, i15$1.MatTooltip, i8.DefaultLayoutDirective, i8.DefaultLayoutGapDirective, i8.DefaultFlexDirective, i16.ɵNgNoValidate, i16.DefaultValueAccessor, i16.NgControlStatus, i16.NgControlStatusGroup, i16.RequiredValidator, i16.NgModel, i16.NgForm, i12.NgBusyDirective, i2.SequenceToggleComponent, i2.DateDirective, i2.InputDirective, i2.AutoFocusDirective, i2.SequenceInputDirective, i2.DefaultValuesDirective, DocumentSelectComponent, ListSelectComponent, DocumentActionsComponent, DocumentDetailsComponent, i3$1.TranslatePipe], styles: ["[_nghost-%COMP%]{height:100%;display:flex;flex-direction:column}"] });
(function () {
    (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DeliveryComponent, [{
            type: Component,
            args: [{ selector: 'fts-delivery', template: "<mat-toolbar color=\"accent\">\n  <div class=\"ft-module-icon\">\n    <button type=\"button\" mat-icon-button>\n      <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-file-upload\"></mat-icon>\n    </button>\n  </div>\n  <h2>\n    <span>{{'sale.delivery'| translate}} N\u00B0:{{model.number}}</span>\n  </h2>\n  <span fxFlex></span>\n  <button type=\"button\" mat-button class=\"with-icon\"  (click)=\"goBack()\" [matTooltip]=\"'sale.delivery_list'|translate\">\n    <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-format-list-bulleted\"></mat-icon>\n  </button>\n</mat-toolbar>\n<div fxFlex fxLayout=\"column\" class=\"ft-content\">\n   <div [ngBusy]=\"loading\"></div>\n\n  <form novalidate #Form=\"ngForm\" fxLayout=\"column\" fxFlex  >\n      <div class=\"ft-padding\" fxLayout=\"row\"  >\n        <div fxFlex=\"60\" fxLayout=\"column\">\n            <div fxLayout=\"row\" fxLayoutGap=\"6px\">\n              <mat-form-field fxFlex=\"25\">\n                <input matInput type=\"text\" required\n                       [ftSequenceInput]=\"'ft_stock.sales.DeliveryForm'\"\n                       [ftSequenceToggle]=\"toggle\"\n                       name=\"sequence\"\n                       [placeholder]=\"'sale.delivery_number'|translate\"\n                       [(ngModel)]=\"model.number\"\n                       [disabled]=\"model?.state?.is_valid\"/>\n                <ft-sequence-toggle matSuffix #toggle  [(objectId)]=\"loadedObject\"\n                                    [config]=\"{cls: 'ft_stock.sales.DeliveryForm', field: 'number'}\">\n                </ft-sequence-toggle>\n              </mat-form-field>\n              <mat-form-field fxFlex=\"24\">\n                <input matInput [ftAutoFocus]=\"true\" ftDate [placeholder]=\"'store.date'|translate\" name=\"date\" [disabled]=\"model?.state?.is_valid\"\n                       [(ngModel)]=\"model.date\" [matDatepicker]=\"picker\">\n                <mat-datepicker-toggle matSuffix [for]=\"picker\"></mat-datepicker-toggle>\n                <mat-datepicker #picker></mat-datepicker>\n              </mat-form-field>\n              <mat-form-field fxFlex>\n                <input matInput   [placeholder]=\"'sale.delivery_man'|translate\" name=\"delivery_man\"\n                       [(ngModel)]=\"model.delivery_man\" [readonly]=\"model?.state?.is_valid\">\n              </mat-form-field>\n           </div>\n            <div fxLayout=\"row\"  fxLayoutGap=\"6px\">\n\n              <fts-document-select fxFlex\n                     [disabled]=\"model?.state?.is_valid\"\n                     [label]=\"'store.patient'\"\n                     [(model)]=\"model.patient\"\n                     [value]=\"'full_name'\"\n                     [settings]=\"patientInputSettings\"\n                     [dialog]=\"patientDialog\">\n              </fts-document-select>\n              <fts-document-select fxFlex\n                     [disabled]=\"model?.state?.is_valid\"\n                     [label]=\"'store.organization'\"\n                     [(model)]=\"model.organization\"\n                     [value]=\"'name'\"\n                     [settings]=\"organizationInputSettings\"\n                     [dialog]=\"organizationDialog\">\n              </fts-document-select>\n            </div>\n        </div>\n        <mat-divider [vertical]=\"true\"></mat-divider>\n        <div fxFlex=\"nogrow\" fxLayout=\"column\">\n\n              <fts-list-select fxFlex\n                               [required]=\"true\"\n                               [disabled]=\"model?.state?.is_valid\"\n                               [(model)]=\"model.store\"\n                               [listDialog]=\"depotDialog\"\n                               [config]=\"{key: 'name', url: 'api/store/depot', cls:'store/depot', customValidator:'depot.check_uniqueness'}\"\n                               [label]=\"'store.depot'\"  [defaultValues]=\"'default_store'\"\n                                >\n              </fts-list-select>\n              <mat-form-field floatLabel=\"always\" class=\"ft-radio-field\" >\n                <input matInput placeholder=\"{{'shared.price_mode'|translate}}\" style=\"display: none\">\n                <mat-radio-group [(ngModel)]=\"model.price_mode\" name=\"price_mode\" [disabled]=\"model?.state?.is_valid\"  ftDefaultValues=\"default_price_mode\">\n                  <mat-radio-button *ngFor=\"let type_price of price_mode\" [value]=\"type_price\">\n                    {{'shared.'+type_price|translate}}\n                  </mat-radio-button>\n                </mat-radio-group>\n              </mat-form-field>\n        </div>\n      </div>\n      <div fxLayout=\"column\" fxFlex>\n        <fts-document-details  fxFlex [(model)]=\"model\"\n                               [resource]=\"resource\"   [movementType]=\"'OUT'\"\n                 [displayedCols]=\"[ 'code','description','qte','price','vat','store','sub_total']\">\n\n          </fts-document-details>\n      </div>\n  </form>\n\n</div>\n<fts-document-actions fxFlex=\"nogrow\" [(model)]=\"model\" [cls]=\"apiUrl\" [resource]=\"resource\"\n                      [formInvalid]=\"Form.invalid || !model?.store\"  [(busy)]=\"loading\"\n                      [routes]=\"routes\" [loadedObject]=\"loadedObject\" [movementType]=\"'OUT'\"></fts-document-actions>\n", styles: [":host{height:100%;display:flex;flex-direction:column}\n"] }]
        }], function () { return [{ type: SharedService }, { type: i3.Router }, { type: i3.ActivatedRoute }, { type: i4$1.Location }, { type: i2.GeneralPurposeService }, { type: i3$1.TranslateService }, { type: SharedModulesService }, { type: i2.DefaultValuesService }]; }, null);
})();

function ConsignmentComponent_mat_radio_button_52_Template(rf, ctx) {
    if (rf & 1) {
        i0.ɵɵelementStart(0, "mat-radio-button", 36);
        i0.ɵɵtext(1);
        i0.ɵɵpipe(2, "translate");
        i0.ɵɵelementEnd();
    }
    if (rf & 2) {
        const type_price_r6 = ctx.$implicit;
        i0.ɵɵproperty("value", type_price_r6);
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 2, "shared." + type_price_r6), " ");
    }
}
const _c0$b = function () { return { cls: "ft_stock.sales.Consignment", field: "number" }; };
const _c1$8 = function () { return { key: "name", url: "api/store/depot", cls: "store/depot", customValidator: "depot.check_uniqueness" }; };
const _c2$4 = function () { return ["code", "description", "qte", "price", "vat", "store", "sub_total"]; };
class ConsignmentComponent {
    constructor(sharedService, defaultValuesService, router, route, location, purposeService, translateService, sharedModulesService) {
        this.sharedService = sharedService;
        this.defaultValuesService = defaultValuesService;
        this.router = router;
        this.route = route;
        this.location = location;
        this.purposeService = purposeService;
        this.translateService = translateService;
        this.sharedModulesService = sharedModulesService;
        this.organizationInputSettings = assignIn(cloneDeep(ORGANIZATION_VIEW), { selectable: false });
        this.organizationDialog = OrganizationDialogComponent;
        this.patientInputSettings = assignIn(cloneDeep(PATIENT_VIEW), { selectable: false });
        this.patientDialog = PatientDialogComponent;
        this.depotDialog = DepotDialogComponent;
        this.loadedObject = null;
        this.price_mode = ['HT', 'TTC'];
        this.model = { date: moment(), price_mode: this.defaultValuesService.getValue('default_price_mode') || 'HT', start_date: moment(), return_date: moment() };
        this.apiUrl = 'sale/consignment';
        this.resource = 'consignment';
        this.routes = { list: '/sale/consignment', form: '/sale/consignment/consignment-form' };
    }
    ngOnInit() {
        this.route.params.subscribe((data) => {
            let id = get(data, 'id');
            if (id)
                this.sharedService.getDocument(this.apiUrl, id).subscribe(data => {
                    this.model = data;
                });
        });
    }
    goBack() {
        this.router.navigate([handleRoute(this.sharedModulesService.pathName, this.routes["list"])]);
    }
}
ConsignmentComponent.ɵfac = function ConsignmentComponent_Factory(t) { return new (t || ConsignmentComponent)(i0.ɵɵdirectiveInject(SharedService), i0.ɵɵdirectiveInject(i2.DefaultValuesService), i0.ɵɵdirectiveInject(i3.Router), i0.ɵɵdirectiveInject(i3.ActivatedRoute), i0.ɵɵdirectiveInject(i4$1.Location), i0.ɵɵdirectiveInject(i2.GeneralPurposeService), i0.ɵɵdirectiveInject(i3$1.TranslateService), i0.ɵɵdirectiveInject(SharedModulesService)); };
ConsignmentComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ConsignmentComponent, selectors: [["fts-consignment"]], decls: 56, vars: 82, consts: [["color", "accent"], [1, "ft-module-icon"], ["type", "button", "mat-icon-button", ""], ["fontSet", "mdi", "fontIcon", "mdi-file-export"], ["fxFlex", ""], ["type", "button", "mat-button", "", 1, "with-icon", 3, "matTooltip", "click"], ["fontSet", "mdi", "fontIcon", "mdi-format-list-bulleted"], ["fxFlex", "", "fxLayout", "column", 1, "ft-content"], [3, "ngBusy"], ["novalidate", "", "fxLayout", "column", "fxFlex", ""], ["Form", "ngForm"], ["fxLayout", "row", 1, "ft-padding"], ["fxFlex", "60", "fxLayout", "column"], ["fxLayout", "row", "fxLayoutGap", "6px"], ["fxFlex", "24"], ["matInput", "", "type", "text", "required", "", "name", "sequence", 3, "ftSequenceInput", "ftSequenceToggle", "placeholder", "ngModel", "disabled", "ngModelChange"], ["matSuffix", "", 3, "objectId", "config", "objectIdChange"], ["toggle", ""], ["matInput", "", "ftDate", "", "name", "date", 3, "ftAutoFocus", "placeholder", "disabled", "ngModel", "matDatepicker", "ngModelChange"], ["matSuffix", "", 3, "for"], ["picker", ""], ["matInput", "", "ftDate", "", "name", "start_date", "required", "", 3, "placeholder", "max", "disabled", "ngModel", "matDatepicker", "ngModelChange"], ["picker3", ""], ["matInput", "", "ftDate", "", "name", "dead_line", "required", "", 3, "placeholder", "min", "disabled", "ngModel", "matDatepicker", "ngModelChange"], ["picker2", ""], ["fxFlex", "", 3, "disabled", "label", "model", "value", "settings", "dialog", "modelChange"], [3, "vertical"], ["fxFlex", "nogrow", "fxLayout", "column"], ["fxFlex", "", 3, "required", "disabled", "model", "listDialog", "config", "label", "defaultValues", "modelChange"], ["floatLabel", "always", 1, "ft-radio-field"], ["matInput", "", 2, "display", "none", 3, "placeholder"], ["name", "price_mode", "ftDefaultValues", "default_price_mode", 3, "ngModel", "disabled", "ngModelChange"], [3, "value", 4, "ngFor", "ngForOf"], ["fxLayout", "column", "fxFlex", ""], ["fxFlex", "", 3, "model", "resource", "movementType", "displayedCols", "modelChange"], ["fxFlex", "nogrow", 3, "model", "cls", "resource", "formInvalid", "busy", "routes", "loadedObject", "movementType", "modelChange", "busyChange"], [3, "value"]], template: function ConsignmentComponent_Template(rf, ctx) {
        if (rf & 1) {
            i0.ɵɵelementStart(0, "mat-toolbar", 0)(1, "div", 1)(2, "button", 2);
            i0.ɵɵelement(3, "mat-icon", 3);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(4, "h2")(5, "span");
            i0.ɵɵtext(6);
            i0.ɵɵpipe(7, "translate");
            i0.ɵɵelementEnd()();
            i0.ɵɵelement(8, "span", 4);
            i0.ɵɵelementStart(9, "button", 5);
            i0.ɵɵlistener("click", function ConsignmentComponent_Template_button_click_9_listener() { return ctx.goBack(); });
            i0.ɵɵpipe(10, "translate");
            i0.ɵɵelement(11, "mat-icon", 6);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(12, "div", 7);
            i0.ɵɵelement(13, "div", 8);
            i0.ɵɵelementStart(14, "form", 9, 10)(16, "div", 11)(17, "div", 12)(18, "div", 13)(19, "mat-form-field", 14)(20, "input", 15);
            i0.ɵɵlistener("ngModelChange", function ConsignmentComponent_Template_input_ngModelChange_20_listener($event) { return ctx.model.number = $event; });
            i0.ɵɵpipe(21, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(22, "ft-sequence-toggle", 16, 17);
            i0.ɵɵlistener("objectIdChange", function ConsignmentComponent_Template_ft_sequence_toggle_objectIdChange_22_listener($event) { return ctx.loadedObject = $event; });
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(24, "mat-form-field", 14)(25, "input", 18);
            i0.ɵɵlistener("ngModelChange", function ConsignmentComponent_Template_input_ngModelChange_25_listener($event) { return ctx.model.date = $event; });
            i0.ɵɵpipe(26, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(27, "mat-datepicker-toggle", 19)(28, "mat-datepicker", null, 20);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(30, "mat-form-field", 14)(31, "input", 21);
            i0.ɵɵlistener("ngModelChange", function ConsignmentComponent_Template_input_ngModelChange_31_listener($event) { return ctx.model.start_date = $event; });
            i0.ɵɵpipe(32, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(33, "mat-datepicker-toggle", 19)(34, "mat-datepicker", null, 22);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(36, "mat-form-field", 14)(37, "input", 23);
            i0.ɵɵlistener("ngModelChange", function ConsignmentComponent_Template_input_ngModelChange_37_listener($event) { return ctx.model.return_date = $event; });
            i0.ɵɵpipe(38, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(39, "mat-datepicker-toggle", 19)(40, "mat-datepicker", null, 24);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(42, "div", 13)(43, "fts-document-select", 25);
            i0.ɵɵlistener("modelChange", function ConsignmentComponent_Template_fts_document_select_modelChange_43_listener($event) { return ctx.model.patient = $event; });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(44, "fts-document-select", 25);
            i0.ɵɵlistener("modelChange", function ConsignmentComponent_Template_fts_document_select_modelChange_44_listener($event) { return ctx.model.organization = $event; });
            i0.ɵɵelementEnd()()();
            i0.ɵɵelement(45, "mat-divider", 26);
            i0.ɵɵelementStart(46, "div", 27)(47, "fts-list-select", 28);
            i0.ɵɵlistener("modelChange", function ConsignmentComponent_Template_fts_list_select_modelChange_47_listener($event) { return ctx.model.store = $event; });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(48, "mat-form-field", 29);
            i0.ɵɵelement(49, "input", 30);
            i0.ɵɵpipe(50, "translate");
            i0.ɵɵelementStart(51, "mat-radio-group", 31);
            i0.ɵɵlistener("ngModelChange", function ConsignmentComponent_Template_mat_radio_group_ngModelChange_51_listener($event) { return ctx.model.price_mode = $event; });
            i0.ɵɵtemplate(52, ConsignmentComponent_mat_radio_button_52_Template, 3, 4, "mat-radio-button", 32);
            i0.ɵɵelementEnd()()()();
            i0.ɵɵelementStart(53, "div", 33)(54, "fts-document-details", 34);
            i0.ɵɵlistener("modelChange", function ConsignmentComponent_Template_fts_document_details_modelChange_54_listener($event) { return ctx.model = $event; });
            i0.ɵɵelementEnd()()()();
            i0.ɵɵelementStart(55, "fts-document-actions", 35);
            i0.ɵɵlistener("modelChange", function ConsignmentComponent_Template_fts_document_actions_modelChange_55_listener($event) { return ctx.model = $event; })("busyChange", function ConsignmentComponent_Template_fts_document_actions_busyChange_55_listener($event) { return ctx.loading = $event; });
            i0.ɵɵelementEnd();
        }
        if (rf & 2) {
            const _r0 = i0.ɵɵreference(15);
            const _r1 = i0.ɵɵreference(23);
            const _r2 = i0.ɵɵreference(29);
            const _r3 = i0.ɵɵreference(35);
            const _r4 = i0.ɵɵreference(41);
            i0.ɵɵadvance(6);
            i0.ɵɵtextInterpolate2("", i0.ɵɵpipeBind1(7, 65, "sale.consignment_form"), " N\u00B0:", ctx.model.number, "");
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("matTooltip", i0.ɵɵpipeBind1(10, 67, "store.consignment"));
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngBusy", ctx.loading);
            i0.ɵɵadvance(7);
            i0.ɵɵproperty("ftSequenceInput", "ft_stock.sales.Consignment")("ftSequenceToggle", _r1)("placeholder", i0.ɵɵpipeBind1(21, 69, "sale.consignment_number"))("ngModel", ctx.model.number)("disabled", ctx.model == null ? null : ctx.model.state == null ? null : ctx.model.state.is_valid);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("objectId", ctx.loadedObject)("config", i0.ɵɵpureFunction0(79, _c0$b));
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ftAutoFocus", true)("placeholder", i0.ɵɵpipeBind1(26, 71, "store.date"))("disabled", ctx.model == null ? null : ctx.model.state == null ? null : ctx.model.state.is_valid)("ngModel", ctx.model.date)("matDatepicker", _r2);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("for", _r2);
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(32, 73, "purchase.start_date"))("max", ctx.model.return_date)("disabled", ctx.model == null ? null : ctx.model.state == null ? null : ctx.model.state.is_valid)("ngModel", ctx.model.start_date)("matDatepicker", _r3);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("for", _r3);
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(38, 75, "purchase.dead_line_date"))("min", ctx.model.start_date)("disabled", ctx.model == null ? null : ctx.model.state == null ? null : ctx.model.state.is_valid)("ngModel", ctx.model.return_date)("matDatepicker", _r4);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("for", _r4);
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("disabled", ctx.model == null ? null : ctx.model.state == null ? null : ctx.model.state.is_valid)("label", "store.patient")("model", ctx.model.patient)("value", "full_name")("settings", ctx.patientInputSettings)("dialog", ctx.patientDialog);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("disabled", ctx.model == null ? null : ctx.model.state == null ? null : ctx.model.state.is_valid)("label", "store.organization")("model", ctx.model.organization)("value", "name")("settings", ctx.organizationInputSettings)("dialog", ctx.organizationDialog);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("vertical", true);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("required", true)("disabled", ctx.model == null ? null : ctx.model.state == null ? null : ctx.model.state.is_valid)("model", ctx.model.store)("listDialog", ctx.depotDialog)("config", i0.ɵɵpureFunction0(80, _c1$8))("label", "store.depot")("defaultValues", "default_store");
            i0.ɵɵadvance(2);
            i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(50, 77, "shared.price_mode"));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngModel", ctx.model.price_mode)("disabled", ctx.model == null ? null : ctx.model.state == null ? null : ctx.model.state.is_valid);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngForOf", ctx.price_mode);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("model", ctx.model)("resource", ctx.resource)("movementType", "Consignment")("displayedCols", i0.ɵɵpureFunction0(81, _c2$4));
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("model", ctx.model)("cls", ctx.apiUrl)("resource", ctx.resource)("formInvalid", _r0.invalid || !(ctx.model == null ? null : ctx.model.store))("busy", ctx.loading)("routes", ctx.routes)("loadedObject", ctx.loadedObject)("movementType", "Consignment");
        }
    }, dependencies: [i4$1.NgForOf, i6.MatButton, i7.MatDatepicker, i7.MatDatepickerInput, i7.MatDatepickerToggle, i9.MatIcon, i10.MatFormField, i10.MatSuffix, i11$1.MatInput, i12$1.MatDivider, i13.MatRadioGroup, i13.MatRadioButton, i11.MatToolbar, i15$1.MatTooltip, i8.DefaultLayoutDirective, i8.DefaultLayoutGapDirective, i8.DefaultFlexDirective, i16.ɵNgNoValidate, i16.DefaultValueAccessor, i16.NgControlStatus, i16.NgControlStatusGroup, i16.RequiredValidator, i16.NgModel, i16.NgForm, i12.NgBusyDirective, i2.SequenceToggleComponent, i2.DateDirective, i2.InputDirective, i2.AutoFocusDirective, i2.SequenceInputDirective, i2.DefaultValuesDirective, DocumentSelectComponent, ListSelectComponent, DocumentActionsComponent, DocumentDetailsComponent, i3$1.TranslatePipe], styles: ["[_nghost-%COMP%]{height:100%;display:flex;flex-direction:column}"] });
(function () {
    (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ConsignmentComponent, [{
            type: Component,
            args: [{ selector: 'fts-consignment', template: "<mat-toolbar color=\"accent\">\n  <div class=\"ft-module-icon\">\n    <button type=\"button\" mat-icon-button>\n      <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-file-export\"></mat-icon>\n    </button>\n  </div>\n  <h2>\n    <span>{{'sale.consignment_form'| translate}} N\u00B0:{{model.number}}</span>\n  </h2>\n  <span fxFlex></span>\n  <button type=\"button\" mat-button class=\"with-icon\"  (click)=\"goBack()\" [matTooltip]=\"'store.consignment'|translate\">\n    <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-format-list-bulleted\"></mat-icon>\n  </button>\n</mat-toolbar>\n\n<div fxFlex fxLayout=\"column\" class=\"ft-content\">\n   <div [ngBusy]=\"loading\"></div>\n \n  <form novalidate #Form=\"ngForm\" fxLayout=\"column\" fxFlex  >\n      <div class=\"ft-padding\" fxLayout=\"row\"  >\n        <div fxFlex=\"60\" fxLayout=\"column\">\n            <div fxLayout=\"row\" fxLayoutGap=\"6px\">\n              <mat-form-field fxFlex=\"24\">\n                <input matInput type=\"text\" required\n                       [ftSequenceInput]=\"'ft_stock.sales.Consignment'\"\n                       [ftSequenceToggle]=\"toggle\"\n                       name=\"sequence\"\n                       [placeholder]=\"'sale.consignment_number'|translate\"\n                       [(ngModel)]=\"model.number\"\n\n                       [disabled]=\"model?.state?.is_valid\"/>\n                <ft-sequence-toggle matSuffix #toggle  [(objectId)]=\"loadedObject\"\n                                    [config]=\"{cls: 'ft_stock.sales.Consignment', field: 'number'}\">\n                </ft-sequence-toggle>\n              </mat-form-field>\n              <mat-form-field fxFlex=\"24\">\n                <input matInput  [ftAutoFocus]=\"true\" ftDate [placeholder]=\"'store.date'|translate\" name=\"date\" [disabled]=\"model?.state?.is_valid\"\n                       [(ngModel)]=\"model.date\" [matDatepicker]=\"picker\">\n                <mat-datepicker-toggle matSuffix [for]=\"picker\"></mat-datepicker-toggle>\n                <mat-datepicker #picker></mat-datepicker>\n              </mat-form-field>\n              <mat-form-field fxFlex=\"24\">\n                <input matInput ftDate [placeholder]=\"'purchase.start_date'|translate\" name=\"start_date\"  [max]=\"model.return_date\"\n                       required\n                       [disabled]=\"model?.state?.is_valid\"\n                       [(ngModel)]=\"model.start_date\" [matDatepicker]=\"picker3\">\n                <mat-datepicker-toggle matSuffix [for]=\"picker3\"></mat-datepicker-toggle>\n                <mat-datepicker #picker3></mat-datepicker>\n              </mat-form-field>\n              <mat-form-field fxFlex=\"24\">\n                <input matInput ftDate [placeholder]=\"'purchase.dead_line_date'|translate\" name=\"dead_line\" [min]=\"model.start_date\"\n                       required\n                       [disabled]=\"model?.state?.is_valid\"\n                       [(ngModel)]=\"model.return_date\" [matDatepicker]=\"picker2\">\n                <mat-datepicker-toggle matSuffix [for]=\"picker2\"></mat-datepicker-toggle>\n                <mat-datepicker #picker2></mat-datepicker>\n              </mat-form-field>\n           </div>\n            <div fxLayout=\"row\"  fxLayoutGap=\"6px\">\n\n              <fts-document-select fxFlex\n                     [disabled]=\"model?.state?.is_valid\"\n                     [label]=\"'store.patient'\"\n                     [(model)]=\"model.patient\"\n                     [value]=\"'full_name'\"\n                     [settings]=\"patientInputSettings\"\n                     [dialog]=\"patientDialog\">\n              </fts-document-select>\n              <fts-document-select fxFlex\n                     [disabled]=\"model?.state?.is_valid\"\n                     [label]=\"'store.organization'\"\n                     [(model)]=\"model.organization\"\n                     [value]=\"'name'\"\n                     [settings]=\"organizationInputSettings\"\n                     [dialog]=\"organizationDialog\">\n              </fts-document-select>\n            </div>\n        </div>\n        <mat-divider [vertical]=\"true\"></mat-divider>\n        <div fxFlex=\"nogrow\" fxLayout=\"column\">\n\n              <fts-list-select fxFlex\n                               [required]=\"true\"\n                               [disabled]=\"model?.state?.is_valid\"\n                               [(model)]=\"model.store\"\n                               [listDialog]=\"depotDialog\"\n                               [config]=\"{key: 'name', url: 'api/store/depot', cls:'store/depot', customValidator:'depot.check_uniqueness'}\"\n                               [label]=\"'store.depot'\"  [defaultValues]=\"'default_store'\"\n                                >\n              </fts-list-select>\n              <mat-form-field floatLabel=\"always\" class=\"ft-radio-field\" >\n                <input matInput placeholder=\"{{'shared.price_mode'|translate}}\" style=\"display: none\">\n                <mat-radio-group [(ngModel)]=\"model.price_mode\" name=\"price_mode\" [disabled]=\"model?.state?.is_valid\"  ftDefaultValues=\"default_price_mode\">\n                  <mat-radio-button *ngFor=\"let type_price of price_mode\" [value]=\"type_price\">\n                    {{'shared.'+type_price|translate}}\n                  </mat-radio-button>\n                </mat-radio-group>\n              </mat-form-field>\n        </div>\n      </div>\n      <div fxLayout=\"column\" fxFlex>\n        <fts-document-details  fxFlex [(model)]=\"model\"\n                               [resource]=\"resource\"   [movementType]=\"'Consignment'\"\n                         [displayedCols]=\"['code','description','qte','price','vat','store','sub_total']\">\n</fts-document-details>\n      </div>\n  </form>\n</div>\n<fts-document-actions fxFlex=\"nogrow\" [(model)]=\"model\" [cls]=\"apiUrl\" [resource]=\"resource\"\n                      [formInvalid]=\"Form.invalid || !model?.store\"  [(busy)]=\"loading\"\n                      [routes]=\"routes\" [loadedObject]=\"loadedObject\" [movementType]=\"'Consignment'\"></fts-document-actions>\n", styles: [":host{height:100%;display:flex;flex-direction:column}\n"] }]
        }], function () { return [{ type: SharedService }, { type: i2.DefaultValuesService }, { type: i3.Router }, { type: i3.ActivatedRoute }, { type: i4$1.Location }, { type: i2.GeneralPurposeService }, { type: i3$1.TranslateService }, { type: SharedModulesService }]; }, null);
})();

function ConsignmentReturnComponent_mat_radio_button_40_Template(rf, ctx) {
    if (rf & 1) {
        i0.ɵɵelementStart(0, "mat-radio-button", 33);
        i0.ɵɵtext(1);
        i0.ɵɵpipe(2, "translate");
        i0.ɵɵelementEnd();
    }
    if (rf & 2) {
        const type_price_r4 = ctx.$implicit;
        i0.ɵɵproperty("value", type_price_r4);
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 2, "shared." + type_price_r4), " ");
    }
}
const _c0$a = function () { return { cls: "ft_stock.sales.ConsignmentReturn", field: "number" }; };
const _c1$7 = function () { return { key: "name", url: "api/store/depot", cls: "store/depot", customValidator: "depot.check_uniqueness" }; };
const _c2$3 = function () { return ["consignment_number", "code", "description", "qte", "price", "vat", "store", "sub_total"]; };
class ConsignmentReturnComponent {
    constructor(sharedService, defaultValuesService, router, route, location, purposeService, translateService, sharedModulesService) {
        this.sharedService = sharedService;
        this.defaultValuesService = defaultValuesService;
        this.router = router;
        this.route = route;
        this.location = location;
        this.purposeService = purposeService;
        this.translateService = translateService;
        this.sharedModulesService = sharedModulesService;
        this.patientInputSettings = assignIn(cloneDeep(PATIENT_VIEW), { selectable: false });
        this.patientDialog = PatientDialogComponent;
        this.organizationInputSettings = assignIn(cloneDeep(ORGANIZATION_VIEW), { selectable: false });
        this.organizationDialog = OrganizationDialogComponent;
        this.depotDialog = DepotDialogComponent;
        this.loadedObject = null;
        this.price_mode = ['HT', 'TTC'];
        this.model = { date: moment(), price_mode: this.defaultValuesService.getValue('default_price_mode') || 'HT' };
        this.apiUrl = 'sale/consignment-return';
        this.resource = 'consignment-return';
        this.routes = { list: '/sale/consignment-return', form: '/sale/consignment-return/consignment-return-form' };
    }
    ngOnInit() {
        this.route.params.subscribe((data) => {
            let id = get(data, 'id');
            if (id)
                this.sharedService.getDocument(this.apiUrl, id).subscribe(data => {
                    this.model = data;
                });
        });
    }
    goBack() {
        this.router.navigate([handleRoute(this.sharedModulesService.pathName, this.routes["list"])]);
    }
}
ConsignmentReturnComponent.ɵfac = function ConsignmentReturnComponent_Factory(t) { return new (t || ConsignmentReturnComponent)(i0.ɵɵdirectiveInject(SharedService), i0.ɵɵdirectiveInject(i2.DefaultValuesService), i0.ɵɵdirectiveInject(i3.Router), i0.ɵɵdirectiveInject(i3.ActivatedRoute), i0.ɵɵdirectiveInject(i4$1.Location), i0.ɵɵdirectiveInject(i2.GeneralPurposeService), i0.ɵɵdirectiveInject(i3$1.TranslateService), i0.ɵɵdirectiveInject(SharedModulesService)); };
ConsignmentReturnComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ConsignmentReturnComponent, selectors: [["fts-consignment-return"]], decls: 44, vars: 66, consts: [["color", "accent"], [1, "ft-module-icon"], ["type", "button", "mat-icon-button", ""], ["fontSet", "mdi", "fontIcon", "mdi-file-import"], ["fxFlex", ""], ["type", "button", "mat-button", "", 1, "with-icon", 3, "matTooltip", "click"], ["fontSet", "mdi", "fontIcon", "mdi-format-list-bulleted"], ["fxFlex", "", "fxLayout", "column", 1, "ft-content"], [3, "ngBusy"], ["novalidate", "", "fxLayout", "column", "fxFlex", ""], ["Form", "ngForm"], ["fxLayout", "row", 1, "ft-padding"], ["fxFlex", "60", "fxLayout", "column"], ["fxLayout", "row", "fxLayoutGap", "6px"], ["fxFlex", "24"], ["matInput", "", "type", "text", "required", "", "name", "sequence", 3, "ftSequenceInput", "ftSequenceToggle", "placeholder", "ngModel", "disabled", "ngModelChange"], ["matSuffix", "", 3, "objectId", "config", "objectIdChange"], ["toggle", ""], ["fxFlex", "25"], ["matInput", "", "ftDate", "", "name", "date", 3, "ftAutoFocus", "placeholder", "disabled", "ngModel", "matDatepicker", "ngModelChange"], ["matSuffix", "", 3, "for"], ["picker", ""], ["fxFlex", "", 3, "disabled", "label", "model", "value", "settings", "dialog", "modelChange"], [3, "vertical"], ["fxFlex", "nogrow", "fxLayout", "column"], ["fxFlex", "", 3, "required", "disabled", "model", "listDialog", "config", "label", "defaultValues", "modelChange"], ["floatLabel", "always", 1, "ft-radio-field"], ["matInput", "", 2, "display", "none", 3, "placeholder"], ["name", "price_mode", "ftDefaultValues", "default_price_mode", 3, "ngModel", "disabled", "ngModelChange"], [3, "value", 4, "ngFor", "ngForOf"], ["fxLayout", "column", "fxFlex", ""], ["fxFlex", "", 3, "model", "resource", "movementType", "displayedCols", "modelChange"], ["fxFlex", "nogrow", 3, "model", "cls", "resource", "formInvalid", "busy", "routes", "loadedObject", "movementType", "modelChange", "busyChange"], [3, "value"]], template: function ConsignmentReturnComponent_Template(rf, ctx) {
        if (rf & 1) {
            i0.ɵɵelementStart(0, "mat-toolbar", 0)(1, "div", 1)(2, "button", 2);
            i0.ɵɵelement(3, "mat-icon", 3);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(4, "h2")(5, "span");
            i0.ɵɵtext(6);
            i0.ɵɵpipe(7, "translate");
            i0.ɵɵelementEnd()();
            i0.ɵɵelement(8, "span", 4);
            i0.ɵɵelementStart(9, "button", 5);
            i0.ɵɵlistener("click", function ConsignmentReturnComponent_Template_button_click_9_listener() { return ctx.goBack(); });
            i0.ɵɵpipe(10, "translate");
            i0.ɵɵelement(11, "mat-icon", 6);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(12, "div", 7);
            i0.ɵɵelement(13, "div", 8);
            i0.ɵɵelementStart(14, "form", 9, 10)(16, "div", 11)(17, "div", 12)(18, "div", 13)(19, "mat-form-field", 14)(20, "input", 15);
            i0.ɵɵlistener("ngModelChange", function ConsignmentReturnComponent_Template_input_ngModelChange_20_listener($event) { return ctx.model.number = $event; });
            i0.ɵɵpipe(21, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(22, "ft-sequence-toggle", 16, 17);
            i0.ɵɵlistener("objectIdChange", function ConsignmentReturnComponent_Template_ft_sequence_toggle_objectIdChange_22_listener($event) { return ctx.loadedObject = $event; });
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(24, "mat-form-field", 18)(25, "input", 19);
            i0.ɵɵlistener("ngModelChange", function ConsignmentReturnComponent_Template_input_ngModelChange_25_listener($event) { return ctx.model.date = $event; });
            i0.ɵɵpipe(26, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(27, "mat-datepicker-toggle", 20)(28, "mat-datepicker", null, 21);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(30, "div", 13)(31, "fts-document-select", 22);
            i0.ɵɵlistener("modelChange", function ConsignmentReturnComponent_Template_fts_document_select_modelChange_31_listener($event) { return ctx.model.patient = $event; });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(32, "fts-document-select", 22);
            i0.ɵɵlistener("modelChange", function ConsignmentReturnComponent_Template_fts_document_select_modelChange_32_listener($event) { return ctx.model.organization = $event; });
            i0.ɵɵelementEnd()()();
            i0.ɵɵelement(33, "mat-divider", 23);
            i0.ɵɵelementStart(34, "div", 24)(35, "fts-list-select", 25);
            i0.ɵɵlistener("modelChange", function ConsignmentReturnComponent_Template_fts_list_select_modelChange_35_listener($event) { return ctx.model.store = $event; });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(36, "mat-form-field", 26);
            i0.ɵɵelement(37, "input", 27);
            i0.ɵɵpipe(38, "translate");
            i0.ɵɵelementStart(39, "mat-radio-group", 28);
            i0.ɵɵlistener("ngModelChange", function ConsignmentReturnComponent_Template_mat_radio_group_ngModelChange_39_listener($event) { return ctx.model.price_mode = $event; });
            i0.ɵɵtemplate(40, ConsignmentReturnComponent_mat_radio_button_40_Template, 3, 4, "mat-radio-button", 29);
            i0.ɵɵelementEnd()()()();
            i0.ɵɵelementStart(41, "div", 30)(42, "fts-document-details", 31);
            i0.ɵɵlistener("modelChange", function ConsignmentReturnComponent_Template_fts_document_details_modelChange_42_listener($event) { return ctx.model = $event; });
            i0.ɵɵelementEnd()()()();
            i0.ɵɵelementStart(43, "fts-document-actions", 32);
            i0.ɵɵlistener("modelChange", function ConsignmentReturnComponent_Template_fts_document_actions_modelChange_43_listener($event) { return ctx.model = $event; })("busyChange", function ConsignmentReturnComponent_Template_fts_document_actions_busyChange_43_listener($event) { return ctx.loading = $event; });
            i0.ɵɵelementEnd();
        }
        if (rf & 2) {
            const _r0 = i0.ɵɵreference(15);
            const _r1 = i0.ɵɵreference(23);
            const _r2 = i0.ɵɵreference(29);
            i0.ɵɵadvance(6);
            i0.ɵɵtextInterpolate2("", i0.ɵɵpipeBind1(7, 53, "sale.consignment_return"), " N\u00B0:", ctx.model.number, "");
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("matTooltip", i0.ɵɵpipeBind1(10, 55, "store.consignment"));
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngBusy", ctx.loading);
            i0.ɵɵadvance(7);
            i0.ɵɵproperty("ftSequenceInput", "ft_stock.sales.ConsignmentReturn")("ftSequenceToggle", _r1)("placeholder", i0.ɵɵpipeBind1(21, 57, "purchase.return_form_number"))("ngModel", ctx.model.number)("disabled", ctx.model == null ? null : ctx.model.state == null ? null : ctx.model.state.is_valid);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("objectId", ctx.loadedObject)("config", i0.ɵɵpureFunction0(63, _c0$a));
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ftAutoFocus", true)("placeholder", i0.ɵɵpipeBind1(26, 59, "store.date"))("disabled", ctx.model == null ? null : ctx.model.state == null ? null : ctx.model.state.is_valid)("ngModel", ctx.model.date)("matDatepicker", _r2);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("for", _r2);
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("disabled", ctx.model == null ? null : ctx.model.state == null ? null : ctx.model.state.is_valid)("label", "store.patient")("model", ctx.model.patient)("value", "full_name")("settings", ctx.patientInputSettings)("dialog", ctx.patientDialog);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("disabled", ctx.model == null ? null : ctx.model.state == null ? null : ctx.model.state.is_valid)("label", "store.organization")("model", ctx.model.organization)("value", "name")("settings", ctx.organizationInputSettings)("dialog", ctx.organizationDialog);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("vertical", true);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("required", true)("disabled", ctx.model == null ? null : ctx.model.state == null ? null : ctx.model.state.is_valid)("model", ctx.model.store)("listDialog", ctx.depotDialog)("config", i0.ɵɵpureFunction0(64, _c1$7))("label", "store.depot")("defaultValues", "default_store");
            i0.ɵɵadvance(2);
            i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(38, 61, "shared.price_mode"));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngModel", ctx.model.price_mode)("disabled", ctx.model == null ? null : ctx.model.state == null ? null : ctx.model.state.is_valid);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngForOf", ctx.price_mode);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("model", ctx.model)("resource", ctx.resource)("movementType", "ConsignmentReturn")("displayedCols", i0.ɵɵpureFunction0(65, _c2$3));
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("model", ctx.model)("cls", ctx.apiUrl)("resource", ctx.resource)("formInvalid", _r0.invalid || !(ctx.model == null ? null : ctx.model.store))("busy", ctx.loading)("routes", ctx.routes)("loadedObject", ctx.loadedObject)("movementType", "ConsignmentReturn");
        }
    }, dependencies: [i4$1.NgForOf, i6.MatButton, i7.MatDatepicker, i7.MatDatepickerInput, i7.MatDatepickerToggle, i9.MatIcon, i10.MatFormField, i10.MatSuffix, i11$1.MatInput, i12$1.MatDivider, i13.MatRadioGroup, i13.MatRadioButton, i11.MatToolbar, i15$1.MatTooltip, i8.DefaultLayoutDirective, i8.DefaultLayoutGapDirective, i8.DefaultFlexDirective, i16.ɵNgNoValidate, i16.DefaultValueAccessor, i16.NgControlStatus, i16.NgControlStatusGroup, i16.RequiredValidator, i16.NgModel, i16.NgForm, i12.NgBusyDirective, i2.SequenceToggleComponent, i2.DateDirective, i2.InputDirective, i2.AutoFocusDirective, i2.SequenceInputDirective, i2.DefaultValuesDirective, DocumentSelectComponent, ListSelectComponent, DocumentActionsComponent, DocumentDetailsComponent, i3$1.TranslatePipe], styles: ["[_nghost-%COMP%]{height:100%;display:flex;flex-direction:column}"] });
(function () {
    (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ConsignmentReturnComponent, [{
            type: Component,
            args: [{ selector: 'fts-consignment-return', template: "<mat-toolbar color=\"accent\">\n  <div class=\"ft-module-icon\">\n    <button type=\"button\" mat-icon-button>\n      <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-file-import\"></mat-icon>\n    </button>\n  </div>\n  <h2>\n    <span>{{'sale.consignment_return'| translate}} N\u00B0:{{model.number}}</span>\n  </h2>\n  <span fxFlex></span>\n  <button type=\"button\" mat-button class=\"with-icon\"  (click)=\"goBack()\" [matTooltip]=\"'store.consignment'|translate\">\n    <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-format-list-bulleted\"></mat-icon>\n  </button>\n</mat-toolbar>\n\n<div fxFlex fxLayout=\"column\" class=\"ft-content\">\n   <div [ngBusy]=\"loading\"></div>\n\n  <form novalidate #Form=\"ngForm\" fxLayout=\"column\" fxFlex  >\n      <div class=\"ft-padding\" fxLayout=\"row\"  >\n        <div fxFlex=\"60\" fxLayout=\"column\">\n            <div fxLayout=\"row\" fxLayoutGap=\"6px\">\n              <mat-form-field fxFlex=\"24\">\n                <input matInput type=\"text\" required\n                       [ftSequenceInput]=\"'ft_stock.sales.ConsignmentReturn'\"\n                       [ftSequenceToggle]=\"toggle\"\n                       name=\"sequence\"\n                       [placeholder]=\"'purchase.return_form_number'|translate\"\n                       [(ngModel)]=\"model.number\"\n\n                       [disabled]=\"model?.state?.is_valid\"/>\n                <ft-sequence-toggle matSuffix #toggle  [(objectId)]=\"loadedObject\"\n                                    [config]=\"{cls: 'ft_stock.sales.ConsignmentReturn', field: 'number'}\">\n                </ft-sequence-toggle>\n              </mat-form-field>\n              <mat-form-field fxFlex=\"25\">\n                <input matInput [ftAutoFocus]=\"true\" ftDate [placeholder]=\"'store.date'|translate\" name=\"date\" [disabled]=\"model?.state?.is_valid\"\n                       [(ngModel)]=\"model.date\" [matDatepicker]=\"picker\">\n                <mat-datepicker-toggle matSuffix [for]=\"picker\"></mat-datepicker-toggle>\n                <mat-datepicker #picker></mat-datepicker>\n              </mat-form-field>\n           </div>\n            <div fxLayout=\"row\"  fxLayoutGap=\"6px\">\n              <fts-document-select fxFlex\n                     [disabled]=\"model?.state?.is_valid\"\n                     [label]=\"'store.patient'\"\n                     [(model)]=\"model.patient\"\n                     [value]=\"'full_name'\"\n                     [settings]=\"patientInputSettings\"\n                     [dialog]=\"patientDialog\">\n              </fts-document-select>\n              <fts-document-select fxFlex\n                     [disabled]=\"model?.state?.is_valid\"\n                     [label]=\"'store.organization'\"\n                     [(model)]=\"model.organization\"\n                     [value]=\"'name'\"\n                     [settings]=\"organizationInputSettings\"\n                     [dialog]=\"organizationDialog\">\n              </fts-document-select>\n            </div>\n        </div>\n        <mat-divider [vertical]=\"true\"></mat-divider>\n        <div fxFlex=\"nogrow\" fxLayout=\"column\">\n\n              <fts-list-select fxFlex\n                               [required]=\"true\"\n                               [disabled]=\"model?.state?.is_valid\"\n                               [(model)]=\"model.store\"\n                               [listDialog]=\"depotDialog\"\n                               [config]=\"{key: 'name', url: 'api/store/depot', cls:'store/depot', customValidator:'depot.check_uniqueness'}\"\n                               [label]=\"'store.depot'\"  [defaultValues]=\"'default_store'\"\n                                >\n              </fts-list-select>\n              <mat-form-field floatLabel=\"always\" class=\"ft-radio-field\" >\n                <input matInput placeholder=\"{{'shared.price_mode'|translate}}\" style=\"display: none\">\n                <mat-radio-group [(ngModel)]=\"model.price_mode\" name=\"price_mode\" [disabled]=\"model?.state?.is_valid\"  ftDefaultValues=\"default_price_mode\">\n                  <mat-radio-button *ngFor=\"let type_price of price_mode\" [value]=\"type_price\">\n                    {{'shared.'+type_price|translate}}\n                  </mat-radio-button>\n                </mat-radio-group>\n              </mat-form-field>\n        </div>\n      </div>\n      <div fxLayout=\"column\" fxFlex>\n        <fts-document-details  fxFlex [(model)]=\"model\"\n                               [resource]=\"resource\"  [movementType]=\"'ConsignmentReturn'\"\n                         [displayedCols]=\"[  'consignment_number','code','description','qte','price','vat','store','sub_total']\">\n</fts-document-details>\n      </div>\n  </form>\n</div>\n<fts-document-actions fxFlex=\"nogrow\" [(model)]=\"model\" [cls]=\"apiUrl\" [resource]=\"resource\"\n                      [formInvalid]=\"Form.invalid || !model?.store\"  [(busy)]=\"loading\"\n                      [routes]=\"routes\" [loadedObject]=\"loadedObject\" [movementType]=\"'ConsignmentReturn'\"></fts-document-actions>\n", styles: [":host{height:100%;display:flex;flex-direction:column}\n"] }]
        }], function () { return [{ type: SharedService }, { type: i2.DefaultValuesService }, { type: i3.Router }, { type: i3.ActivatedRoute }, { type: i4$1.Location }, { type: i2.GeneralPurposeService }, { type: i3$1.TranslateService }, { type: SharedModulesService }]; }, null);
})();

function PurchaseReceiptComponent_mat_radio_button_42_Template(rf, ctx) {
    if (rf & 1) {
        i0.ɵɵelementStart(0, "mat-radio-button", 33);
        i0.ɵɵtext(1);
        i0.ɵɵpipe(2, "translate");
        i0.ɵɵelementEnd();
    }
    if (rf & 2) {
        const type_price_r4 = ctx.$implicit;
        i0.ɵɵproperty("value", type_price_r4);
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 2, "shared." + type_price_r4), " ");
    }
}
const _c0$9 = function () { return { cls: "ft_stock.purchase.PurchaseReceipt", field: "number" }; };
const _c1$6 = function () { return { key: "name", url: "api/store/depot", cls: "store/depot", customValidator: "depot.check_uniqueness" }; };
const _c2$2 = function () { return ["deposition_number", "order_number", "price_request_number", "code", "description", "qte", "price", "vat", "store", "sub_total"]; };
class PurchaseReceiptComponent {
    constructor(sharedModulesService, defaultValuesService, router, route, sharedService) {
        this.sharedModulesService = sharedModulesService;
        this.defaultValuesService = defaultValuesService;
        this.router = router;
        this.route = route;
        this.sharedService = sharedService;
        this.providerInputSettings = assignIn(cloneDeep(PROVIDER_VIEW), { selectable: false });
        this.providerDialog = ProviderDialogComponent;
        this.loadedObject = null;
        this.depotDialog = DepotDialogComponent;
        this.price_mode = ['HT', 'TTC'];
        this.model = { date: moment(), start_date: moment(), dead_line: moment(), price_mode: this.defaultValuesService.getValue('default_price_mode') || 'HT' };
        this.apiUrl = 'purchase/purchase-receipt';
        this.resource = 'purchase-receipt';
        this.routes = { list: '/purchase/purchase-receipt', form: '/purchase/purchase-receipt/purchase-receipt-form' };
    }
    ngOnInit() {
        this.route.params.subscribe((data) => {
            let id = get(data, 'id');
            if (id)
                this.sharedService.getDocument(this.apiUrl, id).subscribe(data => {
                    this.model = data;
                });
        });
    }
    goBack() {
        this.router.navigate([handleRoute(this.sharedModulesService.pathName, this.routes["list"])]);
    }
}
PurchaseReceiptComponent.ɵfac = function PurchaseReceiptComponent_Factory(t) { return new (t || PurchaseReceiptComponent)(i0.ɵɵdirectiveInject(SharedModulesService), i0.ɵɵdirectiveInject(i2.DefaultValuesService), i0.ɵɵdirectiveInject(i3.Router), i0.ɵɵdirectiveInject(i3.ActivatedRoute), i0.ɵɵdirectiveInject(SharedService)); };
PurchaseReceiptComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PurchaseReceiptComponent, selectors: [["fts-purchase-receipt"]], decls: 46, vars: 66, consts: [["color", "accent"], [1, "ft-module-icon"], ["type", "button", "mat-icon-button", ""], ["fontSet", "mdi", "fontIcon", "mdi-clipboard-arrow-down"], ["fxFlex", ""], ["type", "button", "mat-button", "", 1, "with-icon", 3, "matTooltip", "click"], ["fontSet", "mdi", "fontIcon", "mdi-format-list-bulleted"], ["fxFlex", "", "fxLayout", "column", 1, "ft-content"], [3, "ngBusy"], ["novalidate", "", "fxLayout", "column", "fxFlex", ""], ["Form", "ngForm"], ["fxLayout", "row", 1, "ft-padding"], ["fxFlex", "60", "fxLayout", "column"], ["fxLayout", "row", "fxLayoutGap", "6px"], ["fxFlex", "nogrow"], ["matInput", "", "type", "text", "required", "", "name", "sequence", 3, "ftSequenceInput", "ftSequenceToggle", "placeholder", "ngModel", "disabled", "ngModelChange"], ["matSuffix", "", 3, "objectId", "config", "objectIdChange"], ["toggle", ""], ["matInput", "", "ftDate", "", "name", "date", 3, "ftAutoFocus", "placeholder", "disabled", "ngModel", "matDatepicker", "ngModelChange"], ["matSuffix", "", 3, "for"], ["picker", ""], ["fxFlex", "", 3, "disabled", "label", "model", "value", "required", "settings", "dialog", "modelChange"], ["matInput", "", "name", "doc_number", 3, "placeholder", "ngModel", "readonly", "ngModelChange"], [3, "vertical"], ["fxFlex", "nogrow", "fxLayout", "column"], ["fxFlex", "", 3, "required", "disabled", "model", "listDialog", "config", "label", "defaultValues", "modelChange"], ["floatLabel", "always", 1, "ft-radio-field"], ["matInput", "", 2, "display", "none", 3, "placeholder"], ["name", "price_mode", "ftDefaultValues", "default_price_mode", 3, "ngModel", "disabled", "ngModelChange"], [3, "value", 4, "ngFor", "ngForOf"], ["fxLayout", "column", "fxFlex", ""], ["fxFlex", "", 3, "model", "resource", "movementType", "displayedCols", "modelChange"], ["fxFlex", "nogrow", 3, "model", "cls", "resource", "formInvalid", "busy", "routes", "loadedObject", "movementType", "modelChange", "busyChange"], [3, "value"]], template: function PurchaseReceiptComponent_Template(rf, ctx) {
        if (rf & 1) {
            i0.ɵɵelementStart(0, "mat-toolbar", 0)(1, "div", 1)(2, "button", 2);
            i0.ɵɵelement(3, "mat-icon", 3);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(4, "h2")(5, "span");
            i0.ɵɵtext(6);
            i0.ɵɵpipe(7, "translate");
            i0.ɵɵelementEnd()();
            i0.ɵɵelement(8, "span", 4);
            i0.ɵɵelementStart(9, "button", 5);
            i0.ɵɵlistener("click", function PurchaseReceiptComponent_Template_button_click_9_listener() { return ctx.goBack(); });
            i0.ɵɵpipe(10, "translate");
            i0.ɵɵelement(11, "mat-icon", 6);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(12, "div", 7);
            i0.ɵɵelement(13, "div", 8);
            i0.ɵɵelementStart(14, "form", 9, 10)(16, "div", 11)(17, "div", 12)(18, "div", 13)(19, "mat-form-field", 14)(20, "input", 15);
            i0.ɵɵlistener("ngModelChange", function PurchaseReceiptComponent_Template_input_ngModelChange_20_listener($event) { return ctx.model.number = $event; });
            i0.ɵɵpipe(21, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(22, "ft-sequence-toggle", 16, 17);
            i0.ɵɵlistener("objectIdChange", function PurchaseReceiptComponent_Template_ft_sequence_toggle_objectIdChange_22_listener($event) { return ctx.loadedObject = $event; });
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(24, "mat-form-field", 14)(25, "input", 18);
            i0.ɵɵlistener("ngModelChange", function PurchaseReceiptComponent_Template_input_ngModelChange_25_listener($event) { return ctx.model.date = $event; });
            i0.ɵɵpipe(26, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(27, "mat-datepicker-toggle", 19)(28, "mat-datepicker", null, 20);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(30, "div", 13)(31, "fts-document-select", 21);
            i0.ɵɵlistener("modelChange", function PurchaseReceiptComponent_Template_fts_document_select_modelChange_31_listener($event) { return ctx.model.provider = $event; });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(32, "mat-form-field", 4)(33, "input", 22);
            i0.ɵɵlistener("ngModelChange", function PurchaseReceiptComponent_Template_input_ngModelChange_33_listener($event) { return ctx.model.doc_number = $event; });
            i0.ɵɵpipe(34, "translate");
            i0.ɵɵelementEnd()()()();
            i0.ɵɵelement(35, "mat-divider", 23);
            i0.ɵɵelementStart(36, "div", 24)(37, "fts-list-select", 25);
            i0.ɵɵlistener("modelChange", function PurchaseReceiptComponent_Template_fts_list_select_modelChange_37_listener($event) { return ctx.model.store = $event; });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(38, "mat-form-field", 26);
            i0.ɵɵelement(39, "input", 27);
            i0.ɵɵpipe(40, "translate");
            i0.ɵɵelementStart(41, "mat-radio-group", 28);
            i0.ɵɵlistener("ngModelChange", function PurchaseReceiptComponent_Template_mat_radio_group_ngModelChange_41_listener($event) { return ctx.model.price_mode = $event; });
            i0.ɵɵtemplate(42, PurchaseReceiptComponent_mat_radio_button_42_Template, 3, 4, "mat-radio-button", 29);
            i0.ɵɵelementEnd()()()();
            i0.ɵɵelementStart(43, "div", 30)(44, "fts-document-details", 31);
            i0.ɵɵlistener("modelChange", function PurchaseReceiptComponent_Template_fts_document_details_modelChange_44_listener($event) { return ctx.model = $event; });
            i0.ɵɵelementEnd()()()();
            i0.ɵɵelementStart(45, "fts-document-actions", 32);
            i0.ɵɵlistener("modelChange", function PurchaseReceiptComponent_Template_fts_document_actions_modelChange_45_listener($event) { return ctx.model = $event; })("busyChange", function PurchaseReceiptComponent_Template_fts_document_actions_busyChange_45_listener($event) { return ctx.loading = $event; });
            i0.ɵɵelementEnd();
        }
        if (rf & 2) {
            const _r0 = i0.ɵɵreference(15);
            const _r1 = i0.ɵɵreference(23);
            const _r2 = i0.ɵɵreference(29);
            i0.ɵɵadvance(6);
            i0.ɵɵtextInterpolate2("", i0.ɵɵpipeBind1(7, 51, "purchase.purchase_receipt"), " N\u00B0:", ctx.model.number, "");
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("matTooltip", i0.ɵɵpipeBind1(10, 53, "purchase.purchase_receipt_list"));
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngBusy", ctx.loading);
            i0.ɵɵadvance(7);
            i0.ɵɵproperty("ftSequenceInput", "ft_stock.purchase.PurchaseReceipt")("ftSequenceToggle", _r1)("placeholder", i0.ɵɵpipeBind1(21, 55, "purchase.receipt_number"))("ngModel", ctx.model.number)("disabled", ctx.model == null ? null : ctx.model.state == null ? null : ctx.model.state.is_valid);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("objectId", ctx.loadedObject)("config", i0.ɵɵpureFunction0(63, _c0$9));
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ftAutoFocus", true)("placeholder", i0.ɵɵpipeBind1(26, 57, "store.date"))("disabled", ctx.model == null ? null : ctx.model.state == null ? null : ctx.model.state.is_valid)("ngModel", ctx.model.date)("matDatepicker", _r2);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("for", _r2);
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("disabled", ctx.model == null ? null : ctx.model.state == null ? null : ctx.model.state.is_valid)("label", "store.default_provider")("model", ctx.model.provider)("value", "name")("required", true)("settings", ctx.providerInputSettings)("dialog", ctx.providerDialog);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(34, 59, "shared.doc_number"))("ngModel", ctx.model.doc_number)("readonly", ctx.model == null ? null : ctx.model.state == null ? null : ctx.model.state.is_valid);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("vertical", true);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("required", true)("disabled", ctx.model == null ? null : ctx.model.state == null ? null : ctx.model.state.is_valid)("model", ctx.model.store)("listDialog", ctx.depotDialog)("config", i0.ɵɵpureFunction0(64, _c1$6))("label", "store.depot")("defaultValues", "default_store");
            i0.ɵɵadvance(2);
            i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(40, 61, "shared.price_mode"));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngModel", ctx.model.price_mode)("disabled", ctx.model == null ? null : ctx.model.state == null ? null : ctx.model.state.is_valid);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngForOf", ctx.price_mode);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("model", ctx.model)("resource", ctx.resource)("movementType", "PurchaseReceipt")("displayedCols", i0.ɵɵpureFunction0(65, _c2$2));
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("model", ctx.model)("cls", ctx.apiUrl)("resource", ctx.resource)("formInvalid", _r0.invalid || !(ctx.model == null ? null : ctx.model.store) || !ctx.model.provider)("busy", ctx.loading)("routes", ctx.routes)("loadedObject", ctx.loadedObject)("movementType", "PurchaseReceipt");
        }
    }, dependencies: [i4$1.NgForOf, i6.MatButton, i7.MatDatepicker, i7.MatDatepickerInput, i7.MatDatepickerToggle, i9.MatIcon, i10.MatFormField, i10.MatSuffix, i11$1.MatInput, i12$1.MatDivider, i13.MatRadioGroup, i13.MatRadioButton, i11.MatToolbar, i15$1.MatTooltip, i8.DefaultLayoutDirective, i8.DefaultLayoutGapDirective, i8.DefaultFlexDirective, i16.ɵNgNoValidate, i16.DefaultValueAccessor, i16.NgControlStatus, i16.NgControlStatusGroup, i16.RequiredValidator, i16.NgModel, i16.NgForm, i12.NgBusyDirective, i2.SequenceToggleComponent, i2.DateDirective, i2.InputDirective, i2.AutoFocusDirective, i2.SequenceInputDirective, i2.DefaultValuesDirective, DocumentSelectComponent, ListSelectComponent, DocumentActionsComponent, DocumentDetailsComponent, i3$1.TranslatePipe], styles: ["[_nghost-%COMP%]{height:100%;display:flex;flex-direction:column}"] });
(function () {
    (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PurchaseReceiptComponent, [{
            type: Component,
            args: [{ selector: 'fts-purchase-receipt', template: "<mat-toolbar color=\"accent\">\n  <div class=\"ft-module-icon\">\n    <button type=\"button\" mat-icon-button>\n      <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-clipboard-arrow-down\"></mat-icon>\n    </button>\n  </div>\n  <h2>\n    <span>{{'purchase.purchase_receipt'| translate}} N\u00B0:{{model.number}}</span>\n  </h2>\n\n  <span fxFlex></span>\n  <button type=\"button\" mat-button class=\"with-icon\"  (click)=\"goBack()\" [matTooltip]=\"'purchase.purchase_receipt_list'|translate\">\n    <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-format-list-bulleted\"></mat-icon>\n  </button>\n</mat-toolbar>\n\n<div fxFlex fxLayout=\"column\" class=\"ft-content\">\n   <div [ngBusy]=\"loading\"></div>\n\n  <form novalidate #Form=\"ngForm\" fxLayout=\"column\" fxFlex  >\n      <div class=\"ft-padding\" fxLayout=\"row\"  >\n        <div fxFlex=\"60\" fxLayout=\"column\">\n            <div fxLayout=\"row\" fxLayoutGap=\"6px\">\n              <mat-form-field fxFlex=\"nogrow\">\n                <input matInput type=\"text\" required\n                       [ftSequenceInput]=\"'ft_stock.purchase.PurchaseReceipt'\"\n                       [ftSequenceToggle]=\"toggle\"\n                       name=\"sequence\"\n                       [placeholder]=\"'purchase.receipt_number'|translate\"\n                       [(ngModel)]=\"model.number\"\n\n                       [disabled]=\"model?.state?.is_valid\"/>\n                <ft-sequence-toggle matSuffix #toggle  [(objectId)]=\"loadedObject\"\n                                    [config]=\"{cls: 'ft_stock.purchase.PurchaseReceipt', field: 'number'}\">\n                </ft-sequence-toggle>\n              </mat-form-field>\n              <mat-form-field fxFlex=\"nogrow\">\n                <input matInput  [ftAutoFocus]=\"true\"  ftDate [placeholder]=\"'store.date'|translate\" name=\"date\" [disabled]=\"model?.state?.is_valid\"\n                       [(ngModel)]=\"model.date\" [matDatepicker]=\"picker\">\n                <mat-datepicker-toggle matSuffix [for]=\"picker\"></mat-datepicker-toggle>\n                <mat-datepicker #picker></mat-datepicker>\n              </mat-form-field>\n           </div>\n            <div fxLayout=\"row\"  fxLayoutGap=\"6px\">\n              <fts-document-select fxFlex\n                                   [disabled]=\"model?.state?.is_valid\"\n                                   [label]=\"'store.default_provider'\"\n                                   [(model)]=\"model.provider\"\n                                   [value]=\"'name'\"\n                                   [required]=\"true\"\n                                   [settings]=\"providerInputSettings\"\n                                   [dialog]=\"providerDialog\">\n              </fts-document-select>\n\n              <mat-form-field fxFlex >\n                <input matInput [placeholder]=\"'shared.doc_number'|translate\" name=\"doc_number\"\n                       [(ngModel)]=\"model.doc_number\" [readonly]=\"model?.state?.is_valid\">\n              </mat-form-field>\n\n            </div>\n        </div>\n        <mat-divider [vertical]=\"true\"></mat-divider>\n        <div fxFlex=\"nogrow\" fxLayout=\"column\">\n              <fts-list-select fxFlex\n                               [required]=\"true\"\n                               [disabled]=\"model?.state?.is_valid\"\n                               [(model)]=\"model.store\"\n                               [listDialog]=\"depotDialog\"\n                               [config]=\"{key: 'name', url: 'api/store/depot', cls:'store/depot', customValidator:'depot.check_uniqueness'}\"\n                               [label]=\"'store.depot'\"  [defaultValues]=\"'default_store'\"\n                                >\n              </fts-list-select>\n              <mat-form-field floatLabel=\"always\" class=\"ft-radio-field\" >\n                <input matInput placeholder=\"{{'shared.price_mode'|translate}}\" style=\"display: none\">\n                <mat-radio-group [(ngModel)]=\"model.price_mode\" name=\"price_mode\" [disabled]=\"model?.state?.is_valid\"  ftDefaultValues=\"default_price_mode\">\n                  <mat-radio-button *ngFor=\"let type_price of price_mode\" [value]=\"type_price\">\n                    {{'shared.'+type_price|translate}}\n                  </mat-radio-button>\n                </mat-radio-group>\n              </mat-form-field>\n\n        </div>\n      </div>\n      <div fxLayout=\"column\" fxFlex>\n        <fts-document-details  fxFlex [(model)]=\"model\"\n                               [resource]=\"resource\"\n                                [movementType]=\"'PurchaseReceipt'\"\n                                [displayedCols]=\"['deposition_number','order_number','price_request_number','code','description','qte','price','vat','store','sub_total']\">\n        </fts-document-details>\n      </div>\n  </form>\n\n</div>\n<fts-document-actions fxFlex=\"nogrow\" [(model)]=\"model\" [cls]=\"apiUrl\" [resource]=\"resource\"\n                      [formInvalid]=\"Form.invalid || !model?.store || !model.provider\"  [(busy)]=\"loading\"\n                      [routes]=\"routes\" [loadedObject]=\"loadedObject\" [movementType]=\"'PurchaseReceipt'\"></fts-document-actions>\n", styles: [":host{height:100%;display:flex;flex-direction:column}\n"] }]
        }], function () { return [{ type: SharedModulesService }, { type: i2.DefaultValuesService }, { type: i3.Router }, { type: i3.ActivatedRoute }, { type: SharedService }]; }, null);
})();

class InventoryService {
    constructor(http, ws) {
        this.http = http;
        this.ws = ws;
    }
    getAvailableLots(depot, article, mvtType, sourceDoc) {
        return this.ws.call("lot-number.get_available_lots", { depot, article, mvtType, sourceDoc });
    }
    getAvailableSerials(depot, article, mvtType, sourceDoc) {
        return this.ws.call("serial-number.get_available_serials", { depot, article, mvtType, sourceDoc });
    }
    getArticleHistoric(query) {
        return this.ws.call("states.get_article_historic", { query });
    }
}
InventoryService.ɵfac = function InventoryService_Factory(t) { return new (t || InventoryService)(i0.ɵɵinject(i1$1.HttpClient), i0.ɵɵinject(i2.FtWsService)); };
InventoryService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: InventoryService, factory: InventoryService.ɵfac, providedIn: 'root' });
(function () {
    (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(InventoryService, [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], function () { return [{ type: i1$1.HttpClient }, { type: i2.FtWsService }]; }, null);
})();

function InvSerialDialogComponent_div_12_Template(rf, ctx) {
    if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 22);
        i0.ɵɵelement(1, "mat-icon", 23)(2, "span", 24);
        i0.ɵɵelementEnd();
    }
    if (rf & 2) {
        i0.ɵɵproperty("@scaleAnimation", undefined);
    }
}
function InvSerialDialogComponent_ng_container_13_mat_list_option_1_Template(rf, ctx) {
    if (rf & 1) {
        i0.ɵɵelementStart(0, "mat-list-option", 26);
        i0.ɵɵtext(1);
        i0.ɵɵelementEnd();
    }
    if (rf & 2) {
        const s_r6 = i0.ɵɵnextContext().$implicit;
        i0.ɵɵproperty("value", s_r6);
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", s_r6.code, " ");
    }
}
function InvSerialDialogComponent_ng_container_13_Template(rf, ctx) {
    if (rf & 1) {
        i0.ɵɵelementContainerStart(0);
        i0.ɵɵtemplate(1, InvSerialDialogComponent_ng_container_13_mat_list_option_1_Template, 2, 2, "mat-list-option", 25);
        i0.ɵɵelementContainerEnd();
    }
    if (rf & 2) {
        const s_r6 = ctx.$implicit;
        const ctx_r1 = i0.ɵɵnextContext();
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx_r1.checkIsSelected(s_r6 == null ? null : s_r6.code));
    }
}
function InvSerialDialogComponent_mat_list_item_19_Template(rf, ctx) {
    if (rf & 1) {
        const _r10 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "mat-list-item", 27)(1, "input", 28);
        i0.ɵɵlistener("ngModelChange", function InvSerialDialogComponent_mat_list_item_19_Template_input_ngModelChange_1_listener($event) { i0.ɵɵrestoreView(_r10); const ctx_r9 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r9.code = $event); })("keydown.enter", function InvSerialDialogComponent_mat_list_item_19_Template_input_keydown_enter_1_listener() { i0.ɵɵrestoreView(_r10); const ctx_r11 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r11.addSerial()); });
        i0.ɵɵpipe(2, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "button", 29);
        i0.ɵɵlistener("click", function InvSerialDialogComponent_mat_list_item_19_Template_button_click_3_listener() { i0.ɵɵrestoreView(_r10); const ctx_r12 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r12.addSerial()); });
        i0.ɵɵelement(4, "mat-icon", 30);
        i0.ɵɵelementEnd()();
    }
    if (rf & 2) {
        const ctx_r2 = i0.ɵɵnextContext();
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(2, 5, "inventory.new_code"))("ftAutoFocus", ctx_r2.codeFocus)("ngModel", ctx_r2.code);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("disabled", !ctx_r2.code || ctx_r2.code == "" || ctx_r2.checkExist(ctx_r2.code));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("@scaleAnimation", undefined);
    }
}
function InvSerialDialogComponent_div_20_Template(rf, ctx) {
    if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 22);
        i0.ɵɵelement(1, "mat-icon", 23)(2, "span", 24);
        i0.ɵɵelementEnd();
    }
    if (rf & 2) {
        i0.ɵɵproperty("@scaleAnimation", undefined);
    }
}
function InvSerialDialogComponent_mat_list_item_21_ng_container_2_Template(rf, ctx) {
    if (rf & 1) {
        const _r17 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementContainerStart(0);
        i0.ɵɵelementStart(1, "button", 33);
        i0.ɵɵlistener("click", function InvSerialDialogComponent_mat_list_item_21_ng_container_2_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r17); const item_r13 = i0.ɵɵnextContext().$implicit; const ctx_r15 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r15.removeSerial(item_r13)); });
        i0.ɵɵelement(2, "mat-icon", 34);
        i0.ɵɵelementEnd();
        i0.ɵɵelementContainerEnd();
    }
    if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("@scaleAnimation", undefined);
    }
}
function InvSerialDialogComponent_mat_list_item_21_Template(rf, ctx) {
    if (rf & 1) {
        i0.ɵɵelementStart(0, "mat-list-item", 27);
        i0.ɵɵelement(1, "span", 31);
        i0.ɵɵtemplate(2, InvSerialDialogComponent_mat_list_item_21_ng_container_2_Template, 3, 1, "ng-container", 32);
        i0.ɵɵelementEnd();
    }
    if (rf & 2) {
        const item_r13 = ctx.$implicit;
        const ctx_r4 = i0.ɵɵnextContext();
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("translate", item_r13.code);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx_r4.readOnly);
    }
}
function InvSerialDialogComponent_button_24_Template(rf, ctx) {
    if (rf & 1) {
        const _r19 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "button", 35);
        i0.ɵɵlistener("click", function InvSerialDialogComponent_button_24_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r19); const ctx_r18 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r18.saveSerial()); });
        i0.ɵɵtext(1);
        i0.ɵɵpipe(2, "translate");
        i0.ɵɵelementEnd();
    }
    if (rf & 2) {
        const ctx_r5 = i0.ɵɵnextContext();
        i0.ɵɵproperty("disabled", ctx_r5.qte != ctx_r5.serials.length || ctx_r5.isDuplicated());
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 2, "shared.saveSerial"), " ");
    }
}
class InvSerialDialogComponent {
    constructor(data, dialogRef, inventoryService) {
        this.data = data;
        this.dialogRef = dialogRef;
        this.inventoryService = inventoryService;
        this.serials = [];
        this.qte = 0;
        this.depot = null;
        this.selectedSerials = [];
        this.readOnly = false;
        this.movementType = null;
        this.sourceDoc = null;
        this.code = null;
        this.codeFocus = true;
        this.serials = get(data, 'serials', []);
        this.qte = get(data, 'qte');
        this.article = get(data, 'article');
        this.depot = get(data, 'depot');
        this.readOnly = get(data, 'readOnly', false);
        this.movementType = get(data, 'movementType', null);
        this.sourceDoc = get(data, 'sourceDoc', null);
    }
    ngOnInit() {
        this.busy = this.inventoryService.getAvailableSerials(this.depot, this.article, this.movementType, this.sourceDoc).subscribe(data => {
            this.availableSerials = data;
        });
    }
    saveSerial() {
        this.dialogRef.close(this.serials);
    }
    removeSerial(idx) {
        this.serials.splice(idx, 1);
    }
    selectSerials() {
        this.serials = concat(this.serials, this.selectedSerials);
    }
    checkIsSelected(code) {
        return code ? find(this.serials, (e) => {
            return e.code == code;
        }) : false;
    }
    addSerial() {
        if (!isEmpty(this.code)) {
            this.serials.push({ code: this.code, is_new: true });
            this.code = null;
            this.codeFocus = true;
        }
    }
    isDuplicated() {
        return size(uniqBy(this.serials, 'code')) != size(this.serials);
    }
    checkExist(code) {
        return find(this.serials, (s) => { return s.code == code; });
    }
}
InvSerialDialogComponent.ɵfac = function InvSerialDialogComponent_Factory(t) { return new (t || InvSerialDialogComponent)(i0.ɵɵdirectiveInject(MAT_DIALOG_DATA), i0.ɵɵdirectiveInject(i1.MatDialogRef), i0.ɵɵdirectiveInject(InventoryService)); };
InvSerialDialogComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: InvSerialDialogComponent, selectors: [["fts-inv-serial-dialog"]], decls: 28, vars: 19, consts: [["color", "primary"], ["mat-dialog-title", ""], ["fontSet", "mdi", "fontIcon", "mdi-format-list-bulleted"], ["fxFlex", ""], ["mat-icon-button", "", "mat-dialog-close", "", "tabindex", "-1"], ["fontSet", "mdi", "fontIcon", "mdi-close"], ["mat-dialog-content", "", "fxLayout", "row", 1, "ft-content"], ["fxLayout", "row", "fxFlex", "", 3, "ngBusy"], ["fxLayout", "column", "fxFlex", "", 1, "selection-list", 3, "tabindex", "fxLayoutAlign"], ["tabindex", "-2", "role", "list", "multiple", "", "color", "accent", 3, "ngModel", "disabled", "ngModelChange"], ["class", "ft-empty-content", 4, "ngIf"], [4, "ngFor", "ngForOf"], ["fxLayout", "column", "fxLayoutAlign", "center center"], ["mat-icon-button", "", "tabindex", "-1", 1, "mat-primary", 3, "disabled", "click"], ["fontSet", "mdi", "fontIcon", "mdi-arrow-right-drop-circle-outline"], ["fxLayout", "column", "fxFlex", "", 1, "selection-list"], ["role", "list"], ["role", "listitem", 4, "ngIf"], ["role", "listitem", 4, "ngFor", "ngForOf"], ["mat-dialog-actions", ""], ["color", "primary", "mat-raised-button", "", 3, "disabled", "click", 4, "ngIf"], ["color", "warn", "mat-raised-button", "", "tabindex", "-1", 3, "mat-dialog-close"], [1, "ft-empty-content"], ["fontSet", "mdi", "fontIcon", "mdi-alert-circle-outline"], ["translate", "common.no_element_to_show"], [3, "value", 4, "ngIf"], [3, "value"], ["role", "listitem"], ["fxFlex", "", "matInput", "", "name", "code", 3, "placeholder", "ftAutoFocus", "ngModel", "ngModelChange", "keydown.enter"], ["mat-icon-button", "", "color", "primary", 3, "disabled", "click"], ["fxFlex", "noshrink", "fontSet", "mdi", "fontIcon", "mdi-plus"], ["fxFlex", "", 3, "translate"], [4, "ngIf"], ["mat-icon-button", "", "color", "warn", 3, "click"], ["fxFlex", "noshrink", "fontSet", "mdi", "fontIcon", "mdi-close-circle"], ["color", "primary", "mat-raised-button", "", 3, "disabled", "click"]], template: function InvSerialDialogComponent_Template(rf, ctx) {
        if (rf & 1) {
            i0.ɵɵelementStart(0, "mat-toolbar", 0)(1, "h2", 1);
            i0.ɵɵelement(2, "mat-icon", 2);
            i0.ɵɵtext(3);
            i0.ɵɵpipe(4, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(5, "span", 3);
            i0.ɵɵelementStart(6, "button", 4);
            i0.ɵɵelement(7, "mat-icon", 5);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(8, "div", 6)(9, "div", 7)(10, "div", 8)(11, "mat-selection-list", 9);
            i0.ɵɵlistener("ngModelChange", function InvSerialDialogComponent_Template_mat_selection_list_ngModelChange_11_listener($event) { return ctx.selectedSerials = $event; });
            i0.ɵɵtemplate(12, InvSerialDialogComponent_div_12_Template, 3, 1, "div", 10);
            i0.ɵɵtemplate(13, InvSerialDialogComponent_ng_container_13_Template, 2, 1, "ng-container", 11);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(14, "div", 12)(15, "button", 13);
            i0.ɵɵlistener("click", function InvSerialDialogComponent_Template_button_click_15_listener() { return ctx.selectSerials(); });
            i0.ɵɵelement(16, "mat-icon", 14);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(17, "div", 15)(18, "mat-action-list", 16);
            i0.ɵɵtemplate(19, InvSerialDialogComponent_mat_list_item_19_Template, 5, 7, "mat-list-item", 17);
            i0.ɵɵtemplate(20, InvSerialDialogComponent_div_20_Template, 3, 1, "div", 10);
            i0.ɵɵtemplate(21, InvSerialDialogComponent_mat_list_item_21_Template, 3, 2, "mat-list-item", 18);
            i0.ɵɵelementEnd()()()();
            i0.ɵɵelementStart(22, "div", 19);
            i0.ɵɵelement(23, "span", 3);
            i0.ɵɵtemplate(24, InvSerialDialogComponent_button_24_Template, 3, 4, "button", 20);
            i0.ɵɵelementStart(25, "button", 21);
            i0.ɵɵtext(26);
            i0.ɵɵpipe(27, "translate");
            i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 15, "shared.serial_number"), " ");
            i0.ɵɵadvance(6);
            i0.ɵɵproperty("ngBusy", ctx.busy);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("tabindex", 1)("fxLayoutAlign", (ctx.availableSerials == null ? null : ctx.availableSerials.length) > 0 ? "start" : "center center");
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngModel", ctx.selectedSerials)("disabled", ctx.readOnly);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", (ctx.availableSerials == null ? null : ctx.availableSerials.length) == 0);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngForOf", ctx.availableSerials);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("disabled", ctx.readOnly || (ctx.selectedSerials == null ? null : ctx.selectedSerials.length) == 0 || (ctx.selectedSerials == null ? null : ctx.selectedSerials.length) > ctx.qte);
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngIf", !ctx.readOnly);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", !ctx.serials || ctx.serials.length == 0);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngForOf", ctx.serials);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngIf", !ctx.readOnly);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("mat-dialog-close", null);
            i0.ɵɵadvance(1);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(27, 17, ctx.readOnly ? "shared.exit" : "shared.cancel"));
        }
    }, dependencies: [i4$1.NgForOf, i4$1.NgIf, i6.MatButton, i1.MatDialogClose, i1.MatDialogTitle, i1.MatDialogContent, i1.MatDialogActions, i9.MatIcon, i11$1.MatInput, i7$1.MatList, i7$1.MatListItem, i7$1.MatSelectionList, i7$1.MatListOption, i11.MatToolbar, i8.DefaultLayoutDirective, i8.DefaultLayoutAlignDirective, i8.DefaultFlexDirective, i16.DefaultValueAccessor, i16.NgControlStatus, i16.NgModel, i3$1.TranslateDirective, i12.NgBusyDirective, i2.InputDirective, i2.AutoFocusDirective, i3$1.TranslatePipe], data: { animation: [
            SCALE_ANIMATION
        ] } });
(function () {
    (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(InvSerialDialogComponent, [{
            type: Component,
            args: [{ selector: 'fts-inv-serial-dialog', animations: [
                        SCALE_ANIMATION
                    ], template: "<mat-toolbar color=\"primary\">\n  <h2 mat-dialog-title>\n    <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-format-list-bulleted\"></mat-icon>\n    {{ 'shared.serial_number' | translate }}\n  </h2>\n  <span fxFlex></span>\n  <button mat-icon-button mat-dialog-close tabindex=\"-1\">\n    <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-close\"></mat-icon>\n  </button>\n</mat-toolbar>\n\n<div mat-dialog-content class=\"ft-content\" fxLayout=\"row\">\n    <div  [ngBusy]=\"busy\" fxLayout=\"row\" fxFlex>\n      <div fxLayout=\"column\" fxFlex class=\"selection-list\"  [tabindex]=\"1\" [fxLayoutAlign]=\"availableSerials?.length>0? 'start':'center center'\">\n        <mat-selection-list tabindex=\"-2\" role=\"list\" [(ngModel)]=\"selectedSerials\" multiple color=\"accent\" [disabled]=\"readOnly\">\n          <div *ngIf=\"availableSerials?.length == 0\" class=\"ft-empty-content\" [@scaleAnimation]  >\n              <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-alert-circle-outline\"></mat-icon>\n              <span translate=\"common.no_element_to_show\"></span>\n          </div>\n          <ng-container *ngFor=\"let s of availableSerials;\">\n            <mat-list-option *ngIf=\"!checkIsSelected(s?.code)\"  [value]=\"s\" >\n                {{ s.code }}\n            </mat-list-option>\n          </ng-container>\n        </mat-selection-list>\n      </div>\n      <div fxLayout=\"column\" fxLayoutAlign=\"center center\">\n         <button mat-icon-button tabindex=\"-1\"  class=\"mat-primary\" (click)=\"selectSerials()\" [disabled]=\"readOnly||selectedSerials?.length==0 ||selectedSerials?.length>qte\">\n            <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-arrow-right-drop-circle-outline\"></mat-icon>\n          </button>\n      </div>\n      <div fxLayout=\"column\" fxFlex  class=\"selection-list\" >\n         <mat-action-list role=\"list\">\n            <mat-list-item  *ngIf=\"!readOnly\" role=\"listitem\">\n              <input fxFlex matInput [placeholder]=\"'inventory.new_code'|translate\" [ftAutoFocus]=\"codeFocus\"\n                       name=\"code\"  [(ngModel)]=\"code\" (keydown.enter)=\"addSerial()\">\n               <button [disabled]=\"!code || code==''|| checkExist(code)\" (click)=\"addSerial()\"  mat-icon-button color=\"primary\" >\n                <mat-icon fxFlex=\"noshrink\" fontSet=\"mdi\" fontIcon=\"mdi-plus\" [@scaleAnimation]></mat-icon>\n              </button>\n            </mat-list-item>\n            <div *ngIf=\"!serials || serials.length == 0\" class=\"ft-empty-content\" [@scaleAnimation]  >\n                <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-alert-circle-outline\"></mat-icon>\n                <span translate=\"common.no_element_to_show\"></span>\n            </div>\n\n            <mat-list-item role=\"listitem\" *ngFor=\"let item of serials\">\n                    <span fxFlex [translate]=\"item.code\"></span>\n                    <ng-container  *ngIf=\"!readOnly\">\n                      <button (click)=\"removeSerial(item)\"  mat-icon-button color=\"warn\" >\n                        <mat-icon fxFlex=\"noshrink\" fontSet=\"mdi\" fontIcon=\"mdi-close-circle\" [@scaleAnimation]></mat-icon>\n                      </button>\n                    </ng-container>\n            </mat-list-item>\n         </mat-action-list>\n      </div>\n    </div>\n</div>\n<div mat-dialog-actions>\n  <span fxFlex></span>\n  <button color=\"primary\"  *ngIf=\"!readOnly\" mat-raised-button (click)=\"saveSerial()\" [disabled]=\"qte !=serials.length || isDuplicated()\">\n    {{'shared.saveSerial'|translate}}\n  </button>\n  <button [mat-dialog-close]=\"null\" color=\"warn\" mat-raised-button tabindex=\"-1\">{{ (readOnly ?'shared.exit':'shared.cancel')|translate}}</button>\n</div>\n" }]
        }], function () {
        return [{ type: undefined, decorators: [{
                        type: Inject,
                        args: [MAT_DIALOG_DATA]
                    }] }, { type: i1.MatDialogRef }, { type: InventoryService }];
    }, null);
})();

function InvLotDialogComponent_div_12_Template(rf, ctx) {
    if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 20);
        i0.ɵɵelement(1, "mat-icon", 21)(2, "span", 22);
        i0.ɵɵelementEnd();
    }
    if (rf & 2) {
        i0.ɵɵproperty("@scaleAnimation", undefined);
    }
}
function InvLotDialogComponent_ng_container_13_mat_list_option_1_Template(rf, ctx) {
    if (rf & 1) {
        i0.ɵɵelementStart(0, "mat-list-option", 24);
        i0.ɵɵtext(1);
        i0.ɵɵelementEnd();
    }
    if (rf & 2) {
        const s_r3 = i0.ɵɵnextContext().$implicit;
        i0.ɵɵproperty("value", s_r3);
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", s_r3.code, " ");
    }
}
function InvLotDialogComponent_ng_container_13_Template(rf, ctx) {
    if (rf & 1) {
        i0.ɵɵelementContainerStart(0);
        i0.ɵɵtemplate(1, InvLotDialogComponent_ng_container_13_mat_list_option_1_Template, 2, 2, "mat-list-option", 23);
        i0.ɵɵelementContainerEnd();
    }
    if (rf & 2) {
        const s_r3 = ctx.$implicit;
        const ctx_r1 = i0.ɵɵnextContext();
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx_r1.checkIsSelected(s_r3 == null ? null : s_r3.code));
    }
}
function InvLotDialogComponent_button_22_Template(rf, ctx) {
    if (rf & 1) {
        const _r7 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "button", 25);
        i0.ɵɵlistener("click", function InvLotDialogComponent_button_22_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r7); const ctx_r6 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r6.saveLot()); });
        i0.ɵɵtext(1);
        i0.ɵɵpipe(2, "translate");
        i0.ɵɵelementEnd();
    }
    if (rf & 2) {
        const ctx_r2 = i0.ɵɵnextContext();
        i0.ɵɵproperty("disabled", !ctx_r2.isValidQte());
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 2, "shared.save"), " ");
    }
}
const _c0$8 = function () { return []; };
class InvLotDialogComponent {
    constructor(data, dialogRef, translate, inventoryService) {
        this.data = data;
        this.dialogRef = dialogRef;
        this.translate = translate;
        this.inventoryService = inventoryService;
        this.lots = [];
        this.qte = 0;
        this.depot = null;
        this.linesSource = of([]);
        this.selectedLots = [];
        this.readOnly = false;
        this.movementType = null;
        this.sourceDoc = null;
        this.columns = new BehaviorSubject([
            {
                'label': 'store.code',
                'key': 'code',
                'type': 'text',
                'is_global_searchable': true,
                editable: (r) => {
                    return get(r, 'is_new');
                }
            },
            {
                'label': 'store.date',
                'key': 'expiry_date',
                'type': 'date',
                'is_global_searchable': true,
                editable: true
            },
            {
                'label': 'store.qte',
                'key': 'store_qte',
                'type': 'number',
                "editable": (r) => {
                    return !this.readOnly;
                },
                min: 0,
                'numberConfig': "float"
            },
            {
                label: '', key: 'actions', type: 'actions', actions: [
                    {
                        class: 'mat-warn',
                        icon: 'mdi-close-circle',
                        disabled: (r) => {
                            return this.readOnly;
                        },
                        method: (item, index, ev) => {
                            return this.removeLine(item, index);
                        },
                    }
                ]
            }
        ]);
        this.multiActions = [
            {
                icon: 'mdi-plus-box',
                class: 'mat-primary',
                isMultipleSelection: false,
                method: (item, index, ev) => {
                    this.addLot();
                },
                disabled: () => {
                    return this.qte <= sumBy(this.lots, 'store_qte');
                }
            },
        ];
        this.qte = get(data, 'qte');
        this.article = get(data, 'article');
        this.depot = get(data, 'depot');
        this.lots = get(data, 'lots');
        this.linesSource = of(this.lots);
        this.readOnly = get(data, 'readOnly', false);
        this.movementType = get(data, 'movementType', null);
        this.sourceDoc = get(data, 'sourceDoc', null);
    }
    ngOnInit() {
        this.busy = this.inventoryService.getAvailableLots(this.depot, this.article, this.movementType, this.sourceDoc).subscribe(data => {
            this.availableLots = data;
        });
    }
    removeLine(row, idx) {
        this.lots.splice(idx, 1);
        this.linesSource = of(this.lots);
    }
    saveLot() {
        this.dialogRef.close(this.lots);
    }
    checkIsSelected(code) {
        return code ? find(this.lots, (e) => {
            return e.code == code;
        }) : false;
    }
    getRequiredLotQte(l) {
        let allowedQts = this.allowedQte();
        if (allowedQts > 0) {
            let available_qte = subtract(sum([
                get(l, 'store_qte', 0),
                get(l, 'deposition_qte', 0)
            ]), sum([get(l, 'consigned_qte', 0),
                get(l, 'sold_qte', 0),
                get(l, 'return_qte', 0)
            ]));
            return available_qte > allowedQts ? allowedQts : available_qte;
        }
        else
            return 0;
    }
    selectLots() {
        let lot = [];
        forEach(cloneDeep(this.selectedLots), (l) => {
            this.lots.push(assignIn(omit(l, 'deposition_qte', 'consigned_qte', 'sold_qte', 'return_qte'), { 'store_qte': this.getRequiredLotQte(l) }));
        });
        this.linesSource = of(this.lots);
    }
    allowedQte() {
        return this.qte - sumBy(this.lots, 'store_qte');
    }
    isValidQte() {
        return this.qte == sumBy(this.lots, 'store_qte') && !find(this.lots, { store_qte: 0 });
    }
    addLot() {
        this.lots.push({
            code: null,
            expiry_date: moment(),
            store_qte: this.allowedQte(),
            is_new: true
        });
        this.linesSource = of(this.lots);
    }
}
InvLotDialogComponent.ɵfac = function InvLotDialogComponent_Factory(t) { return new (t || InvLotDialogComponent)(i0.ɵɵdirectiveInject(MAT_DIALOG_DATA), i0.ɵɵdirectiveInject(i1.MatDialogRef), i0.ɵɵdirectiveInject(i3$1.TranslateService), i0.ɵɵdirectiveInject(InventoryService)); };
InvLotDialogComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: InvLotDialogComponent, selectors: [["fts-inv-lot-dialog"]], decls: 26, vars: 25, consts: [["color", "primary"], ["mat-dialog-title", ""], ["fontSet", "mdi", "fontIcon", "mdi-format-list-bulleted"], ["fxFlex", ""], ["mat-icon-button", "", "mat-dialog-close", "", "tabindex", "-1"], ["fontSet", "mdi", "fontIcon", "mdi-close"], ["mat-dialog-content", "", "fxLayout", "row", 1, "ft-content"], ["fxLayout", "row", "fxFlex", "", 3, "ngBusy"], ["fxLayout", "column", "fxFlex", "30", 1, "selection-list", 3, "fxLayoutAlign"], ["tabindex", "-2", "role", "list", "multiple", "", "color", "accent", 3, "ngModel", "disabled", "ngModelChange"], ["class", "ft-empty-content", 4, "ngIf"], [4, "ngFor", "ngForOf"], ["fxLayout", "column", "fxLayoutAlign", "center center"], ["mat-icon-button", "", "tabindex", "-1", 1, "mat-primary", 3, "disabled", "click"], ["fontSet", "mdi", "fontIcon", "mdi-arrow-right-drop-circle-outline"], ["fxLayout", "column", "fxFlex", "", 1, "ft-content"], [3, "remote", "source", "selectable", "hasPagination", "columns", "hasFooter", "multiActions"], ["mat-dialog-actions", ""], ["color", "primary", "mat-raised-button", "", 3, "disabled", "click", 4, "ngIf"], ["color", "warn", "mat-raised-button", "", "tabindex", "-1", 3, "mat-dialog-close"], [1, "ft-empty-content"], ["fontSet", "mdi", "fontIcon", "mdi-alert-circle-outline"], ["translate", "common.no_element_to_show"], [3, "value", 4, "ngIf"], [3, "value"], ["color", "primary", "mat-raised-button", "", 3, "disabled", "click"]], template: function InvLotDialogComponent_Template(rf, ctx) {
        if (rf & 1) {
            i0.ɵɵelementStart(0, "mat-toolbar", 0)(1, "h2", 1);
            i0.ɵɵelement(2, "mat-icon", 2);
            i0.ɵɵtext(3);
            i0.ɵɵpipe(4, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(5, "span", 3);
            i0.ɵɵelementStart(6, "button", 4);
            i0.ɵɵelement(7, "mat-icon", 5);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(8, "div", 6)(9, "div", 7)(10, "div", 8)(11, "mat-selection-list", 9);
            i0.ɵɵlistener("ngModelChange", function InvLotDialogComponent_Template_mat_selection_list_ngModelChange_11_listener($event) { return ctx.selectedLots = $event; });
            i0.ɵɵtemplate(12, InvLotDialogComponent_div_12_Template, 3, 1, "div", 10);
            i0.ɵɵtemplate(13, InvLotDialogComponent_ng_container_13_Template, 2, 1, "ng-container", 11);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(14, "div", 12)(15, "button", 13);
            i0.ɵɵlistener("click", function InvLotDialogComponent_Template_button_click_15_listener() { return ctx.selectLots(); });
            i0.ɵɵelement(16, "mat-icon", 14);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(17, "div", 15);
            i0.ɵɵelement(18, "ft-generic-body-table", 16);
            i0.ɵɵpipe(19, "async");
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(20, "div", 17);
            i0.ɵɵelement(21, "span", 3);
            i0.ɵɵtemplate(22, InvLotDialogComponent_button_22_Template, 3, 4, "button", 18);
            i0.ɵɵelementStart(23, "button", 19);
            i0.ɵɵtext(24);
            i0.ɵɵpipe(25, "translate");
            i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 18, "shared.lot_number"), "");
            i0.ɵɵadvance(6);
            i0.ɵɵproperty("ngBusy", ctx.busy);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("fxLayoutAlign", (ctx.availableLots == null ? null : ctx.availableLots.length) > 0 ? "start" : "center center");
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngModel", ctx.selectedLots)("disabled", ctx.readOnly);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", (ctx.availableLots == null ? null : ctx.availableLots.length) == 0);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngForOf", ctx.availableLots);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("disabled", ctx.readOnly || (ctx.selectedLots == null ? null : ctx.selectedLots.length) == 0);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("remote", false)("source", ctx.linesSource)("selectable", false)("hasPagination", true)("columns", i0.ɵɵpipeBind1(19, 20, ctx.columns))("hasFooter", false)("multiActions", ctx.readOnly ? i0.ɵɵpureFunction0(24, _c0$8) : ctx.multiActions);
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngIf", !ctx.readOnly);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("mat-dialog-close", null);
            i0.ɵɵadvance(1);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(25, 22, ctx.readOnly ? "shared.exit" : "shared.cancel"));
        }
    }, dependencies: [i4$1.NgForOf, i4$1.NgIf, i6.MatButton, i1.MatDialogClose, i1.MatDialogTitle, i1.MatDialogContent, i1.MatDialogActions, i9.MatIcon, i7$1.MatSelectionList, i7$1.MatListOption, i11.MatToolbar, i8.DefaultLayoutDirective, i8.DefaultLayoutAlignDirective, i8.DefaultFlexDirective, i16.NgControlStatus, i16.NgModel, i3$1.TranslateDirective, i12.NgBusyDirective, i4$2.GenericBodyTableComponent, i4$1.AsyncPipe, i3$1.TranslatePipe], data: { animation: [
            SCALE_ANIMATION
        ] } });
(function () {
    (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(InvLotDialogComponent, [{
            type: Component,
            args: [{ selector: 'fts-inv-lot-dialog', animations: [
                        SCALE_ANIMATION
                    ], template: "<mat-toolbar color=\"primary\">\n  <h2 mat-dialog-title>\n    <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-format-list-bulleted\"></mat-icon>\n    {{ 'shared.lot_number' | translate }}</h2>\n  <span fxFlex></span>\n  <button mat-icon-button mat-dialog-close tabindex=\"-1\">\n    <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-close\"></mat-icon>\n  </button>\n</mat-toolbar>\n\n<div mat-dialog-content  class=\"ft-content\" fxLayout=\"row\">\n    <div  [ngBusy]=\"busy\" fxLayout=\"row\" fxFlex>\n      <div fxLayout=\"column\" fxFlex=\"30\" class=\"selection-list\"  [fxLayoutAlign]=\"availableLots?.length>0? 'start':'center center'\">\n        <mat-selection-list tabindex=\"-2\" role=\"list\" [(ngModel)]=\"selectedLots\" multiple color=\"accent\" [disabled]=\"readOnly\">\n          <div *ngIf=\"availableLots?.length == 0\" class=\"ft-empty-content\" [@scaleAnimation]  >\n              <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-alert-circle-outline\"></mat-icon>\n              <span translate=\"common.no_element_to_show\"></span>\n          </div>\n          <ng-container *ngFor=\"let s of availableLots\">\n            <mat-list-option *ngIf=\"!checkIsSelected(s?.code)\"  [value]=\"s\" >\n                {{ s.code }}\n            </mat-list-option>\n          </ng-container>\n        </mat-selection-list>\n      </div>\n      <div fxLayout=\"column\" fxLayoutAlign=\"center center\">\n         <button mat-icon-button tabindex=\"-1\"  class=\"mat-primary\" (click)=\"selectLots()\" [disabled]=\"readOnly || selectedLots?.length==0\">\n            <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-arrow-right-drop-circle-outline\"></mat-icon>\n          </button>\n      </div>\n      <div fxLayout=\"column\" fxFlex    class=\"ft-content\">\n        <ft-generic-body-table\n          [remote]=\"false\"\n          [source]=\"linesSource\"\n          [selectable]=\"false\"\n          [hasPagination]=\"true\"\n          [columns]=\"columns| async\"\n          [hasFooter]=\"false\"\n          [multiActions]=\"readOnly ? []: multiActions\"\n        ></ft-generic-body-table>\n      </div>\n    </div>\n</div>\n<div mat-dialog-actions>\n  <span fxFlex></span>\n  <button color=\"primary\"  *ngIf=\"!readOnly\" mat-raised-button (click)=\"saveLot()\"  [disabled]=\"!isValidQte()\" >\n    {{'shared.save'|translate}}\n  </button>\n\n<!-- [disabled]=\"!sumQteLot()\"-->\n  <button [mat-dialog-close]=\"null\" color=\"warn\" mat-raised-button tabindex=\"-1\">{{ (readOnly ?'shared.exit':'shared.cancel')|translate}}</button>\n</div>\n" }]
        }], function () {
        return [{ type: undefined, decorators: [{
                        type: Inject,
                        args: [MAT_DIALOG_DATA]
                    }] }, { type: i1.MatDialogRef }, { type: i3$1.TranslateService }, { type: InventoryService }];
    }, null);
})();

const _c0$7 = function () { return []; };
class InventoryLinesComponent {
    constructor(route, dialog, translateService) {
        this.route = route;
        this.dialog = dialog;
        this.translateService = translateService;
        this.readOnly = false;
        this.linesSource = of([]);
        this.columns = [
            {
                "label": "store.code",
                "key": "code",
                "type": "text"
            },
            {
                "label": "store.description",
                "key": "description",
                "type": "text",
                "editable": true,
                'extended': true
            },
            {
                "label": "inventory.qte",
                "key": "qte",
                "type": "number",
                "editable": true,
                numberConfig: 'float',
                min: 0
            },
            {
                "label": "inventory.theo_qte",
                "key": "theo_qte",
                "type": "number",
                "editable": true,
                numberConfig: 'float',
                callBack: (row) => {
                    return this.readOnly ? row.theo_qte : row.theo_qte = get(find(get(row, 'article.theo_stores'), (s) => { return s.depot == get(this.defaultDepot, 'id'); }), 'store_qte', 0);
                }
            },
            {
                "label": "inventory.difference_qte",
                "key": "qte_diff",
                "type": "number",
                "editable": true,
                numberConfig: 'float',
                callBack: (row) => { return this.readOnly ? row.qte_diff : row.qte_diff = subtract(row.qte, row.theo_qte); },
                class: (row) => { return `${get(row, 'qte_diff', 0) < 0 ? "warning" : ""} ${get(row, 'qte_diff', 0) > 0 ? "success" : ""}`; }
            },
            {
                "label": "inventory.pmp",
                "key": "price",
                "type": "number",
                "editable": true,
                numberConfig: 'float',
                min: 0
            },
            {
                "label": "inventory.theo_pmp",
                "key": "theo_pmp",
                "type": "number",
                "editable": true,
                numberConfig: 'float',
                callBack: (row) => { return this.readOnly ? row.theo_pmp : row.theo_pmp = get(row, 'article.pmp', 0); }
            },
            {
                "label": "inventory.difference_pmp",
                "key": "pmp_diff",
                "type": "number",
                "editable": true,
                numberConfig: 'float',
                callBack: (row) => { return !this.readOnly ? row.pmp_diff = subtract(row.price, row.theo_pmp) : row.pmp_diff; },
                class: (row) => { return `${get(row, 'pmp_diff', 0) < 0 ? "warning" : ""} ${get(row, 'pmp_diff', 0) > 0 ? "success" : ""}`; }
            },
            {
                "label": "store.total_sous",
                "key": "sub_total",
                "type": "number",
                "numberConfig": "float",
                "callBack": (row) => {
                    return 0; //row.qte*row.price;
                }
            }
        ];
        this.multiActions = [
            {
                class: 'mat-primary',
                icon: 'mdi-playlist-plus',
                isMultipleSelection: false,
                method: (item, ev) => {
                    return this.showSelectionDialog();
                },
                tooltip: this.translateService.instant('shared.add')
            },
            {
                class: 'mat-accent',
                icon: 'mdi-comment-plus-outline',
                isMultipleSelection: false,
                method: (item, ev) => {
                    return this.addComment();
                },
                tooltip: this.translateService.instant('shared.add_comment')
            }
        ];
        this.actionColumn = {
            label: '', key: 'actions', type: 'actions', actions: [
                {
                    class: 'mat-primary',
                    icon: 'mdi-text-box',
                    method: (item, index, ev) => {
                        this.showArticleDetails(item);
                    },
                    tooltip: "shared.article_details",
                    disabled: (item) => {
                        return get(item, 'is_comment');
                    },
                },
                {
                    icon: 'mdi-alpha-s-circle',
                    method: (item, index, ev) => {
                        this.handleSerials(item);
                    },
                    disabled: (item) => {
                        return !get(item, 'article.has_serial') || !get(item, 'store.id', null);
                    },
                    hidden: (item) => {
                        return get(item, 'article.has_lot_number');
                    },
                    class: (line) => {
                        if (line.qte <= 0 || line.qte != get(line, 'serials_list', []).length) {
                            return 'mat-warn';
                        }
                        else {
                            return 'success-color';
                        }
                    },
                    tooltip: "shared.serial_numbers"
                },
                {
                    icon: 'mdi-alpha-l-circle',
                    method: (item, index, ev) => {
                        this.handleLots(item);
                    },
                    hidden: (item) => {
                        return !get(item, 'article.has_lot_number', false);
                    },
                    disabled: (item) => {
                        return !get(item, 'store.id', null);
                    },
                    class: (line) => {
                        return (line.qte <= 0 || line.qte != chain(line).get('lots_list').sumBy('store_qte').value()) ? 'mat-warn' : 'success-color';
                    },
                    tooltip: "shared.lot_numbers"
                },
                {
                    class: 'mat-warn',
                    icon: 'mdi-close-circle',
                    method: (item, index, ev) => {
                        return this.removeLine(item, index);
                    },
                    disabled: () => {
                        return this.readOnly;
                    },
                    tooltip: "shared.delete"
                }
            ]
        };
        this.linesColumns = new BehaviorSubject(this.columns.concat(this.actionColumn));
        this.extendedColHandler = (index, item) => get(item, 'is_comment') === true;
        this.modelLines = [];
        this.priceMode = null;
        this.defaultDepot = null;
        this.movementType = null;
        this.optionalDepot = null;
        this.linesChange = new EventEmitter();
    }
    set handleOptionalDepot(value) {
        this.optionalDepot = value;
    }
    set handleDepot(value) {
        this.defaultDepot = value;
    }
    set handleMovementType(value) {
        this.movementType = value;
    }
    set handleReadOnly(value) {
        this.readOnly = value;
    }
    set lines(value) {
        if (!isUndefined(value)) {
            this.modelLines = value;
            this.linesSource = of(value);
        }
    }
    ngOnInit() {
    }
    addComment() {
        this.modelLines.push({
            code: '',
            description: '',
            is_comment: true
        });
        this.linesSource = of(this.modelLines);
    }
    showArticleDetails(row) {
        this.dialog.open(ArticleSummaryDialogComponent, assignIn(LARGE_DIALOG, {
            data: {
                id: get(row, 'article.id')
            },
            disableClose: true
        })).afterClosed().subscribe(noop);
    }
    handleSerials(row) {
        this.dialog.open(InvSerialDialogComponent, assignIn(MEDIUM_DIALOG, {
            data: {
                serials: cloneDeep(get(row, 'serials_list', [])),
                qte: get(row, 'qte', 0),
                article: get(row, 'article.id', null),
                depot: get(row, 'store.id', null),
                readOnly: this.readOnly,
                movementType: this.movementType,
                sourceDoc: pick(get(row, 'source_document'), 'id', '_model')
            }, disableClose: true
        })).afterClosed().subscribe(data => {
            if (data) {
                row.serials_list = data;
                this.linesSource = of(this.modelLines);
            }
        });
    }
    handleLots(row) {
        this.dialog.open(InvLotDialogComponent, assignIn(MEDIUM_DIALOG, {
            data: {
                lots: cloneDeep(get(row, 'lots_list', [])),
                qte: get(row, 'qte', 0),
                article: get(row, 'article.id', null),
                depot: get(row, 'store.id', null),
                readOnly: this.readOnly,
                movementType: this.movementType,
                sourceDoc: pick(get(row, 'source_document'), 'id', '_model')
            },
            disableClose: true
        })).afterClosed().subscribe(data => {
            if (data) {
                row.lots_list = data;
                this.linesSource = of(this.modelLines);
            }
        });
    }
    removeLine(row, index) {
        this.modelLines.splice(index, 1);
        this.linesSource = of(this.modelLines);
    }
    showSelectionDialog() {
        this.dialog.open(LinesDialogComponent, assignIn(LARGE_DIALOG, {
            data: { cls: this.movementType, query: [], selectable: true },
            disableClose: true
        })).afterClosed().subscribe(this.handleLines.bind(this));
    }
    handleLines(data) {
        this.modelLines = chain(this.modelLines).concat(this.handleArticleLines(get(data, 'article', []))).value();
        this.handleLinesChange();
    }
    handleLinesChange() {
        this.linesChange.emit(this.modelLines);
        this.linesSource = of(this.modelLines);
    }
    handleArticleLines(articles) {
        return map(articles, item => chain(item)
            .pick("code", "description")
            .assign({
            article: item,
            theo_qte: get(find(item.theo_stores, (s) => { return s.depot == get(this.defaultDepot, 'id'); }), 'store_qte', 0),
            qte: 0,
            price: 0,
            theo_pmp: get(item, 'pmp', 0),
            store: this.defaultDepot,
            lots_list: [],
            serials_list: []
        })
            .value());
    }
}
InventoryLinesComponent.ɵfac = function InventoryLinesComponent_Factory(t) { return new (t || InventoryLinesComponent)(i0.ɵɵdirectiveInject(i3.ActivatedRoute), i0.ɵɵdirectiveInject(i1.MatDialog), i0.ɵɵdirectiveInject(i3$1.TranslateService)); };
InventoryLinesComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: InventoryLinesComponent, selectors: [["fts-inventory-lines"]], inputs: { handleOptionalDepot: ["optionalDepot", "handleOptionalDepot"], handleDepot: ["defaultDepot", "handleDepot"], handleMovementType: ["movementType", "handleMovementType"], handleReadOnly: ["readOnly", "handleReadOnly"], lines: "lines" }, outputs: { linesChange: "linesChange" }, decls: 3, vars: 11, consts: [["fxLayout", "column", "fxFlex", "", "fxFill", "", 1, "ft-content"], [3, "remote", "source", "selectable", "hasPagination", "columns", "multiActions", "hasFooter", "extendedHandler"]], template: function InventoryLinesComponent_Template(rf, ctx) {
        if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵelement(1, "ft-generic-body-table", 1);
            i0.ɵɵpipe(2, "async");
            i0.ɵɵelementEnd();
        }
        if (rf & 2) {
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("remote", false)("source", ctx.linesSource)("selectable", false)("hasPagination", true)("columns", i0.ɵɵpipeBind1(2, 8, ctx.linesColumns))("multiActions", ctx.readOnly ? i0.ɵɵpureFunction0(10, _c0$7) : ctx.multiActions)("hasFooter", false)("extendedHandler", ctx.extendedColHandler);
        }
    }, dependencies: [i8.DefaultLayoutDirective, i8.FlexFillDirective, i8.DefaultFlexDirective, i4$2.GenericBodyTableComponent, i4$1.AsyncPipe], styles: [".table-container .mat-table .mat-cell.warning{background-color:red}  .table-container .mat-table .mat-cell.success{background-color:green}"] });
(function () {
    (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(InventoryLinesComponent, [{
            type: Component,
            args: [{ selector: 'fts-inventory-lines', template: "<div fxLayout=\"column\" fxFlex  fxFill class=\"ft-content\">\n  <ft-generic-body-table\n    [remote]=\"false\"\n    [source]=\"linesSource\"\n    [selectable]=\"false\"\n    [hasPagination]=\"true\"\n    [columns]=\"linesColumns| async\"\n    [multiActions]=\"readOnly ? [] : multiActions\"\n    [hasFooter]=\"false\"\n    [extendedHandler]=\"extendedColHandler\"\n  ></ft-generic-body-table>\n</div>\n", styles: ["::ng-deep .table-container .mat-table .mat-cell.warning{background-color:red}::ng-deep .table-container .mat-table .mat-cell.success{background-color:green}\n"] }]
        }], function () { return [{ type: i3.ActivatedRoute }, { type: i1.MatDialog }, { type: i3$1.TranslateService }]; }, { handleOptionalDepot: [{
                type: Input,
                args: ['optionalDepot']
            }], handleDepot: [{
                type: Input,
                args: ['defaultDepot']
            }], handleMovementType: [{
                type: Input,
                args: ['movementType']
            }], handleReadOnly: [{
                type: Input,
                args: ['readOnly']
            }], lines: [{
                type: Input
            }], linesChange: [{
                type: Output
            }] });
})();

function InventoryComponent_div_14_Template(rf, ctx) {
    if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 29);
        i0.ɵɵelement(1, "img", 30);
        i0.ɵɵelementEnd();
    }
}
const _c0$6 = function () { return { cls: "ft_stock.store.StoreInventory", field: "number" }; };
const _c1$5 = function () { return { key: "name", url: "api/store/depot", cls: "store/depot", customValidator: "depot.check_uniqueness" }; };
class InventoryComponent {
    constructor(sharedModulesService, router, route, sharedService) {
        this.sharedModulesService = sharedModulesService;
        this.router = router;
        this.route = route;
        this.sharedService = sharedService;
        this.loadedObject = null;
        this.depotDialog = DepotDialogComponent;
        this.model = { date: moment() };
        this.apiUrl = 'store/inventory';
        this.resource = 'store-inventory';
        this.routes = { list: '/inventory/inventory', form: '/inventory/inventory/inventory-form' };
    }
    ngOnInit() {
        this.route.params.subscribe((data) => {
            let id = get(data, 'id');
            if (id)
                this.sharedService.getDocument(this.apiUrl, id).subscribe(data => {
                    this.model = data;
                });
        });
    }
    goBack() {
        this.router.navigate([handleRoute(this.sharedModulesService.pathName, this.routes["list"])]);
    }
    handleLinesValidation() {
        return find(this.model.lines, (row) => { return row.qte_diff < 0 || row.pmp_diff < 0; });
    }
}
InventoryComponent.ɵfac = function InventoryComponent_Factory(t) { return new (t || InventoryComponent)(i0.ɵɵdirectiveInject(SharedModulesService), i0.ɵɵdirectiveInject(i3.Router), i0.ɵɵdirectiveInject(i3.ActivatedRoute), i0.ɵɵdirectiveInject(SharedService)); };
InventoryComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: InventoryComponent, selectors: [["fts-inventory"]], decls: 39, vars: 50, consts: [["color", "accent"], [1, "ft-module-icon"], ["type", "button", "mat-icon-button", ""], ["fontSet", "mdi", "fontIcon", "mdi-clipboard-arrow-left"], ["fxFlex", ""], ["type", "button", "mat-button", "", 1, "with-icon", 3, "matTooltip", "click"], ["fontSet", "mdi", "fontIcon", "mdi-format-list-bulleted"], ["fxFlex", "", "fxLayout", "column", 1, "ft-content"], [3, "ngBusy"], ["fxLayoutAlign", "center center", "class", "validate-icon", 4, "ngIf"], ["novalidate", "", "fxLayout", "column", "fxFlex", ""], ["Form", "ngForm"], ["fxLayout", "row", 1, "ft-padding"], ["fxFlex", "60", "fxLayout", "column"], ["fxLayout", "row", "fxLayoutGap", "6px"], ["fxFlex", "24"], ["matInput", "", "type", "text", "required", "", "name", "sequence", 3, "ftSequenceInput", "ftSequenceToggle", "placeholder", "ngModel", "disabled", "ngModelChange"], ["matSuffix", "", 3, "objectId", "config", "objectIdChange"], ["toggle", ""], ["fxFlex", "25"], ["matInput", "", "ftDate", "", "name", "date", 3, "placeholder", "disabled", "ngModel", "matDatepicker", "ngModelChange"], ["matSuffix", "", 3, "for"], ["picker", ""], ["fxFlex", "30"], ["matInput", "", "required", "", "name", "manager", 3, "placeholder", "ngModel", "ngModelChange"], ["fxFlex", "30", 3, "required", "disabled", "model", "listDialog", "config", "label", "defaultValues", "modelChange"], ["fxLayout", "column", "fxFlex", ""], ["fxFlex", "", 3, "lines", "defaultDepot", "readOnly", "linesChange"], ["fxFlex", "nogrow", 3, "model", "cls", "resource", "disableValidate", "formInvalid", "busy", "routes", "loadedObject", "movementType", "modelChange", "busyChange"], ["fxLayoutAlign", "center center", 1, "validate-icon"], ["mat-card-image", "", "src", "/assets/lock-outline.svg", "alt", "validation img"]], template: function InventoryComponent_Template(rf, ctx) {
        if (rf & 1) {
            i0.ɵɵelementStart(0, "mat-toolbar", 0)(1, "div", 1)(2, "button", 2);
            i0.ɵɵelement(3, "mat-icon", 3);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(4, "h2")(5, "span");
            i0.ɵɵtext(6);
            i0.ɵɵpipe(7, "translate");
            i0.ɵɵelementEnd()();
            i0.ɵɵelement(8, "span", 4);
            i0.ɵɵelementStart(9, "button", 5);
            i0.ɵɵlistener("click", function InventoryComponent_Template_button_click_9_listener() { return ctx.goBack(); });
            i0.ɵɵpipe(10, "translate");
            i0.ɵɵelement(11, "mat-icon", 6);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(12, "div", 7);
            i0.ɵɵelement(13, "div", 8);
            i0.ɵɵtemplate(14, InventoryComponent_div_14_Template, 2, 0, "div", 9);
            i0.ɵɵelementStart(15, "form", 10, 11)(17, "div", 12)(18, "div", 13)(19, "div", 14)(20, "mat-form-field", 15)(21, "input", 16);
            i0.ɵɵlistener("ngModelChange", function InventoryComponent_Template_input_ngModelChange_21_listener($event) { return ctx.model.number = $event; });
            i0.ɵɵpipe(22, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(23, "ft-sequence-toggle", 17, 18);
            i0.ɵɵlistener("objectIdChange", function InventoryComponent_Template_ft_sequence_toggle_objectIdChange_23_listener($event) { return ctx.loadedObject = $event; });
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(25, "mat-form-field", 19)(26, "input", 20);
            i0.ɵɵlistener("ngModelChange", function InventoryComponent_Template_input_ngModelChange_26_listener($event) { return ctx.model.date = $event; });
            i0.ɵɵpipe(27, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(28, "mat-datepicker-toggle", 21)(29, "mat-datepicker", null, 22);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(31, "div", 14)(32, "mat-form-field", 23)(33, "input", 24);
            i0.ɵɵlistener("ngModelChange", function InventoryComponent_Template_input_ngModelChange_33_listener($event) { return ctx.model.manager = $event; });
            i0.ɵɵpipe(34, "translate");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(35, "fts-list-select", 25);
            i0.ɵɵlistener("modelChange", function InventoryComponent_Template_fts_list_select_modelChange_35_listener($event) { return ctx.model.store = $event; });
            i0.ɵɵelementEnd()()()();
            i0.ɵɵelementStart(36, "div", 26)(37, "fts-inventory-lines", 27);
            i0.ɵɵlistener("linesChange", function InventoryComponent_Template_fts_inventory_lines_linesChange_37_listener($event) { return ctx.model.lines = $event; });
            i0.ɵɵelementEnd()()()();
            i0.ɵɵelementStart(38, "fts-document-actions", 28);
            i0.ɵɵlistener("modelChange", function InventoryComponent_Template_fts_document_actions_modelChange_38_listener($event) { return ctx.model = $event; })("busyChange", function InventoryComponent_Template_fts_document_actions_busyChange_38_listener($event) { return ctx.loading = $event; });
            i0.ɵɵelementEnd();
        }
        if (rf & 2) {
            const _r1 = i0.ɵɵreference(16);
            const _r2 = i0.ɵɵreference(24);
            const _r3 = i0.ɵɵreference(30);
            i0.ɵɵadvance(6);
            i0.ɵɵtextInterpolate2("", i0.ɵɵpipeBind1(7, 38, "inventory.inventory_form"), " N\u00B0:", ctx.model.number, "");
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("matTooltip", i0.ɵɵpipeBind1(10, 40, "purchase.return_list"));
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngBusy", ctx.loading);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.model.state == null ? null : ctx.model.state.is_valid);
            i0.ɵɵadvance(7);
            i0.ɵɵproperty("ftSequenceInput", "ft_stock.store.StoreInventory")("ftSequenceToggle", _r2)("placeholder", i0.ɵɵpipeBind1(22, 42, "ft_stock.purchase.return_form_number"))("ngModel", ctx.model.number)("disabled", ctx.model == null ? null : ctx.model.state == null ? null : ctx.model.state.is_valid);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("objectId", ctx.loadedObject)("config", i0.ɵɵpureFunction0(48, _c0$6));
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(27, 44, "store.date"))("disabled", ctx.model == null ? null : ctx.model.state == null ? null : ctx.model.state.is_valid)("ngModel", ctx.model.date)("matDatepicker", _r3);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("for", _r3);
            i0.ɵɵadvance(5);
            i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(34, 46, "inventory.manager"))("ngModel", ctx.model.manager);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("required", true)("disabled", ctx.model == null ? null : ctx.model.state == null ? null : ctx.model.state.is_valid)("model", ctx.model.store)("listDialog", ctx.depotDialog)("config", i0.ɵɵpureFunction0(49, _c1$5))("label", "store.depot")("defaultValues", "default_store");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("lines", ctx.model.lines)("defaultDepot", ctx.model.store)("readOnly", ctx.model == null ? null : ctx.model.state == null ? null : ctx.model.state.is_valid);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("model", ctx.model)("cls", ctx.apiUrl)("resource", ctx.resource)("disableValidate", ctx.handleLinesValidation())("formInvalid", _r1.invalid || !(ctx.model == null ? null : ctx.model.store))("busy", ctx.loading)("routes", ctx.routes)("loadedObject", ctx.loadedObject)("movementType", "Inventory");
        }
    }, dependencies: [i4$1.NgIf, i6.MatButton, i6$1.MatCardImage, i7.MatDatepicker, i7.MatDatepickerInput, i7.MatDatepickerToggle, i9.MatIcon, i10.MatFormField, i10.MatSuffix, i11$1.MatInput, i11.MatToolbar, i15$1.MatTooltip, i8.DefaultLayoutDirective, i8.DefaultLayoutGapDirective, i8.DefaultLayoutAlignDirective, i8.DefaultFlexDirective, i16.ɵNgNoValidate, i16.DefaultValueAccessor, i16.NgControlStatus, i16.NgControlStatusGroup, i16.RequiredValidator, i16.NgModel, i16.NgForm, i12.NgBusyDirective, i2.SequenceToggleComponent, i2.DateDirective, i2.InputDirective, i2.SequenceInputDirective, ListSelectComponent, DocumentActionsComponent, InventoryLinesComponent, i3$1.TranslatePipe], styles: ["[_nghost-%COMP%]{height:100%;display:flex;flex-direction:column}"] });
(function () {
    (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(InventoryComponent, [{
            type: Component,
            args: [{ selector: 'fts-inventory', template: "<mat-toolbar color=\"accent\">\n  <div class=\"ft-module-icon\">\n    <button type=\"button\" mat-icon-button>\n      <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-clipboard-arrow-left\"></mat-icon>\n    </button>\n  </div>\n  <h2>\n    <span>{{'inventory.inventory_form'| translate}} N\u00B0:{{model.number}}</span>\n  </h2>\n  <span fxFlex></span>\n  <button type=\"button\" mat-button class=\"with-icon\"  (click)=\"goBack()\" [matTooltip]=\"'purchase.return_list'|translate\">\n    <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-format-list-bulleted\"></mat-icon>\n  </button>\n</mat-toolbar>\n\n<div fxFlex fxLayout=\"column\" class=\"ft-content\">\n   <div [ngBusy]=\"loading\"></div>\n  <div *ngIf=\"model.state?.is_valid\" fxLayoutAlign=\"center center\" class=\"validate-icon\">\n    <img mat-card-image src=\"/assets/lock-outline.svg\" alt=\"validation img\">\n  </div>\n  <form novalidate #Form=\"ngForm\" fxLayout=\"column\" fxFlex  >\n      <div class=\"ft-padding\" fxLayout=\"row\"  >\n        <div fxFlex=\"60\" fxLayout=\"column\">\n            <div fxLayout=\"row\" fxLayoutGap=\"6px\">\n              <mat-form-field fxFlex=\"24\">\n                <input matInput type=\"text\" required\n                       [ftSequenceInput]=\"'ft_stock.store.StoreInventory'\"\n                       [ftSequenceToggle]=\"toggle\"\n                       name=\"sequence\"\n                       [placeholder]=\"'ft_stock.purchase.return_form_number'|translate\"\n                       [(ngModel)]=\"model.number\"\n\n                       [disabled]=\"model?.state?.is_valid\"/>\n                <ft-sequence-toggle matSuffix #toggle  [(objectId)]=\"loadedObject\"\n                                    [config]=\"{cls: 'ft_stock.store.StoreInventory', field: 'number'}\">\n                </ft-sequence-toggle>\n              </mat-form-field>\n              <mat-form-field fxFlex=\"25\">\n                <input matInput ftDate [placeholder]=\"'store.date'|translate\" name=\"date\" [disabled]=\"model?.state?.is_valid\"\n                       [(ngModel)]=\"model.date\" [matDatepicker]=\"picker\">\n                <mat-datepicker-toggle matSuffix [for]=\"picker\"></mat-datepicker-toggle>\n                <mat-datepicker #picker></mat-datepicker>\n              </mat-form-field>\n           </div>\n            <div fxLayout=\"row\"  fxLayoutGap=\"6px\">\n              <mat-form-field fxFlex=\"30\" >\n                <input matInput [placeholder]=\"'inventory.manager'|translate\" required\n                       name=\"manager\"  [(ngModel)]=\"model.manager\" >\n              </mat-form-field>\n              <fts-list-select fxFlex=\"30\"\n                               [required]=\"true\"\n                               [disabled]=\"model?.state?.is_valid\"\n                               [(model)]=\"model.store\"\n                               [listDialog]=\"depotDialog\"\n                               [config]=\"{key: 'name', url: 'api/store/depot', cls:'store/depot', customValidator:'depot.check_uniqueness'}\"\n                               [label]=\"'store.depot'\"  [defaultValues]=\"'default_store'\"\n                                >\n              </fts-list-select>\n            </div>\n        </div>\n      </div>\n      <div fxLayout=\"column\" fxFlex>\n          <fts-inventory-lines  fxFlex [(lines)]=\"model.lines\" [defaultDepot]=\"model.store\"  [readOnly]=\"model?.state?.is_valid\"></fts-inventory-lines>\n      </div>\n  </form>\n</div>\n<fts-document-actions fxFlex=\"nogrow\" [(model)]=\"model\" [cls]=\"apiUrl\" [resource]=\"resource\" [disableValidate]=\"handleLinesValidation()\"\n                      [formInvalid]=\"Form.invalid || !model?.store\"  [(busy)]=\"loading\"\n                      [routes]=\"routes\" [loadedObject]=\"loadedObject\" [movementType]=\"'Inventory'\"></fts-document-actions>\n", styles: [":host{height:100%;display:flex;flex-direction:column}\n"] }]
        }], function () { return [{ type: SharedModulesService }, { type: i3.Router }, { type: i3.ActivatedRoute }, { type: SharedService }]; }, null);
})();

function pivotTabs(component) {
    return function () {
        const labels = this.Labels;
        return [
            {
                title: labels.export_print,
                id: "wdr-tab-export-print",
                mobile: false,
                rightGroup: true,
                icon: "<md-icon class=\"mdi mdi-printer\"></md-icon>",
                handler: () => {
                    if (!component.emptyData)
                        this.printHandler();
                }
            },
            {
                title: labels.export,
                id: "wdr-tab-export",
                mobile: false,
                rightGroup: true,
                icon: "<md-icon class=\"mdi mdi-database-export\"></md-icon>",
                menu: [
                    {
                        title: labels.export_excel,
                        id: "wdr-tab-export-excel",
                        handler: type => {
                            if (!component.emptyData)
                                component.exportHandler(type);
                        },
                        args: "excel",
                        icon: "<md-icon class=\"mdi mdi-file-excel-outline\"></md-icon>"
                    },
                    {
                        title: labels.export_pdf,
                        id: "wdr-tab-export-pdf",
                        handler: type => {
                            if (!component.emptyData)
                                component.exportHandler(type);
                        },
                        args: "pdf",
                        icon: "<md-icon class=\"mdi mdi-file-pdf-outline\"></md-icon>"
                    },
                ]
            },
            {
                title: labels.format,
                id: "wdr-tab-format",
                icon: "<md-icon class=\"mdi mdi-table-edit\"></md-icon>",
                rightGroup: true,
                menu: [
                    {
                        title: this.osUtils.isMobile ? labels.format_cells_mobile : labels.format_cells,
                        id: "wdr-tab-format-cells",
                        handler: () => {
                            if (!component.emptyData)
                                this.formatCellsHandler();
                        },
                        icon: "<md-icon class=\"mdi mdi-format-letter-matches\"></md-icon>"
                    },
                    {
                        title: this.osUtils.isMobile ? labels.conditional_formatting_mobile : labels.conditional_formatting,
                        id: "wdr-tab-format-conditional",
                        handler: () => {
                            if (!component.emptyData)
                                this.conditionalFormattingHandler();
                        },
                        icon: "<md-icon class=\"mdi mdi-format-color-highlight\"></md-icon>"
                    }
                ]
            },
            {
                title: labels.fields,
                id: "wdr-tab-fields",
                handler: () => {
                    if (!component.emptyData)
                        this.fieldsHandler();
                },
                icon: "<md-icon class=\"mdi mdi-table-settings\"></md-icon>",
                rightGroup: true
            },
            {
                title: labels.options,
                id: "wdr-tab-options",
                handler: () => {
                    if (!component.emptyData)
                        this.optionsHandler();
                },
                icon: "<md-icon class=\"mdi mdi-cog\"></md-icon>",
                rightGroup: true
            }
        ];
    };
}

const LOCALIZATION = {
    "fieldsList": {
        "flatHierarchyBox": "Sélectionner et Organiser les colonnes",
        "hierarchyBox": "Glisser Les Dimensions",
        "filterBox": "Glisser & Organiser Des Filtres De Rapport",
        "rowBox": "Glisser & Trier Les Lignes",
        "columnBox": "Glisser & Organiser Les Colonnes",
        "measureBox": "Glisser & Organiser Les Valeurs",
        "values": "Valeurs",
        "addCalculatedMeasure": "Ajouter une valeur calculée",
        "expandAll": "Développez Tous",
        "collapseAll": "Grouper toutes Les",
        "formulasGroupName": "Les Valeurs Calculées",
        "allFields": "Tous Les Champs",
        "rows": "Les lignes",
        "columns": "Les colonnes",
        "filters": "Des Filtres De Rapport",
        "dropField": "Baisse de domaine ici",
        "title": "Champs",
        "subtitle": "Faites glisser et déposez des champs d'organiser"
    },
    "filter": {
        "all": "Tous",
        "multipleItems": "Plusieurs Éléments",
        "selectAll": "Sélectionnez tous ",
        "selectAllResults": "Sélectionnez tous Les Résultats",
        "top": "Top",
        "bottom": "Bas",
        "ascSort": "Az",
        "descSort": "zA",
        "topX": "Top 10",
        "clearTopX": "Vider",
        "measuresPrompt": "Choisissez la valeur",
        "search": "Recherche",
        "amountSelected": "{0} {1} sélectionnés",
        "amountFound": "{0} {1} sont sélectionnés",
        "sort": "Tri:",
        "addGroup": "Ajouter un groupe",
        "groupName": "Groupe 1",
        "ungroup": "Dissocier"
    },
    "drillThrough": {
        "title": "Détails",
        "row": "Ligne: <b>{0}<\/b>",
        "column": "Colonne: <b>{0}<\/b>",
        "value": "{0}: <b>{1}<\/b>"
    },
    "calculatedView": {
        "title": "Valeur Calculée",
        "measureBox": "Faites glisser les valeurs à la formule",
        "measureName": "Nom de la valeur",
        "formula": "Formule",
        "formulaPrompt": "Glissez des valeurs et modifier la formule ici",
        "calculateIndividualValues": "Calculer les valeurs individuelles",
        "removeValue": "Supprimer",
        "removeValueTitle": "Supprimer {0}?",
        "removeValueMessage": "Êtes-vous sûr de vouloir supprimer cette valeur calculée?",
        "header": "Ajouter de la valeur calculée",
        "allValues": "Toutes les valeurs"
    },
    "grid": {
        "total": "Sous total",
        "totals": "Les totaux",
        "grandTotal": "Total",
        "blankMember": " ",
        "dateInvalidCaption": "Date non valide",
        "reportInformation": "Rapport D'Information"
    },
    "tooltips": {
        "row": "Ligne:",
        "column": "Colonne:",
        "headerResize": "Faites glisser pour redimensionner",
        "headerFit": "Double-cliquez pour l'ajustement",
        "filterIcon": "Cliquez pour filtrer",
        "filtered": "Filtré",
        "expandIcon": "Cliquer pour agrandir",
        "collapseIcon": "Cliquez sur l'effondrement",
        "drillDown": "Cliquez pour forer vers le bas",
        "drillUp": "Cliquez sur explorer",
        "sortIcon": "Cliquez pour trier Desc",
        "sortedDescIcon": "Cliquez pour trier Asc",
        "sortedAscIcon": "Cliquez pour trier Desc",
        "close": "Cliquez pour fermer"
    },
    "aggregations": {
        "sum": {
            "caption": "Somme",
            "totalCaption": "Somme de {0}",
            "grandTotalCaption": "Somme de {0}"
        },
        "count": {
            "caption": "Compte",
            "totalCaption": "Le comte de {0}",
            "grandTotalCaption": "Nombre Total de {0}"
        },
        "distinctCount": {
            "caption": "Compte distint",
            "totalCaption": "Nombre Distinct de {0}",
            "grandTotalCaption": "Total nombre Distinct de {0}"
        },
        "difference": {
            "caption": "Différence",
            "totalCaption": "Différence de {0}",
            "grandTotalCaption": "Différence de {0}"
        },
        "percentDifference": {
            "caption": "% De différence",
            "totalCaption": "% De différence de {0}",
            "grandTotalCaption": "% De différence de {0}"
        },
        "average": {
            "caption": "Moyenne",
            "totalCaption": "Moyenne de {0}",
            "grandTotalCaption": "Moyenne totale de {0}"
        },
        "product": {
            "caption": "Produit",
            "totalCaption": "Produit de {0}",
            "grandTotalCaption": "Total du Produit de {0}"
        },
        "min": {
            "caption": "Min",
            "totalCaption": "Min de {0}",
            "grandTotalCaption": "Total Min de {0}"
        },
        "max": {
            "caption": "Max",
            "totalCaption": "Max de {0}",
            "grandTotalCaption": "Total Max de {0}"
        },
        "percent": {
            "caption": "% du Grand Total",
            "totalCaption": "% du Grand Total de {0}",
            "grandTotalCaption": "Total en % du Total de {0}"
        },
        "percentOfColumn": {
            "caption": "% de Colonne",
            "totalCaption": "% de la Colonne de {0}",
            "grandTotalCaption": "Total % de la Colonne de {0}"
        },
        "percentOfRow": {
            "caption": "% de la Ligne",
            "totalCaption": "% de la Ligne de {0}",
            "grandTotalCaption": "Total % de la Ligne de {0}"
        },
        "index": {
            "caption": "Index",
            "totalCaption": "Indice de {0}",
            "grandTotalCaption": "Indice de {0}"
        },
        "none": {
            "caption": "Aucun Calcul"
        }
    },
    "messages": {
        "error": "Erreur!",
        "warning": "Avertissement!",
        "limitation": "Limitation!",
        "browse": "Parcourir",
        "confirmation": "Confirmation",
        "reportFileType": "Flexmonster fichier de rapport",
        "loading": "Chargement...",
        "loadingConfiguration": "",
        "loadingData": "Chargement des données...",
        "waiting": "L'attente de la réponse {0} secondes.",
        "progress": "{0}K",
        "progressUnknown": "chargé {0}K",
        "analyzing": "L'analyse des données...",
        "analyzingProgress": "{0} registres de {1} ({2}%)",
        "analyzingRecords": "{0}% des dossiers",
        "saving": "Enregistrement...",
        "loadingDimensions": "Chargement dimensions...",
        "loadingHierarchies": "Chargement des hiérarchies...",
        "loadingMeasures": "Chargement de mesures...",
        "loadingKPIs": "Chargement Des Kpi...",
        "loadingMembers": "Chargement de membres...",
        "loadingLevels": "Niveaux de chargement...",
        "loadingProperties": "Chargement des propriétés...",
        "fullscreen": "Ouvrir le rapport en plein écran?",
        "exportComplete": "L'exportation de données est créé, veuillez cliquer sur le bouton \"Enregistrer\" pour enregistrer le _data.",
        "exportProgress": "Exportation en cours...",
        "exportError": "Échec à l'exportation. Une erreur inattendue s'est produite.",
        "generatingPDF": "Génération de PDF",
        "pleaseWait": "Veuillez patienter.",
        "pagesWereGenerated": "les pages ont été générés.",
        "uploading": "Le téléchargement de...",
        "cantSaveFile": "Ne peut pas enregistrer le fichier.",
        "cantSaveToClipboard": "Erreur: Impossible d'écrire dans le presse-papiers.",
        "saveReportToFile": "Le rapport est prêt à être enregistrées dans un fichier, veuillez cliquer sur le bouton \"Enregistrer\" pour enregistrer le rapport.",
        "loadReportFromFile": "Sélectionnez fichier de rapport pour être chargé.",
        "inputNewName": "Entrer le nouveau nom",
        "inputReportName": "Entrez le nom de rapport",
        "invalidDataSource": "Invalide de la source de données ou un catalogue. Veuillez vérifier. <br\/><br\/><u><a href='https:\/\/www.flexmonster.com\/doc\/typical-errors\/#invalid-datasource' target='_blank'>Lire plus d'info sur cette erreur<\/a><\/u>",
        "dataStreamError": "Stream erreur s'est produite lors du chargement '{0}'<br\/><br\/><u><a href='https:\/\/www.flexmonster.com\/doc\/typical-errors\/#stream-error' target='_blank'>Lire plus d'info sur cette erreur<\/a><\/u>",
        "unableToOpenFile": "Impossible d'ouvrir le fichier {0}.<br\/><br\/>Il semble que ce fichier n'existe pas ou \"Access-Control-Allow-Origin' en-tête est absente de la ressource demandée.<br\/><br\/><u><a href='https:\/\/www.flexmonster.com\/doc\/typical-errors\/#unable-to-open-file' target='_blank'>Lire plus d'info sur cette erreur<\/a><\/u>",
        "unableTwoFileBrowsingSessions": "Parcourir de la boîte de dialogue de fichier est déjà ouvert.",
        "inappropriateFileFormat": "Le fichier de données est inappropriée de format.",
        "invalidJSONdata": "Les données JSON n'est pas valide.",
        "wrongFormulaFormat": "La mauvaise formule de format. Veuillez vérifier.",
        "excelCsvChartsExportError": "Exportation vers Microsoft Excel ou CSV n'est pas disponible pour les graphiques.",
        "excelPdfExportLimitation": "Exportation vers Microsoft Excel ou PDF n'est pas disponible dans l'édition actuelle.",
        "excelExportLimitation": "L'exportation n'est pas disponible dans l'édition actuelle.",
        "noDataAvailable": "Source de données est vide. Veuillez vérifier le fichier CSV.",
        "saveDataToFile": "Les données sont prêtes à être enregistrées dans un fichier, veuillez cliquer sur le bouton \"Enregistrer\" pour enregistrer le fichier.",
        "dataWasUpdated": "Source de données a été mis à jour sur le serveur. Actualiser le rapport?",
        "ocsvIncompatible": "Impossible de lire les données de la source. Il semble que OCSV fichier a été compressé avec une version plus récente. Veuillez mettre à jour le composant à la version {0} ou plus récent.",
        "unknownError": "Erreur inconnue s'est produite.",
        "invalidReportFormat": "Invalide format de rapport ou de l'accès au dossier est refusé.",
        "csvHeaderParsingError": "CSV-tête de l'erreur d'analyse.",
        "tooManyColumnsInClassicMode": "Trop de colonnes de forme classique. Commutation de la maquette à la forme compacte.",
        "cantExpand": "Certains champs ne peuvent pas être élargi. Veuillez affiner l'ensemble de données.",
        "cantExpandTitle": "Ensemble de données est trop grande"
    },
    "buttons": {
        "ok": "OK",
        "apply": "Appliquer",
        "cancel": "Annuler",
        "save": "Enregistrer",
        "clear": "Vider",
        "select": "Sélectionnez",
        "yes": "Oui",
        "no": "Pas de"
    },
    "contextMenu": {
        "clearSorting": "Annuler le tri",
        "collapse": "L'effondrement",
        "drillThrough": "Percer",
        "expand": "Développez",
        "openFilter": "Ouvrir filtre",
        "sortColumnAsc": "Colonne de tri asc",
        "sortColumnDesc": "Colonne de tri desc",
        "sortRowAsc": "Ligne de tri asc",
        "sortRowDesc": "Ligne de tri desc"
    },
    "date": {
        "year": "Année",
        "quarter": "Trimestre",
        "month": "Mois",
        "day": "Jour"
    },
    "quarters": {
        "q1": "Trimestre 1",
        "q2": "Trimestre 2",
        "q3": "Trimestre 3",
        "q4": "Trimestre 4"
    },
    "months": {
        "january": "Janvier",
        "february": "Février",
        "march": "Mars",
        "april": "Avril",
        "may": "Mai",
        "june": "Juin",
        "july": "Juillet",
        "august": "Août",
        "september": "Septembre",
        "october": "Octobre",
        "november": "Novembre",
        "december": "Décembre"
    },
    "monthsShort": {
        "january": "Jan",
        "february": "Fév",
        "march": "Mar",
        "april": "Avr",
        "may": "Mai",
        "june": "Jun",
        "july": "Jul",
        "august": "Aoû",
        "september": "Sep",
        "october": "Oct",
        "november": "Nov",
        "december": "Dec"
    },
    "weekdays": {
        "first": "Dimanche",
        "second": "Lundi",
        "third": "Mardi",
        "fourth": "Mercredi",
        "fifth": "Jeudi",
        "sixth": "Vendredi",
        "seventh": "Samedi"
    },
    "weekdaysShort": {
        "first": "Dim",
        "second": "Lun",
        "third": "Mar",
        "fourth": "Mer",
        "fifth": "Jeu",
        "sixth": "Ven",
        "seventh": "Sam"
    },
    "toolbar": {
        "connect": "Connecter",
        "connect_local_csv": "CSV local",
        "connect_local_ocsv": "Local OCSV",
        "connect_local_json": "JSON local",
        "connect_remote_csv": "CSV externe",
        "connect_remote_csv_mobile": "CSV",
        "connect_remote_json": "JSON externe",
        "connect_remote_json_mobile": "JSON",
        "open": "Ouvrir",
        "local_report": "Rapport Local",
        "remote_report": "Rapport à distance",
        "remote_report_mobile": "Rapport",
        "save": "Enregistrer",
        "save_json": "Enregister JSON",
        "load_json": "Charger JSON",
        "grid": "Grille",
        "grid_flat": "Plat",
        "grid_classic": "Classique",
        "grid_compact": "Compact",
        "format": "Format",
        "format_cells": "Format de cellule",
        "format_cells_mobile": "Format",
        "conditional_formatting": "La mise en forme conditionnelle",
        "conditional_formatting_mobile": "Conditionnel",
        "options": "Options",
        "fullscreen": "Plein écran",
        "minimize": "Minimiser",
        "export": "Exporter",
        "export_print": "Imprimer",
        "export_html": "HTML",
        "export_excel": "Pour Excel",
        "export_pdf": "PDF",
        "fields": "Champs",
        "ok": "OK",
        "apply": "Appliquer",
        "done": "Fait",
        "cancel": "Annuler",
        "value": "Valeur",
        "delete": "Supprimer",
        "if": "Si",
        "then": "Alors",
        "open_remote_csv": "Ouverte CSV à distance",
        "open_remote_json": "Ouvrir JSON à distance",
        "csv": "CSV",
        "open_remote_report": "Ouverir un rapports à distance",
        "choose_value": "Choisissez la valeur",
        "text_align": "Aligner texte",
        "align_left": "de gauche",
        "align_right": "droit",
        "none": "Aucun",
        "space": "(Espace)",
        "thousand_separator": "Séparateur de milliers",
        "decimal_separator": "Séparateur décimal",
        "decimal_places": "Décimales",
        "currency_symbol": "Symbole de devise",
        "currency_align": "Aligner symbole",
        "null_value": "Valeur Null",
        "is_percent": "Format pour cent",
        "true_value": "vrai",
        "false_value": "faux",
        "conditional": "Conditionnel",
        "add_condition": "Ajouter une condition",
        "less_than": "Moins de",
        "less_than_or_equal": "Inférieure ou égale à",
        "greater_than": "Plus de",
        "greater_than_or_equal": "Supérieure ou égale à",
        "equal_to": "Égal à",
        "not_equal_to": "Pas égal à",
        "between": "Entre",
        "is_empty": "Vide",
        "all_values": "Toutes les valeurs",
        "and": "et",
        "and_symbole": "&",
        "cp_text": "Texte",
        "cp_highlight": "Mettre en évidence",
        "layout_options": "Options de mise en page",
        "layout": "Mise en page",
        "compact_view": "Forme compacte",
        "classic_view": "Forme classique",
        "flat_view": "Forme plate",
        "grand_totals": "Les totaux généraux",
        "grand_totals_off": "Ne pas afficher les totaux généraux",
        "grand_totals_on": "Afficher les totaux généraux",
        "grand_totals_on_rows": "Afficher uniquement pour les lignes",
        "grand_totals_on_columns": "Afficher pour les colonnes uniquement",
        "subtotals": "Les sous-totaux",
        "subtotals_off": "Ne pas afficher les sous-totaux",
        "subtotals_on": "Afficher les sous-totaux",
        "subtotals_on_rows": "Afficher les lignes de sous-total seulement",
        "subtotals_on_columns": "Afficher les sous-total des colonnes seulement",
        "choose_page_orientation": "Choisissez l'orientation de la page",
        "landscape": "Paysage",
        "portrait": "Portrait"
    },
    "_id": "ID"
};

class WebDataRocksPivot {
    constructor(el) {
        // events
        this.cellclick = new EventEmitter();
        this.celldoubleclick = new EventEmitter();
        this.dataerror = new EventEmitter();
        this.datafilecancelled = new EventEmitter();
        this.dataloaded = new EventEmitter();
        this.datachanged = new EventEmitter();
        this.fieldslistclose = new EventEmitter();
        this.fieldslistopen = new EventEmitter();
        this.filteropen = new EventEmitter();
        this.fullscreen = new EventEmitter();
        this.loadingdata = new EventEmitter();
        this.loadinglocalization = new EventEmitter();
        this.loadingreportfile = new EventEmitter();
        this.localizationerror = new EventEmitter();
        this.localizationloaded = new EventEmitter();
        this.openingreportfile = new EventEmitter();
        this.querycomplete = new EventEmitter();
        this.queryerror = new EventEmitter();
        this.ready = new EventEmitter();
        this.reportchange = new EventEmitter();
        this.reportcomplete = new EventEmitter();
        this.reportfilecancelled = new EventEmitter();
        this.reportfileerror = new EventEmitter();
        this.reportfileloaded = new EventEmitter();
        this.runningquery = new EventEmitter();
        this.update = new EventEmitter();
        this.beforetoolbarcreated = new EventEmitter();
        this.aftergriddraw = new EventEmitter();
        this.beforegriddraw = new EventEmitter();
        this.root = el.nativeElement;
    }
    ngOnInit() {
        this.webDataRocks = new WebDataRocks({
            container: this.root.getElementsByClassName("wbr-ng-wrapper")[0],
            width: this.width,
            height: this.height,
            toolbar: this.toolbar,
            report: this.report,
            global: this.global,
            customizeCell: this.customizeCell,
            cellclick: (cell) => this.cellclick.next(cell),
            celldoubleclick: (cell) => this.celldoubleclick.next(cell),
            dataerror: (event) => this.dataerror.next(event),
            datafilecancelled: () => this.datafilecancelled.next(null),
            dataloaded: () => this.dataloaded.next(null),
            datachanged: (event) => this.datachanged.next(event),
            fieldslistclose: () => this.fieldslistclose.next(null),
            fieldslistopen: () => this.fieldslistopen.next(null),
            filteropen: () => this.filteropen.next(null),
            loadingdata: () => this.loadingdata.next(null),
            loadinglocalization: () => this.loadinglocalization.next(null),
            loadingreportfile: () => this.loadingreportfile.next(null),
            localizationerror: () => this.localizationerror.next(null),
            localizationloaded: () => this.localizationloaded.next(null),
            openingreportfile: () => this.openingreportfile.next(null),
            querycomplete: () => this.querycomplete.next(null),
            queryerror: () => this.queryerror.next(null),
            ready: () => this.ready.next(this.webDataRocks),
            reportchange: () => this.reportchange.next(null),
            reportcomplete: () => this.reportcomplete.next(null),
            reportfilecancelled: () => this.reportfilecancelled.next(null),
            reportfileerror: () => this.reportfileerror.next(null),
            reportfileloaded: () => this.reportfileloaded.next(null),
            runningquery: () => this.runningquery.next(null),
            update: () => this.update.next(null),
            beforetoolbarcreated: (toolbar) => this.beforetoolbarcreated.next(toolbar),
            aftergriddraw: (event) => this.aftergriddraw.next(event),
            beforegriddraw: (event) => this.beforegriddraw.next(event)
        });
    }
}
WebDataRocksPivot.ɵfac = function WebDataRocksPivot_Factory(t) { return new (t || WebDataRocksPivot)(i0.ɵɵdirectiveInject(i0.ElementRef)); };
WebDataRocksPivot.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: WebDataRocksPivot, selectors: [["wbr-pivot"]], inputs: { toolbar: "toolbar", width: "width", height: "height", report: "report", global: "global", customizeCell: "customizeCell" }, outputs: { cellclick: "cellclick", celldoubleclick: "celldoubleclick", dataerror: "dataerror", datafilecancelled: "datafilecancelled", dataloaded: "dataloaded", datachanged: "datachanged", fieldslistclose: "fieldslistclose", fieldslistopen: "fieldslistopen", filteropen: "filteropen", fullscreen: "fullscreen", loadingdata: "loadingdata", loadinglocalization: "loadinglocalization", loadingreportfile: "loadingreportfile", localizationerror: "localizationerror", localizationloaded: "localizationloaded", openingreportfile: "openingreportfile", querycomplete: "querycomplete", queryerror: "queryerror", ready: "ready", reportchange: "reportchange", reportcomplete: "reportcomplete", reportfilecancelled: "reportfilecancelled", reportfileerror: "reportfileerror", reportfileloaded: "reportfileloaded", runningquery: "runningquery", update: "update", beforetoolbarcreated: "beforetoolbarcreated", aftergriddraw: "aftergriddraw", beforegriddraw: "beforegriddraw" }, decls: 2, vars: 0, consts: [[1, "wbr-ng-wrapper"]], template: function WebDataRocksPivot_Template(rf, ctx) {
        if (rf & 1) {
            i0.ɵɵelementStart(0, "div");
            i0.ɵɵelement(1, "div", 0);
            i0.ɵɵelementEnd();
        }
    }, encapsulation: 2 });
(function () {
    (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WebDataRocksPivot, [{
            type: Component,
            args: [{
                    selector: "wbr-pivot",
                    template: "<div><div class='wbr-ng-wrapper'></div></div>"
                }]
        }], function () { return [{ type: i0.ElementRef }]; }, { toolbar: [{
                type: Input
            }], width: [{
                type: Input
            }], height: [{
                type: Input
            }], report: [{
                type: Input
            }], global: [{
                type: Input
            }], customizeCell: [{
                type: Input
            }], cellclick: [{
                type: Output
            }], celldoubleclick: [{
                type: Output
            }], dataerror: [{
                type: Output
            }], datafilecancelled: [{
                type: Output
            }], dataloaded: [{
                type: Output
            }], datachanged: [{
                type: Output
            }], fieldslistclose: [{
                type: Output
            }], fieldslistopen: [{
                type: Output
            }], filteropen: [{
                type: Output
            }], fullscreen: [{
                type: Output
            }], loadingdata: [{
                type: Output
            }], loadinglocalization: [{
                type: Output
            }], loadingreportfile: [{
                type: Output
            }], localizationerror: [{
                type: Output
            }], localizationloaded: [{
                type: Output
            }], openingreportfile: [{
                type: Output
            }], querycomplete: [{
                type: Output
            }], queryerror: [{
                type: Output
            }], ready: [{
                type: Output
            }], reportchange: [{
                type: Output
            }], reportcomplete: [{
                type: Output
            }], reportfilecancelled: [{
                type: Output
            }], reportfileerror: [{
                type: Output
            }], reportfileloaded: [{
                type: Output
            }], runningquery: [{
                type: Output
            }], update: [{
                type: Output
            }], beforetoolbarcreated: [{
                type: Output
            }], aftergriddraw: [{
                type: Output
            }], beforegriddraw: [{
                type: Output
            }] });
})();

const _c0$5 = ["pivot"];
const _c1$4 = function () { return { key: "name", url: "api/store/depot", cls: "store/depot" }; };
class ArticleHistoricComponent {
    constructor(inventoryService, translateService) {
        this.inventoryService = inventoryService;
        this.translateService = translateService;
        this.articleInputSettings = assignIn(cloneDeep(ARTICLE_VIEW), { selectable: false });
        this.providerInputSettings = assignIn(cloneDeep(PROVIDER_VIEW), { selectable: false });
        this.provider = null;
        this.article = null;
        this.store = null;
        this.query = { from: moment(), to: moment() };
        this.headers = {
            _id: {
                type: "number",
                caption: this.translateService.instant('shared.id')
            },
            date: {
                "type": "string",
                caption: this.translateService.instant('shared.date')
            },
            doc_number: {
                "type": "string",
                caption: this.translateService.instant('shared.doc_number')
            },
            mvt_source: {
                "type": "string",
                caption: this.translateService.instant('shared.source')
            },
            type: {
                "type": "string",
                caption: this.translateService.instant('shared.type')
            },
            patient: {
                "type": "string",
                caption: this.translateService.instant('shared.patient')
            },
            price: {
                "type": "number",
                caption: this.translateService.instant('shared.price')
            },
            provider: {
                "type": "string",
                caption: this.translateService.instant('shared.provider')
            },
            qte: {
                "type": "number",
                caption: this.translateService.instant('shared.qte')
            }
        };
        this.data = [];
        this.config = {
            dataSource: {
                'dataSourceType': 'json',
                'data': concat(this.headers, this.data),
            },
            localization: LOCALIZATION,
            "slice": {
                "rows": [
                    {
                        "uniqueName": "date"
                    },
                    {
                        "uniqueName": "doc_number"
                    },
                    {
                        "uniqueName": "mvt_source"
                    },
                    {
                        "uniqueName": "type"
                    },
                    {
                        "uniqueName": "patient"
                    },
                    {
                        "uniqueName": "price"
                    },
                    {
                        "uniqueName": "provider"
                    },
                    {
                        "uniqueName": "qte"
                    }
                ],
                "columns": [
                    {
                        "uniqueName": "Measures"
                    }
                ],
                "flatOrder": [
                    "date",
                    "doc_number",
                    "mvt_source",
                    "type",
                    "patient",
                    "price",
                    "provider",
                    "qte"
                ]
            },
            "options": {
                "grid": {
                    "type": "flat",
                    "showTotals": "off",
                    "showGrandTotals": "off"
                }
            }
        };
    }
    onPivotReady(pivot) {
        console.log("[ready] WebDataRocksPivot", this.child);
    }
    onCustomizeCell(cell, data) {
        if (data.isClassicTotalRow)
            cell.addClass("fm-total-classic-r");
        if (data.isGrandTotalRow)
            cell.addClass("fm-grand-total-r");
        if (data.isGrandTotalColumn)
            cell.addClass("fm-grand-total-c");
    }
    onReportComplete() {
        this.child.webDataRocks.off("reportcomplete");
        this.child.webDataRocks.setReport(this.config);
    }
    onToolbarCreated(toolbar) {
        toolbar.getTabs = pivotTabs(this);
    }
    ngOnInit() {
        this.loadData();
    }
    loadData() {
        this.inventoryService.getArticleHistoric(assign(this.query, { provider: get(this.provider, 'id') }, { article: get(this.article, 'id') }, { store: get(this.store, 'id') })).subscribe(data => {
            this.data = data;
            this.child.webDataRocks.setReport(assign(this.config, {
                dataSource: {
                    data: concat(this.headers, this.data)
                }
            }));
        });
    }
    handleQuery(ev) {
        this.loadData();
    }
    exportHandler(fileType) {
        this.child.webDataRocks.exportTo(fileType, { filename: `historic_article_${get(this.article, 'code', '')}_${get(this.store, 'name', '')}` }, noop);
    }
}
ArticleHistoricComponent.ɵfac = function ArticleHistoricComponent_Factory(t) { return new (t || ArticleHistoricComponent)(i0.ɵɵdirectiveInject(InventoryService), i0.ɵɵdirectiveInject(i3$1.TranslateService)); };
ArticleHistoricComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ArticleHistoricComponent, selectors: [["fts-article-historic"]], viewQuery: function ArticleHistoricComponent_Query(rf, ctx) {
        if (rf & 1) {
            i0.ɵɵviewQuery(_c0$5, 5);
        }
        if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.child = _t.first);
        }
    }, decls: 35, vars: 42, consts: [["color", "accent"], [1, "ft-module-icon"], ["type", "button", "mat-icon-button", ""], ["fontSet", "mdi", "fontIcon", "mdi-format-align-middle"], ["fxFlex", ""], ["fxFlex", "", "fxLayout", "column", 1, "ft-content"], [3, "ngBusy"], ["fxLayout", "row", "fxLayoutGap", "6px", 1, "ft-padding"], [3, "label", "model", "value", "settings", "modelChange"], ["matInput", "", "ftDate", "", "name", "start_date", "required", "", 3, "placeholder", "max", "disabled", "ngModel", "matDatepicker", "ngModelChange"], ["matSuffix", "", 3, "for"], ["picker3", ""], ["matInput", "", "ftDate", "", "name", "dead_line", "required", "", 3, "placeholder", "min", "disabled", "ngModel", "matDatepicker", "ngModelChange"], ["picker2", ""], [3, "model", "config", "label", "defaultValues", "modelChange"], ["fxLayout", "row", 1, "ft-padding"], ["name", "last_inv_date", "color", "primary", 3, "ngModel", "ngModelChange"], [3, "innerHTML"], ["fxFlex", "", "fxLayout", "column"], [1, "ft-wdr-container", 3, "toolbar", "width", "height", "report", "customizeCell", "ready", "reportcomplete", "beforetoolbarcreated"], ["pivot", ""]], template: function ArticleHistoricComponent_Template(rf, ctx) {
        if (rf & 1) {
            i0.ɵɵelementStart(0, "mat-toolbar", 0)(1, "div", 1)(2, "button", 2);
            i0.ɵɵelement(3, "mat-icon", 3);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(4, "h2")(5, "span");
            i0.ɵɵtext(6);
            i0.ɵɵpipe(7, "translate");
            i0.ɵɵelementEnd()();
            i0.ɵɵelement(8, "span", 4);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(9, "div", 5);
            i0.ɵɵelement(10, "div", 6);
            i0.ɵɵelementStart(11, "div", 7)(12, "fts-document-select", 8);
            i0.ɵɵlistener("modelChange", function ArticleHistoricComponent_Template_fts_document_select_modelChange_12_listener($event) { return ctx.article = $event; })("modelChange", function ArticleHistoricComponent_Template_fts_document_select_modelChange_12_listener($event) { return ctx.handleQuery($event); });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(13, "mat-form-field")(14, "input", 9);
            i0.ɵɵlistener("ngModelChange", function ArticleHistoricComponent_Template_input_ngModelChange_14_listener($event) { return ctx.query.from = $event; })("ngModelChange", function ArticleHistoricComponent_Template_input_ngModelChange_14_listener($event) { return ctx.handleQuery($event); });
            i0.ɵɵpipe(15, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(16, "mat-datepicker-toggle", 10)(17, "mat-datepicker", null, 11);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(19, "mat-form-field")(20, "input", 12);
            i0.ɵɵlistener("ngModelChange", function ArticleHistoricComponent_Template_input_ngModelChange_20_listener($event) { return ctx.query.to = $event; })("ngModelChange", function ArticleHistoricComponent_Template_input_ngModelChange_20_listener($event) { return ctx.handleQuery($event); });
            i0.ɵɵpipe(21, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(22, "mat-datepicker-toggle", 10)(23, "mat-datepicker", null, 13);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(25, "div", 7)(26, "fts-list-select", 14);
            i0.ɵɵlistener("modelChange", function ArticleHistoricComponent_Template_fts_list_select_modelChange_26_listener($event) { return ctx.store = $event; })("modelChange", function ArticleHistoricComponent_Template_fts_list_select_modelChange_26_listener($event) { return ctx.handleQuery($event); });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(27, "fts-document-select", 8);
            i0.ɵɵlistener("modelChange", function ArticleHistoricComponent_Template_fts_document_select_modelChange_27_listener($event) { return ctx.provider = $event; })("modelChange", function ArticleHistoricComponent_Template_fts_document_select_modelChange_27_listener($event) { return ctx.handleQuery($event); });
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(28, "div", 15)(29, "mat-slide-toggle", 16);
            i0.ɵɵlistener("ngModelChange", function ArticleHistoricComponent_Template_mat_slide_toggle_ngModelChange_29_listener($event) { return ctx.query.last_inventory_date = $event; })("ngModelChange", function ArticleHistoricComponent_Template_mat_slide_toggle_ngModelChange_29_listener($event) { return ctx.handleQuery($event); });
            i0.ɵɵelement(30, "span", 17);
            i0.ɵɵpipe(31, "translate");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(32, "div", 18)(33, "wbr-pivot", 19, 20);
            i0.ɵɵlistener("ready", function ArticleHistoricComponent_Template_wbr_pivot_ready_33_listener($event) { return ctx.onPivotReady($event); })("reportcomplete", function ArticleHistoricComponent_Template_wbr_pivot_reportcomplete_33_listener() { return ctx.onReportComplete(); })("beforetoolbarcreated", function ArticleHistoricComponent_Template_wbr_pivot_beforetoolbarcreated_33_listener($event) { return ctx.onToolbarCreated($event); });
            i0.ɵɵelementEnd()()();
        }
        if (rf & 2) {
            const _r0 = i0.ɵɵreference(18);
            const _r1 = i0.ɵɵreference(24);
            i0.ɵɵadvance(6);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(7, 33, "inventory.movements_state"));
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngBusy", ctx.loading);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("label", "store.article")("model", ctx.article)("value", "code")("settings", ctx.articleInputSettings);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(15, 35, "purchase.start_date"))("max", ctx.query.to)("disabled", ctx.query.last_inventory_date)("ngModel", ctx.query.from)("matDatepicker", _r0);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("for", _r0);
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(21, 37, "purchase.dead_line_date"))("min", ctx.query.from)("disabled", ctx.query.last_inventory_date)("ngModel", ctx.query.to)("matDatepicker", _r1);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("for", _r1);
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("model", ctx.store)("config", i0.ɵɵpureFunction0(41, _c1$4))("label", "store.depot")("defaultValues", "default_store");
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("label", "store.default_provider")("model", ctx.provider)("value", "name")("settings", ctx.providerInputSettings);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngModel", ctx.query.last_inventory_date);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(31, 39, "shared.last_inventory_date"), i0.ɵɵsanitizeHtml);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("toolbar", true)("width", "100%")("height", 500)("report", ctx.config)("customizeCell", ctx.onCustomizeCell);
        }
    }, dependencies: [i6.MatButton, i7.MatDatepicker, i7.MatDatepickerInput, i7.MatDatepickerToggle, i9.MatIcon, i10.MatFormField, i10.MatSuffix, i11$1.MatInput, i8$1.MatSlideToggle, i11.MatToolbar, i8.DefaultLayoutDirective, i8.DefaultLayoutGapDirective, i8.DefaultFlexDirective, i16.DefaultValueAccessor, i16.NgControlStatus, i16.RequiredValidator, i16.NgModel, i12.NgBusyDirective, i2.DateDirective, i2.InputDirective, DocumentSelectComponent, ListSelectComponent, WebDataRocksPivot, i3$1.TranslatePipe], styles: ["[_nghost-%COMP%]{height:100%;display:flex;flex-direction:column}"] });
(function () {
    (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ArticleHistoricComponent, [{
            type: Component,
            args: [{ selector: 'fts-article-historic', template: "<mat-toolbar color=\"accent\">\n  <div class=\"ft-module-icon\">\n    <button type=\"button\" mat-icon-button>\n      <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-format-align-middle\"></mat-icon>\n    </button>\n  </div>\n  <h2>\n    <span>{{'inventory.movements_state'|translate}}</span>\n  </h2>\n  <span fxFlex></span>\n</mat-toolbar>\n\n<div fxFlex fxLayout=\"column\" class=\"ft-content\">\n   <div [ngBusy]=\"loading\"></div>\n  <div  fxLayout=\"row\"  fxLayoutGap=\"6px\" class=\"ft-padding\">\n     <fts-document-select\n                         [label]=\"'store.article'\"\n                         [(model)]=\"article\"\n                         (modelChange)=\"handleQuery($event)\"\n                         [value]=\"'code'\"\n                         [settings]=\"articleInputSettings\" >\n    </fts-document-select>\n        <mat-form-field >\n      <input matInput ftDate [placeholder]=\"'purchase.start_date'|translate\"\n             name=\"start_date\"  [max]=\"query.to\" [disabled]=\"query.last_inventory_date\"\n             required\n             [(ngModel)]=\"query.from\"\n            (ngModelChange)=\"handleQuery($event)\"\n             [matDatepicker]=\"picker3\">\n      <mat-datepicker-toggle matSuffix [for]=\"picker3\"></mat-datepicker-toggle>\n      <mat-datepicker #picker3></mat-datepicker>\n    </mat-form-field>\n    <mat-form-field >\n      <input matInput ftDate [placeholder]=\"'purchase.dead_line_date'|translate\"\n             name=\"dead_line\" [min]=\"query.from\" [disabled]=\"query.last_inventory_date\"\n             required\n             [(ngModel)]=\"query.to\"\n              (ngModelChange)=\"handleQuery($event)\"\n             [matDatepicker]=\"picker2\">\n      <mat-datepicker-toggle matSuffix [for]=\"picker2\"></mat-datepicker-toggle>\n      <mat-datepicker #picker2></mat-datepicker>\n    </mat-form-field>\n  </div>\n\n  <div  fxLayout=\"row\"  fxLayoutGap=\"6px\" class=\"ft-padding\">\n      <fts-list-select\n         [(model)]=\"store\"\n        (modelChange)=\"handleQuery($event)\"\n         [config]=\"{key: 'name', url: 'api/store/depot', cls:'store/depot'}\"\n         [label]=\"'store.depot'\"\n         [defaultValues]=\"'default_store'\"\n          >\n      </fts-list-select>\n     <fts-document-select\n                         [label]=\"'store.default_provider'\"\n                         [(model)]=\"provider\"\n                        (modelChange)=\"handleQuery($event)\"\n                         [value]=\"'name'\"\n                         [settings]=\"providerInputSettings\">\n    </fts-document-select>\n\n  </div>\n  <div  fxLayout=\"row\" class=\"ft-padding\">\n        <mat-slide-toggle name=\"last_inv_date\"\n                          [(ngModel)]=\"query.last_inventory_date\"\n                          (ngModelChange)=\"handleQuery($event)\"\n                          color=\"primary\">\n          <span [innerHTML]=\"'shared.last_inventory_date' | translate\"></span>\n        </mat-slide-toggle>\n    </div>\n  <div fxFlex fxLayout=\"column\" >\n\n     <wbr-pivot #pivot [toolbar]=\"true\" class=\"ft-wdr-container\"\n              [width]=\"'100%'\"\n              [height]=\"500\"\n              [report]=\"config\"\n             [customizeCell]=\"onCustomizeCell\"\n            (ready)=\"onPivotReady($event)\"\n            (reportcomplete)=\"onReportComplete()\"\n            (beforetoolbarcreated)=\"onToolbarCreated($event)\"\n     >\n    </wbr-pivot>\n  </div>\n</div>\n", styles: [":host{height:100%;display:flex;flex-direction:column}\n"] }]
        }], function () { return [{ type: InventoryService }, { type: i3$1.TranslateService }]; }, { child: [{
                type: ViewChild,
                args: ['pivot']
            }] });
})();

function PurchaseInvoiceComponent_mat_option_45_Template(rf, ctx) {
    if (rf & 1) {
        i0.ɵɵelementStart(0, "mat-option", 37);
        i0.ɵɵtext(1);
        i0.ɵɵpipe(2, "translate");
        i0.ɵɵelementEnd();
    }
    if (rf & 2) {
        const type_r8 = ctx.$implicit;
        i0.ɵɵproperty("value", type_r8);
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 2, "shared." + type_r8), " ");
    }
}
function PurchaseInvoiceComponent_mat_option_49_Template(rf, ctx) {
    if (rf & 1) {
        i0.ɵɵelementStart(0, "mat-option", 37);
        i0.ɵɵtext(1);
        i0.ɵɵpipe(2, "translate");
        i0.ɵɵelementEnd();
    }
    if (rf & 2) {
        const condition_r9 = ctx.$implicit;
        i0.ɵɵproperty("value", condition_r9);
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 2, "shared." + condition_r9.key), " ");
    }
}
function PurchaseInvoiceComponent_mat_radio_button_55_Template(rf, ctx) {
    if (rf & 1) {
        i0.ɵɵelementStart(0, "mat-radio-button", 37);
        i0.ɵɵtext(1);
        i0.ɵɵpipe(2, "translate");
        i0.ɵɵelementEnd();
    }
    if (rf & 2) {
        const type_price_r10 = ctx.$implicit;
        i0.ɵɵproperty("value", type_price_r10);
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 2, "shared." + type_price_r10), " ");
    }
}
function PurchaseInvoiceComponent_mat_radio_button_60_Template(rf, ctx) {
    if (rf & 1) {
        i0.ɵɵelementStart(0, "mat-radio-button", 37);
        i0.ɵɵtext(1);
        i0.ɵɵpipe(2, "translate");
        i0.ɵɵelementEnd();
    }
    if (rf & 2) {
        const t_r11 = ctx.$implicit;
        i0.ɵɵproperty("value", t_r11);
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 2, "purchase." + t_r11), " ");
    }
}
const _c0$4 = function () { return { cls: "ft_stock.purchase.PurchaseInvoice", field: "number" }; };
const _c1$3 = function () { return { key: "name", url: "api/store/depot", cls: "store/depot", customValidator: "depot.check_uniqueness" }; };
const _c2$1 = function () { return ["receipt_number", "code", "description", "qte", "vat", "price", "sub_total"]; };
class PurchaseInvoiceComponent {
    constructor(sharedModulesService, defaultValuesService, router, route, sharedService) {
        this.sharedModulesService = sharedModulesService;
        this.defaultValuesService = defaultValuesService;
        this.router = router;
        this.route = route;
        this.sharedService = sharedService;
        this.providerInputSettings = assignIn(cloneDeep(PROVIDER_VIEW), { selectable: false });
        this.depotDialog = DepotDialogComponent;
        this.providerDialog = ProviderDialogComponent;
        this.loadedObject = null;
        this.paymentModeTypes = PAYMENT_MODE_TYPES;
        this.paymentConditions = PAYMENT_CONDITIONS;
        this.modelTypes = ["PURCHASE", "LOAD"];
        this.price_mode = ['HT', 'TTC'];
        this.model = { loads: [], type: "PURCHASE", date: moment(),
            price_mode: this.defaultValuesService.getValue('default_price_mode') || 'HT',
            payment_mode: { type: this.defaultValuesService.getValue('payment_mode') } };
        this.apiUrl = 'purchase/purchase-invoice';
        this.resource = 'purchase-invoice';
        this.routes = { list: '/purchase/purchase-invoice', form: '/purchase/purchase-invoice/purchase-invoice-form' };
    }
    ngOnInit() {
        this.route.params.subscribe((data) => {
            let id = get(data, 'id');
            if (id)
                this.sharedService.getDocument(this.apiUrl, id).subscribe(data => {
                    this.model = data;
                });
        });
    }
    goBack() {
        this.router.navigate([handleRoute(this.sharedModulesService.pathName, this.routes["list"])]);
    }
    handleState(state) {
        this.loading = this.sharedService.saveDocument(this.apiUrl, this.model, null).subscribe(data => {
            this.model = data;
        });
    }
    compareMode(o1, o2) {
        return o1 == o2;
    }
    compareCondition(o1, o2) {
        return o1 && o2 ? o1.key == o2.key || o1.id == o2.id : false;
    }
    handlePaymentCondition(ev) {
        this.model.deadline = moment(this.model.date).add(get(ev, 'value.value'), 'days');
    }
}
PurchaseInvoiceComponent.ɵfac = function PurchaseInvoiceComponent_Factory(t) { return new (t || PurchaseInvoiceComponent)(i0.ɵɵdirectiveInject(SharedModulesService), i0.ɵɵdirectiveInject(i2.DefaultValuesService), i0.ɵɵdirectiveInject(i3.Router), i0.ɵɵdirectiveInject(i3.ActivatedRoute), i0.ɵɵdirectiveInject(SharedService)); };
PurchaseInvoiceComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PurchaseInvoiceComponent, selectors: [["fts-purchase-invoice"]], decls: 64, vars: 88, consts: [["color", "accent"], [1, "ft-module-icon"], ["type", "button", "mat-icon-button", ""], ["fontSet", "mdi", "fontIcon", "mdi-receipt"], ["fxFlex", ""], ["mat-icon-button", "", 3, "matTooltip", "click"], ["fontSet", "mdi", "fontIcon", "mdi-format-list-bulleted"], ["fxFlex", "", "fxLayout", "column", 1, "ft-content"], [3, "ngBusy"], ["fxFlex", "", "fxLayout", "column", "fxLayoutGap", "8px"], ["Form", "ngForm"], ["fxLayout", "row", 1, "ft-padding"], ["fxFlex", "60", "fxLayout", "column"], ["fxLayout", "row", "fxLayoutGap", "6px"], ["fxFlex", "nogrow"], ["matInput", "", "type", "text", "required", "", "name", "sequence", 3, "ftSequenceInput", "ftSequenceToggle", "placeholder", "ngModel", "readonly", "ngModelChange"], ["matSuffix", "", 3, "objectId", "config", "objectIdChange"], ["toggle", ""], ["matInput", "", "ftDate", "", "name", "date", 3, "placeholder", "readonly", "ngModel", "matDatepicker", "ngModelChange"], ["matSuffix", "", 3, "for"], ["picker", ""], ["matInput", "", "ftDate", "", "name", "deadline", "required", "", 3, "ftAutoFocus", "placeholder", "readonly", "ngModel", "matDatepicker", "ngModelChange"], ["picker2", ""], ["fxFlex", "", 3, "disabled", "label", "model", "required", "value", "settings", "dialog", "modelChange"], ["fxFlex", "", 3, "required", "disabled", "model", "listDialog", "config", "label", "defaultValues", "modelChange"], [3, "vertical"], ["fxFlex", "", "fxLayout", "column"], ["ftDefaultValues", "payment_mode", "name", "mode", 3, "placeholder", "compareWith", "ngModel", "ngModelChange"], [3, "value", 4, "ngFor", "ngForOf"], ["ftDefaultValues", "default_payment_condition", "name", "payment_condition", 3, "placeholder", "compareWith", "ngModel", "ngModelChange", "selectionChange"], ["fxFlex", "", "fxLayout", "column", "floatLabel", "always", 1, "ft-radio-field"], ["matInput", "", 2, "display", "none", 3, "placeholder"], ["name", "price_mode", "ftDefaultValues", "default_price_mode", 3, "ngModel", "disabled", "ngModelChange"], ["name", "type", 3, "ngModel", "disabled", "ngModelChange"], ["fxLayout", "column", "fxFlex", ""], ["fxFlex", "", 3, "model", "resource", "movementType", "displayedCols", "modelChange"], ["fxFlex", "nogrow", 3, "model", "cls", "resource", "formInvalid", "busy", "autoValidate", "autoInvalidate", "routes", "loadedObject", "movementType", "modelChange", "busyChange"], [3, "value"]], template: function PurchaseInvoiceComponent_Template(rf, ctx) {
        if (rf & 1) {
            i0.ɵɵelementStart(0, "mat-toolbar", 0)(1, "div", 1)(2, "button", 2);
            i0.ɵɵelement(3, "mat-icon", 3);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(4, "h2")(5, "span");
            i0.ɵɵtext(6);
            i0.ɵɵpipe(7, "translate");
            i0.ɵɵelementEnd()();
            i0.ɵɵelement(8, "span", 4);
            i0.ɵɵelementStart(9, "button", 5);
            i0.ɵɵlistener("click", function PurchaseInvoiceComponent_Template_button_click_9_listener() { return ctx.goBack(); });
            i0.ɵɵpipe(10, "translate");
            i0.ɵɵelement(11, "mat-icon", 6);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(12, "div", 7);
            i0.ɵɵelement(13, "div", 8);
            i0.ɵɵelementStart(14, "form", 9, 10)(16, "div", 11)(17, "div", 12)(18, "div", 13)(19, "mat-form-field", 14)(20, "input", 15);
            i0.ɵɵlistener("ngModelChange", function PurchaseInvoiceComponent_Template_input_ngModelChange_20_listener($event) { return ctx.model.number = $event; });
            i0.ɵɵpipe(21, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(22, "ft-sequence-toggle", 16, 17);
            i0.ɵɵlistener("objectIdChange", function PurchaseInvoiceComponent_Template_ft_sequence_toggle_objectIdChange_22_listener($event) { return ctx.loadedObject = $event; });
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(24, "mat-form-field", 14)(25, "input", 18);
            i0.ɵɵlistener("ngModelChange", function PurchaseInvoiceComponent_Template_input_ngModelChange_25_listener($event) { return ctx.model.date = $event; });
            i0.ɵɵpipe(26, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(27, "mat-datepicker-toggle", 19)(28, "mat-datepicker", null, 20);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(30, "mat-form-field", 14)(31, "input", 21);
            i0.ɵɵlistener("ngModelChange", function PurchaseInvoiceComponent_Template_input_ngModelChange_31_listener($event) { return ctx.model.deadline = $event; });
            i0.ɵɵpipe(32, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(33, "mat-datepicker-toggle", 19)(34, "mat-datepicker", null, 22);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(36, "div", 13)(37, "fts-document-select", 23);
            i0.ɵɵlistener("modelChange", function PurchaseInvoiceComponent_Template_fts_document_select_modelChange_37_listener($event) { return ctx.model.provider = $event; });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(38, "fts-list-select", 24);
            i0.ɵɵlistener("modelChange", function PurchaseInvoiceComponent_Template_fts_list_select_modelChange_38_listener($event) { return ctx.model.store = $event; });
            i0.ɵɵelementEnd()()();
            i0.ɵɵelement(39, "mat-divider", 25);
            i0.ɵɵelementStart(40, "div", 26)(41, "div", 13)(42, "mat-form-field", 4)(43, "mat-select", 27);
            i0.ɵɵlistener("ngModelChange", function PurchaseInvoiceComponent_Template_mat_select_ngModelChange_43_listener($event) { return ctx.model.payment_mode.type = $event; });
            i0.ɵɵpipe(44, "translate");
            i0.ɵɵtemplate(45, PurchaseInvoiceComponent_mat_option_45_Template, 3, 4, "mat-option", 28);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(46, "mat-form-field", 4)(47, "mat-select", 29);
            i0.ɵɵlistener("ngModelChange", function PurchaseInvoiceComponent_Template_mat_select_ngModelChange_47_listener($event) { return ctx.model.payment_condition = $event; })("selectionChange", function PurchaseInvoiceComponent_Template_mat_select_selectionChange_47_listener($event) { return ctx.handlePaymentCondition($event); });
            i0.ɵɵpipe(48, "translate");
            i0.ɵɵtemplate(49, PurchaseInvoiceComponent_mat_option_49_Template, 3, 4, "mat-option", 28);
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(50, "div", 13)(51, "mat-form-field", 30);
            i0.ɵɵelement(52, "input", 31);
            i0.ɵɵpipe(53, "translate");
            i0.ɵɵelementStart(54, "mat-radio-group", 32);
            i0.ɵɵlistener("ngModelChange", function PurchaseInvoiceComponent_Template_mat_radio_group_ngModelChange_54_listener($event) { return ctx.model.price_mode = $event; });
            i0.ɵɵtemplate(55, PurchaseInvoiceComponent_mat_radio_button_55_Template, 3, 4, "mat-radio-button", 28);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(56, "mat-form-field", 30);
            i0.ɵɵelement(57, "input", 31);
            i0.ɵɵpipe(58, "translate");
            i0.ɵɵelementStart(59, "mat-radio-group", 33);
            i0.ɵɵlistener("ngModelChange", function PurchaseInvoiceComponent_Template_mat_radio_group_ngModelChange_59_listener($event) { return ctx.model.type = $event; });
            i0.ɵɵtemplate(60, PurchaseInvoiceComponent_mat_radio_button_60_Template, 3, 4, "mat-radio-button", 28);
            i0.ɵɵelementEnd()()()()();
            i0.ɵɵelementStart(61, "div", 34)(62, "fts-document-details", 35);
            i0.ɵɵlistener("modelChange", function PurchaseInvoiceComponent_Template_fts_document_details_modelChange_62_listener($event) { return ctx.model = $event; });
            i0.ɵɵelementEnd()()()();
            i0.ɵɵelementStart(63, "fts-document-actions", 36);
            i0.ɵɵlistener("modelChange", function PurchaseInvoiceComponent_Template_fts_document_actions_modelChange_63_listener($event) { return ctx.model = $event; })("busyChange", function PurchaseInvoiceComponent_Template_fts_document_actions_busyChange_63_listener($event) { return ctx.loading = $event; });
            i0.ɵɵelementEnd();
        }
        if (rf & 2) {
            const _r0 = i0.ɵɵreference(15);
            const _r1 = i0.ɵɵreference(23);
            const _r2 = i0.ɵɵreference(29);
            const _r3 = i0.ɵɵreference(35);
            i0.ɵɵadvance(6);
            i0.ɵɵtextInterpolate2("", i0.ɵɵpipeBind1(7, 67, "purchase.purchase_invoice_form"), "\u00A0 N\u00B0:", ctx.model.number, "");
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("matTooltip", i0.ɵɵpipeBind1(10, 69, "purchase.purchase_invoice_list"));
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngBusy", ctx.loading);
            i0.ɵɵadvance(7);
            i0.ɵɵproperty("ftSequenceInput", "ft_stock.purchase.PurchaseInvoice")("ftSequenceToggle", _r1)("placeholder", i0.ɵɵpipeBind1(21, 71, "purchase.invoice_number"))("ngModel", ctx.model.number)("readonly", ctx.model == null ? null : ctx.model.state == null ? null : ctx.model.state.is_valid);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("objectId", ctx.loadedObject)("config", i0.ɵɵpureFunction0(85, _c0$4));
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(26, 73, "store.date"))("readonly", ctx.model == null ? null : ctx.model.state == null ? null : ctx.model.state.is_valid)("ngModel", ctx.model.date)("matDatepicker", _r2);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("for", _r2);
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ftAutoFocus", true)("placeholder", i0.ɵɵpipeBind1(32, 75, "purchase.deadline"))("readonly", ctx.model == null ? null : ctx.model.state == null ? null : ctx.model.state.is_valid)("ngModel", ctx.model.deadline)("matDatepicker", _r3);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("for", _r3);
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("disabled", ctx.model == null ? null : ctx.model.state == null ? null : ctx.model.state.is_valid)("label", "shared.provider")("model", ctx.model.provider)("required", true)("value", "name")("settings", ctx.providerInputSettings)("dialog", ctx.providerDialog);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("required", true)("disabled", ctx.model == null ? null : ctx.model.state == null ? null : ctx.model.state.is_valid)("model", ctx.model.store)("listDialog", ctx.depotDialog)("config", i0.ɵɵpureFunction0(86, _c1$3))("label", "store.depot")("defaultValues", "default_store");
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("vertical", true);
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(44, 77, "purchase.payment_mode"))("compareWith", ctx.compareMode)("ngModel", ctx.model.payment_mode.type);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngForOf", ctx.paymentModeTypes);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(48, 79, "purchase.payment_condition"))("compareWith", ctx.compareCondition)("ngModel", ctx.model.payment_condition);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngForOf", ctx.paymentConditions);
            i0.ɵɵadvance(3);
            i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(53, 81, "shared.price_mode"));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngModel", ctx.model.price_mode)("disabled", ctx.model == null ? null : ctx.model.state == null ? null : ctx.model.state.is_valid);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngForOf", ctx.price_mode);
            i0.ɵɵadvance(2);
            i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(58, 83, "store.type"));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngModel", ctx.model.type)("disabled", ctx.model == null ? null : ctx.model.state == null ? null : ctx.model.state.is_valid);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngForOf", ctx.modelTypes);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("model", ctx.model)("resource", ctx.resource)("movementType", "PurchaseInvoice")("displayedCols", i0.ɵɵpureFunction0(87, _c2$1));
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("model", ctx.model)("cls", ctx.apiUrl)("resource", ctx.resource)("formInvalid", _r0.invalid || !ctx.model.provider)("busy", ctx.loading)("autoValidate", true)("autoInvalidate", true)("routes", ctx.routes)("loadedObject", ctx.loadedObject)("movementType", "PurchaseInvoice");
        }
    }, dependencies: [i4$1.NgForOf, i5.MatOption, i6.MatButton, i7.MatDatepicker, i7.MatDatepickerInput, i7.MatDatepickerToggle, i9.MatIcon, i10.MatFormField, i10.MatSuffix, i11$1.MatInput, i12$1.MatDivider, i13.MatRadioGroup, i13.MatRadioButton, i15.MatSelect, i11.MatToolbar, i15$1.MatTooltip, i8.DefaultLayoutDirective, i8.DefaultLayoutGapDirective, i8.DefaultFlexDirective, i16.ɵNgNoValidate, i16.DefaultValueAccessor, i16.NgControlStatus, i16.NgControlStatusGroup, i16.RequiredValidator, i16.NgModel, i16.NgForm, i12.NgBusyDirective, i2.SequenceToggleComponent, i2.DateDirective, i2.InputDirective, i2.AutoFocusDirective, i2.SequenceInputDirective, i2.DefaultValuesDirective, DocumentSelectComponent, ListSelectComponent, DocumentActionsComponent, DocumentDetailsComponent, i3$1.TranslatePipe], styles: ["[_nghost-%COMP%]{height:100%;display:flex;flex-direction:column}"] });
(function () {
    (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PurchaseInvoiceComponent, [{
            type: Component,
            args: [{ selector: 'fts-purchase-invoice', template: "<mat-toolbar color=\"accent\">\n  <div class=\"ft-module-icon\">\n    <button type=\"button\" mat-icon-button>\n      <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-receipt\"></mat-icon>\n    </button>\n  </div>\n  <h2>\n    <span>{{'purchase.purchase_invoice_form'| translate}}&nbsp; N\u00B0:{{model.number}}</span>\n  </h2>\n  <span fxFlex></span>\n\n  <button mat-icon-button (click)=\"goBack()\"\n          [matTooltip]=\"'purchase.purchase_invoice_list'| translate\">\n    <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-format-list-bulleted\"></mat-icon>\n  </button>\n\n</mat-toolbar>\n\n<div fxFlex fxLayout=\"column\" class=\"ft-content\">\n    <div [ngBusy]=\"loading\"></div>\n\n    <form #Form=\"ngForm\" fxFlex fxLayout=\"column\" fxLayoutGap=\"8px\">\n    <div class=\"ft-padding\" fxLayout=\"row\">\n          <div fxFlex=\"60\" fxLayout=\"column\">\n            <div fxLayout=\"row\" fxLayoutGap=\"6px\">\n                 <mat-form-field fxFlex=\"nogrow\">\n                    <input matInput type=\"text\" required\n                           [ftSequenceInput]=\"'ft_stock.purchase.PurchaseInvoice'\"\n                           [ftSequenceToggle]=\"toggle\"\n                           name=\"sequence\"\n                           [placeholder]=\"'purchase.invoice_number'|translate\"\n                           [(ngModel)]=\"model.number\"\n\n                           [readonly]=\"model?.state?.is_valid\"/>\n                    <ft-sequence-toggle matSuffix #toggle  [(objectId)]=\"loadedObject\"\n                                        [config]=\"{cls: 'ft_stock.purchase.PurchaseInvoice', field: 'number'}\">\n                    </ft-sequence-toggle>\n                  </mat-form-field>\n                  <mat-form-field fxFlex=\"nogrow\">\n                    <input matInput ftDate [placeholder]=\"'store.date'|translate\" name=\"date\" [readonly]=\"model?.state?.is_valid\"\n                           [(ngModel)]=\"model.date\" [matDatepicker]=\"picker\">\n                    <mat-datepicker-toggle matSuffix [for]=\"picker\"></mat-datepicker-toggle>\n                    <mat-datepicker #picker></mat-datepicker>\n                  </mat-form-field>\n                  <mat-form-field fxFlex=\"nogrow\">\n                    <input matInput ftDate  [ftAutoFocus]=\"true\" [placeholder]=\"'purchase.deadline'|translate\"  name=\"deadline\" [readonly]=\"model?.state?.is_valid\" required\n                           [(ngModel)]=\"model.deadline\" [matDatepicker]=\"picker2\">\n                    <mat-datepicker-toggle matSuffix [for]=\"picker2\"></mat-datepicker-toggle>\n                    <mat-datepicker #picker2></mat-datepicker>\n                  </mat-form-field>\n            </div>\n            <div fxLayout=\"row\" fxLayoutGap=\"6px\">\n              <fts-document-select fxFlex\n                                   [disabled]=\"model?.state?.is_valid\"\n                                   [label]=\"'shared.provider'\"\n                                   [(model)]=\"model.provider\"\n                                   [required]=\"true\"\n                                   [value]=\"'name'\"\n                                   [settings]=\"providerInputSettings\"\n                                   [dialog]=\"providerDialog\">\n              </fts-document-select>\n\n                <fts-list-select fxFlex\n                   [required]=\"true\"\n                   [disabled]=\"model?.state?.is_valid\"\n                   [(model)]=\"model.store\"\n                   [listDialog]=\"depotDialog\"\n                   [config]=\"{key: 'name', url: 'api/store/depot', cls:'store/depot', customValidator:'depot.check_uniqueness'}\"\n                   [label]=\"'store.depot'\"\n                    [defaultValues]=\"'default_store'\"\n                    >\n                </fts-list-select>\n            </div>\n          </div>\n          <mat-divider [vertical]=\"true\"></mat-divider>\n          <div fxFlex fxLayout=\"column\">\n            <div fxLayout=\"row\" fxLayoutGap=\"6px\">\n               <mat-form-field fxFlex>\n                  <mat-select [placeholder]=\"'purchase.payment_mode' | translate\" [compareWith]=\"compareMode\"\n                              ftDefaultValues=\"payment_mode\"\n                              [(ngModel)]=\"model.payment_mode.type\" name=\"mode\">\n                    <mat-option *ngFor=\"let type of paymentModeTypes\" [value]=\"type\">\n                      {{'shared.'+type |translate}}\n                    </mat-option>\n                  </mat-select>\n                </mat-form-field>\n                <mat-form-field fxFlex>\n                  <mat-select [placeholder]=\"'purchase.payment_condition' | translate\" [compareWith]=\"compareCondition\" ftDefaultValues=\"default_payment_condition\"\n                              [(ngModel)]=\"model.payment_condition\" name=\"payment_condition\" (selectionChange)=\"handlePaymentCondition($event)\">\n                    <mat-option *ngFor=\"let condition of paymentConditions\" [value]=\"condition\">\n                      {{'shared.'+condition.key|translate}}\n                    </mat-option>\n                  </mat-select>\n                </mat-form-field>\n            </div>\n            <div  fxLayout=\"row\" fxLayoutGap=\"6px\">\n\n                <mat-form-field fxFlex fxLayout=\"column\" floatLabel=\"always\" class=\"ft-radio-field\" >\n                  <input matInput placeholder=\"{{'shared.price_mode'|translate}}\"  style=\"display: none\">\n                  <mat-radio-group [(ngModel)]=\"model.price_mode\" name=\"price_mode\" [disabled]=\"model?.state?.is_valid\"  ftDefaultValues=\"default_price_mode\">\n                    <mat-radio-button *ngFor=\"let type_price of price_mode\" [value]=\"type_price\">\n                      {{'shared.'+type_price|translate}}\n                    </mat-radio-button>\n                  </mat-radio-group>\n                </mat-form-field>\n\n                <mat-form-field fxFlex fxLayout=\"column\" floatLabel=\"always\" class=\"ft-radio-field\" >\n                  <input matInput placeholder=\"{{'store.type'|translate}}\"  style=\"display: none\">\n                  <mat-radio-group [(ngModel)]=\"model.type\" name=\"type\" [disabled]=\"model?.state?.is_valid\"  >\n                    <mat-radio-button *ngFor=\"let t of modelTypes\" [value]=\"t\">\n                      {{'purchase.'+t|translate}}\n                    </mat-radio-button>\n                  </mat-radio-group>\n                </mat-form-field>\n            </div>\n          </div>\n    </div>\n\n\n    <div fxLayout=\"column\" fxFlex>\n      <fts-document-details  fxFlex [(model)]=\"model\"\n                               [resource]=\"resource\"\n                              [movementType]=\"'PurchaseInvoice'\"\n                              [displayedCols]=\"['receipt_number', 'code','description','qte','vat','price','sub_total']\"\n                                    >\n      </fts-document-details>\n    </div>\n\n  </form>\n</div>\n\n<fts-document-actions fxFlex=\"nogrow\" [(model)]=\"model\" [cls]=\"apiUrl\" [resource]=\"resource\"\n                      [formInvalid]=\"Form.invalid|| !model.provider\"  [(busy)]=\"loading\" [autoValidate]=\"true\"  [autoInvalidate]=\"true\"\n                      [routes]=\"routes\" [loadedObject]=\"loadedObject\" [movementType]=\"'PurchaseInvoice'\"></fts-document-actions>\n\n", styles: [":host{height:100%;display:flex;flex-direction:column}\n"] }]
        }], function () { return [{ type: SharedModulesService }, { type: i2.DefaultValuesService }, { type: i3.Router }, { type: i3.ActivatedRoute }, { type: SharedService }]; }, null);
})();

class PaymentService {
    constructor(http, ws) {
        this.http = http;
        this.ws = ws;
    }
    getUnpaidDocuments(query) {
        return this.ws.call('purchase-payment.get_unpaid_documents', { query });
    }
}
PaymentService.ɵfac = function PaymentService_Factory(t) { return new (t || PaymentService)(i0.ɵɵinject(i1$1.HttpClient), i0.ɵɵinject(i2.FtWsService)); };
PaymentService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: PaymentService, factory: PaymentService.ɵfac, providedIn: 'root' });
(function () {
    (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PaymentService, [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], function () { return [{ type: i1$1.HttpClient }, { type: i2.FtWsService }]; }, null);
})();

const paymentLinesHeaders = [
    {
        'key': 'paid_doc.date',
        'label': 'shared.date',
        'type': 'date'
    }, {
        'key': 'paid_doc.number',
        'label': 'payment.paid_doc',
        'type': 'text'
    },
    {
        'key': 'total_amount',
        'label': 'payment.total_amount',
        'type': 'number',
        'numberConfig': 'float'
    },
    {
        'key': 'remaining_amount',
        'label': 'payment.line_remaining_amount',
        'type': 'number',
        'numberConfig': 'float'
    }
];

const _c0$3 = function () { return []; };
class PaymentLinesComponent {
    constructor() {
        this._lines = new BehaviorSubject([]);
        this.showAmounts = true;
        this.linesChange = new EventEmitter();
        this.dissociateLineHandler = new EventEmitter();
        this.actionHandler = new EventEmitter();
        this.displayedColumns = [];
        this.actionColumn = {
            label: '', key: 'actions', type: 'actions', actions: [
                {
                    class: 'mat-warn',
                    icon: 'mdi-close-circle',
                    method: (item, index, ev) => {
                        return this.removeLine(item, index);
                    },
                }
            ]
        };
        this.linesSource$ = of([]);
        this.extendedColHandler = (index, item) => item.is_comment === true || item['details'] && item.details.length > 0;
    }
    set lines(value) {
        this.linesSource$ = of(value);
        this._lines.next(value);
    }
    get lines() {
        return this._lines.getValue();
    }
    ngOnInit() {
        this.encasement_col = {
            'key': 'encasement_amount',
            'label': 'payment.encasement_amount',
            'type': 'number',
            'editable': this.hideActions,
            'numberConfig': 'float',
            'dbClick': (row) => {
                return this.encasementDbClick(row);
            },
            'min': 0
            // 'max': (row) => {
            //   return this.setMax(row);
            // },
        };
        this.handleColumns(paymentLinesHeaders);
    }
    handleColumns(paymentLinesHeaders) {
        this.linesColumns = new BehaviorSubject(_.concat(_.cloneDeep(paymentLinesHeaders), this.encasement_col, !this.hideActions ? this.actionColumn : []));
    }
    onLinesChange(data) {
        this.lines = data;
        this.linesSource$ = of(this.lines);
    }
    removeLine(row, idx) {
        this.lines.splice(idx, 1);
        this.linesSource$ = of(this.lines);
        this.dissociateLineHandler.emit(row);
    }
    getTotal() {
        let total = _.reduce(this.lines, sumTotal, 0);
        return _.isNil(total) ? 0 : total;
        function sumTotal(result, value) {
            return result + value['encasement_amount'];
        }
    }
    paymentRemainingAmount() {
        let model_amount = this.payment.received_amount - this.payment.consumed_amount;
        return model_amount - this.getTotal() > 0 ? model_amount - this.getTotal() : 0;
    }
    handlePaymentLine(row) {
        let paid_idx = _.findIndex(this.payment.lines, function (item) {
            if (item['paid_doc'].number == row.paid_doc.number && item['paid_doc']._module == row.paid_doc._module && item['paid_doc']._model == row.paid_doc._model)
                return item;
        });
        if (paid_idx == -1) {
            this.payment.lines.push(row);
        }
        else {
            _.update(this.payment.lines, `[${paid_idx}].encasement_amount`, function (encasement_amount) {
                return encasement_amount + row.encasement_amount;
            });
        }
    }
    encasementDbClick(row) {
        this.actionHandler.emit({ action: 'encasementDbClick', data: row });
    }
    setMax(row) {
        // let remaining_amount = this.paymentRemainingAmount();
        // return remaining_amount < row.remaining_amount ? remaining_amount : row.remaining_amount;
    }
}
PaymentLinesComponent.ɵfac = function PaymentLinesComponent_Factory(t) { return new (t || PaymentLinesComponent)(); };
PaymentLinesComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PaymentLinesComponent, selectors: [["fts-payment-lines"]], inputs: { lines: "lines", cls: "cls", hideActions: "hideActions", payment: ["model", "payment"], showAmounts: "showAmounts" }, outputs: { linesChange: "linesChange", dissociateLineHandler: "dissociateLineHandler", actionHandler: "actionHandler" }, decls: 3, vars: 10, consts: [["fxFlex", "", 1, "document-lines-container"], ["fxFlex", "", 3, "remote", "source", "selectable", "hasPagination", "columns", "multiActions", "extendedHandler"]], template: function PaymentLinesComponent_Template(rf, ctx) {
        if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵelement(1, "ft-generic-body-table", 1);
            i0.ɵɵpipe(2, "async");
            i0.ɵɵelementEnd();
        }
        if (rf & 2) {
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("remote", false)("source", ctx.linesSource$)("selectable", false)("hasPagination", true)("columns", i0.ɵɵpipeBind1(2, 7, ctx.linesColumns))("multiActions", i0.ɵɵpureFunction0(9, _c0$3))("extendedHandler", ctx.extendedColHandler);
        }
    }, dependencies: [i8.DefaultFlexDirective, i4$2.GenericBodyTableComponent, i4$1.AsyncPipe] });
(function () {
    (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PaymentLinesComponent, [{
            type: Component,
            args: [{ selector: 'fts-payment-lines', template: "\n<div fxFlex class=\"document-lines-container\">\n  <ft-generic-body-table fxFlex\n                         [remote]=\"false\"\n                         [source]=\"linesSource$\"\n                         [selectable]=\"false\"\n                         [hasPagination]=\"true\"\n                         [columns]=\"linesColumns | async\"\n                         [multiActions]=\"[]\"\n                         [extendedHandler]=\"extendedColHandler\"\n  >\n  </ft-generic-body-table>\n</div>\n\n" }]
        }], function () { return []; }, { lines: [{
                type: Input
            }], cls: [{
                type: Input
            }], hideActions: [{
                type: Input
            }], payment: [{
                type: Input,
                args: ['model']
            }], showAmounts: [{
                type: Input
            }], linesChange: [{
                type: Output
            }], dissociateLineHandler: [{
                type: Output
            }], actionHandler: [{
                type: Output
            }] });
})();

function PaymentActionsComponent_ng_template_1_button_0_Template(rf, ctx) {
    if (rf & 1) {
        const _r8 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "button", 7);
        i0.ɵɵlistener("click", function PaymentActionsComponent_ng_template_1_button_0_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r8); const ctx_r7 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r7.remove()); });
        i0.ɵɵelement(1, "mat-icon", 8);
        i0.ɵɵelementEnd();
    }
}
function PaymentActionsComponent_ng_template_1_Template(rf, ctx) {
    if (rf & 1) {
        i0.ɵɵtemplate(0, PaymentActionsComponent_ng_template_1_button_0_Template, 2, 0, "button", 6);
    }
    if (rf & 2) {
        const ctx_r0 = i0.ɵɵnextContext();
        i0.ɵɵproperty("ngIf", ctx_r0.model.id && !(ctx_r0.model == null ? null : ctx_r0.model.state == null ? null : ctx_r0.model.state.is_valid));
    }
}
function PaymentActionsComponent_ng_template_7_button_0_Template(rf, ctx) {
    if (rf & 1) {
        const _r11 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "button", 3);
        i0.ɵɵlistener("click", function PaymentActionsComponent_ng_template_7_button_0_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r11); const ctx_r10 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r10.dissociateLines()); });
        i0.ɵɵelementStart(1, "span");
        i0.ɵɵtext(2);
        i0.ɵɵpipe(3, "translate");
        i0.ɵɵelementEnd()();
    }
    if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 1, "payment.dissociate"));
    }
}
function PaymentActionsComponent_ng_template_7_Template(rf, ctx) {
    if (rf & 1) {
        i0.ɵɵtemplate(0, PaymentActionsComponent_ng_template_7_button_0_Template, 4, 3, "button", 9);
    }
    if (rf & 2) {
        const ctx_r1 = i0.ɵɵnextContext();
        i0.ɵɵproperty("ngIf", (ctx_r1.model == null ? null : ctx_r1.model.lines.length) > 0);
    }
}
function PaymentActionsComponent_ng_template_8_button_0_Template(rf, ctx) {
    if (rf & 1) {
        const _r14 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "button", 3);
        i0.ɵɵlistener("click", function PaymentActionsComponent_ng_template_8_button_0_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r14); const ctx_r13 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r13.invalidateHeader()); });
        i0.ɵɵelementStart(1, "span");
        i0.ɵɵtext(2);
        i0.ɵɵpipe(3, "translate");
        i0.ɵɵelementEnd()();
    }
    if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 1, "payment.header_invalidate"));
    }
}
function PaymentActionsComponent_ng_template_8_Template(rf, ctx) {
    if (rf & 1) {
        i0.ɵɵtemplate(0, PaymentActionsComponent_ng_template_8_button_0_Template, 4, 3, "button", 9);
    }
    if (rf & 2) {
        const ctx_r2 = i0.ɵɵnextContext();
        i0.ɵɵproperty("ngIf", ctx_r2.headerDisabled);
    }
}
function PaymentActionsComponent_button_9_Template(rf, ctx) {
    if (rf & 1) {
        const _r16 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "button", 10);
        i0.ɵɵlistener("click", function PaymentActionsComponent_button_9_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r16); const ctx_r15 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r15.shareReceivedAmount()); });
        i0.ɵɵelementStart(1, "span");
        i0.ɵɵtext(2);
        i0.ɵɵpipe(3, "translate");
        i0.ɵɵelementEnd()();
    }
    if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 1, "payment.calculate"));
    }
}
function PaymentActionsComponent_button_10_Template(rf, ctx) {
    if (rf & 1) {
        const _r18 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "button", 11);
        i0.ɵɵlistener("click", function PaymentActionsComponent_button_10_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r18); const ctx_r17 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r17.save(true)); });
        i0.ɵɵelementStart(1, "span");
        i0.ɵɵtext(2);
        i0.ɵɵpipe(3, "translate");
        i0.ɵɵelementEnd()();
    }
    if (rf & 2) {
        const ctx_r4 = i0.ɵɵnextContext();
        i0.ɵɵproperty("disabled", ctx_r4.formInvalid);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 2, "shared.save_exit"));
    }
}
function PaymentActionsComponent_button_11_Template(rf, ctx) {
    if (rf & 1) {
        const _r20 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "button", 11);
        i0.ɵɵlistener("click", function PaymentActionsComponent_button_11_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r20); const ctx_r19 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r19.save()); });
        i0.ɵɵelementStart(1, "span");
        i0.ɵɵtext(2);
        i0.ɵɵpipe(3, "translate");
        i0.ɵɵelementEnd()();
    }
    if (rf & 2) {
        const ctx_r5 = i0.ɵɵnextContext();
        i0.ɵɵproperty("disabled", ctx_r5.formInvalid);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 2, "shared.save"));
    }
}
const _c0$2 = function () { return { resource: "payment", action: "delete", behavior: "remove" }; };
const _c1$2 = function () { return { resource: "payment", action: "invalidate", behavior: "remove" }; };
class PaymentActionsComponent {
    constructor(sharedService, router, dialog, sharedModulesService, translateService, snackBar, purposeService) {
        this.sharedService = sharedService;
        this.router = router;
        this.dialog = dialog;
        this.sharedModulesService = sharedModulesService;
        this.translateService = translateService;
        this.snackBar = snackBar;
        this.purposeService = purposeService;
        this.preLines = [];
        this.preventSave = false;
        this.busy = null;
        this.modelChange = new EventEmitter();
        this._formInvalid = new BehaviorSubject(false);
        this.busyChange = new EventEmitter();
    }
    set handlePreLines(value) {
        this.preLines = value;
    }
    ;
    set handleSubscription(value) {
        this.busy = value;
    }
    set formInvalid(value) {
        this._formInvalid.next(value);
    }
    get formInvalid() {
        return this._formInvalid.getValue();
    }
    ngOnInit() {
    }
    handlePaymentLine(row) {
        let paid_idx = _.findIndex(this.model.lines, function (item) {
            if (item['paid_doc'].id == row.paid_doc.id && item['paid_doc']._module == row.paid_doc._module && item['paid_doc']._model == row.paid_doc._model)
                return item;
        });
        if (paid_idx == -1) {
            this.model.lines.push(row);
        }
        else {
            _.update(this.model.lines, `[${paid_idx}]`, function (line) {
                return _.assignIn(line, {
                    encasement_amount: line.encasement_amount + row.encasement_amount,
                    remaining_amount: line.remaining_amount - row.encasement_amount
                });
            });
        }
        // row.encasement_amount=0;
    }
    save(with_exit) {
        _.chain(this.preLines).filter((l) => {
            return l['encasement_amount'] > 0;
        }).value().forEach(this.handlePaymentLine.bind(this));
        if (!this.preventSave) {
            this.preventSave = true;
            if (!isNil(this.loadedObject)) {
                this.sharedService.loadDocument(this.resource, this.loadedObject).subscribe(data => {
                    this.performSave(with_exit, data);
                });
            }
            else {
                this.performSave(with_exit);
            }
        }
    }
    performSave(with_exit, load_data) {
        this.busy = this.sharedService.saveDocument(this.cls, this.model, load_data ? this.loadedObject : null).subscribe(data => data ? this.saveSuccess(data, with_exit) : _.noop);
        this.busyChange.emit(this.busy);
    }
    saveSuccess(data, with_exit) {
        this.model = data;
        this.handleSaveEvents();
        if (with_exit) {
            this.router.navigate([handleRoute(this.sharedModulesService.pathName, this.routes['list'])]);
        }
        else {
            this.router.navigate([handleRoute(this.sharedModulesService.pathName, this.routes['form']), get(this.model, 'id')], { replaceUrl: true });
            this.modelChange.emit(data);
        }
    }
    handleSaveEvents() {
        _.chain(this.preLines).filter((l) => {
            return l.encasement_amount > 0;
        }).value().forEach((line) => {
            line.encasement_amount = 0;
        });
    }
    remove() {
        this.purposeService.openConfirmDialog(this.translateService.instant('store.delete_object_warning'))
            .subscribe(res => {
            if (res)
                this.sharedService.deleteDocument(this.cls, this.model.id).subscribe((data) => {
                    this.router.navigate([handleRoute(this.sharedModulesService.pathName, this.routes['list'])]);
                });
        });
    }
    exit() {
        this.router.navigate([handleRoute(this.sharedModulesService.pathName, this.routes['list'])]);
    }
    print() {
    }
    invalidateHeader() {
        this.modelChange.emit('headerInvalidate');
    }
    shareReceivedAmount() {
        this.modelChange.emit('shareReceivedAmount');
    }
    dissociateLines() {
        this.modelChange.emit('dissociateLines');
    }
}
PaymentActionsComponent.ɵfac = function PaymentActionsComponent_Factory(t) { return new (t || PaymentActionsComponent)(i0.ɵɵdirectiveInject(SharedService), i0.ɵɵdirectiveInject(i3.Router), i0.ɵɵdirectiveInject(i1.MatDialog), i0.ɵɵdirectiveInject(SharedModulesService), i0.ɵɵdirectiveInject(i3$1.TranslateService), i0.ɵɵdirectiveInject(i1$2.MatSnackBar), i0.ɵɵdirectiveInject(i2.GeneralPurposeService)); };
PaymentActionsComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PaymentActionsComponent, selectors: [["fts-payment-actions"]], inputs: { model: "model", handlePreLines: ["preLines", "handlePreLines"], cls: "cls", resource: "resource", headerDisabled: "headerDisabled", loadedObject: "loadedObject", routes: "routes", handleSubscription: ["busy", "handleSubscription"], formInvalid: "formInvalid" }, outputs: { modelChange: "modelChange", busyChange: "busyChange" }, decls: 12, vars: 12, consts: [["fxFlex", "", 1, "ft-actions"], [3, "ftAcl"], ["fxFlex", ""], ["type", "button", "mat-raised-button", "", "color", "warn", 3, "click"], ["type", "button", "mat-raised-button", "", "color", "primary", "class", "success-button", 3, "click", 4, "ngIf"], ["type", "button", "mat-raised-button", "", "color", "primary", 3, "disabled", "click", 4, "ngIf"], ["type", "button", "mat-mini-fab", "", "color", "warn", 3, "click", 4, "ngIf"], ["type", "button", "mat-mini-fab", "", "color", "warn", 3, "click"], ["fontSet", "mdi", "fontIcon", "mdi-delete"], ["type", "button", "mat-raised-button", "", "color", "warn", 3, "click", 4, "ngIf"], ["type", "button", "mat-raised-button", "", "color", "primary", 1, "success-button", 3, "click"], ["type", "button", "mat-raised-button", "", "color", "primary", 3, "disabled", "click"]], template: function PaymentActionsComponent_Template(rf, ctx) {
        if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtemplate(1, PaymentActionsComponent_ng_template_1_Template, 1, 1, "ng-template", 1);
            i0.ɵɵelement(2, "span", 2);
            i0.ɵɵelementStart(3, "button", 3);
            i0.ɵɵlistener("click", function PaymentActionsComponent_Template_button_click_3_listener() { return ctx.exit(); });
            i0.ɵɵelementStart(4, "span");
            i0.ɵɵtext(5);
            i0.ɵɵpipe(6, "translate");
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(7, PaymentActionsComponent_ng_template_7_Template, 1, 1, "ng-template", 1);
            i0.ɵɵtemplate(8, PaymentActionsComponent_ng_template_8_Template, 1, 1, "ng-template", 1);
            i0.ɵɵtemplate(9, PaymentActionsComponent_button_9_Template, 4, 3, "button", 4);
            i0.ɵɵtemplate(10, PaymentActionsComponent_button_10_Template, 4, 4, "button", 5);
            i0.ɵɵtemplate(11, PaymentActionsComponent_button_11_Template, 4, 4, "button", 5);
            i0.ɵɵelementEnd();
        }
        if (rf & 2) {
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ftAcl", i0.ɵɵpureFunction0(9, _c0$2));
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(6, 7, "shared.exit"));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ftAcl", i0.ɵɵpureFunction0(10, _c1$2));
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ftAcl", i0.ɵɵpureFunction0(11, _c1$2));
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", (ctx.model == null ? null : ctx.model.received_amount) > 0 && ctx.preLines.length > 0);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", !(ctx.model == null ? null : ctx.model.state == null ? null : ctx.model.state.is_valid));
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", !(ctx.model == null ? null : ctx.model.state == null ? null : ctx.model.state.is_valid));
        }
    }, dependencies: [i4$1.NgIf, i6.MatButton, i9.MatIcon, i8.DefaultFlexDirective, i2.AclDirective, i3$1.TranslatePipe], encapsulation: 2 });
(function () {
    (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PaymentActionsComponent, [{
            type: Component,
            args: [{ selector: 'fts-payment-actions', template: "<div fxFlex class=\"ft-actions\">\n   <ng-template  [ftAcl]=\"{resource:  'payment', action: 'delete', behavior: 'remove'}\">\n    <button type=\"button\" *ngIf=\"model.id && !model?.state?.is_valid\" mat-mini-fab color=\"warn\" (click)=\"remove()\"  >\n      <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-delete\"></mat-icon>\n    </button>\n  </ng-template>\n  <span fxFlex></span>\n\n  <button type=\"button\" mat-raised-button color=\"warn\" (click)=\"exit()\">\n    <span>{{'shared.exit'|translate}}</span>\n  </button>\n  <ng-template [ftAcl]=\"{resource: 'payment', action: 'invalidate', behavior: 'remove'}\">\n    <button type=\"button\"  *ngIf=\"model?.lines.length>0\" mat-raised-button color=\"warn\" (click)=\"dissociateLines()\">\n      <span>{{'payment.dissociate'|translate}}</span>\n    </button>\n  </ng-template>\n  <ng-template [ftAcl]=\"{resource: 'payment', action: 'invalidate', behavior: 'remove'}\">\n    <button type=\"button\" *ngIf=\"headerDisabled\" mat-raised-button color=\"warn\"\n            (click)=\"invalidateHeader()\">\n      <span>{{'payment.header_invalidate'|translate}}</span>\n    </button>\n  </ng-template>\n  <button type=\"button\" *ngIf=\"model?.received_amount>0 && preLines.length>0\"  mat-raised-button color=\"primary\"\n          (click)=\"shareReceivedAmount()\" class=\"success-button\">\n    <span>{{'payment.calculate'|translate}}</span>\n  </button>\n  <button type=\"button\" *ngIf=\"!model?.state?.is_valid\" mat-raised-button color=\"primary\" (click)=\"save(true)\"  [disabled]=\"formInvalid\">\n    <span>{{'shared.save_exit'|translate}}</span>\n  </button>\n  <button type=\"button\" *ngIf=\"!model?.state?.is_valid\" mat-raised-button color=\"primary\" (click)=\"save()\"  [disabled]=\"formInvalid\">\n    <span>{{'shared.save'|translate}}</span>\n  </button>\n</div>\n\n\n" }]
        }], function () { return [{ type: SharedService }, { type: i3.Router }, { type: i1.MatDialog }, { type: SharedModulesService }, { type: i3$1.TranslateService }, { type: i1$2.MatSnackBar }, { type: i2.GeneralPurposeService }]; }, { model: [{
                type: Input
            }], handlePreLines: [{
                type: Input,
                args: ['preLines']
            }], cls: [{
                type: Input
            }], resource: [{
                type: Input
            }], headerDisabled: [{
                type: Input
            }], loadedObject: [{
                type: Input
            }], routes: [{
                type: Input
            }], modelChange: [{
                type: Output
            }], handleSubscription: [{
                type: Input,
                args: ['busy']
            }], busyChange: [{
                type: Output
            }], formInvalid: [{
                type: Input
            }] });
})();

const _c0$1 = ["paymentForm"];
function PaymentFormComponent_span_8_Template(rf, ctx) {
    if (rf & 1) {
        i0.ɵɵelementStart(0, "span");
        i0.ɵɵtext(1);
        i0.ɵɵpipe(2, "translate");
        i0.ɵɵelementEnd();
    }
    if (rf & 2) {
        const ctx_r0 = i0.ɵɵnextContext();
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate2("| ", i0.ɵɵpipeBind1(2, 2, "payment.init_amount"), ": ", ctx_r0.payment.received_amount, " ");
    }
}
function PaymentFormComponent_div_17_Template(rf, ctx) {
    if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 45);
        i0.ɵɵelement(1, "img", 46);
        i0.ɵɵelementEnd();
    }
}
function PaymentFormComponent_mat_option_51_Template(rf, ctx) {
    if (rf & 1) {
        i0.ɵɵelementStart(0, "mat-option", 47);
        i0.ɵɵtext(1);
        i0.ɵɵpipe(2, "translate");
        i0.ɵɵelementEnd();
    }
    if (rf & 2) {
        const type_r7 = ctx.$implicit;
        i0.ɵɵproperty("value", type_r7);
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 2, "shared." + type_r7), " ");
    }
}
const _c1$1 = function (a0) { return [a0]; };
const _c2 = function () { return { cls: "ft_stock.purchase.PurchasePayment", field: "number" }; };
const _c3 = function () { return { key: "value", url: "api/list/bank", cls: "list/bank", customValidator: "bank.check_uniqueness" }; };
const _c4 = function (a0) { return { "warning": a0 }; };
class PaymentFormComponent {
    constructor(sharedModulesService, defaultValuesService, router, route, sharedService, paymentService) {
        this.sharedModulesService = sharedModulesService;
        this.defaultValuesService = defaultValuesService;
        this.router = router;
        this.route = route;
        this.sharedService = sharedService;
        this.paymentService = paymentService;
        this.listDialog = ListFormDialogComponent;
        this.providerInputSettings = assignIn(cloneDeep(PROVIDER_VIEW), { selectable: false });
        this.providerDialog = ProviderDialogComponent;
        this.loadedObject = null;
        this.paymentLines = [];
        this.paymentModeTypes = PAYMENT_MODE_TYPES;
        this.payment = {
            date: moment(),
            deadline: moment(),
            lines: [],
            payment_mode: { type: this.defaultValuesService.getValue('payment_mode') },
            received_amount: 0,
            consumed_amount: 0,
            remaining_amount: 0
        };
        this.apiUrl = 'purchase/purchase-payment';
        this.resource = 'purchase-payment';
        this.routes = { list: '/purchase/purchase-payment', form: '/purchase/purchase-payment/purchase-payment-form' };
    }
    ngOnInit() {
        this.route.params.subscribe((data) => {
            let id = get(data, 'id');
            if (id)
                this.sharedService.getDocument(this.apiUrl, id).subscribe(data => {
                    this.payment = data;
                    this.loadDocToPay();
                    this.disableHeader();
                });
        });
    }
    disableHeader() {
        if (_.get(this.payment, 'id')) {
            this.paymentForm.form.disable();
        }
    }
    enableHeader() {
        this.paymentForm.form.enable();
        this.dissociateLines();
    }
    dissociateLines() {
        _.forEach(this.payment.lines, function (row) {
            this.dissociateOneLine(row);
        }.bind(this));
        this.payment.lines = [];
        this.payment.consumed_amount = 0;
    }
    dissociateOneLine(row) {
        let paid_idx = _.findIndex(this.paymentLines, function (item) {
            if (item['paid_doc'].id == row.paid_doc.id && item['paid_doc']._module == row.paid_doc._module && item['paid_doc']._model == row.paid_doc._model)
                return item;
        });
        if (paid_idx != -1) {
            this.paymentLines[paid_idx].remaining_amount = this.paymentLines[paid_idx].remaining_amount + row.encasement_amount;
            this.paymentLines[paid_idx].encasement_amount = 0;
            this.paymentLines = _.cloneDeep(this.paymentLines);
        }
        else {
            this.paymentLines = _.concat(this.paymentLines, _.assignIn(row, {
                remaining_amount: row.encasement_amount,
                encasement_amount: 0
            }));
        }
    }
    onModelChange(data) {
        if (typeof data === 'string') {
            this.executeCommand(data);
        }
        else {
            this.disableHeader();
            this.payment = data;
            this.loadDocToPay();
        }
    }
    executeCommand(cmd) {
        switch (cmd) {
            case 'headerInvalidate':
                return this.enableHeader();
            case 'dissociateLines':
                return this.dissociateLines();
            case 'shareReceivedAmount':
                return this.shareReceivedAmount();
        }
    }
    handleAction(action) {
        switch (action.action) {
            case 'encasementDbClick':
                return this.encasementDbClick(action.data);
        }
    }
    handleProviderChange(data) {
        //this.payment.provider = data;
        this.loadDocToPay();
    }
    loadDocToPay() {
        this.paymentLines = [];
        if (this.payment.provider) {
            this.paymentService.getUnpaidDocuments({
                provider: _.get(this.payment, 'provider.id')
            }).subscribe(data => {
                let res = _.compact(_.map(data, (invoice) => {
                    return this.refreshPaymentLines(invoice, 'ft_stock.purchase.models', 'PurchaseInvoice');
                }));
                this.paymentLines = res;
            });
        }
    }
    refreshPaymentLines(doc, _pkg, _model) {
        if (!doc['is_paid']) {
            if (_.isNil(_.find(this.paymentLines, function (item) {
                if (item.paid_doc.number == doc.number && item.paid_doc._module == _pkg && item.paid_doc._model == _model)
                    return item;
            }))) {
                return {
                    total_amount: doc.ttc_amount,
                    paid_doc: _.assignIn(doc, {
                        _module: _pkg,
                        _model: _model,
                        _pkg: _pkg
                    }),
                    encasement_amount: 0.0,
                    remaining_amount: doc.remaining_amount
                };
            }
        }
    }
    handleReceivedAmountChange() {
        if (this.payment.received_amount == 0 || _.sumBy(this.paymentLines, 'encasement_amount') > this.payment.received_amount) {
            this.resetEncasementAmount(this.paymentLines);
        }
    }
    resetEncasementAmount(lines) {
        _.forEach(lines, function (line) {
            line.remaining_amount += parseFloat(line.encasement_amount);
            line.encasement_amount = 0;
        });
    }
    shareReceivedAmount() {
        this.resetEncasementAmount(this.paymentLines);
        this.paymentLines = _.map(this.paymentLines, (line) => {
            this.encasementDbClick(line);
            return line;
        });
    }
    getRealTotal() {
        let total = _.reduce(this.payment.lines, getLineTotal, 0);
        return _.isNil(total) ? 0 : total;
        function getLineTotal(result, value) {
            return result + _.get(value, 'encasement_amount', 0);
        }
    }
    getTotal() {
        let total = _.reduce(this.paymentLines, getTotal, 0);
        return _.isNaN(total) ? 0 : total;
        function getTotal(result, value) {
            return result + value['encasement_amount'];
        }
    }
    paymentRemainingAmount() {
        let model_amount = this.payment.received_amount - this.getRealTotal();
        return model_amount - this.getTotal() > 0 ? model_amount - this.getTotal() : 0;
    }
    getCurrentRemainingAmount() {
        let model_amount = this.payment.received_amount - this.getRealTotal();
        return model_amount - this.getTotal();
    }
    handlePaymentLine(row) {
        let paid_idx = _.findIndex(this.payment.lines, function (item) {
            if (item['paid_doc'].id == row.paid_doc.id && item['paid_doc']._module == row.paid_doc._module && item['paid_doc']._model == row.paid_doc._model)
                return item;
        });
        if (paid_idx == -1) {
            this.payment.lines = _.concat(this.payment.lines, row);
        }
        else {
            _.update(this.payment.lines, `[${paid_idx}]`, function (line) {
                return _.assignIn(line, {
                    encasement_amount: line.encasement_amount + row.encasement_amount,
                    remaining_amount: line.remaining_amount - row.encasement_amount
                });
            });
        }
    }
    encasementDbClick(row) {
        if (row.encasement_amount > 0)
            return;
        let amount = this.paymentRemainingAmount();
        if (amount > 0) {
            if (amount - row.remaining_amount > 0) {
                row.encasement_amount = row.remaining_amount;
            }
            else {
                row.encasement_amount = amount;
            }
            row.remaining_amount = row.remaining_amount - row.encasement_amount;
        }
    }
    onPreLinesChange(data) {
        this.paymentLines = data;
    }
    onPaymentLinesChange(data) {
        this.payment.lines = data;
    }
    compareMode(o1, o2) {
        return o1 == o2;
    }
}
PaymentFormComponent.ɵfac = function PaymentFormComponent_Factory(t) { return new (t || PaymentFormComponent)(i0.ɵɵdirectiveInject(SharedModulesService), i0.ɵɵdirectiveInject(i2.DefaultValuesService), i0.ɵɵdirectiveInject(i3.Router), i0.ɵɵdirectiveInject(i3.ActivatedRoute), i0.ɵɵdirectiveInject(SharedService), i0.ɵɵdirectiveInject(PaymentService)); };
PaymentFormComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PaymentFormComponent, selectors: [["fts-payment-form"]], viewQuery: function PaymentFormComponent_Query(rf, ctx) {
        if (rf & 1) {
            i0.ɵɵviewQuery(_c0$1, 7);
        }
        if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.paymentForm = _t.first);
        }
    }, decls: 85, vars: 114, consts: [["color", "accent"], [1, "ft-module-icon"], ["type", "button", "mat-icon-button", ""], ["fontSet", "mdi", "fontIcon", "mdi-currency-usd"], [4, "ngIf"], ["fxFlex", ""], ["type", "button", "mat-button", "", 1, "with-icon", 3, "routerLink"], ["fontSet", "mdi", "fontIcon", "mdi-format-list-bulleted"], ["fxFlex", "", "fxLayout", "column", 1, "ft-content", "no-padding"], [3, "ngBusy"], ["fxLayoutAlign", "center center", "class", "validate-icon", 4, "ngIf"], ["fxFlex", "", "fxLayout", "column", "fxLayoutGap", "6px"], ["paymentForm", "ngForm"], ["fxLayout", "row", "fxLayoutGap", "6px", 1, "ft-padding"], ["fxFlex", "40", "fxLayout", "column"], ["fxLayout", "row", "fxLayoutGap", "6px"], ["fxFlex", "nogrow"], ["matInput", "", "type", "text", "required", "", "name", "sequence", 3, "ftSequenceInput", "ftSequenceToggle", "placeholder", "ngModel", "ngModelChange"], ["matSuffix", "", 3, "disabled", "objectId", "config", "objectIdChange"], ["toggle", ""], ["matInput", "", "ftDate", "", "name", "doc_date", 3, "matDatepicker", "placeholder", "ngModel", "ngModelChange"], ["matSuffix", "", 3, "for"], ["matDatepickerToggleIcon", "", "fontSet", "mdi", "fontIcon", "mdi-calendar-today"], ["inv_date", ""], ["fxLayout", "row"], ["fxFlex", "", 3, "disabled", "label", "model", "required", "value", "settings", "dialog", "modelChange"], [3, "vertical"], ["fxFlex", "60", "fxLayout", "column"], ["matInput", "", "ftDate", "", "name", "deadline", 3, "matDatepicker", "placeholder", "ngModel", "ngModelChange"], ["d_date", ""], ["ftDefaultValues", "payment_mode", "name", "mode", 3, "placeholder", "compareWith", "ngModel", "ngModelChange"], [3, "value", 4, "ngFor", "ngForOf"], ["matInput", "", "name", "p_ref", 3, "placeholder", "ngModel", "ngModelChange"], ["fxFlex", "", 3, "disabled", "model", "listDialog", "config", "label", "modelChange"], ["matInput", "", "required", "", "name", "p_received", 3, "placeholder", "ftNumber", "ftAutoFocus", "ngModel", "min", "ngModelChange", "change"], ["matInput", "", "name", "p_consumed", 3, "placeholder", "ftNumber", "ngModel", "disabled", "ngModelChange"], ["matInput", "", "name", "p_remaining", 3, "placeholder", "ftNumber", "ngModel", "disabled", "ngModelChange"], ["fxFlex", "", "fxLayout", "column"], ["fxFlex", "", "fxLayout", "column", 3, "label"], ["fxLayout", "column", "fxFlex", "", "fxLayoutGap", "6px", 1, "ft-padding"], [3, "ngClass"], ["fxFlex", "", 3, "lines", "model", "hideActions", "linesChange", "actionHandler"], ["fxFlex", "", 3, "label", "disabled"], ["fxFlex", "", 3, "lines", "model", "hideActions", "linesChange", "dissociateLineHandler"], ["fxFlex", "nogrow", 3, "model", "cls", "resource", "loadedObject", "headerDisabled", "preLines", "formInvalid", "routes", "busy", "modelChange", "busyChange"], ["fxLayoutAlign", "center center", 1, "validate-icon"], ["mat-card-image", "", "src", "/assets/lock-outline.svg", "alt", "validation img"], [3, "value"]], template: function PaymentFormComponent_Template(rf, ctx) {
        if (rf & 1) {
            i0.ɵɵelementStart(0, "mat-toolbar", 0)(1, "div", 1)(2, "button", 2);
            i0.ɵɵelement(3, "mat-icon", 3);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(4, "h2")(5, "span");
            i0.ɵɵtext(6);
            i0.ɵɵpipe(7, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(8, PaymentFormComponent_span_8_Template, 3, 4, "span", 4);
            i0.ɵɵelementEnd();
            i0.ɵɵelement(9, "span", 5);
            i0.ɵɵelementStart(10, "button", 6);
            i0.ɵɵelement(11, "mat-icon", 7);
            i0.ɵɵelementStart(12, "span");
            i0.ɵɵtext(13);
            i0.ɵɵpipe(14, "translate");
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(15, "div", 8);
            i0.ɵɵelement(16, "div", 9);
            i0.ɵɵtemplate(17, PaymentFormComponent_div_17_Template, 2, 0, "div", 10);
            i0.ɵɵelementStart(18, "form", 11, 12)(20, "div", 13)(21, "div", 14)(22, "div", 15)(23, "mat-form-field", 16)(24, "input", 17);
            i0.ɵɵlistener("ngModelChange", function PaymentFormComponent_Template_input_ngModelChange_24_listener($event) { return ctx.payment.number = $event; });
            i0.ɵɵpipe(25, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(26, "ft-sequence-toggle", 18, 19);
            i0.ɵɵlistener("objectIdChange", function PaymentFormComponent_Template_ft_sequence_toggle_objectIdChange_26_listener($event) { return ctx.loadedObject = $event; });
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(28, "mat-form-field")(29, "input", 20);
            i0.ɵɵlistener("ngModelChange", function PaymentFormComponent_Template_input_ngModelChange_29_listener($event) { return ctx.payment.date = $event; });
            i0.ɵɵpipe(30, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(31, "mat-datepicker-toggle", 21);
            i0.ɵɵelement(32, "mat-icon", 22);
            i0.ɵɵelementEnd();
            i0.ɵɵelement(33, "mat-datepicker", null, 23);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(35, "div", 24)(36, "fts-document-select", 25);
            i0.ɵɵlistener("modelChange", function PaymentFormComponent_Template_fts_document_select_modelChange_36_listener($event) { return ctx.payment.provider = $event; })("modelChange", function PaymentFormComponent_Template_fts_document_select_modelChange_36_listener($event) { return ctx.handleProviderChange($event); });
            i0.ɵɵelementEnd()()();
            i0.ɵɵelement(37, "mat-divider", 26);
            i0.ɵɵelementStart(38, "div", 27)(39, "div", 15)(40, "mat-form-field")(41, "input", 28);
            i0.ɵɵlistener("ngModelChange", function PaymentFormComponent_Template_input_ngModelChange_41_listener($event) { return ctx.payment.deadline = $event; });
            i0.ɵɵpipe(42, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(43, "mat-datepicker-toggle", 21);
            i0.ɵɵelement(44, "mat-icon", 22);
            i0.ɵɵelementEnd();
            i0.ɵɵelement(45, "mat-datepicker", null, 29);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(47, "div", 15)(48, "mat-form-field", 5)(49, "mat-select", 30);
            i0.ɵɵlistener("ngModelChange", function PaymentFormComponent_Template_mat_select_ngModelChange_49_listener($event) { return ctx.payment.payment_mode.type = $event; });
            i0.ɵɵpipe(50, "translate");
            i0.ɵɵtemplate(51, PaymentFormComponent_mat_option_51_Template, 3, 4, "mat-option", 31);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(52, "mat-form-field", 5)(53, "input", 32);
            i0.ɵɵlistener("ngModelChange", function PaymentFormComponent_Template_input_ngModelChange_53_listener($event) { return ctx.payment.payment_mode.ref = $event; });
            i0.ɵɵpipe(54, "translate");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(55, "fts-list-select", 33);
            i0.ɵɵlistener("modelChange", function PaymentFormComponent_Template_fts_list_select_modelChange_55_listener($event) { return ctx.payment.payment_mode.bank = $event; });
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(56, "div", 15)(57, "mat-form-field", 5)(58, "input", 34);
            i0.ɵɵlistener("ngModelChange", function PaymentFormComponent_Template_input_ngModelChange_58_listener($event) { return ctx.payment.received_amount = $event; })("change", function PaymentFormComponent_Template_input_change_58_listener() { return ctx.handleReceivedAmountChange(); });
            i0.ɵɵpipe(59, "translate");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(60, "mat-form-field", 5)(61, "input", 35);
            i0.ɵɵlistener("ngModelChange", function PaymentFormComponent_Template_input_ngModelChange_61_listener($event) { return ctx.payment.consumed_amount = $event; });
            i0.ɵɵpipe(62, "translate");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(63, "mat-form-field", 5)(64, "input", 36);
            i0.ɵɵlistener("ngModelChange", function PaymentFormComponent_Template_input_ngModelChange_64_listener($event) { return ctx.payment.remaining_amount = $event; });
            i0.ɵɵpipe(65, "translate");
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(66, "div", 15)(67, "mat-form-field", 5)(68, "input", 32);
            i0.ɵɵlistener("ngModelChange", function PaymentFormComponent_Template_input_ngModelChange_68_listener($event) { return ctx.payment.comment = $event; });
            i0.ɵɵpipe(69, "translate");
            i0.ɵɵelementEnd()()()()();
            i0.ɵɵelementStart(70, "mat-tab-group", 37)(71, "mat-tab", 38);
            i0.ɵɵpipe(72, "translate");
            i0.ɵɵelementStart(73, "div", 39)(74, "div", 24);
            i0.ɵɵelement(75, "span", 5);
            i0.ɵɵelementStart(76, "strong", 40);
            i0.ɵɵtext(77);
            i0.ɵɵpipe(78, "translate");
            i0.ɵɵpipe(79, "ftNumber");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(80, "fts-payment-lines", 41);
            i0.ɵɵlistener("linesChange", function PaymentFormComponent_Template_fts_payment_lines_linesChange_80_listener($event) { return ctx.paymentLines = $event; })("actionHandler", function PaymentFormComponent_Template_fts_payment_lines_actionHandler_80_listener($event) { return ctx.handleAction($event); });
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(81, "mat-tab", 42);
            i0.ɵɵpipe(82, "translate");
            i0.ɵɵelementStart(83, "fts-payment-lines", 43);
            i0.ɵɵlistener("linesChange", function PaymentFormComponent_Template_fts_payment_lines_linesChange_83_listener($event) { return ctx.payment.lines = $event; })("dissociateLineHandler", function PaymentFormComponent_Template_fts_payment_lines_dissociateLineHandler_83_listener($event) { return ctx.dissociateOneLine($event); });
            i0.ɵɵelementEnd()()()()();
            i0.ɵɵelementStart(84, "fts-payment-actions", 44);
            i0.ɵɵlistener("modelChange", function PaymentFormComponent_Template_fts_payment_actions_modelChange_84_listener($event) { return ctx.onModelChange($event); })("busyChange", function PaymentFormComponent_Template_fts_payment_actions_busyChange_84_listener($event) { return ctx.loading = $event; });
            i0.ɵɵelementEnd();
        }
        if (rf & 2) {
            const _r2 = i0.ɵɵreference(19);
            const _r3 = i0.ɵɵreference(27);
            const _r4 = i0.ɵɵreference(34);
            const _r5 = i0.ɵɵreference(46);
            i0.ɵɵadvance(6);
            i0.ɵɵtextInterpolate2("", i0.ɵɵpipeBind1(7, 77, "payment.payment_header_number"), ": ", ctx.payment.number, " ");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", _r2.disabled);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("routerLink", i0.ɵɵpureFunction1(108, _c1$1, ctx.routes["list"]));
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(14, 79, "payment.payment_list"));
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngBusy", ctx.loading);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.payment.state == null ? null : ctx.payment.state.is_valid);
            i0.ɵɵadvance(7);
            i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(25, 81, "payment.payment_number"));
            i0.ɵɵproperty("ftSequenceInput", "ft_stock.purchase.PurchasePayment")("ftSequenceToggle", _r3)("ngModel", ctx.payment.number);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("disabled", ctx.payment.id)("objectId", ctx.loadedObject)("config", i0.ɵɵpureFunction0(110, _c2));
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("matDatepicker", _r4)("placeholder", i0.ɵɵpipeBind1(30, 83, "shared.date"))("ngModel", ctx.payment.date);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("for", _r4);
            i0.ɵɵadvance(5);
            i0.ɵɵproperty("disabled", _r2.disabled)("label", "shared.provider")("model", ctx.payment.provider)("required", true)("value", "name")("settings", ctx.providerInputSettings)("dialog", ctx.providerDialog);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("vertical", true);
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("matDatepicker", _r5)("placeholder", i0.ɵɵpipeBind1(42, 85, "payment.deadline"))("ngModel", ctx.payment.deadline);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("for", _r5);
            i0.ɵɵadvance(6);
            i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(50, 87, "purchase.payment_mode"))("compareWith", ctx.compareMode)("ngModel", ctx.payment.payment_mode.type);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngForOf", ctx.paymentModeTypes);
            i0.ɵɵadvance(2);
            i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(54, 89, "payment.ref"));
            i0.ɵɵproperty("ngModel", ctx.payment.payment_mode.ref);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("disabled", _r2.disabled)("model", ctx.payment.payment_mode.bank)("listDialog", ctx.listDialog)("config", i0.ɵɵpureFunction0(111, _c3))("label", "payment.bank");
            i0.ɵɵadvance(3);
            i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(59, 91, "payment.received_amount"));
            i0.ɵɵproperty("ftNumber", "float")("ftAutoFocus", true)("ngModel", ctx.payment.received_amount)("min", 1);
            i0.ɵɵadvance(3);
            i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(62, 93, "payment.consumed_amount"));
            i0.ɵɵproperty("ftNumber", "float")("ngModel", ctx.payment.consumed_amount)("disabled", true);
            i0.ɵɵadvance(3);
            i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(65, 95, "payment.remaining_amount"));
            i0.ɵɵproperty("ftNumber", "float")("ngModel", ctx.payment.remaining_amount)("disabled", true);
            i0.ɵɵadvance(4);
            i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(69, 97, "shared.comment"));
            i0.ɵɵproperty("ngModel", ctx.payment.comment);
            i0.ɵɵadvance(3);
            i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(72, 99, "payment.be_paid_document"));
            i0.ɵɵadvance(5);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(112, _c4, ctx.getCurrentRemainingAmount() < 0));
            i0.ɵɵadvance(1);
            i0.ɵɵtextInterpolate2("", i0.ɵɵpipeBind1(78, 101, "payment.remaining_amount"), " : ", i0.ɵɵpipeBind2(79, 103, ctx.getCurrentRemainingAmount(), "currency"), "");
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("lines", ctx.paymentLines)("model", ctx.payment)("hideActions", true);
            i0.ɵɵadvance(1);
            i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(82, 106, "payment.payment_lines"));
            i0.ɵɵproperty("disabled", ctx.payment.lines.length == 0);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("lines", ctx.payment.lines)("model", ctx.payment)("hideActions", true);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("model", ctx.payment)("cls", ctx.apiUrl)("resource", ctx.resource)("loadedObject", ctx.loadedObject)("headerDisabled", _r2.disabled)("preLines", ctx.paymentLines)("formInvalid", _r2.invalid || !ctx.payment.provider || ctx.getCurrentRemainingAmount() < 0)("routes", ctx.routes)("busy", ctx.loading);
        }
    }, dependencies: [i4$1.NgClass, i4$1.NgForOf, i4$1.NgIf, i5.MatOption, i6.MatButton, i6$1.MatCardImage, i7.MatDatepicker, i7.MatDatepickerInput, i7.MatDatepickerToggle, i7.MatDatepickerToggleIcon, i9.MatIcon, i10.MatFormField, i10.MatSuffix, i11$1.MatInput, i12$1.MatDivider, i15.MatSelect, i15$2.MatTabGroup, i15$2.MatTab, i11.MatToolbar, i8.DefaultLayoutDirective, i8.DefaultLayoutGapDirective, i8.DefaultLayoutAlignDirective, i8.DefaultFlexDirective, i9$1.DefaultClassDirective, i16.ɵNgNoValidate, i16.DefaultValueAccessor, i16.NgControlStatus, i16.NgControlStatusGroup, i16.RequiredValidator, i16.NgModel, i16.NgForm, i12.NgBusyDirective, i2.SequenceToggleComponent, i2.DateDirective, i2.InputDirective, i2.NumberDirective, i2.AutoFocusDirective, i2.SequenceInputDirective, i2.DefaultValuesDirective, i3.RouterLink, DocumentSelectComponent, ListSelectComponent, PaymentLinesComponent, PaymentActionsComponent, i3$1.TranslatePipe, i2.NumberPipe], styles: ["[_nghost-%COMP%]{height:100%;display:flex;flex-direction:column}"] });
(function () {
    (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PaymentFormComponent, [{
            type: Component,
            args: [{ selector: 'fts-payment-form', template: "<mat-toolbar color=\"accent\">\n  <div class=\"ft-module-icon\">\n    <button type=\"button\" mat-icon-button>\n      <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-currency-usd\"></mat-icon>\n    </button>\n  </div>\n  <h2>\n    <span>{{'payment.payment_header_number'|translate}}: {{payment.number}} </span>\n    <span *ngIf=\"paymentForm.disabled\">| {{'payment.init_amount'|translate}}: {{payment.received_amount}} </span>\n  </h2>\n  <span fxFlex></span>\n  <button type=\"button\" mat-button class=\"with-icon\" [routerLink]=\"[routes['list']]\">\n    <mat-icon fontSet=\"mdi\" fontIcon=\"mdi-format-list-bulleted\"></mat-icon>\n    <span>{{'payment.payment_list'|translate}}</span>\n  </button>\n</mat-toolbar>\n    <div fxFlex fxLayout=\"column\" class=\"ft-content no-padding\">\n      <div [ngBusy]=\"loading\"></div>\n\n      <div *ngIf=\"payment.state?.is_valid\" fxLayoutAlign=\"center center\" class=\"validate-icon\">\n        <img mat-card-image src=\"/assets/lock-outline.svg\" alt=\"validation img\">\n      </div>\n      <form #paymentForm=\"ngForm\" fxFlex fxLayout=\"column\" fxLayoutGap=\"6px\">\n        <div class=\"ft-padding\" fxLayout=\"row\" fxLayoutGap=\"6px\">\n          <div  fxFlex=\"40\" fxLayout=\"column\">\n            <div fxLayout=\"row\" fxLayoutGap=\"6px\">\n              <mat-form-field fxFlex=\"nogrow\">\n                <input matInput type=\"text\" required\n                       [ftSequenceInput]=\"'ft_stock.purchase.PurchasePayment'\"\n                       [ftSequenceToggle]=\"toggle\"\n                       name=\"sequence\"\n                       placeholder=\"{{'payment.payment_number'|translate}}\"\n                       [(ngModel)]=\"payment.number\"/>\n                <ft-sequence-toggle [disabled]=\"payment.id\"\n                                    matSuffix #toggle [(objectId)]=\"loadedObject\"\n                                    [config]=\"{cls: 'ft_stock.purchase.PurchasePayment', field: 'number'}\">\n                </ft-sequence-toggle>\n              </mat-form-field>\n              <mat-form-field>\n                <input matInput ftDate [matDatepicker]=\"inv_date\" [placeholder]=\"'shared.date'|translate\"\n                       [(ngModel)]=\"payment.date\" name=\"doc_date\">\n                <mat-datepicker-toggle matSuffix [for]=\"inv_date\">\n                  <mat-icon matDatepickerToggleIcon fontSet=\"mdi\" fontIcon=\"mdi-calendar-today\"></mat-icon>\n                </mat-datepicker-toggle>\n                <mat-datepicker #inv_date></mat-datepicker>\n              </mat-form-field>\n\n            </div>\n\n\n            <div fxLayout=\"row\">\n                 <fts-document-select fxFlex\n                                   [disabled]=\"paymentForm.disabled\"\n                                   [label]=\"'shared.provider'\"\n                                   [(model)]=\"payment.provider\"\n                                   (modelChange)=\"handleProviderChange($event)\"\n                                   [required]=\"true\"\n                                   [value]=\"'name'\"\n                                   [settings]=\"providerInputSettings\"\n                                   [dialog]=\"providerDialog\">\n                 </fts-document-select>\n            </div>\n          </div>\n          <mat-divider [vertical]=\"true\"></mat-divider>\n          <div fxFlex=\"60\" fxLayout=\"column\">\n            <div fxLayout=\"row\" fxLayoutGap=\"6px\">\n             <mat-form-field>\n                <input matInput ftDate [matDatepicker]=\"d_date\" [placeholder]=\"'payment.deadline'|translate\"\n                       [(ngModel)]=\"payment.deadline\" name=\"deadline\">\n                <mat-datepicker-toggle matSuffix [for]=\"d_date\">\n                  <mat-icon matDatepickerToggleIcon fontSet=\"mdi\" fontIcon=\"mdi-calendar-today\"></mat-icon>\n                </mat-datepicker-toggle>\n                <mat-datepicker #d_date></mat-datepicker>\n              </mat-form-field>\n            </div>\n            <div fxLayout=\"row\" fxLayoutGap=\"6px\">\n              <!--<ftb-select-list [required]=\"true\" [disabled]=\"paymentForm.disabled\" fxFlex label=\"shared.payment_mode\"-->\n              <!--[model]=\"payment.payment_mode.type\"-->\n              <!--[cls]=\"'PaymentModeType'\" (valueChange)=\"listChange($event,'type')\"></ftb-select-list>-->\n              <mat-form-field fxFlex>\n                <mat-select [placeholder]=\"'purchase.payment_mode' | translate\" [compareWith]=\"compareMode\"\n                            ftDefaultValues=\"payment_mode\"\n                            [(ngModel)]=\"payment.payment_mode.type\" name=\"mode\">\n                  <mat-option *ngFor=\"let type of paymentModeTypes\" [value]=\"type\">\n                    {{'shared.'+type |translate}}\n                  </mat-option>\n                </mat-select>\n              </mat-form-field>\n              <mat-form-field fxFlex>\n                <input matInput placeholder=\"{{'payment.ref'|translate}}\"\n                       [(ngModel)]=\"payment.payment_mode.ref\" name=\"p_ref\">\n              </mat-form-field>\n\n               <fts-list-select fxFlex\n                   [disabled]=\"paymentForm.disabled\"\n                   [(model)]=\"payment.payment_mode.bank\"\n                   [listDialog]=\"listDialog\"\n                   [config]=\"{key: 'value', url: 'api/list/bank', cls:'list/bank', customValidator:'bank.check_uniqueness'}\"\n                   [label]=\"'payment.bank'\"   >\n              </fts-list-select>\n            </div>\n            <div fxLayout=\"row\" fxLayoutGap=\"6px\">\n              <mat-form-field fxFlex>\n                <input matInput placeholder=\"{{'payment.received_amount'|translate}}\" [ftNumber]=\"'float'\" [ftAutoFocus]=\"true\"\n                       [(ngModel)]=\"payment.received_amount\" (change)=\"handleReceivedAmountChange()\" [min]=\"1\" required\n                       name=\"p_received\">\n              </mat-form-field>\n              <mat-form-field fxFlex>\n                <input matInput placeholder=\"{{'payment.consumed_amount'|translate}}\" [ftNumber]=\"'float'\"\n                       [(ngModel)]=\"payment.consumed_amount\" [disabled]=\"true\" name=\"p_consumed\">\n              </mat-form-field>\n              <mat-form-field fxFlex>\n                <input matInput\n                       placeholder=\"{{'payment.remaining_amount'|translate}}\" [ftNumber]=\"'float'\"\n                       [(ngModel)]=\"payment.remaining_amount\" [disabled]=\"true\" name=\"p_remaining\">\n              </mat-form-field>\n            </div>\n            <div fxLayout=\"row\" fxLayoutGap=\"6px\">\n              <mat-form-field fxFlex>\n                <input matInput placeholder=\"{{'shared.comment'|translate}}\"\n                       [(ngModel)]=\"payment.comment\" name=\"p_ref\">\n              </mat-form-field>\n            </div>\n          </div>\n        </div>\n        <mat-tab-group fxFlex fxLayout=\"column\">\n          <mat-tab fxFlex fxLayout=\"column\" label=\"{{'payment.be_paid_document'|translate}}\">\n            <div fxLayout=\"column\" fxFlex=\"\" fxLayoutGap=\"6px\" class=\"ft-padding\" >\n                <div fxLayout=\"row\">\n                    <span fxFlex=\"\"></span>\n                    <strong   [ngClass]=\"{'warning':getCurrentRemainingAmount()<0}\">{{'payment.remaining_amount'|translate}} : {{getCurrentRemainingAmount()| ftNumber:'currency'}}</strong>\n                </div>\n              <fts-payment-lines fxFlex [(lines)]=\"paymentLines\" [model]=\"payment\" [hideActions]=\"true\"\n                                (actionHandler)=\"handleAction($event)\"></fts-payment-lines>\n            </div>\n          </mat-tab>\n          <mat-tab fxFlex label=\"{{'payment.payment_lines'|translate}}\" [disabled]=\"payment.lines.length==0\">\n            <fts-payment-lines fxFlex [(lines)]=\"payment.lines\" [model]=\"payment\" [hideActions]=\"true\"\n                               (dissociateLineHandler)=\"dissociateOneLine($event)\" ></fts-payment-lines>\n          </mat-tab>\n        </mat-tab-group>\n      </form>\n    </div>\n<fts-payment-actions fxFlex=\"nogrow\" [model]=\"payment\"\n                      [cls]=\"apiUrl\" [resource]=\"resource\"\n                     (modelChange)=\"onModelChange($event)\" [loadedObject]=\"loadedObject\"\n                     [headerDisabled]=\"paymentForm.disabled\" [preLines]=\"paymentLines\"\n                     [formInvalid]=\"paymentForm.invalid || !payment.provider  || getCurrentRemainingAmount()<0\"\n                     [routes]=\"routes\"  [(busy)]=\"loading\"></fts-payment-actions>\n\n", styles: [":host{height:100%;display:flex;flex-direction:column}\n"] }]
        }], function () { return [{ type: SharedModulesService }, { type: i2.DefaultValuesService }, { type: i3.Router }, { type: i3.ActivatedRoute }, { type: SharedService }, { type: PaymentService }]; }, { paymentForm: [{
                type: ViewChild,
                args: ['paymentForm', { static: true }]
            }] });
})();

const routes = [
    {
        path: '',
        pathMatch: 'full',
        redirectTo: 'store'
    },
    {
        path: '',
        component: SubLayoutComponent,
        canActivate: [AuthGuard],
        children: [
            {
                path: 'store',
                children: [
                    {
                        path: '',
                        pathMatch: 'full',
                        redirectTo: 'article'
                    },
                    {
                        path: 'article',
                        component: MainContainerComponent,
                        children: [
                            { path: '', pathMatch: 'full', redirectTo: 'article-list' },
                            { path: 'article-list', component: DocumentsListComponent, data: ARTICLE_VIEW },
                            { path: 'article-form', component: ArticleFormComponent },
                            { path: 'article-form/:id', component: ArticleFormComponent },
                        ]
                    },
                    { path: 'provider-list', component: DocumentsListComponent, data: PROVIDER_VIEW },
                    { path: 'depot-list', component: DocumentsListComponent, data: DEPOT_VIEW },
                    { path: 'family-list', component: DocumentsListComponent, data: FAMILY_VIEW },
                    {
                        path: 'movement',
                        component: MainContainerComponent,
                        children: [
                            { path: '', pathMatch: 'full', redirectTo: 'movement-list' },
                            { path: 'movement-list', component: DocumentsListComponent, data: STORE_MOVEMENT_VIEW },
                            { path: 'movement-form', component: MovementComponent },
                            { path: 'movement-form/:id', component: MovementComponent },
                        ]
                    },
                    {
                        path: 'transformation',
                        component: MainContainerComponent,
                        children: [
                            { path: '', pathMatch: 'full', redirectTo: 'transformation-list' },
                            { path: 'transformation-list', component: DocumentsListComponent, data: STORE_TRANSFORMATION_VIEW },
                            { path: 'transformation-form', component: TransformationComponent },
                            { path: 'transformation-form/:id', component: TransformationComponent }
                        ]
                    },
                    {
                        path: 'exchange',
                        component: MainContainerComponent,
                        children: [
                            { path: '', pathMatch: 'full', redirectTo: 'exchange-list' },
                            { path: 'exchange-list', component: DocumentsListComponent, data: STORE_EXCHANGE_VIEW },
                            { path: 'exchange-form', component: ExchangeComponent },
                            { path: 'exchange-form/:id', component: ExchangeComponent },
                        ]
                    },
                ]
            },
            {
                path: 'purchase',
                children: [
                    {
                        path: '',
                        pathMatch: 'full',
                        redirectTo: 'price-request'
                    },
                    {
                        path: 'price-request',
                        component: MainContainerComponent,
                        children: [
                            { path: '', pathMatch: 'full', redirectTo: 'price-request-list' },
                            { path: 'price-request-list', component: DocumentsListComponent, data: PRICE_REQUEST_VIEW },
                            { path: 'price-request-form', component: PriceRequestFormComponent },
                            { path: 'price-request-form/:id', component: PriceRequestFormComponent },
                        ]
                    },
                    {
                        path: 'purchase-order',
                        component: MainContainerComponent,
                        children: [
                            { path: '', pathMatch: 'full', redirectTo: 'purchase-order-list' },
                            { path: 'purchase-order-list', component: DocumentsListComponent, data: PURCHASE_ORDER_VIEW },
                            { path: 'purchase-order-form', component: PurchaseOrderComponent },
                            { path: 'purchase-order-form/:id', component: PurchaseOrderComponent },
                        ]
                    },
                    {
                        path: 'purchase-receipt',
                        component: MainContainerComponent,
                        children: [
                            { path: '', pathMatch: 'full', redirectTo: 'purchase-receipt-list' },
                            { path: 'purchase-receipt-list', component: DocumentsListComponent, data: PURCHASE_RECEIPT_VIEW },
                            { path: 'purchase-receipt-form', component: PurchaseReceiptComponent },
                            { path: 'purchase-receipt-form/:id', component: PurchaseReceiptComponent },
                        ]
                    },
                    {
                        path: 'deposition',
                        component: MainContainerComponent, children: [
                            { path: '', pathMatch: 'full', redirectTo: 'deposition-list' },
                            { path: 'deposition-list', component: DocumentsListComponent, data: DEPOSITION_VIEW },
                            { path: 'deposition-form', component: DepositionComponent },
                            { path: 'deposition-form/:id', component: DepositionComponent },
                        ]
                    },
                    {
                        path: 'return',
                        component: MainContainerComponent,
                        children: [
                            { path: '', pathMatch: 'full', redirectTo: 'return-list' },
                            { path: 'return-list', component: DocumentsListComponent, data: RETURN_VIEW },
                            { path: 'return-form', component: ReturnFormComponent },
                            { path: 'return-form/:id', component: ReturnFormComponent },
                        ]
                    },
                    {
                        path: 'purchase-invoice',
                        component: MainContainerComponent,
                        children: [
                            { path: '', pathMatch: 'full', redirectTo: 'purchase-invoice-list' },
                            { path: 'purchase-invoice-list', component: DocumentsListComponent, data: PURCHASE_INVOICE_VIEW },
                            { path: 'purchase-invoice-form', component: PurchaseInvoiceComponent },
                            { path: 'purchase-invoice-form/:id', component: PurchaseInvoiceComponent },
                        ]
                    },
                    {
                        path: 'purchase-payment',
                        component: MainContainerComponent,
                        children: [
                            { path: '', pathMatch: 'full', redirectTo: 'purchase-payment-list' },
                            { path: 'purchase-payment-list', component: DocumentsListComponent, data: PURCHASE_PAYMENT_VIEW },
                            { path: 'purchase-payment-form', component: PaymentFormComponent },
                            { path: 'purchase-payment-form/:id', component: PaymentFormComponent },
                        ]
                    }
                ]
            },
            {
                path: 'sale',
                children: [
                    {
                        path: 'delivery',
                        component: MainContainerComponent,
                        children: [
                            { path: '', pathMatch: 'full', redirectTo: 'delivery-list' },
                            { path: 'delivery-list', component: DocumentsListComponent, data: DELIVERY_VIEW },
                            { path: 'delivery-form', component: DeliveryComponent },
                            { path: 'delivery-form/:id', component: DeliveryComponent },
                        ]
                    },
                    {
                        path: 'consignment',
                        component: MainContainerComponent,
                        children: [
                            { path: '', pathMatch: 'full', redirectTo: 'consignment-list' },
                            { path: 'consignment-list', component: DocumentsListComponent, data: CONSIGNMENT_VIEW },
                            { path: 'consignment-form', component: ConsignmentComponent },
                            { path: 'consignment-form/:id', component: ConsignmentComponent },
                        ]
                    },
                    {
                        path: 'consignment-return',
                        component: MainContainerComponent,
                        children: [
                            { path: '', pathMatch: 'full', redirectTo: 'consignment-return-list' },
                            { path: 'consignment-return-list', component: DocumentsListComponent, data: CONSIGNMENT_RETURN_VIEW },
                            { path: 'consignment-return-form', component: ConsignmentReturnComponent },
                            { path: 'consignment-return-form/:id', component: ConsignmentReturnComponent },
                        ]
                    },
                ]
            },
            {
                path: 'inventory', children: [
                    {
                        path: 'inventory',
                        component: MainContainerComponent,
                        children: [
                            { path: '', pathMatch: 'full', redirectTo: 'inventory-list' },
                            { path: 'inventory-list', component: DocumentsListComponent, data: STORE_INVENTORY_VIEW },
                            { path: 'inventory-form', component: InventoryComponent },
                            { path: 'inventory-form/:id', component: InventoryComponent },
                        ]
                    },
                    { path: 'article-historic', component: ArticleHistoricComponent },
                ]
            }
        ]
    }
];
class SubLayoutRoutingModule {
}
SubLayoutRoutingModule.ɵfac = function SubLayoutRoutingModule_Factory(t) { return new (t || SubLayoutRoutingModule)(); };
SubLayoutRoutingModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: SubLayoutRoutingModule });
SubLayoutRoutingModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [RouterModule.forChild(routes), RouterModule] });
(function () {
    (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SubLayoutRoutingModule, [{
            type: NgModule,
            args: [{
                    imports: [RouterModule.forChild(routes)],
                    exports: [RouterModule]
                }]
        }], null, null);
})();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(SubLayoutRoutingModule, { imports: [i3.RouterModule], exports: [RouterModule] }); })();

function DefaultSettingsComponent_mat_radio_button_9_Template(rf, ctx) {
    if (rf & 1) {
        i0.ɵɵelementStart(0, "mat-radio-button", 13);
        i0.ɵɵtext(1);
        i0.ɵɵpipe(2, "translate");
        i0.ɵɵelementEnd();
    }
    if (rf & 2) {
        const p_r5 = ctx.$implicit;
        i0.ɵɵproperty("value", p_r5);
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 2, "shared." + p_r5), " ");
    }
}
function DefaultSettingsComponent_mat_radio_button_14_Template(rf, ctx) {
    if (rf & 1) {
        i0.ɵɵelementStart(0, "mat-radio-button", 13);
        i0.ɵɵtext(1);
        i0.ɵɵpipe(2, "translate");
        i0.ɵɵelementEnd();
    }
    if (rf & 2) {
        const type_r6 = ctx.$implicit;
        i0.ɵɵproperty("value", type_r6);
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 2, "store." + type_r6), " ");
    }
}
function DefaultSettingsComponent_mat_option_22_Template(rf, ctx) {
    if (rf & 1) {
        i0.ɵɵelementStart(0, "mat-option", 13);
        i0.ɵɵtext(1);
        i0.ɵɵpipe(2, "translate");
        i0.ɵɵelementEnd();
    }
    if (rf & 2) {
        const type_r7 = ctx.$implicit;
        i0.ɵɵproperty("value", type_r7);
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 2, "shared." + type_r7), " ");
    }
}
function DefaultSettingsComponent_mat_option_26_Template(rf, ctx) {
    if (rf & 1) {
        i0.ɵɵelementStart(0, "mat-option", 13);
        i0.ɵɵtext(1);
        i0.ɵɵpipe(2, "translate");
        i0.ɵɵelementEnd();
    }
    if (rf & 2) {
        const condition_r8 = ctx.$implicit;
        i0.ɵɵproperty("value", condition_r8);
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 2, "shared." + condition_r8.key), " ");
    }
}
const _c0 = function () { return { key: "name", url: "api/store/depot", cls: "store/depot", customValidator: "depot.check_uniqueness" }; };
const _c1 = function () { return { key: "description", url: "api/list/vat/", cls: "list/vat", isNumber: true, customValidator: "store-vat.check_uniqueness" }; };
class DefaultSettingsComponent {
    constructor(defaultValuesService) {
        this.defaultValuesService = defaultValuesService;
        this.depotDialog = DepotDialogComponent;
        this.vatDialog = ListFormDialogComponent;
        this.price_mode = ['HT', 'TTC'];
        this.types = ['IN', 'OUT'];
        this.paymentModeTypes = PAYMENT_MODE_TYPES;
        this.paymentConditions = PAYMENT_CONDITIONS;
        this.default_store = this.defaultValuesService.getValue('default_store');
        this.default_sale_vat = this.defaultValuesService.getValue('default_sale_vat');
        this.default_purchase_vat = this.defaultValuesService.getValue('default_purchase_vat');
        this.default_price_mode = this.defaultValuesService.getValue('default_price_mode');
        this.payment_mode = this.defaultValuesService.getValue('payment_mode');
        this.default_payment_condition = this.defaultValuesService.getValue('default_payment_condition');
        this.default_movement_type = this.defaultValuesService.getValue('default_movement_type');
    }
    ngOnInit() {
    }
    compareMode(o1, o2) {
        return o1 == o2;
    }
    compareCondition(o1, o2) {
        return o1 && o2 ? o1.key == o2.key || o1.id == o2.id : false;
    }
}
DefaultSettingsComponent.ɵfac = function DefaultSettingsComponent_Factory(t) { return new (t || DefaultSettingsComponent)(i0.ɵɵdirectiveInject(i2.DefaultValuesService)); };
DefaultSettingsComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DefaultSettingsComponent, selectors: [["fts-default-settings"]], decls: 27, vars: 47, consts: [["fxFlex", "", "fxLayout", "column", 1, "ft-padding"], ["form", "ngForm"], ["fxLayout", "row", "fxLayoutGap", "8px"], ["fxFlex", "", 3, "model", "listDialog", "config", "label", "defaultValues", "updateOnChange", "modelChange"], ["fxLayout", "row", "fxFlex", "", "fxLayoutGap", "8px"], ["floatLabel", "always", "fxFlex", "", 1, "ft-radio-field"], ["matInput", "", 2, "display", "none", 3, "placeholder"], ["name", "price_mode", "ftDefaultValues", "default_price_mode", 3, "ngModel", "updateOnChange", "ngModelChange"], [3, "value", 4, "ngFor", "ngForOf"], ["name", "type", "ftDefaultValues", "default_movement_type", 3, "ngModel", "updateOnChange", "ngModelChange"], ["fxFlex", ""], ["ftDefaultValues", "payment_mode", "name", "mode", 3, "placeholder", "compareWith", "updateOnChange", "ngModel", "ngModelChange"], ["ftDefaultValues", "default_payment_condition", "name", "payment_condition", 3, "placeholder", "compareWith", "updateOnChange", "ngModel", "ngModelChange"], [3, "value"]], template: function DefaultSettingsComponent_Template(rf, ctx) {
        if (rf & 1) {
            i0.ɵɵelementStart(0, "form", 0, 1)(2, "div", 2)(3, "fts-list-select", 3);
            i0.ɵɵlistener("modelChange", function DefaultSettingsComponent_Template_fts_list_select_modelChange_3_listener($event) { return ctx.default_store = $event; });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(4, "div", 4)(5, "mat-form-field", 5);
            i0.ɵɵelement(6, "input", 6);
            i0.ɵɵpipe(7, "translate");
            i0.ɵɵelementStart(8, "mat-radio-group", 7);
            i0.ɵɵlistener("ngModelChange", function DefaultSettingsComponent_Template_mat_radio_group_ngModelChange_8_listener($event) { return ctx.default_price_mode = $event; });
            i0.ɵɵtemplate(9, DefaultSettingsComponent_mat_radio_button_9_Template, 3, 4, "mat-radio-button", 8);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(10, "mat-form-field", 5);
            i0.ɵɵelement(11, "input", 6);
            i0.ɵɵpipe(12, "translate");
            i0.ɵɵelementStart(13, "mat-radio-group", 9);
            i0.ɵɵlistener("ngModelChange", function DefaultSettingsComponent_Template_mat_radio_group_ngModelChange_13_listener($event) { return ctx.default_movement_type = $event; });
            i0.ɵɵtemplate(14, DefaultSettingsComponent_mat_radio_button_14_Template, 3, 4, "mat-radio-button", 8);
            i0.ɵɵelementEnd()()()();
            i0.ɵɵelementStart(15, "div", 2)(16, "fts-list-select", 3);
            i0.ɵɵlistener("modelChange", function DefaultSettingsComponent_Template_fts_list_select_modelChange_16_listener($event) { return ctx.default_sale_vat = $event; });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(17, "fts-list-select", 3);
            i0.ɵɵlistener("modelChange", function DefaultSettingsComponent_Template_fts_list_select_modelChange_17_listener($event) { return ctx.default_purchase_vat = $event; });
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(18, "div", 2)(19, "mat-form-field", 10)(20, "mat-select", 11);
            i0.ɵɵlistener("ngModelChange", function DefaultSettingsComponent_Template_mat_select_ngModelChange_20_listener($event) { return ctx.payment_mode = $event; });
            i0.ɵɵpipe(21, "translate");
            i0.ɵɵtemplate(22, DefaultSettingsComponent_mat_option_22_Template, 3, 4, "mat-option", 8);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(23, "mat-form-field", 10)(24, "mat-select", 12);
            i0.ɵɵlistener("ngModelChange", function DefaultSettingsComponent_Template_mat_select_ngModelChange_24_listener($event) { return ctx.default_payment_condition = $event; });
            i0.ɵɵpipe(25, "translate");
            i0.ɵɵtemplate(26, DefaultSettingsComponent_mat_option_26_Template, 3, 4, "mat-option", 8);
            i0.ɵɵelementEnd()()()();
        }
        if (rf & 2) {
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("model", ctx.default_store)("listDialog", ctx.depotDialog)("config", i0.ɵɵpureFunction0(44, _c0))("label", "store.depot")("defaultValues", "default_store")("updateOnChange", true);
            i0.ɵɵadvance(3);
            i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(7, 36, "shared.price_mode"));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngModel", ctx.default_price_mode)("updateOnChange", true);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngForOf", ctx.price_mode);
            i0.ɵɵadvance(2);
            i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(12, 38, "store.default_movement_type"));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngModel", ctx.default_movement_type)("updateOnChange", true);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngForOf", ctx.types);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("model", ctx.default_sale_vat)("listDialog", ctx.vatDialog)("config", i0.ɵɵpureFunction0(45, _c1))("label", "store.sale_vat")("defaultValues", "default_sale_vat")("updateOnChange", true);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("model", ctx.default_purchase_vat)("listDialog", ctx.vatDialog)("config", i0.ɵɵpureFunction0(46, _c1))("label", "store.purchase_vat")("defaultValues", "default_purchase_vat")("updateOnChange", true);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(21, 40, "purchase.payment_mode"))("compareWith", ctx.compareMode)("updateOnChange", true)("ngModel", ctx.payment_mode);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngForOf", ctx.paymentModeTypes);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(25, 42, "purchase.payment_condition"))("compareWith", ctx.compareCondition)("updateOnChange", true)("ngModel", ctx.default_payment_condition);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngForOf", ctx.paymentConditions);
        }
    }, dependencies: [i4$1.NgForOf, i5.MatOption, i10.MatFormField, i11$1.MatInput, i13.MatRadioGroup, i13.MatRadioButton, i15.MatSelect, i8.DefaultLayoutDirective, i8.DefaultLayoutGapDirective, i8.DefaultFlexDirective, i16.ɵNgNoValidate, i16.NgControlStatus, i16.NgControlStatusGroup, i16.NgModel, i16.NgForm, i2.InputDirective, i2.DefaultValuesDirective, ListSelectComponent, i3$1.TranslatePipe], encapsulation: 2 });
(function () {
    (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DefaultSettingsComponent, [{
            type: Component,
            args: [{ selector: 'fts-default-settings', template: "\n\n<form #form=\"ngForm\" fxFlex fxLayout=\"column\" class=\"ft-padding\">\n       <div fxLayout=\"row\" fxLayoutGap=\"8px\">\n            <fts-list-select fxFlex\n                            [(model)]=\"default_store\"\n                            [listDialog]=\"depotDialog\"\n                            [config]=\"{key: 'name', url: 'api/store/depot', cls:'store/depot', customValidator:'depot.check_uniqueness'}\"\n                            [label]=\"'store.depot'\"\n                            [defaultValues]=\"'default_store'\"\n                            [updateOnChange]=\"true\"\n                            >\n            </fts-list-select>\n\t     <div fxLayout=\"row\" fxFlex fxLayoutGap=\"8px\">\n\n\t\t  <mat-form-field floatLabel=\"always\" class=\"ft-radio-field\" fxFlex >\n\t\t    <input matInput placeholder=\"{{'shared.price_mode'|translate}}\" style=\"display: none\">\n\t\t    <mat-radio-group [(ngModel)]=\"default_price_mode\" name=\"price_mode\" [updateOnChange]=\"true\"  ftDefaultValues=\"default_price_mode\">\n\t\t      <mat-radio-button *ngFor=\"let p of price_mode\" [value]=\"p\">\n\t\t        {{'shared.'+p|translate}}\n\t\t      </mat-radio-button>\n\t\t    </mat-radio-group>\n\t\t  </mat-form-field>\n\t\t  <mat-form-field floatLabel=\"always\" class=\"ft-radio-field\" fxFlex>\n\t\t    <input matInput placeholder=\"{{'store.default_movement_type'|translate}}\" style=\"display: none\">\n\t\t    <mat-radio-group [(ngModel)]=\"default_movement_type\" name=\"type\" [updateOnChange]=\"true\"  ftDefaultValues=\"default_movement_type\"\n\t\t                    >\n\t\t      <mat-radio-button *ngFor=\"let type of types\" [value]=\"type\">\n\t\t        {{'store.'+type|translate}}\n\t\t      </mat-radio-button>\n\t\t    </mat-radio-group>\n\t\t  </mat-form-field>\n          </div>\n  </div>\n       <div fxLayout=\"row\" fxLayoutGap=\"8px\">\n\n            <fts-list-select fxFlex\n                             [(model)]=\"default_sale_vat\"\n                             [listDialog]=\"vatDialog\"\n                             [config]=\"{key: 'description', url: 'api/list/vat/', cls:'list/vat', isNumber:true,customValidator:'store-vat.check_uniqueness' }\"\n                             [label]=\"'store.sale_vat'\"  [defaultValues]=\"'default_sale_vat'\" [updateOnChange]=\"true\"\n                             >\n            </fts-list-select>\n            <fts-list-select fxFlex\n                             [(model)]=\"default_purchase_vat\"\n                             [listDialog]=\"vatDialog\"\n                             [config]=\"{key: 'description', url: 'api/list/vat/', cls:'list/vat', isNumber:true,customValidator:'store-vat.check_uniqueness' }\"\n                             [label]=\"'store.purchase_vat'\"  [defaultValues]=\"'default_purchase_vat'\" [updateOnChange]=\"true\"\n                             >\n            </fts-list-select>\n\n        </div>\n       <div fxLayout=\"row\" fxLayoutGap=\"8px\">\n\n            <mat-form-field fxFlex>\n              <mat-select [placeholder]=\"'purchase.payment_mode' | translate\" [compareWith]=\"compareMode\"\n                          ftDefaultValues=\"payment_mode\" [updateOnChange]=\"true\"\n                          [(ngModel)]=\"payment_mode\" name=\"mode\">\n                <mat-option *ngFor=\"let type of paymentModeTypes\" [value]=\"type\">\n                  {{'shared.'+type |translate}}\n                </mat-option>\n              </mat-select>\n            </mat-form-field>\n          <mat-form-field fxFlex>\n            <mat-select [placeholder]=\"'purchase.payment_condition' | translate\" [compareWith]=\"compareCondition\" ftDefaultValues=\"default_payment_condition\" [updateOnChange]=\"true\"\n                        [(ngModel)]=\"default_payment_condition\" name=\"payment_condition\"  >\n              <mat-option *ngFor=\"let condition of paymentConditions\" [value]=\"condition\">\n                {{'shared.'+condition.key|translate}}\n              </mat-option>\n            </mat-select>\n          </mat-form-field>\n       </div>\n\n\n      <!--  <fts-list-select\n           [(model)]=\"store\"\n           [listDialog]=\"depotDialog\"\n           [config]=\"{key: 'name', url: 'api/store/depot', cls:'store/depot', customValidator:'depot.check_uniqueness'}\"\n           [label]=\"'store.depot'\"\n            >\n        </fts-list-select>-->\n</form>\n\n\n\n\n\n\n\n" }]
        }], function () { return [{ type: i2.DefaultValuesService }]; }, null);
})();

class SharedModule {
}
SharedModule.ɵfac = function SharedModule_Factory(t) { return new (t || SharedModule)(); };
SharedModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: SharedModule });
SharedModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ providers: [
        SharedService,
        SerialService,
        LotService
    ], imports: [CommonModule,
        MaterialModule,
        TranslateModule,
        HttpClientModule,
        FormsModule,
        NgBusyModule,
        FtTableModule,
        FtCoreModule,
        RouterModule,
        ReactiveFormsModule,
        FileManagerModule] });
(function () {
    (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SharedModule, [{
            type: NgModule,
            args: [{
                    declarations: [
                        DocumentsListComponent,
                        MainContainerComponent,
                        ProviderDialogComponent,
                        DepotDialogComponent,
                        SelectDocumentsDialogComponent,
                        DocumentSelectComponent,
                        ListSelectComponent,
                        ListFormDialogComponent,
                        DocumentActionsComponent,
                        DocumentLinesComponent,
                        DocumentDetailsComponent,
                        LinesDialogComponent,
                        InSerialDialogComponent,
                        OutSerialDialogComponent,
                        InLotDialogComponent,
                        OutLotDialogComponent,
                        AlertDialogComponent,
                        DocumentFooterComponent,
                        ArticleTransformSelectComponent,
                        ArticleSummaryDialogComponent,
                        DefaultSettingsComponent,
                        AddLoadsDialogComponent,
                        OrganizationDialogComponent,
                        PatientDialogComponent,
                        FamilyDialogComponent,
                        AddArticleDialogComponent
                    ],
                    imports: [
                        CommonModule,
                        MaterialModule,
                        TranslateModule,
                        HttpClientModule,
                        FormsModule,
                        NgBusyModule,
                        FtTableModule,
                        FtCoreModule,
                        RouterModule,
                        ReactiveFormsModule,
                        FileManagerModule
                    ],
                    providers: [
                        SharedService,
                        SerialService,
                        LotService
                    ],
                    exports: [
                        MainContainerComponent,
                        DocumentsListComponent,
                        DocumentSelectComponent,
                        ListSelectComponent,
                        DocumentActionsComponent,
                        DocumentDetailsComponent,
                        DocumentFooterComponent,
                        DocumentLinesComponent,
                        ArticleTransformSelectComponent,
                        DefaultSettingsComponent,
                        FamilyDialogComponent,
                        AddArticleDialogComponent
                    ],
                    entryComponents: [
                        ProviderDialogComponent,
                        DepotDialogComponent,
                        SelectDocumentsDialogComponent,
                        ListFormDialogComponent,
                        LinesDialogComponent,
                        InSerialDialogComponent,
                        OutSerialDialogComponent,
                        InLotDialogComponent,
                        OutLotDialogComponent,
                        AlertDialogComponent,
                        ArticleSummaryDialogComponent,
                        AddLoadsDialogComponent,
                        OrganizationDialogComponent,
                        PatientDialogComponent
                    ]
                }]
        }], null, null);
})();
(function () {
    (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(SharedModule, { declarations: [DocumentsListComponent,
            MainContainerComponent,
            ProviderDialogComponent,
            DepotDialogComponent,
            SelectDocumentsDialogComponent,
            DocumentSelectComponent,
            ListSelectComponent,
            ListFormDialogComponent,
            DocumentActionsComponent,
            DocumentLinesComponent,
            DocumentDetailsComponent,
            LinesDialogComponent,
            InSerialDialogComponent,
            OutSerialDialogComponent,
            InLotDialogComponent,
            OutLotDialogComponent,
            AlertDialogComponent,
            DocumentFooterComponent,
            ArticleTransformSelectComponent,
            ArticleSummaryDialogComponent,
            DefaultSettingsComponent,
            AddLoadsDialogComponent,
            OrganizationDialogComponent,
            PatientDialogComponent,
            FamilyDialogComponent,
            AddArticleDialogComponent], imports: [CommonModule,
            MaterialModule,
            TranslateModule,
            HttpClientModule,
            FormsModule,
            NgBusyModule,
            FtTableModule,
            FtCoreModule,
            RouterModule,
            ReactiveFormsModule,
            FileManagerModule], exports: [MainContainerComponent,
            DocumentsListComponent,
            DocumentSelectComponent,
            ListSelectComponent,
            DocumentActionsComponent,
            DocumentDetailsComponent,
            DocumentFooterComponent,
            DocumentLinesComponent,
            ArticleTransformSelectComponent,
            DefaultSettingsComponent,
            FamilyDialogComponent,
            AddArticleDialogComponent] });
})();
i0.ɵɵsetComponentScope(AddArticleDialogComponent, [i4$1.NgForOf, i4$1.NgIf, i6.MatButton, i1.MatDialogClose, i1.MatDialogContent, i1.MatDialogActions, i9.MatIcon, i10.MatError, i10.MatFormField, i11$1.MatInput, i13.MatRadioGroup, i13.MatRadioButton, i8$1.MatSlideToggle, i11.MatToolbar, i8.DefaultLayoutDirective, i8.DefaultLayoutGapDirective, i8.FlexFillDirective, i8.DefaultFlexDirective, i16.ɵNgNoValidate, i16.DefaultValueAccessor, i16.NgControlStatus, i16.NgControlStatusGroup, i16.RequiredValidator, i16.NgModel, i16.NgForm, i12.NgBusyDirective, i2.InputDirective, i2.NumberDirective, i2.AutoFocusDirective, i2.CustomValidationDirective, DocumentSelectComponent,
    ListSelectComponent], [i3$1.TranslatePipe]);

class StoreService {
    constructor(http, ws) {
        this.http = http;
        this.ws = ws;
    }
    getFamiliesTree() {
        return this.ws.call("family.get_families_tree");
    }
}
StoreService.ɵfac = function StoreService_Factory(t) { return new (t || StoreService)(i0.ɵɵinject(i1$1.HttpClient), i0.ɵɵinject(i2.FtWsService)); };
StoreService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: StoreService, factory: StoreService.ɵfac, providedIn: 'root' });
(function () {
    (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(StoreService, [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], function () { return [{ type: i1$1.HttpClient }, { type: i2.FtWsService }]; }, null);
})();

class StoreModule {
}
StoreModule.ɵfac = function StoreModule_Factory(t) { return new (t || StoreModule)(); };
StoreModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: StoreModule });
StoreModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ providers: [
        StoreService
    ], imports: [CommonModule,
        MaterialModule,
        TranslateModule,
        HttpClientModule,
        FormsModule,
        NgBusyModule,
        FtCoreModule,
        MatDialogModule,
        RouterModule,
        ReactiveFormsModule,
        ngfModule,
        FtTableModule,
        FileManagerModule,
        SharedModule] });
(function () {
    (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(StoreModule, [{
            type: NgModule,
            args: [{
                    declarations: [
                        ArticleFormComponent,
                        ArticleComponentsComponent,
                        ArticleSubstitutionsComponent,
                        MovementComponent,
                        TransformationComponent,
                        ExchangeComponent,
                    ],
                    imports: [
                        CommonModule,
                        MaterialModule,
                        TranslateModule,
                        HttpClientModule,
                        FormsModule,
                        NgBusyModule,
                        FtCoreModule,
                        MatDialogModule,
                        RouterModule,
                        ReactiveFormsModule,
                        ngfModule,
                        FtTableModule,
                        FileManagerModule,
                        SharedModule
                    ],
                    exports: [],
                    entryComponents: [],
                    providers: [
                        StoreService
                    ]
                }]
        }], null, null);
})();
(function () {
    (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(StoreModule, { declarations: [ArticleFormComponent,
            ArticleComponentsComponent,
            ArticleSubstitutionsComponent,
            MovementComponent,
            TransformationComponent,
            ExchangeComponent], imports: [CommonModule,
            MaterialModule,
            TranslateModule,
            HttpClientModule,
            FormsModule,
            NgBusyModule,
            FtCoreModule,
            MatDialogModule,
            RouterModule,
            ReactiveFormsModule,
            ngfModule,
            FtTableModule,
            FileManagerModule,
            SharedModule] });
})();

class FtsPurchaseModule {
}
FtsPurchaseModule.ɵfac = function FtsPurchaseModule_Factory(t) { return new (t || FtsPurchaseModule)(); };
FtsPurchaseModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: FtsPurchaseModule });
FtsPurchaseModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ providers: [PaymentService], imports: [CommonModule,
        MaterialModule,
        MatDialogModule,
        FormsModule,
        ReactiveFormsModule,
        BrowserAnimationsModule,
        TranslateModule.forChild(),
        FtCoreModule,
        NgBusyModule,
        FtTableModule,
        RouterModule,
        SharedModule,
        FileManagerModule] });
(function () {
    (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FtsPurchaseModule, [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        MaterialModule,
                        MatDialogModule,
                        FormsModule,
                        ReactiveFormsModule,
                        BrowserAnimationsModule,
                        TranslateModule.forChild(),
                        FtCoreModule,
                        NgBusyModule,
                        FtTableModule,
                        RouterModule,
                        SharedModule,
                        FileManagerModule
                    ],
                    declarations: [
                        PriceRequestFormComponent,
                        PurchaseOrderComponent,
                        DepositionComponent,
                        ReturnFormComponent,
                        PurchaseReceiptComponent,
                        PurchaseInvoiceComponent,
                        PaymentFormComponent,
                        PaymentLinesComponent,
                        PaymentActionsComponent
                    ],
                    providers: [PaymentService],
                    exports: []
                }]
        }], null, null);
})();
(function () {
    (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(FtsPurchaseModule, { declarations: [PriceRequestFormComponent,
            PurchaseOrderComponent,
            DepositionComponent,
            ReturnFormComponent,
            PurchaseReceiptComponent,
            PurchaseInvoiceComponent,
            PaymentFormComponent,
            PaymentLinesComponent,
            PaymentActionsComponent], imports: [CommonModule,
            MaterialModule,
            MatDialogModule,
            FormsModule,
            ReactiveFormsModule,
            BrowserAnimationsModule, i3$1.TranslateModule, FtCoreModule,
            NgBusyModule,
            FtTableModule,
            RouterModule,
            SharedModule,
            FileManagerModule] });
})();

class FtsSaleModule {
}
FtsSaleModule.ɵfac = function FtsSaleModule_Factory(t) { return new (t || FtsSaleModule)(); };
FtsSaleModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: FtsSaleModule });
FtsSaleModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
        MaterialModule,
        MatDialogModule,
        FormsModule,
        ReactiveFormsModule,
        BrowserAnimationsModule,
        TranslateModule.forChild(),
        FtCoreModule,
        NgBusyModule,
        FtTableModule,
        RouterModule,
        SharedModule,
        FileManagerModule] });
(function () {
    (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FtsSaleModule, [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        MaterialModule,
                        MatDialogModule,
                        FormsModule,
                        ReactiveFormsModule,
                        BrowserAnimationsModule,
                        TranslateModule.forChild(),
                        FtCoreModule,
                        NgBusyModule,
                        FtTableModule,
                        RouterModule,
                        SharedModule,
                        FileManagerModule
                    ],
                    declarations: [
                        DeliveryComponent,
                        ConsignmentComponent,
                        ConsignmentReturnComponent
                    ],
                    entryComponents: [],
                    providers: [],
                    exports: []
                }]
        }], null, null);
})();
(function () {
    (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(FtsSaleModule, { declarations: [DeliveryComponent,
            ConsignmentComponent,
            ConsignmentReturnComponent], imports: [CommonModule,
            MaterialModule,
            MatDialogModule,
            FormsModule,
            ReactiveFormsModule,
            BrowserAnimationsModule, i3$1.TranslateModule, FtCoreModule,
            NgBusyModule,
            FtTableModule,
            RouterModule,
            SharedModule,
            FileManagerModule] });
})();

class FtsInventoryModule {
}
FtsInventoryModule.ɵfac = function FtsInventoryModule_Factory(t) { return new (t || FtsInventoryModule)(); };
FtsInventoryModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: FtsInventoryModule });
FtsInventoryModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ providers: [InventoryService], imports: [CommonModule,
        MaterialModule,
        MatDialogModule,
        FormsModule,
        ReactiveFormsModule,
        BrowserAnimationsModule,
        TranslateModule.forChild(),
        FtCoreModule,
        NgBusyModule,
        FtTableModule,
        RouterModule,
        SharedModule] });
(function () {
    (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FtsInventoryModule, [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        MaterialModule,
                        MatDialogModule,
                        FormsModule,
                        ReactiveFormsModule,
                        BrowserAnimationsModule,
                        TranslateModule.forChild(),
                        FtCoreModule,
                        NgBusyModule,
                        FtTableModule,
                        RouterModule,
                        SharedModule
                    ],
                    declarations: [
                        InventoryComponent,
                        InventoryLinesComponent,
                        InvLotDialogComponent,
                        InvSerialDialogComponent,
                        ArticleHistoricComponent,
                        WebDataRocksPivot
                    ],
                    providers: [InventoryService],
                    entryComponents: [InvLotDialogComponent,
                        InvSerialDialogComponent],
                    exports: []
                }]
        }], null, null);
})();
(function () {
    (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(FtsInventoryModule, { declarations: [InventoryComponent,
            InventoryLinesComponent,
            InvLotDialogComponent,
            InvSerialDialogComponent,
            ArticleHistoricComponent,
            WebDataRocksPivot], imports: [CommonModule,
            MaterialModule,
            MatDialogModule,
            FormsModule,
            ReactiveFormsModule,
            BrowserAnimationsModule, i3$1.TranslateModule, FtCoreModule,
            NgBusyModule,
            FtTableModule,
            RouterModule,
            SharedModule] });
})();

const rootConfig = {
    provide: FILE_MANAGER_ROOT_CONFIG,
    useValue: {
        "store-article": 'ft_stock.fts_shared.models.StoreArticle',
        "price-request": 'ft_stock.purchase.models.PriceRequest',
        "purchase-order": 'ft_stock.purchase.models.PurchaseOrder',
        "purchase-receipt": 'ft_stock.purchase.models.PurchaseReceipt',
        "return-form": 'ft_stock.purchase.models.ReturnForm',
        "deposition-form": 'ft_stock.purchase.models.DepositionForm',
        "delivery-form": 'ft_stock.sales.models.DeliveryForm',
        "consignment": 'ft_stock.sales.models.Consignment',
        "consignment-return": 'ft_stock.sales.models.ConsignmentReturn',
        "store-transformation": 'ft_stock.store.models.StoreTransformation',
        "store-exchange": 'ft_stock.store.models.StoreExchange',
        "store-movement": 'ft_stock.store.models.StoreMovement',
        "purchase-invoice": 'ft_stock.purchase.models.PurchaseInvoice',
        "purchase-payment": 'ft_stock.purchase.models.PurchasePayment'
    }
};
class SubLayoutModule {
    static forRoot(config) {
        return {
            ngModule: SubLayoutModule,
            providers: [
                config ? config : { provide: SHARED_MODULE_CONFIG, useValue: null },
                SharedModulesService
            ]
        };
    }
}
SubLayoutModule.ɵfac = function SubLayoutModule_Factory(t) { return new (t || SubLayoutModule)(); };
SubLayoutModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: SubLayoutModule });
SubLayoutModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
        MaterialModule,
        TranslateModule.forChild(),
        HttpClientModule,
        FormsModule,
        NgBusyModule,
        FtCoreModule,
        RouterModule,
        ReactiveFormsModule,
        SharedModule,
        StoreModule,
        FtsPurchaseModule,
        FtsSaleModule,
        FtsInventoryModule,
        SubLayoutRoutingModule,
        FtFileManagerSharedModule,
        FileManagerModule.forRoot(rootConfig),
        FtVisualizerModule,
        MediaModule] });
(function () {
    (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SubLayoutModule, [{
            type: NgModule,
            args: [{
                    declarations: [
                        SubLayoutComponent
                    ],
                    imports: [
                        CommonModule,
                        MaterialModule,
                        TranslateModule.forChild(),
                        HttpClientModule,
                        FormsModule,
                        NgBusyModule,
                        FtCoreModule,
                        RouterModule,
                        ReactiveFormsModule,
                        SharedModule,
                        StoreModule,
                        FtsPurchaseModule,
                        FtsSaleModule,
                        FtsInventoryModule,
                        SubLayoutRoutingModule,
                        FtFileManagerSharedModule,
                        FileManagerModule.forRoot(rootConfig),
                        FtVisualizerModule,
                        MediaModule
                    ]
                }]
        }], null, null);
})();
(function () {
    (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(SubLayoutModule, { declarations: [SubLayoutComponent], imports: [CommonModule,
            MaterialModule, i3$1.TranslateModule, HttpClientModule,
            FormsModule,
            NgBusyModule,
            FtCoreModule,
            RouterModule,
            ReactiveFormsModule,
            SharedModule,
            StoreModule,
            FtsPurchaseModule,
            FtsSaleModule,
            FtsInventoryModule,
            SubLayoutRoutingModule,
            FtFileManagerSharedModule, i21.FileManagerModule, FtVisualizerModule,
            MediaModule] });
})();

const lang$5 = {
    store: 'Stock',
    purchase: 'Achat',
    sale: 'Vente',
    settings: 'Entrepôt',
    inventory: 'Inventaire',
    provider: 'Fournisseur',
    yes: 'Ok',
    no: 'Annuler',
    name: 'Nom',
    parent: 'Famille',
    description: 'Description',
    manager: 'Manager',
    address: 'Adresse',
    is_default: 'Par défaut',
    code: 'Code',
    family: 'Famille',
    purchase_price: 'Prix achat',
    sale_price: 'Prix vente',
    sale_price_min: 'Prix vente min',
    purshase_price_max: 'Prix maximum',
    prohibited_for_sale: 'interdit venter',
    prohibited_to_purchase: 'interdit Aacheter',
    allows_negative_stock: 'Stocks négatifs',
    has_serial: 'N°.Série',
    has_lot_number: 'N°lot',
    lapsing: 'Péremption',
    default_provider: 'Fournisseur',
    sale_vat: 'TVA vente',
    purchase_vat: 'TVA acheter',
    sale_unity: 'Unité de vente',
    purchase_unity: 'Acheter l\'unité',
    min_qte: 'Quantité min',
    max_qte: 'quantité max',
    min_dep_qte: 'Quantité depot min',
    max_dep_qte: 'Quantité depot max',
    purchase_price_max: 'prix d\'achat max',
    evaluation: 'évaluation',
    document_purchase: 'document atacher',
    // purchase: 'achat',
    number: 'N°.Demande',
    date: 'Date',
    providers: 'Fournisseurs',
    article: "Article",
    comment: "Commentaire",
    movement_list: 'Liste des mouvements',
    provider_list: 'Liste des fournisseurs',
    depot_list: 'Liste des dépôts',
    family_list: 'Liste des familles',
    article_list: 'Liste des articles',
    transformation_list: 'Liste des transformations',
    exchange_list: 'Liste des échanges',
    purchase_order_list: 'Bons de commandes',
    return_list: 'Liste des retours',
    inventory_list: 'Liste des inventaire',
    new_ligne: 'Nouvelle ligne',
    selected_details: 'Détails',
    articles: 'Articles',
    price_request: 'Demande des prix',
    purchase_order: 'Bons de commandes',
    deposition_form: 'Bons depositions',
    select: 'Sélectionner',
    reset: 'Annuler',
    return_form: 'Bons de retours',
    ttc_amount: 'Montant TTC',
    show_information: 'Informations',
    show_info: 'Informations',
    save_article: 'Enregistrer',
    validate: 'Valider',
    invalidate: 'Dévalider',
    addSerial: 'N°.Série',
    saveSerial: 'Enregistrer',
    serial: 'N°.Série',
    cancel: 'Annuler',
    prefix: 'Préfixe',
    start: 'Début',
    increment: 'Incrémenter par',
    filling: 'Remplissage',
    serial_number: 'N°Serie',
    lot_number: 'N°Lot',
    expiry_date: 'Date Péremption',
    lot: 'code',
    qte: 'Quantite',
    add: 'Ajouter',
    manufacture_date: 'Date Fabrication',
    store_qte: 'Quantite',
    serials_deposition: 'N°Serie deposition',
    serials_receipt: 'N°Serie reception',
    price_mode: 'Mode de prix',
    HT: 'HT',
    TTC: 'TTC',
    document: 'N°Document',
    source: 'Source',
    type: 'Type Mouvement',
    patient: 'Patient',
    price: 'Prix',
    organizational: 'Organismme',
    date_b: 'Date Début',
    date_e: 'Date Fin',
    store_: 'Depot',
    last_inv: 'Dernier Inventaire',
    ALL: 'Tout',
    ASSEMBLY: 'Assemblage',
    DISASSEMBLING: 'Désassemblage',
    sum_qte_in: 'Qte Entrée',
    sum_qte_out: 'Qte Sortie',
    total_qte: 'Total',
    msg_check_doc: 'Impossible de supprimer ce document veuillez verifier ses dépendences!',
    msg_g: 'Probleme de suppression, veuillez verifier ses dépendences!',
    ht_amount: 'Montant HT',
    serial_dep: 'serie deposition',
    serial_rec: 'serie recéption',
    filtring: 'Rechercher',
    serials: 'les Series',
    amount_vat_line: 'TVA',
    impossible_valid_document_delete: 'Impossible de supprimer un document validé !',
    check: 'Chéque',
    effect: 'Effet',
    species: 'Espéce',
    Bank_card: 'Carte bancaire',
    'net_10_days': '10 jours nets',
    'net_30_days': '30 jours nets 30',
    'net_120_days': '120 jours nets',
    'net_60_days': '60 jours nets',
    'net_90_days': '90 jours nets',
    'end_of_month_the_10': 'Fin de mois le 10',
    'end_of_month_the_25': 'Fin de mois le 25',
    '30_end_of_month': '30 jours fin de mois',
    '45_end_of_month': '45 jours fin de mois',
    '60_end_of_month': '60 jours fin de mois',
    '90_end_of_month': '90 jours fin de mois',
    '30_end_of_month_the_10': '30 jours fin de mois le 10',
    '30_end_of_month_the_15': '30 jours fin de mois le 15',
    '30_end_of_month_the_25': '30 jours fin de mois le 25',
    '60_end_of_month_the_10': '60 jours fin de mois le 10',
    '60_end_of_month_the_25': '60 jours fin de mois le 25',
    '90_end_of_month_the_10': '90 jours fin de mois le 10',
    // sources: {
    cls: {
        StoreMovement: "Mouvement",
        DepositionForm: 'Déposition',
        PurchaseReceipt: 'Réception',
        ReturnForm: 'Return',
        StoreTransformation: 'Transformation',
        DeliveryForm: 'Livraison'
    },
    attached_documents: 'Pièces jointes',
    delete: "Supprimer",
    required_field_error: "Ce champ est requis",
    add_new: "Ajouter",
    exit: "Quitter",
    save_exit: "Enregistrer et quitter",
    save: "Enregistrer",
    document_lines: "Lignes document",
    article_details: "Détail d'article",
    serial_numbers: "N°.Séries",
    lot_numbers: "N°lots",
    add_comment: "Commentaire",
    vat_amount: "Montant TVA",
    state: 'État',
    is_valid: "Validé",
    is_draft: "Brouillon",
    validate_object_failed: "Impossible de valider ce document Veuillez verifier ses details !",
    invalidate_object_failed: "Impossible de dévalider ce document Veuillez verifier ses dépendances !",
    'None': 'Aucune',
    'CASH': 'Espèce',
    'CCCA': 'Traite',
    'CCHK': 'Chèque de banque',
    'CDAC': 'Compte Crédit/Débit',
    'CHCK': 'Chèque',
    'DDPO': 'Dépôt Direct',
    'DEBC': 'Carte bancaire',
    days_suffix: ' jour(s)',
    submit_add: 'OK',
    deposition_abbreviate: "BD",
    receipt_abbreviate: "BR",
    consignment_abbreviate: "CN",
    purchase_order_abbreviate: "BC",
    price_request_abbreviate: "DP",
    doc_number: "N°.document",
    impossible_document_delete_check_dependencies: "Impossible de supprimer l'objet veuillez verifier ses dépendances!",
    comments: "Commentaires",
    file_manager: "Pièces jointes",
    consigned_qte: "Qté.Consignation",
    deposition_qte: "Qté.Déposition",
    copyright: 'Copyright 2013-2017 - dépôt légal N°2017LB0009',
    unity: "Unité",
    vat: "Tva",
    add_load: "Charges",
    first_name: 'Prénom',
    last_name: 'Nom',
    patient_last_name: 'Patient.Nom',
    patient_first_name: 'Patient.Prénom',
    cin: 'CIN',
    birth_date: 'Date de naissance',
    email: 'Email',
    full_name: 'Nom Complet',
    phone_number: 'Téléphone',
    organization_list: "Liste des organismes",
    patient_list: "Liste des patients",
    patient_file: "Fiche patient",
    title: 'Titre',
    organization_file: "Fiche organisme",
    accounting_code: "Code comptable",
    "id": "Identifiant",
    last_inventory_date: "Date de dernier inventaire"
};

const lang$4 = {
    store_management: 'Gestion des entrepôts',
    article_list: 'Liste des articles',
    store_purchase: 'Gestion des Achats',
    price_request: 'Demande de prix',
    store_sale: 'Gestion des ventes',
    store_movement: 'Gestion des Mouvements',
    store_inventory: 'Gestion des inventaires',
    description: 'Description',
    default_provider: 'Fournisseur',
    family: 'Famille',
    article: 'Article',
    sale_price: 'Prix de vente',
    sale_price_min: 'Prix de vent minimal',
    sale_unity: 'Unité de vente',
    purchase_price: 'Prix achat',
    purchase_price_max: 'Prix achat maximal',
    purchase_vat: 'Tva d\'achat',
    purchase_unity: 'Unité d\'achat',
    sale_vat: 'Tva de vente',
    prohibited_for_sale: 'Interdit de vendre',
    prohibited_to_purchase: 'Interdit d\'acheter',
    allows_negative_stock: 'Stock négatif',
    has_serial: 'N°.Série',
    has_lot_number: 'N°.Lot',
    lapsing: 'Péremption',
    min_qte: "Qté minimal",
    operation_completed: 'Enregistrement avec succés"',
    provide: 'Provider',
    components: 'Components',
    qte: 'Quantité',
    prise: 'prix',
    component: 'Composants',
    Substitutions: 'Substitutions',
    save_close: 'Enregistrer et quitter',
    code_already_exist: 'code est déjà exist',
    value_already_exist: 'Valeur existe déjà',
    // evaluation: 'Evaluation de dépot',
    evaluation: 'Valorisation du stock',
    qte_stock: 'Quantité de Stock',
    Accessibilité: 'Accessibilité',
    article_form: 'Article',
    substitutions: 'substitutions',
    historical: 'historique',
    sales_history: 'historique de vente',
    statistical: 'statistique',
    document_purchase: 'document atacher',
    purchase: 'achat',
    purchase_management: 'Gestion des achats',
    number: 'N°.Demande',
    date: 'Date',
    provider_list: 'Liste des fournisseurs',
    quantity: "Quantite",
    price: "Prix",
    depot: "Dépôt",
    vat: "TVA",
    purchase_order: 'Bon de Commande',
    delivery: 'Bon de Livraison',
    movement: 'Mouvement',
    movements: 'Liste des mouvements',
    patient: 'Patient',
    organization: 'Organisation',
    type: 'Type',
    IN: 'Entrée',
    OUT: 'Sortie',
    provider: 'Fournisseur',
    return: 'Bon des retours',
    return_form: 'Bon de Retour',
    deposition_form: 'Bon de déposition',
    deposition: 'Bon de Déposition',
    transformation: 'Liste des transformations',
    transformation_form: 'Transformation',
    transformation_list: 'Transformations',
    exchange_list: 'Échanges inter-dépôts',
    store_exchange: 'Échange inter-dépôt',
    exchange: 'Échange',
    exchange_number: 'N°.Échange',
    exchanges: 'Liste des échanges',
    source: 'Source',
    responsible: 'Responsable',
    reason: 'Raison',
    inventory: 'Inventaire',
    manager: 'Responsable',
    comment: 'Commentaire',
    inventory_form: 'Inventaire',
    movement_list: 'Liste des movements',
    exchage_list: 'Liste des échanges',
    articles: 'Articles',
    under_total: 'Sous Total',
    movement_change_type_message: 'Voulez vous vraiment changer le type de mouvement?',
    validate: 'Valider',
    store: 'Dépôt',
    invalidate: 'Dévalider',
    total: 'Total',
    destination_depot: 'Dépôt de destination',
    source_depot: 'Dépôt source',
    ALL: 'Tout',
    cancel: "Annuler",
    article_form_sheet: 'Fiche d\'article',
    historical_purchase_sales: 'Historique Achat/Vente',
    FIFO: 'FIFO',
    LIFO: 'LIFO',
    FEFO: 'FEFO',
    PMP: 'PMP',
    pmp: "PMP",
    price_excl_tax: 'Prix HT',
    price_incl_tax: 'Prix TTC',
    total_sous: 'Sous Total',
    article_general: "Générale",
    management_rules: "Règles de gestion",
    store_out_rules: "Règles de sorties de stocks",
    consignment: "Bons de consignations",
    consignment_return: "Retours de consignations",
    article_description: "Descriptif",
    generals: 'Paramètres généraux',
    app_config: 'Configuration de l\'application',
    search: 'Recherche',
    code: 'Code',
    name: 'Raison Sociale',
    sales_manager: 'Gestionnaire de vente',
    director: 'Directeur Commercial',
    phone: 'Numéro de téléphone',
    fax: 'Fax',
    address: 'Adresse',
    email: 'Email',
    rc: 'RC',
    ice: 'ICE',
    title: 'Titre',
    is_default: 'Par défaut',
    parent: 'Famille parent',
    list_setup: 'Gestion des liste',
    allow_provider_delete: 'Voulez vous vraiment supprimer cet élement?',
    unity: 'Unité',
    family_list: 'Liste des familles',
    depot_list: 'Liste des depot',
    purshase_price_max: 'Prix maximum',
    max_qte: 'Qté max',
    min_dep_qte: 'Qté min en déposition',
    max_dep_qte: 'Qté max en déposition',
    selected: 'OK',
    name_already_exist: 'le nom est déjà exist',
    select: 'sélectionner',
    not_a_valid_email: 'Email n\'est pas correct',
    depot_name: 'Nom',
    name_f: 'Nom',
    settings_g: 'Paramétres généraux',
    //movement_list :'',
    movement_form: '',
    mvm_in: 'Mouvement Entrer',
    mvm_out: 'Mouvement Sortie',
    trs_assembly: 'Transformation Assemblée',
    trs_disassembly: 'Transformation Disassemblée',
    value: 'Valeur',
    profile_management: 'Gestion de profile',
    impression: 'Impression',
    user_profile: 'Gestion d\'utilisateur',
    save: "Enregistrer",
    movement_number: 'N°.Mouvement',
    transformation_number: 'N°.Transformation',
    delivery_date: 'Date de livraison',
    default_movement_type: "Type de mouvement"
};

const lang$3 = {
    price_request: 'Demande de Prix',
    price_request_number: 'N°.Demande',
    purchase_receipt: 'Bon de réception',
    purchase_receipt_list: 'Bons de réceptions',
    return_form: 'Bon de Retour',
    return_form_list: 'Liste des retours',
    return_list: 'Liste des retours',
    document_purchase: 'document atacher',
    purchase: 'achat',
    // number: 'N°.Demande',
    number: 'N°',
    date: 'Date',
    provider: 'Fournisseurs',
    price_request_list: "Demandes de prix",
    article: 'Article',
    comment: 'Commentaire',
    purchase_order_list: 'bon des commandes',
    purchase_order: 'Bon de commande',
    patient: 'Patient',
    attention_to: 'à l\'attention',
    payment_mode: 'Mode de paiement',
    payment_condition: 'Condition paiements',
    doc_deposition: 'Déposition',
    doc_PurchaseOrder: 'Bn commande',
    providers: 'Fournisseurs',
    default_provider: 'Fournisseur',
    reason: 'Raison',
    depot: 'Depot',
    deposition_dead_line: 'Fin de déposition',
    deposition: 'Bon de déposition',
    deposition_list: 'Bons de dépositions',
    deposition_number: 'N°.Déposition',
    cancel_doc: 'Annuler',
    fence_doc: 'Clôturer',
    days_net_10: '10 jours nets',
    end_month_10: 'Fin de mois le 10',
    days_nets_30: '30 jours nets',
    end_month_25: 'Fin de mois le 25',
    days_end_month_30: '30 jours fin de mois',
    days_end_month_10_30: '30 jours fin de mois le 10',
    days_end_month_15_30: '30 jours fin de mois le 15',
    days_end_month_45: '45 jours fin de mois',
    end_net_60: '60 jours nets',
    days_end_month_25_30: '30 jours fin de mois le 25',
    days_month_60: '60 jours fin de mois',
    days_month_10_60: '60 jours fin de mois le 10',
    end_net_90: '90 jours nets',
    days_month_10_90: '90 jours fin de mois le 10',
    days_net_120: '120 jours nets',
    //purchase_receipt_list: '',
    purchase_order_number: "N°.Commande",
    dead_line_date: 'Date fin',
    start_date: 'Date début',
    return_form_number: "N°.Retour",
    receipt_number: "N°.Réception",
    invoice_number: "N°.Facture",
    purchase_invoice_list: "Liste des factures",
    purchase_invoice_form: "Facture",
    purchase_invoice: "Factures",
    payment_number: 'N°.Réglement',
    received_amount: 'Montant encaissé',
    consumed_amount: 'Montant consommé',
    remaining_amount: 'Reliquat',
    purchase_payment_list: 'Liste des réglements',
    purchase_payment_form: 'Réglement ',
    purchase_payment: 'Réglements',
    LOAD: 'Charge',
    PURCHASE: 'Achat',
    deadline: 'Date d\'échéance'
};

const lang$2 = {
    patient: 'patient',
    organization: 'organisation',
    delivery: 'Bon de Livraison',
    delivery_list: 'Bons de livraisons',
    number: 'N°.livraison',
    date: 'Date',
    delivery_man: 'Livreur',
    delivery_number: 'N°.Livraison',
    consignment_form: "Bon de consignation",
    consignment_number: "N°.Consignation",
    consignment_return: "Retour de consignation"
};

const lang$1 = {
    inventory_form: 'Inventaire',
    inventory_form_list: 'Liste des inventaires',
    manager: 'Responsable',
    comment: 'Commentaire',
    depot: 'Dépôt',
    is_valid: 'Valider',
    block_all: 'Bloques tout documents',
    code: 'Code',
    description: 'Description',
    pmp: 'PMP',
    theo_pmp: 'PMP.Théo',
    qte: 'Qté',
    theo_qte: 'Qté.Théo',
    difference_qte: 'Écart.Qté',
    difference_pmp: 'Écart.PMP',
    total: 'Total',
    serials_in: 'liste series restant',
    serials_out: 'liste series sortant',
    new_serials: 'Nouveau Serie',
    lots_in: 'liste lots restant',
    lots_out: 'liste lots sortant',
    invalidate_block_all: 'Débloquer tout documents',
    msg: 'Etes-vous sur de vouloir valider l\'inventaire ?',
    msg_difference: 'Problem des ecarts, Voulez-vous valider ?',
    new_serial: 'Nouveau Serie',
    new_lot: 'Nouveau Lot',
    msg_check_val: 'Il ya des documents non validé, Voulez-vous continuer ?',
    add_new_lot: 'Ajouter Nouveau Lot',
    list_lot_in: 'Liste restant',
    show_list_lot_in_new: 'Listes des lots restant avec des nouveau créons',
    list_lot_out: 'Liste sorant',
    show_list_lot_out: 'Listes des lots sortant',
    list_serial_new: 'Les series',
    list_serial_in: 'Listes des series restant',
    list_serial_out: 'Listes des series sortant',
    inventory_number: "N°.Inventaire",
    movements_state: "Mouvements du stock",
    new_code: "Nouveau N°.Série"
};

const lang = {
    payment_list: 'Liste des réglements',
    payment: 'Réglement ',
    payment_header_number: 'Réglement N°',
    payment_number: 'N°.Réglement',
    deadline: 'Date d\'échéance',
    bank: 'Banque',
    ref: 'Ref',
    received_amount: 'Montant encaissé',
    init_amount: 'Montant initial',
    consumed_amount: 'Montant consommé',
    remaining_amount: 'Reliquat',
    be_paid_document: 'Documents à régler',
    payment_lines: 'Lignes réglement',
    encasement_amount: "Montant encaissé",
    total_amount: "Montant",
    paid_doc: "N°. Document",
    line_remaining_amount: "Reste à régler",
    payment_outstanding_amount: "Reliquat",
    header_invalidate: "Dévalider l'en-tête",
    calculate: "Calculer",
    dissociate: "Dissocier",
    external_doc_id: "N°.Document HIS/RIS"
};

/**
 * Generated bundle index. Do not edit.
 */

export { AddArticleDialogComponent, AddLoadsDialogComponent, AlertDialogComponent, ArticleComponentsComponent, ArticleFormComponent, ArticleSubstitutionsComponent, ArticleSummaryDialogComponent, ArticleTransformSelectComponent, ConsignmentComponent, ConsignmentReturnComponent, DefaultSettingsComponent, DeliveryComponent, DepositionComponent, DepotDialogComponent, DocumentActionsComponent, DocumentDetailsComponent, DocumentFooterComponent, DocumentLinesComponent, DocumentSelectComponent, DocumentsListComponent, ExchangeComponent, FamilyDialogComponent, FtsInventoryModule, FtsPurchaseModule, FtsSaleModule, InLotDialogComponent, InSerialDialogComponent, InvLotDialogComponent, InvSerialDialogComponent, InventoryComponent, InventoryLinesComponent, InventoryService, LinesDialogComponent, ListFormDialogComponent, ListSelectComponent, LotService, MainContainerComponent, MovementComponent, OutLotDialogComponent, OutSerialDialogComponent, PaymentActionsComponent, PaymentFormComponent, PaymentLinesComponent, PaymentService, PriceRequestFormComponent, ProviderDialogComponent, PurchaseInvoiceComponent, PurchaseOrderComponent, PurchaseReceiptComponent, ReturnFormComponent, SHARED_MODULE_CONFIG, SelectDocumentsDialogComponent, SerialService, SharedModule, SharedModulesService, SharedService, StoreModule, StoreService, SubLayoutComponent, SubLayoutModule, SubLayoutRoutingModule, TransformationComponent, getLinePrice, getLineVat, handleRoute, handleSubTotal, handleViewRoute, lang$1 as inventoryLang, lang as paymentLang, lang$3 as purchaseLang, lang$2 as saleLang, lang$5 as sharedLang, lang$4 as storeLang };
